var If = Object.defineProperty;
var Pf = (t, e, n) => e in t ? If(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var ut = (t, e, n) => Pf(t, typeof e != "symbol" ? e + "" : e, n);
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Rf(t) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const n of t.split(",")) e[n] = 1;
  return (n) => n in e;
}
const Vr = Object.freeze({}), Pi = () => {
}, vr = Object.assign, Lf = (t, e) => {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}, Mf = Object.prototype.hasOwnProperty, qi = (t, e) => Mf.call(t, e), gt = Array.isArray, mr = (t) => fs(t) === "[object Map]", jf = (t) => fs(t) === "[object Set]", nt = (t) => typeof t == "function", hl = (t) => typeof t == "string", ii = (t) => typeof t == "symbol", Wt = (t) => t !== null && typeof t == "object", Nf = (t) => (Wt(t) || nt(t)) && nt(t.then) && nt(t.catch), Bf = Object.prototype.toString, fs = (t) => Bf.call(t), fl = (t) => fs(t).slice(8, -1), $f = (t) => fs(t) === "[object Object]", ia = (t) => hl(t) && t !== "NaN" && t[0] !== "-" && "" + parseInt(t, 10) === t, dl = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return (n) => e[n] || (e[n] = t(n));
}, pl = dl((t) => t.charAt(0).toUpperCase() + t.slice(1)), zf = dl(
  (t) => t ? `on${pl(t)}` : ""
), Dn = (t, e) => !Object.is(t, e), Uf = (t, e, n, i = !1) => {
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: !1,
    writable: i,
    value: n
  });
};
let Ua;
const ds = () => Ua || (Ua = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function an(t, ...e) {
  console.warn(`[Vue warn] ${t}`, ...e);
}
let Ee;
const Ds = /* @__PURE__ */ new WeakSet();
class Hf {
  constructor(e) {
    this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0;
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Ds.has(this) && (Ds.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || gl(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Ha(this), bl(this);
    const e = Ee, n = Ct;
    Ee = this, Ct = !0;
    try {
      return this.fn();
    } finally {
      Ee !== this && an(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), _l(this), Ee = e, Ct = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let e = this.deps; e; e = e.nextDep)
        aa(e);
      this.deps = this.depsTail = void 0, Ha(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Ds.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    ko(this) && this.run();
  }
  get dirty() {
    return ko(this);
  }
}
let ml = 0, Ur, Hr;
function gl(t, e = !1) {
  if (t.flags |= 8, e) {
    t.next = Hr, Hr = t;
    return;
  }
  t.next = Ur, Ur = t;
}
function sa() {
  ml++;
}
function oa() {
  if (--ml > 0)
    return;
  if (Hr) {
    let e = Hr;
    for (Hr = void 0; e; ) {
      const n = e.next;
      e.next = void 0, e.flags &= -9, e = n;
    }
  }
  let t;
  for (; Ur; ) {
    let e = Ur;
    for (Ur = void 0; e; ) {
      const n = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (i) {
          t || (t = i);
        }
      e = n;
    }
  }
  if (t) throw t;
}
function bl(t) {
  for (let e = t.deps; e; e = e.nextDep)
    e.version = -1, e.prevActiveLink = e.dep.activeLink, e.dep.activeLink = e;
}
function _l(t) {
  let e, n = t.depsTail, i = n;
  for (; i; ) {
    const r = i.prevDep;
    i.version === -1 ? (i === n && (n = r), aa(i), qf(i)) : e = i, i.dep.activeLink = i.prevActiveLink, i.prevActiveLink = void 0, i = r;
  }
  t.deps = e, t.depsTail = n;
}
function ko(t) {
  for (let e = t.deps; e; e = e.nextDep)
    if (e.dep.version !== e.version || e.dep.computed && (yl(e.dep.computed) || e.dep.version !== e.version))
      return !0;
  return !!t._dirty;
}
function yl(t) {
  if (t.flags & 4 && !(t.flags & 16) || (t.flags &= -17, t.globalVersion === Gr))
    return;
  t.globalVersion = Gr;
  const e = t.dep;
  if (t.flags |= 2, e.version > 0 && !t.isSSR && t.deps && !ko(t)) {
    t.flags &= -3;
    return;
  }
  const n = Ee, i = Ct;
  Ee = t, Ct = !0;
  try {
    bl(t);
    const r = t.fn(t._value);
    (e.version === 0 || Dn(r, t._value)) && (t._value = r, e.version++);
  } catch (r) {
    throw e.version++, r;
  } finally {
    Ee = n, Ct = i, _l(t), t.flags &= -3;
  }
}
function aa(t, e = !1) {
  const { dep: n, prevSub: i, nextSub: r } = t;
  if (i && (i.nextSub = r, t.prevSub = void 0), r && (r.prevSub = i, t.nextSub = void 0), n.subsHead === t && (n.subsHead = r), n.subs === t && (n.subs = i, !i && n.computed)) {
    n.computed.flags &= -5;
    for (let s = n.computed.deps; s; s = s.nextDep)
      aa(s, !0);
  }
  !e && !--n.sc && n.map && n.map.delete(n.key);
}
function qf(t) {
  const { prevDep: e, nextDep: n } = t;
  e && (e.nextDep = n, t.prevDep = void 0), n && (n.prevDep = e, t.nextDep = void 0);
}
let Ct = !0;
const vl = [];
function si() {
  vl.push(Ct), Ct = !1;
}
function oi() {
  const t = vl.pop();
  Ct = t === void 0 ? !0 : t;
}
function Ha(t) {
  const { cleanup: e } = t;
  if (t.cleanup = void 0, e) {
    const n = Ee;
    Ee = void 0;
    try {
      e();
    } finally {
      Ee = n;
    }
  }
}
let Gr = 0;
class Wf {
  constructor(e, n) {
    this.sub = e, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class ps {
  constructor(e) {
    this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.subsHead = void 0;
  }
  track(e) {
    if (!Ee || !Ct || Ee === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== Ee)
      n = this.activeLink = new Wf(Ee, this), Ee.deps ? (n.prevDep = Ee.depsTail, Ee.depsTail.nextDep = n, Ee.depsTail = n) : Ee.deps = Ee.depsTail = n, wl(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const i = n.nextDep;
      i.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = i), n.prevDep = Ee.depsTail, n.nextDep = void 0, Ee.depsTail.nextDep = n, Ee.depsTail = n, Ee.deps === n && (Ee.deps = i);
    }
    return Ee.onTrack && Ee.onTrack(
      vr(
        {
          effect: Ee
        },
        e
      )
    ), n;
  }
  trigger(e) {
    this.version++, Gr++, this.notify(e);
  }
  notify(e) {
    sa();
    try {
      for (let n = this.subsHead; n; n = n.nextSub)
        n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
          vr(
            {
              effect: n.sub
            },
            e
          )
        );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      oa();
    }
  }
}
function wl(t) {
  if (t.dep.sc++, t.sub.flags & 4) {
    const e = t.dep.computed;
    if (e && !t.dep.subs) {
      e.flags |= 20;
      for (let i = e.deps; i; i = i.nextDep)
        wl(i);
    }
    const n = t.dep.subs;
    n !== t && (t.prevSub = n, n && (n.nextSub = t)), t.dep.subsHead === void 0 && (t.dep.subsHead = t), t.dep.subs = t;
  }
}
const Wi = /* @__PURE__ */ new WeakMap(), Zn = Symbol(
  "Object iterate"
), So = Symbol(
  "Map keys iterate"
), Kr = Symbol(
  "Array iterate"
);
function st(t, e, n) {
  if (Ct && Ee) {
    let i = Wi.get(t);
    i || Wi.set(t, i = /* @__PURE__ */ new Map());
    let r = i.get(n);
    r || (i.set(n, r = new ps()), r.map = i, r.key = n), r.track({
      target: t,
      type: e,
      key: n
    });
  }
}
function kn(t, e, n, i, r, s) {
  const o = Wi.get(t);
  if (!o) {
    Gr++;
    return;
  }
  const a = (u) => {
    u && u.trigger({
      target: t,
      type: e,
      key: n,
      newValue: i,
      oldValue: r,
      oldTarget: s
    });
  };
  if (sa(), e === "clear")
    o.forEach(a);
  else {
    const u = gt(t), c = u && ia(n);
    if (u && n === "length") {
      const l = Number(i);
      o.forEach((h, f) => {
        (f === "length" || f === Kr || !ii(f) && f >= l) && a(h);
      });
    } else
      switch ((n !== void 0 || o.has(void 0)) && a(o.get(n)), c && a(o.get(Kr)), e) {
        case "add":
          u ? c && a(o.get("length")) : (a(o.get(Zn)), mr(t) && a(o.get(So)));
          break;
        case "delete":
          u || (a(o.get(Zn)), mr(t) && a(o.get(So)));
          break;
        case "set":
          mr(t) && a(o.get(Zn));
          break;
      }
  }
  oa();
}
function Vf(t, e) {
  const n = Wi.get(t);
  return n && n.get(e);
}
function or(t) {
  const e = Se(t);
  return e === t ? e : (st(e, "iterate", Kr), ot(t) ? e : e.map(et));
}
function ua(t) {
  return st(t = Se(t), "iterate", Kr), t;
}
const Gf = {
  __proto__: null,
  [Symbol.iterator]() {
    return Fs(this, Symbol.iterator, et);
  },
  concat(...t) {
    return or(this).concat(
      ...t.map((e) => gt(e) ? or(e) : e)
    );
  },
  entries() {
    return Fs(this, "entries", (t) => (t[1] = et(t[1]), t));
  },
  every(t, e) {
    return Jt(this, "every", t, e, void 0, arguments);
  },
  filter(t, e) {
    return Jt(this, "filter", t, e, (n) => n.map(et), arguments);
  },
  find(t, e) {
    return Jt(this, "find", t, e, et, arguments);
  },
  findIndex(t, e) {
    return Jt(this, "findIndex", t, e, void 0, arguments);
  },
  findLast(t, e) {
    return Jt(this, "findLast", t, e, et, arguments);
  },
  findLastIndex(t, e) {
    return Jt(this, "findLastIndex", t, e, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(t, e) {
    return Jt(this, "forEach", t, e, void 0, arguments);
  },
  includes(...t) {
    return Os(this, "includes", t);
  },
  indexOf(...t) {
    return Os(this, "indexOf", t);
  },
  join(t) {
    return or(this).join(t);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...t) {
    return Os(this, "lastIndexOf", t);
  },
  map(t, e) {
    return Jt(this, "map", t, e, void 0, arguments);
  },
  pop() {
    return Or(this, "pop");
  },
  push(...t) {
    return Or(this, "push", t);
  },
  reduce(t, ...e) {
    return qa(this, "reduce", t, e);
  },
  reduceRight(t, ...e) {
    return qa(this, "reduceRight", t, e);
  },
  shift() {
    return Or(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(t, e) {
    return Jt(this, "some", t, e, void 0, arguments);
  },
  splice(...t) {
    return Or(this, "splice", t);
  },
  toReversed() {
    return or(this).toReversed();
  },
  toSorted(t) {
    return or(this).toSorted(t);
  },
  toSpliced(...t) {
    return or(this).toSpliced(...t);
  },
  unshift(...t) {
    return Or(this, "unshift", t);
  },
  values() {
    return Fs(this, "values", et);
  }
};
function Fs(t, e, n) {
  const i = ua(t), r = i[e]();
  return i !== t && !ot(t) && (r._next = r.next, r.next = () => {
    const s = r._next();
    return s.value && (s.value = n(s.value)), s;
  }), r;
}
const Kf = Array.prototype;
function Jt(t, e, n, i, r, s) {
  const o = ua(t), a = o !== t && !ot(t), u = o[e];
  if (u !== Kf[e]) {
    const h = u.apply(t, s);
    return a ? et(h) : h;
  }
  let c = n;
  o !== t && (a ? c = function(h, f) {
    return n.call(this, et(h), f, t);
  } : n.length > 2 && (c = function(h, f) {
    return n.call(this, h, f, t);
  }));
  const l = u.call(o, c, i);
  return a && r ? r(l) : l;
}
function qa(t, e, n, i) {
  const r = ua(t);
  let s = n;
  return r !== t && (ot(t) ? n.length > 3 && (s = function(o, a, u) {
    return n.call(this, o, a, u, t);
  }) : s = function(o, a, u) {
    return n.call(this, o, et(a), u, t);
  }), r[e](s, ...i);
}
function Os(t, e, n) {
  const i = Se(t);
  st(i, "iterate", Kr);
  const r = i[e](...n);
  return (r === -1 || r === !1) && ld(n[0]) ? (n[0] = Se(n[0]), i[e](...n)) : r;
}
function Or(t, e, n = []) {
  si(), sa();
  const i = Se(t)[e].apply(t, n);
  return oa(), oi(), i;
}
const Zf = /* @__PURE__ */ Rf("__proto__,__v_isRef,__isVue"), xl = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((t) => t !== "arguments" && t !== "caller").map((t) => Symbol[t]).filter(ii)
);
function Jf(t) {
  ii(t) || (t = String(t));
  const e = Se(this);
  return st(e, "has", t), e.hasOwnProperty(t);
}
class kl {
  constructor(e = !1, n = !1) {
    this._isReadonly = e, this._isShallow = n;
  }
  get(e, n, i) {
    if (n === "__v_skip") return e.__v_skip;
    const r = this._isReadonly, s = this._isShallow;
    if (n === "__v_isReactive")
      return !r;
    if (n === "__v_isReadonly")
      return r;
    if (n === "__v_isShallow")
      return s;
    if (n === "__v_raw")
      return i === (r ? s ? Dl : Tl : s ? Cl : El).get(e) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(e) === Object.getPrototypeOf(i) ? e : void 0;
    const o = gt(e);
    if (!r) {
      let u;
      if (o && (u = Gf[n]))
        return u;
      if (n === "hasOwnProperty")
        return Jf;
    }
    const a = Reflect.get(
      e,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      We(e) ? e : i
    );
    return (ii(n) ? xl.has(n) : Zf(n)) || (r || st(e, "get", n), s) ? a : We(a) ? o && ia(n) ? a : a.value : Wt(a) ? r ? ai(a) : ie(a) : a;
  }
}
class Sl extends kl {
  constructor(e = !1) {
    super(!1, e);
  }
  set(e, n, i, r) {
    let s = e[n];
    if (!this._isShallow) {
      const u = Vt(s);
      if (!ot(i) && !Vt(i) && (s = Se(s), i = Se(i)), !gt(e) && We(s) && !We(i))
        return u ? !1 : (s.value = i, !0);
    }
    const o = gt(e) && ia(n) ? Number(n) < e.length : qi(e, n), a = Reflect.set(
      e,
      n,
      i,
      We(e) ? e : r
    );
    return e === Se(r) && (o ? Dn(i, s) && kn(e, "set", n, i, s) : kn(e, "add", n, i)), a;
  }
  deleteProperty(e, n) {
    const i = qi(e, n), r = e[n], s = Reflect.deleteProperty(e, n);
    return s && i && kn(e, "delete", n, void 0, r), s;
  }
  has(e, n) {
    const i = Reflect.has(e, n);
    return (!ii(n) || !xl.has(n)) && st(e, "has", n), i;
  }
  ownKeys(e) {
    return st(
      e,
      "iterate",
      gt(e) ? "length" : Zn
    ), Reflect.ownKeys(e);
  }
}
class Al extends kl {
  constructor(e = !1) {
    super(!0, e);
  }
  set(e, n) {
    return an(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      e
    ), !0;
  }
  deleteProperty(e, n) {
    return an(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      e
    ), !0;
  }
}
const Yf = /* @__PURE__ */ new Sl(), Xf = /* @__PURE__ */ new Al(), Qf = /* @__PURE__ */ new Sl(!0), ed = /* @__PURE__ */ new Al(!0), Ao = (t) => t, di = (t) => Reflect.getPrototypeOf(t);
function td(t, e, n) {
  return function(...i) {
    const r = this.__v_raw, s = Se(r), o = mr(s), a = t === "entries" || t === Symbol.iterator && o, u = t === "keys" && o, c = r[t](...i), l = n ? Ao : e ? Eo : et;
    return !e && st(
      s,
      "iterate",
      u ? So : Zn
    ), {
      // iterator protocol
      next() {
        const { value: h, done: f } = c.next();
        return f ? { value: h, done: f } : {
          value: a ? [l(h[0]), l(h[1])] : l(h),
          done: f
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function pi(t) {
  return function(...e) {
    {
      const n = e[0] ? `on key "${e[0]}" ` : "";
      an(
        `${pl(t)} operation ${n}failed: target is readonly.`,
        Se(this)
      );
    }
    return t === "delete" ? !1 : t === "clear" ? void 0 : this;
  };
}
function nd(t, e) {
  const n = {
    get(r) {
      const s = this.__v_raw, o = Se(s), a = Se(r);
      t || (Dn(r, a) && st(o, "get", r), st(o, "get", a));
      const { has: u } = di(o), c = e ? Ao : t ? Eo : et;
      if (u.call(o, r))
        return c(s.get(r));
      if (u.call(o, a))
        return c(s.get(a));
      s !== o && s.get(r);
    },
    get size() {
      const r = this.__v_raw;
      return !t && st(Se(r), "iterate", Zn), Reflect.get(r, "size", r);
    },
    has(r) {
      const s = this.__v_raw, o = Se(s), a = Se(r);
      return t || (Dn(r, a) && st(o, "has", r), st(o, "has", a)), r === a ? s.has(r) : s.has(r) || s.has(a);
    },
    forEach(r, s) {
      const o = this, a = o.__v_raw, u = Se(a), c = e ? Ao : t ? Eo : et;
      return !t && st(u, "iterate", Zn), a.forEach((l, h) => r.call(s, c(l), c(h), o));
    }
  };
  return vr(
    n,
    t ? {
      add: pi("add"),
      set: pi("set"),
      delete: pi("delete"),
      clear: pi("clear")
    } : {
      add(r) {
        !e && !ot(r) && !Vt(r) && (r = Se(r));
        const s = Se(this);
        return di(s).has.call(s, r) || (s.add(r), kn(s, "add", r, r)), this;
      },
      set(r, s) {
        !e && !ot(s) && !Vt(s) && (s = Se(s));
        const o = Se(this), { has: a, get: u } = di(o);
        let c = a.call(o, r);
        c ? Wa(o, a, r) : (r = Se(r), c = a.call(o, r));
        const l = u.call(o, r);
        return o.set(r, s), c ? Dn(s, l) && kn(o, "set", r, s, l) : kn(o, "add", r, s), this;
      },
      delete(r) {
        const s = Se(this), { has: o, get: a } = di(s);
        let u = o.call(s, r);
        u ? Wa(s, o, r) : (r = Se(r), u = o.call(s, r));
        const c = a ? a.call(s, r) : void 0, l = s.delete(r);
        return u && kn(s, "delete", r, void 0, c), l;
      },
      clear() {
        const r = Se(this), s = r.size !== 0, o = mr(r) ? new Map(r) : new Set(r), a = r.clear();
        return s && kn(
          r,
          "clear",
          void 0,
          void 0,
          o
        ), a;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((r) => {
    n[r] = td(r, t, e);
  }), n;
}
function ms(t, e) {
  const n = nd(t, e);
  return (i, r, s) => r === "__v_isReactive" ? !t : r === "__v_isReadonly" ? t : r === "__v_raw" ? i : Reflect.get(
    qi(n, r) && r in i ? n : i,
    r,
    s
  );
}
const rd = {
  get: /* @__PURE__ */ ms(!1, !1)
}, id = {
  get: /* @__PURE__ */ ms(!1, !0)
}, sd = {
  get: /* @__PURE__ */ ms(!0, !1)
}, od = {
  get: /* @__PURE__ */ ms(!0, !0)
};
function Wa(t, e, n) {
  const i = Se(n);
  if (i !== n && e.call(t, i)) {
    const r = fl(t);
    an(
      `Reactive ${r} contains both the raw and reactive versions of the same object${r === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const El = /* @__PURE__ */ new WeakMap(), Cl = /* @__PURE__ */ new WeakMap(), Tl = /* @__PURE__ */ new WeakMap(), Dl = /* @__PURE__ */ new WeakMap();
function ad(t) {
  switch (t) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function ud(t) {
  return t.__v_skip || !Object.isExtensible(t) ? 0 : ad(fl(t));
}
function ie(t) {
  return Vt(t) ? t : gs(
    t,
    !1,
    Yf,
    rd,
    El
  );
}
function cd(t) {
  return gs(
    t,
    !1,
    Qf,
    id,
    Cl
  );
}
function ai(t) {
  return gs(
    t,
    !0,
    Xf,
    sd,
    Tl
  );
}
function Fl(t) {
  return gs(
    t,
    !0,
    ed,
    od,
    Dl
  );
}
function gs(t, e, n, i, r) {
  if (!Wt(t))
    return an(
      `value cannot be made ${e ? "readonly" : "reactive"}: ${String(
        t
      )}`
    ), t;
  if (t.__v_raw && !(e && t.__v_isReactive))
    return t;
  const s = r.get(t);
  if (s)
    return s;
  const o = ud(t);
  if (o === 0)
    return t;
  const a = new Proxy(
    t,
    o === 2 ? i : n
  );
  return r.set(t, a), a;
}
function qr(t) {
  return Vt(t) ? qr(t.__v_raw) : !!(t && t.__v_isReactive);
}
function Vt(t) {
  return !!(t && t.__v_isReadonly);
}
function ot(t) {
  return !!(t && t.__v_isShallow);
}
function ld(t) {
  return t ? !!t.__v_raw : !1;
}
function Se(t) {
  const e = t && t.__v_raw;
  return e ? Se(e) : t;
}
function hd(t) {
  return !qi(t, "__v_skip") && Object.isExtensible(t) && Uf(t, "__v_skip", !0), t;
}
const et = (t) => Wt(t) ? ie(t) : t, Eo = (t) => Wt(t) ? ai(t) : t;
function We(t) {
  return t ? t.__v_isRef === !0 : !1;
}
function ye(t) {
  return Ol(t, !1);
}
function _e(t) {
  return Ol(t, !0);
}
function Ol(t, e) {
  return We(t) ? t : new fd(t, e);
}
class fd {
  constructor(e, n) {
    this.dep = new ps(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? e : Se(e), this._value = n ? e : et(e), this.__v_isShallow = n;
  }
  get value() {
    return this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }), this._value;
  }
  set value(e) {
    const n = this._rawValue, i = this.__v_isShallow || ot(e) || Vt(e);
    e = i ? e : Se(e), Dn(e, n) && (this._rawValue = e, this._value = i ? e : et(e), this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: e,
      oldValue: n
    }));
  }
}
function ca(t) {
  return We(t) ? t.value : t;
}
function De(t) {
  return nt(t) ? t() : ca(t);
}
class dd {
  constructor(e) {
    this.__v_isRef = !0, this._value = void 0;
    const n = this.dep = new ps(), { get: i, set: r } = e(n.track.bind(n), n.trigger.bind(n));
    this._get = i, this._set = r;
  }
  get value() {
    return this._value = this._get();
  }
  set value(e) {
    this._set(e);
  }
}
function pd(t) {
  return new dd(t);
}
class md {
  constructor(e, n, i) {
    this._object = e, this._key = n, this._defaultValue = i, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const e = this._object[this._key];
    return this._value = e === void 0 ? this._defaultValue : e;
  }
  set value(e) {
    this._object[this._key] = e;
  }
  get dep() {
    return Vf(Se(this._object), this._key);
  }
}
class gd {
  constructor(e) {
    this._getter = e, this.__v_isRef = !0, this.__v_isReadonly = !0, this._value = void 0;
  }
  get value() {
    return this._value = this._getter();
  }
}
function Co(t, e, n) {
  return We(t) ? t : nt(t) ? new gd(t) : Wt(t) && arguments.length > 1 ? bd(t, e, n) : ye(t);
}
function bd(t, e, n) {
  const i = t[e];
  return We(i) ? i : new md(t, e, n);
}
class _d {
  constructor(e, n, i) {
    this.fn = e, this.setter = n, this._value = void 0, this.dep = new ps(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Gr - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = i;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Ee !== this)
      return gl(this, !0), !0;
  }
  get value() {
    const e = this.dep.track({
      target: this,
      type: "get",
      key: "value"
    });
    return yl(this), e && (e.version = this.dep.version), this._value;
  }
  set value(e) {
    this.setter ? this.setter(e) : an("Write operation failed: computed value is readonly");
  }
}
function yd(t, e, n = !1) {
  let i, r;
  nt(t) ? i = t : (i = t.get, r = t.set);
  const s = new _d(i, r, n);
  return e && !n && (s.onTrack = e.onTrack, s.onTrigger = e.onTrigger), s;
}
const mi = {}, Vi = /* @__PURE__ */ new WeakMap();
let zn;
function vd(t, e = !1, n = zn) {
  if (n) {
    let i = Vi.get(n);
    i || Vi.set(n, i = []), i.push(t);
  } else e || an(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function wd(t, e, n = Vr) {
  const { immediate: i, deep: r, once: s, scheduler: o, augmentJob: a, call: u } = n, c = (v) => {
    (n.onWarn || an)(
      "Invalid watch source: ",
      v,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, l = (v) => r ? v : ot(v) || r === !1 || r === 0 ? Sn(v, 1) : Sn(v);
  let h, f, d, p, m = !1, _ = !1;
  if (We(t) ? (f = () => t.value, m = ot(t)) : qr(t) ? (f = () => l(t), m = !0) : gt(t) ? (_ = !0, m = t.some((v) => qr(v) || ot(v)), f = () => t.map((v) => {
    if (We(v))
      return v.value;
    if (qr(v))
      return l(v);
    if (nt(v))
      return u ? u(v, 2) : v();
    c(v);
  })) : nt(t) ? e ? f = u ? () => u(t, 2) : t : f = () => {
    if (d) {
      si();
      try {
        d();
      } finally {
        oi();
      }
    }
    const v = zn;
    zn = h;
    try {
      return u ? u(t, 3, [p]) : t(p);
    } finally {
      zn = v;
    }
  } : (f = Pi, c(t)), e && r) {
    const v = f, w = r === !0 ? 1 / 0 : r;
    f = () => Sn(v(), w);
  }
  const y = () => {
    h.stop();
  };
  if (s && e) {
    const v = e;
    e = (...w) => {
      v(...w), y();
    };
  }
  let b = _ ? new Array(t.length).fill(mi) : mi;
  const g = (v) => {
    if (!(!(h.flags & 1) || !h.dirty && !v))
      if (e) {
        const w = h.run();
        if (r || m || (_ ? w.some((E, A) => Dn(E, b[A])) : Dn(w, b))) {
          d && d();
          const E = zn;
          zn = h;
          try {
            const A = [
              w,
              // pass undefined as the old value when it's changed for the first time
              b === mi ? void 0 : _ && b[0] === mi ? [] : b,
              p
            ];
            u ? u(e, 3, A) : (
              // @ts-expect-error
              e(...A)
            ), b = w;
          } finally {
            zn = E;
          }
        }
      } else
        h.run();
  };
  return a && a(g), h = new Hf(f), h.scheduler = o ? () => o(g, !1) : g, p = (v) => vd(v, !1, h), d = h.onStop = () => {
    const v = Vi.get(h);
    if (v) {
      if (u)
        u(v, 4);
      else
        for (const w of v) w();
      Vi.delete(h);
    }
  }, h.onTrack = n.onTrack, h.onTrigger = n.onTrigger, e ? i ? g(!0) : b = h.run() : o ? o(g.bind(null, !0), !0) : h.run(), y.pause = h.pause.bind(h), y.resume = h.resume.bind(h), y.stop = y, y;
}
function Sn(t, e = 1 / 0, n) {
  if (e <= 0 || !Wt(t) || t.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(t)))
    return t;
  if (n.add(t), e--, We(t))
    Sn(t.value, e, n);
  else if (gt(t))
    for (let i = 0; i < t.length; i++)
      Sn(t[i], e, n);
  else if (jf(t) || mr(t))
    t.forEach((i) => {
      Sn(i, e, n);
    });
  else if ($f(t)) {
    for (const i in t)
      Sn(t[i], e, n);
    for (const i of Object.getOwnPropertySymbols(t))
      Object.prototype.propertyIsEnumerable.call(t, i) && Sn(t[i], e, n);
  }
  return t;
}
const Jn = [];
function xd(t) {
  Jn.push(t);
}
function kd() {
  Jn.pop();
}
let Is = !1;
function lt(t, ...e) {
  if (Is) return;
  Is = !0, si();
  const n = Jn.length ? Jn[Jn.length - 1].component : null, i = n && n.appContext.config.warnHandler, r = Sd();
  if (i)
    bs(
      i,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        t + e.map((s) => {
          var o, a;
          return (a = (o = s.toString) == null ? void 0 : o.call(s)) != null ? a : JSON.stringify(s);
        }).join(""),
        n && n.proxy,
        r.map(
          ({ vnode: s }) => `at <${ql(n, s.type)}>`
        ).join(`
`),
        r
      ]
    );
  else {
    const s = [`[Vue warn]: ${t}`, ...e];
    r.length && s.push(`
`, ...Ad(r)), console.warn(...s);
  }
  oi(), Is = !1;
}
function Sd() {
  let t = Jn[Jn.length - 1];
  if (!t)
    return [];
  const e = [];
  for (; t; ) {
    const n = e[0];
    n && n.vnode === t ? n.recurseCount++ : e.push({
      vnode: t,
      recurseCount: 0
    });
    const i = t.component && t.component.parent;
    t = i && i.vnode;
  }
  return e;
}
function Ad(t) {
  const e = [];
  return t.forEach((n, i) => {
    e.push(...i === 0 ? [] : [`
`], ...Ed(n));
  }), e;
}
function Ed({ vnode: t, recurseCount: e }) {
  const n = e > 0 ? `... (${e} recursive calls)` : "", i = t.component ? t.component.parent == null : !1, r = ` at <${ql(
    t.component,
    t.type,
    i
  )}`, s = ">" + n;
  return t.props ? [r, ...Cd(t.props), s] : [r + s];
}
function Cd(t) {
  const e = [], n = Object.keys(t);
  return n.slice(0, 3).forEach((i) => {
    e.push(...Il(i, t[i]));
  }), n.length > 3 && e.push(" ..."), e;
}
function Il(t, e, n) {
  return hl(e) ? (e = JSON.stringify(e), n ? e : [`${t}=${e}`]) : typeof e == "number" || typeof e == "boolean" || e == null ? n ? e : [`${t}=${e}`] : We(e) ? (e = Il(t, Se(e.value), !0), n ? e : [`${t}=Ref<`, e, ">"]) : nt(e) ? [`${t}=fn${e.name ? `<${e.name}>` : ""}`] : (e = Se(e), n ? e : [`${t}=`, e]);
}
const la = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function bs(t, e, n, i) {
  try {
    return i ? t(...i) : t();
  } catch (r) {
    fa(r, e, n);
  }
}
function ha(t, e, n, i) {
  if (nt(t)) {
    const r = bs(t, e, n, i);
    return r && Nf(r) && r.catch((s) => {
      fa(s, e, n);
    }), r;
  }
  if (gt(t)) {
    const r = [];
    for (let s = 0; s < t.length; s++)
      r.push(ha(t[s], e, n, i));
    return r;
  } else
    lt(
      `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof t}`
    );
}
function fa(t, e, n, i = !0) {
  const r = e ? e.vnode : null, { errorHandler: s, throwUnhandledErrorInProduction: o } = e && e.appContext.config || Vr;
  if (e) {
    let a = e.parent;
    const u = e.proxy, c = la[n];
    for (; a; ) {
      const l = a.ec;
      if (l) {
        for (let h = 0; h < l.length; h++)
          if (l[h](t, u, c) === !1)
            return;
      }
      a = a.parent;
    }
    if (s) {
      si(), bs(s, null, 10, [
        t,
        u,
        c
      ]), oi();
      return;
    }
  }
  Td(t, n, r, i, o);
}
function Td(t, e, n, i = !0, r = !1) {
  {
    const s = la[e];
    if (n && xd(n), lt(`Unhandled error${s ? ` during execution of ${s}` : ""}`), n && kd(), i)
      throw t;
    console.error(t);
  }
}
const mt = [];
let Qt = -1;
const gr = [];
let wn = null, hr = 0;
const Pl = /* @__PURE__ */ Promise.resolve();
let Gi = null;
const Dd = 100;
function _s(t) {
  const e = Gi || Pl;
  return t ? e.then(this ? t.bind(this) : t) : e;
}
function Fd(t) {
  let e = Qt + 1, n = mt.length;
  for (; e < n; ) {
    const i = e + n >>> 1, r = mt[i], s = Zr(r);
    s < t || s === t && r.flags & 2 ? e = i + 1 : n = i;
  }
  return e;
}
function Rl(t) {
  if (!(t.flags & 1)) {
    const e = Zr(t), n = mt[mt.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(t.flags & 2) && e >= Zr(n) ? mt.push(t) : mt.splice(Fd(e), 0, t), t.flags |= 1, Ll();
  }
}
function Ll() {
  Gi || (Gi = Pl.then(jl));
}
function Ml(t) {
  gt(t) ? gr.push(...t) : wn && t.id === -1 ? wn.splice(hr + 1, 0, t) : t.flags & 1 || (gr.push(t), t.flags |= 1), Ll();
}
function Od(t) {
  if (gr.length) {
    const e = [...new Set(gr)].sort(
      (n, i) => Zr(n) - Zr(i)
    );
    if (gr.length = 0, wn) {
      wn.push(...e);
      return;
    }
    for (wn = e, t = t || /* @__PURE__ */ new Map(), hr = 0; hr < wn.length; hr++) {
      const n = wn[hr];
      Nl(t, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    wn = null, hr = 0;
  }
}
const Zr = (t) => t.id == null ? t.flags & 2 ? -1 : 1 / 0 : t.id;
function jl(t) {
  t = t || /* @__PURE__ */ new Map();
  const e = (n) => Nl(t, n);
  try {
    for (Qt = 0; Qt < mt.length; Qt++) {
      const n = mt[Qt];
      if (n && !(n.flags & 8)) {
        if (e(n))
          continue;
        n.flags & 4 && (n.flags &= -2), bs(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; Qt < mt.length; Qt++) {
      const n = mt[Qt];
      n && (n.flags &= -2);
    }
    Qt = -1, mt.length = 0, Od(t), Gi = null, (mt.length || gr.length) && jl(t);
  }
}
function Nl(t, e) {
  const n = t.get(e) || 0;
  if (n > Dd) {
    const i = e.i, r = i && Hl(i.type);
    return fa(
      `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return t.set(e, n + 1), !1;
}
const Ps = /* @__PURE__ */ new Map();
ds().__VUE_HMR_RUNTIME__ = {
  createRecord: Rs(Id),
  rerender: Rs(Pd),
  reload: Rs(Rd)
};
const Ki = /* @__PURE__ */ new Map();
function Id(t, e) {
  return Ki.has(t) ? !1 : (Ki.set(t, {
    initialDef: Zi(e),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Zi(t) {
  return Zd(t) ? t.__vccOpts : t;
}
function Pd(t, e) {
  const n = Ki.get(t);
  n && (n.initialDef.render = e, [...n.instances].forEach((i) => {
    e && (i.render = e, Zi(i.type).render = e), i.renderCache = [], i.update();
  }));
}
function Rd(t, e) {
  const n = Ki.get(t);
  if (!n) return;
  e = Zi(e), Va(n.initialDef, e);
  const i = [...n.instances];
  for (let r = 0; r < i.length; r++) {
    const s = i[r], o = Zi(s.type);
    let a = Ps.get(o);
    a || (o !== n.initialDef && Va(o, e), Ps.set(o, a = /* @__PURE__ */ new Set())), a.add(s), s.appContext.propsCache.delete(s.type), s.appContext.emitsCache.delete(s.type), s.appContext.optionsCache.delete(s.type), s.ceReload ? (a.add(s), s.ceReload(e.styles), a.delete(s)) : s.parent ? Rl(() => {
      s.parent.update(), a.delete(s);
    }) : s.appContext.reload ? s.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), s.root.ce && s !== s.root && s.root.ce._removeChildStyle(o);
  }
  Ml(() => {
    Ps.clear();
  });
}
function Va(t, e) {
  vr(t, e);
  for (const n in t)
    n !== "__file" && !(n in e) && delete t[n];
}
function Rs(t) {
  return (e, n) => {
    try {
      return t(e, n);
    } catch (i) {
      console.error(i), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let da = null;
ds().requestIdleCallback;
ds().cancelIdleCallback;
const Ld = (t) => t.type.__isKeepAlive;
function Md(t, e) {
  jd(t, "a", e);
}
function jd(t, e, n = ln) {
  const i = t.__wdc || (t.__wdc = () => {
    let r = n;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return t();
  });
  if (pa(e, i, n), n) {
    let r = n.parent;
    for (; r && r.parent; )
      Ld(r.parent.vnode) && Nd(i, e, n, r), r = r.parent;
  }
}
function Nd(t, e, n, i) {
  const r = pa(
    e,
    t,
    i,
    !0
    /* prepend */
  );
  $d(() => {
    Lf(i[e], r);
  }, n);
}
function pa(t, e, n = ln, i = !1) {
  if (n) {
    const r = n[t] || (n[t] = []), s = e.__weh || (e.__weh = (...o) => {
      si();
      const a = Vd(n), u = ha(e, n, t, o);
      return a(), oi(), u;
    });
    return i ? r.unshift(s) : r.push(s), s;
  } else {
    const r = zf(la[t].replace(/ hook$/, ""));
    lt(
      `${r} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const ma = (t) => (e, n = ln) => {
  (!Jr || t === "sp") && pa(t, (...i) => e(...i), n);
}, ga = ma("m"), Bd = ma(
  "bum"
), $d = ma("um"), zd = {};
zd.ownKeys = (t) => (lt(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(t));
let Bl = null;
function $l(t, e, n = !1) {
  const i = ln || da;
  if (i || Bl) {
    const r = i ? i.parent == null ? i.vnode.appContext && i.vnode.appContext.provides : i.parent.provides : void 0;
    if (r && t in r)
      return r[t];
    if (arguments.length > 1)
      return n && nt(e) ? e.call(i && i.proxy) : e;
    lt(`injection "${String(t)}" not found.`);
  } else
    lt("inject() can only be used inside setup() or functional components.");
}
function zl() {
  return !!(ln || da || Bl);
}
const Ud = Wd, Hd = Symbol.for("v-scx"), qd = () => {
  {
    const t = $l(Hd);
    return t || lt(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), t;
  }
};
function nr(t, e) {
  return Ul(t, null, e);
}
function Ge(t, e, n) {
  return nt(e) || lt(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), Ul(t, e, n);
}
function Ul(t, e, n = Vr) {
  const { immediate: i, deep: r, flush: s, once: o } = n;
  e || (i !== void 0 && lt(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && lt(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), o !== void 0 && lt(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const a = vr({}, n);
  a.onWarn = lt;
  const u = e && i || !e && s !== "post";
  let c;
  if (Jr) {
    if (s === "sync") {
      const d = qd();
      c = d.__watcherHandles || (d.__watcherHandles = []);
    } else if (!u) {
      const d = () => {
      };
      return d.stop = Pi, d.resume = Pi, d.pause = Pi, d;
    }
  }
  const l = ln;
  a.call = (d, p, m) => ha(d, l, p, m);
  let h = !1;
  s === "post" ? a.scheduler = (d) => {
    Ud(d, l && l.suspense);
  } : s !== "sync" && (h = !0, a.scheduler = (d, p) => {
    p ? d() : Rl(d);
  }), a.augmentJob = (d) => {
    e && (d.flags |= 4), h && (d.flags |= 2, l && (d.id = l.uid, d.i = l));
  };
  const f = wd(t, e, a);
  return Jr && (c ? c.push(f) : u && f()), f;
}
function Wd(t, e) {
  e && e.pendingBranch ? gt(t) ? e.effects.push(...t) : e.effects.push(t) : Ml(t);
}
let ln = null;
const ys = () => ln || da;
let To;
{
  const t = ds(), e = (n, i) => {
    let r;
    return (r = t[n]) || (r = t[n] = []), r.push(i), (s) => {
      r.length > 1 ? r.forEach((o) => o(s)) : r[0](s);
    };
  };
  To = e(
    "__VUE_INSTANCE_SETTERS__",
    (n) => ln = n
  ), e(
    "__VUE_SSR_SETTERS__",
    (n) => Jr = n
  );
}
const Vd = (t) => {
  const e = ln;
  return To(t), t.scope.on(), () => {
    t.scope.off(), To(e);
  };
};
let Jr = !1;
const Gd = /(?:^|[-_])(\w)/g, Kd = (t) => t.replace(Gd, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function Hl(t, e = !0) {
  return nt(t) ? t.displayName || t.name : t.name || e && t.__name;
}
function ql(t, e, n = !1) {
  let i = Hl(e);
  if (!i && e.__file) {
    const r = e.__file.match(/([^/\\]+)\.\w+$/);
    r && (i = r[1]);
  }
  if (!i && t && t.parent) {
    const r = (s) => {
      for (const o in s)
        if (s[o] === e)
          return o;
    };
    i = r(
      t.components || t.parent.type.components
    ) || r(t.appContext.components);
  }
  return i ? Kd(i) : n ? "App" : "Anonymous";
}
function Zd(t) {
  return nt(t) && "__vccOpts" in t;
}
const te = (t, e) => {
  const n = yd(t, e, Jr);
  {
    const i = ys();
    i && i.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function Jd() {
  if (typeof window > "u")
    return;
  const t = { style: "color:#3ba776" }, e = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, i = { style: "color:#eb2f96" }, r = {
    __vue_custom_formatter: !0,
    header(h) {
      return Wt(h) ? h.__isVue ? ["div", t, "VueInstance"] : We(h) ? [
        "div",
        {},
        ["span", t, l(h)],
        "<",
        // avoid debugger accessing value affecting behavior
        a("_value" in h ? h._value : h),
        ">"
      ] : qr(h) ? [
        "div",
        {},
        ["span", t, ot(h) ? "ShallowReactive" : "Reactive"],
        "<",
        a(h),
        `>${Vt(h) ? " (readonly)" : ""}`
      ] : Vt(h) ? [
        "div",
        {},
        ["span", t, ot(h) ? "ShallowReadonly" : "Readonly"],
        "<",
        a(h),
        ">"
      ] : null : null;
    },
    hasBody(h) {
      return h && h.__isVue;
    },
    body(h) {
      if (h && h.__isVue)
        return [
          "div",
          {},
          ...s(h.$)
        ];
    }
  };
  function s(h) {
    const f = [];
    h.type.props && h.props && f.push(o("props", Se(h.props))), h.setupState !== Vr && f.push(o("setup", h.setupState)), h.data !== Vr && f.push(o("data", Se(h.data)));
    const d = u(h, "computed");
    d && f.push(o("computed", d));
    const p = u(h, "inject");
    return p && f.push(o("injected", p)), f.push([
      "div",
      {},
      [
        "span",
        {
          style: i.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: h }]
    ]), f;
  }
  function o(h, f) {
    return f = vr({}, f), Object.keys(f).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        h
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(f).map((d) => [
          "div",
          {},
          ["span", i, d + ": "],
          a(f[d], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(h, f = !0) {
    return typeof h == "number" ? ["span", e, h] : typeof h == "string" ? ["span", n, JSON.stringify(h)] : typeof h == "boolean" ? ["span", i, h] : Wt(h) ? ["object", { object: f ? Se(h) : h }] : ["span", n, String(h)];
  }
  function u(h, f) {
    const d = h.type;
    if (nt(d))
      return;
    const p = {};
    for (const m in h.ctx)
      c(d, m, f) && (p[m] = h.ctx[m]);
    return p;
  }
  function c(h, f, d) {
    const p = h[d];
    if (gt(p) && p.includes(f) || Wt(p) && f in p || h.extends && c(h.extends, f, d) || h.mixins && h.mixins.some((m) => c(m, f, d)))
      return !0;
  }
  function l(h) {
    return ot(h) ? "ShallowRef" : h.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(r) : window.devtoolsFormatters = [r];
}
const Yd = lt;
let Xd;
const Ga = typeof window < "u" && window.trustedTypes;
if (Ga)
  try {
    Xd = /* @__PURE__ */ Ga.createPolicy("vue", {
      createHTML: (t) => t
    });
  } catch (t) {
    Yd(`Error creating trusted types policy: ${t}`);
  }
const Qd = {};
Qd.name = "show";
function e0() {
  console.info(
    `You are running a development build of Vue.
Make sure to use the production build (*.prod.js) when deploying for production.`
  ), Jd();
}
function t0(t) {
  Object.getOwnPropertySymbols(t).forEach((e) => {
  });
}
new RegExp(
  "\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b"
);
const n0 = Symbol("vModelRadio"), r0 = Symbol(
  "vModelCheckbox"
), i0 = Symbol("vModelText"), s0 = Symbol(
  "vModelSelect"
), o0 = Symbol(
  "vModelDynamic"
), a0 = Symbol(
  "vOnModifiersGuard"
), u0 = Symbol(
  "vOnKeysGuard"
), c0 = Symbol("vShow"), l0 = Symbol("Transition"), h0 = Symbol(
  "TransitionGroup"
);
t0({
  [n0]: "vModelRadio",
  [r0]: "vModelCheckbox",
  [i0]: "vModelText",
  [s0]: "vModelSelect",
  [o0]: "vModelDynamic",
  [a0]: "withModifiers",
  [u0]: "withKeys",
  [c0]: "vShow",
  [l0]: "Transition",
  [h0]: "TransitionGroup"
});
e0();
const Ls = /* @__PURE__ */ new WeakMap(), f0 = (...t) => {
  var e;
  const n = t[0], i = (e = ys()) == null ? void 0 : e.proxy;
  if (i == null && !zl())
    throw new Error("injectLocal must be called in setup");
  return i && Ls.has(i) && n in Ls.get(i) ? Ls.get(i)[n] : $l(...t);
};
function d0(t) {
  if (!We(t))
    return ie(t);
  const e = new Proxy({}, {
    get(n, i, r) {
      return ca(Reflect.get(t.value, i, r));
    },
    set(n, i, r) {
      return We(t.value[i]) && !We(r) ? t.value[i].value = r : t.value[i] = r, !0;
    },
    deleteProperty(n, i) {
      return Reflect.deleteProperty(t.value, i);
    },
    has(n, i) {
      return Reflect.has(t.value, i);
    },
    ownKeys() {
      return Object.keys(t.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  });
  return ie(e);
}
const Yr = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const p0 = (t) => t != null, m0 = Object.prototype.toString, g0 = (t) => m0.call(t) === "[object Object]", Ka = () => +Date.now(), Ms = (t, e, n) => Math.min(n, Math.max(e, t)), Ji = () => {
};
function ba(...t) {
  if (t.length !== 1)
    return Co(...t);
  const e = t[0];
  return typeof e == "function" ? ai(pd(() => ({ get: e, set: Ji }))) : ye(e);
}
function Wl(t, e) {
  function n(...i) {
    return new Promise((r, s) => {
      Promise.resolve(t(() => e.apply(this, i), { fn: e, thisArg: this, args: i })).then(r).catch(s);
    });
  }
  return n;
}
const Vl = (t) => t();
function b0(t, e = {}) {
  let n, i, r = Ji;
  const s = (u) => {
    clearTimeout(u), r(), r = Ji;
  };
  let o;
  return (u) => {
    const c = De(t), l = De(e.maxWait);
    return n && s(n), c <= 0 || l !== void 0 && l <= 0 ? (i && (s(i), i = null), Promise.resolve(u())) : new Promise((h, f) => {
      r = e.rejectOnCancel ? f : h, o = u, l && !i && (i = setTimeout(() => {
        n && s(n), i = null, h(o());
      }, l)), n = setTimeout(() => {
        i && s(i), i = null, h(u());
      }, c);
    });
  };
}
function _0(t = Vl, e = {}) {
  const {
    initialState: n = "active"
  } = e, i = ba(n === "active");
  function r() {
    i.value = !1;
  }
  function s() {
    i.value = !0;
  }
  const o = (...a) => {
    i.value && t(...a);
  };
  return { isActive: ai(i), pause: r, resume: s, eventFilter: o };
}
function y0(t) {
  let e;
  function n() {
    return e || (e = t()), e;
  }
  return n.reset = async () => {
    const i = e;
    e = void 0, i && await i;
  }, n;
}
function Za(t) {
  return t.endsWith("rem") ? Number.parseFloat(t) * 16 : Number.parseFloat(t);
}
function Ri(t) {
  return Array.isArray(t) ? t : [t];
}
function v0(t) {
  return ys();
}
function Gl(t, e = 200, n = {}) {
  return Wl(
    b0(e, n),
    t
  );
}
function w0(t, e = 200, n = {}) {
  const i = ye(De(t)), r = Gl(() => {
    i.value = t.value;
  }, e, n);
  return Ge(t, () => r()), Fl(i);
}
function x0(t, e, n = {}) {
  const {
    eventFilter: i = Vl,
    ...r
  } = n;
  return Ge(
    t,
    Wl(
      i,
      e
    ),
    r
  );
}
function k0(t, e, n = {}) {
  const {
    eventFilter: i,
    initialState: r = "active",
    ...s
  } = n, { eventFilter: o, pause: a, resume: u, isActive: c } = _0(i, { initialState: r });
  return { stop: x0(
    t,
    e,
    {
      ...s,
      eventFilter: o
    }
  ), pause: a, resume: u, isActive: c };
}
function _a(t, e = !0, n) {
  v0() ? ga(t, n) : e ? t() : _s(t);
}
function Kl(t, e = 1e3, n = {}) {
  const {
    immediate: i = !0,
    immediateCallback: r = !1
  } = n;
  let s = null;
  const o = _e(!1);
  function a() {
    s && (clearInterval(s), s = null);
  }
  function u() {
    o.value = !1, a();
  }
  function c() {
    const l = De(e);
    l <= 0 || (o.value = !0, r && t(), a(), o.value && (s = setInterval(t, l)));
  }
  return i && Yr && c(), (We(e) || typeof e == "function") && Ge(e, () => {
    o.value && Yr && c();
  }), {
    isActive: Fl(o),
    pause: u,
    resume: c
  };
}
function S0(t, e, n) {
  return Ge(
    t,
    e,
    {
      ...n,
      immediate: !0
    }
  );
}
function Zl(t, e, n) {
  let i;
  We(n) ? i = {
    evaluating: n
  } : i = n || {};
  const {
    lazy: r = !1,
    evaluating: s = void 0,
    shallow: o = !0,
    onError: a = Ji
  } = i, u = _e(!r), c = o ? _e(e) : ye(e);
  let l = 0;
  return nr(async (h) => {
    if (!u.value)
      return;
    l++;
    const f = l;
    let d = !1;
    s && Promise.resolve().then(() => {
      s.value = !0;
    });
    try {
      const p = await t((m) => {
        h(() => {
          s && (s.value = !1), d || m();
        });
      });
      f === l && (c.value = p);
    } catch (p) {
      a(p);
    } finally {
      s && f === l && (s.value = !1), d = !0;
    }
  }), r ? te(() => (u.value = !0, c.value)) : c;
}
const bt = Yr ? window : void 0, A0 = Yr ? window.document : void 0, ya = Yr ? window.navigator : void 0;
function un(t) {
  var e;
  const n = De(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function Me(...t) {
  const e = [], n = () => {
    e.forEach((a) => a()), e.length = 0;
  }, i = (a, u, c, l) => (a.addEventListener(u, c, l), () => a.removeEventListener(u, c, l)), r = te(() => {
    const a = Ri(De(t[0])).filter((u) => u != null);
    return a.every((u) => typeof u != "string") ? a : void 0;
  }), s = S0(
    () => {
      var a, u;
      return [
        (u = (a = r.value) == null ? void 0 : a.map((c) => un(c))) != null ? u : [bt].filter((c) => c != null),
        Ri(De(r.value ? t[1] : t[0])),
        Ri(ca(r.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        De(r.value ? t[3] : t[2])
      ];
    },
    ([a, u, c, l]) => {
      if (n(), !(a != null && a.length) || !(u != null && u.length) || !(c != null && c.length))
        return;
      const h = g0(l) ? { ...l } : l;
      e.push(
        ...a.flatMap(
          (f) => u.flatMap(
            (d) => c.map((p) => i(f, d, p, h))
          )
        )
      );
    },
    { flush: "post" }
  );
  return () => {
    s(), n();
  };
}
function E0() {
  const t = _e(!1), e = ys();
  return e && ga(() => {
    t.value = !0;
  }, e), t;
}
function Sr(t) {
  const e = E0();
  return te(() => (e.value, !!t()));
}
function C0(t, e, n = {}) {
  const { window: i = bt, ...r } = n;
  let s;
  const o = Sr(() => i && "MutationObserver" in i), a = () => {
    s && (s.disconnect(), s = void 0);
  }, u = te(() => {
    const f = De(t), d = Ri(f).map(un).filter(p0);
    return new Set(d);
  }), c = Ge(
    () => u.value,
    (f) => {
      a(), o.value && f.size && (s = new MutationObserver(e), f.forEach((d) => s.observe(d, r)));
    },
    { immediate: !0, flush: "post" }
  );
  return {
    isSupported: o,
    stop: () => {
      c(), a();
    },
    takeRecords: () => s == null ? void 0 : s.takeRecords()
  };
}
function T0(t) {
  return typeof t == "function" ? t : typeof t == "string" ? (e) => e.key === t : Array.isArray(t) ? (e) => t.includes(e.key) : () => !0;
}
function D0(...t) {
  let e, n, i = {};
  t.length === 3 ? (e = t[0], n = t[1], i = t[2]) : t.length === 2 ? typeof t[1] == "object" ? (e = !0, n = t[0], i = t[1]) : (e = t[0], n = t[1]) : (e = !0, n = t[0]);
  const {
    target: r = bt,
    eventName: s = "keydown",
    passive: o = !1,
    dedupe: a = !1
  } = i, u = T0(e);
  return Me(r, s, (l) => {
    l.repeat && De(a) || u(l) && n(l);
  }, o);
}
function gi(t, e, n = {}) {
  return D0(t, e, { ...n, eventName: "keydown" });
}
function Jl(t, e = {}) {
  const {
    immediate: n = !0,
    fpsLimit: i = void 0,
    window: r = bt,
    once: s = !1
  } = e, o = _e(!1), a = te(() => i ? 1e3 / De(i) : null);
  let u = 0, c = null;
  function l(d) {
    if (!o.value || !r)
      return;
    u || (u = d);
    const p = d - u;
    if (a.value && p < a.value) {
      c = r.requestAnimationFrame(l);
      return;
    }
    if (u = d, t({ delta: p, timestamp: d }), s) {
      o.value = !1, c = null;
      return;
    }
    c = r.requestAnimationFrame(l);
  }
  function h() {
    !o.value && r && (o.value = !0, u = 0, c = r.requestAnimationFrame(l));
  }
  function f() {
    o.value = !1, c != null && r && (r.cancelAnimationFrame(c), c = null);
  }
  return n && h(), {
    isActive: ai(o),
    pause: f,
    resume: h
  };
}
const F0 = Symbol("vueuse-ssr-width");
function O0() {
  const t = zl() ? f0(F0, null) : null;
  return typeof t == "number" ? t : void 0;
}
function I0(t, e = {}) {
  const { window: n = bt, ssrWidth: i = O0() } = e, r = Sr(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), s = _e(typeof i == "number"), o = _e(), a = _e(!1), u = (c) => {
    a.value = c.matches;
  };
  return nr(() => {
    if (s.value) {
      s.value = !r.value;
      const c = De(t).split(",");
      a.value = c.some((l) => {
        const h = l.includes("not all"), f = l.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), d = l.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let p = !!(f || d);
        return f && p && (p = i >= Za(f[1])), d && p && (p = i <= Za(d[1])), h ? !p : p;
      });
      return;
    }
    r.value && (o.value = n.matchMedia(De(t)), a.value = o.value.matches);
  }), Me(o, "change", u, { passive: !0 }), te(() => a.value);
}
function P0(t, e = {}) {
  const {
    controls: n = !1,
    navigator: i = ya
  } = e, r = Sr(() => i && "permissions" in i), s = _e(), o = typeof t == "string" ? { name: t } : t, a = _e(), u = () => {
    var l, h;
    a.value = (h = (l = s.value) == null ? void 0 : l.state) != null ? h : "prompt";
  };
  Me(s, "change", u, { passive: !0 });
  const c = y0(async () => {
    if (r.value) {
      if (!s.value)
        try {
          s.value = await i.permissions.query(o);
        } catch {
          s.value = void 0;
        } finally {
          u();
        }
      if (n)
        return Se(s.value);
    }
  });
  return c(), n ? {
    state: a,
    isSupported: r,
    query: c
  } : a;
}
const bi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, _i = "__vueuse_ssr_handlers__", R0 = /* @__PURE__ */ L0();
function L0() {
  return _i in bi || (bi[_i] = bi[_i] || {}), bi[_i];
}
function Yl(t, e) {
  return R0[t] || e;
}
function M0(t) {
  return I0("(prefers-color-scheme: dark)", t);
}
function j0(t) {
  return t == null ? "any" : t instanceof Set ? "set" : t instanceof Map ? "map" : t instanceof Date ? "date" : typeof t == "boolean" ? "boolean" : typeof t == "string" ? "string" : typeof t == "object" ? "object" : Number.isNaN(t) ? "any" : "number";
}
const N0 = {
  boolean: {
    read: (t) => t === "true",
    write: (t) => String(t)
  },
  object: {
    read: (t) => JSON.parse(t),
    write: (t) => JSON.stringify(t)
  },
  number: {
    read: (t) => Number.parseFloat(t),
    write: (t) => String(t)
  },
  any: {
    read: (t) => t,
    write: (t) => String(t)
  },
  string: {
    read: (t) => t,
    write: (t) => String(t)
  },
  map: {
    read: (t) => new Map(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t.entries()))
  },
  set: {
    read: (t) => new Set(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t))
  },
  date: {
    read: (t) => new Date(t),
    write: (t) => t.toISOString()
  }
}, Ja = "vueuse-storage";
function Gt(t, e, n, i = {}) {
  var r;
  const {
    flush: s = "pre",
    deep: o = !0,
    listenToStorageChanges: a = !0,
    writeDefaults: u = !0,
    mergeDefaults: c = !1,
    shallow: l,
    window: h = bt,
    eventFilter: f,
    onError: d = (P) => {
      console.error(P);
    },
    initOnMounted: p
  } = i, m = (l ? _e : ye)(typeof e == "function" ? e() : e), _ = te(() => De(t));
  if (!n)
    try {
      n = Yl("getDefaultStorage", () => {
        var P;
        return (P = bt) == null ? void 0 : P.localStorage;
      })();
    } catch (P) {
      d(P);
    }
  if (!n)
    return m;
  const y = De(e), b = j0(y), g = (r = i.serializer) != null ? r : N0[b], { pause: v, resume: w } = k0(
    m,
    () => A(m.value),
    { flush: s, deep: o, eventFilter: f }
  );
  Ge(_, () => O(), { flush: s }), h && a && _a(() => {
    n instanceof Storage ? Me(h, "storage", O, { passive: !0 }) : Me(h, Ja, R), p && O();
  }), p || O();
  function E(P, k) {
    if (h) {
      const S = {
        key: _.value,
        oldValue: P,
        newValue: k,
        storageArea: n
      };
      h.dispatchEvent(n instanceof Storage ? new StorageEvent("storage", S) : new CustomEvent(Ja, {
        detail: S
      }));
    }
  }
  function A(P) {
    try {
      const k = n.getItem(_.value);
      if (P == null)
        E(k, null), n.removeItem(_.value);
      else {
        const S = g.write(P);
        k !== S && (n.setItem(_.value, S), E(k, S));
      }
    } catch (k) {
      d(k);
    }
  }
  function C(P) {
    const k = P ? P.newValue : n.getItem(_.value);
    if (k == null)
      return u && y != null && n.setItem(_.value, g.write(y)), y;
    if (!P && c) {
      const S = g.read(k);
      return typeof c == "function" ? c(S, y) : b === "object" && !Array.isArray(S) ? { ...y, ...S } : S;
    } else return typeof k != "string" ? k : g.read(k);
  }
  function O(P) {
    if (!(P && P.storageArea !== n)) {
      if (P && P.key == null) {
        m.value = y;
        return;
      }
      if (!(P && P.key !== _.value)) {
        v();
        try {
          (P == null ? void 0 : P.newValue) !== g.write(m.value) && (m.value = C(P));
        } catch (k) {
          d(k);
        } finally {
          P ? _s(w) : w();
        }
      }
    }
  }
  function R(P) {
    O(P.detail);
  }
  return m;
}
const B0 = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function $0(t = {}) {
  const {
    selector: e = "html",
    attribute: n = "class",
    initialValue: i = "auto",
    window: r = bt,
    storage: s,
    storageKey: o = "vueuse-color-scheme",
    listenToStorageChanges: a = !0,
    storageRef: u,
    emitAuto: c,
    disableTransition: l = !0
  } = t, h = {
    auto: "",
    light: "light",
    dark: "dark",
    ...t.modes || {}
  }, f = M0({ window: r }), d = te(() => f.value ? "dark" : "light"), p = u || (o == null ? ba(i) : Gt(o, i, s, { window: r, listenToStorageChanges: a })), m = te(() => p.value === "auto" ? d.value : p.value), _ = Yl(
    "updateHTMLAttrs",
    (v, w, E) => {
      const A = typeof v == "string" ? r == null ? void 0 : r.document.querySelector(v) : un(v);
      if (!A)
        return;
      const C = /* @__PURE__ */ new Set(), O = /* @__PURE__ */ new Set();
      let R = null;
      if (w === "class") {
        const k = E.split(/\s/g);
        Object.values(h).flatMap((S) => (S || "").split(/\s/g)).filter(Boolean).forEach((S) => {
          k.includes(S) ? C.add(S) : O.add(S);
        });
      } else
        R = { key: w, value: E };
      if (C.size === 0 && O.size === 0 && R === null)
        return;
      let P;
      l && (P = r.document.createElement("style"), P.appendChild(document.createTextNode(B0)), r.document.head.appendChild(P));
      for (const k of C)
        A.classList.add(k);
      for (const k of O)
        A.classList.remove(k);
      R && A.setAttribute(R.key, R.value), l && (r.getComputedStyle(P).opacity, document.head.removeChild(P));
    }
  );
  function y(v) {
    var w;
    _(e, n, (w = h[v]) != null ? w : v);
  }
  function b(v) {
    t.onChanged ? t.onChanged(v, y) : y(v);
  }
  Ge(m, b, { flush: "post", immediate: !0 }), _a(() => b(m.value));
  const g = te({
    get() {
      return c ? p.value : m.value;
    },
    set(v) {
      p.value = v;
    }
  });
  return Object.assign(g, { store: p, system: d, state: m });
}
function z0(t, e) {
  const n = _e(c()), i = ba(t), r = te({
    get() {
      var l;
      let f = i.value.indexOf(n.value);
      return f < 0 && (f = (l = void 0) != null ? l : 0), f;
    },
    set(l) {
      s(l);
    }
  });
  function s(l) {
    const h = i.value, f = h.length, d = (l % f + f) % f, p = h[d];
    return n.value = p, p;
  }
  function o(l = 1) {
    return s(r.value + l);
  }
  function a(l = 1) {
    return o(l);
  }
  function u(l = 1) {
    return o(-l);
  }
  function c() {
    var l, h;
    return (h = De((l = void 0) != null ? l : De(t)[0])) != null ? h : void 0;
  }
  return Ge(i, () => s(r.value)), {
    state: n,
    index: r,
    next: a,
    prev: u,
    go: s
  };
}
function U0(t = {}) {
  const {
    valueDark: e = "dark",
    valueLight: n = ""
  } = t, i = $0({
    ...t,
    onChanged: (o, a) => {
      var u;
      t.onChanged ? (u = t.onChanged) == null || u.call(t, o === "dark", a, o) : a(o);
    },
    modes: {
      dark: e,
      light: n
    }
  }), r = te(() => i.system.value);
  return te({
    get() {
      return i.value === "dark";
    },
    set(o) {
      const a = o ? "dark" : "light";
      r.value === a ? i.value = "auto" : i.value = a;
    }
  });
}
function H0(t = {}) {
  const {
    navigator: e = ya,
    requestPermissions: n = !1,
    constraints: i = { audio: !0, video: !0 },
    onUpdated: r
  } = t, s = ye([]), o = te(() => s.value.filter((p) => p.kind === "videoinput")), a = te(() => s.value.filter((p) => p.kind === "audioinput")), u = te(() => s.value.filter((p) => p.kind === "audiooutput")), c = Sr(() => e && e.mediaDevices && e.mediaDevices.enumerateDevices), l = _e(!1);
  let h;
  async function f() {
    c.value && (s.value = await e.mediaDevices.enumerateDevices(), r == null || r(s.value), h && (h.getTracks().forEach((p) => p.stop()), h = null));
  }
  async function d() {
    const p = i.video ? "camera" : "microphone";
    if (!c.value)
      return !1;
    if (l.value)
      return !0;
    const { state: m, query: _ } = P0(p, { controls: !0 });
    if (await _(), m.value !== "granted") {
      let y = !0;
      try {
        h = await e.mediaDevices.getUserMedia(i);
      } catch {
        h = null, y = !1;
      }
      f(), l.value = y;
    } else
      l.value = !0;
    return l.value;
  }
  return c.value && (n && d(), Me(e.mediaDevices, "devicechange", f, { passive: !0 }), f()), {
    devices: s,
    ensurePermissions: d,
    permissionGranted: l,
    videoInputs: o,
    audioInputs: a,
    audioOutputs: u,
    isSupported: c
  };
}
function q0(t, e, n = {}) {
  const { window: i = bt, ...r } = n;
  let s;
  const o = Sr(() => i && "ResizeObserver" in i), a = () => {
    s && (s.disconnect(), s = void 0);
  }, u = te(() => {
    const h = De(t);
    return Array.isArray(h) ? h.map((f) => un(f)) : [un(h)];
  }), c = Ge(
    u,
    (h) => {
      if (a(), o.value && i) {
        s = new ResizeObserver(e);
        for (const f of h)
          f && s.observe(f, r);
      }
    },
    { immediate: !0, flush: "post" }
  );
  return {
    isSupported: o,
    stop: () => {
      a(), c();
    }
  };
}
function W0(t, e = {}) {
  const {
    reset: n = !0,
    windowResize: i = !0,
    windowScroll: r = !0,
    immediate: s = !0,
    updateTiming: o = "sync"
  } = e, a = _e(0), u = _e(0), c = _e(0), l = _e(0), h = _e(0), f = _e(0), d = _e(0), p = _e(0);
  function m() {
    const y = un(t);
    if (!y) {
      n && (a.value = 0, u.value = 0, c.value = 0, l.value = 0, h.value = 0, f.value = 0, d.value = 0, p.value = 0);
      return;
    }
    const b = y.getBoundingClientRect();
    a.value = b.height, u.value = b.bottom, c.value = b.left, l.value = b.right, h.value = b.top, f.value = b.width, d.value = b.x, p.value = b.y;
  }
  function _() {
    o === "sync" ? m() : o === "next-frame" && requestAnimationFrame(() => m());
  }
  return q0(t, _), Ge(() => un(t), (y) => !y && _()), C0(t, _, {
    attributeFilter: ["style", "class"]
  }), r && Me("scroll", _, { capture: !0, passive: !0 }), i && Me("resize", _, { passive: !0 }), _a(() => {
    s && _();
  }), {
    height: a,
    bottom: u,
    left: c,
    right: l,
    top: h,
    width: f,
    x: d,
    y: p,
    update: _
  };
}
const V0 = ["mousedown", "mouseup", "keydown", "keyup"];
function G0(t, e = {}) {
  const {
    events: n = V0,
    document: i = A0,
    initial: r = null
  } = e, s = _e(r);
  return i && n.forEach((o) => {
    Me(i, o, (a) => {
      typeof a.getModifierState == "function" && (s.value = a.getModifierState(t));
    }, { passive: !0 });
  }), s;
}
const K0 = {
  page: (t) => [t.pageX, t.pageY],
  client: (t) => [t.clientX, t.clientY],
  screen: (t) => [t.screenX, t.screenY],
  movement: (t) => t instanceof MouseEvent ? [t.movementX, t.movementY] : null
};
function Z0(t = {}) {
  const {
    type: e = "page",
    touch: n = !0,
    resetOnTouchEnds: i = !1,
    initialValue: r = { x: 0, y: 0 },
    window: s = bt,
    target: o = s,
    scroll: a = !0,
    eventFilter: u
  } = t;
  let c = null, l = 0, h = 0;
  const f = _e(r.x), d = _e(r.y), p = _e(null), m = typeof e == "function" ? e : K0[e], _ = (A) => {
    const C = m(A);
    c = A, C && ([f.value, d.value] = C, p.value = "mouse"), s && (l = s.scrollX, h = s.scrollY);
  }, y = (A) => {
    if (A.touches.length > 0) {
      const C = m(A.touches[0]);
      C && ([f.value, d.value] = C, p.value = "touch");
    }
  }, b = () => {
    if (!c || !s)
      return;
    const A = m(c);
    c instanceof MouseEvent && A && (f.value = A[0] + s.scrollX - l, d.value = A[1] + s.scrollY - h);
  }, g = () => {
    f.value = r.x, d.value = r.y;
  }, v = u ? (A) => u(() => _(A), {}) : (A) => _(A), w = u ? (A) => u(() => y(A), {}) : (A) => y(A), E = u ? () => u(() => b(), {}) : () => b();
  if (o) {
    const A = { passive: !0 };
    Me(o, ["mousemove", "dragover"], v, A), n && e !== "movement" && (Me(o, ["touchstart", "touchmove"], w, A), i && Me(o, "touchend", g, A)), a && e === "page" && Me(s, "scroll", E, A);
  }
  return {
    x: f,
    y: d,
    sourceType: p
  };
}
function J0(t, e = {}) {
  const {
    handleOutside: n = !0,
    window: i = bt
  } = e, r = e.type || "page", { x: s, y: o, sourceType: a } = Z0(e), u = _e(t ?? (i == null ? void 0 : i.document.body)), c = _e(0), l = _e(0), h = _e(0), f = _e(0), d = _e(0), p = _e(0), m = _e(!0);
  let _ = () => {
  };
  return i && (_ = Ge(
    [u, s, o],
    () => {
      const y = un(u);
      if (!y || !(y instanceof Element))
        return;
      const {
        left: b,
        top: g,
        width: v,
        height: w
      } = y.getBoundingClientRect();
      h.value = b + (r === "page" ? i.pageXOffset : 0), f.value = g + (r === "page" ? i.pageYOffset : 0), d.value = w, p.value = v;
      const E = s.value - h.value, A = o.value - f.value;
      m.value = v === 0 || w === 0 || E < 0 || A < 0 || E > v || A > w, (n || !m.value) && (c.value = E, l.value = A);
    },
    { immediate: !0 }
  ), Me(
    document,
    "mouseleave",
    () => m.value = !0,
    { passive: !0 }
  )), {
    x: s,
    y: o,
    sourceType: a,
    elementX: c,
    elementY: l,
    elementPositionX: h,
    elementPositionY: f,
    elementHeight: d,
    elementWidth: p,
    isOutside: m,
    stop: _
  };
}
function Y0(t = {}) {
  const {
    touch: e = !0,
    drag: n = !0,
    capture: i = !1,
    initialValue: r = !1,
    window: s = bt
  } = t, o = _e(r), a = _e(null);
  if (!s)
    return {
      pressed: o,
      sourceType: a
    };
  const u = (f) => (d) => {
    var p;
    o.value = !0, a.value = f, (p = t.onPressed) == null || p.call(t, d);
  }, c = (f) => {
    var d;
    o.value = !1, a.value = null, (d = t.onReleased) == null || d.call(t, f);
  }, l = te(() => un(t.target) || s), h = { passive: !0, capture: i };
  return Me(l, "mousedown", u("mouse"), h), Me(s, "mouseleave", c, h), Me(s, "mouseup", c, h), n && (Me(l, "dragstart", u("mouse"), h), Me(s, "drop", c, h), Me(s, "dragend", c, h)), e && (Me(l, "touchstart", u("touch"), h), Me(s, "touchend", c, h), Me(s, "touchcancel", c, h)), {
    pressed: o,
    sourceType: a
  };
}
function X0(t = {}) {
  const {
    controls: e = !1,
    interval: n = "requestAnimationFrame"
  } = t, i = ye(/* @__PURE__ */ new Date()), r = () => i.value = /* @__PURE__ */ new Date(), s = n === "requestAnimationFrame" ? Jl(r, { immediate: !0 }) : Kl(r, n, { immediate: !0 });
  return e ? {
    now: i,
    ...s
  } : i;
}
function Q0(t = {}, e = {}) {
  const { navigator: n = ya } = e, i = n, r = Sr(() => i && "canShare" in i);
  return {
    isSupported: r,
    share: async (o = {}) => {
      if (r.value) {
        const a = {
          ...De(t),
          ...De(o)
        };
        let u = !0;
        if (a.files && i.canShare && (u = i.canShare({ files: a.files })), u)
          return i.share(a);
      }
    }
  };
}
function ep(t = {}) {
  const {
    controls: e = !1,
    offset: n = 0,
    immediate: i = !0,
    interval: r = "requestAnimationFrame",
    callback: s
  } = t, o = _e(Ka() + n), a = () => o.value = Ka() + n, u = s ? () => {
    a(), s(o.value);
  } : a, c = r === "requestAnimationFrame" ? Jl(u, { immediate: i }) : Kl(u, r, { immediate: i });
  return e ? {
    timestamp: o,
    ...c
  } : o;
}
function tp(t = ye(null)) {
  const { pressed: e } = Y0(), n = ie({
    x: 0,
    y: 0,
    normX: 0,
    normY: 0,
    pressed: e,
    inside: !1
  });
  ga(() => {
    document.addEventListener("mousemove", i);
    const { isOutside: r } = J0(t);
    Ge(r, (s) => {
      n.inside = !s;
    });
  }), Bd(() => {
    document.removeEventListener("mousemove", i);
  });
  function i(r, s = t.value, o = !1) {
    const a = s.closest("svg");
    if (!a) return;
    var u = a.createSVGPoint();
    u.x = r.clientX, u.y = r.clientY;
    let c = u.matrixTransform(a.getScreenCTM().inverse());
    if (o) {
      let l = s.getBBox();
      n.x = c.x < l.width ? c.x < 0 ? 0 : c.x : l.width, n.y = c.y < l.height ? c.y < 0 ? 0 : c.y : l.height, n.normY = n.y / l.height, n.normX = n.x / l.width;
    } else
      n.x = c.x, n.y = c.y;
  }
  return {
    area: t,
    mouse: n
  };
}
var me = function(t, e, n) {
  if (!e.has(t))
    throw new TypeError("attempted to set private field on non-instance");
  return e.set(t, n), n;
}, oe = function(t, e) {
  if (!e.has(t))
    throw new TypeError("attempted to get private field on non-instance");
  return e.get(t);
}, _n, Un, St, fr, Br, Ot, It, Pt, Rt, Lt, Mt, jt, Nt, Hn, dr, yn, Li, vn;
const np = function(t) {
  var e = 131, n = 137, i = 0;
  t += "x";
  var r = Math.floor(9007199254740991 / n);
  for (let s = 0; s < t.length; s++)
    i > r && (i = Math.floor(i / n)), i = i * e + t.charCodeAt(s);
  return i;
}, le = "0123456789abcdef".split(""), rp = [
  -2147483648,
  8388608,
  32768,
  128
], wt = [
  24,
  16,
  8,
  0
], yi = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], Ke = [];
class ip {
  constructor(e = !1, n = !1) {
    _n.set(this, void 0), Un.set(this, void 0), St.set(this, void 0), fr.set(this, void 0), Br.set(this, void 0), Ot.set(this, void 0), It.set(this, void 0), Pt.set(this, void 0), Rt.set(this, void 0), Lt.set(this, void 0), Mt.set(this, void 0), jt.set(this, void 0), Nt.set(this, void 0), Hn.set(this, void 0), dr.set(this, void 0), yn.set(this, void 0), Li.set(this, 0), vn.set(this, void 0), this.init(e, n);
  }
  init(e, n) {
    n ? (Ke[0] = Ke[16] = Ke[1] = Ke[2] = Ke[3] = Ke[4] = Ke[5] = Ke[6] = Ke[7] = Ke[8] = Ke[9] = Ke[10] = Ke[11] = Ke[12] = Ke[13] = Ke[14] = Ke[15] = 0, me(this, Un, Ke)) : me(this, Un, [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]), e ? (me(this, Ot, 3238371032), me(this, It, 914150663), me(this, Pt, 812702999), me(this, Rt, 4144912697), me(this, Lt, 4290775857), me(this, Mt, 1750603025), me(this, jt, 1694076839), me(this, Nt, 3204075428)) : (me(this, Ot, 1779033703), me(this, It, 3144134277), me(this, Pt, 1013904242), me(this, Rt, 2773480762), me(this, Lt, 1359893119), me(this, Mt, 2600822924), me(this, jt, 528734635), me(this, Nt, 1541459225)), me(this, _n, me(this, vn, me(this, St, me(this, dr, 0)))), me(this, fr, me(this, Hn, !1)), me(this, Br, !0), me(this, yn, e);
  }
  update(e) {
    if (oe(this, fr))
      return this;
    let n;
    e instanceof ArrayBuffer ? n = new Uint8Array(e) : n = e;
    let i = 0;
    const r = n.length, s = oe(this, Un);
    for (; i < r; ) {
      let o;
      if (oe(this, Hn) && (me(this, Hn, !1), s[0] = oe(this, _n), s[16] = s[1] = s[2] = s[3] = s[4] = s[5] = s[6] = s[7] = s[8] = s[9] = s[10] = s[11] = s[12] = s[13] = s[14] = s[15] = 0), typeof n != "string")
        for (o = oe(this, vn); i < r && o < 64; ++i)
          s[o >> 2] |= n[i] << wt[o++ & 3];
      else
        for (o = oe(this, vn); i < r && o < 64; ++i) {
          let a = n.charCodeAt(i);
          a < 128 ? s[o >> 2] |= a << wt[o++ & 3] : a < 2048 ? (s[o >> 2] |= (192 | a >> 6) << wt[o++ & 3], s[o >> 2] |= (128 | a & 63) << wt[o++ & 3]) : a < 55296 || a >= 57344 ? (s[o >> 2] |= (224 | a >> 12) << wt[o++ & 3], s[o >> 2] |= (128 | a >> 6 & 63) << wt[o++ & 3], s[o >> 2] |= (128 | a & 63) << wt[o++ & 3]) : (a = 65536 + ((a & 1023) << 10 | n.charCodeAt(++i) & 1023), s[o >> 2] |= (240 | a >> 18) << wt[o++ & 3], s[o >> 2] |= (128 | a >> 12 & 63) << wt[o++ & 3], s[o >> 2] |= (128 | a >> 6 & 63) << wt[o++ & 3], s[o >> 2] |= (128 | a & 63) << wt[o++ & 3]);
        }
      me(this, Li, o), me(this, St, oe(this, St) + (o - oe(this, vn))), o >= 64 ? (me(this, _n, s[16]), me(this, vn, o - 64), this.hash(), me(this, Hn, !0)) : me(this, vn, o);
    }
    return oe(this, St) > 4294967295 && (me(this, dr, oe(this, dr) + (oe(this, St) / 4294967296 << 0)), me(this, St, oe(this, St) % 4294967296)), this;
  }
  finalize() {
    if (oe(this, fr))
      return;
    me(this, fr, !0);
    const e = oe(this, Un), n = oe(this, Li);
    e[16] = oe(this, _n), e[n >> 2] |= rp[n & 3], me(this, _n, e[16]), n >= 56 && (oe(this, Hn) || this.hash(), e[0] = oe(this, _n), e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = oe(this, dr) << 3 | oe(this, St) >>> 29, e[15] = oe(this, St) << 3, this.hash();
  }
  hash() {
    let e = oe(this, Ot), n = oe(this, It), i = oe(this, Pt), r = oe(this, Rt), s = oe(this, Lt), o = oe(this, Mt), a = oe(this, jt), u = oe(this, Nt);
    const c = oe(this, Un);
    let l, h, f, d, p, m, _, y, b, g;
    for (let v = 16; v < 64; ++v)
      d = c[v - 15], l = (d >>> 7 | d << 25) ^ (d >>> 18 | d << 14) ^ d >>> 3, d = c[v - 2], h = (d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10, c[v] = c[v - 16] + l + c[v - 7] + h << 0;
    g = n & i;
    for (let v = 0; v < 64; v += 4)
      oe(this, Br) ? (oe(this, yn) ? (_ = 300032, d = c[0] - 1413257819, u = d - 150054599 << 0, r = d + 24177077 << 0) : (_ = 704751109, d = c[0] - 210244248, u = d - 1521486534 << 0, r = d + 143694565 << 0), me(this, Br, !1)) : (l = (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10), h = (s >>> 6 | s << 26) ^ (s >>> 11 | s << 21) ^ (s >>> 25 | s << 7), _ = e & n, f = _ ^ e & i ^ g, m = s & o ^ ~s & a, d = u + h + m + yi[v] + c[v], p = l + f, u = r + d << 0, r = d + p << 0), l = (r >>> 2 | r << 30) ^ (r >>> 13 | r << 19) ^ (r >>> 22 | r << 10), h = (u >>> 6 | u << 26) ^ (u >>> 11 | u << 21) ^ (u >>> 25 | u << 7), y = r & e, f = y ^ r & n ^ _, m = u & s ^ ~u & o, d = a + h + m + yi[v + 1] + c[v + 1], p = l + f, a = i + d << 0, i = d + p << 0, l = (i >>> 2 | i << 30) ^ (i >>> 13 | i << 19) ^ (i >>> 22 | i << 10), h = (a >>> 6 | a << 26) ^ (a >>> 11 | a << 21) ^ (a >>> 25 | a << 7), b = i & r, f = b ^ i & e ^ y, m = a & u ^ ~a & s, d = o + h + m + yi[v + 2] + c[v + 2], p = l + f, o = n + d << 0, n = d + p << 0, l = (n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10), h = (o >>> 6 | o << 26) ^ (o >>> 11 | o << 21) ^ (o >>> 25 | o << 7), g = n & i, f = g ^ n & r ^ b, m = o & a ^ ~o & u, d = s + h + m + yi[v + 3] + c[v + 3], p = l + f, s = e + d << 0, e = d + p << 0;
    me(this, Ot, oe(this, Ot) + e << 0), me(this, It, oe(this, It) + n << 0), me(this, Pt, oe(this, Pt) + i << 0), me(this, Rt, oe(this, Rt) + r << 0), me(this, Lt, oe(this, Lt) + s << 0), me(this, Mt, oe(this, Mt) + o << 0), me(this, jt, oe(this, jt) + a << 0), me(this, Nt, oe(this, Nt) + u << 0);
  }
  hex() {
    this.finalize();
    const e = oe(this, Ot), n = oe(this, It), i = oe(this, Pt), r = oe(this, Rt), s = oe(this, Lt), o = oe(this, Mt), a = oe(this, jt), u = oe(this, Nt);
    let c = le[e >> 28 & 15] + le[e >> 24 & 15] + le[e >> 20 & 15] + le[e >> 16 & 15] + le[e >> 12 & 15] + le[e >> 8 & 15] + le[e >> 4 & 15] + le[e & 15] + le[n >> 28 & 15] + le[n >> 24 & 15] + le[n >> 20 & 15] + le[n >> 16 & 15] + le[n >> 12 & 15] + le[n >> 8 & 15] + le[n >> 4 & 15] + le[n & 15] + le[i >> 28 & 15] + le[i >> 24 & 15] + le[i >> 20 & 15] + le[i >> 16 & 15] + le[i >> 12 & 15] + le[i >> 8 & 15] + le[i >> 4 & 15] + le[i & 15] + le[r >> 28 & 15] + le[r >> 24 & 15] + le[r >> 20 & 15] + le[r >> 16 & 15] + le[r >> 12 & 15] + le[r >> 8 & 15] + le[r >> 4 & 15] + le[r & 15] + le[s >> 28 & 15] + le[s >> 24 & 15] + le[s >> 20 & 15] + le[s >> 16 & 15] + le[s >> 12 & 15] + le[s >> 8 & 15] + le[s >> 4 & 15] + le[s & 15] + le[o >> 28 & 15] + le[o >> 24 & 15] + le[o >> 20 & 15] + le[o >> 16 & 15] + le[o >> 12 & 15] + le[o >> 8 & 15] + le[o >> 4 & 15] + le[o & 15] + le[a >> 28 & 15] + le[a >> 24 & 15] + le[a >> 20 & 15] + le[a >> 16 & 15] + le[a >> 12 & 15] + le[a >> 8 & 15] + le[a >> 4 & 15] + le[a & 15];
    return oe(this, yn) || (c += le[u >> 28 & 15] + le[u >> 24 & 15] + le[u >> 20 & 15] + le[u >> 16 & 15] + le[u >> 12 & 15] + le[u >> 8 & 15] + le[u >> 4 & 15] + le[u & 15]), c;
  }
  toString() {
    return this.hex();
  }
  digest() {
    this.finalize();
    const e = oe(this, Ot), n = oe(this, It), i = oe(this, Pt), r = oe(this, Rt), s = oe(this, Lt), o = oe(this, Mt), a = oe(this, jt), u = oe(this, Nt), c = [
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      n >> 24 & 255,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      i >> 24 & 255,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      r >> 24 & 255,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      s >> 24 & 255,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      o >> 24 & 255,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      a >> 24 & 255,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255
    ];
    return oe(this, yn) || c.push(u >> 24 & 255, u >> 16 & 255, u >> 8 & 255, u & 255), c;
  }
  array() {
    return this.digest();
  }
  arrayBuffer() {
    this.finalize();
    const e = new ArrayBuffer(oe(this, yn) ? 28 : 32), n = new DataView(e);
    return n.setUint32(0, oe(this, Ot)), n.setUint32(4, oe(this, It)), n.setUint32(8, oe(this, Pt)), n.setUint32(12, oe(this, Rt)), n.setUint32(16, oe(this, Lt)), n.setUint32(20, oe(this, Mt)), n.setUint32(24, oe(this, jt)), oe(this, yn) || n.setUint32(28, oe(this, Nt)), e;
  }
}
_n = /* @__PURE__ */ new WeakMap(), Un = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap(), Ot = /* @__PURE__ */ new WeakMap(), It = /* @__PURE__ */ new WeakMap(), Pt = /* @__PURE__ */ new WeakMap(), Rt = /* @__PURE__ */ new WeakMap(), Lt = /* @__PURE__ */ new WeakMap(), Mt = /* @__PURE__ */ new WeakMap(), jt = /* @__PURE__ */ new WeakMap(), Nt = /* @__PURE__ */ new WeakMap(), Hn = /* @__PURE__ */ new WeakMap(), dr = /* @__PURE__ */ new WeakMap(), yn = /* @__PURE__ */ new WeakMap(), Li = /* @__PURE__ */ new WeakMap(), vn = /* @__PURE__ */ new WeakMap();
function sp(t) {
  const e = new ip();
  return e.update(t), parseInt(e.hex().substring(0, 8), 16);
}
const op = function(t) {
  var e = "#";
  return t.forEach(function(n) {
    n < 16 && (e += 0), e += n.toString(16);
  }), e;
}, ap = function(t, e, n) {
  t /= 360;
  var i = n < 0.5 ? n * (1 + e) : n + e - n * e, r = 2 * n - i;
  return [
    t + 1 / 3,
    t,
    t - 1 / 3
  ].map(function(s) {
    return s < 0 && s++, s > 1 && s--, s < 1 / 6 ? s = r + (i - r) * 6 * s : s < 0.5 ? s = i : s < 2 / 3 ? s = r + (i - r) * 6 * (2 / 3 - s) : s = r, Math.round(s * 255);
  });
};
class pr {
  constructor(e = {}) {
    const [n, i] = [
      e.lightness,
      e.saturation
    ].map(function(r) {
      return r = r !== void 0 ? r : [
        0.35,
        0.5,
        0.65
      ], Array.isArray(r) ? r.concat() : [
        r
      ];
    });
    this.L = n, this.S = i, typeof e.hue == "number" && (e.hue = {
      min: e.hue,
      max: e.hue
    }), typeof e.hue == "object" && !Array.isArray(e.hue) && (e.hue = [
      e.hue
    ]), typeof e.hue > "u" && (e.hue = []), this.hueRanges = e.hue.map(function(r) {
      return {
        min: typeof r.min > "u" ? 0 : r.min,
        max: typeof r.max > "u" ? 360 : r.max
      };
    }), this.hash = sp, typeof e.hash == "function" && (this.hash = e.hash), e.hash === "bkdr" && (this.hash = np);
  }
  hsl(e) {
    var n, i, r, s = this.hash(e), o = 727;
    if (this.hueRanges.length) {
      const a = this.hueRanges[s % this.hueRanges.length];
      n = s / this.hueRanges.length % o * (a.max - a.min) / o + a.min;
    } else
      n = s % 359;
    return s = Math.ceil(s / 360), i = this.S[s % this.S.length], s = Math.ceil(s / this.S.length), r = this.L[s % this.L.length], [
      n,
      i,
      r
    ];
  }
  rgb(e) {
    var n = this.hsl(e);
    return ap.apply(this, n);
  }
  hex(e) {
    var n = this.rgb(e);
    return op(n);
  }
}
const up = {
  light: new pr({
    saturation: [0.05, 0.08, 0.22],
    lightness: [0.85, 0.87, 0.9]
  }),
  pale: new pr({
    saturation: [0.05, 0.42, 0.52],
    lightness: [0.75, 0.77, 0.9]
  }),
  regular: new pr({
    saturation: [0.1, 0.5, 0.7],
    lightness: [0.3, 0.5, 0.7]
  }),
  deep: new pr({
    saturation: [0.5, 0.6, 0.7],
    lightness: [0.2, 0.35, 0.4]
  }),
  dark: new pr({
    saturation: [0.02, 0.5, 0.6],
    lightness: [0.18, 0.2, 0.5]
  })
};
function Xl(t = "deep") {
  return typeof t == "object" ? new pr(t) : up[t];
}
const cp = ie({
  dark: U0()
});
function q2({
  pub: t,
  size: e = 200,
  light: n = 0.5,
  overlay: i = 0.5,
  draw: r = "squares",
  attachment: s = "fixed",
  round: o = !1
}) {
  if (t)
    return {
      background: `linear-gradient(hsla(255,0%,${n * 100}%,${i}), hsla(255,0%,${n * 100}%,${i})), url(${oh({
        pub: t,
        draw: r,
        reflect: !1,
        size: e,
        dark: cp.dark,
        round: o
      })})`,
      backgroundSize: "cover, cover",
      backgroundAttachment: `${s},${s}`
    };
}
var sn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var js, Ya;
function lp() {
  if (Ya) return js;
  Ya = 1;
  var t = 1e3, e = t * 60, n = e * 60, i = n * 24, r = i * 7, s = i * 365.25;
  js = function(l, h) {
    h = h || {};
    var f = typeof l;
    if (f === "string" && l.length > 0)
      return o(l);
    if (f === "number" && isFinite(l))
      return h.long ? u(l) : a(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function o(l) {
    if (l = String(l), !(l.length > 100)) {
      var h = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        l
      );
      if (h) {
        var f = parseFloat(h[1]), d = (h[2] || "ms").toLowerCase();
        switch (d) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return f * s;
          case "weeks":
          case "week":
          case "w":
            return f * r;
          case "days":
          case "day":
          case "d":
            return f * i;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return f * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return f * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return f * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return f;
          default:
            return;
        }
      }
    }
  }
  function a(l) {
    var h = Math.abs(l);
    return h >= i ? Math.round(l / i) + "d" : h >= n ? Math.round(l / n) + "h" : h >= e ? Math.round(l / e) + "m" : h >= t ? Math.round(l / t) + "s" : l + "ms";
  }
  function u(l) {
    var h = Math.abs(l);
    return h >= i ? c(l, h, i, "day") : h >= n ? c(l, h, n, "hour") : h >= e ? c(l, h, e, "minute") : h >= t ? c(l, h, t, "second") : l + " ms";
  }
  function c(l, h, f, d) {
    var p = h >= f * 1.5;
    return Math.round(l / f) + " " + d + (p ? "s" : "");
  }
  return js;
}
var hp = lp();
const va = /* @__PURE__ */ Pn(hp), fp = Xl("deep"), dp = 1e4;
function pp(t) {
  const e = ue(), n = ye(t), { user: i } = Re();
  return { account: te(() => {
    const s = ie({
      pub: n.value,
      color: te(() => n.value ? fp.hex(n.value) : "gray"),
      profile: {
        name: ""
      },
      pulse: 0,
      lastSeen: te(() => {
        const o = Date.now() - s.pulse;
        return o > dp ? va(o) : "online";
      }),
      blink: !1,
      db: e.user(n.value)
    });
    return i.is && e.user().get("petnames").get(n.value).on(async (o) => {
      s.petname = await i.decrypt(o);
    }), e.user(n.value).get("pulse").on((o) => {
      s.blink = !s.blink, s.pulse = o;
    }).back().get("profile").map().on((o, a) => {
      s.profile[a] = o;
    }), s;
  }), setPetname: mp };
}
async function mp(t, e) {
  const { user: n } = Re();
  if (!n.is) return;
  const i = ue(), r = await n.encrypt(e);
  i.user().get("petnames").get(t).put(r);
}
var gp = Object.create, Ql = Object.defineProperty, bp = Object.getOwnPropertyDescriptor, _p = Object.getOwnPropertyNames, yp = Object.getPrototypeOf, vp = Object.prototype.hasOwnProperty, rr = (t, e) => () => (e || t((e = { exports: {} }).exports, e), e.exports), wp = (t, e, n, i) => {
  if (e && typeof e == "object" || typeof e == "function") for (let r of _p(e)) !vp.call(t, r) && r !== n && Ql(t, r, { get: () => e[r], enumerable: !(i = bp(e, r)) || i.enumerable });
  return t;
}, wa = (t, e, n) => (n = t != null ? gp(yp(t)) : {}, wp(Ql(n, "default", { value: t, enumerable: !0 }), t)), eh = rr((t) => {
  (function(e) {
    typeof DO_NOT_EXPORT_CRC > "u" ? typeof t == "object" ? e(t) : typeof define == "function" && define.amd ? define(function() {
      var n = {};
      return e(n), n;
    }) : e({}) : e({});
  })(function(e) {
    e.version = "0.3.0";
    function n() {
      for (var c = 0, l = new Array(256), h = 0; h != 256; ++h) c = h, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1, l[h] = c;
      return typeof Int32Array < "u" ? new Int32Array(l) : l;
    }
    var i = n(), r = typeof Buffer < "u";
    function s(c) {
      if (c.length > 32768 && r) return a(new Buffer(c));
      for (var l = -1, h = c.length - 1, f = 0; f < h; ) l = i[(l ^ c.charCodeAt(f++)) & 255] ^ l >>> 8, l = i[(l ^ c.charCodeAt(f++)) & 255] ^ l >>> 8;
      return f === h && (l = l >>> 8 ^ i[(l ^ c.charCodeAt(f)) & 255]), l ^ -1;
    }
    function o(c) {
      if (c.length > 1e4) return a(c);
      for (var l = -1, h = 0, f = c.length - 3; h < f; ) l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255];
      for (; h < f + 3; ) l = l >>> 8 ^ i[(l ^ c[h++]) & 255];
      return l ^ -1;
    }
    function a(c) {
      for (var l = -1, h = 0, f = c.length - 7; h < f; ) l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255], l = l >>> 8 ^ i[(l ^ c[h++]) & 255];
      for (; h < f + 7; ) l = l >>> 8 ^ i[(l ^ c[h++]) & 255];
      return l ^ -1;
    }
    function u(c) {
      for (var l = -1, h = 0, f = c.length, d, p; h < f; ) d = c.charCodeAt(h++), d < 128 ? l = l >>> 8 ^ i[(l ^ d) & 255] : d < 2048 ? (l = l >>> 8 ^ i[(l ^ (192 | d >> 6 & 31)) & 255], l = l >>> 8 ^ i[(l ^ (128 | d & 63)) & 255]) : d >= 55296 && d < 57344 ? (d = (d & 1023) + 64, p = c.charCodeAt(h++) & 1023, l = l >>> 8 ^ i[(l ^ (240 | d >> 8 & 7)) & 255], l = l >>> 8 ^ i[(l ^ (128 | d >> 2 & 63)) & 255], l = l >>> 8 ^ i[(l ^ (128 | p >> 6 & 15 | d & 3)) & 255], l = l >>> 8 ^ i[(l ^ (128 | p & 63)) & 255]) : (l = l >>> 8 ^ i[(l ^ (224 | d >> 12 & 15)) & 255], l = l >>> 8 ^ i[(l ^ (128 | d >> 6 & 63)) & 255], l = l >>> 8 ^ i[(l ^ (128 | d & 63)) & 255]);
      return l ^ -1;
    }
    e.table = i, e.bstr = s, e.buf = o, e.str = u;
  });
}), xp = rr((t, e) => {
  var n = eh();
  e.exports = o;
  var i = new Uint8Array(4), r = new Int32Array(i.buffer), s = new Uint32Array(i.buffer);
  function o(a) {
    if (a[0] !== 137) throw new Error("Invalid .png file header");
    if (a[1] !== 80) throw new Error("Invalid .png file header");
    if (a[2] !== 78) throw new Error("Invalid .png file header");
    if (a[3] !== 71) throw new Error("Invalid .png file header");
    if (a[4] !== 13) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    if (a[5] !== 10) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    if (a[6] !== 26) throw new Error("Invalid .png file header");
    if (a[7] !== 10) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    for (var u = !1, c = [], l = 8; l < a.length; ) {
      i[3] = a[l++], i[2] = a[l++], i[1] = a[l++], i[0] = a[l++];
      var h = s[0] + 4, f = new Uint8Array(h);
      f[0] = a[l++], f[1] = a[l++], f[2] = a[l++], f[3] = a[l++];
      var d = String.fromCharCode(f[0]) + String.fromCharCode(f[1]) + String.fromCharCode(f[2]) + String.fromCharCode(f[3]);
      if (!c.length && d !== "IHDR") throw new Error("IHDR header missing");
      if (d === "IEND") {
        u = !0, c.push({ name: d, data: new Uint8Array(0) });
        break;
      }
      for (var p = 4; p < h; p++) f[p] = a[l++];
      i[3] = a[l++], i[2] = a[l++], i[1] = a[l++], i[0] = a[l++];
      var m = r[0], _ = n.buf(f);
      if (_ !== m) throw new Error("CRC values for " + d + " header do not match, PNG file is likely corrupted");
      var y = new Uint8Array(f.buffer.slice(4));
      c.push({ name: d, data: y });
    }
    if (!u) throw new Error(".png file ended prematurely: no IEND header was found");
    return c;
  }
}), kp = rr((t, e) => {
  e.exports = function(n, i, r) {
    var s = [], o = n.length;
    if (o === 0) return s;
    var a = i < 0 ? Math.max(0, i + o) : i || 0;
    for (r !== void 0 && (o = r < 0 ? r + o : r); o-- > a; ) s[o - a] = n[o];
    return s;
  };
}), Sp = rr((t, e) => {
  var n = kp(), i = eh();
  e.exports = a;
  var r = new Uint8Array(4), s = new Int32Array(r.buffer), o = new Uint32Array(r.buffer);
  function a(u) {
    var c = 8, l = c, h;
    for (h = 0; h < u.length; h++) c += u[h].data.length, c += 12;
    var f = new Uint8Array(c);
    for (f[0] = 137, f[1] = 80, f[2] = 78, f[3] = 71, f[4] = 13, f[5] = 10, f[6] = 26, f[7] = 10, h = 0; h < u.length; h++) {
      var d = u[h], p = d.name, m = d.data, _ = m.length, y = [p.charCodeAt(0), p.charCodeAt(1), p.charCodeAt(2), p.charCodeAt(3)];
      o[0] = _, f[l++] = r[3], f[l++] = r[2], f[l++] = r[1], f[l++] = r[0], f[l++] = y[0], f[l++] = y[1], f[l++] = y[2], f[l++] = y[3];
      for (var b = 0; b < _; ) f[l++] = m[b++];
      var g = y.concat(n(m)), v = i.buf(g);
      s[0] = v, f[l++] = r[3], f[l++] = r[2], f[l++] = r[1], f[l++] = r[0];
    }
    return f;
  }
}), Ap = rr((t, e) => {
  e.exports = n;
  function n(i, r) {
    if (i = String(i), r = String(r), !/^[\x00-\xFF]+$/.test(i) || !/^[\x00-\xFF]+$/.test(r)) throw new Error("Only Latin-1 characters are permitted in PNG tEXt chunks. You might want to consider base64 encoding and/or zEXt compression");
    if (i.length >= 80) throw new Error('Keyword "' + i + '" is longer than the 79-character limit imposed by the PNG specification');
    for (var s = i.length + r.length + 1, o = new Uint8Array(s), a = 0, u, c = 0; c < i.length; c++) {
      if (!(u = i.charCodeAt(c))) throw new Error("0x00 character is not permitted in tEXt keywords");
      o[a++] = u;
    }
    o[a++] = 0;
    for (var l = 0; l < r.length; l++) {
      if (!(u = r.charCodeAt(l))) throw new Error("0x00 character is not permitted in tEXt content");
      o[a++] = u;
    }
    return { name: "tEXt", data: o };
  }
}), Ep = rr((t, e) => {
  e.exports = n;
  function n(i) {
    i.data && i.name && (i = i.data);
    for (var r = !0, s = "", o = "", a = 0; a < i.length; a++) {
      var u = i[a];
      if (r) u ? o += String.fromCharCode(u) : r = !1;
      else if (u) s += String.fromCharCode(u);
      else throw new Error("Invalid NULL character found. 0x00 character is not permitted in tEXt content");
    }
    return { keyword: o, text: s };
  }
}), Cp = rr((t) => {
  t.encode = Ap(), t.decode = Ep();
}), Tp = () => {
  if (typeof window > "u" || typeof window.CanvasRenderingContext2D > "u" || !n()) return;
  let t = CanvasRenderingContext2D.prototype, e = t.drawImage;
  if (!e) {
    console.error("This script requires a basic implementation of drawImage");
    return;
  }
  t.drawImage = function(o, a, u) {
    if (arguments.length !== 9) return e.apply(this, [...arguments]);
    let c = i(...arguments);
    if (!r(c)) return e.apply(this, c);
  };
  function n() {
    let o = document.createElement("canvas").getContext("2d");
    o.fillRect(0, 0, 40, 40), o.drawImage(o.canvas, -40, -40, 80, 80, 50, 50, 20, 20);
    let a = o.getImageData(50, 50, 30, 30), u = new Uint32Array(a.data.buffer), c = (f, d) => u[d * a.width + f], l = [[9, 9], [20, 9], [9, 20], [20, 20]], h = [[10, 10], [19, 10], [10, 19], [19, 19]];
    return l.some(([f, d]) => c(f, d) !== 0) || h.some(([f, d]) => c(f, d) === 0);
  }
  function i(o, a, u, c, l, h, f, d, p) {
    let { width: m, height: _ } = s(o);
    c < 0 && (a += c, c = Math.abs(c)), l < 0 && (u += l, l = Math.abs(l)), d < 0 && (h += d, d = Math.abs(d)), p < 0 && (f += p, p = Math.abs(p));
    let y = Math.max(a, 0), b = Math.min(a + c, m), g = Math.max(u, 0), v = Math.min(u + l, _), w = d / c, E = p / l;
    return [o, y, g, b - y, v - g, a < 0 ? h - a * w : h, u < 0 ? f - u * E : f, (b - y) * w, (v - g) * E];
  }
  function r(o) {
    return [3, 4, 7, 8].some((a) => !o[a]);
  }
  function s(o) {
    let a = (u) => {
      let c = globalThis[u];
      return c && o instanceof c;
    };
    if (a("HTMLImageElement")) return { width: o.naturalWidth, height: o.naturalHeight };
    if (a("HTMLVideoElement")) return { width: o.videoWidth, height: o.videoHeight };
    if (a("SVGImageElement")) throw new TypeError("SVGImageElement isn't yet supported as source image.", "UnsupportedError");
    if (a("HTMLCanvasElement") || a("ImageBitmap")) return o;
  }
}, th = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
function Dp(t) {
  return t.split("").reduce((e, n) => e * 64 + th.indexOf(n), 0);
}
function Fp(t) {
  let e = th.split(""), n = [], i = 0;
  for (let r of t) n[i++] = e.indexOf(r) / 64;
  return n;
}
function Op(t) {
  return t && typeof t == "string" && t.length === 87 && t.split(".").length === 2;
}
function nh(t) {
  let e = t.split("."), n = e.map((a) => Fp(a)), i = n.map((a) => a[42]), r = n.map((a) => a.reduce((u, c) => u + c) / a.length), s = e.map((a) => Dp(a) % 360), o = e.map((a, u) => `hsl(${s[u]} ${i[u] * 100}% ${r[u] * 100}%)`);
  return { finals: i, decoded: n, angles: s, averages: r, colors: o };
}
function Yi(t, e = 3) {
  return [...Array(Math.ceil(t.length / e))].map(() => t.splice(0, e));
}
var rh = wa(xp()), Ip = wa(Sp()), ih = wa(Cp()), er = ye(null);
function Pp(t, e, n = "png") {
  if (n === "svg") {
    let i = t.outerHTML || t;
    return sh(i, e);
  } else return Mp(t, e);
}
function Rp(t) {
  try {
    let e = t.toDataURL("image/png").split(",")[1], n = atob(e), i = new Uint8Array(n.length);
    for (let r = 0; r < n.length; r++) i[r] = n.charCodeAt(r);
    return i;
  } catch (e) {
    return er.value = "Failed to convert canvas to buffer: " + e.message, null;
  }
}
function sh(t, e) {
  try {
    let n = `<metadata>
      <gun-data>${JSON.stringify(e)}</gun-data>
    </metadata>`;
    return t.replace("</svg>", `${n}</svg>`);
  } catch (n) {
    return er.value = "Failed to embed data in SVG: " + n.message, null;
  }
}
function Lp(t) {
  console.log(t);
  try {
    let e = t.match(/<metadata>\s*<gun-data>(.*?)<\/gun-data>\s*<\/metadata>/s);
    return !e || !e[1] ? (er.value = "No embedded data found in SVG", null) : JSON.parse(e[1]);
  } catch (e) {
    return er.value = "Failed to extract data from SVG: " + e.message, null;
  }
}
function Mp(t, e) {
  try {
    let n = Rp(t);
    if (!n) return null;
    let i = (0, rh.default)(n);
    return i.splice(-1, 0, ih.default.encode("message", JSON.stringify(e))), (0, Ip.default)(i);
  } catch (n) {
    return er.value = "Failed to embed data: " + n.message, null;
  }
}
function jp(t, e = "image/png") {
  if (e === "image/svg+xml") {
    let n = new TextDecoder().decode(t);
    return Lp(n);
  }
  try {
    let n = (0, rh.default)(t).filter((i) => i.name === "tEXt").map((i) => ih.default.decode(i.data)).find((i) => i.keyword === "message");
    return n ? JSON.parse(n.text) : null;
  } catch (n) {
    return er.value = n.message, null;
  }
}
async function Np(t) {
  try {
    if (!(t instanceof File)) throw new Error("Input must be a File object");
    let e = await t.arrayBuffer(), n = new Uint8Array(e);
    return await jp(n, t.type);
  } catch (e) {
    return er.value = e.message, null;
  }
}
function Bp({ pub: t, size: e, dark: n, draw: i, reflect: r, round: s, embed: o, p3: a }) {
  let u = document.createElement("canvas");
  u.width = u.height = e;
  let c = u.getContext("2d"), { decoded: l, finals: h } = nh(t);
  if ($p({ ctx: c, top: h[0], bottom: h[1], size: e, dark: n }), i == "squares" ? (c.filter = "blur(20px)", Xa(l[0], c, e, a), c.filter = "blur(0px)", c.globalCompositeOperation = "color-burn", Xa(l[1], c, e, a)) : (Qa(l[0], c, e, 0.42 * e, a), c.globalCompositeOperation = "multiply", Qa(l[1], c, e, 0.125 * e, a)), r && (c.globalCompositeOperation = "source-over", c.scale(-1, 1), c.translate(-e / 2, 0), c.drawImage(u, e / 2, 0, e, e, 0, 0, e, e), c.setTransform(1, 0, 0, 1, 0, 0)), s) {
    let d = c.getImageData(0, 0, e, e);
    c.clearRect(0, 0, e, e), c.fillStyle = n ? "#cccccc" : "#ffffff", c.fillRect(0, 0, e, e), c.putImageData(d, 0, 0), c.globalCompositeOperation = "destination-in", c.beginPath(), c.arc(e / 2, e / 2, e / 2, 0, Math.PI * 2), c.closePath(), c.fill();
  }
  let f = u.toDataURL("image/png");
  if (o) {
    let d = Pp(u, { pub: t, content: o });
    if (d) {
      let p = new Blob([d], { type: "image/png" });
      f = URL.createObjectURL(p);
    }
  }
  return f;
}
function $p({ ctx: t, top: e = 0, bottom: n = 150, size: i = 200, dark: r = !1 }) {
  let s = t.createLinearGradient(0, 0, 0, i), o = r ? 0 : 70;
  s.addColorStop(0, `hsl(0,0%,${o + e * 30}%)`), s.addColorStop(1, `hsl(0,0%,${o + n * 30}%)`), t.fillStyle = s, t.fillRect(0, 0, i, i);
}
function Xa(t, e, n, i) {
  Yi(t, 14).forEach((r) => {
    if (r.length === 14) {
      let [s, o, a, u, c, l, h, f, d, p, m, _, y, b] = r, g = n / 8 + a * n * (7 / 8), v = e.createLinearGradient(s * n + g * f, 0, s * n + g * y, n);
      v.addColorStop(0, i ? `color(display-p3 ${u} ${c} ${l} / ${h})` : `rgba(${u * 255}, ${c * 255}, ${l * 255}, ${h})`), v.addColorStop(1, i ? `color(display-p3 ${d} ${p} ${m} / ${_})` : `rgba(${d * 255}, ${p * 255}, ${m * 255}, ${_})`), e.fillStyle = v, e.translate(s * n, o * n), e.rotate(b * Math.PI), e.fillRect(-g / 2, -g / 2, g, g), e.setTransform(1, 0, 0, 1, 0, 0);
    }
  });
}
function Qa(t, e, n, i, r) {
  Yi(t, 7).forEach((s) => {
    if (s.length === 7) {
      let [o, a, u, c, l, h, f] = s;
      e.beginPath(), e.arc(n / 2 + o * n / 2, a * n, u * i, 0, 2 * Math.PI), e.fillStyle = r ? `color(display-p3 ${c} ${l} ${h} / ${f})` : `rgba(${c * 255}, ${l * 255}, ${h * 255}, ${f})`, e.closePath(), e.fill();
    }
  });
}
function zp({ size: t, reflect: e, finals: n, averages: i, breathVert: r = 0.03 } = {}) {
  return `
    <script type="text/javascript"><![CDATA[
      // Compact state using shorter variable names
      const s = {
        e: [], // elements
        m: { x: null, y: null, tx: 0, ty: 0 }, // mouse
        r: null, // rect
        f: null, // frame
        t: 0, // lastTime
        p: false, // pulse active
        pt: 0, // pulse start time
        pv: 0  // pulse current value (0-1)
      };

      // Optimize by precomputing constants
      const c = {
        d: 900, // duration
        pr: ${t} * (0.5 + (${n[0]}) / 4), // perspectiveRange
        pz: ${t} * 1.2, // perspectiveZ
        bz: ${t} * 0.4* ${n[1]}, // baseZ
        cx: ${t}/2, // centerX
        cy: ${t}/2, // centerY
        sz: ${t}, // size
        mv: (0.1 + 0.05*${i[0]})* Math.max(0.8, Math.min(4.4, 200/${t})), // movement range for the mouse following
        // Small sizes get slightly stronger animations to be noticeable
        bs: 0.1 * Math.max(0.8, Math.min(1.4, 200/${t})), // breathing scale - stronger for small sizes
        bd: 4500 + ${i[1]}*1000, // breathing duration in ms
        pa: 0.6 * Math.max(0.8, Math.min(1.4, 200/${t})), // pulse amplitude - stronger for small sizes
        pr: 200, // pulse rise time in ms
        pf: 700, // pulse fall time in ms
        bv: ${r} * Math.max(0.8, Math.min(1.4, 200/${t})) // breathing vertical amplitude
      };

      // Init function using IIFE
      (() => {
        const svg = document.currentScript.closest('svg');
        if (!svg) return;
        
        const ur = () => s.r = svg.getBoundingClientRect();
        ur(); // Initial calculation
        
        // Create handler functions once to avoid repeated function creation
        const resizeHandler = ur;
        const mouseHandler = e => {
          const { left, top, width, height } = s.r;
          s.m.tx = ((e.clientX - left) / width) * c.sz;
          s.m.ty = ((e.clientY - top) / height) * c.sz;
          if (s.m.x === null) {
            s.m.x = s.m.tx;
            s.m.y = s.m.ty;
          }
        };
        
        // Pulse start handler for mousedown/touchstart
        const pulseStart = e => {
          s.p = true;
          s.pt = performance.now();
          // Don't prevent default on mousedown to maintain normal behavior
          if (e.type === 'touchstart') e.preventDefault();
        };
        
        // Pulse end handler for mouseup/touchend
        const pulseEnd = () => {
          s.p = false;
          s.pt = performance.now(); // Reset pulse time to track decay
        };
        
        // Pointer leave handler
        const pointerLeave = () => {
          s.m.x = null;
          s.p = false; // Also end pulse if pointer leaves
        };

        // Cache element arrays to avoid repopulation
        s.e = [
          ...Array.from(svg.querySelectorAll('.interactive-circle')).map(el => {
            const x = +el.getAttribute('data-cx'),
                  y = +el.getAttribute('data-cy'),
                  r = +el.getAttribute('r'),
                  o = +el.getAttribute('data-opacity');
            return { 
              el, t: 'c', 
              x, y, r,
              cx: x, cy: y, 
              m: Math.pow(r / (c.sz * 0.05), 0.7) * o, // Mass proportional to radius cubed for realistic feel
              o: Math.random() * Math.PI * 2 // Phase offset
            };
          }),
          ...Array.from(svg.querySelectorAll('.interactive-square')).map(el => {
            const x = +el.getAttribute('data-cx'),
                  y = +el.getAttribute('data-cy'),
                  r = +el.getAttribute('data-r'),
                  o = +el.getAttribute('data-opacity'),
                  a = +el.getAttribute('data-angle') + (Math.random() * 20 - 10);
            return { 
              el, t: 's', 
              x, y, z: c.bz, r: a, 
              cx: x, cy: y, cz: c.bz, cr: a, cs: 1,
              m: Math.pow((r / c.sz), 1.5) * o, // Mass proportional to size for realistic feel
              o: Math.random() * Math.PI * 2 // Phase offset
            };
          })
        ];

        // Initial transform for squares
        s.e.filter(el => el.t === 's').forEach(setTransform);

        // Event listeners - reuse handler functions
        window.addEventListener('resize', resizeHandler, { passive: true });
        svg.addEventListener('mousemove', mouseHandler, { passive: true });
        svg.addEventListener('mouseenter', mouseHandler, { passive: true });
        svg.addEventListener('mouseleave', pointerLeave, { passive: true });
        
        // Pulse events
        svg.addEventListener('mousedown', pulseStart, { passive: true });
        svg.addEventListener('touchstart', pulseStart, { passive: false });
        window.addEventListener('mouseup', pulseEnd, { passive: true });
        window.addEventListener('touchend', pulseEnd, { passive: true });
        window.addEventListener('touchcancel', pulseEnd, { passive: true });
        
        // Start animation
        animate(performance.now());
        
        // Cleanup function for event listener removal
        document.currentScript.addEventListener('remove', () => {
          cancelAnimationFrame(s.f);
          window.removeEventListener('resize', resizeHandler);
          svg.removeEventListener('mousemove', mouseHandler);
          svg.removeEventListener('mouseenter', mouseHandler);
          svg.removeEventListener('mouseleave', pointerLeave);
          svg.removeEventListener('mousedown', pulseStart);
          svg.removeEventListener('touchstart', pulseStart);
          window.removeEventListener('mouseup', pulseEnd);
          window.removeEventListener('touchend', pulseEnd);
          window.removeEventListener('touchcancel', pulseEnd);
        });
      })();

      // Transform function - kept out of loop for clarity
      function setTransform(el) {
        const ps = c.pz / (c.pz + el.cz);
        const px = c.cx + (el.cx - c.cx) * ps;
        const py = c.cy + (el.cy - c.cy) * ps;
        el.el.setAttribute('transform',
          'translate('+ px+' '+ py+') rotate('+ el.cr+ ') scale(' +  ps * el.cs+')'
        );
      }
      
      // Update pulse value with smooth interpolation
      function updatePulseValue(time) {
        if (s.p) {
          // Smooth rise when pressed
          const elapsed = time - s.pt;
          s.pv += (1 - s.pv) * Math.min(1, elapsed / c.pr);
        } else {
          // Smooth fall when released
          const elapsed = time - s.pt;
          s.pv *= Math.max(0, 1 - elapsed / c.pf);
        }
        return s.pv;
      }
      
      // Calculate breathing and pulse together
      function getEffects(el, time, pulseValue) {
        // Calculate breathing cycle (0-2π)
        const angle = (time % c.bd) / c.bd * Math.PI * 2 + el.o;
        
        // Calculate sin wave (-1 to 1)
        const wave = Math.sin(angle);
        
        // Scale and offset
        const breathScale = 1 + wave * c.bs * (1 - Math.min(0.8, el.m));
        const yOffset = wave * c.sz * c.bv * (1 - Math.min(0.8, el.m));
        
        // Apply mass-proportional pulse (smaller objects pulse more)
        // Use inverse square law: smaller objects get more effect
        // Stronger effect for very small objects
        const massEffect = Math.pow(1 - Math.min(0.8, el.m), 2);
        const pulse = pulseValue * c.pa * massEffect;
        
        return { 
          scale: breathScale * (1 + pulse),
          yOffset,
          pulse
        };
      }

      // Update elements efficiently
      function updateElement(el, dt, time, pulseValue) {
        const sm = Math.min(dt / c.d, 1) * (el.t === 's' ? 0.3 : 0.1);
        const fx = getEffects(el, time, pulseValue);
        const mouseStrength = Math.max(0.6, Math.min(1, c.sz / 150));
        
        if (el.t === 'c') { // Circle update
          if (s.m.x !== null) {
            const dx = s.m.x - el.x;
            const dy = s.m.y - el.y;
            const d = Math.sqrt(dx * dx + dy * dy); // Faster than hypot for 2D
            
            // Size-relative movement radius
            const moveMax = c.sz * c.mv * (1 - Math.min(0.8, el.m));
            const move = Math.min(d, moveMax) * mouseStrength;
            
            // Only calculate angle if needed
            const a = d > 0.1 ? Math.atan2(dy, dx) : 0;
            
            // Target with breathing + mouse
            const tx = el.x + move * (dx / d);
            const ty = el.y + move * (dy / d) + fx.yOffset;
            
            el.cx += (tx - el.cx) * 0.1;
            el.cy += (ty - el.cy) * 0.1;
          } else {
            // Only breathing when no mouse
            el.cx += (el.x - el.cx) * 0.1;
            el.cy += (el.y + fx.yOffset - el.cy) * 0.1;
          }
          
          // Apply attributes
          el.el.setAttribute('cx', el.cx);
          el.el.setAttribute('cy', el.cy);
          el.el.setAttribute('r', el.r * fx.scale);
          
          // Handle reflection if enabled (minimized property lookups)
          if (${e}) {
            const mirror = el.el.nextElementSibling;
            if (mirror) {
              mirror.setAttribute('cx', c.sz - el.cx);
              mirror.setAttribute('cy', el.cy);
              mirror.setAttribute('r', el.r * fx.scale);
            }
          }
          return;
        }

        if (el.t === 's') { // Square update
          if (s.m.x !== null) {
            const dx = s.m.x - el.x;
            const dy = s.m.y - el.y;
            const d = Math.sqrt(dx * dx + dy * dy);
            const n = Math.min(d / c.pr, 1);
            
            // Size-relative movement radius
            const moveMax = c.sz * 0.1 * (1 - Math.min(0.8, el.m));
            const move = Math.min(d, moveMax) * mouseStrength;
            
            // Only calculate angle if needed
            const a = d > 0.1 ? Math.atan2(dy, dx) : 0;
            
            // Fast power for smoother effect
            const zf = 1 - n * n;
            
            // Update with mouse + breathing
            el.cx += (el.x + move * (dx / d) - el.cx) * sm;
            el.cy += (el.y + move * (dy / d) + fx.yOffset - el.cy) * sm;
            
            // Z-depth with pulse
            const depth = c.bz - (c.bz * zf * (1 - Math.min(0.8, el.m)) * fx.scale);
            // Pulse brings forward (squares float forward on click)
            const pulseZ = depth - fx.pulse * c.bz * 0.7;
            el.cz += (pulseZ - el.cz) * sm;
            
            el.cr += (el.r + Math.sin(d / 100) * 5 * (1 - Math.min(0.8, el.m)) - el.cr) * sm;
            el.cs += ((1 + (zf * 0.3 * (1 - Math.min(0.8, el.m)))) * fx.scale - el.cs) * sm;
          } else {
            // Only breathing when no mouse
            el.cx += (el.x - el.cx) * sm;
            el.cy += (el.y + fx.yOffset - el.cy) * sm;
            
            // Z pulse pushes element forward
            const pulseZ = c.bz * (1 - fx.pulse * 0.7);
            el.cz += (pulseZ - el.cz) * sm;
            
            el.cr += (el.r + Math.sin(time / 1500) * 3 * (1 - Math.min(0.8, el.m)) - el.cr) * sm;
            el.cs += (fx.scale - el.cs) * sm;
          }

          setTransform(el);
        }
      }

      // Main animation loop
      function animate(time) {
        const dt = s.t ? time - s.t : 0;
        s.t = time;

        // Mouse smoothing
        if (s.m.x !== null) {
          s.m.x += (s.m.tx - s.m.x) * 0.1;
          s.m.y += (s.m.ty - s.m.y) * 0.1;
        }
        
        // Update pulse value with smooth transitions
        const pulseValue = updatePulseValue(time);

        // Update all elements once
        s.e.forEach(el => updateElement(el, dt, time, pulseValue));
        
        // Continue animation
        s.f = requestAnimationFrame(animate);
      }
    ]]><\/script>
  `;
}
function Up({ pub: t, size: e = 200, dark: n = !1, draw: i = "circles", reflect: r = !0, round: s = !0, embed: o = !0, svg: a } = {}) {
  let { decoded: u, finals: c, averages: l } = nh(t), h = `
      <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="hsla(0,0%,${(n ? 0 : 70) + c[0] * 30}%)"/>
        <stop offset="100%" stop-color="hsla(0,0%,${(n ? 0 : 70) + c[1] * 30}%)"/>
      </linearGradient>
    `, f = (y, b = !1) => Yi(y, 14).map((g) => {
    if (g.length !== 14) return "";
    let [v, w, E, A, C, O, R, P, k, S, x, I, F, T] = g, L = e / 8 + E * e * (7 / 8), M = `gradient-${v}-${w}-${b ? "2" : "1"}`, U = v * e, $ = w * e, z = a === "interactive" ? `class="interactive-square" data-cx="${U}" data-cy="${$}" data-r="${L}" data-angle="${T * 180}" data-opacity="${(R + I) / 2}"` : "";
    return `
          <defs>
            <linearGradient id="${M}" x1="${P}" y1="0" x2="${F}" y2="1">
              <stop offset="0%" stop-color="color(display-p3 ${A} ${C} ${O} / ${R})"/>
              <stop offset="100%" stop-color="color(display-p3 ${k} ${S} ${x} / ${I})"/>
            </linearGradient>
          </defs>
          <g ${z} transform="translate(${U} ${$}) rotate(${T * 180})">
            <rect 
              x="${-L / 2}" y="${-L / 2}" 
              width="${L}" height="${L}"
              fill="url(#${M})"
              style="${b ? "mix-blend-mode:color-burn;" : "filter:blur(20px);"}"
            />
          </g>
        `;
  }).join(""), d = (y, b, g = !1) => Yi(y, 7).map((v) => {
    if (v.length !== 7) return "";
    let [w, E, A, C, O, R, P] = v, k = e / 2 + w * e / 2, S = E * e, x = A * b;
    return `
          <circle 
            ${a === "interactive" ? `class="interactive-circle" data-cx="${k}" data-cy="${S}" data-opacity="${P}"` : ""}
            cx="${k}" cy="${S}" r="${x}"
            fill="color(display-p3 ${C} ${O} ${R} / ${P})"

            style="${g ? "mix-blend-mode:multiply;" : ""}"
          />
          ${r ? `
          <circle 
            cx="${e - k}" cy="${S}" r="${x}"
            fill="color(display-p3 ${C} ${O} ${R} / ${P})"

            style="${g ? "mix-blend-mode:multiply;" : ""}"
          />` : ""}
        `;
  }).join(""), p = s ? `
      <defs>
        <clipPath id="circle-mask">
          <circle cx="${e / 2}" cy="${e / 2}" r="${e / 2}" />
        </clipPath>
      </defs>
    ` : "", m = a === "interactive" ? zp({ size: e, reflect: r, finals: c, averages: l }) : "", _ = `
      <svg 
        width="${e}" height="${e}" 
        viewBox="0 0 ${e} ${e}" 
        xmlns="http://www.w3.org/2000/svg"
        style="overflow: visible;"
        >
        <defs>${h}</defs>
        ${p}
        <g ${s ? 'clip-path="url(#circle-mask)"' : ""}>
          <rect x="${-e}" width="${3 * e}" y="${-e}" height="${3 * e}" fill="url(#bg)"/>
          ${i === "squares" ? `${f(u[0], !1)}
             ${f(u[1], !0)}` : `${d(u[0], 0.42 * e)}
             ${d(u[1], 0.125 * e, !0)}`}
        </g>
        ${m}
      </svg>
    `;
  if (a === "interactive") return `data:image/svg+xml,${encodeURIComponent(_.trim())}`;
  if (o) {
    let y = { pub: t };
    o && (y.content = o), _ = sh(_, y);
  }
  return `data:image/svg+xml;base64,${typeof btoa == "function" ? btoa(_) : Buffer.from(_).toString("base64")}`;
}
var vi = {};
function oh(t = {}) {
  let { pub: e, size: n = 200, dark: i = !1, draw: r = "circles", reflect: s = !0, round: o = !0, embed: a = !0, svg: u = !0, p3: c = !0 } = t, l = typeof window < "u" && typeof document < "u";
  if (!Op(e)) return "";
  if (u || !l) return Up({ pub: e, size: n, dark: i, draw: r, reflect: s, round: o, embed: a, svg: u });
  let h = JSON.stringify(arguments[0]);
  if (vi != null && vi[h]) return vi[h];
  let f = Bp({ pub: e, size: n, dark: i, draw: r, reflect: s, round: o, embed: a, p3: c });
  return vi[h] = f, f;
}
Tp();
const Ue = ie({
  input: "",
  show: !1,
  safePair: !1,
  minLength: 5,
  safe: {
    saved: !1,
    password: "",
    enc: "",
    pass: ""
  },
  dec: {},
  links: ie({
    pass: te(() => {
      var t;
      return eu((t = Ue.safe) == null ? void 0 : t.enc);
    }),
    pair: te(() => eu(JSON.stringify(xe.pair())))
  }),
  set() {
    ah(Ue.input), Ue.input = "", Ue.show = !1;
  }
});
function eu(t = "", e = "#/auth/") {
  let n = encodeURIComponent(t);
  return window.location.origin + window.location.pathname + e + n;
}
function W2(t, e = "#/auth/") {
  let n = t.indexOf(e), i = t.substring(n + e.length);
  return decodeURIComponent(i);
}
function V2() {
  return ue().user().get("safe").map().on((e, n) => {
    Ue.safe[n] = e;
  }), nr(async () => {
    var e, n;
    if (!Ue.show) {
      Ue.dec = {};
      return;
    }
    (e = Ue == null ? void 0 : Ue.safe) != null && e.pass && (Ue.dec.pass = await xe.decrypt(Ue.safe.pass), Ue.input = Ue.dec.pass || ""), (n = Ue == null ? void 0 : Ue.safe) != null && n.enc && (Ue.dec.pair = await Ve.decrypt(Ue.safe.enc, Ue.dec.pass));
  }), { pass: Ue, setPass: ah, authWithPass: Hp };
}
async function G2(t) {
  return await ue().get(`~${t}`).get("safe").get("enc").then();
}
async function Hp(t, e) {
  let i = await ue().get(`~${t}`).get("safe").get("enc").then(), r = await Ve.decrypt(i, e);
  As(r);
}
async function ah(t) {
  const e = ue();
  let n = await Ve.encrypt(xe.pair(), t), i = await xe.encrypt(t);
  e.user().get("safe").get("enc").put(n), e.user().get("safe").get("pass").put(i);
}
function K2(t, e) {
  if (!t) return;
  const n = decodeURIComponent(t);
  if (n.substring(0, 3) == "SEA")
    return e && qp(n, e), "encrypted";
  try {
    let i = JSON.parse(n);
    return gf(i) && As(i), "success";
  } catch {
    return "incorrect link";
  }
}
async function qp(t, e) {
  let n = await Ve.decrypt(t, e);
  As(n);
}
async function Z2(t, e) {
  const n = t[0];
  if (!n) return;
  const i = n.type.toLowerCase();
  try {
    if (i === "application/json" || n.name.endsWith(".webkey"))
      return await ug([n]);
    if (i === "image/png" || i === "image/svg+xml") {
      const r = await Np(n);
      if (r != null && r.content) return r.content;
    } else if (i.startsWith("image/")) {
      const { processFile: r } = j2();
      return await r(n);
    }
  } catch (r) {
    console.error("Failed to extract auth data from file:", r);
  }
}
function J2() {
  const { share: t, isSupported: e } = Q0();
  function n(u, c = "Bookmark") {
    return {
      Win: {
        content: `[InternetShortcut]
URL=${u}`,
        extension: ".url",
        mime: "application/internet-shortcut"
      },
      Mac: {
        content: `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
<dict>
  <key>URL</key>
  <string>${u}</string>
</dict>
</plist>`,
        extension: ".webloc",
        mime: "application/x-apple-plist"
      },
      Linux: {
        content: `[Desktop Entry]
Encoding=UTF-8
Type=Link
Name=${c}
URL=${u}`,
        extension: ".desktop",
        mime: "application/x-desktop"
      }
    };
  }
  function i(u, c, l) {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && e) {
      t({
        title: c,
        text: l.startsWith("text/") ? u : "Your key file",
        files: [new File([u], c, { type: l })]
      });
      return;
    }
    const h = new Blob([u], { type: l }), f = URL.createObjectURL(h), d = document.createElement("a");
    d.href = f, d.download = c, document.body.appendChild(d), d.click(), document.body.removeChild(d), URL.revokeObjectURL(f);
  }
  function r(u, c, l) {
    const f = n(u)[c];
    !(f != null && f.content) || !(f != null && f.extension) || i(
      f.content,
      `${l || "account"}${f.extension}`,
      f.mime
    );
  }
  function s(u, c, l = "png") {
    fetch(u).then((h) => h.blob()).then((h) => i(h, `${c || "account " + (/* @__PURE__ */ new Date()).getDate()}.${l}`, h.type));
  }
  function o(u, c, l = ".webkey") {
    i(
      u,
      `${c || "account " + (/* @__PURE__ */ new Date()).getDate()}.${l}`,
      "application/json"
    );
  }
  async function a(u, c, l = "png") {
    if (!e) {
      console.log("Sharing not supported");
      return;
    }
    try {
      const h = await fetch(u).then((d) => d.blob());
      if (!h) {
        console.error("Failed to create blob from data URL");
        return;
      }
      const f = new File([h], `${c || "avatar"}.${l}`, { type: l == "png" ? "image/png" : "image/svg+xml" });
      return t({
        title: c || "Gun-Vue avatar",
        files: [f]
      }).catch((d) => console.error("Share failed:", d));
    } catch (h) {
      console.error("Share preparation failed:", h);
    }
  }
  return {
    saveLink: r,
    saveImage: s,
    saveJson: o,
    shareImage: a
  };
}
const uh = (t) => btoa(String.fromCharCode(...t)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""), ch = () => crypto.getRandomValues(new Uint8Array(32)), Wp = () => crypto.getRandomValues(new Uint8Array(16));
async function Y2(t) {
  const e = t || `User ${(/* @__PURE__ */ new Date()).toISOString().replace("T", " ").slice(0, 16)}`, n = {
    challenge: ch(),
    rp: { name: "Gun-Vue" },
    user: {
      id: Wp(),
      name: e,
      displayName: e
    },
    pubKeyCredParams: [{ type: "public-key", alg: -7 }],
    authenticatorSelection: {
      residentKey: "required",
      userVerification: "preferred"
    },
    attestation: "none",
    timeout: 6e4
  }, i = await navigator.credentials.create({ publicKey: n });
  return { id: uh(new Uint8Array(i.rawId)) };
}
async function X2() {
  const t = {
    challenge: ch(),
    userVerification: "preferred",
    timeout: 6e4
  }, e = await navigator.credentials.get({ publicKey: t });
  return { id: uh(new Uint8Array(e.rawId)) };
}
const An = Gt("cast-camera", "default"), br = Gt("cast-mic", "default"), Vp = ye(""), tu = ye(!0), nu = Gt("slidev-record-mimetype", "video/webm"), lh = {
  "video/webm": "webm",
  "video/webm;codecs=h264": "mp4",
  "video/x-matroska;codecs=avc1": "mkv"
};
function Xi(t, e) {
  const n = /* @__PURE__ */ new Date(), i = (o) => `${o}`.padStart(2, "0"), r = `${i(n.getMonth() + 1)}${i(n.getDate())}-${i(
    n.getHours()
  )}${i(n.getMinutes())}`, s = e ? lh[e] : "webm";
  return `${[r, t, Vp.value].filter((o) => !!o).join("-")}.${s}`;
}
function Q2() {
  return MediaRecorder && typeof MediaRecorder.isTypeSupported == "function" ? Object.keys(lh).filter(
    (t) => MediaRecorder.isTypeSupported(t)
  ) : [];
}
const ev = ie({
  screen: te(() => Xi("screen", nu.value)),
  camera: te(() => Xi("camera", nu.value))
}), {
  devices: tv,
  videoInputs: ru,
  audioInputs: iu,
  ensurePermissions: su
} = H0({
  onUpdated: function() {
    var t, e;
    An.value !== "none" && (ru.value.find((n) => n.deviceId === An.value) || (An.value = ((t = ru.value[0]) == null ? void 0 : t.deviceId) || "default")), br.value !== "none" && (iu.value.find((n) => n.deviceId === br.value) || (br.value = ((e = iu.value[0]) == null ? void 0 : e.deviceId) || "default"));
  }
});
function ou(t, e) {
  const n = document.createElement("a");
  n.setAttribute("href", e), n.setAttribute("download", t), document.body.appendChild(n), n.click(), document.body.removeChild(n);
}
function Gp() {
  const t = ye(!1), e = ye(0), n = ep();
  Ge(
    t,
    (y) => y ? e.value = Date.now() : e.value = 0
  );
  const i = te(() => e.value ? n.value - e.value : 0), r = ye(!1), s = _e(), o = _e(), a = _e(), u = _e(), c = _e(), l = {
    type: "video",
    bitsPerSecond: 4 * 256 * 8 * 1024,
    // Extending recording limit as default is only 1h (see https://github.com/muaz-khan/RecordRTC/issues/144)
    timeSlice: 24 * 60 * 60 * 1e3
  };
  async function h() {
    An.value !== "none" && (r.value ? (r.value = !1, t.value || m(a)) : (await f(), a.value && (r.value = !!a.value)));
  }
  async function f() {
    if (await su(), await _s(), !a.value) {
      if (An.value === "none" && br.value === "none") return;
      a.value = await navigator.mediaDevices.getUserMedia({
        video: An.value === "none" || tu.value !== !0 ? !1 : {
          deviceId: An.value
        },
        audio: br.value === "none" ? !1 : {
          deviceId: br.value
        }
      });
    }
  }
  Ge(An, async (y) => {
    if (y === "none")
      m(a);
    else {
      if (t.value) return;
      a.value && (m(a), await f());
    }
  });
  async function d(y = {}) {
    var g;
    await su();
    const { default: b } = await import("./RecordRTC-BhQBmu42.js").then((v) => v.RecordRTC);
    if (await f(), u.value = await navigator.mediaDevices.getDisplayMedia({
      video: {
        // aspectRatio: 1.6,
        frameRate: 30,
        width: 3840,
        height: 2160
      }
    }), u.value.addEventListener("inactive", p), c.value = new MediaStream(), u.value.getVideoTracks().forEach((v) => c.value.addTrack(v)), Object.assign(l, y), a.value) {
      const v = (g = a.value.getAudioTracks()) == null ? void 0 : g[0];
      v && c.value.addTrack(v), s.value = new b(a.value, l), s.value.startRecording();
    }
    o.value = new b(c.value, l), o.value.startRecording(), t.value = !0;
  }
  async function p() {
    var y, b;
    t.value = !1, (y = s.value) == null || y.stopRecording(() => {
      if (tu.value) {
        const g = s.value.getBlob(), v = URL.createObjectURL(g);
        ou(Xi("camera", l.mimeType), v), window.URL.revokeObjectURL(v);
      }
      s.value = void 0, r.value || m(a);
    }), (b = o.value) == null || b.stopRecording(() => {
      const g = o.value.getBlob(), v = URL.createObjectURL(g);
      ou(Xi("screen", l.mimeType), v), window.URL.revokeObjectURL(v), m(u), m(c), o.value = void 0;
    });
  }
  function m(y) {
    const b = y.value;
    b && (b.getTracks().forEach((g) => {
      g.stop(), b.removeTrack(g);
    }), y.value = void 0);
  }
  function _() {
    t.value ? p() : d();
  }
  return Me("beforeunload", (y) => {
    t.value && (confirm("Recording is not saved yet, do you want to leave?") || (y.preventDefault(), y.returnValue = ""));
  }), {
    recording: t,
    recordingTime: i,
    showAvatar: r,
    toggleRecording: _,
    startRecording: d,
    stopRecording: p,
    toggleAvatar: h,
    recorderCamera: s,
    recorderSlides: o,
    streamCamera: a,
    streamCapture: u,
    streamSlides: c
  };
}
const nv = Gp();
var Mi = { exports: {} }, Kp = Mi.exports, au;
function Zp() {
  return au || (au = 1, function(t, e) {
    (function(n, i, r) {
      t.exports = r(), t.exports.default = r();
    })("slugify", Kp, function() {
      var n = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), i = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
      function r(s, o) {
        if (typeof s != "string")
          throw new Error("slugify: string argument expected");
        o = typeof o == "string" ? { replacement: o } : o || {};
        var a = i[o.locale] || {}, u = o.replacement === void 0 ? "-" : o.replacement, c = o.trim === void 0 ? !0 : o.trim, l = s.normalize().split("").reduce(function(h, f) {
          var d = a[f];
          return d === void 0 && (d = n[f]), d === void 0 && (d = f), d === u && (d = " "), h + d.replace(o.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        return o.strict && (l = l.replace(/[^A-Za-z0-9\s]/g, "")), c && (l = l.trim()), l = l.replace(/\s+/g, u), o.lower && (l = l.toLowerCase()), l;
      }
      return r.extend = function(s) {
        Object.assign(n, s);
      }, r;
    });
  }(Mi)), Mi.exports;
}
var Jp = Zp();
const Qi = /* @__PURE__ */ Pn(Jp), wi = ye("general"), Do = "chat";
function rv(t = "general") {
  const e = ue(), { user: n } = Re();
  wi.value = t;
  const i = ie({}), r = ie({}), s = ie({});
  e.user(ne.pub).get(Do).map().once((l, h) => {
    const [f, d] = h.split("@");
    i[f] || (i[f] = { upvotes: /* @__PURE__ */ new Set(), downvotes: /* @__PURE__ */ new Set() }), i[f].upvotes.delete(d), i[f].downvotes.delete(d), l === !0 ? (i[f].upvotes.add(d), d == n.pub && (delete r[f], s[f] = !0)) : l === !1 ? (i[f].downvotes.add(d), d == n.pub && (r[f] = !0, delete s[f])) : l === null && d == n.pub && (delete r[f], delete s[f]);
  });
  const o = te(
    () => Object.entries(i).map(([l, h]) => ({
      title: l,
      authors: Array.from(h.upvotes),
      rating: h.upvotes.size - h.downvotes.size,
      my: h.upvotes.has(n.pub) ? 1 : h.downvotes.has(n.pub) ? -1 : 0
    })).filter(
      (l) => l.title == "general" || s[l.title] || !r[l.title] && l.rating >= 0
    ).sort((l, h) => h.rating - l.rating)
  ), a = te(() => {
    const l = ie({});
    return e.user(ne.pub).get("chat/" + wi.value).map().on((h, f) => {
      const d = f.substring(0, 13), p = f.substring(14);
      h ? l[f] = { timestamp: d, author: p, text: h } : delete l[f];
    }), l;
  }), u = te(
    () => w0(te(() => Object.values(a.value || {}))).value.sort((l, h) => l.timestamp > h.timestamp ? 1 : -1)
  );
  function c(l) {
    if (!l) return;
    const h = Date.now();
    e.user(ne.pub).get("chat/" + wi.value).get(`${h}@${n.pub}`).put(l, void 0, { opt: { cert: ne.features.chat } });
  }
  return {
    send: c,
    addChat: (l) => uu(l, !0),
    removeChat: (l) => uu(l, !1),
    currentChat: wi,
    chats: o,
    messages: a,
    sorted: u
  };
}
async function uu(t, e = !0) {
  const n = ue(), { user: i } = Re(), s = await n.user(ne.pub).get(Do).get(`${Qi(t)}@${i.pub}`).then() === e ? null : e;
  n.user(ne.pub).get(Do).get(`${Qi(t)}@${i.pub}`).put(s, void 0, { opt: { cert: ne.features.chat } });
}
function Vn(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ji = { exports: {} };
ji.exports;
var cu;
function Ar() {
  return cu || (cu = 1, function(t) {
    (function() {
      function e(i, r) {
        return r ? Vn(i) : i.slice ? e[s(i)] : function(o, a) {
          i(o = { exports: {} }), e[s(a)] = o.exports;
        };
        function s(o) {
          return o.split("/").slice(-1).toString().replace(".js", "");
        }
      }
      var n = t;
      e(function(i) {
        String.random = function(s, o) {
          var a = "";
          for (s = s || 24, o = o || "0123456789ABCDEFGHIJKLMNOPQRSTUVWXZabcdefghijklmnopqrstuvwxyz"; s-- > 0; )
            a += o.charAt(Math.floor(Math.random() * o.length));
          return a;
        }, String.match = function(s, o) {
          var a, u;
          return typeof s != "string" ? !1 : (typeof o == "string" && (o = { "=": o }), o = o || {}, a = o["="] || o["*"] || o[">"] || o["<"], s === a ? !0 : u !== o["="] ? !1 : (a = o["*"] || o[">"], s.slice(0, (a || "").length) === a ? !0 : u !== o["*"] ? !1 : u !== o[">"] && u !== o["<"] ? s >= o[">"] && s <= o["<"] : u !== o[">"] && s >= o[">"] || u !== o["<"] && s <= o["<"]));
        }, String.hash = function(s, o) {
          if (typeof s == "string") {
            if (o = o || 0, !s.length)
              return o;
            for (var a = 0, u = s.length, c; a < u; ++a)
              c = s.charCodeAt(a), o = (o << 5) - o + c, o |= 0;
            return o;
          }
        };
        var r = Object.prototype.hasOwnProperty;
        Object.plain = function(s) {
          return s ? s instanceof Object && s.constructor === Object || Object.prototype.toString.call(s).match(/^\[object (\w+)\]$/)[1] === "Object" : !1;
        }, Object.empty = function(s, o) {
          for (var a in s)
            if (r.call(s, a) && (!o || o.indexOf(a) == -1))
              return !1;
          return !0;
        }, Object.keys = Object.keys || function(s) {
          var o = [];
          for (var a in s)
            r.call(s, a) && o.push(a);
          return o;
        }, function() {
          var s, o = setTimeout, a = 0, u = 0, c = typeof setImmediate != "" + s && setImmediate || function(h, f) {
            return typeof MessageChannel == "" + s ? o : ((h = new MessageChannel()).port1.onmessage = function(d) {
              d.data == "" && f();
            }, function(d) {
              f = d, h.port2.postMessage("");
            });
          }(), l = o.check = o.check || typeof performance != "" + s && performance || { now: function() {
            return +/* @__PURE__ */ new Date();
          } };
          o.hold = o.hold || 9, o.poll = o.poll || function(h) {
            if (o.hold >= l.now() - a && u++ < 3333) {
              h();
              return;
            }
            c(function() {
              a = l.now(), h();
            }, u = 0);
          };
        }(), function() {
          var s = setTimeout, o = s.turn = s.turn || function(f) {
            a.push(f) == 1 && u(h);
          }, a = o.s = [], u = s.poll, c = 0, l, h = function() {
            (l = a[c++]) && l(), (c == a.length || c == 99) && (a = o.s = a.slice(c), c = 0), a.length && u(h);
          };
        }(), function() {
          var s, o = setTimeout, a = o.turn;
          (o.each = o.each || function(u, c, l, h) {
            h = h || 9, function f(d, p, m) {
              if (p = (d = (u || []).splice(0, h)).length) {
                for (var _ = 0; _ < p && s === (m = c(d[_])); _++)
                  ;
                if (s === m) {
                  a(f);
                  return;
                }
              }
              l && l(m);
            }();
          })();
        }();
      })(e, "./shim"), e(function(i) {
        i.exports = function r(l, o, a) {
          if (!l)
            return { to: r };
          var u, c = typeof o == "function", l = (this.tag || (this.tag = {}))[l] || c && (this.tag[l] = { tag: l, to: r._ = { next: function(f) {
            var d;
            (d = this.to) && d.next(f);
          } } });
          if (c) {
            var h = {
              off: r.off || (r.off = function() {
                if (this.next === r._.next)
                  return !0;
                this === this.the.last && (this.the.last = this.back), this.to.back = this.back, this.next = r._.next, this.back.to = this.to, this.the.last === this.the && delete this.on.tag[this.the.tag];
              }),
              to: r._,
              next: o,
              the: l,
              on: this,
              as: a
            };
            return (h.back = l.last || l).to = h, l.last = h;
          }
          return (l = l.to) && u !== o && l.next(o), l;
        };
      })(e, "./onto"), e(function(i) {
        i.exports = function(r) {
          return r === null || typeof r == "string" || typeof r == "boolean" || // we want +/- Infinity to be, but JSON does not support it, sad face.
          // can you guess what v === v checks for? ;)
          typeof r == "number" && r != 1 / 0 && r != -1 / 0 && r === r || !!r && typeof r["#"] == "string" && Object.keys(r).length === 1 && r["#"];
        };
      })(e, "./valid"), e(function(i) {
        e("./shim");
        function r() {
          var l = +/* @__PURE__ */ new Date();
          return u < l ? (o = 0, u = l + r.drift) : u = l + (o += 1) / a + r.drift;
        }
        r.drift = 0;
        var s = -1 / 0, o = 0, a = 999, u = s, c;
        r.is = function(l, h, f) {
          var d = h && l && l._ && l._[">"] || f;
          if (d)
            return typeof (d = d[h]) == "number" ? d : s;
        }, r.ify = function(l, h, f, d, p) {
          (l = l || {})._ = l._ || {}, p && (l._["#"] = p);
          var m = l._[">"] || (l._[">"] = {});
          return c !== h && h !== "_" && (typeof f == "number" && (m[h] = f), c !== d && (l[h] = d)), l;
        }, i.exports = r;
      })(e, "./state"), e(function(i) {
        e("./shim");
        function r(s) {
          var o = { s: {} }, a = o.s;
          s = s || { max: 999, age: 1e3 * 9 }, o.check = function(c) {
            return a[c] ? u(c) : !1;
          };
          var u = o.track = function(c) {
            var l = a[c] || (a[c] = {});
            return l.was = o.now = +/* @__PURE__ */ new Date(), o.to || (o.to = setTimeout(o.drop, s.age + 9)), u.ed && u.ed(c), l;
          };
          return o.drop = function(c) {
            o.to = null, o.now = +/* @__PURE__ */ new Date();
            var l = Object.keys(a);
            console.STAT && console.STAT(o.now, +/* @__PURE__ */ new Date() - o.now, "dup drop keys"), setTimeout.each(l, function(h) {
              var f = a[h];
              f && (c || s.age) > o.now - f.was || delete a[h];
            }, 0, 99);
          }, o;
        }
        i.exports = r;
      })(e, "./dup"), e(function(i) {
        e("./onto"), i.exports = function(o, a) {
          if (this.on) {
            var u = (this.opt || {}).lack || 9e3;
            if (typeof o != "function") {
              if (!o)
                return;
              var l = o["#"] || o, c = (this.tag || "")[l];
              return c ? (a && (c = this.on(l, a), clearTimeout(c.err), c.err = setTimeout(function() {
                c.off();
              }, u)), !0) : void 0;
            }
            var l = a && a["#"] || r(9);
            if (!o)
              return l;
            var h = this.on(l, o, a);
            return h.err = h.err || setTimeout(function() {
              h.off(), h.next({ err: "Error: No ACK yet.", lack: !0 });
            }, u), l;
          }
        };
        var r = String.random || function() {
          return Math.random().toString(36).slice(2);
        };
      })(e, "./ask"), e(function(i) {
        function r(p) {
          return p instanceof r ? (this._ = { $: this }).$ : this instanceof r ? r.create(this._ = { $: this, opt: p }) : new r(p);
        }
        r.is = function(p) {
          return p instanceof r || p && p._ && p === p._.$ || !1;
        }, r.version = 0.202, r.chain = r.prototype, r.chain.toJSON = function() {
        }, e("./shim"), r.valid = e("./valid"), r.state = e("./state"), r.on = e("./onto"), r.dup = e("./dup"), r.ask = e("./ask"), function() {
          r.create = function(S) {
            S.root = S.root || S, S.graph = S.graph || {}, S.on = S.on || r.on, S.ask = S.ask || r.ask, S.dup = S.dup || r.dup();
            var x = S.$.opt(S.opt);
            return S.once || (S.on("in", p, S), S.on("out", p, S), S.on("put", y, S), r.on("create", S), S.on("create", S)), S.once = 1, x;
          };
          function p(S) {
            if (S) {
              if (S.out === p) {
                this.to.next(S);
                return;
              }
              var x = this, I = x.as, F = I.at || I, T = F.$, L = F.dup, M, U = S.DBG;
              if ((M = S["#"]) || (M = S["#"] = o(9)), !L.check(M)) {
                if (L.track(M), M = S._, S._ = typeof M == "function" ? M : function() {
                }, S.$ && S.$ === (S.$._ || "").$ || (S.$ = T), S["@"] && !S.put && g(S), !F.ask(S["@"], S))
                  if (U && (U.u = +/* @__PURE__ */ new Date()), S.put) {
                    m(S);
                    return;
                  } else
                    S.get && r.on.get(S, T);
                U && (U.uc = +/* @__PURE__ */ new Date()), x.to.next(S), U && (U.ua = +/* @__PURE__ */ new Date()), !(S.nts || S.NTS) && (S.out = p, F.on("out", S), U && (U.ue = +/* @__PURE__ */ new Date()));
              }
            }
          }
          function m(S) {
            if (S) {
              var x = S._ || "", I = x.root = ((x.$ = S.$ || "")._ || "").root;
              if (S["@"] && x.faith && !x.miss) {
                S.out = p, I.on("out", S);
                return;
              }
              x.latch = I.hatch, x.match = I.hatch = [];
              var F = S.put, T = x.DBG = S.DBG, L = +/* @__PURE__ */ new Date();
              if (P = P || L, !(F["#"] && F["."])) {
                T && (T.p = L), x["#"] = S["#"], x.msg = S, x.all = 0, x.stun = 1;
                var M = Object.keys(F);
                console.STAT && console.STAT(L, ((T || x).pk = +/* @__PURE__ */ new Date()) - L, "put sort");
                var U = 0, $, z, X, J, K, be, Fe;
                (function de(ge) {
                  if ($ != U) {
                    if ($ = U, !(X = M[U])) {
                      console.STAT && console.STAT(L, ((T || x).pd = +/* @__PURE__ */ new Date()) - L, "put"), b(x);
                      return;
                    }
                    (J = F[X]) ? (Fe = J._) ? X !== Fe["#"] ? be = w + E(X) + "soul not same." : (K = Fe[">"]) || (be = w + E(X) + "no state.") : be = w + E(X) + "no meta." : be = w + E(X) + "no node.", z = Object.keys(J || {});
                  }
                  if (be) {
                    S.err = x.err = be, b(x);
                    return;
                  }
                  var Ae = 0, ke;
                  for (ge = ge || 0; ge++ < 9 && (ke = z[Ae++]); )
                    if (ke !== "_") {
                      var Le = J[ke], Xe = K[ke];
                      if (h === Xe) {
                        be = w + E(ke) + "on" + E(X) + "no state.";
                        break;
                      }
                      if (!u(Le)) {
                        be = w + E(ke) + "on" + E(X) + "bad " + typeof Le + E(Le);
                        break;
                      }
                      _(Le, ke, X, Xe, S), ++R;
                    }
                  if ((z = z.slice(Ae)).length) {
                    a(de);
                    return;
                  }
                  ++U, z = null, de(ge);
                })();
              }
            }
          }
          r.on.put = m;
          function _(S, x, I, F, T) {
            var L = T._ || "", M = L.root, U = M.graph, $, z = U[I] || f, X = c(z, x, 1), J = z[x], K = L.DBG;
            ($ = console.STAT) && (!U[I] || !J) && ($.has = ($.has || 0) + 1);
            var be = O();
            if (F > be) {
              setTimeout(function() {
                _(S, x, I, F, T);
              }, ($ = F - be) > C ? C : $), console.STAT && console.STAT((K || L).Hf = +/* @__PURE__ */ new Date(), $, "future");
              return;
            }
            if (!(F < X) && !(!L.faith && F === X && (S === J || A(S) <= A(J)) && !L.miss)) {
              L.stun++;
              var Fe = T["#"] + L.all++, de = { toString: function() {
                return Fe;
              }, _: L };
              de.toJSON = de.toString, M.dup.track(de)["#"] = T["#"], K && (K.ph = K.ph || +/* @__PURE__ */ new Date()), M.on("put", { "#": de, "@": T["@"], put: { "#": I, ".": x, ":": S, ">": F }, ok: T.ok, _: L });
            }
          }
          function y(S) {
            var x;
            (x = (S._ || "").DBG) && (x.pa = +/* @__PURE__ */ new Date(), x.pm = x.pm || +/* @__PURE__ */ new Date());
            var I = this, F = I.as, T = F.graph, L = S._, M = S.put, U = M["#"], $ = M["."], z = M[":"], X = M[">"];
            S["#"];
            var J;
            (J = L.msg) && (J = J.put) && (J = J[U]) && l(J, $, X, z, U), T[U] = l(T[U], $, X, z, U), (J = (F.next || "")[U]) && J.on("in", S), b(L), I.to.next(S);
          }
          function b(S, x) {
            var I;
            if (!S.stop && !(!S.err && 0 < --S.stun) && (S.stop = 1, !!(I = S.root))) {
              var F = S.match;
              F.end = 1, F === I.hatch && (!(F = S.latch) || F.end ? delete I.hatch : I.hatch = F), S.hatch && S.hatch(), setTimeout.each(S.match, function(T) {
                T && T();
              }), !(!(x = S.msg) || S.err || x.err) && (x.out = p, S.root.on("out", x), k());
            }
          }
          function g(S) {
            var x = S["@"] || "", I;
            if (!(I = x._)) {
              var F = (F = S.$) && (F = F._) && (F = F.root) && (F = F.dup);
              if (!(F = F.check(x)))
                return;
              S["@"] = F["#"] || S["@"];
              return;
            }
            I.acks = (I.acks || 0) + 1, (I.err = S.err) && (S["@"] = I["#"], b(I)), I.ok = S.ok || I.ok, !I.stop && !I.crack && (I.crack = I.match && I.match.push(function() {
              v(I);
            })), v(I);
          }
          function v(S) {
            !S || !S.root || S.stun || S.acks !== S.all || S.root.on("in", { "@": S["#"], err: S.err, ok: S.err ? h : S.ok || { "": 1 } });
          }
          var w = "Error: Invalid graph!", E = function(S) {
            return " '" + ("" + S).slice(0, 9) + "...' ";
          }, A = JSON.stringify, C = 2147483647, O = r.state, R = 0, P, k = function() {
            R > 999 && R / -(P - (P = +/* @__PURE__ */ new Date())) > 1 && (r.window && console.log("Warning: You're syncing 1K+ records a second, faster than DOM can update - consider limiting query."), k = function() {
              R = 0;
            });
          };
        }(), function() {
          r.on.get = function(m, _) {
            var y = _._, b = m.get, g = b["#"], v = y.graph[g], w = b["."], E = y.next || (y.next = {}), A = E[g], C = m._ || {}, O = C.DBG = m.DBG;
            if (O && (O.g = +/* @__PURE__ */ new Date()), !v)
              return y.on("get", m);
            if (w) {
              if ((typeof w != "string" || h === v[w]) && !((A || "").next || "")[w]) {
                y.on("get", m);
                return;
              }
              v = l({}, w, c(v, w), v[w], g);
            }
            v && p(m, v), y.on("get", m);
          };
          function p(m, _) {
            var y = +/* @__PURE__ */ new Date(), b = m._ || {}, g = b.DBG = m.DBG, v = m["#"], w = o(9), E = Object.keys(_ || "").sort(), A = ((_ || "")._ || "")["#"];
            E.length;
            var C = m.$._.root, O = _ === C.graph[A];
            console.STAT && console.STAT(y, ((g || b).gk = +/* @__PURE__ */ new Date()) - y, "got keys"), _ && function R() {
              y = +/* @__PURE__ */ new Date();
              for (var P = 0, k, S = {}, x; P < 9 && (k = E[P++]); )
                l(S, k, c(_, k), _[k], A);
              E = E.slice(P), (x = {})[A] = S, S = x;
              var I;
              O && (I = function() {
              }, I.ram = I.faith = !0), x = E.length, console.STAT && console.STAT(y, -(y - (y = +/* @__PURE__ */ new Date())), "got copied some"), g && (g.ga = +/* @__PURE__ */ new Date()), C.on("in", { "@": v, "#": w, put: S, "%": x ? w = o(9) : h, $: C.$, _: I, DBG: g, FOO: 1 }), console.STAT && console.STAT(y, +/* @__PURE__ */ new Date() - y, "got in"), x && setTimeout.turn(R);
            }(), _ || C.on("in", { "@": m["#"] });
          }
          r.on.get.ack = p;
        }(), function() {
          r.chain.opt = function(p) {
            p = p || {};
            var m = this, _ = m._, y = p.peers || p;
            return Object.plain(p) || (p = {}), Object.plain(_.opt) || (_.opt = p), typeof y == "string" && (y = [y]), Object.plain(_.opt.peers) || (_.opt.peers = {}), y instanceof Array && (p.peers = {}, y.forEach(function(b) {
              var g = {};
              g.id = g.url = b, p.peers[b] = _.opt.peers[b] = _.opt.peers[b] || g;
            })), s(p, function b(g) {
              var v = this[g];
              if (this && this.hasOwnProperty(g) || typeof v == "string" || Object.empty(v)) {
                this[g] = v;
                return;
              }
              v && v.constructor !== Object && !(v instanceof Array) || s(v, b);
            }), _.opt.from = p, r.on("opt", _), _.opt.uuid = _.opt.uuid || function(g) {
              return r.state().toString(36).replace(".", "") + String.random(g || 12);
            }, m;
          };
        }();
        var s = function(p, m) {
          Object.keys(p).forEach(m, p);
        }, o = String.random, a = setTimeout.turn, u = r.valid, c = r.state.is, l = r.state.ify, h, f = {}, d;
        r.log = function() {
          return !r.log.off && d.log.apply(d, arguments), [].slice.call(arguments).join(" ");
        }, r.log.once = function(p, m, _) {
          return (_ = r.log.once)[p] = _[p] || 0, _[p]++ || r.log(m);
        }, typeof window < "u" && ((window.GUN = window.Gun = r).window = window);
        try {
          typeof n < "u" && (n.exports = r);
        } catch {
        }
        i.exports = r, (r.window || {}).console = (r.window || {}).console || { log: function() {
        } }, (d = console).only = function(p, m) {
          return d.only.i && p === d.only.i && d.only.i++ && (d.log.apply(d, arguments) || m);
        }, r.log.once("welcome", "Hello wonderful person! :) Thanks for using GUN, please ask for help on http://chat.gun.eco if anything takes you longer than 5min to figure out!");
      })(e, "./root"), e(function(i) {
        var r = e("./root");
        r.chain.back = function(a, u) {
          var c;
          if (a = a || 1, a === -1 || a === 1 / 0)
            return this._.root.$;
          if (a === 1)
            return (this._.back || this._).$;
          var l = this, h = l._;
          if (typeof a == "string" && (a = a.split(".")), a instanceof Array) {
            var f = 0, d = a.length, c = h;
            for (f; f < d; f++)
              c = (c || s)[a[f]];
            return o !== c ? u ? l : c : (c = h.back) ? c.$.back(a, u) : void 0;
          }
          if (typeof a == "function") {
            for (var p, c = { back: h }; (c = c.back) && o === (p = a(c, u)); )
              ;
            return p;
          }
          return typeof a == "number" ? (h.back || h).$.back(a - 1) : this;
        };
        var s = {}, o;
      })(e, "./back"), e(function(i) {
        var r = e("./root");
        r.chain.chain = function(b) {
          var g = this, v = g._, w = new (b || g).constructor(g), E = w._, A;
          return E.root = A = v.root, E.id = ++A.once, E.back = g._, E.on = r.on, E.on("in", r.on.in, E), E.on("out", r.on.out, E), w;
        };
        function s(b) {
          var g, v = this.as, w = v.back, E = v.root, A;
          if (b.$ || (b.$ = v.$), this.to.next(b), v.err) {
            v.on("in", { put: v.put = h, $: v.$ });
            return;
          }
          if (g = b.get) {
            if (E.pass && (E.pass[v.id] = v), v.lex && Object.keys(v.lex).forEach(function(C) {
              A[C] = v.lex[C];
            }, A = b.get = b.get || {}), g["#"] || v.soul) {
              if (g["#"] = g["#"] || v.soul, b["#"] || (b["#"] = f(9)), w = E.$.get(g["#"])._, g = g["."]) {
                if (p(w.put, g) && (A = w.ask && w.ask[g], (w.ask || (w.ask = {}))[g] = w.$.get(g)._, w.on("in", { get: g, put: { "#": w.soul, ".": g, ":": w.put[g], ">": _(E.graph[w.soul], g) } }), A))
                  return;
              } else {
                if (A = w.ask && w.ask[""], (w.ask || (w.ask = {}))[""] = w, h !== w.put && (w.on("in", w), A))
                  return;
                b.$ = w.$;
              }
              return E.ask(c, b), E.on("in", b);
            }
            if (g["."])
              return v.get ? (b = { get: { ".": v.get }, $: v.$ }, (w.ask || (w.ask = {}))[v.get] = b.$._, w.on("out", b)) : (b = { get: v.lex ? b.get : {}, $: v.$ }, w.on("out", b));
            if ((v.ask || (v.ask = {}))[""] = v, v.get)
              return g["."] = v.get, (w.ask || (w.ask = {}))[v.get] = b.$._, w.on("out", b);
          }
          return w.on("out", b);
        }
        r.on.out = s;
        function o(b, g) {
          g = g || this.as;
          var v = g.root, w = b.$ || (b.$ = g.$), E = (w || "")._ || l, A = b.put || "", C = A["#"], O = A["."], R = h !== A["="] ? A["="] : A[":"], P = A[">"] || -1 / 0, k;
          if (h !== b.put && (h === A["#"] || h === A["."] || h === A[":"] && h === A["="] || h === A[">"])) {
            if (!d(A)) {
              if (!(C = ((A || "")._ || "")["#"])) {
                console.log("chain not yet supported for", A, "...", b, g);
                return;
              }
              return w = g.root.$.get(C), setTimeout.each(Object.keys(A).sort(), function(S) {
                S == "_" || h === (P = _(A, S)) || g.on("in", { $: w, put: { "#": C, ".": S, "=": A[S], ">": P }, VIA: b });
              });
            }
            g.on("in", { $: E.back.$, put: { "#": C = E.back.soul, ".": O = E.has || E.get, "=": A, ">": _(E.back.put, O) }, via: b });
            return;
          }
          (b.seen || "")[g.id] || ((b.seen || (b.seen = function() {
          }))[g.id] = g, g !== E && (Object.keys(b).forEach(function(S) {
            A[S] = b[S];
          }, A = {}), A.get = g.get || A.get, !g.soul && !g.has ? A.$$$ = A.$$$ || g.$ : E.soul && (A.$ = g.$, A.$$ = A.$$ || E.$), b = A), u(b, g), (g.soul || b.$$) && P >= _(v.graph[C], O) && ((A = v.$.get(C)._).put = y(A.put, O, P, R, C)), !E.soul && P >= _(v.graph[C], O) && (k = (v.$.get(C)._.next || "")[O]) && (k.put = R, typeof (A = d(R)) == "string" && (k.put = v.$.get(A)._.put || R)), this.to && this.to.next(b), g.any && setTimeout.each(Object.keys(g.any), function(S) {
            (S = g.any[S]) && S(b);
          }, 0, 99), g.echo && setTimeout.each(Object.keys(g.echo), function(S) {
            (S = g.echo[S]) && S.on("in", b);
          }, 0, 99), ((b.$$ || "")._ || E).soul && (k = g.next) && (k = k[O]) && (A = {}, Object.keys(b).forEach(function(S) {
            A[S] = b[S];
          }), A.$ = (b.$$ || b.$).get(A.get = O), delete A.$$, delete A.$$$, k.on("in", A)), a(b, g));
        }
        r.on.in = o;
        function a(b, g) {
          if (g = g || this.as || b.$._, !(b.$$ && this !== r.on) && !(!b.put || g.soul)) {
            var v = b.put || "", w = v["="] || v[":"], O, E = g.root, A = E.$.get(v["#"]).get(v["."])._;
            if (typeof (w = d(w)) != "string") {
              this === r.on && ((A.echo || (A.echo = {}))[g.id] = g);
              return;
            }
            if (!((A.echo || (A.echo = {}))[g.id] && !(E.pass || "")[g.id])) {
              if (O = E.pass) {
                if (O[w + g.id])
                  return;
                O[w + g.id] = 1;
              }
              (A.echo || (A.echo = {}))[g.id] = g, g.has && (g.link = w);
              var C = E.$.get(A.link = w)._;
              (C.echo || (C.echo = {}))[A.id] = A;
              var O = g.ask || "";
              (O[""] || g.lex) && C.on("out", { get: { "#": w } }), setTimeout.each(Object.keys(O), function(R, P) {
                !R || !(P = O[R]) || P.on("out", { get: { "#": w, ".": R } });
              }, 0, 99);
            }
          }
        }
        r.on.link = a;
        function u(b, g) {
          var v = b.put || "", w = h !== v["="] ? v["="] : v[":"], E = g.root, A, C;
          if (h === w) {
            if (g.soul && h !== g.put || (C = (b.$$ || b.$ || "")._ || "", b["@"] && (h !== C.put || h !== g.put)))
              return;
            (A = g.link || b.linked) && delete (E.$.get(A)._.echo || "")[g.id], g.has && (g.link = null), g.put = h, setTimeout.each(Object.keys(g.next || ""), function(O, R) {
              (R = g.next[O]) && (A && delete (E.$.get(A).get(O)._.echo || "")[R.id], R.on("in", { get: O, put: h, $: R.$ }));
            }, 0, 99);
            return;
          }
          g.soul || b.$$ || (A = d(w), C = b.$._ || "", !((A === C.link || g.has && !C.link) && !((E.pass || "")[g.id] && typeof A != "string")) && (delete (C.echo || "")[g.id], u({ get: g.get, put: h, $: b.$, linked: b.linked = b.linked || C.link }, g)));
        }
        r.on.unlink = u;
        function c(b, g) {
          var v = this.as, w = v.$._;
          w.root;
          var E = v.get || "", A = (b.put || "")[E["#"]] || "";
          if (!b.put || typeof E["."] == "string" && h === A[E["."]]) {
            if (h !== w.put || !w.soul && !w.has)
              return;
            w.ack = (w.ack || 0) + 1, w.on("in", {
              get: w.get,
              put: w.put = h,
              $: w.$,
              "@": b["@"]
            });
            return;
          }
          (b._ || {}).miss = 1, r.on.put(b);
        }
        var l = {}, h, f = String.random, d = r.valid, p = function(b, g) {
          return b && Object.prototype.hasOwnProperty.call(b, g);
        }, m = r.state, _ = m.is, y = m.ify;
      })(e, "./chain"), e(function(i) {
        var r = e("./root");
        r.chain.get = function(h, f, d) {
          var p, m;
          if (typeof h == "string") {
            if (h.length == 0)
              return (p = this.chain())._.err = { err: r.log("0 length key!", h) }, f && f.call(p, p._.err), p;
            var _ = this, y = _._, b = y.next || u;
            (p = b[h]) || (p = h && s(h, _)), p = p && p.$;
          } else if (typeof h == "function") {
            let C = function(O, R, P) {
              if (!C.stun && !((T = v.pass) && !T[w])) {
                var k = O.$._, S = (O.$$ || "")._, x = (S || k).put, I = !k.has && !k.soul, F = {}, T;
                if ((I || l === x) && (x = l === ((T = O.put) || "")["="] ? l === (T || "")[":"] ? T : T[":"] : T["="]), typeof (T = r.valid(x)) == "string" && (x = l === (T = v.$.get(T)._.put) ? g.not ? l : x : T), !(g.not && l === x)) {
                  if (l === g.stun) {
                    if ((T = v.stun) && T.on && (y.$.back(function(L) {
                      if (T.on("" + L.id, F = {}), (F.run || 0) < C.id)
                        return F;
                    }), !F.run && T.on("" + k.id, F = {}), !F.run && S && T.on("" + S.id, F = {}), C.id > F.run && ((!F.stun || F.stun.end) && (F.stun = T.on("stun"), F.stun = F.stun && F.stun.last), F.stun && !F.stun.end))) {
                      (F.stun.add || (F.stun.add = {}))[w] = function() {
                        C(O, R, 1);
                      };
                      return;
                    }
                    if (
                      /*odd &&*/
                      l === x && (P = 0), (T = v.hatch) && !T.end && l === g.hatch && !P
                    ) {
                      if (E[k.$._.id])
                        return;
                      E[k.$._.id] = 1, T.push(function() {
                        C(O, R, 1);
                      });
                      return;
                    }
                    E = {};
                  }
                  if (v.pass) {
                    if (v.pass[w + k.id])
                      return;
                    v.pass[w + k.id] = 1;
                  }
                  if (g.on) {
                    g.ok.call(k.$, x, k.get, O, R || C);
                    return;
                  }
                  if (g.v2020) {
                    g.ok(O, R || C);
                    return;
                  }
                  Object.keys(O).forEach(function(L) {
                    T[L] = O[L];
                  }, T = {}), O = T, O.put = x, g.ok.call(g.as, O, R || C);
                }
              }
            };
            if (f === !0)
              return o(this, h, f, d), this;
            p = this;
            var y = p._, g = f || {}, v = y.root, w;
            g.at = y, g.ok = h;
            var E = {};
            return C.at = y, (y.any || (y.any = {}))[w = String.random(7)] = C, C.off = function() {
              C.stun = 1, y.any && delete y.any[w];
            }, C.rid = a, C.id = g.run || ++v.once, m = v.pass, (v.pass = {})[w] = 1, g.out = g.out || { get: {} }, y.on("out", g.out), v.pass = m, p;
          } else {
            if (typeof h == "number")
              return this.get("" + h, f, d);
            if (typeof (m = c(h)) == "string")
              return this.get(m, f, d);
            (m = this.get.next) && (p = m(this, h));
          }
          return p ? (f && typeof f == "function" && p.get(f, d), p) : ((p = this.chain())._.err = { err: r.log("Invalid get request!", h) }, f && f.call(p, p._.err), p);
        };
        function s(h, f) {
          var d = f._, p = d.next, m = f.chain(), _ = m._;
          return p || (p = d.next = {}), p[_.get = h] = _, f === d.root.$ ? _.soul = h : (d.soul || d.has) && (_.has = h), _;
        }
        function o(h, f, d, p) {
          var m = h._, _ = 0, y;
          return (y = m.soul || m.link) ? f(y, p, m) : m.jam ? m.jam.push([f, p]) : (m.jam = [[f, p]], h.get(function(g, v) {
            if (!(l === g.put && !m.root.opt.super && (y = Object.keys(m.root.opt.peers).length) && ++_ <= y)) {
              v.rid(g);
              var w = (w = g.$) && w._ || {}, E = 0, A;
              for (y = m.jam, delete m.jam; A = y[E++]; ) {
                var C = A[0];
                A = A[1], C && C(w.link || w.soul || r.valid(g.put) || ((g.put || {})._ || {})["#"], A, g, v);
              }
            }
          }, { out: { get: { ".": !0 } } }), h);
        }
        function a(h) {
          var f = this.at || this.on;
          if (!h || f.soul || f.has)
            return this.off();
          if (h = (h = (h = h.$ || h)._ || h).id) {
            f.map;
            var d;
            if ((d = this.seen || (this.seen = {}))[h])
              return !0;
            d[h] = !0;
          }
        }
        var u = {}, c = r.valid, l;
      })(e, "./get"), e(function(i) {
        var r = e("./root");
        r.chain.put = function(p, m, _) {
          var y = this, b = y._, g = b.root;
          _ = _ || {}, _.root = b.root, _.run || (_.run = g.once), s(_, b.id), _.ack = _.ack || m, _.via = _.via || y, _.data = _.data || p, _.soul || (_.soul = b.soul || typeof m == "string" && m);
          var v = _.state = _.state || r.state();
          return typeof p == "function" ? (p(function(w) {
            _.data = w, y.put(c, c, _);
          }), y) : _.soul ? (_.$ = g.$.get(_.soul), _.todo = [{ it: _.data, ref: _.$ }], _.turn = _.turn || h, _.ran = _.ran || o, function w() {
            var E = _.todo, A = E.pop(), C = A.it;
            A.ref && A.ref._.id;
            var O, R, P, k, S;
            if (s(_, A.ref), (k = A.todo) && (R = k.pop(), C = C[R], k.length && E.push(A)), R && (E.path || (E.path = [])).push(R), !(O = f(C)) && !(S = r.is(C))) {
              if (!Object.plain(C)) {
                o.err(_, "Invalid data: " + u(C) + " at " + (_.via.back(function(T) {
                  T.get && k.push(T.get);
                }, k = []) || k.join(".")) + "." + (E.path || []).join("."));
                return;
              }
              for (var x = _.seen || (_.seen = []), I = x.length; I--; )
                if (C === (k = x[I]).it) {
                  O = C = k.link;
                  break;
                }
            }
            if (R && O)
              A.node = d(A.node, R, v, C);
            else {
              let T = function(L, M) {
                var U = P.link["#"];
                M && (M.off(), M.rid(L));
                var $ = U || L.soul || (k = (L.$$ || L.$)._ || "").soul || k.link || ((k = k.put || "")._ || "")["#"] || k["#"] || ((k = L.put || "") && L.$$ ? k["#"] : (k["="] || k[":"] || "")["#"]);
                if (!U && s(_, L.$), !$ && !A.link["#"]) {
                  (A.wait || (A.wait = [])).push(function() {
                    T(L, M);
                  });
                  return;
                }
                $ || ($ = [], (L.$$ || L.$).back(function(z) {
                  if (k = z.soul || z.link)
                    return $.push(k);
                  $.push(z.get);
                }), $ = $.reverse().join("/")), P.link["#"] = $, !S && (((_.graph || (_.graph = {}))[$] = P.node || (P.node = { _: {} }))._["#"] = $), delete _.wait[F], P.wait && setTimeout.each(P.wait, function(z) {
                  z && z();
                }), _.ran(_);
              };
              if (!_.seen) {
                o.err(_, "Data at root of graph must be a node (an object).");
                return;
              }
              _.seen.push(P = { it: C, link: {}, todo: S ? [] : Object.keys(C).sort().reverse(), path: (E.path || []).slice(), up: A }), A.node = d(A.node, R, v, P.link), !S && P.todo.length && E.push(P);
              var F = _.seen.length;
              (_.wait || (_.wait = {}))[F] = "", k = (P.ref = S ? C : R ? A.ref.get(R) : A.ref)._, (k = C && (C._ || "")["#"] || k.soul || k.link) ? T({ soul: k }) : P.ref.get(T, {
                run: _.run,
                /*hatch: 0,*/
                v2020: 1,
                out: { get: { ".": " " } }
              });
            }
            if (!E.length)
              return _.ran(_);
            _.turn(w);
          }(), y) : (a(_), y);
        };
        function s(p, m) {
          if (m) {
            m = (m._ || "").id || m;
            var _ = p.root.stun || (p.root.stun = { on: r.on }), y = {}, b;
            p.stun || (p.stun = _.on("stun", function() {
            })), (b = _.on("" + m)) && b.the.last.next(y), !(y.run >= p.run) && _.on("" + m, function(g) {
              if (p.stun.end) {
                this.off(), this.to.next(g);
                return;
              }
              g.run = g.run || p.run, g.stun = g.stun || p.stun;
            });
          }
        }
        function o(p) {
          if (p.err) {
            o.end(p.stun, p.root);
            return;
          }
          if (!(p.todo.length || p.end || !Object.empty(p.wait))) {
            p.end = 1;
            var m = p.$.back(-1)._, _ = m.root, y = m.ask(function(w) {
              _.on("ack", w), w.err && !w.lack && r.log(w), ++b > (p.acks || 0) && this.off(), p.ack && p.ack(w, this);
            }, p.opt), b = 0, g = p.stun, v;
            (v = function() {
              g && (o.end(g, _), setTimeout.each(Object.keys(g = g.add || ""), function(w) {
                (w = g[w]) && w();
              }));
            }).hatch = v, p.ack && !p.ok && (p.ok = p.acks || 9), p.via._.on("out", { put: p.out = p.graph, ok: p.ok && { "@": p.ok + 1 }, opt: p.opt, "#": y, _: v });
          }
        }
        o.end = function(p, m) {
          p.end = l, p.the.to === p && p === p.the.last && delete m.stun, p.off();
        }, o.err = function(p, m) {
          (p.ack || l).call(p, p.out = { err: p.err = r.log(m) }), p.ran(p);
        };
        function a(p) {
          var m = p.via._, _;
          p.via = p.via.back(function(y) {
            if (y.soul || !y.get)
              return y.$;
            _ = p.data, (p.data = {})[y.get] = _;
          }), (!p.via || !p.via._.soul) && (p.via = m.root.$.get(((p.data || "")._ || "")["#"] || m.$.back("opt.uuid")())), p.via.put(p.data, p.ack, p);
        }
        function u(p, m) {
          return p && (m = p.constructor) && m.name || typeof p;
        }
        var c, l = function() {
        }, h = setTimeout.turn, f = r.valid, d = r.state.ify;
      })(e, "./put"), e(function(i) {
        var r = e("./root");
        e("./chain"), e("./back"), e("./put"), e("./get"), i.exports = r;
      })(e, "./index"), e(function(i) {
        var r = e("./index");
        r.chain.on = function(a, u, c, l) {
          var h = this, f = h._;
          f.root;
          var d;
          if (typeof a == "string")
            return u ? (d = f.on(a, u, c || f, l), c && c.$ && (c.subs || (c.subs = [])).push(d), h) : f.on(a);
          var p = u;
          return (p = p === !0 ? { change: !0 } : p || {}).not = 1, p.on = 1, h.get(a, p), h;
        }, r.chain.once = function(a, u) {
          if (u = u || {}, !a)
            return s(this);
          var c = this, l = c._, h = l.root;
          l.put;
          var f = String.random(7), d;
          return c.get(function(p, m, _, y) {
            var b = this, g = b._, v = g.one || (g.one = {});
            if (y.stun || v[f] === "")
              return;
            if ((d = r.valid(p)) === !0) {
              w();
              return;
            }
            if (typeof d == "string")
              return;
            clearTimeout((l.one || "")[f]), clearTimeout(v[f]), v[f] = setTimeout(w, u.wait || 99);
            function w(E) {
              if (!g.has && !g.soul && (g = { put: p, get: m }), o === (d = g.put) && (d = ((_.$$ || "")._ || "").put), typeof r.valid(d) == "string" && (d = h.$.get(d)._.put, d === o && !E)) {
                v[f] = setTimeout(function() {
                  w(1);
                }, u.wait || 99);
                return;
              }
              y.stun || v[f] !== "" && (v[f] = "", (l.soul || l.has) && y.off(), a.call(b, d, g.get), clearTimeout(v[f]));
            }
          }, { on: 1 }), c;
        };
        function s(a, u, c) {
          return r.log.once("valonce", "Chainable val is experimental, its behavior and API may change moving forward. Please play with it and report bugs and ideas on how to improve it."), (c = a.chain())._.nix = a.once(function(l, h) {
            c._.on("in", this._);
          }), c._.lex = a._.lex, c;
        }
        r.chain.off = function() {
          var a = this, u = a._, c, l = u.back;
          if (l)
            return u.ack = 0, (c = l.next) && c[u.get] && delete c[u.get], (c = l.any) && (delete l.any, l.any = {}), (c = l.ask) && delete c[u.get], (c = l.put) && delete c[u.get], (c = u.soul) && delete l.root.graph[c], (c = u.map) && Object.keys(c).forEach(function(h, f) {
              f = c[h], f.link && l.root.$.get(f.link).off();
            }), (c = u.next) && Object.keys(c).forEach(function(h, f) {
              f = c[h], f.$.off();
            }), u.on("off", {}), a;
        };
        var o;
      })(e, "./on"), e(function(i) {
        var r = e("./index"), s = r.chain.get.next;
        r.chain.get.next = function(c, l) {
          var h;
          return Object.plain(l) ? (h = ((h = l["#"]) || "")["="] || h) ? c.get(h) : ((h = c.chain()._).lex = l, c.on("in", function(f) {
            String.match(f.get || (f.put || "")["."], l["."] || l["#"] || l) && h.on("in", f), this.to.next(f);
          }), h.$) : (s || a)(c, l);
        }, r.chain.map = function(c, l, h) {
          var f = this, d = f._, p, m;
          return Object.plain(c) && (p = c["."] ? c : { ".": c }, c = u), c ? (r.log.once("mapfn", "Map functions are experimental, their behavior and API may change moving forward. Please play with it and report bugs and ideas on how to improve it."), m = f.chain(), f.map().on(function(_, y, b, g) {
            var v = (c || a).call(this, _, y, b, g);
            if (u !== v) {
              if (_ === v)
                return m._.on("in", b);
              if (r.is(v))
                return m._.on("in", v._);
              var w = {};
              Object.keys(b.put).forEach(function(E) {
                w[E] = b.put[E];
              }, w), w["="] = v, m._.on("in", { get: y, put: w });
            }
          }), m) : ((m = d.each) || ((d.each = m = f.chain())._.lex = p || m._.lex || d.lex, m._.nix = f.back("nix"), f.on("in", o, m._)), m);
        };
        function o(c) {
          this.to.next(c);
          var l = this.as, h = c.$, f = h._, d = c.put, p;
          !f.soul && !c.$$ || (p = l.lex) && !String.match(c.get || (d || "")["."], p["."] || p["#"] || p) || r.on.link(c, l);
        }
        var a = function() {
        }, u;
      })(e, "./map"), e(function(i) {
        var r = e("./index");
        r.chain.set = function(s, o, a) {
          var u = this, c = u.back(-1), l, h;
          return o = o || function() {
          }, a = a || {}, a.item = a.item || s, (l = ((s || "")._ || "")["#"]) && ((s = {})["#"] = l), typeof (h = r.valid(s)) == "string" ? u.get(l = h).put(s, o, a) : r.is(s) ? (u.put(function(f) {
            s.get(function(d, p, m) {
              if (!d)
                return o.call(u, { err: r.log('Only a node can be linked! Not "' + m.put + '"!') });
              (h = {})[d] = { "#": d }, f(h);
            }, !0);
          }), s) : (Object.plain(s) && (s = c.get(l = u.back("opt.uuid")()).put(s)), u.get(l || c.back("opt.uuid")(7)).put(s, o, a));
        };
      })(e, "./set"), e(function(i) {
        e("./shim");
        var r = function() {
        }, s = JSON.parseAsync || function(c, l, h) {
          var f, d = +/* @__PURE__ */ new Date();
          try {
            l(f, JSON.parse(c, h), o.sucks(+/* @__PURE__ */ new Date() - d));
          } catch (p) {
            l(p);
          }
        }, o = JSON.stringifyAsync || function(c, l, h, f) {
          var d, p = +/* @__PURE__ */ new Date();
          try {
            l(d, JSON.stringify(c, h, f), o.sucks(+/* @__PURE__ */ new Date() - p));
          } catch (m) {
            l(m);
          }
        };
        o.sucks = function(c) {
          c > 99 && (console.log("Warning: JSON blocking CPU detected. Add `gun/lib/yson.js` to fix."), o.sucks = r);
        };
        function a(c) {
          var l = function() {
          }, h = c.opt || {};
          h.log = h.log || console.log, h.gap = h.gap || h.wait || 0, h.max = h.max || (h.memory ? h.memory * 999 * 999 : 3e8) * 0.3, h.pack = h.pack || h.max * 0.01 * 0.01, h.puff = h.puff || 9;
          var f = setTimeout.turn || setTimeout, d = c.dup, p = d.check, m = d.track, _ = l.hear = function(g, v) {
            if (g) {
              if (h.max <= g.length)
                return l.say({ dam: "!", err: "Message too big!" }, v);
              l === this && (_.d += g.length || 0, ++_.c);
              var w = v.SH = +/* @__PURE__ */ new Date(), E = g[0], A;
              if (E === "[") {
                s(g, function(C, O) {
                  if (C || !O)
                    return l.say({ dam: "!", err: "DAM JSON parse error." }, v);
                  console.STAT && console.STAT(+/* @__PURE__ */ new Date(), O.length, "# on hear batch");
                  var R = h.puff;
                  (function P() {
                    for (var k = +/* @__PURE__ */ new Date(), S = 0, x; S < R && (x = O[S++]); )
                      l.hear(x, v);
                    O = O.slice(S), console.STAT && console.STAT(k, +/* @__PURE__ */ new Date() - k, "hear loop"), y(v), O.length && f(P, 0);
                  })();
                }), g = "";
                return;
              }
              if (E === "{" || (g["#"] || Object.plain(g)) && (A = g)) {
                if (A)
                  return _.one(A, v, w);
                s(g, function(C, O) {
                  if (C || !O)
                    return l.say({ dam: "!", err: "DAM JSON parse error." }, v);
                  _.one(O, v, w);
                });
                return;
              }
            }
          };
          _.one = function(g, v, P) {
            var E, A, C, O, R;
            if (g.DBG && (g.DBG = R = { DBG: g.DBG }), R && (R.h = P), R && (R.hp = +/* @__PURE__ */ new Date()), (E = g["#"]) || (E = g["#"] = String.random(9)), !(C = p(E)) && (A = g["##"], !(A && (C = g["@"] || g.get && E) && d.check(O = C + A)))) {
              if ((g._ = function() {
              }).via = l.leap = v, (C = g["><"]) && typeof C == "string" && C.slice(0, 99).split(",").forEach(function(k) {
                this[k] = 1;
              }, g._.yo = {}), C = g.dam) {
                (C = l.hear[C]) && C(g, v, c), m(E);
                return;
              }
              (C = g.ok) && (g._.near = C["/"]);
              var P = +/* @__PURE__ */ new Date();
              R && (R.is = P), v.SI = E, m.ed = function(k) {
                E === k && (m.ed = 0, (k = d.s[E]) && (k.via = v, g.get && (k.it = g)));
              }, c.on("in", l.last = g), R && (R.hd = +/* @__PURE__ */ new Date()), console.STAT && console.STAT(P, +/* @__PURE__ */ new Date() - P, g.get ? "msg get" : g.put ? "msg put" : "msg"), m(E), O && m(O), l.leap = l.last = null;
            }
          }, _.c = _.d = 0, function() {
            var g = 0, v;
            l.hash = function(A, C) {
              var O, R, P, k = +/* @__PURE__ */ new Date();
              o(A.put, function S(x, I) {
                var F = (R || (R = P = I || "")).slice(0, 32768);
                if (O = String.hash(F, O), R = R.slice(32768), R) {
                  f(S, 0);
                  return;
                }
                console.STAT && console.STAT(k, +/* @__PURE__ */ new Date() - k, "say json+hash"), A._.$put = P, A["##"] = O, l.say(A, C), delete A._.$put;
              }, w);
            };
            function w(A, C) {
              var O;
              return C instanceof Object ? (Object.keys(C).sort().forEach(E, { to: O = {}, on: C }), O) : C;
            }
            function E(A) {
              this.to[A] = this.on[A];
            }
            l.say = function(A, C) {
              var O;
              if ((O = this) && (O = O.to) && O.next && O.next(A), !A)
                return !1;
              var R, P, k, S = A["@"], x = A._ || (A._ = function() {
              }), I = A.DBG, F = +/* @__PURE__ */ new Date();
              if (x.y = x.y || F, C || I && (I.y = F), (R = A["#"]) || (R = A["#"] = String.random(9)), !v && m(R), !(P = A["##"]) && u !== A.put && !x.via && S) {
                l.hash(A, C);
                return;
              }
              if (!C && S && (C = (O = d.s[S]) && (O.via || (O = O.it) && (O = O._) && O.via) || (O = l.last) && S === O["#"] && l.leap), !C && S)
                return d.s[S] ? void 0 : (console.STAT && console.STAT(+/* @__PURE__ */ new Date(), ++g, "total no peer to ack to"), !1);
              if (S && !A.put && !P && ((d.s[S] || "").it || "")["##"])
                return !1;
              if (!C && l.way)
                return l.way(A);
              if (I && (I.yh = +/* @__PURE__ */ new Date()), !(k = x.raw)) {
                l.raw(A, C);
                return;
              }
              if (I && (I.yr = +/* @__PURE__ */ new Date()), !C || !C.id) {
                if (!Object.plain(C || h.peers))
                  return !1;
                var F = +/* @__PURE__ */ new Date();
                h.puff;
                var T = h.peers, L = Object.keys(C || h.peers || {});
                console.STAT && console.STAT(F, +/* @__PURE__ */ new Date() - F, "peer keys"), function $() {
                  var z = +/* @__PURE__ */ new Date();
                  v = 1;
                  var X = x.raw;
                  x.raw = k;
                  for (var J = 0, K; J < 9 && (K = (L || "")[J++]); )
                    (K = T[K] || (C || "")[K]) && l.say(A, K);
                  x.raw = X, v = 0, L = L.slice(J), console.STAT && console.STAT(z, +/* @__PURE__ */ new Date() - z, "say loop"), L.length && (f($, 0), S && m(S));
                }();
                return;
              }
              if (!C.wire && l.wire && l.wire(C), R !== C.last) {
                if (C.last = R, C === x.via || (O = x.yo) && (O[C.url] || O[C.pid] || O[C.id]))
                  return !1;
                if (console.STAT && console.STAT(F, ((I || x).yp = +/* @__PURE__ */ new Date()) - (x.y || F), "say prep"), !v && S && m(S), C.batch) {
                  if (C.tail = (O = C.tail || 0) + k.length, C.tail <= h.pack) {
                    C.batch += (O ? "," : "") + k;
                    return;
                  }
                  y(C);
                }
                C.batch = "[";
                var M = +/* @__PURE__ */ new Date();
                setTimeout(function() {
                  console.STAT && console.STAT(M, +/* @__PURE__ */ new Date() - M, "0ms TO"), y(C);
                }, h.gap), b(k, C), console.STAT && S === C.SI && console.STAT(F, +/* @__PURE__ */ new Date() - C.SH, "say ack");
              }
            }, l.say.c = l.say.d = 0, l.raw = function(A, C) {
              if (!A)
                return "";
              var O = A._ || {}, R, P;
              if (P = O.raw)
                return P;
              if (typeof A == "string")
                return A;
              var k = A["##"], S = A["@"];
              if (k && S) {
                if (!O.via && p(S + k))
                  return !1;
                if (P = (d.s[S] || "").it) {
                  if (k === P["##"])
                    return !1;
                  P["##"] || (P["##"] = k);
                }
              }
              if (!A.dam && !A["@"]) {
                var x = 0, I = [];
                P = h.peers;
                for (var F in P) {
                  var T = P[F];
                  if (I.push(T.url || T.pid || T.id), ++x > 6)
                    break;
                }
                x > 1 && (A["><"] = I.join());
              }
              if (A.put && (P = A.ok) && (A.ok = { "@": (P["@"] || 1) - 1, "/": P["/"] == A._.near ? l.near : P["/"] }), R = O.$put) {
                P = {}, Object.keys(A).forEach(function(M) {
                  P[M] = A[M];
                }), P.put = ":])([:", o(P, function(M, U) {
                  if (!M) {
                    var $ = +/* @__PURE__ */ new Date();
                    P = U.indexOf('"put":":])([:"'), L(u, U = U.slice(0, P + 6) + R + U.slice(P + 14)), console.STAT && console.STAT($, +/* @__PURE__ */ new Date() - $, "say slice");
                  }
                });
                return;
              }
              o(A, L);
              function L(M, U) {
                M || (O.raw = U, l.say(A, C));
              }
            };
          }();
          function y(g) {
            var v = g.batch, w = typeof v == "string";
            if (w && (v += "]"), g.batch = g.tail = null, !!v && !(w ? 3 > v.length : !v.length)) {
              if (!w)
                try {
                  v = v.length === 1 ? v[0] : JSON.stringify(v);
                } catch (E) {
                  return h.log("DAM JSON stringify error", E);
                }
              v && b(v, g);
            }
          }
          function b(g, v) {
            try {
              var w = v.wire;
              v.say ? v.say(g) : w.send && w.send(g), l.say.d += g.length || 0, ++l.say.c;
            } catch {
              (v.queue = v.queue || []).push(g);
            }
          }
          return l.near = 0, l.hi = function(g) {
            var v = g.wire, w;
            if (!v) {
              l.wire(g.length && { url: g, id: g } || g);
              return;
            }
            g.id ? h.peers[g.url || g.id] = g : (w = g.id = g.id || g.url || String.random(9), l.say({ dam: "?", pid: c.opt.pid }, h.peers[w] = g), delete d.s[g.last]), g.met || (l.near++, g.met = +/* @__PURE__ */ new Date(), c.on("hi", g)), w = g.queue, g.queue = [], setTimeout.each(w || [], function(E) {
              b(E, g);
            }, 0, 9);
          }, l.bye = function(g) {
            g.met && --l.near, delete g.met, c.on("bye", g);
            var v = +/* @__PURE__ */ new Date();
            v = v - (g.met || v), l.bye.time = ((l.bye.time || v) + v) / 2;
          }, l.hear["!"] = function(g, v) {
            h.log("Error:", g.err);
          }, l.hear["?"] = function(g, v) {
            g.pid && (v.pid || (v.pid = g.pid), g["@"]) || (l.say({ dam: "?", pid: h.pid, "@": g["#"] }, v), delete d.s[v.last]);
          }, l.hear.mob = function(g, v) {
            if (g.peers) {
              var w = Object.keys(g.peers), E = w[Math.random() * w.length >> 0];
              E && (l.bye(v), l.hi(E));
            }
          }, c.on("create", function(g) {
            g.opt.pid = g.opt.pid || String.random(9), this.to.next(g), g.on("out", l.say);
          }), c.on("bye", function(g, v) {
            g = h.peers[g.id || g] || g, this.to.next(g), g.bye ? g.bye() : (v = g.wire) && v.close && v.close(), delete h.peers[g.id], g.wire = null;
          }), c.on("bye", function(g, v) {
            this.to.next(g), (v = console.STAT) && (v.peers = l.near), (v = g.url) && setTimeout(function() {
            }, h.lack || 9e3);
          }), c.on("hi", function(g, v) {
            if (this.to.next(g), (v = console.STAT) && (v.peers = l.near), !h.super) {
              var w = Object.keys(c.next || "");
              w.length > 9999 && !console.SUBS && console.log(console.SUBS = "Warning: You have more than 10K live GETs, which might use more bandwidth than your screen can show - consider `.off()`."), setTimeout.each(w, function(E) {
                var A = c.next[E];
                if (h.super || (A.ask || "")[""]) {
                  l.say({ get: { "#": E } }, g);
                  return;
                }
                setTimeout.each(Object.keys(A.ask || ""), function(C) {
                  C && l.say({ "##": String.hash((c.graph[E] || "")[C]), get: { "#": E, ".": C } }, g);
                });
              });
            }
          }), l;
        }
        var u;
        try {
          i.exports = a;
        } catch {
        }
      })(e, "./mesh"), e(function(i) {
        var r = e("./index");
        r.Mesh = e("./mesh"), r.on("opt", function(o) {
          if (this.to.next(o), o.once)
            return;
          var a = o.opt;
          if (a.WebSocket === !1)
            return;
          var u = r.window || {}, c = a.WebSocket || u.WebSocket || u.webkitWebSocket || u.mozWebSocket;
          if (!c)
            return;
          a.WebSocket = c;
          var l = a.mesh = a.mesh || r.Mesh(o);
          l.wire || a.wire, l.wire = a.wire = h;
          function h(m) {
            try {
              if (!m || !m.url)
                return y && y(m);
              var _ = m.url.replace(/^http/, "ws"), y = m.wire = new a.WebSocket(_);
              return y.onclose = function() {
                d(m), a.mesh.bye(m);
              }, y.onerror = function(b) {
                d(m);
              }, y.onopen = function() {
                a.mesh.hi(m);
              }, y.onmessage = function(b) {
                b && a.mesh.hear(b.data || b, m);
              }, y;
            } catch {
              a.mesh.bye(m);
            }
          }
          setTimeout(function() {
            !a.super && o.on("out", { dam: "hi" });
          }, 1);
          var f = 2 * 999;
          function d(m) {
            clearTimeout(m.defer), a.peers[m.url] && (p && m.retry <= 0 || (m.retry = (m.retry || a.retry + 1 || 60) - (-m.tried + (m.tried = +/* @__PURE__ */ new Date()) < f * 4 ? 1 : 0), m.defer = setTimeout(function _() {
              if (p && p.hidden)
                return setTimeout(_, f);
              h(m);
            }, f)));
          }
          var p = "" + s != typeof document && document;
        });
        var s;
      })(e, "./websocket"), e(function(i) {
        if (!(typeof Gun > "u")) {
          var r = function() {
          }, s;
          try {
            s = (Gun.window || r).localStorage;
          } catch {
          }
          s || (Gun.log("Warning: No localStorage exists to persist data to!"), s = { setItem: function(a, u) {
            this[a] = u;
          }, removeItem: function(a) {
            delete this[a];
          }, getItem: function(a) {
            return this[a];
          } });
          var o = JSON.stringifyAsync || function(a, u, c, l) {
            var h;
            try {
              u(h, JSON.stringify(a, c, l));
            } catch (f) {
              u(f);
            }
          };
          Gun.on("create", function a(u) {
            this.to.next(u);
            var c = u.opt;
            u.graph;
            var l = [], h, f, d, p;
            if (c.localStorage === !1)
              return;
            c.prefix = c.file || "gun/";
            try {
              h = a[c.prefix] = a[c.prefix] || JSON.parse(d = s.getItem(c.prefix)) || {};
            } catch {
              h = a[c.prefix] = {};
            }
            d = (d || "").length, u.on("get", function(_) {
              this.to.next(_);
              var y = _.get, b, g, v, w;
              !y || !(b = y["#"]) || (g = h[b] || w, g && (v = y["."]) && !Object.plain(v) && (g = Gun.state.ify({}, v, Gun.state.is(g, v), g[v], b)), Gun.on.get.ack(_, g));
            }), u.on("put", function(_) {
              this.to.next(_);
              var y = _.put, b = y["#"], g = y["."], v = _["#"], w = _.ok || "";
              if (h[b] = Gun.state.ify(h[b], g, y[">"], y[":"], b), p && d > 4999880) {
                u.on("in", { "@": v, err: "localStorage max!" });
                return;
              }
              !_["@"] && (!_._.via || Math.random() < w["@"] / w["/"]) && l.push(v), !f && (f = setTimeout(m, 9 + d / 333));
            });
            function m() {
              if (!l.length && ((setTimeout.turn || "").s || "").length) {
                setTimeout(m, 99);
                return;
              }
              var _ = l;
              clearTimeout(f), f = !1, l = [], o(h, function(y, b) {
                try {
                  !y && s.setItem(c.prefix, b);
                } catch (g) {
                  y = p = g || "localStorage failure";
                }
                y && (Gun.log(y + " Consider using GUN's IndexedDB plugin for RAD for more storage space, https://gun.eco/docs/RAD#install"), u.on("localStorage:error", { err: y, get: c.prefix, put: h })), d = b.length, setTimeout.each(_, function(g) {
                  u.on("in", { "@": g, err: y, ok: 0 });
                }, 0, 99);
              });
            }
          });
        }
      })(e, "./localStorage");
    })(), function() {
      var P;
      if ("" + P != typeof Gun) {
        var e = function(k) {
          console.warn("Warning! Deprecated internal utility will break in next version:", k);
        }, n = Gun;
        n.fn = n.fn || { is: function(k) {
          return e("fn"), !!k && typeof k == "function";
        } }, n.bi = n.bi || { is: function(k) {
          return e("bi"), k instanceof Boolean || typeof k == "boolean";
        } }, n.num = n.num || { is: function(k) {
          return e("num"), !i(k) && (k - parseFloat(k) + 1 >= 0 || k === 1 / 0 || k === -1 / 0);
        } }, n.text = n.text || { is: function(k) {
          return e("text"), typeof k == "string";
        } }, n.text.ify = n.text.ify || function(k) {
          return e("text.ify"), n.text.is(k) ? k : typeof JSON < "u" ? JSON.stringify(k) : k && k.toString ? k.toString() : k;
        }, n.text.random = n.text.random || function(k, S) {
          e("text.random");
          var x = "";
          for (k = k || 24, S = S || "0123456789ABCDEFGHIJKLMNOPQRSTUVWXZabcdefghijklmnopqrstuvwxyz"; k > 0; )
            x += S.charAt(Math.floor(Math.random() * S.length)), k--;
          return x;
        }, n.text.match = n.text.match || function(k, S) {
          var x, I;
          return e("text.match"), typeof k != "string" ? !1 : (typeof S == "string" && (S = { "=": S }), S = S || {}, x = S["="] || S["*"] || S[">"] || S["<"], k === x ? !0 : I !== S["="] ? !1 : (x = S["*"] || S[">"] || S["<"], k.slice(0, (x || "").length) === x ? !0 : I !== S["*"] ? !1 : I !== S[">"] && I !== S["<"] ? k >= S[">"] && k <= S["<"] : I !== S[">"] && k >= S[">"] || I !== S["<"] && k <= S["<"]));
        }, n.text.hash = n.text.hash || function(k, S) {
          if (e("text.hash"), typeof k == "string") {
            if (S = S || 0, !k.length)
              return S;
            for (var x = 0, I = k.length, F; x < I; ++x)
              F = k.charCodeAt(x), S = (S << 5) - S + F, S |= 0;
            return S;
          }
        }, n.list = n.list || { is: function(k) {
          return e("list"), k instanceof Array;
        } }, n.list.slit = n.list.slit || Array.prototype.slice, n.list.sort = n.list.sort || function(k) {
          return e("list.sort"), function(S, x) {
            return !S || !x ? 0 : (S = S[k], x = x[k], S < x ? -1 : S > x ? 1 : 0);
          };
        }, n.list.map = n.list.map || function(k, S, x) {
          return e("list.map"), O(k, S, x);
        }, n.list.index = 1, n.obj = n.boj || { is: function(k) {
          return e("obj"), k ? k instanceof Object && k.constructor === Object || Object.prototype.toString.call(k).match(/^\[object (\w+)\]$/)[1] === "Object" : !1;
        } }, n.obj.put = n.obj.put || function(k, S, x) {
          return e("obj.put"), (k || {})[S] = x, k;
        }, n.obj.has = n.obj.has || function(k, S) {
          return e("obj.has"), k && Object.prototype.hasOwnProperty.call(k, S);
        }, n.obj.del = n.obj.del || function(k, S) {
          if (e("obj.del"), !!k)
            return k[S] = null, delete k[S], k;
        }, n.obj.as = n.obj.as || function(k, S, x, I) {
          return e("obj.as"), k[S] = k[S] || (I === x ? {} : x);
        }, n.obj.ify = n.obj.ify || function(k) {
          if (e("obj.ify"), v(k))
            return k;
          try {
            k = JSON.parse(k);
          } catch {
            k = {};
          }
          return k;
        }, function() {
          var k;
          function S(x, I) {
            E(this, I) && k !== this[I] || (this[I] = x);
          }
          n.obj.to = n.obj.to || function(x, I) {
            return e("obj.to"), I = I || {}, O(x, S, I), I;
          };
        }(), n.obj.copy = n.obj.copy || function(k) {
          return e("obj.copy"), k && JSON.parse(JSON.stringify(k));
        }, function() {
          function k(S, x) {
            var I = this.n, F;
            if (!(I && (x === I || v(I) && E(I, x))) && F !== x)
              return !0;
          }
          n.obj.empty = n.obj.empty || function(S, x) {
            return e("obj.empty"), S ? !O(S, k, { n: x }) : !0;
          };
        }(), function() {
          function k(I, F) {
            if (arguments.length === 2) {
              k.r = k.r || {}, k.r[I] = F;
              return;
            }
            k.r = k.r || [], k.r.push(I);
          }
          var S = Object.keys, x;
          Object.keys = Object.keys || function(I) {
            return x(I, function(F, T, L) {
              L(T);
            });
          }, n.obj.map = x = n.obj.map || function(I, F, T) {
            e("obj.map");
            var L, M = 0, U, $, z, X, J = typeof F == "function";
            if (k.r = L, S && v(I) && (z = S(I), X = !0), T = T || {}, i(I) || z)
              for (U = (z || I).length; M < U; M++) {
                var K = M + n.list.index;
                if (J) {
                  if ($ = X ? F.call(T, I[z[M]], z[M], k) : F.call(T, I[M], K, k), $ !== L)
                    return $;
                } else if (F === I[X ? z[M] : M])
                  return z ? z[M] : K;
              }
            else
              for (M in I)
                if (J) {
                  if (E(I, M) && ($ = T ? F.call(T, I[M], M, k) : F(I[M], M, k), $ !== L))
                    return $;
                } else if (F === I[M])
                  return M;
            return J ? k.r : n.list.index ? 0 : -1;
          };
        }(), n.time = n.time || {}, n.time.is = n.time.is || function(k) {
          return e("time"), k ? k instanceof Date : +(/* @__PURE__ */ new Date()).getTime();
        };
        var b = n.fn.is, i = n.list.is, g = n.obj, v = g.is, E = g.has, O = g.map, r = {};
        r.is = function(k) {
          return e("val.is"), k === P ? !1 : k === null ? !0 : k === 1 / 0 ? !1 : a(k) || o(k) || p(k) ? !0 : r.link.is(k) || !1;
        }, r.link = r.rel = { _: "#" }, function() {
          r.link.is = function(S) {
            if (e("val.link.is"), S && S[s] && !S._ && v(S)) {
              var x = {};
              if (O(S, k, x), x.id)
                return x.id;
            }
            return !1;
          };
          function k(S, x) {
            var I = this;
            if (I.id)
              return I.id = !1;
            if (x == s && a(S))
              I.id = S;
            else
              return I.id = !1;
          }
        }(), r.link.ify = function(k) {
          return e("val.link.ify"), C({}, s, k);
        }, n.obj.has._ = ".";
        var s = r.link._, P, o = n.bi.is, p = n.num.is, a = n.text.is, g = n.obj, v = g.is, C = g.put, O = g.map;
        n.val = n.val || r;
        var u = { _: "_" };
        u.soul = function(k, S) {
          return e("node.soul"), k && k._ && k._[S || h];
        }, u.soul.ify = function(k, S) {
          return e("node.soul.ify"), S = typeof S == "string" ? { soul: S } : S || {}, k = k || {}, k._ = k._ || {}, k._[h] = S.soul || k._[h] || l(), k;
        }, u.soul._ = r.link._, function() {
          u.is = function(S, x, I) {
            e("node.is");
            var F;
            return v(S) && (F = u.soul(S)) ? !O(S, k, { as: I, cb: x, s: F, n: S }) : !1;
          };
          function k(S, x) {
            if (x !== u._) {
              if (!r.is(S))
                return !0;
              this.cb && this.cb.call(this.as, S, x, this.n, this.s);
            }
          }
        }(), function() {
          u.ify = function(S, x, I) {
            return e("node.ify"), x ? typeof x == "string" ? x = { soul: x } : typeof x == "function" && (x = { map: x }) : x = {}, x.map && (x.node = x.map.call(I, S, P, x.node || {})), (x.node = u.soul.ify(x.node || {}, x)) && O(S, k, { o: x, as: I }), x.node;
          };
          function k(S, x) {
            var I = this.o, F, T;
            if (I.map) {
              F = I.map.call(this.as, S, "" + x, I.node), T === F ? w(I.node, x) : I.node && (I.node[x] = F);
              return;
            }
            r.is(S) && (I.node[x] = S);
          }
        }();
        var g = n.obj, v = g.is, w = g.del, O = g.map, c = n.text, l = c.random, h = u.soul._, P;
        n.node = n.node || u;
        var f = n.state;
        f.lex = function() {
          return e("state.lex"), f().toString(36).replace(".", "");
        }, f.to = function(k, S, x) {
          e("state.to");
          var I = (k || {})[S];
          return v(I) && (I = R(I)), f.ify(x, S, f.is(k, S), I, u.soul(k));
        }, function() {
          f.map = function(S, x, I) {
            e("state.map");
            var F, T = v(T = S || x) ? T : null;
            return S = b(S = S || x) ? S : null, T && !S ? (x = p(x) ? x : f(), T[_] = T[_] || {}, O(T, k, { o: T, s: x }), T) : (I = I || v(x) ? x : F, x = p(x) ? x : f(), function(L, M, U, $) {
              if (!S)
                return k.call({ o: U, s: x }, L, M), L;
              S.call(I || this || {}, L, M, U, $), !(E(U, M) && F === U[M]) && k.call({ o: U, s: x }, L, M);
            });
          };
          function k(S, x) {
            _ !== x && f.ify(this.o, x, this.s);
          }
        }();
        var g = n.obj;
        g.as;
        var E = g.has, v = g.is, O = g.map, R = g.copy, d = n.num, p = d.is, m = n.fn, b = m.is, _ = u._, P, y = {};
        (function() {
          y.is = function(x, I, F, T) {
            return e("graph.is"), !x || !v(x) || A(x) ? !1 : !O(x, k, { cb: I, fn: F, as: T });
          };
          function k(x, I) {
            if (!x || I !== u.soul(x) || !u.is(x, this.fn, this.as))
              return !0;
            this.cb && (S.n = x, S.as = this.as, this.cb.call(S.as, x, I, S));
          }
          function S(x) {
            x && u.is(S.n, x, S.as);
          }
        })(), function() {
          y.ify = function(T, L, M) {
            e("graph.ify");
            var U = { path: [], obj: T };
            return L ? typeof L == "string" ? L = { soul: L } : typeof L == "function" && (L.map = L) : L = {}, typeof M == "string" && (L.soul = L.soul || M, M = P), L.soul && (U.link = r.link.ify(L.soul)), L.shell = (M || {}).shell, L.graph = L.graph || {}, L.seen = L.seen || [], L.as = L.as || M, k(L, U), L.root = U.node, L.graph;
          };
          function k(T, L) {
            var M;
            return (M = F(T, L)) ? M : (L.env = T, L.soul = x, u.ify(L.obj, S, L) && (L.link = L.link || r.link.ify(u.soul(L.node)), L.obj !== T.shell && (T.graph[r.link.is(L.link)] = L.node)), L);
          }
          function S(T, L, M) {
            var U = this, $ = U.env, z, X;
            if (u._ === L && E(T, r.link._))
              return M._;
            if (z = I(T, L, M, U, $)) {
              if (L || (U.node = U.node || M || {}, E(T, u._) && u.soul(T) && (U.node._ = R(T._)), U.node = u.soul.ify(U.node, r.link.is(U.link)), U.link = U.link || r.link.ify(u.soul(U.node))), (X = $.map) && (X.call($.as || {}, T, L, M, U), E(M, L))) {
                if (T = M[L], P === T) {
                  w(M, L);
                  return;
                }
                if (!(z = I(T, L, M, U, $)))
                  return;
              }
              if (!L)
                return U.node;
              if (z === !0)
                return T;
              if (X = k($, { obj: T, path: U.path.concat(L) }), !!X.node)
                return X.link;
            }
          }
          function x(T) {
            var L = this, M = r.link.is(L.link), U = L.env.graph;
            L.link = L.link || r.link.ify(T), L.link[r.link._] = T, L.node && L.node[u._] && (L.node[u._][r.link._] = T), E(U, M) && (U[T] = U[M], w(U, M));
          }
          function I(T, L, M, U, $) {
            var z;
            if (r.is(T))
              return !0;
            if (v(T))
              return 1;
            if (z = $.invalid)
              return T = z.call($.as || {}, T, L, M), I(T, L, M, U, $);
            $.err = "Invalid value at '" + U.path.concat(L).join(".") + "'!", n.list.is(T) && ($.err += " Use `.set(item)` instead of an Array.");
          }
          function F(T, L) {
            for (var M = T.seen, U = M.length, $; U--; )
              if ($ = M[U], L.obj === $.obj)
                return $;
            M.push(L);
          }
        }(), y.node = function(k) {
          e("graph.node");
          var S = u.soul(k);
          if (S)
            return C({}, S, k);
        }, function() {
          y.to = function(S, x, I) {
            if (e("graph.to"), !!S) {
              var F = {};
              return I = I || { seen: {} }, O(S[x], k, { obj: F, graph: S, opt: I }), F;
            }
          };
          function k(S, x) {
            var I, F;
            if (u._ === x) {
              if (A(S, r.link._))
                return;
              this.obj[x] = R(S);
              return;
            }
            if (!(I = r.link.is(S))) {
              this.obj[x] = S;
              return;
            }
            if (F = this.opt.seen[I]) {
              this.obj[x] = F;
              return;
            }
            this.obj[x] = this.opt.seen[I] = y.to(this.graph, I, this.opt);
          }
        }();
        var b = n.fn.is, g = n.obj, v = g.is, w = g.del, E = g.has, A = g.empty, C = g.put, O = g.map, R = g.copy, P;
        n.graph = n.graph || y;
      }
    }();
  }(ji)), ji.exports;
}
var Yp = Ar();
const Fn = /* @__PURE__ */ Pn(Yp);
var lu = {}, hu;
function Xp() {
  if (hu) return lu;
  hu = 1;
  var t = typeof window < "u" ? window.Gun : Ar();
  return t.chain.promise = function(i) {
    var n = this, i = i || function(r) {
      return r;
    };
    return new Promise(function(r, s) {
      n.once(function(o, a) {
        r({ put: o, get: a, gun: this });
      });
    }).then(i);
  }, t.chain.then = function(e) {
    var n = this, i = new Promise((r, s) => {
      n.once(function(o, a) {
        r(o, a);
      });
    });
    return e ? i.then(e) : i;
  }, lu;
}
Xp();
var Ns = { exports: {} }, fu;
function xa() {
  return fu || (fu = 1, function() {
    function t() {
      var s = function(o, a, u) {
        if (s.unit = 0, !u && i !== a && (s.last = "" + o < s.last ? s.last : "" + o, delete (s.$ || {})[r]), u = u || s.$ || (s.$ = {}), !o && Object.keys(u).length)
          return u;
        o = "" + o;
        for (var c = 0, l = o.length - 1, h = o[c], f, d; !(f = u[h]) && c < l; )
          h += o[++c];
        if (f)
          if (c == l) {
            if (i === a)
              return i === (d = f[""]) ? f : (s.unit = 1) && d;
            f[""] = a;
          } else
            return i !== a && delete f[r], s(o.slice(++c), a, f || (f = {}));
        else {
          if (!e(u, function(p, m) {
            var _ = 0, y = "";
            if ((m || "").length)
              for (; m[_] == o[_]; )
                y += m[_++];
            if (y) {
              if (i === a)
                return _ <= l ? void 0 : ((d || (d = {}))[m.slice(_)] = p, p);
              var b = {};
              if (b[m.slice(_)] = p, _ = o.slice(_), _ === "" ? b[""] = a : (b[_] = {})[""] = a, u[y] = b, t.debug && "" + y == "undefined") {
                console.log(0, y);
                debugger;
              }
              return delete u[m], !0;
            }
          })) {
            if (i === a)
              return;
            if ((u[h] || (u[h] = {}))[""] = a, t.debug && "" + h == "undefined") {
              console.log(1, h);
              debugger;
            }
          }
          if (i === a)
            return d;
        }
      };
      return s;
    }
    if (t.map = function s(o, a, u, c) {
      try {
        c = c || [];
        var l = typeof o == "function" ? o.$ || {} : o;
        //!opt && console.log("WHAT IS T?", JSON.stringify(t).length);
        if (!l)
          return;
        if (typeof l == "string") {
          if (t.debug)
            throw ["BUG:", o, a, u, c];
          return;
        }
        var h = (l[r] || n).sort || (l[r] = function C() {
          return C.sort = Object.keys(l).sort(), C;
        }()).sort, f;
        u = u === !0 ? { branch: !0 } : u || {}, (f = u.reverse) && (h = h.slice(0).reverse());
        for (var d = u.start, p = u.end, m = "￿", _ = 0, y = h.length; _ < y; _++) {
          var b = h[_], g = l[b], v, w, E;
          if (!(!g || b === "" || r === b || b === "undefined") && (w = c.slice(0), w.push(b), E = w.join(""), !(i !== d && E < (d || "").slice(0, E.length)) && !(i !== p && (p || m) < E))) {
            if (f && (v = s(g, a, u, w), i !== v))
              return v;
            if (i !== (v = g[""])) {
              var A = 1;
              if (i !== d && E < (d || "") && (A = 0), i !== p && E > (p || m) && (A = 0), A && (v = a(v, E, b, c), i !== v))
                return v;
            } else if (u.branch && (v = a(i, E, b, c), i !== v))
              return v;
            if (c = w, !f && (v = s(g, a, u, c), i !== v))
              return v;
            c.pop();
          }
        }
      } catch (C) {
        console.error(C);
      }
    }, typeof window < "u")
      window.Radix = t;
    else
      try {
        Ns.exports = t;
      } catch {
      }
    var e = t.object = function(s, o, a) {
      for (var u in s)
        if (s.hasOwnProperty(u) && (a = o(s[u], u)) !== i)
          return a;
    }, n = {}, i, r = "";
  }()), Ns.exports;
}
xa();
var Bs = { exports: {} }, $s = { exports: {} }, du;
function Qp() {
  return du || (du = 1, function(t) {
    (function() {
      var e = {}, n, i = setTimeout.turn || typeof setImmediate != "" + n && setImmediate || setTimeout;
      e.parseAsync = function(s, o, a, u) {
        if (typeof s != "string") {
          try {
            o(n, JSON.parse(s));
          } catch (h) {
            o(h);
          }
          return;
        }
        var c = { i: 0, text: s, done: o, l: s.length, up: [] };
        u = u || 1024 * 32, l();
        function l() {
          for (var h = c.text, f = c.i, d = c.l, p = 0, m = c.w, _, y; p++ < u; ) {
            var b = h[f++];
            if (f > d) {
              c.end = !0;
              break;
            }
            if (m) {
              for (f = h.indexOf('"', f - 1), b = h[f], y = 0; h[f - ++y] == "\\"; )
                ;
              y = !(y % 2), _ = _ || y, b == '"' && !y && (m = n, y = c.s, c.a ? (y = h.slice(c.sl, f), (_ || 1 + y.indexOf("\\")) && (y = JSON.parse('"' + y + '"')), c.at instanceof Array ? c.at.push(c.s = y) : (c.at || (c.end = p = u, y = n), (c.at || {})[c.s] = c.s = y), c.s = n) : (c.s = h.slice(c.sl, f), (_ || 1 + c.s.indexOf("\\")) && (c.s = JSON.parse('"' + c.s + '"'))), c.a = _ = n), ++f;
            } else
              switch (b) {
                case '"':
                  c.sl = f, m = !0;
                  break;
                case ":":
                  c.ai = f, c.a = !0;
                  break;
                case ",":
                  (c.a || c.at instanceof Array) && (y = h.slice(c.ai, f - 1)) && n !== (y = r(y)) && (c.at instanceof Array ? c.at.push(y) : c.at[c.s] = y), c.a = n, c.at instanceof Array && (c.a = !0, c.ai = f);
                  break;
                case "{":
                  c.up.push(c.at || (c.at = {})), c.at instanceof Array ? c.at.push(c.at = {}) : n !== (y = c.s) && (c.at[y] = c.at = {}), c.a = n;
                  break;
                case "}":
                  c.a && (y = h.slice(c.ai, f - 1)) && n !== (y = r(y)) && (c.at instanceof Array ? c.at.push(y) : (c.at || (c.end = p = u, y = n), (c.at || {})[c.s] = y)), c.a = n, c.at = c.up.pop();
                  break;
                case "[":
                  n !== (y = c.s) ? (c.up.push(c.at), c.at[y] = c.at = []) : c.at || c.up.push(c.at = []), c.a = !0, c.ai = f;
                  break;
                case "]":
                  c.a && (y = h.slice(c.ai, f - 1)) && n !== (y = r(y)) && (c.at instanceof Array ? c.at.push(y) : c.at[c.s] = y), c.a = n, c.at = c.up.pop();
                  break;
              }
          }
          if (c.s = n, c.i = f, c.w = m, c.end) {
            if (y = c.at, n === y)
              try {
                y = JSON.parse(s);
              } catch (g) {
                return c.done(g);
              }
            c.done(n, y);
          } else
            i(l);
        }
      };
      function r(s) {
        var o = parseFloat(s);
        if (!isNaN(o))
          return o;
        if (s = s.trim(), s == "true")
          return !0;
        if (s == "false")
          return !1;
        if (s == "null")
          return null;
      }
      e.stringifyAsync = function(s, o, a, u, c) {
        c = c || {}, c.text = c.text || "", c.up = [c.at = { d: s }], c.done = o, c.i = 0;
        var l = 0;
        h();
        function h() {
          var f = c.at, d = f.d, p = "", m;
          switch (f.i && f.i - f.j > 0 && (p += ","), n !== (m = f.k) && (p += JSON.stringify(m) + ":"), typeof d) {
            case "boolean":
              p += "" + d;
              break;
            case "string":
              p += JSON.stringify(d);
              break;
            case "number":
              p += isNaN(d) ? "null" : d;
              break;
            case "object":
              if (!d) {
                p += "null";
                break;
              }
              if (d instanceof Array) {
                p += "[", f = { i: -1, as: d, up: f, j: 0 }, f.l = d.length, c.up.push(c.at = f);
                break;
              }
              if (typeof (d || "").toJSON != "function") {
                p += "{", f = { i: -1, ok: Object.keys(d).sort(), as: d, up: f, j: 0 }, f.l = f.ok.length, c.up.push(c.at = f);
                break;
              }
              if (m = d.toJSON()) {
                p += m;
                break;
              }
            // let this & below pass into default case...
            case "function":
              if (f.as instanceof Array) {
                p += "null";
                break;
              }
            default:
              p = "", f.j++;
          }
          for (c.text += p; 1 + f.i >= f.l; )
            c.text += f.ok ? "}" : "]", f = c.at = f.up;
          if (++f.i < f.l) {
            if ((m = f.ok) ? f.d = f.as[f.k = m[f.i]] : f.d = f.as[f.i], ++l < 9)
              return h();
            l = 0, i(h);
            return;
          }
          c.done(n, c.text);
        }
      }, typeof window != "" + n && (window.YSON = e);
      try {
        "" + n != "object" && (t.exports = e);
      } catch {
      }
      typeof JSON != "" + n && (JSON.parseAsync = e.parseAsync, JSON.stringifyAsync = e.stringifyAsync);
    })();
  }($s)), $s.exports;
}
var zs, pu;
function em() {
  return pu || (pu = 1, zs = function(t) {
    var e = xa();
    t.find("a", function() {
      var n = [];
      e.map(t.list, function(s, o) {
        o.indexOf("%1B") + 1 && s && n.push([o, s]);
      }), n.length && console.log(`
! ! ! WARNING ! ! !
RAD v0.2020.x has detected OLD v0.2019.x data & automatically migrating. Automatic migration will be turned OFF in future versions! If you are just developing/testing, we recommend you reset your data. Please contact us if you have any concerns.
This message should only log once.`);
      var i, r;
      n.forEach(function(s) {
        i = s[0], r = s[1], t.list(decodeURIComponent(i), r), t.list(i, 0);
      }), i && t.find.bad(i);
    });
  }), zs;
}
var mu;
function hh() {
  return mu || (mu = 1, function() {
    function t(i) {
      i = i || {}, i.log = i.log || console.log, i.file = String(i.file || "radata");
      var r = (t.has || (t.has = {}))[i.file];
      if (r)
        return r;
      i.max = i.max || (i.memory ? i.memory * 999 * 999 : 3e8) * 0.3, i.until = i.until || i.wait || 250, i.batch = i.batch || 10 * 1e3, i.chunk = i.chunk || 1024 * 1024 * 1, i.code = i.code || {}, i.code.from = i.code.from || "!", i.jsonify = !0;
      function s(_) {
        return encodeURIComponent(_).replace(/\*/g, "%2A");
      }
      function o(_) {
        return m !== _ && (!_ || typeof _ != "object");
      }
      var a = "" + m == typeof setImmediate ? setTimeout : setImmediate, u = setTimeout.turn || a, m, c = n.object, l = 0;
      if (!i.store)
        return i.log("ERROR: Radisk needs `opt.store` interface with `{get: fn, put: fn (, list: fn)}`!");
      if (!i.store.put)
        return i.log("ERROR: Radisk needs `store.put` interface with `(file, data, cb)`!");
      if (!i.store.get)
        return i.log("ERROR: Radisk needs `store.get` interface with `(file, cb)`!");
      i.store.list, "" + m != typeof Vn && Qp();
      var h = JSON.parseAsync || function(_, y, b) {
        var g;
        try {
          y(g, JSON.parse(_, b));
        } catch (v) {
          y(v);
        }
      }, f = function(_, y, b, g, v) {
        if (typeof y == "function") {
          var w = b || {};
          b = y, f.read(_, b, w, v || g);
          return;
        }
        f.save(_, y, b, g, v);
      };
      f.save = function(_, y, b, g, v) {
        var w = { key: _ }, E, A;
        w.find = function(C) {
          var O;
          if (w.file = C || (C = i.code.from), v && (v = v[C] = v[C] || {}), v && (v.sf = v.sf || +/* @__PURE__ */ new Date()), O = f.disk[C]) {
            w.mix(m, O);
            return;
          }
          f.parse(C, w.mix, m, v);
        }, w.mix = function(C, O) {
          if (v && (v.sml = +/* @__PURE__ */ new Date()), v && (v.sm = v.sm || +/* @__PURE__ */ new Date()), w.err = C || w.err) {
            b(C);
            return;
          }
          var R = w.file = (O || "").file || w.file, P;
          if (!O && R !== i.code.from) {
            f.find.bad(R), f.save(_, y, b, g);
            return;
          }
          if ((O = f.disk[R] || (f.disk[R] = O || n())).file || (O.file = R), i.compare && (y = i.compare(O(_), y, _, R), m === y)) {
            b(C, -1);
            return;
          }
          if ((w.disk = O)(_, y), g && ((P = (P = O.tags || (O.tags = {}))[g] || (P[g] = f.tags[g] || (f.tags[g] = {})))[R] || (P[R] = f.one[g] || (f.one[g] = b)), b = null), v && (v.st = v.st || +/* @__PURE__ */ new Date()), O.Q) {
            b && O.Q.push(b);
            return;
          }
          O.Q = b ? [b] : [], O.to = setTimeout(w.write, i.until);
        }, w.write = function() {
          v && (v.sto = v.sto || +/* @__PURE__ */ new Date());
          var C = E = w.file, O = w.disk;
          A = w.q = O.Q, w.tags = O.tags, delete O.Q, delete f.disk[C], delete O.tags, f.write(C, O, w.ack, m, v);
        }, w.ack = function(C, O) {
          v && (v.sa = v.sa || +/* @__PURE__ */ new Date()), v && (v.sal = A.length);
          var R, P;
          for (var k in f.tags)
            if (f.tags.hasOwnProperty(k)) {
              var S = f.tags[k];
              if (!((P = f.disk[E]) && (P = P.tags) && P[S])) {
                R = S[E], delete S[E];
                var x;
                for (var I in S)
                  if (S.hasOwnProperty(I)) {
                    x = !0;
                    break;
                  }
                x || (delete f.tags[S], R && R(C, O));
              }
            }
          !A && (A = "");
          for (var F = A.length, T = 0, L = +/* @__PURE__ */ new Date(); T < F; T++)
            (R = A[T]) && R(C, O);
          console.STAT && console.STAT(L, +/* @__PURE__ */ new Date() - L, "rad acks", s(w.file)), console.STAT && console.STAT(L, A.length, "rad acks #", s(w.file));
        }, b || (b = function(C, O) {
        }), f.find(_, w.find);
      }, f.disk = {}, f.one = {}, f.tags = {};
      var d = 0;
      f.write = function(_, y, b, g, v) {
        if (!y) {
          b("No radix!");
          return;
        }
        g = typeof g == "object" ? g : { force: g };
        var w = function() {
        }, E, A;
        if (w.text = "", w.file = _ = y.file || (y.file = _), !_) {
          b("What file?");
          return;
        }
        if (w.write = function() {
          var C = y.raw = w.text;
          f.disk[_ = y.file || w.file || _] = y;
          var O = +/* @__PURE__ */ new Date();
          v && (v.wd = O), f.find.add(_, function(P) {
            if (v && (v.wa = +/* @__PURE__ */ new Date()), P) {
              b(P);
              return;
            }
            i.store.put(s(_), C, function(S, x) {
              v && (v.wp = +/* @__PURE__ */ new Date()), console.STAT && console.STAT(O, l = +/* @__PURE__ */ new Date() - O, "wrote disk", JSON.stringify(_), ++d, "total all writes."), b(S, x || 1), y.Q || delete f.disk[_];
            });
          });
        }, w.split = function() {
          var C = +/* @__PURE__ */ new Date();
          v && (v.wf = C), w.text = "", w.count || (w.count = 0, n.map(y, function() {
            w.count++;
          })), v && (v.wfc = w.count), w.limit = Math.ceil(w.count / 2);
          var O = w.count;
          return w.count = 0, v && (v.wf1 = +/* @__PURE__ */ new Date()), w.sub = n(), n.map(y, w.slice, { reverse: 1 }), v && (v.wf2 = +/* @__PURE__ */ new Date()), f.write(w.end, w.sub, w.both, g), v && (v.wf3 = +/* @__PURE__ */ new Date()), w.hub = n(), n.map(y, w.stop), v && (v.wf4 = +/* @__PURE__ */ new Date()), f.write(y.file, w.hub, w.both, g), v && (v.wf5 = +/* @__PURE__ */ new Date()), console.STAT && console.STAT(C, +/* @__PURE__ */ new Date() - C, "rad split", s(y.file), O), !0;
        }, w.slice = function(C, O) {
          if (w.sub(w.end = O, C), w.limit <= ++w.count)
            return !0;
        }, w.stop = function(C, O) {
          if (O >= w.end)
            return !0;
          w.hub(O, C);
        }, w.both = function(C, O) {
          if (v && (v.wfd = +/* @__PURE__ */ new Date()), A) {
            b(C || A);
            return;
          }
          if (E) {
            b(C, O);
            return;
          }
          E = !0, A = C;
        }, w.each = function(C, O, R, P) {
          if (m !== C && w.count++, i.max <= (C || "").length)
            return b("Data too big!"), !0;
          var k = t.encode(P.length) + "#" + t.encode(R) + (m === C ? "" : ":" + t.encode(C)) + `
`;
          if (i.chunk < w.text.length + k.length && 1 < w.count && !g.force)
            return w.split();
          w.text += k;
        }, i.jsonify) {
          f.write.jsonify(w, y, b, g, v);
          return;
        }
        n.map(y, w.each, !0) || w.write();
      }, f.write.jsonify = function(_, y, b, g, v) {
        var w, E = +/* @__PURE__ */ new Date();
        v && (v.w = E);
        try {
          w = JSON.stringify(y.$);
        } catch {
          b("Cannot radisk!");
          return;
        }
        if (v && (v.ws = +/* @__PURE__ */ new Date()), console.STAT && console.STAT(E, +/* @__PURE__ */ new Date() - E, "rad stringified JSON"), i.chunk < w.length && !g.force) {
          var A = 0;
          if (n.map(y, function() {
            if (A++)
              return !0;
          }), A > 1)
            return _.split();
        }
        _.text = w, _.write();
      }, f.range = function(_, y) {
        if (!(!_ || !y)) {
          if (m === y.start && m === y.end || o(_))
            return _;
          var b = n();
          return n.map(_, function(g, v) {
            b(v, g);
          }, y), b("");
        }
      }, function() {
        f.read = function(_, y, b, g) {
          b = b || {};
          var v = { key: _ };
          v.find = function(w) {
            var E;
            if (v.file = w || (w = i.code.from), g && (g = g[w] = g[w] || {}), g && (g.rf = g.rf || +/* @__PURE__ */ new Date()), E = f.disk[v.file = w]) {
              v.check(m, E);
              return;
            }
            f.parse(w, v.check, m, g);
          }, v.get = function(w, E, A) {
            if (g && (g.rgl = +/* @__PURE__ */ new Date()), g && (g.rg = g.rg || +/* @__PURE__ */ new Date()), v.err = w || v.err) {
              y(w);
              return;
            }
            var C = v.file = (E || "").file || v.file;
            if (!E && C !== i.code.from) {
              f.find.bad(C), f.read(_, y, b);
              return;
            }
            if (E = f.disk[C] || (f.disk[C] = E), !E) {
              y(C === i.code.from ? m : "No file!");
              return;
            }
            E.file || (E.file = C);
            var O = f.range(E(_), b);
            if (g && (g.rr = +/* @__PURE__ */ new Date()), b.unit = E.unit, b.chunks = (b.chunks || 0) + 1, b.parsed = (b.parsed || 0) + ((A || "").parsed || b.chunks * i.chunk), b.more = 1, b.next = m, n.map(f.list, function(S, x) {
              if (!(!S || C === x))
                return b.next = x, 1;
            }, b.reverse ? { reverse: 1, end: C } : { start: C }), g && (g.rl = +/* @__PURE__ */ new Date()), b.next || (b.more = 0), b.next && (!b.reverse && (_ < b.next && b.next.indexOf(_) != 0 || m !== b.end && (b.end || "￿") < b.next) && (b.more = 0), b.reverse && (_ > b.next && _.indexOf(b.next) != 0 || m !== b.start && (b.start || "") > b.next && C <= b.start) && (b.more = 0)), !b.more) {
              y(v.err, O, b);
              return;
            }
            if (O && y(v.err, O, b), !(b.parsed >= b.limit)) {
              var R = +/* @__PURE__ */ new Date();
              g && (g.rm = R);
              var P = b.next;
              a(function() {
                console.STAT && console.STAT(R, +/* @__PURE__ */ new Date() - R, "rad more"), f.parse(P, v.check);
              }, 0);
            }
          }, v.check = function(w, E, A) {
            if (v.get(w, E, A), !(!E || E.check)) {
              E.check = 1;
              var C = +/* @__PURE__ */ new Date();
              (A || (A = {})).file || (A.file = v.file), n.map(E, function(O, R) {
                f.find(R, function(P) {
                  if ((P || (P = i.code.from)) !== A.file) {
                    var k = ("" + Math.random()).slice(-3);
                    u(function() {
                      f.save(R, O, function S(x, I) {
                        if (x) {
                          f.save(R, O, S);
                          return;
                        }
                        console.STAT && console.STAT("MISLOCATED DATA CORRECTED", k, s(R), s(A.file), s(P));
                      });
                    }, 0);
                  }
                });
              }), console.STAT && console.STAT(C, +/* @__PURE__ */ new Date() - C, "rad check");
            }
          }, f.find(_ || (b.reverse ? b.end || "" : b.start || ""), v.find);
        };
      }(), function() {
        var _ = 0, y = {}, b = "";
        f.parse = function(g, v, w, E) {
          var A;
          if (!g)
            return v();
          if (A = y[g]) {
            A.push(v);
            return;
          }
          A = y[g] = [v];
          var C = function() {
          }, O = { file: g };
          (C.disk = n()).file = g, C.read = function(P, k) {
            if (E && (E.rpg = +/* @__PURE__ */ new Date()), console.STAT && console.STAT(R, +/* @__PURE__ */ new Date() - R, "read disk", JSON.stringify(g), ++_, "total all parses."), (C.err = P) || (C.not = !k)) {
              delete y[g], C.map(A, C.ack);
              return;
            }
            if (typeof k != "string") {
              try {
                i.max <= k.length ? C.err = "Chunk too big!" : k = k.toString();
              } catch (S) {
                C.err = S;
              }
              if (C.err) {
                delete y[g], C.map(A, C.ack);
                return;
              }
            }
            if (O.parsed = k.length, E && (E.rpl = O.parsed), E && (E.rpa = A.length), R = +/* @__PURE__ */ new Date(), !(i.jsonify || k[0] === "{")) {
              C.radec(P, k);
              return;
            }
            h(k, function(S, x) {
              if (!S) {
                delete y[g], C.disk.$ = x, console.STAT && (l = +/* @__PURE__ */ new Date() - R) > 9 && console.STAT(R, l, "rad parsed JSON"), E && (E.rpd = +/* @__PURE__ */ new Date()), C.map(A, C.ack);
                return;
              }
              if (k[0] === "{") {
                delete y[g], C.err = "JSON error!", C.map(A, C.ack);
                return;
              }
              C.radec(S, k);
            });
          }, C.map = function() {
            if (!(!A || !A.length)) {
              for (var P = +/* @__PURE__ */ new Date(), k = C.err, S = C.not ? m : C.disk, x = 0, I; x < 9 && (I = A[x++]); )
                I(k, S, O);
              console.STAT && console.STAT(P, +/* @__PURE__ */ new Date() - P, "rad packs", s(g)), console.STAT && console.STAT(P, x, "rad packs #", s(g)), (A = A.slice(x)).length && u(C.map, 0);
            }
          }, C.ack = function(P) {
            if (P) {
              if (C.err || C.not) {
                P(C.err, m, O);
                return;
              }
              P(m, C.disk, O);
            }
          }, C.radec = function(P, k) {
            delete y[g], R = +/* @__PURE__ */ new Date();
            var S = C.split(k), x = [], I, F, T;
            if (!S || S[1] !== 0) {
              C.err = "File '" + g + "' does not have root radix! ", C.map(A, C.ack);
              return;
            }
            for (; S; )
              F = T = m, I = S[1], S = C.split(S[2]) || "", S[0] == "#" && (F = S[1], x = x.slice(0, I), I <= x.length && x.push(F)), S = C.split(S[2]) || "", S[0] != `
` && ((S[0] == "=" || S[0] == ":") && (T = S[1]), m !== F && m !== T && C.disk(x.join(""), T), S = C.split(S[2]));
            console.STAT && console.STAT(R, +/* @__PURE__ */ new Date() - R, "parsed RAD"), C.map(A, C.ack);
          }, C.split = function(P) {
            if (P) {
              var k = [], S = {}, x = -1, I = "";
              if (x = P.indexOf(b), !!P[x])
                return I = P.slice(0, x), k[0] = I, k[1] = t.decode(P.slice(x), S), k[2] = P.slice(x + S.i), k;
            }
          }, f.disk && (w || (w = (f.disk[g] || "").raw));
          var R = +/* @__PURE__ */ new Date();
          if (E && (E.rp = R), w)
            return u(function() {
              C.read(m, w);
            }, 0);
          i.store.get(s(g), C.read);
        };
      }(), function() {
        var _, y = "", b;
        f.find = function(w, E) {
          if (!_) {
            if (b) {
              b.push([w, E]);
              return;
            }
            b = [[w, E]], f.parse(y, g);
            return;
          }
          n.map(f.list = _, function(A, C) {
            if (A)
              return E(C) || !0;
          }, { reverse: 1, end: w }) || E(i.code.from);
        }, f.find.add = function(w, E) {
          var A = _(w);
          if (A || w === y) {
            E(m, 1);
            return;
          }
          _(w, 1), E.found = (E.found || 0) + 1, f.write(y, _, function(C, O) {
            if (C) {
              E(C);
              return;
            }
            E.found = (E.found || 0) - 1, E.found === 0 && E(m, 1);
          }, !0);
        }, f.find.bad = function(w, E) {
          _(w, 0), f.write(y, _, E || p);
        };
        function g(w, E) {
          if (w) {
            i.log("list", w), setTimeout(function() {
              f.parse(y, g);
            }, 1e3);
            return;
          }
          if (E) {
            v(E);
            return;
          }
          if (_ = _ || E || n(), !i.store.list) {
            v(_);
            return;
          }
          i.store.list(function(A) {
            if (!A) {
              v(_);
              return;
            }
            f.find.add(A, p);
          });
        }
        function v(w, E) {
          _ = _ || w, _.file = y, E = b, b = null, c(E, function(A) {
            f.find(A[0], A[1]);
          });
        }
      }();
      try {
        !e.window && em()(f);
      } catch {
      }
      var p = function() {
      }, m;
      return t.has[i.file] = f, f;
    }
    if (function() {
      var i = "";
      t.encode = function(r, s, o) {
        o = o || i;
        var a = o, u;
        if (typeof r == "string") {
          for (var c = r.indexOf(o); c != -1; )
            a += o, c = r.indexOf(o, c + 1);
          return a + '"' + r + o;
        } else {
          if (r && r["#"] && Object.keys(r).length == 1)
            return a + "#" + u + a;
          if (typeof r == "number")
            return a + "+" + (r || 0) + a;
          if (r === null)
            return a + " " + a;
          if (r === !0)
            return a + "+" + a;
          if (r === !1)
            return a + "-" + a;
        }
      }, t.decode = function(r, s, o) {
        o = o || i;
        var a = "", u = -1, c = 0, l, h;
        if (o === r[0]) {
          for (; o === r[++u]; )
            ++c;
          for (h = r[l = c] || !0; --c >= 0; )
            u = r.indexOf(o, u + 1);
          if (u == -1 && (u = r.length), a = r.slice(l + 1, u), s && (s.i = u + 1), h === '"')
            return a;
          if (h === "#")
            return { "#": a };
          if (h === "+")
            return a.length === 0 ? !0 : parseFloat(a);
          if (h === " ")
            return null;
          if (h === "-")
            return !1;
        }
      };
    }(), typeof window < "u") {
      var e = window.Gun, n = window.Radix;
      window.Radisk = t;
    } else {
      var e = Ar(), n = xa();
      try {
        Bs.exports = t;
      } catch {
      }
    }
    t.Radix = n;
  }()), Bs.exports;
}
hh();
var gu = {}, bu;
function tm() {
  if (bu) return gu;
  bu = 1;
  var t = {}, e = typeof window < "u" ? window.Gun : Ar();
  return e.on("create", function(n) {
    e.TESTING && (n.opt.file = "radatatest"), this.to.next(n);
    var i = n.opt, r;
    if (!(i.rad === !1 || i.radisk === !1) && !(r + "" != typeof process && "" + (t || "").RAD == "false")) {
      var s = e.window && e.window.Radisk || hh(), o = s.Radix, a = s(i), u = "\x1B", c = 0;
      n.on("put", function(h) {
        if (this.to.next(h), !(h._ || "").rad) {
          var f = h["#"], d = h.put, p = d["#"], m = d["."], _ = d[":"], y = d[">"], b = (h._ || "").DBG;
          b && (b.sp = b.sp || +/* @__PURE__ */ new Date());
          var g = (h._ || "").RPS || ((h._ || "").RPS = +/* @__PURE__ */ new Date());
          a(p + u + m, { ":": _, ">": y }, function(v, w) {
            if (b && (b.spd = b.spd || +/* @__PURE__ */ new Date()), console.STAT && console.STAT(g, +/* @__PURE__ */ new Date() - g, "put"), v) {
              n.on("in", { "@": f, err: v, DBG: b });
              return;
            }
            n.on("in", { "@": f, ok: w, DBG: b });
          }, !1, b && (b.r = b.r || {})), b && (b.sps = b.sps || +/* @__PURE__ */ new Date());
        }
      }), n.on("get", function(h) {
        this.to.next(h);
        var f = h._ || "", d = f.DBG = h.DBG;
        d && (d.sg = +/* @__PURE__ */ new Date());
        var p = h["#"], m = h.get, _ = h.get["#"], y = h.get["."] || "", b = {}, g, v, w, E;
        if (typeof _ == "string" ? v = _ : _ && (r !== (w = _["*"]) && (b.limit = E = 1), r !== _[">"] && (b.start = _[">"]), r !== _["<"] && (b.end = _["<"]), v = E ? "" + w : w || _["="], E = null), v && !b.limit && (typeof y == "string" ? v = v + u + (b.atom = y) : y && (r !== y[">"] && (b.start = y[">"], b.limit = 1), r !== y["<"] && (b.end = y["<"], b.limit = 1), r !== (w = y["*"]) && (b.limit = E = 1), v && (v = v + u + (E ? "" + (w || "") : w || (b.atom = y["="] || ""))))), ((w = m["%"]) || b.limit) && (b.limit = w <= (b.pack || 1e3 * 100) ? w : 1), (y["-"] || (_ || {})["-"] || m["-"]) && (b.reverse = !0), (w = (n.next || "")[_]) && w.put) {
          if (b.atom) {
            if (w = (w.next || "")[b.atom], w && w.root && w.root.graph && w.root.graph[_] && w.root.graph[_][b.atom])
              return;
          } else if (w && w.rad)
            return;
        }
        var A = e.state(), C = +/* @__PURE__ */ new Date(), O = 0;
        d && (d.sgm = C), a(v || "", function(P, k, S) {
          d && (d.sgr = +/* @__PURE__ */ new Date()), d && (d.sgi = S);
          try {
            i.store.stats.get.time[l % 50] = +/* @__PURE__ */ new Date() - C, ++l, i.store.stats.get.count++, P && (i.store.stats.get.err = P);
          } catch {
          }
          console.STAT && console.STAT(C, +/* @__PURE__ */ new Date() - C, "got", JSON.stringify(v)), C = +/* @__PURE__ */ new Date(), S = S || "";
          var x, I;
          if (S.unit && k && r !== (x = k[":"]) && r !== (I = k[">"])) {
            var F = v.split(u), T = F[0], L = F[1];
            (g = g || {})[T] = e.state.ify(g[T], L, I, x, T), n.$.get(T).get(L)._.rad = A;
          } else k && (typeof k != "string" && (b.atom ? k = r : o.map(k, R, b)), !g && k && R(k, ""), !b.atom && !y & typeof _ == "string" && !b.limit && !b.more && (n.$.get(_)._.rad = A));
          d && (d.sgp = +/* @__PURE__ */ new Date()), console.STAT && (c = +/* @__PURE__ */ new Date() - C) > 9 && (console.STAT(C, c, "got prep time"), console.STAT(C, O, "got prep #")), O = 0, C = +/* @__PURE__ */ new Date();
          var M = function() {
          };
          M.faith = !0, M.rad = m, n.on("in", { "@": p, put: g, "%": S.more ? 1 : r, err: P || r, _: M, DBG: d }), console.STAT && (c = +/* @__PURE__ */ new Date() - C) > 9 && console.STAT(C, c, "got emit", Object.keys(g || {}).length), g = r;
        }, b, d && (d.r = d.r || {})), d && (d.sgd = +/* @__PURE__ */ new Date()), console.STAT && (c = +/* @__PURE__ */ new Date() - C) > 9 && console.STAT(C, c, "get call");
        function R(P, k, S, x) {
          if (O++, !!P) {
            k = (v + k).split(u);
            var I = k.slice(0, 1)[0];
            if (k = k.slice(-1)[0], b.limit && b.limit <= b.count)
              return !0;
            var F, T, L = I, M = k;
            if (typeof P != "string") {
              F = P[":"], T = P[">"], (g = g || {})[L] = e.state.ify(g[L], M, T, F, L), b.count = (b.count || 0) + ((F || "").length || 9);
              return;
            }
            b.count = (b.count || 0) + P.length;
            var U = P.lastIndexOf(">"), $ = s.decode(P.slice(U + 1), null, u);
            P = s.decode(P.slice(0, U), null, u), (g = g || {})[I] = e.state.ify(g[I], k, $, P, I);
          }
        }
      }), e.valid, (i.store || {}).stats = { get: { time: {}, count: 0 }, put: { time: {}, count: 0 } };
      var l = 0;
    }
  }), gu;
}
tm();
var Us = { exports: {} }, _u;
function nm() {
  return _u || (_u = 1, function() {
    function t(n) {
      n = n || {}, n.file = String(n.file || "radata");
      var i = t[n.file], r = null, s;
      if (i)
        return console.log("Warning: reusing same IndexedDB store and options as 1st."), t[n.file];
      i = t[n.file] = function() {
      };
      try {
        n.indexedDB = n.indexedDB || t.indexedDB || indexedDB;
      } catch {
      }
      try {
        if (!n.indexedDB || location.protocol == "file:") {
          var o = i.d || (i.d = {});
          return i.put = function(a, u, c) {
            o[a] = u, setTimeout(function() {
              c(null, 1);
            }, 250);
          }, i.get = function(a, u) {
            setTimeout(function() {
              u(null, o[a] || s);
            }, 5);
          }, console.log("Warning: No indexedDB exists to persist data to!"), i;
        }
      } catch {
      }
      return i.start = function() {
        var a = indexedDB.open(n.file, 1);
        a.onupgradeneeded = function(u) {
          u.target.result.createObjectStore(n.file);
        }, a.onsuccess = function() {
          r = a.result;
        }, a.onerror = function(u) {
          console.log(u || 1);
        };
      }, i.start(), i.put = function(a, u, c) {
        if (!r) {
          setTimeout(function() {
            i.put(a, u, c);
          }, 1);
          return;
        }
        var l = r.transaction([n.file], "readwrite"), h = l.objectStore(n.file), f = h.put(u, "" + a);
        f.onsuccess = h.onsuccess = l.onsuccess = function() {
          c(null, 1);
        }, f.onabort = h.onabort = l.onabort = function(d) {
          c(d || "put.tx.abort");
        }, f.onerror = h.onerror = l.onerror = function(d) {
          c(d || "put.tx.error");
        };
      }, i.get = function(a, u) {
        if (!r) {
          setTimeout(function() {
            i.get(a, u);
          }, 9);
          return;
        }
        var c = r.transaction([n.file], "readonly"), l = c.objectStore(n.file), h = l.get("" + a);
        h.onsuccess = function() {
          u(null, h.result);
        }, h.onabort = function(f) {
          u(f || 4);
        }, h.onerror = function(f) {
          u(f || 5);
        };
      }, setInterval(function() {
        r && r.close(), r = null, i.start();
      }, 1e3 * 15), i;
    }
    if (typeof window < "u")
      (t.window = window).RindexedDB = t, t.indexedDB = window.indexedDB;
    else
      try {
        Us.exports = t;
      } catch {
      }
    try {
      var e = t.window.Gun || Ar();
      e.on("create", function(n) {
        this.to.next(n), n.opt.store = n.opt.store || t(n.opt);
      });
    } catch {
    }
  }()), Us.exports;
}
nm();
var yu = {}, vu;
function rm() {
  return vu || (vu = 1, function() {
    var t = typeof window < "u" ? window.Gun : Ar();
    t.on("opt", function(e) {
      this.to.next(e);
      var n = e.opt;
      if (e.once || !t.Mesh || n.RTCPeerConnection === !1)
        return;
      var i;
      typeof window < "u" && (i = window), typeof sn < "u" && (i = sn), i = i || {};
      var r = n.RTCPeerConnection || i.RTCPeerConnection || i.webkitRTCPeerConnection || i.mozRTCPeerConnection, s = n.RTCSessionDescription || i.RTCSessionDescription || i.webkitRTCSessionDescription || i.mozRTCSessionDescription, o = n.RTCIceCandidate || i.RTCIceCandidate || i.webkitRTCIceCandidate || i.mozRTCIceCandidate;
      if (!r || !s || !o)
        return;
      n.RTCPeerConnection = r, n.RTCSessionDescription = s, n.RTCIceCandidate = o, n.rtc = n.rtc || { iceServers: [
        { urls: "stun:stun.l.google.com:19302" },
        { urls: "stun:stun.sipgate.net:3478" }
        /*,
        {urls: "stun:stun.stunprotocol.org"},
        {urls: "stun:stun.sipgate.net:10000"},
        {urls: "stun:217.10.68.152:10000"},
        {urls: 'stun:stun.services.mozilla.com'}*/
      ] }, n.rtc.dataChannel = n.rtc.dataChannel || { ordered: !1, maxRetransmits: 2 }, n.rtc.sdp = n.rtc.sdp || { mandatory: { OfferToReceiveAudio: !1, OfferToReceiveVideo: !1 } }, n.rtc.max = n.rtc.max || 55, n.rtc.room = n.rtc.room || t.window && (location.hash.slice(1) || location.pathname.slice(1)), n.announce = function(c) {
        n.rtc.start = +/* @__PURE__ */ new Date(), e.$.get("/RTC/" + n.rtc.room + "<?99").get("+").put(n.pid, function(l) {
          !l.ok || !l.ok.rtc || u(l);
        }, { acks: n.rtc.max }).on(function(l, h, f) {
          l === n.pid || n.rtc.start > f.put[">"] || u({ "#": "" + f["#"], ok: { rtc: { id: l } } });
        });
      };
      var a = n.mesh = n.mesh || t.Mesh(e);
      e.on("create", function(c) {
        this.to.next(c), setTimeout(n.announce, 1);
      });
      function u(c) {
        if (this && this.off && this.off(), !!c.ok) {
          var l = c.ok.rtc, h, f;
          if (!(!l || !l.id || l.id === n.pid)) {
            if (f = l.answer)
              return !(h = n.peers[l.id] || u[l.id]) || h.remoteSet ? void 0 : (f.sdp = f.sdp.replace(/\\r\\n/g, `\r
`), h.setRemoteDescription(h.remoteSet = new n.RTCSessionDescription(f)));
            if (f = l.candidate)
              return h = n.peers[l.id] || u[l.id] || u({ ok: { rtc: { id: l.id } } }), h.addIceCandidate(new n.RTCIceCandidate(f));
            if (!u[l.id]) {
              (h = new n.RTCPeerConnection(n.rtc)).id = l.id;
              var d = h.wire = h.createDataChannel("dc", n.rtc.dataChannel);
              if (u[l.id] = h, d.to = setTimeout(function() {
                delete u[l.id];
              }, 1e3 * 60), d.onclose = function() {
                a.bye(h);
              }, d.onerror = function(p) {
              }, d.onopen = function(p) {
                delete u[l.id], a.hi(h);
              }, d.onmessage = function(p) {
                p && a.hear(p.data || p, h);
              }, h.onicecandidate = function(p) {
                p.candidate && e.on("out", { "@": c["#"], ok: { rtc: { candidate: p.candidate, id: n.pid } } });
              }, h.ondatachannel = function(p) {
                var m = p.channel;
                m.onmessage = d.onmessage, m.onopen = d.onopen, m.onclose = d.onclose;
              }, f = l.offer) {
                l.offer.sdp = l.offer.sdp.replace(/\\r\\n/g, `\r
`), h.setRemoteDescription(new n.RTCSessionDescription(f)), h.createAnswer(function(p) {
                  h.setLocalDescription(p), e.on("out", { "@": c["#"], ok: { rtc: { answer: p, id: n.pid } } });
                }, function() {
                }, n.rtc.sdp);
                return;
              }
              return h.createOffer(function(p) {
                h.setLocalDescription(p), e.on("out", { "@": c["#"], "#": e.ask(u), ok: { rtc: { offer: p, id: n.pid } } });
              }, function() {
              }, n.rtc.sdp), h;
            }
          }
        }
      }
    });
  }()), yu;
}
rm();
const im = "https://peer.wallie.io/gun", sm = { space: "Space", chat: "Chat", posts: "Posts", rooms: "Rooms", files: "Files" }, om = { pub: "McUmKdO7NtwX1vUrZiNvzgnPVPwgqKGV1PNATxIxTuM.iXExKjIByXeVGosHHeUzaJyrcthdc83O9HuX6rYX0gs", hosts: { "TjJboYZipmwZ59ebrbIfL34nh1TJcOUU8-0XYCZjLbk.5ULMwx29866hdlG-3xM-g-m33QtcZopGOzA85mDDiPo": { enc: 'SEA{"ct":"169OGBU2H9XKmaZLO+s8Pc5+fSaTrrSB4OVFm33CGh+VwxhEu0x9U7ir8m0LxXbcBEVt6MZ7CEPYtIL12Stwi0LCG6a139JEDSWwUZFxE/b/y6HZtn/V2gr9G4xL/TcdWHF2D+r+bBMHqJMBXKoIofz3DH/eArW8IgAIWm+VBmJYkejZ1w8WW9/1qx3RFVIITXeMB5FI8VzY7y9DGCyIDwMNVSeHDbjenK3oDz2qS48Gem13lHv/behM+vZNug7eL7WaF07sf962p0oX9mF0Y0fMLossIFOT8QPjeV9ZcdkMl4ngc+W2HN+WvxldE5dy2yock/15N77X6VQ5111ITDwJHkhXjp4Ro94NeKujb3yh4H8vXbQOeJPPJyQTZ3G4yF4Nw65PKIghIwdBNdsiRQ1QtjxQvaetaK5j5+0=","iv":"dc92+kgMorDWh4I0ntGb","s":"MV6T397GhmNe"}', profile: 'SEA{"m":{"c":"TjJboYZipmwZ59ebrbIfL34nh1TJcOUU8-0XYCZjLbk.5ULMwx29866hdlG-3xM-g-m33QtcZopGOzA85mDDiPo","w":{"*":"profile"}},"s":"j5LkQNRO7KX/PAwK4vvg/SGg2zHp6np2Bq6Ge9RgJrkSBmXPMxRJbsZncBqrlwWYbaUFtb4vcUlzDq9onzVSLA=="}', features: 'SEA{"m":{"c":"TjJboYZipmwZ59ebrbIfL34nh1TJcOUU8-0XYCZjLbk.5ULMwx29866hdlG-3xM-g-m33QtcZopGOzA85mDDiPo","w":{"*":"features"}},"s":"lUXJ84tvirAhnSwWgZGg2QfT0S8D7Xe7D0Bbae24pcX6D/GZuiq/lYPFnr+4ym/6bteJgdWV2U+E2q/1AMblsA=="}', hosts: 'SEA{"m":{"c":"TjJboYZipmwZ59ebrbIfL34nh1TJcOUU8-0XYCZjLbk.5ULMwx29866hdlG-3xM-g-m33QtcZopGOzA85mDDiPo","w":{"*":"hosts"}},"s":"Aq15hOjPHe2Q73pPa3OasqzflU1b41tmVC7mZwX2GQJujI7VYLR85W4zszeu9oEnLfcRf5bgu0aOngJrvLT9KA=="}' } }, features: { space: 'SEA{"m":{"c":"*","w":{"*":"space","+":"*"}},"s":"7N0iKUMsr2LMVyu7WWBknTDUZSTJjsz9vFFkUwNpjdhiAWfga/GIL2HJg6YfbAnCcWKdZCi4fQYLPsoR9LILIg=="}', chat: 'SEA{"m":{"c":"*","w":{"*":"chat","+":"*"}},"s":"2Nv9jI4I1ixSuGZnLFesGoveoioftd2yjIDOLwCGTmqAoX5KJs9f8REj1lAvYwZqm8jX6v36wew7XOwlBG1/IA=="}', posts: 'SEA{"m":{"c":"*","w":{"*":"posts","+":"*"}},"s":"iDKLG8/PkTrhb4uO+aMA5SB6kt/GdOnrnlbEG79OL66v+miHo/Pa1YO+/4yF5f5Y5YSJcskTnoNqi3KW0pFJuA=="}', rooms: 'SEA{"m":{"c":"*","w":{"*":"rooms","+":"*"}},"s":"wIwGepdJmjNOZHA4ujL624PLGu+hLRjgkg2vSm5mRCqN208sKWRqEsMrM44TFfVz6p0wNkmQvdH6kb2037zRwg=="}', files: 'SEA{"m":{"c":"*","w":{"*":"files","+":"*"}},"s":"rni6jM8eMk9lSDmNtroe4pqknBaXTUGHRR/9tEf2nnyx/v+qO465qk+pJJdeKlul0hanLujtL3TH+AE3e5W03A=="}' } }, Gn = {
  relay: im,
  features: sm,
  room: om
}, fh = Gn.relay, je = ie({
  list: [],
  peer: Gt("peer", fh),
  hostname: te(() => {
    var t;
    return ((t = new URL(je.peer)) == null ? void 0 : t.hostname) || "";
  }),
  status: "offline",
  started: 0,
  pulse: 0,
  lag: 0,
  diff: te(() => je.pulse - je.started),
  age: te(() => va(je.diff)),
  delay: te(() => Date.now() - je.pulse),
  blink: !1
});
Ge(
  () => je.pulse,
  (t, e) => {
    je.blink = !je.blink, je.lag = t - e - 500;
  }
);
function am(t) {
  je.peer = t, setTimeout(() => {
    window.location.reload();
  });
}
function um() {
  je.peer = fh, setTimeout(() => {
    window.location.reload();
  });
}
function iv() {
  const t = ue();
  return je.pulse == 0 && (je != null && je.hostname) && t.get(je == null ? void 0 : je.hostname).map().on((e, n) => {
    try {
      je[n] = e;
    } catch (i) {
      console.log(i);
    }
  }), { relay: je, setPeer: am, resetPeer: um };
}
var Ni = { exports: {} };
Ni.exports;
var wu;
function cm() {
  return wu || (wu = 1, function(t) {
    (function() {
      function e(i, r) {
        return r ? Vn(i) : i.slice ? e[s(i)] : function(o, a) {
          i(o = { exports: {} }), e[s(a)] = o.exports;
        };
        function s(o) {
          return o.split("/").slice(-1).toString().replace(".js", "");
        }
      }
      var n = t;
      e(function(i) {
        typeof self < "u" && (i.window = self), typeof window < "u" && (i.window = window);
        var r = i.window || i, s, o = r.SEA || {};
        (o.window = i.window) && (o.window.SEA = o);
        try {
          s + "" != typeof n && (n.exports = o);
        } catch {
        }
        i.exports = o;
      })(e, "./root"), e(function(i) {
        var r = e("./root");
        try {
          r.window && location.protocol.indexOf("s") < 0 && location.host.indexOf("localhost") < 0 && !/^127\.\d+\.\d+\.\d+$/.test(location.hostname) && location.protocol.indexOf("file:") < 0 && (console.warn("HTTPS needed for WebCrypto in SEA, redirecting..."), location.protocol = "https:");
        } catch {
        }
      })(e, "./https"), e(function(i) {
        var r;
        if (r + "" == typeof btoa) {
          if (r + "" == typeof Buffer)
            try {
              sn.Buffer = e("buffer", 1).Buffer;
            } catch {
              console.log("Please `npm install buffer` or add it to your package.json !");
            }
          sn.btoa = function(s) {
            return Buffer.from(s, "binary").toString("base64");
          }, sn.atob = function(s) {
            return Buffer.from(s, "base64").toString("binary");
          };
        }
      })(e, "./base64"), e(function(i) {
        e("./base64");
        function r() {
        }
        Object.assign(r, { from: Array.from }), r.prototype = Object.create(Array.prototype), r.prototype.toString = function(s, o, a) {
          s = s || "utf8", o = o || 0;
          const u = this.length;
          if (s === "hex") {
            const c = new Uint8Array(this);
            return [...Array((a && a + 1 || u) - o).keys()].map((l) => c[l + o].toString(16).padStart(2, "0")).join("");
          }
          if (s === "utf8")
            return Array.from(
              { length: (a || u) - o },
              (c, l) => String.fromCharCode(this[l + o])
            ).join("");
          if (s === "base64")
            return btoa(this);
        }, i.exports = r;
      })(e, "./array"), e(function(i) {
        e("./base64");
        var r = e("./array");
        function s(...o) {
          return console.warn("new SafeBuffer() is depreciated, please use SafeBuffer.from()"), s.from(...o);
        }
        s.prototype = Object.create(Array.prototype), Object.assign(s, {
          // (data, enc) where typeof data === 'string' then enc === 'utf8'|'hex'|'base64'
          from() {
            if (!Object.keys(arguments).length || arguments[0] == null)
              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            const o = arguments[0];
            let a;
            if (typeof o == "string") {
              const c = arguments[1] || "utf8";
              if (c === "hex") {
                const l = o.match(/([\da-fA-F]{2})/g).map((h) => parseInt(h, 16));
                if (!l || !l.length)
                  throw new TypeError("Invalid first argument for type 'hex'.");
                a = r.from(l);
              } else if (c === "utf8" || c === "binary") {
                const l = o.length, h = new Uint16Array(l);
                Array.from({ length: l }, (f, d) => h[d] = o.charCodeAt(d)), a = r.from(h);
              } else if (c === "base64") {
                const l = atob(o), h = l.length, f = new Uint8Array(h);
                Array.from({ length: h }, (d, p) => f[p] = l.charCodeAt(p)), a = r.from(f);
              } else c === "binary" ? a = r.from(o) : console.info("SafeBuffer.from unknown encoding: " + c);
              return a;
            }
            if (o.byteLength, o.byteLength ? o.byteLength : o.length) {
              let c;
              return o instanceof ArrayBuffer && (c = new Uint8Array(o)), r.from(c || o);
            }
          },
          // This is 'safe-buffer.alloc' sans encoding support
          alloc(o, a = 0) {
            return r.from(new Uint8Array(Array.from({ length: o }, () => a)));
          },
          // This is normal UNSAFE 'buffer.alloc' or 'new Buffer(length)' - don't use!
          allocUnsafe(o) {
            return r.from(new Uint8Array(Array.from({ length: o })));
          },
          // This puts together array of array like members
          concat(o) {
            if (!Array.isArray(o))
              throw new TypeError("First argument must be Array containing ArrayBuffer or Uint8Array instances.");
            return r.from(o.reduce((a, u) => a.concat(Array.from(u)), []));
          }
        }), s.prototype.from = s.from, s.prototype.toString = r.prototype.toString, i.exports = s;
      })(e, "./buffer"), e(function(i) {
        const r = e("./root"), s = { Buffer: e("./buffer") };
        var o = {}, a;
        if (JSON.parseAsync = JSON.parseAsync || function(c, l, h) {
          var f;
          try {
            l(f, JSON.parse(c, h));
          } catch (d) {
            l(d);
          }
        }, JSON.stringifyAsync = JSON.stringifyAsync || function(c, l, h, f) {
          var d;
          try {
            l(d, JSON.stringify(c, h, f));
          } catch (p) {
            l(p);
          }
        }, s.parse = function(c, l) {
          return new Promise(function(h, f) {
            JSON.parseAsync(c, function(d, p) {
              d ? f(d) : h(p);
            }, l);
          });
        }, s.stringify = function(c, l, h) {
          return new Promise(function(f, d) {
            JSON.stringifyAsync(c, function(p, m) {
              p ? d(p) : f(m);
            }, l, h);
          });
        }, r.window && (s.crypto = r.window.crypto || r.window.msCrypto, s.subtle = (s.crypto || o).subtle || (s.crypto || o).webkitSubtle, s.TextEncoder = r.window.TextEncoder, s.TextDecoder = r.window.TextDecoder, s.random = (c) => s.Buffer.from(s.crypto.getRandomValues(new Uint8Array(s.Buffer.alloc(c))))), !s.TextDecoder) {
          const { TextEncoder: c, TextDecoder: l } = e((a + "" == typeof n ? "." : "") + "./lib/text-encoding", 1);
          s.TextDecoder = l, s.TextEncoder = c;
        }
        if (!s.crypto)
          try {
            var u = e("crypto", 1);
            Object.assign(s, {
              crypto: u,
              random: (l) => s.Buffer.from(u.randomBytes(l))
            });
            const { Crypto: c } = e("@peculiar/webcrypto", 1);
            s.ossl = s.subtle = new c({ directory: "ossl" }).subtle;
          } catch {
            console.log("Please `npm install @peculiar/webcrypto` or add it to your package.json !");
          }
        i.exports = s;
      })(e, "./shim"), e(function(i) {
        var r = e("./root"), s = e("./shim"), o = {};
        o.pbkdf2 = { hash: { name: "SHA-256" }, iter: 1e5, ks: 64 }, o.ecdsa = {
          pair: { name: "ECDSA", namedCurve: "P-256" },
          sign: { name: "ECDSA", hash: { name: "SHA-256" } }
        }, o.ecdh = { name: "ECDH", namedCurve: "P-256" }, o.jwk = function(a, u) {
          a = a.split(".");
          var c = a[0], l = a[1], h = { kty: "EC", crv: "P-256", x: c, y: l, ext: !0 };
          return h.key_ops = u ? ["sign"] : ["verify"], u && (h.d = u), h;
        }, o.keyToJwk = function(a) {
          return { kty: "oct", k: a.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, ""), ext: !1, alg: "A256GCM" };
        }, o.recall = {
          validity: 12 * 60 * 60,
          // internally in seconds : 12 hours
          hook: function(a) {
            return a;
          }
          // { iat, exp, alias, remember } // or return new Promise((resolve, reject) => resolve(props)
        }, o.check = function(a) {
          return typeof a == "string" && a.slice(0, 4) === "SEA{";
        }, o.parse = async function(u) {
          try {
            var c = typeof u == "string";
            return c && u.slice(0, 4) === "SEA{" && (u = u.slice(3)), c ? await s.parse(u) : u;
          } catch {
          }
          return u;
        }, r.opt = o, i.exports = o;
      })(e, "./settings"), e(function(i) {
        var r = e("./shim");
        i.exports = async function(s, o) {
          var a = typeof s == "string" ? s : await r.stringify(s), u = await r.subtle.digest({ name: o || "SHA-256" }, new r.TextEncoder().encode(a));
          return r.Buffer.from(u);
        };
      })(e, "./sha256"), e(function(i) {
        const r = e("./shim"), s = r.subtle, o = r.ossl ? r.ossl : s, a = (u) => o.digest({ name: "SHA-1" }, new ArrayBuffer(u));
        i.exports = a;
      })(e, "./sha1"), e(function(i) {
        var r = e("./root"), s = e("./shim"), o = e("./settings"), a = e("./sha256"), u;
        r.work = r.work || (async (c, l, h, f) => {
          try {
            var d = (l || {}).epub || l;
            if (f = f || {}, d instanceof Function && (h = d, d = u), c = typeof c == "string" ? c : await s.stringify(c), (f.name || "").toLowerCase().slice(0, 3) === "sha") {
              var p = s.Buffer.from(await a(c, f.name), "binary").toString(f.encode || "base64");
              if (h)
                try {
                  h(p);
                } catch (b) {
                  console.log(b);
                }
              return p;
            }
            d = d || s.random(9);
            var m = await (s.ossl || s.subtle).importKey("raw", new s.TextEncoder().encode(c), { name: f.name || "PBKDF2" }, !1, ["deriveBits"]), _ = await (s.ossl || s.subtle).deriveBits({
              name: f.name || "PBKDF2",
              iterations: f.iterations || o.pbkdf2.iter,
              salt: new s.TextEncoder().encode(f.salt || d),
              hash: f.hash || o.pbkdf2.hash
            }, m, f.length || o.pbkdf2.ks * 8);
            c = s.random(c.length);
            var y = s.Buffer.from(_, "binary").toString(f.encode || "base64");
            if (h)
              try {
                h(y);
              } catch (b) {
                console.log(b);
              }
            return y;
          } catch (b) {
            if (console.log(b), r.err = b, r.throw)
              throw b;
            h && h();
            return;
          }
        }), i.exports = r.work;
      })(e, "./work"), e(function(i) {
        var r = e("./root"), s = e("./shim");
        e("./settings"), r.name = r.name || (async (o, a) => {
          try {
            if (o)
              try {
                o();
              } catch (u) {
                console.log(u);
              }
            return;
          } catch (u) {
            if (console.log(u), r.err = u, r.throw)
              throw u;
            o && o();
            return;
          }
        }), r.pair = r.pair || (async (o, a) => {
          try {
            var u = s.ossl || s.subtle, c = await s.subtle.generateKey({ name: "ECDSA", namedCurve: "P-256" }, !0, ["sign", "verify"]).then(async (f) => {
              var d = {};
              d.priv = (await s.subtle.exportKey("jwk", f.privateKey)).d;
              var p = await s.subtle.exportKey("jwk", f.publicKey);
              return d.pub = p.x + "." + p.y, d;
            });
            try {
              var l = await u.generateKey({ name: "ECDH", namedCurve: "P-256" }, !0, ["deriveKey"]).then(async (f) => {
                var d = {};
                d.epriv = (await u.exportKey("jwk", f.privateKey)).d;
                var p = await u.exportKey("jwk", f.publicKey);
                return d.epub = p.x + "." + p.y, d;
              });
            } catch (f) {
              if (r.window)
                throw f;
              if (f == "Error: ECDH is not a supported algorithm")
                console.log("Ignoring ECDH...");
              else
                throw f;
            }
            l = l || {};
            var h = {
              pub: c.pub,
              priv: c.priv,
              /* pubId, */
              epub: l.epub,
              epriv: l.epriv
            };
            if (o)
              try {
                o(h);
              } catch (f) {
                console.log(f);
              }
            return h;
          } catch (f) {
            if (console.log(f), r.err = f, r.throw)
              throw f;
            o && o();
            return;
          }
        }), i.exports = r.pair;
      })(e, "./pair"), e(function(i) {
        var r = e("./root"), s = e("./shim"), o = e("./settings"), a = e("./sha256"), u;
        r.sign = r.sign || (async (c, l, h, f) => {
          try {
            if (f = f || {}, !(l || f).priv) {
              if (!r.I)
                throw "No signing key.";
              l = await r.I(null, { what: c, how: "sign", why: f.why });
            }
            if (u === c)
              throw "`undefined` not allowed.";
            var d = await o.parse(c), p = f.check = f.check || d;
            if (r.verify && (r.opt.check(p) || p && p.s && p.m) && u !== await r.verify(p, l)) {
              var v = await o.parse(p);
              if (f.raw || (v = "SEA" + await s.stringify(v)), h)
                try {
                  h(v);
                } catch (E) {
                  console.log(E);
                }
              return v;
            }
            var m = l.pub, _ = l.priv, y = o.jwk(m, _), b = await a(d), g = await (s.ossl || s.subtle).importKey("jwk", y, { name: "ECDSA", namedCurve: "P-256" }, !1, ["sign"]).then((w) => (s.ossl || s.subtle).sign({ name: "ECDSA", hash: { name: "SHA-256" } }, w, new Uint8Array(b))), v = { m: d, s: s.Buffer.from(g, "binary").toString(f.encode || "base64") };
            if (f.raw || (v = "SEA" + await s.stringify(v)), h)
              try {
                h(v);
              } catch (w) {
                console.log(w);
              }
            return v;
          } catch (w) {
            if (console.log(w), r.err = w, r.throw)
              throw w;
            h && h();
            return;
          }
        }), i.exports = r.sign;
      })(e, "./sign"), e(function(i) {
        var r = e("./root"), s = e("./shim"), o = e("./settings"), a = e("./sha256"), u;
        r.verify = r.verify || (async (h, f, d, p) => {
          try {
            var m = await o.parse(h);
            if (f === !1) {
              var _ = await o.parse(m.m);
              if (d)
                try {
                  d(_);
                } catch (O) {
                  console.log(O);
                }
              return _;
            }
            p = p || {};
            var y = f.pub || f, b = r.opt.slow_leak ? await r.opt.slow_leak(y) : await (s.ossl || s.subtle).importKey("jwk", o.jwk(y), { name: "ECDSA", namedCurve: "P-256" }, !1, ["verify"]), g = await a(m.m), v, w, E, A;
            try {
              if (v = s.Buffer.from(m.s, p.encode || "base64"), w = new Uint8Array(v), E = await (s.ossl || s.subtle).verify({ name: "ECDSA", hash: { name: "SHA-256" } }, b, w, new Uint8Array(g)), !E)
                throw "Signature did not match.";
            } catch {
              if (r.opt.fallback)
                return await r.opt.fall_verify(h, f, d, p);
            }
            var C = E ? await o.parse(m.m) : u;
            if (d)
              try {
                d(C);
              } catch (O) {
                console.log(O);
              }
            return C;
          } catch (O) {
            if (console.log(O), r.err = O, r.throw)
              throw O;
            d && d();
            return;
          }
        }), i.exports = r.verify;
        var c = {};
        r.opt.slow_leak = (h) => {
          if (c[h]) return c[h];
          var f = o.jwk(h);
          return c[h] = (s.ossl || s.subtle).importKey("jwk", f, { name: "ECDSA", namedCurve: "P-256" }, !1, ["verify"]), c[h];
        };
        var l = r.opt;
        r.opt.fall_verify = async function(h, f, d, p, m) {
          if (m === r.opt.fallback)
            throw "Signature did not match";
          m = m || 1;
          var _ = h || "";
          h = r.opt.unpack(h) || h;
          var y = await o.parse(h), b = f.pub || f, g = await r.opt.slow_leak(b), v = m <= r.opt.fallback ? s.Buffer.from(await s.subtle.digest({ name: "SHA-256" }, new s.TextEncoder().encode(await o.parse(y.m)))) : await a(y.m), w, E, A;
          try {
            if (w = s.Buffer.from(y.s, p.encode || "base64"), E = new Uint8Array(w), A = await (s.ossl || s.subtle).verify({ name: "ECDSA", hash: { name: "SHA-256" } }, g, E, new Uint8Array(v)), !A)
              throw "Signature did not match.";
          } catch {
            try {
              w = s.Buffer.from(y.s, "utf8"), E = new Uint8Array(w), A = await (s.ossl || s.subtle).verify({ name: "ECDSA", hash: { name: "SHA-256" } }, g, E, new Uint8Array(v));
            } catch {
              if (!A)
                throw "Signature did not match.";
            }
          }
          var C = A ? await o.parse(y.m) : u;
          if (l.fall_soul = _["#"], l.fall_key = _["."], l.fall_val = h, l.fall_state = _[">"], d)
            try {
              d(C);
            } catch (O) {
              console.log(O);
            }
          return C;
        }, r.opt.fallback = 2;
      })(e, "./verify"), e(function(i) {
        var r = e("./shim"), s = e("./settings"), o = e("./sha256");
        const a = async (u, c, l) => {
          const h = u + (c || r.random(8)).toString("utf8"), f = r.Buffer.from(await o(h), "binary"), d = s.keyToJwk(f);
          return await r.subtle.importKey("jwk", d, { name: "AES-GCM" }, !1, ["encrypt", "decrypt"]);
        };
        i.exports = a;
      })(e, "./aeskey"), e(function(i) {
        var r = e("./root"), s = e("./shim");
        e("./settings");
        var o = e("./aeskey"), a;
        r.encrypt = r.encrypt || (async (u, c, l, h) => {
          try {
            h = h || {};
            var f = (c || h).epriv || c;
            if (a === u)
              throw "`undefined` not allowed.";
            if (!f) {
              if (!r.I)
                throw "No encryption key.";
              c = await r.I(null, { what: u, how: "encrypt", why: h.why }), f = c.epriv || c;
            }
            var d = typeof u == "string" ? u : await s.stringify(u), p = { s: s.random(9), iv: s.random(15) }, m = await o(f, p.s, h).then((y) => (
              /*shim.ossl ||*/
              s.subtle.encrypt({
                // Keeping the AES key scope as private as possible...
                name: h.name || "AES-GCM",
                iv: new Uint8Array(p.iv)
              }, y, new s.TextEncoder().encode(d))
            )), _ = {
              ct: s.Buffer.from(m, "binary").toString(h.encode || "base64"),
              iv: p.iv.toString(h.encode || "base64"),
              s: p.s.toString(h.encode || "base64")
            };
            if (h.raw || (_ = "SEA" + await s.stringify(_)), l)
              try {
                l(_);
              } catch (y) {
                console.log(y);
              }
            return _;
          } catch (y) {
            if (console.log(y), r.err = y, r.throw)
              throw y;
            l && l();
            return;
          }
        }), i.exports = r.encrypt;
      })(e, "./encrypt"), e(function(i) {
        var r = e("./root"), s = e("./shim"), o = e("./settings"), a = e("./aeskey");
        r.decrypt = r.decrypt || (async (u, c, l, h) => {
          try {
            h = h || {};
            var f = (c || h).epriv || c;
            if (!f) {
              if (!r.I)
                throw "No decryption key.";
              c = await r.I(null, { what: u, how: "decrypt", why: h.why }), f = c.epriv || c;
            }
            var d = await o.parse(u), p, m, _;
            try {
              p = s.Buffer.from(d.s, h.encode || "base64"), m = s.Buffer.from(d.iv, h.encode || "base64"), _ = s.Buffer.from(d.ct, h.encode || "base64");
              var y = await a(f, p, h).then((g) => (
                /*shim.ossl ||*/
                s.subtle.decrypt({
                  // Keeping aesKey scope as private as possible...
                  name: h.name || "AES-GCM",
                  iv: new Uint8Array(m),
                  tagLength: 128
                }, g, new Uint8Array(_))
              ));
            } catch {
              if (h.encode === "utf8")
                throw "Could not decrypt";
              if (r.opt.fallback)
                return h.encode = "utf8", await r.decrypt(u, c, l, h);
            }
            var b = await o.parse(new s.TextDecoder("utf8").decode(y));
            if (l)
              try {
                l(b);
              } catch (g) {
                console.log(g);
              }
            return b;
          } catch (g) {
            if (console.log(g), r.err = g, r.throw)
              throw g;
            l && l();
            return;
          }
        }), i.exports = r.decrypt;
      })(e, "./decrypt"), e(function(i) {
        var r = e("./root"), s = e("./shim");
        e("./settings"), r.secret = r.secret || (async (a, u, c, l) => {
          try {
            if (l = l || {}, !u || !u.epriv || !u.epub) {
              if (!r.I)
                throw "No secret mix.";
              u = await r.I(null, { what: a, how: "secret", why: l.why });
            }
            var h = a.epub || a, f = u.epub, d = u.epriv, p = s.ossl || s.subtle, m = o(h), _ = Object.assign({ public: await p.importKey(...m, !0, []) }, { name: "ECDH", namedCurve: "P-256" }), y = o(f, d), b = await p.importKey(...y, !1, ["deriveBits"]).then(async (v) => {
              var w = await p.deriveBits(_, v, 256), E = new Uint8Array(w), A = await p.importKey("raw", E, { name: "AES-GCM", length: 256 }, !0, ["encrypt", "decrypt"]);
              return p.exportKey("jwk", A).then(({ k: C }) => C);
            }), g = b;
            if (c)
              try {
                c(g);
              } catch (v) {
                console.log(v);
              }
            return g;
          } catch (v) {
            if (console.log(v), r.err = v, r.throw)
              throw v;
            c && c();
            return;
          }
        });
        var o = (a, u) => {
          var [c, l] = a.split("."), h = u ? { d: u } : {};
          return [
            // Use with spread returned value...
            "jwk",
            Object.assign(
              h,
              { x: c, y: l, kty: "EC", crv: "P-256", ext: !0 }
            ),
            // ??? refactor
            { name: "ECDH", namedCurve: "P-256" }
          ];
        };
        i.exports = r.secret;
      })(e, "./secret"), e(function(i) {
        var r = e("./root");
        r.certify = r.certify || (async (s, o = {}, a, u, c = {}) => {
          try {
            if (console.log("SEA.certify() is an early experimental community supported method that may change API behavior without warning in any future version."), s = (() => {
              var g = [];
              if (s) {
                if ((typeof s == "string" || Array.isArray(s)) && s.indexOf("*") > -1) return "*";
                if (typeof s == "string") return s;
                if (Array.isArray(s)) {
                  if (s.length === 1 && s[0]) return typeof s[0] == "object" && s[0].pub ? s[0].pub : typeof s[0] == "string" ? s[0] : null;
                  s.map((v) => {
                    typeof v == "string" ? g.push(v) : typeof v == "object" && v.pub && g.push(v.pub);
                  });
                }
                return typeof s == "object" && s.pub ? s.pub : g.length > 0 ? g : null;
              }
            })(), !s) return console.log("No certificant found.");
            const h = c.expiry && (typeof c.expiry == "number" || typeof c.expiry == "string") ? parseFloat(c.expiry) : null, f = (o || {}).read ? o.read : null, d = (o || {}).write ? o.write : typeof o == "string" || Array.isArray(o) || o["+"] || o["#"] || o["."] || o["="] || o["*"] || o[">"] || o["<"] ? o : null, p = (c || {}).block || (c || {}).blacklist || (c || {}).ban || {}, m = p.read && (typeof p.read == "string" || (p.read || {})["#"]) ? p.read : null, _ = typeof p == "string" ? p : p.write && (typeof p.write == "string" || p.write["#"]) ? p.write : null;
            if (!f && !d) return console.log("No policy found.");
            const y = JSON.stringify({
              c: s,
              ...h ? { e: h } : {},
              // inject expiry if possible
              ...f ? { r: f } : {},
              // "r" stands for read, which means read permission.
              ...d ? { w: d } : {},
              // "w" stands for write, which means write permission.
              ...m ? { rb: m } : {},
              // inject READ block if possible
              ..._ ? { wb: _ } : {}
              // inject WRITE block if possible
            });
            var l = await r.sign(y, a, null, { raw: 1 });
            if (c.raw || (l = "SEA" + JSON.stringify(l)), u)
              try {
                u(l);
              } catch (g) {
                console.log(g);
              }
            return l;
          } catch (h) {
            if (r.err = h, r.throw)
              throw h;
            u && u();
            return;
          }
        }), i.exports = r.certify;
      })(e, "./certify"), e(function(i) {
        var r = e("./shim"), s = e("./root");
        s.work = e("./work"), s.sign = e("./sign"), s.verify = e("./verify"), s.encrypt = e("./encrypt"), s.decrypt = e("./decrypt"), s.certify = e("./certify"), s.random = s.random || r.random, s.Buffer = s.Buffer || e("./buffer"), s.keyid = s.keyid || (async (o) => {
          try {
            const a = r.Buffer.concat(
              o.replace(/-/g, "+").replace(/_/g, "/").split(".").map((h) => r.Buffer.from(h, "base64"))
            ), u = r.Buffer.concat([
              r.Buffer.from([153, a.length / 256, a.length % 256]),
              a
            ]), c = await sha1hash(u), l = r.Buffer.from(c, "binary");
            return l.toString("hex", l.length - 8);
          } catch (a) {
            throw console.log(a), a;
          }
        }), ((s.window || {}).GUN || {}).SEA = s, i.exports = s;
      })(e, "./sea"), e(function(i) {
        var r = e("./sea"), s, o;
        r.window ? s = r.window.GUN || { chain: {} } : s = e((o + "" == typeof n ? "." : "") + "./gun", 1), r.GUN = s;
        function a(c) {
          this._ = { $: this };
        }
        a.prototype = function() {
          function c() {
          }
          return c.prototype = s.chain, new c();
        }(), a.prototype.constructor = a, s.chain.user = function(c) {
          var l = this, f = l.back(-1), h;
          if (c)
            return c = r.opt.pub((c._ || "")["#"]) || c, f.get("~" + c);
          if (h = f.back("user"))
            return h;
          var f = f._, d = f, p = d.opt.uuid || u;
          return (d = (h = d.user = l.chain(new a()))._).opt = {}, d.opt.uuid = function(m) {
            var _ = p(), y = f.user;
            return !y || !(y = y.is) || !(y = y.pub) || (_ = "~" + y + "/" + _, m && m.call && m(null, _)), _;
          }, h;
        };
        function u() {
          return s.state().toString(36).replace(".", "");
        }
        s.User = a, a.GUN = s, a.SEA = s.SEA = r, i.exports = a;
      })(e, "./user"), e(function(i) {
        var r, s = "" + r != typeof GUN ? GUN || { chain: {} } : e(("" + r == typeof n ? "." : "") + "./gun", 1);
        s.chain.then = function(o, a) {
          var u = this, c = new Promise(function(l, h) {
            u.once(l, a);
          });
          return o ? c.then(o) : c;
        };
      })(e, "./then"), e(function(i) {
        var r = e("./user"), s = r.SEA, o = r.GUN, a = function() {
        };
        r.prototype.create = function(...u) {
          var c = typeof u[0] == "object" && (u[0].pub || u[0].epub) ? u[0] : typeof u[1] == "object" && (u[1].pub || u[1].epub) ? u[1] : null, l = c && (c.pub || c.epub) ? c.pub : typeof u[0] == "string" ? u[0] : null, h = c && (c.pub || c.epub) ? c : l && typeof u[1] == "string" ? u[1] : null, f = u.filter((g) => typeof g == "function")[0] || null, d = u && u.length > 1 && typeof u[u.length - 1] == "object" ? u[u.length - 1] : {}, p = this, m = p._, _ = p.back(-1);
          if (f = f || a, d = d || {}, d.check !== !1) {
            var y;
            if (l || (y = "No user."), (h || "").length < 8 && (y = "Password too short!"), y)
              return f({ err: o.log(y) }), p;
          }
          if (m.ing)
            return (f || a)({ err: o.log("User is already being created or authenticated!"), wait: !0 }), p;
          m.ing = !0;
          var b = {};
          return b.a = function(g) {
            if (b.pubs = g, g && !d.already) {
              var v = { err: o.log("User already created!") };
              m.ing = !1, (f || a)(v), p.leave();
              return;
            }
            b.salt = String.random(64), s.work(h, b.salt, b.b);
          }, b.b = function(g) {
            b.proof = g, c ? b.c(c) : s.pair(b.c);
          }, b.c = function(g) {
            var v;
            b.pair = g || {}, (v = m.root.user) && (v._.sea = g, v.is = { pub: g.pub, epub: g.epub, alias: l }), b.data = { pub: g.pub }, b.d();
          }, b.d = function() {
            b.data.alias = l, b.e();
          }, b.e = function() {
            b.data.epub = b.pair.epub, s.encrypt({ priv: b.pair.priv, epriv: b.pair.epriv }, b.proof, b.f, { raw: 1 });
          }, b.f = function(g) {
            b.data.auth = JSON.stringify({ ek: g, s: b.salt }), b.g(b.data.auth);
          }, b.g = function(g) {
            var v;
            b.data.auth = b.data.auth || g, _.get(v = "~" + b.pair.pub).put(b.data).on(b.h);
            var w = {};
            w[v] = { "#": v }, _.get("~@" + l).put(w).get(v).on(b.i);
          }, b.h = function(g, v, w, E) {
            E.off(), b.h.ok = 1, b.i();
          }, b.i = function(g, v, w, E) {
            E && (b.i.ok = 1, E.off()), !(!b.h.ok || !b.i.ok) && (m.ing = !1, f({ ok: 0, pub: b.pair.pub }), a === f && (c ? p.auth(c) : p.auth(l, h)));
          }, _.get("~@" + l).once(b.a), p;
        }, r.prototype.leave = function(u, c) {
          var l = this, h = l.back(-1)._.user;
          if (h && (delete h.is, delete h._.is, delete h._.sea), s.window)
            try {
              var f = {};
              f = s.window.sessionStorage, delete f.recall, delete f.pair;
            } catch {
            }
          return l;
        };
      })(e, "./create"), e(function(i) {
        var r = e("./user"), s = r.SEA, o = r.GUN, a = function() {
        };
        r.prototype.auth = function(...c) {
          var l = typeof c[0] == "object" && (c[0].pub || c[0].epub) ? c[0] : typeof c[1] == "object" && (c[1].pub || c[1].epub) ? c[1] : null, h = !l && typeof c[0] == "string" ? c[0] : null, f = (h || l && !(l.priv && l.epriv)) && typeof c[1] == "string" ? c[1] : null, d = c.filter((w) => typeof w == "function")[0] || null, p = c && c.length > 1 && typeof c[c.length - 1] == "object" ? c[c.length - 1] : {}, m = this, _ = m._, y = m.back(-1);
          if (_.ing)
            return (d || a)({ err: o.log("User is already being created or authenticated!"), wait: !0 }), m;
          _.ing = !0;
          var b = {}, g, v = 9;
          return b.a = function(w) {
            if (!w)
              return b.b();
            if (!w.pub) {
              var E = [];
              return Object.keys(w).forEach(function(A) {
                A != "_" && E.push(w[A]);
              }), b.b(E);
            }
            if (b.name)
              return b.f(w);
            b.c((b.data = w).auth);
          }, b.b = function(w) {
            var E = (b.list = (b.list || []).concat(w || [])).shift();
            if (g === E) {
              if (b.name)
                return b.err("Your user account is not published for dApps to access, please consider syncing it online, or allowing local access by adding your device as a peer.");
              if (h && v--) {
                y.get("~@" + h).once(b.a);
                return;
              }
              return b.err("Wrong user or password.");
            }
            y.get(E).once(b.a);
          }, b.c = function(w) {
            if (g === w)
              return b.b();
            if (typeof w == "string")
              return b.c(u(w));
            s.work(f, (b.auth = w).s, b.d, b.enc);
          }, b.d = function(w) {
            s.decrypt(b.auth.ek, w, b.e, b.enc);
          }, b.e = function(w) {
            if (g === w)
              return b.enc ? (b.enc = null, b.b()) : (b.enc = { encode: "utf8" }, b.c(b.auth));
            b.half = w, b.f(b.data);
          }, b.f = function(w) {
            var E = b.half || {}, A = b.data || {};
            b.g(b.lol = { pub: w.pub || A.pub, epub: w.epub || A.epub, priv: w.priv || E.priv, epriv: w.epriv || E.epriv });
          }, b.g = function(w) {
            if (!w || !w.pub || !w.epub)
              return b.b();
            b.pair = w;
            var E = y._.user, A = E._;
            A.tag;
            var C = A.opt;
            A = E._ = y.get("~" + w.pub)._, A.opt = C, E.is = { pub: w.pub, epub: w.epub, alias: h || w.pub }, A.sea = b.pair, _.ing = !1;
            try {
              f && g == (u(_.root.graph["~" + w.pub].auth) || "")[":"] && (p.shuffle = p.change = f);
            } catch {
            }
            if (p.change ? b.z() : (d || a)(A), s.window && (m.back("user")._.opt || p).remember)
              try {
                var O = {};
                O = s.window.sessionStorage, O.recall = !0, O.pair = JSON.stringify(w);
              } catch {
              }
            try {
              y._.tag.auth ? y._.on("auth", A) : setTimeout(function() {
                y._.on("auth", A);
              }, 1);
            } catch (R) {
              o.log("Your 'auth' callback crashed with:", R);
            }
          }, b.h = function(w) {
            if (!w)
              return b.b();
            if (h = w.alias, h || (h = w.alias = "~" + l.pub), !w.auth)
              return b.g(l);
            l = null, b.c((b.data = w).auth);
          }, b.z = function() {
            b.salt = String.random(64), s.work(p.change, b.salt, b.y);
          }, b.y = function(w) {
            s.encrypt({ priv: b.pair.priv, epriv: b.pair.epriv }, w, b.x, { raw: 1 });
          }, b.x = function(w) {
            b.w(JSON.stringify({ ek: w, s: b.salt }));
          }, b.w = function(w) {
            if (p.shuffle) {
              console.log("migrate core account from UTF8 & shuffle");
              var E = {};
              Object.keys(b.data).forEach(function(A) {
                E[A] = b.data[A];
              }), delete E._, E.auth = w, y.get("~" + b.pair.pub).put(E);
            }
            y.get("~" + b.pair.pub).get("auth").put(w, d || a);
          }, b.err = function(w) {
            var E = { err: o.log(w || "User cannot be found!") };
            _.ing = !1, (d || a)(E);
          }, b.plugin = function(w) {
            if (!(b.name = w))
              return b.err();
            var E = [w];
            w[0] !== "~" && (E[1] = "~" + w, E[2] = "~@" + w), b.b(E);
          }, l ? l.priv && l.epriv ? b.g(l) : y.get("~" + l.pub).once(b.h) : h ? y.get("~@" + h).once(b.a) : !h && !f && s.name(b.plugin), m;
        };
        function u(c) {
          if (typeof c != "string")
            return c;
          try {
            c = JSON.parse(c);
          } catch {
            c = {};
          }
          return c;
        }
      })(e, "./auth"), e(function(i) {
        var r = e("./user"), s = r.SEA;
        r.GUN, r.prototype.recall = function(o, a) {
          var u = this, c = u.back(-1);
          if (o = o || {}, o && o.sessionStorage) {
            if (s.window)
              try {
                var l = {};
                l = s.window.sessionStorage, l && (c._.opt.remember = !0, (u.back("user")._.opt || o).remember = !0, (l.recall || l.pair) && c.user().auth(JSON.parse(l.pair), a));
              } catch {
              }
            return u;
          }
          return u;
        };
      })(e, "./recall"), e(function(i) {
        var r = e("./user"), s = r.SEA, o = r.GUN, a = function() {
        };
        r.prototype.pair = function() {
          var u = this, c;
          try {
            c = new Proxy({ DANGER: "☠" }, { get: function(l, h, f) {
              if (!(!u.is || !(u._ || "").sea))
                return u._.sea[h];
            } });
          } catch {
          }
          return c;
        }, r.prototype.delete = async function(u, c, l) {
          console.log("user.delete() IS DEPRECATED AND WILL BE MOVED TO A MODULE!!!");
          var h = this;
          h.back(-1);
          var f = h.back("user");
          try {
            f.auth(u, c, function(d) {
              var p = (f.is || {}).pub;
              f.map().once(function() {
                this.put(null);
              }), f.leave(), (l || a)({ ok: 0 });
            });
          } catch (d) {
            o.log("User.delete failed! Error:", d);
          }
          return h;
        }, r.prototype.alive = async function() {
          console.log("user.alive() IS DEPRECATED!!!");
          const u = this.back(-1);
          try {
            return await authRecall(u), u._.user._;
          } catch {
            const l = "No session!";
            throw o.log(l), { err: l };
          }
        }, r.prototype.trust = async function(u) {
          console.log("`.trust` API MAY BE DELETED OR CHANGED OR RENAMED, DO NOT USE!"), o.is(u) && u.get("pub").get((c, l) => {
            console.log(c, l);
          }), u.get("trust").get(path).put(theirPubkey);
        }, r.prototype.grant = function(u, c) {
          console.log("`.grant` API MAY BE DELETED OR CHANGED OR RENAMED, DO NOT USE!");
          var l = this, h = l.back(-1).user(), f = h._.sea, d = "";
          return l.back(function(p) {
            p.is || (d += p.get || "");
          }), async function() {
            var p, m = await h.get("grant").get(f.pub).get(d).then();
            m = await s.decrypt(m, f), m || (m = s.random(16).toString(), p = await s.encrypt(m, f), h.get("grant").get(f.pub).get(d).put(p));
            var _ = u.get("pub").then(), y = u.get("epub").then();
            _ = await _, y = await y;
            var b = await s.secret(y, f);
            p = await s.encrypt(m, b), h.get("grant").get(_).get(d).put(p, c);
          }(), l;
        }, r.prototype.secret = function(u, c) {
          console.log("`.secret` API MAY BE DELETED OR CHANGED OR RENAMED, DO NOT USE!");
          var l = this, h = l.back(-1).user(), f = h.pair(), d = "";
          return l.back(function(p) {
            p.is || (d += p.get || "");
          }), async function() {
            var p, m = await h.get("trust").get(f.pub).get(d).then();
            m = await s.decrypt(m, f), m || (m = s.random(16).toString(), p = await s.encrypt(m, f), h.get("trust").get(f.pub).get(d).put(p)), p = await s.encrypt(u, m), l.put(p, c);
          }(), l;
        }, i.exports = r;
      })(e, "./share"), e(function(i) {
        var r = e("./sea"), s = e("./settings"), o, a = (r.window || "").GUN || e(("" + o == typeof n ? "." : "") + "./gun", 1);
        a.on("opt", function(p) {
          p.sea || (p.sea = { own: {} }, p.on("put", u, p)), this.to.next(p);
        });
        function u(p) {
          var m = this, _ = m.as, y = p.put, b = y["#"], g = y["."], v = y[":"], w = y[">"], E = p["#"], A;
          if (!(!b || !g)) {
            if ((p._ || "").faith && (_.opt || "").faith && typeof p._ == "function") {
              r.opt.pack(y, function(O) {
                r.verify(O, !1, function(R) {
                  y["="] = r.opt.unpack(R), m.to.next(p);
                });
              });
              return;
            }
            var C = function(O) {
              _.on("in", { "@": E, err: p.err = O });
            };
            if ((p._ || "").DBG && ((p._ || "").DBG.c = +/* @__PURE__ */ new Date()), 0 <= b.indexOf("<?") && (A = parseFloat(b.split("<?")[1] || ""), A && w < a.state() - A * 1e3)) {
              (A = p._) && A.stun && A.stun--;
              return;
            }
            if (b === "~@") {
              u.alias(m, p, v, g, b, _, C);
              return;
            }
            if (b.slice(0, 2) === "~@") {
              u.pubs(m, p, v, g, b, _, C);
              return;
            }
            if (A = r.opt.pub(b)) {
              u.pub(m, p, v, g, b, _, C, _.user || "", A);
              return;
            }
            if (0 <= b.indexOf("#")) {
              u.hash(m, p, v, g, b, _, C);
              return;
            }
            u.any(m, p, v, g, b, _, C, _.user || "");
          }
        }
        u.hash = function(p, m, _, y, b, g, v) {
          r.work(_, null, function(w) {
            function E(A) {
              let C = "";
              for (let O = 0; O < A.length; O++)
                C += O - 1 & 1 ? "" : String.fromCharCode(parseInt(A.substring(O - 1, O + 1), 16));
              return btoa(C);
            }
            if (w && w === y.split("#").slice(-1)[0])
              return p.to.next(m);
            if (w && w === E(y.split("#").slice(-1)[0]))
              return p.to.next(m);
            v("Data hash not same as hash!");
          }, { name: "SHA-256" });
        }, u.alias = function(p, m, _, y, b, g, v) {
          if (!_)
            return v("Data must exist!");
          if ("~@" + y === l(_))
            return p.to.next(m);
          v("Alias not same!");
        }, u.pubs = function(p, m, _, y, b, g, v) {
          if (!_)
            return v("Alias must exist!");
          if (y === l(_))
            return p.to.next(m);
          v("Alias not same!");
        }, u.pub = async function(p, m, _, y, b, g, v, w, E) {
          var A;
          const C = await s.parse(_) || {}, O = (R, P, k) => {
            if (R.m && R.s && P && E)
              return r.verify(R, E, (S) => {
                if (o !== S && o !== S.e && m.put[">"] && m.put[">"] > parseFloat(S.e)) return v("Certificate expired.");
                if (o !== S && S.c && S.w && (S.c === P || S.c.indexOf("*") > -1)) {
                  let I = b.indexOf("/") > -1 ? b.replace(b.substring(0, b.indexOf("/") + 1), "") : "";
                  String.match = String.match || a.text.match;
                  const F = Array.isArray(S.w) ? S.w : typeof S.w == "object" || typeof S.w == "string" ? [S.w] : [];
                  for (const T of F)
                    if (String.match(I, T["#"]) && String.match(y, T["."]) || !T["."] && String.match(I, T["#"]) || !T["#"] && String.match(y, T["."]) || String.match(I ? I + "/" + y : y, T["#"] || T)) {
                      if (T["+"] && T["+"].indexOf("*") > -1 && I && I.indexOf(P) == -1 && y.indexOf(P) == -1) return v(`Path "${I}" or key "${y}" must contain string "${P}".`);
                      if (S.wb && (typeof S.wb == "string" || (S.wb || {})["#"])) {
                        var x = p.as.root.$.back(-1);
                        return typeof S.wb == "string" && S.wb.slice(0, 1) !== "~" && (x = x.get("~" + E)), x.get(S.wb).get(P).once((L) => L && (L === 1 || L === !0) ? v(`Certificant ${P} blocked.`) : k(S));
                      }
                      return k(S);
                    }
                  return v("Certificate verification fail.");
                }
              });
          };
          if (y === "pub" && "~" + E === b)
            return _ === E ? p.to.next(m) : v("Account not same!");
          if ((A = w.is) && A.pub && !C["*"] && !C["+"] && (E === A.pub || E !== A.pub && ((m._.msg || {}).opt || {}).cert)) {
            r.opt.pack(m.put, (R) => {
              r.sign(R, w._.sea, async function(P) {
                if (o === P) return v(r.err || "Signature fail.");
                if (m.put[":"] = { ":": A = r.opt.unpack(P.m), "~": P.s }, m.put["="] = A, E === w.is.pub) {
                  (A = l(_)) && ((g.sea.own[A] = g.sea.own[A] || {})[E] = 1), JSON.stringifyAsync(m.put[":"], function(k, S) {
                    return k ? v(k || "Stringify error.") : (m.put[":"] = S, p.to.next(m));
                  });
                  return;
                }
                if (E !== w.is.pub && ((m._.msg || {}).opt || {}).cert) {
                  const k = await s.parse(m._.msg.opt.cert);
                  k && k.m && k.s && O(k, w.is.pub, (S) => {
                    m.put[":"]["+"] = k, m.put[":"]["*"] = w.is.pub, JSON.stringifyAsync(m.put[":"], function(x, I) {
                      return x ? v(x || "Stringify error.") : (m.put[":"] = I, p.to.next(m));
                    });
                  });
                }
              }, { raw: 1 });
            });
            return;
          }
          r.opt.pack(m.put, (R) => {
            r.verify(R, C["*"] || E, function(P) {
              var k;
              if (P = r.opt.unpack(P), o === P) return v("Unverified data.");
              if ((k = l(P)) && E === r.opt.pub(k) && ((g.sea.own[k] = g.sea.own[k] || {})[E] = 1), C["+"] && C["+"].m && C["+"].s && C["*"])
                O(C["+"], C["*"], (S) => (m.put["="] = P, p.to.next(m)));
              else
                return m.put["="] = P, p.to.next(m);
            });
          });
        }, u.any = function(p, m, _, y, b, g, v, w) {
          if (g.opt.secure)
            return v("Soul missing public key at '" + y + "'.");
          g.on("secure", function(E) {
            if (this.off(), !g.opt.secure)
              return p.to.next(E);
            v("Data cannot be changed.");
          }).on.on("secure", m);
        };
        var c = a.valid, l = function(p, m) {
          return typeof (m = c(p)) == "string" && m;
        };
        (a.state || "").ify;
        var h = /[^\w_-]/;
        r.opt.pub = function(p) {
          if (p && (p = p.split("~"), !(!p || !(p = p[1])) && (p = p.split(h).slice(0, 2), !(!p || p.length != 2) && (p[0] || "")[0] !== "@")))
            return p = p.slice(0, 2).join("."), p;
        }, r.opt.stringy = function(p) {
        }, r.opt.pack = function(p, m, _, y, b) {
          var g, v;
          if (r.opt.check(p))
            return m(p);
          p && p["#"] && p["."] && p[">"] && (g = p[":"], v = 1), JSON.parseAsync(v ? g : p, function(w, E) {
            var A = o !== (E || "")[":"] && (E || "")["~"];
            if (!A) {
              m(p);
              return;
            }
            m({ m: { "#": b || p["#"], ".": _ || p["."], ":": (E || "")[":"], ">": p[">"] || a.state.is(y, _) }, s: A });
          });
        };
        var f = r.opt;
        r.opt.unpack = function(p, m, _) {
          var y;
          if (o !== p) {
            if (p && o !== (y = p[":"]))
              return y;
            if (m = m || f.fall_key, !_ && f.fall_val && (_ = {}, _[m] = f.fall_val), !(!m || !_)) {
              if (p === _[m] || !r.opt.check(_[m]))
                return p;
              var b = _ && _._ && _._["#"] || f.fall_soul, g = a.state.is(_, m) || f.fall_state;
              if (p && p.length === 4 && b === p[0] && m === p[1] && d(g) === d(p[3]))
                return p[2];
              if (g < r.opt.shuffle_attack)
                return p;
            }
          }
        }, r.opt.shuffle_attack = 15463296e5;
        var d = Math.floor;
      })(e, "./index");
    })();
  }(Ni)), Ni.exports;
}
var lm = cm();
const Ve = /* @__PURE__ */ Pn(lm);
let Hs;
function ue(t = { localStorage: !1 }) {
  if (!Hs) {
    const e = { peers: [je.peer] };
    typeof t == "object" && Object.assign(e, t), Hs = Fn(e);
  }
  return Hs;
}
function hm(t = { localStorage: !1 }) {
  return Fn({ peers: [je.peer], ...t });
}
var rl;
const sv = (rl = Fn == null ? void 0 : Fn.node) == null ? void 0 : rl.soul;
var il;
const dh = (il = Fn == null ? void 0 : Fn.text) == null ? void 0 : il.random;
var qs, xu;
function fm() {
  if (xu) return qs;
  xu = 1;
  const t = "[a-fA-F\\d:]", e = (c) => c && c.includeBoundaries ? `(?:(?<=\\s|^)(?=${t})|(?<=${t})(?=\\s|$))` : "", n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", i = "[a-fA-F\\d]{1,4}", r = `
(?:
(?:${i}:){7}(?:${i}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${i}:){6}(?:${n}|:${i}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${i}:){5}(?::${n}|(?::${i}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${i}:){4}(?:(?::${i}){0,1}:${n}|(?::${i}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${i}:){3}(?:(?::${i}){0,2}:${n}|(?::${i}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${i}:){2}(?:(?::${i}){0,3}:${n}|(?::${i}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${i}:){1}(?:(?::${i}){0,4}:${n}|(?::${i}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${i}){0,5}:${n}|(?::${i}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), s = new RegExp(`(?:^${n}$)|(?:^${r}$)`), o = new RegExp(`^${n}$`), a = new RegExp(`^${r}$`), u = (c) => c && c.exact ? s : new RegExp(`(?:${e(c)}${n}${e(c)})|(?:${e(c)}${r}${e(c)})`, "g");
  return u.v4 = (c) => c && c.exact ? o : new RegExp(`${e(c)}${n}${e(c)}`, "g"), u.v6 = (c) => c && c.exact ? a : new RegExp(`${e(c)}${r}${e(c)}`, "g"), qs = u, qs;
}
const dm = /* @__PURE__ */ JSON.parse('["aaa","aarp","abarth","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","adac","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alfaromeo","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","avianca","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","bananarepublic","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","bugatti","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","cancerresearch","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cbs","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","cityeats","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","comcast","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cookingchannel","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dabur","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","etisalat","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fiat","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","foodnetwork","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontdoor","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","guardian","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hgtv","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hoteles","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerrylogistics","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kinder","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","lancaster","lancia","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","linde","link","lipsy","live","living","lk","llc","llp","loan","loans","locker","locus","loft","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","macys","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","maserati","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mutual","mv","mw","mx","my","mz","na","nab","nagoya","name","natura","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","northwesternmutual","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","oldnavy","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","passagens","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","pramerica","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocher","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","sca","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","ses","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shaw","shell","shia","shiksha","shoes","shop","shopping","shouji","show","showtime","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tiffany","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelchannel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","vermögensberater","vermögensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volkswagen","volvo","vote","voting","voto","voyage","vu","vuelos","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xfinity","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","ελ","ευ","бг","бел","дети","ею","католик","ком","мкд","мон","москва","онлайн","орг","рус","рф","сайт","срб","укр","қаз","հայ","ישראל","קום","ابوظبي","اتصالات","ارامكو","الاردن","البحرين","الجزائر","السعودية","العليان","المغرب","امارات","ایران","بارت","بازار","بيتك","بھارت","تونس","سودان","سورية","شبكة","عراق","عرب","عمان","فلسطين","قطر","كاثوليك","كوم","مصر","مليسيا","موريتانيا","موقع","همراه","پاکستان","ڀارت","कॉम","नेट","भारत","भारतम्","भारोत","संगठन","বাংলা","ভারত","ভাৰত","ਭਾਰਤ","ભારત","ଭାରତ","இந்தியா","இலங்கை","சிங்கப்பூர்","భారత్","ಭಾರತ","ഭാരതം","ලංකා","คอม","ไทย","ລາວ","გე","みんな","アマゾン","クラウド","グーグル","コム","ストア","セール","ファッション","ポイント","世界","中信","中国","中國","中文网","亚马逊","企业","佛山","信息","健康","八卦","公司","公益","台湾","台灣","商城","商店","商标","嘉里","嘉里大酒店","在线","大拿","天主教","娱乐","家電","广东","微博","慈善","我爱你","手机","招聘","政务","政府","新加坡","新闻","时尚","書籍","机构","淡马锡","游戏","澳門","点看","移动","组织机构","网址","网店","网站","网络","联通","诺基亚","谷歌","购物","通販","集团","電訊盈科","飞利浦","食品","餐厅","香格里拉","香港","닷넷","닷컴","삼성","한국"]');
var Ws, ku;
function pm() {
  if (ku) return Ws;
  ku = 1;
  const t = fm(), e = dm;
  return Ws = (n) => {
    n = {
      strict: !0,
      ...n
    };
    const i = `(?:(?:[a-z]+:)?//)${n.strict ? "" : "?"}`, r = "(?:\\S+(?::\\S*)?@)?", s = t.v4().source, o = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", a = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", u = `(?:\\.${n.strict ? "(?:[a-z\\u00a1-\\uffff]{2,})" : `(?:${e.sort((f, d) => d.length - f.length).join("|")})`})\\.?`, h = `(?:${i}|www\\.)${r}(?:localhost|${s}|${o}${a}${u})(?::\\d{2,5})?(?:[/?#][^\\s"]*)?`;
    return n.exact ? new RegExp(`(?:^${h}$)`, "i") : new RegExp(h, "ig");
  }, Ws;
}
var mm = pm();
const gm = /* @__PURE__ */ Pn(mm), Fo = ie({}), Oo = ie({});
function ov() {
  return { relays: Fo, errors: Oo, loadRelays: bm };
}
async function bm({
  source: t = "https://raw.githubusercontent.com/wiki/amark/gun/volunteer.dht.md"
} = {}) {
  const i = (await (await fetch(t)).text()).match(gm());
  return i.push(je.peer), Array.from(i).forEach((s) => {
    let o = new URL(s);
    if (o.pathname === "/gun" && o.pathname.indexOf("~~") === -1) {
      let a = performance.now();
      fetch(o.href, {
        method: "HEAD",
        mode: "cors",
        // mode: 'no-cors',
        redirect: "follow",
        referrerPolicy: "no-referrer"
      }).then((u) => {
        let c = performance.now();
        if (u.ok) {
          const l = {
            host: o.hostname,
            ping: (c - a).toFixed(),
            url: o.href
          };
          Fo[o.hostname] = l;
        } else
          Oo[o.hostname] = u;
      }).catch((u) => {
        Oo[o.hostname] = u;
      });
    }
  }), Fo;
}
function ka(t) {
  return typeof t == "string" && t.length === 44 && t.charAt(43) === "=";
}
async function av(t, e, n) {
  const i = await Ve.secret(n.epub, e);
  return await Ve.encrypt(t, i);
}
async function uv(t, e, n) {
  const i = await Ve.secret(e.epub, n);
  return await Ve.decrypt(t, i);
}
async function hn(t) {
  return await Ve.work(t, null, null, { name: "SHA-256" });
}
async function es(t) {
  let e = typeof t == "string" ? t : JSON.stringify(t);
  return { hash: await hn(e), hashed: e };
}
async function cv(t, e) {
  return await Ve.work(t, null, null, {
    name: "PBKDF2",
    encode: "hex",
    salt: e
  });
}
function _m(t) {
  if (!t) return;
  const e = /[+=/]/g;
  return t.replace(e, ym);
}
function ym(t) {
  switch (t) {
    case "+":
      return "-";
    case "=":
      return ".";
    case "/":
      return "_";
  }
}
function lv(t) {
  if (!t) return;
  const e = /[._-]/g;
  return t.replace(e, vm);
}
function vm(t) {
  switch (t) {
    case "-":
      return "+";
    case ".":
      return "=";
    case "_":
      return "/";
  }
}
function hv(t, e = {}) {
  if (t) {
    if (typeof t == "object")
      return t;
  } else return e;
  try {
    return JSON.parse(t);
  } catch {
    return e;
  }
}
async function wm({
  pair: t,
  tag: e = "word",
  dot: n = "",
  users: i = "*",
  personal: r = !1
}) {
  let s = { "*": `${e}` };
  n && (s["."] = n), r && (s["+"] = "*");
  try {
    return await Ve.certify(i, s, t, null);
  } catch (o) {
    return console.log("cert error: ", o), "";
  }
}
async function Su({ pair: t, list: e = [] }) {
  const n = {};
  for (let i of e)
    n[i.tag] = await wm({ ...i, pair: t });
  return n;
}
const fv = {
  noun: {
    en: "noun",
    ru: "сущ",
    underline: "solid"
  },
  adj: {
    en: "adjective",
    ru: "прил",
    underline: "wavy"
  },
  verb: {
    en: "verb",
    ru: "глаг",
    underline: "double"
  },
  adv: {
    en: "adverb",
    ru: "нареч",
    underline: "dotted"
  }
}, dv = [
  {
    code: "aa",
    name: "Afar",
    native: "Afar"
  },
  {
    code: "ab",
    name: "Abkhazian",
    native: "Аҧсуа"
  },
  {
    code: "af",
    name: "Afrikaans",
    native: "Afrikaans"
  },
  {
    code: "ak",
    name: "Akan",
    native: "Akana"
  },
  {
    code: "am",
    name: "Amharic",
    native: "አማርኛ"
  },
  {
    code: "an",
    name: "Aragonese",
    native: "Aragonés"
  },
  {
    code: "ar",
    name: "Arabic",
    native: "العربية",
    rtl: 1
  },
  {
    code: "as",
    name: "Assamese",
    native: "অসমীয়া"
  },
  {
    code: "av",
    name: "Avar",
    native: "Авар"
  },
  {
    code: "ay",
    name: "Aymara",
    native: "Aymar"
  },
  {
    code: "az",
    name: "Azerbaijani",
    native: "Azərbaycanca / آذربايجان"
  },
  {
    code: "ba",
    name: "Bashkir",
    native: "Башҡорт"
  },
  {
    code: "be",
    name: "Belarusian",
    native: "Беларуская"
  },
  {
    code: "bg",
    name: "Bulgarian",
    native: "Български"
  },
  {
    code: "bh",
    name: "Bihari",
    native: "भोजपुरी"
  },
  {
    code: "bi",
    name: "Bislama",
    native: "Bislama"
  },
  {
    code: "bm",
    name: "Bambara",
    native: "Bamanankan"
  },
  {
    code: "bn",
    name: "Bengali",
    native: "বাংলা"
  },
  {
    code: "bo",
    name: "Tibetan",
    native: "བོད་ཡིག / Bod skad"
  },
  {
    code: "br",
    name: "Breton",
    native: "Brezhoneg"
  },
  {
    code: "bs",
    name: "Bosnian",
    native: "Bosanski"
  },
  {
    code: "ca",
    name: "Catalan",
    native: "Català"
  },
  {
    code: "ce",
    name: "Chechen",
    native: "Нохчийн"
  },
  {
    code: "ch",
    name: "Chamorro",
    native: "Chamoru"
  },
  {
    code: "co",
    name: "Corsican",
    native: "Corsu"
  },
  {
    code: "cr",
    name: "Cree",
    native: "Nehiyaw"
  },
  {
    code: "cs",
    name: "Czech",
    native: "Česky"
  },
  {
    code: "cu",
    name: "Old Church Slavonic / Old Bulgarian",
    native: "словѣньскъ / slověnĭskŭ"
  },
  {
    code: "cv",
    name: "Chuvash",
    native: "Чăваш"
  },
  {
    code: "cy",
    name: "Welsh",
    native: "Cymraeg"
  },
  {
    code: "da",
    name: "Danish",
    native: "Dansk"
  },
  {
    code: "de",
    name: "German",
    native: "Deutsch"
  },
  {
    code: "dv",
    name: "Divehi",
    native: "ދިވެހިބަސް",
    rtl: 1
  },
  {
    code: "dz",
    name: "Dzongkha",
    native: "ཇོང་ཁ"
  },
  {
    code: "ee",
    name: "Ewe",
    native: "Ɛʋɛ"
  },
  {
    code: "el",
    name: "Greek",
    native: "Ελληνικά"
  },
  {
    code: "en",
    name: "English",
    native: "English"
  },
  {
    code: "eo",
    name: "Esperanto",
    native: "Esperanto"
  },
  {
    code: "es",
    name: "Spanish",
    native: "Español"
  },
  {
    code: "et",
    name: "Estonian",
    native: "Eesti"
  },
  {
    code: "eu",
    name: "Basque",
    native: "Euskara"
  },
  {
    code: "fa",
    name: "Persian",
    native: "فارسی",
    rtl: 1
  },
  {
    code: "ff",
    name: "Peul",
    native: "Fulfulde"
  },
  {
    code: "fi",
    name: "Finnish",
    native: "Suomi"
  },
  {
    code: "fj",
    name: "Fijian",
    native: "Na Vosa Vakaviti"
  },
  {
    code: "fo",
    name: "Faroese",
    native: "Føroyskt"
  },
  {
    code: "fr",
    name: "French",
    native: "Français"
  },
  {
    code: "fy",
    name: "West Frisian",
    native: "Frysk"
  },
  {
    code: "ga",
    name: "Irish",
    native: "Gaeilge"
  },
  {
    code: "gd",
    name: "Scottish Gaelic",
    native: "Gàidhlig"
  },
  {
    code: "gl",
    name: "Galician",
    native: "Galego"
  },
  {
    code: "gn",
    name: "Guarani",
    native: "Avañe'ẽ"
  },
  {
    code: "gu",
    name: "Gujarati",
    native: "ગુજરાતી"
  },
  {
    code: "gv",
    name: "Manx",
    native: "Gaelg"
  },
  {
    code: "ha",
    name: "Hausa",
    native: "هَوُسَ",
    rtl: 1
  },
  {
    code: "he",
    name: "Hebrew",
    native: "עברית",
    rtl: 1
  },
  {
    code: "hi",
    name: "Hindi",
    native: "हिन्दी"
  },
  {
    code: "ho",
    name: "Hiri Motu",
    native: "Hiri Motu"
  },
  {
    code: "hr",
    name: "Croatian",
    native: "Hrvatski"
  },
  {
    code: "ht",
    name: "Haitian",
    native: "Krèyol ayisyen"
  },
  {
    code: "hu",
    name: "Hungarian",
    native: "Magyar"
  },
  {
    code: "hy",
    name: "Armenian",
    native: "Հայերեն"
  },
  {
    code: "hz",
    name: "Herero",
    native: "Otsiherero"
  },
  {
    code: "ia",
    name: "Interlingua",
    native: "Interlingua"
  },
  {
    code: "id",
    name: "Indonesian",
    native: "Bahasa Indonesia"
  },
  {
    code: "ie",
    name: "Interlingue",
    native: "Interlingue"
  },
  {
    code: "ig",
    name: "Igbo",
    native: "Igbo"
  },
  {
    code: "ii",
    name: "Sichuan Yi",
    native: "ꆇꉙ / 四川彝语"
  },
  {
    code: "ik",
    name: "Inupiak",
    native: "Iñupiak"
  },
  {
    code: "io",
    name: "Ido",
    native: "Ido"
  },
  {
    code: "is",
    name: "Icelandic",
    native: "Íslenska"
  },
  {
    code: "it",
    name: "Italian",
    native: "Italiano"
  },
  {
    code: "iu",
    name: "Inuktitut",
    native: "ᐃᓄᒃᑎᑐᑦ"
  },
  {
    code: "ja",
    name: "Japanese",
    native: "日本語"
  },
  {
    code: "jv",
    name: "Javanese",
    native: "Basa Jawa"
  },
  {
    code: "ka",
    name: "Georgian",
    native: "ქართული"
  },
  {
    code: "kg",
    name: "Kongo",
    native: "KiKongo"
  },
  {
    code: "ki",
    name: "Kikuyu",
    native: "Gĩkũyũ"
  },
  {
    code: "kj",
    name: "Kuanyama",
    native: "Kuanyama"
  },
  {
    code: "kk",
    name: "Kazakh",
    native: "Қазақша"
  },
  {
    code: "kl",
    name: "Greenlandic",
    native: "Kalaallisut"
  },
  {
    code: "km",
    name: "Cambodian",
    native: "ភាសាខ្មែរ"
  },
  {
    code: "kn",
    name: "Kannada",
    native: "ಕನ್ನಡ"
  },
  {
    code: "ko",
    name: "Korean",
    native: "한국어"
  },
  {
    code: "kr",
    name: "Kanuri",
    native: "Kanuri"
  },
  {
    code: "ks",
    name: "Kashmiri",
    native: "कश्मीरी / كشميري",
    rtl: 1
  },
  {
    code: "ku",
    name: "Kurdish",
    native: "Kurdî / كوردی",
    rtl: 1
  },
  {
    code: "kv",
    name: "Komi",
    native: "Коми"
  },
  {
    code: "kw",
    name: "Cornish",
    native: "Kernewek"
  },
  {
    code: "ky",
    name: "Kirghiz",
    native: "Kırgızca / Кыргызча"
  },
  {
    code: "la",
    name: "Latin",
    native: "Latina"
  },
  {
    code: "lb",
    name: "Luxembourgish",
    native: "Lëtzebuergesch"
  },
  {
    code: "lg",
    name: "Ganda",
    native: "Luganda"
  },
  {
    code: "li",
    name: "Limburgian",
    native: "Limburgs"
  },
  {
    code: "ln",
    name: "Lingala",
    native: "Lingála"
  },
  {
    code: "lo",
    name: "Laotian",
    native: "ລາວ / Pha xa lao"
  },
  {
    code: "lt",
    name: "Lithuanian",
    native: "Lietuvių"
  },
  {
    code: "lu",
    name: "Luba-Katanga",
    native: "Tshiluba"
  },
  {
    code: "lv",
    name: "Latvian",
    native: "Latviešu"
  },
  {
    code: "mg",
    name: "Malagasy",
    native: "Malagasy"
  },
  {
    code: "mh",
    name: "Marshallese",
    native: "Kajin Majel / Ebon"
  },
  {
    code: "mi",
    name: "Maori",
    native: "Māori"
  },
  {
    code: "mk",
    name: "Macedonian",
    native: "Македонски"
  },
  {
    code: "ml",
    name: "Malayalam",
    native: "മലയാളം"
  },
  {
    code: "mn",
    name: "Mongolian",
    native: "Монгол"
  },
  {
    code: "mo",
    name: "Moldovan",
    native: "Moldovenească"
  },
  {
    code: "mr",
    name: "Marathi",
    native: "मराठी"
  },
  {
    code: "ms",
    name: "Malay",
    native: "Bahasa Melayu"
  },
  {
    code: "mt",
    name: "Maltese",
    native: "bil-Malti"
  },
  {
    code: "my",
    name: "Burmese",
    native: "မြန်မာစာ"
  },
  {
    code: "na",
    name: "Nauruan",
    native: "Dorerin Naoero"
  },
  {
    code: "nb",
    name: "Norwegian Bokmål",
    native: "Norsk bokmål"
  },
  {
    code: "nd",
    name: "North Ndebele",
    native: "Sindebele"
  },
  {
    code: "ne",
    name: "Nepali",
    native: "नेपाली"
  },
  {
    code: "ng",
    name: "Ndonga",
    native: "Oshiwambo"
  },
  {
    code: "nl",
    name: "Dutch",
    native: "Nederlands"
  },
  {
    code: "nn",
    name: "Norwegian Nynorsk",
    native: "Norsk nynorsk"
  },
  {
    code: "no",
    name: "Norwegian",
    native: "Norsk"
  },
  {
    code: "nr",
    name: "South Ndebele",
    native: "isiNdebele"
  },
  {
    code: "nv",
    name: "Navajo",
    native: "Diné bizaad"
  },
  {
    code: "ny",
    name: "Chichewa",
    native: "Chi-Chewa"
  },
  {
    code: "oc",
    name: "Occitan",
    native: "Occitan"
  },
  {
    code: "oj",
    name: "Ojibwa",
    native: "ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin"
  },
  {
    code: "om",
    name: "Oromo",
    native: "Oromoo"
  },
  {
    code: "or",
    name: "Oriya",
    native: "ଓଡ଼ିଆ"
  },
  {
    code: "os",
    name: "Ossetian / Ossetic",
    native: "Иронау"
  },
  {
    code: "pa",
    name: "Panjabi / Punjabi",
    native: "ਪੰਜਾਬੀ / पंजाबी / پنجابي"
  },
  {
    code: "pi",
    name: "Pali",
    native: "Pāli / पाऴि"
  },
  {
    code: "pl",
    name: "Polish",
    native: "Polski"
  },
  {
    code: "ps",
    name: "Pashto",
    native: "پښتو",
    rtl: 1
  },
  {
    code: "pt",
    name: "Portuguese",
    native: "Português"
  },
  {
    code: "qu",
    name: "Quechua",
    native: "Runa Simi"
  },
  {
    code: "rm",
    name: "Raeto Romance",
    native: "Rumantsch"
  },
  {
    code: "rn",
    name: "Kirundi",
    native: "Kirundi"
  },
  {
    code: "ro",
    name: "Romanian",
    native: "Română"
  },
  {
    code: "ru",
    name: "Russian",
    native: "Русский"
  },
  {
    code: "rw",
    name: "Rwandi",
    native: "Kinyarwandi"
  },
  {
    code: "sa",
    name: "Sanskrit",
    native: "संस्कृतम्"
  },
  {
    code: "sc",
    name: "Sardinian",
    native: "Sardu"
  },
  {
    code: "sd",
    name: "Sindhi",
    native: "सिनधि"
  },
  {
    code: "se",
    name: "Northern Sami",
    native: "Sámegiella"
  },
  {
    code: "sg",
    name: "Sango",
    native: "Sängö"
  },
  {
    code: "sh",
    name: "Serbo-Croatian",
    native: "Srpskohrvatski / Српскохрватски"
  },
  {
    code: "si",
    name: "Sinhalese",
    native: "සිංහල"
  },
  {
    code: "sk",
    name: "Slovak",
    native: "Slovenčina"
  },
  {
    code: "sl",
    name: "Slovenian",
    native: "Slovenščina"
  },
  {
    code: "sm",
    name: "Samoan",
    native: "Gagana Samoa"
  },
  {
    code: "sn",
    name: "Shona",
    native: "chiShona"
  },
  {
    code: "so",
    name: "Somalia",
    native: "Soomaaliga"
  },
  {
    code: "sq",
    name: "Albanian",
    native: "Shqip"
  },
  {
    code: "sr",
    name: "Serbian",
    native: "Српски"
  },
  {
    code: "ss",
    name: "Swati",
    native: "SiSwati"
  },
  {
    code: "st",
    name: "Southern Sotho",
    native: "Sesotho"
  },
  {
    code: "su",
    name: "Sundanese",
    native: "Basa Sunda"
  },
  {
    code: "sv",
    name: "Swedish",
    native: "Svenska"
  },
  {
    code: "sw",
    name: "Swahili",
    native: "Kiswahili"
  },
  {
    code: "ta",
    name: "Tamil",
    native: "தமிழ்"
  },
  {
    code: "te",
    name: "Telugu",
    native: "తెలుగు"
  },
  {
    code: "tg",
    name: "Tajik",
    native: "Тоҷикӣ"
  },
  {
    code: "th",
    name: "Thai",
    native: "ไทย / Phasa Thai"
  },
  {
    code: "ti",
    name: "Tigrinya",
    native: "ትግርኛ"
  },
  {
    code: "tk",
    name: "Turkmen",
    native: "Туркмен / تركمن"
  },
  {
    code: "tl",
    name: "Tagalog / Filipino",
    native: "Tagalog"
  },
  {
    code: "tn",
    name: "Tswana",
    native: "Setswana"
  },
  {
    code: "to",
    name: "Tonga",
    native: "Lea Faka-Tonga"
  },
  {
    code: "tr",
    name: "Turkish",
    native: "Türkçe"
  },
  {
    code: "ts",
    name: "Tsonga",
    native: "Xitsonga"
  },
  {
    code: "tt",
    name: "Tatar",
    native: "Tatarça"
  },
  {
    code: "tw",
    name: "Twi",
    native: "Twi"
  },
  {
    code: "ty",
    name: "Tahitian",
    native: "Reo Mā`ohi"
  },
  {
    code: "ug",
    name: "Uyghur",
    native: "Uyƣurqə / ئۇيغۇرچە"
  },
  {
    code: "uk",
    name: "Ukrainian",
    native: "Українська"
  },
  {
    code: "ur",
    name: "Urdu",
    native: "اردو",
    rtl: 1
  },
  {
    code: "uz",
    name: "Uzbek",
    native: "Ўзбек"
  },
  {
    code: "ve",
    name: "Venda",
    native: "Tshivenḓa"
  },
  {
    code: "vi",
    name: "Vietnamese",
    native: "Tiếng Việt"
  },
  {
    code: "vo",
    name: "Volapük",
    native: "Volapük"
  },
  {
    code: "wa",
    name: "Walloon",
    native: "Walon"
  },
  {
    code: "wo",
    name: "Wolof",
    native: "Wollof"
  },
  {
    code: "xh",
    name: "Xhosa",
    native: "isiXhosa"
  },
  {
    code: "yi",
    name: "Yiddish",
    native: "ייִדיש",
    rtl: 1
  },
  {
    code: "yo",
    name: "Yoruba",
    native: "Yorùbá"
  },
  {
    code: "za",
    name: "Zhuang",
    native: "Cuengh / Tôô / 壮语"
  },
  {
    code: "zh",
    name: "Chinese",
    native: "中文"
  },
  {
    code: "zu",
    name: "Zulu",
    native: "isiZulu"
  }
];
function cn(t) {
  return Array.isArray ? Array.isArray(t) : gh(t) === "[object Array]";
}
function xm(t) {
  if (typeof t == "string")
    return t;
  let e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
function km(t) {
  return t == null ? "" : xm(t);
}
function Ut(t) {
  return typeof t == "string";
}
function ph(t) {
  return typeof t == "number";
}
function Sm(t) {
  return t === !0 || t === !1 || Am(t) && gh(t) == "[object Boolean]";
}
function mh(t) {
  return typeof t == "object";
}
function Am(t) {
  return mh(t) && t !== null;
}
function ct(t) {
  return t != null;
}
function Vs(t) {
  return !t.trim().length;
}
function gh(t) {
  return t == null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
}
const Em = "Incorrect 'index' type", Cm = (t) => `Invalid value for key ${t}`, Tm = (t) => `Pattern length exceeds max of ${t}.`, Dm = (t) => `Missing ${t} property in key`, Fm = (t) => `Property 'weight' in key '${t}' must be a positive integer`, Au = Object.prototype.hasOwnProperty;
class Om {
  constructor(e) {
    this._keys = [], this._keyMap = {};
    let n = 0;
    e.forEach((i) => {
      let r = bh(i);
      this._keys.push(r), this._keyMap[r.id] = r, n += r.weight;
    }), this._keys.forEach((i) => {
      i.weight /= n;
    });
  }
  get(e) {
    return this._keyMap[e];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function bh(t) {
  let e = null, n = null, i = null, r = 1, s = null;
  if (Ut(t) || cn(t))
    i = t, e = Eu(t), n = Io(t);
  else {
    if (!Au.call(t, "name"))
      throw new Error(Dm("name"));
    const o = t.name;
    if (i = o, Au.call(t, "weight") && (r = t.weight, r <= 0))
      throw new Error(Fm(o));
    e = Eu(o), n = Io(o), s = t.getFn;
  }
  return { path: e, id: n, weight: r, src: i, getFn: s };
}
function Eu(t) {
  return cn(t) ? t : t.split(".");
}
function Io(t) {
  return cn(t) ? t.join(".") : t;
}
function Im(t, e) {
  let n = [], i = !1;
  const r = (s, o, a) => {
    if (ct(s))
      if (!o[a])
        n.push(s);
      else {
        let u = o[a];
        const c = s[u];
        if (!ct(c))
          return;
        if (a === o.length - 1 && (Ut(c) || ph(c) || Sm(c)))
          n.push(km(c));
        else if (cn(c)) {
          i = !0;
          for (let l = 0, h = c.length; l < h; l += 1)
            r(c[l], o, a + 1);
        } else o.length && r(c, o, a + 1);
      }
  };
  return r(t, Ut(e) ? e.split(".") : e, 0), i ? n : n[0];
}
const Pm = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: !1,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: !1,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
}, Rm = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: !1,
  // When `true`, the algorithm will ignore diacritics (accents) in comparisons
  ignoreDiacritics: !1,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: !1,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: !0,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (t, e) => t.score === e.score ? t.idx < e.idx ? -1 : 1 : t.score < e.score ? -1 : 1
}, Lm = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
}, Mm = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: !1,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: Im,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: !1,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: !1,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var pe = {
  ...Rm,
  ...Pm,
  ...Lm,
  ...Mm
};
const jm = /[^ ]+/g;
function Nm(t = 1, e = 3) {
  const n = /* @__PURE__ */ new Map(), i = Math.pow(10, e);
  return {
    get(r) {
      const s = r.match(jm).length;
      if (n.has(s))
        return n.get(s);
      const o = 1 / Math.pow(s, 0.5 * t), a = parseFloat(Math.round(o * i) / i);
      return n.set(s, a), a;
    },
    clear() {
      n.clear();
    }
  };
}
class Sa {
  constructor({
    getFn: e = pe.getFn,
    fieldNormWeight: n = pe.fieldNormWeight
  } = {}) {
    this.norm = Nm(n, 3), this.getFn = e, this.isCreated = !1, this.setIndexRecords();
  }
  setSources(e = []) {
    this.docs = e;
  }
  setIndexRecords(e = []) {
    this.records = e;
  }
  setKeys(e = []) {
    this.keys = e, this._keysMap = {}, e.forEach((n, i) => {
      this._keysMap[n.id] = i;
    });
  }
  create() {
    this.isCreated || !this.docs.length || (this.isCreated = !0, Ut(this.docs[0]) ? this.docs.forEach((e, n) => {
      this._addString(e, n);
    }) : this.docs.forEach((e, n) => {
      this._addObject(e, n);
    }), this.norm.clear());
  }
  // Adds a doc to the end of the index
  add(e) {
    const n = this.size();
    Ut(e) ? this._addString(e, n) : this._addObject(e, n);
  }
  // Removes the doc at the specified index of the index
  removeAt(e) {
    this.records.splice(e, 1);
    for (let n = e, i = this.size(); n < i; n += 1)
      this.records[n].i -= 1;
  }
  getValueForItemAtKeyId(e, n) {
    return e[this._keysMap[n]];
  }
  size() {
    return this.records.length;
  }
  _addString(e, n) {
    if (!ct(e) || Vs(e))
      return;
    let i = {
      v: e,
      i: n,
      n: this.norm.get(e)
    };
    this.records.push(i);
  }
  _addObject(e, n) {
    let i = { i: n, $: {} };
    this.keys.forEach((r, s) => {
      let o = r.getFn ? r.getFn(e) : this.getFn(e, r.path);
      if (ct(o)) {
        if (cn(o)) {
          let a = [];
          const u = [{ nestedArrIndex: -1, value: o }];
          for (; u.length; ) {
            const { nestedArrIndex: c, value: l } = u.pop();
            if (ct(l))
              if (Ut(l) && !Vs(l)) {
                let h = {
                  v: l,
                  i: c,
                  n: this.norm.get(l)
                };
                a.push(h);
              } else cn(l) && l.forEach((h, f) => {
                u.push({
                  nestedArrIndex: f,
                  value: h
                });
              });
          }
          i.$[s] = a;
        } else if (Ut(o) && !Vs(o)) {
          let a = {
            v: o,
            n: this.norm.get(o)
          };
          i.$[s] = a;
        }
      }
    }), this.records.push(i);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function _h(t, e, { getFn: n = pe.getFn, fieldNormWeight: i = pe.fieldNormWeight } = {}) {
  const r = new Sa({ getFn: n, fieldNormWeight: i });
  return r.setKeys(t.map(bh)), r.setSources(e), r.create(), r;
}
function Bm(t, { getFn: e = pe.getFn, fieldNormWeight: n = pe.fieldNormWeight } = {}) {
  const { keys: i, records: r } = t, s = new Sa({ getFn: e, fieldNormWeight: n });
  return s.setKeys(i), s.setIndexRecords(r), s;
}
function xi(t, {
  errors: e = 0,
  currentLocation: n = 0,
  expectedLocation: i = 0,
  distance: r = pe.distance,
  ignoreLocation: s = pe.ignoreLocation
} = {}) {
  const o = e / t.length;
  if (s)
    return o;
  const a = Math.abs(i - n);
  return r ? o + a / r : a ? 1 : o;
}
function $m(t = [], e = pe.minMatchCharLength) {
  let n = [], i = -1, r = -1, s = 0;
  for (let o = t.length; s < o; s += 1) {
    let a = t[s];
    a && i === -1 ? i = s : !a && i !== -1 && (r = s - 1, r - i + 1 >= e && n.push([i, r]), i = -1);
  }
  return t[s - 1] && s - i >= e && n.push([i, s - 1]), n;
}
const Wn = 32;
function zm(t, e, n, {
  location: i = pe.location,
  distance: r = pe.distance,
  threshold: s = pe.threshold,
  findAllMatches: o = pe.findAllMatches,
  minMatchCharLength: a = pe.minMatchCharLength,
  includeMatches: u = pe.includeMatches,
  ignoreLocation: c = pe.ignoreLocation
} = {}) {
  if (e.length > Wn)
    throw new Error(Tm(Wn));
  const l = e.length, h = t.length, f = Math.max(0, Math.min(i, h));
  let d = s, p = f;
  const m = a > 1 || u, _ = m ? Array(h) : [];
  let y;
  for (; (y = t.indexOf(e, p)) > -1; ) {
    let A = xi(e, {
      currentLocation: y,
      expectedLocation: f,
      distance: r,
      ignoreLocation: c
    });
    if (d = Math.min(A, d), p = y + l, m) {
      let C = 0;
      for (; C < l; )
        _[y + C] = 1, C += 1;
    }
  }
  p = -1;
  let b = [], g = 1, v = l + h;
  const w = 1 << l - 1;
  for (let A = 0; A < l; A += 1) {
    let C = 0, O = v;
    for (; C < O; )
      xi(e, {
        errors: A,
        currentLocation: f + O,
        expectedLocation: f,
        distance: r,
        ignoreLocation: c
      }) <= d ? C = O : v = O, O = Math.floor((v - C) / 2 + C);
    v = O;
    let R = Math.max(1, f - O + 1), P = o ? h : Math.min(f + O, h) + l, k = Array(P + 2);
    k[P + 1] = (1 << A) - 1;
    for (let x = P; x >= R; x -= 1) {
      let I = x - 1, F = n[t.charAt(I)];
      if (m && (_[I] = +!!F), k[x] = (k[x + 1] << 1 | 1) & F, A && (k[x] |= (b[x + 1] | b[x]) << 1 | 1 | b[x + 1]), k[x] & w && (g = xi(e, {
        errors: A,
        currentLocation: I,
        expectedLocation: f,
        distance: r,
        ignoreLocation: c
      }), g <= d)) {
        if (d = g, p = I, p <= f)
          break;
        R = Math.max(1, 2 * f - p);
      }
    }
    if (xi(e, {
      errors: A + 1,
      currentLocation: f,
      expectedLocation: f,
      distance: r,
      ignoreLocation: c
    }) > d)
      break;
    b = k;
  }
  const E = {
    isMatch: p >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, g)
  };
  if (m) {
    const A = $m(_, a);
    A.length ? u && (E.indices = A) : E.isMatch = !1;
  }
  return E;
}
function Um(t) {
  let e = {};
  for (let n = 0, i = t.length; n < i; n += 1) {
    const r = t.charAt(n);
    e[r] = (e[r] || 0) | 1 << i - n - 1;
  }
  return e;
}
const ts = String.prototype.normalize ? (t) => t.normalize("NFD").replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, "") : (t) => t;
class yh {
  constructor(e, {
    location: n = pe.location,
    threshold: i = pe.threshold,
    distance: r = pe.distance,
    includeMatches: s = pe.includeMatches,
    findAllMatches: o = pe.findAllMatches,
    minMatchCharLength: a = pe.minMatchCharLength,
    isCaseSensitive: u = pe.isCaseSensitive,
    ignoreDiacritics: c = pe.ignoreDiacritics,
    ignoreLocation: l = pe.ignoreLocation
  } = {}) {
    if (this.options = {
      location: n,
      threshold: i,
      distance: r,
      includeMatches: s,
      findAllMatches: o,
      minMatchCharLength: a,
      isCaseSensitive: u,
      ignoreDiacritics: c,
      ignoreLocation: l
    }, e = u ? e : e.toLowerCase(), e = c ? ts(e) : e, this.pattern = e, this.chunks = [], !this.pattern.length)
      return;
    const h = (d, p) => {
      this.chunks.push({
        pattern: d,
        alphabet: Um(d),
        startIndex: p
      });
    }, f = this.pattern.length;
    if (f > Wn) {
      let d = 0;
      const p = f % Wn, m = f - p;
      for (; d < m; )
        h(this.pattern.substr(d, Wn), d), d += Wn;
      if (p) {
        const _ = f - Wn;
        h(this.pattern.substr(_), _);
      }
    } else
      h(this.pattern, 0);
  }
  searchIn(e) {
    const { isCaseSensitive: n, ignoreDiacritics: i, includeMatches: r } = this.options;
    if (e = n ? e : e.toLowerCase(), e = i ? ts(e) : e, this.pattern === e) {
      let m = {
        isMatch: !0,
        score: 0
      };
      return r && (m.indices = [[0, e.length - 1]]), m;
    }
    const {
      location: s,
      distance: o,
      threshold: a,
      findAllMatches: u,
      minMatchCharLength: c,
      ignoreLocation: l
    } = this.options;
    let h = [], f = 0, d = !1;
    this.chunks.forEach(({ pattern: m, alphabet: _, startIndex: y }) => {
      const { isMatch: b, score: g, indices: v } = zm(e, m, _, {
        location: s + y,
        distance: o,
        threshold: a,
        findAllMatches: u,
        minMatchCharLength: c,
        includeMatches: r,
        ignoreLocation: l
      });
      b && (d = !0), f += g, b && v && (h = [...h, ...v]);
    });
    let p = {
      isMatch: d,
      score: d ? f / this.chunks.length : 1
    };
    return d && r && (p.indices = h), p;
  }
}
class Rn {
  constructor(e) {
    this.pattern = e;
  }
  static isMultiMatch(e) {
    return Cu(e, this.multiRegex);
  }
  static isSingleMatch(e) {
    return Cu(e, this.singleRegex);
  }
  search() {
  }
}
function Cu(t, e) {
  const n = t.match(e);
  return n ? n[1] : null;
}
class Hm extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(e) {
    const n = e === this.pattern;
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class qm extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(e) {
    const i = e.indexOf(this.pattern) === -1;
    return {
      isMatch: i,
      score: i ? 0 : 1,
      indices: [0, e.length - 1]
    };
  }
}
class Wm extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(e) {
    const n = e.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class Vm extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(e) {
    const n = !e.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, e.length - 1]
    };
  }
}
class Gm extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(e) {
    const n = e.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [e.length - this.pattern.length, e.length - 1]
    };
  }
}
class Km extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(e) {
    const n = !e.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, e.length - 1]
    };
  }
}
class vh extends Rn {
  constructor(e, {
    location: n = pe.location,
    threshold: i = pe.threshold,
    distance: r = pe.distance,
    includeMatches: s = pe.includeMatches,
    findAllMatches: o = pe.findAllMatches,
    minMatchCharLength: a = pe.minMatchCharLength,
    isCaseSensitive: u = pe.isCaseSensitive,
    ignoreDiacritics: c = pe.ignoreDiacritics,
    ignoreLocation: l = pe.ignoreLocation
  } = {}) {
    super(e), this._bitapSearch = new yh(e, {
      location: n,
      threshold: i,
      distance: r,
      includeMatches: s,
      findAllMatches: o,
      minMatchCharLength: a,
      isCaseSensitive: u,
      ignoreDiacritics: c,
      ignoreLocation: l
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(e) {
    return this._bitapSearch.searchIn(e);
  }
}
class wh extends Rn {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(e) {
    let n = 0, i;
    const r = [], s = this.pattern.length;
    for (; (i = e.indexOf(this.pattern, n)) > -1; )
      n = i + s, r.push([i, n - 1]);
    const o = !!r.length;
    return {
      isMatch: o,
      score: o ? 0 : 1,
      indices: r
    };
  }
}
const Po = [
  Hm,
  wh,
  Wm,
  Vm,
  Km,
  Gm,
  qm,
  vh
], Tu = Po.length, Zm = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/, Jm = "|";
function Ym(t, e = {}) {
  return t.split(Jm).map((n) => {
    let i = n.trim().split(Zm).filter((s) => s && !!s.trim()), r = [];
    for (let s = 0, o = i.length; s < o; s += 1) {
      const a = i[s];
      let u = !1, c = -1;
      for (; !u && ++c < Tu; ) {
        const l = Po[c];
        let h = l.isMultiMatch(a);
        h && (r.push(new l(h, e)), u = !0);
      }
      if (!u)
        for (c = -1; ++c < Tu; ) {
          const l = Po[c];
          let h = l.isSingleMatch(a);
          if (h) {
            r.push(new l(h, e));
            break;
          }
        }
    }
    return r;
  });
}
const Xm = /* @__PURE__ */ new Set([vh.type, wh.type]);
class Qm {
  constructor(e, {
    isCaseSensitive: n = pe.isCaseSensitive,
    ignoreDiacritics: i = pe.ignoreDiacritics,
    includeMatches: r = pe.includeMatches,
    minMatchCharLength: s = pe.minMatchCharLength,
    ignoreLocation: o = pe.ignoreLocation,
    findAllMatches: a = pe.findAllMatches,
    location: u = pe.location,
    threshold: c = pe.threshold,
    distance: l = pe.distance
  } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: n,
      ignoreDiacritics: i,
      includeMatches: r,
      minMatchCharLength: s,
      findAllMatches: a,
      ignoreLocation: o,
      location: u,
      threshold: c,
      distance: l
    }, e = n ? e : e.toLowerCase(), e = i ? ts(e) : e, this.pattern = e, this.query = Ym(this.pattern, this.options);
  }
  static condition(e, n) {
    return n.useExtendedSearch;
  }
  searchIn(e) {
    const n = this.query;
    if (!n)
      return {
        isMatch: !1,
        score: 1
      };
    const { includeMatches: i, isCaseSensitive: r, ignoreDiacritics: s } = this.options;
    e = r ? e : e.toLowerCase(), e = s ? ts(e) : e;
    let o = 0, a = [], u = 0;
    for (let c = 0, l = n.length; c < l; c += 1) {
      const h = n[c];
      a.length = 0, o = 0;
      for (let f = 0, d = h.length; f < d; f += 1) {
        const p = h[f], { isMatch: m, indices: _, score: y } = p.search(e);
        if (m) {
          if (o += 1, u += y, i) {
            const b = p.constructor.type;
            Xm.has(b) ? a = [...a, ..._] : a.push(_);
          }
        } else {
          u = 0, o = 0, a.length = 0;
          break;
        }
      }
      if (o) {
        let f = {
          isMatch: !0,
          score: u / o
        };
        return i && (f.indices = a), f;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
}
const Ro = [];
function eg(...t) {
  Ro.push(...t);
}
function Lo(t, e) {
  for (let n = 0, i = Ro.length; n < i; n += 1) {
    let r = Ro[n];
    if (r.condition(t, e))
      return new r(t, e);
  }
  return new yh(t, e);
}
const ns = {
  AND: "$and",
  OR: "$or"
}, Mo = {
  PATH: "$path",
  PATTERN: "$val"
}, jo = (t) => !!(t[ns.AND] || t[ns.OR]), tg = (t) => !!t[Mo.PATH], ng = (t) => !cn(t) && mh(t) && !jo(t), Du = (t) => ({
  [ns.AND]: Object.keys(t).map((e) => ({
    [e]: t[e]
  }))
});
function xh(t, e, { auto: n = !0 } = {}) {
  const i = (r) => {
    let s = Object.keys(r);
    const o = tg(r);
    if (!o && s.length > 1 && !jo(r))
      return i(Du(r));
    if (ng(r)) {
      const u = o ? r[Mo.PATH] : s[0], c = o ? r[Mo.PATTERN] : r[u];
      if (!Ut(c))
        throw new Error(Cm(u));
      const l = {
        keyId: Io(u),
        pattern: c
      };
      return n && (l.searcher = Lo(c, e)), l;
    }
    let a = {
      children: [],
      operator: s[0]
    };
    return s.forEach((u) => {
      const c = r[u];
      cn(c) && c.forEach((l) => {
        a.children.push(i(l));
      });
    }), a;
  };
  return jo(t) || (t = Du(t)), i(t);
}
function rg(t, { ignoreFieldNorm: e = pe.ignoreFieldNorm }) {
  t.forEach((n) => {
    let i = 1;
    n.matches.forEach(({ key: r, norm: s, score: o }) => {
      const a = r ? r.weight : null;
      i *= Math.pow(
        o === 0 && a ? Number.EPSILON : o,
        (a || 1) * (e ? 1 : s)
      );
    }), n.score = i;
  });
}
function ig(t, e) {
  const n = t.matches;
  e.matches = [], ct(n) && n.forEach((i) => {
    if (!ct(i.indices) || !i.indices.length)
      return;
    const { indices: r, value: s } = i;
    let o = {
      indices: r,
      value: s
    };
    i.key && (o.key = i.key.src), i.idx > -1 && (o.refIndex = i.idx), e.matches.push(o);
  });
}
function sg(t, e) {
  e.score = t.score;
}
function og(t, e, {
  includeMatches: n = pe.includeMatches,
  includeScore: i = pe.includeScore
} = {}) {
  const r = [];
  return n && r.push(ig), i && r.push(sg), t.map((s) => {
    const { idx: o } = s, a = {
      item: e[o],
      refIndex: o
    };
    return r.length && r.forEach((u) => {
      u(s, a);
    }), a;
  });
}
class fn {
  constructor(e, n = {}, i) {
    this.options = { ...pe, ...n }, this.options.useExtendedSearch, this._keyStore = new Om(this.options.keys), this.setCollection(e, i);
  }
  setCollection(e, n) {
    if (this._docs = e, n && !(n instanceof Sa))
      throw new Error(Em);
    this._myIndex = n || _h(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(e) {
    ct(e) && (this._docs.push(e), this._myIndex.add(e));
  }
  remove(e = () => !1) {
    const n = [];
    for (let i = 0, r = this._docs.length; i < r; i += 1) {
      const s = this._docs[i];
      e(s, i) && (this.removeAt(i), i -= 1, r -= 1, n.push(s));
    }
    return n;
  }
  removeAt(e) {
    this._docs.splice(e, 1), this._myIndex.removeAt(e);
  }
  getIndex() {
    return this._myIndex;
  }
  search(e, { limit: n = -1 } = {}) {
    const {
      includeMatches: i,
      includeScore: r,
      shouldSort: s,
      sortFn: o,
      ignoreFieldNorm: a
    } = this.options;
    let u = Ut(e) ? Ut(this._docs[0]) ? this._searchStringList(e) : this._searchObjectList(e) : this._searchLogical(e);
    return rg(u, { ignoreFieldNorm: a }), s && u.sort(o), ph(n) && n > -1 && (u = u.slice(0, n)), og(u, this._docs, {
      includeMatches: i,
      includeScore: r
    });
  }
  _searchStringList(e) {
    const n = Lo(e, this.options), { records: i } = this._myIndex, r = [];
    return i.forEach(({ v: s, i: o, n: a }) => {
      if (!ct(s))
        return;
      const { isMatch: u, score: c, indices: l } = n.searchIn(s);
      u && r.push({
        item: s,
        idx: o,
        matches: [{ score: c, value: s, norm: a, indices: l }]
      });
    }), r;
  }
  _searchLogical(e) {
    const n = xh(e, this.options), i = (a, u, c) => {
      if (!a.children) {
        const { keyId: h, searcher: f } = a, d = this._findMatches({
          key: this._keyStore.get(h),
          value: this._myIndex.getValueForItemAtKeyId(u, h),
          searcher: f
        });
        return d && d.length ? [
          {
            idx: c,
            item: u,
            matches: d
          }
        ] : [];
      }
      const l = [];
      for (let h = 0, f = a.children.length; h < f; h += 1) {
        const d = a.children[h], p = i(d, u, c);
        if (p.length)
          l.push(...p);
        else if (a.operator === ns.AND)
          return [];
      }
      return l;
    }, r = this._myIndex.records, s = {}, o = [];
    return r.forEach(({ $: a, i: u }) => {
      if (ct(a)) {
        let c = i(n, a, u);
        c.length && (s[u] || (s[u] = { idx: u, item: a, matches: [] }, o.push(s[u])), c.forEach(({ matches: l }) => {
          s[u].matches.push(...l);
        }));
      }
    }), o;
  }
  _searchObjectList(e) {
    const n = Lo(e, this.options), { keys: i, records: r } = this._myIndex, s = [];
    return r.forEach(({ $: o, i: a }) => {
      if (!ct(o))
        return;
      let u = [];
      i.forEach((c, l) => {
        u.push(
          ...this._findMatches({
            key: c,
            value: o[l],
            searcher: n
          })
        );
      }), u.length && s.push({
        idx: a,
        item: o,
        matches: u
      });
    }), s;
  }
  _findMatches({ key: e, value: n, searcher: i }) {
    if (!ct(n))
      return [];
    let r = [];
    if (cn(n))
      n.forEach(({ v: s, i: o, n: a }) => {
        if (!ct(s))
          return;
        const { isMatch: u, score: c, indices: l } = i.searchIn(s);
        u && r.push({
          score: c,
          key: e,
          value: s,
          idx: o,
          norm: a,
          indices: l
        });
      });
    else {
      const { v: s, n: o } = n, { isMatch: a, score: u, indices: c } = i.searchIn(s);
      a && r.push({ score: u, key: e, value: s, norm: o, indices: c });
    }
    return r;
  }
}
fn.version = "7.1.0";
fn.createIndex = _h;
fn.parseIndex = Bm;
fn.config = pe;
fn.parseQuery = xh;
eg(Qm);
const Cn = ie({
  word: null,
  def: null
}), No = Gt("dict-lang", "en");
Ge(Cn, () => {
  Cn.word && Cn.def && ag(Cn);
});
function pv() {
  const t = ue(), e = ye(""), n = te(() => kh(e.value));
  async function i() {
    const u = await hn(n.value);
    t.get("dict").get("#word").get(u).put(n.value), Cn.word = u, e.value = "";
  }
  const r = ie({});
  t.user(ne.pub).get("dict").map().on(async (u, c) => {
    if (!u) return;
    let l = c.slice(0, 44), h = c.slice(45, 89), f = await t.get("dict").get("#def").get(h).then();
    if (f) {
      try {
        f = JSON.parse(f);
      } catch (d) {
        console.log(d, f);
        return;
      }
      (f == null ? void 0 : f.lang) == No.value && (r[l] = r[l] || await t.get("dict").get("#word").get(l).then());
    }
  });
  const s = ie({});
  t.get("dict").get("#word").map().once((u, c) => {
    u.includes(" ") || (s[c] = u);
  });
  const o = te(() => {
    let u = Object.entries(s).map((c) => ({ text: c[1], hash: c[0] }));
    return new fn(u, {
      keys: ["text"],
      includeScore: !0
    });
  }), a = te(() => o.value.search(e.value));
  return { input: e, found: a, words: s, linked: r, word: n, addWord: i };
}
function mv(t) {
  const e = ue(), n = ye("");
  return e.get("dict").get("#word").get(t).once((i) => {
    n.value = kh(i);
  }), { word: n };
}
function gv() {
  const t = ue(), e = ie({
    text: "",
    lang: No,
    part: "noun"
  });
  async function n() {
    const { hash: a, hashed: u } = await es(e);
    t.get("dict").get("#def").get(a).put(u), Cn.def = a, e.text = "", e.part = null;
  }
  const i = ie({});
  t.user(ne.pub).get("dict").map().on(async (a, u) => {
    if (!a) return;
    let c = u.slice(45, 89), l = await t.get("dict").get("#def").get(c).then();
    if (l)
      try {
        if (l = JSON.parse(l), (l == null ? void 0 : l.lang) != No.value) return;
        i[c] = i[c] || l;
      } catch (h) {
        console.log(h, l);
      }
  });
  const r = ie({});
  t.get("dict").get("#def").map().once((a, u) => {
    r[u] = JSON.parse(a);
  });
  const s = te(() => {
    let a = [];
    for (let u in r)
      a.push({ hash: u, ...r[u] });
    return new fn(a, {
      keys: ["text"],
      includeScore: !0
    });
  }), o = te(() => s.value.search(e.text));
  return { def: e, addDef: n, defs: r, found: o, linked: i };
}
async function ag({ word: t, def: e }) {
  var s;
  const n = ue(), { user: i } = Re();
  let r = await n.user(ne.pub).get("dict").get(`${t}:${e}@${i.pub}`).then();
  n.user(ne.pub).get("dict").get(`${t}:${e}@${i.pub}`).put(!r, null, { opt: { cert: (s = ne.features) == null ? void 0 : s.dict } }), Cn.word = null, Cn.def = null;
}
function bv(t) {
  const e = ue(), n = ie({});
  return e.user(ne.pub).get("dict").map().on((i, r) => {
    var l;
    if (r.indexOf(t) == -1) return;
    const { from: o, to: a, author: u } = Aa(r);
    let c = o == t ? a : o;
    n[c] = n[c] || {}, i ? n[c][u] = i : ((l = n == null ? void 0 : n[c]) == null || delete l[u], Object.keys(n == null ? void 0 : n[c]).length == 0 && (n == null || delete n[c]));
  }), n;
}
function _v(t) {
  const e = ue(), n = ie({});
  return e.user(ne.pub).get("dict").map().on((i, r) => {
    var u;
    const { from: s, to: o, author: a } = Aa(r);
    a == t && (n[s] = n[s] || {}, i ? n[s][o] = i : ((u = n == null ? void 0 : n[s]) == null || delete u[o], Object.keys(n[s]).length == 0 && (n == null || delete n[s])));
  }), n;
}
function yv() {
  const t = ue(), e = ie({});
  return t.user(ne.pub).get("dict").map().once(async (n, i) => {
    const { from: r, to: s, author: o } = Aa(i);
    e[o] = e[o] || {}, e[o][r] = e[o][r] || {}, e[o][r][s] = n;
  }), e;
}
function vv() {
  const t = ue(), e = ie({});
  return t.user(ne.pub).get("dict").map().once(async (n, i) => {
    let r = i.slice(45, 89), s = await t.get("dict").get("#def").get(r).then();
    if (s) {
      try {
        s = JSON.parse(s);
      } catch (o) {
        console.log(s, o);
      }
      s != null && s.lang && (e[s == null ? void 0 : s.lang] = e[s == null ? void 0 : s.lang] || 0, e[s == null ? void 0 : s.lang]++);
    }
  }), e;
}
function Aa(t) {
  return {
    from: t.slice(0, 44),
    to: t.slice(45, 89),
    author: t.slice(-87)
  };
}
function wv({ text: t, stress: e }) {
  const n = "&#x301;";
  if (!t) return;
  let i = t.slice(0, e + 1) + n + t.slice(e + 1);
  return i[0].toUpperCase() + i.slice(1);
}
function kh(t) {
  if (!t) return "";
  let e = t.toLowerCase().matchAll(new RegExp("\\p{L}", "gu"), "");
  return Array.from(e).map((n) => n[0]).join("");
}
function Bo(t, e, n, i = !0) {
  const r = document.createElement("a");
  r.download = n, i ? r.href = URL.createObjectURL(new Blob([t], { type: e })) : r.href = `data:${e};,${t}`, r.dataset.downloadurl = [e, r.download, r.href].join(":"), r.style.display = "none", document.body.appendChild(r), r.click(), document.body.removeChild(r);
}
async function ug(t) {
  if (!t || t.length === 0)
    return;
  const e = t[0], n = 2e7;
  if (e.size > n) {
    console.error("File is bigger than " + n + " bytes limit");
    return;
  }
  return new Promise((i, r) => {
    let s = new FileReader();
    s.onload = () => {
      i(s.result);
    }, s.onerror = (o) => {
      r(o);
    }, s.readAsText(e);
  });
}
function xv({
  preserveRatio: t = !1,
  picSize: e = 100,
  maxSize: n = 1024e4
}) {
  const i = ie({
    errors: [],
    status: "",
    output: {}
  });
  function r(d) {
    const p = d.target.files;
    a(), p.length && (i.status = "loading", Array.from(p).map((m) => s(m)));
  }
  function s(d) {
    return o(d).then((p) => {
      i.output = {
        name: h(d.name),
        content: p,
        size: lg(Math.round(p.length * 3 / 4))
      }, i.status = "success";
    }), null;
  }
  function o(d) {
    return new Promise((p, m) => {
      const _ = new FileReader(), y = new FileReader(), b = d.slice(0, 4);
      _.readAsArrayBuffer(b), _.onloadend = (g) => {
        const v = g.target.result;
        let w = c(l(v));
        if (u(d.size) > u(n) && i.errors.push({
          message: "File size is too large!"
        }), w === !1 && i.errors.push({
          message: "File type is not supported!"
        }), i.errors.length > 0) {
          f(i.errors), a();
          return;
        } else
          y.readAsDataURL(d);
      }, y.onloadend = () => {
        const g = new Image(), v = y.result;
        typeof v == "string" && (g.src = v, g.onload = () => {
          const w = t ? g.naturalWidth / g.naturalHeight : 1, E = document.createElement("canvas");
          E.width = e, E.height = e / w, E.getContext("2d").drawImage(g, 0, 0, E.width, E.height), p(E.toDataURL());
        });
      }, _.onerror = (g) => m(g), y.onerror = (g) => m(g);
    });
  }
  function a() {
    i.status = "", i.errors = [], i.output = {};
  }
  function u(d) {
    return d * Math.pow(10, -6);
  }
  function c(d) {
    return [
      "89504E47",
      // image/png
      "47494638",
      // image/gif
      "FFD8FFDB",
      // image/jpeg
      "FFD8FFE0",
      "FFD8FFE1",
      "FFD8FFE2",
      "FFD8FFE3",
      "FFD8FFE8",
      "FFD8FFED",
      "3C3F786D",
      // svg/xml
      "3C737667"
    ].includes(d);
  }
  function l(d) {
    const p = new Uint8Array(d);
    let m = [];
    return p.forEach((_) => {
      m.push(_.toString(16));
    }), m.join("").toUpperCase();
  }
  function h(d) {
    return d.replace(/\.[^/.]+$/, "").toLowerCase();
  }
  function f(d) {
    d.length === 2 ? console.error("File upload failed due to size and type!") : console.error(d[0].message + d[0].type);
  }
  return {
    state: i,
    handleChange: r
  };
}
const cg = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
function lg(t) {
  let e = 0, n = parseInt(t + "", 10) || 0;
  for (; n >= 1024 && ++e; )
    n = n / 1024;
  return n.toFixed(n < 10 && e > 0 ? 1 : 0) + " " + cg[e];
}
function kv(t) {
  var e = null;
  if (typeof t != "string")
    return e;
  var n = t.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  return n && n.length && (e = n[1]), e;
}
function hg(t) {
  var e;
  return (e = t.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)) == null ? void 0 : e[0];
}
function fg(t) {
  return t.substring(
    t.indexOf("/") + 1,
    t.indexOf(";base64")
  );
}
var Fu = {
  JVBERi0: "application/pdf",
  R0lGODdh: "image/gif",
  R0lGODlh: "image/gif",
  iVBORw0KGgo: "image/png",
  "/9j/": "image/jpg"
};
function Ou(t) {
  for (var e in Fu)
    if (t.indexOf(e) === 0)
      return Fu[e];
}
var Gs = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
var Iu;
function dg() {
  return Iu || (Iu = 1, function(t, e) {
    (function(n) {
      t.exports = n();
    })(function() {
      return function n(i, r, s) {
        function o(c, l) {
          if (!r[c]) {
            if (!i[c]) {
              var h = typeof Vn == "function" && Vn;
              if (!l && h) return h(c, !0);
              if (a) return a(c, !0);
              var f = new Error("Cannot find module '" + c + "'");
              throw f.code = "MODULE_NOT_FOUND", f;
            }
            var d = r[c] = { exports: {} };
            i[c][0].call(d.exports, function(p) {
              var m = i[c][1][p];
              return o(m || p);
            }, d, d.exports, n, i, r, s);
          }
          return r[c].exports;
        }
        for (var a = typeof Vn == "function" && Vn, u = 0; u < s.length; u++) o(s[u]);
        return o;
      }({ 1: [function(n, i, r) {
        var s = n("./utils"), o = n("./support"), a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        r.encode = function(u) {
          for (var c, l, h, f, d, p, m, _ = [], y = 0, b = u.length, g = b, v = s.getTypeOf(u) !== "string"; y < u.length; ) g = b - y, h = v ? (c = u[y++], l = y < b ? u[y++] : 0, y < b ? u[y++] : 0) : (c = u.charCodeAt(y++), l = y < b ? u.charCodeAt(y++) : 0, y < b ? u.charCodeAt(y++) : 0), f = c >> 2, d = (3 & c) << 4 | l >> 4, p = 1 < g ? (15 & l) << 2 | h >> 6 : 64, m = 2 < g ? 63 & h : 64, _.push(a.charAt(f) + a.charAt(d) + a.charAt(p) + a.charAt(m));
          return _.join("");
        }, r.decode = function(u) {
          var c, l, h, f, d, p, m = 0, _ = 0, y = "data:";
          if (u.substr(0, y.length) === y) throw new Error("Invalid base64 input, it looks like a data url.");
          var b, g = 3 * (u = u.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
          if (u.charAt(u.length - 1) === a.charAt(64) && g--, u.charAt(u.length - 2) === a.charAt(64) && g--, g % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
          for (b = o.uint8array ? new Uint8Array(0 | g) : new Array(0 | g); m < u.length; ) c = a.indexOf(u.charAt(m++)) << 2 | (f = a.indexOf(u.charAt(m++))) >> 4, l = (15 & f) << 4 | (d = a.indexOf(u.charAt(m++))) >> 2, h = (3 & d) << 6 | (p = a.indexOf(u.charAt(m++))), b[_++] = c, d !== 64 && (b[_++] = l), p !== 64 && (b[_++] = h);
          return b;
        };
      }, { "./support": 30, "./utils": 32 }], 2: [function(n, i, r) {
        var s = n("./external"), o = n("./stream/DataWorker"), a = n("./stream/Crc32Probe"), u = n("./stream/DataLengthProbe");
        function c(l, h, f, d, p) {
          this.compressedSize = l, this.uncompressedSize = h, this.crc32 = f, this.compression = d, this.compressedContent = p;
        }
        c.prototype = { getContentWorker: function() {
          var l = new o(s.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new u("data_length")), h = this;
          return l.on("end", function() {
            if (this.streamInfo.data_length !== h.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
          }), l;
        }, getCompressedWorker: function() {
          return new o(s.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
        } }, c.createWorkerFrom = function(l, h, f) {
          return l.pipe(new a()).pipe(new u("uncompressedSize")).pipe(h.compressWorker(f)).pipe(new u("compressedSize")).withStreamInfo("compression", h);
        }, i.exports = c;
      }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(n, i, r) {
        var s = n("./stream/GenericWorker");
        r.STORE = { magic: "\0\0", compressWorker: function() {
          return new s("STORE compression");
        }, uncompressWorker: function() {
          return new s("STORE decompression");
        } }, r.DEFLATE = n("./flate");
      }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(n, i, r) {
        var s = n("./utils"), o = function() {
          for (var a, u = [], c = 0; c < 256; c++) {
            a = c;
            for (var l = 0; l < 8; l++) a = 1 & a ? 3988292384 ^ a >>> 1 : a >>> 1;
            u[c] = a;
          }
          return u;
        }();
        i.exports = function(a, u) {
          return a !== void 0 && a.length ? s.getTypeOf(a) !== "string" ? function(c, l, h, f) {
            var d = o, p = f + h;
            c ^= -1;
            for (var m = f; m < p; m++) c = c >>> 8 ^ d[255 & (c ^ l[m])];
            return -1 ^ c;
          }(0 | u, a, a.length, 0) : function(c, l, h, f) {
            var d = o, p = f + h;
            c ^= -1;
            for (var m = f; m < p; m++) c = c >>> 8 ^ d[255 & (c ^ l.charCodeAt(m))];
            return -1 ^ c;
          }(0 | u, a, a.length, 0) : 0;
        };
      }, { "./utils": 32 }], 5: [function(n, i, r) {
        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
      }, {}], 6: [function(n, i, r) {
        var s = null;
        s = typeof Promise < "u" ? Promise : n("lie"), i.exports = { Promise: s };
      }, { lie: 37 }], 7: [function(n, i, r) {
        var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", o = n("pako"), a = n("./utils"), u = n("./stream/GenericWorker"), c = s ? "uint8array" : "array";
        function l(h, f) {
          u.call(this, "FlateWorker/" + h), this._pako = null, this._pakoAction = h, this._pakoOptions = f, this.meta = {};
        }
        r.magic = "\b\0", a.inherits(l, u), l.prototype.processChunk = function(h) {
          this.meta = h.meta, this._pako === null && this._createPako(), this._pako.push(a.transformTo(c, h.data), !1);
        }, l.prototype.flush = function() {
          u.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
        }, l.prototype.cleanUp = function() {
          u.prototype.cleanUp.call(this), this._pako = null;
        }, l.prototype._createPako = function() {
          this._pako = new o[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
          var h = this;
          this._pako.onData = function(f) {
            h.push({ data: f, meta: h.meta });
          };
        }, r.compressWorker = function(h) {
          return new l("Deflate", h);
        }, r.uncompressWorker = function() {
          return new l("Inflate", {});
        };
      }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(n, i, r) {
        function s(d, p) {
          var m, _ = "";
          for (m = 0; m < p; m++) _ += String.fromCharCode(255 & d), d >>>= 8;
          return _;
        }
        function o(d, p, m, _, y, b) {
          var g, v, w = d.file, E = d.compression, A = b !== c.utf8encode, C = a.transformTo("string", b(w.name)), O = a.transformTo("string", c.utf8encode(w.name)), R = w.comment, P = a.transformTo("string", b(R)), k = a.transformTo("string", c.utf8encode(R)), S = O.length !== w.name.length, x = k.length !== R.length, I = "", F = "", T = "", L = w.dir, M = w.date, U = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
          p && !m || (U.crc32 = d.crc32, U.compressedSize = d.compressedSize, U.uncompressedSize = d.uncompressedSize);
          var $ = 0;
          p && ($ |= 8), A || !S && !x || ($ |= 2048);
          var z = 0, X = 0;
          L && (z |= 16), y === "UNIX" ? (X = 798, z |= function(K, be) {
            var Fe = K;
            return K || (Fe = be ? 16893 : 33204), (65535 & Fe) << 16;
          }(w.unixPermissions, L)) : (X = 20, z |= function(K) {
            return 63 & (K || 0);
          }(w.dosPermissions)), g = M.getUTCHours(), g <<= 6, g |= M.getUTCMinutes(), g <<= 5, g |= M.getUTCSeconds() / 2, v = M.getUTCFullYear() - 1980, v <<= 4, v |= M.getUTCMonth() + 1, v <<= 5, v |= M.getUTCDate(), S && (F = s(1, 1) + s(l(C), 4) + O, I += "up" + s(F.length, 2) + F), x && (T = s(1, 1) + s(l(P), 4) + k, I += "uc" + s(T.length, 2) + T);
          var J = "";
          return J += `
\0`, J += s($, 2), J += E.magic, J += s(g, 2), J += s(v, 2), J += s(U.crc32, 4), J += s(U.compressedSize, 4), J += s(U.uncompressedSize, 4), J += s(C.length, 2), J += s(I.length, 2), { fileRecord: h.LOCAL_FILE_HEADER + J + C + I, dirRecord: h.CENTRAL_FILE_HEADER + s(X, 2) + J + s(P.length, 2) + "\0\0\0\0" + s(z, 4) + s(_, 4) + C + I + P };
        }
        var a = n("../utils"), u = n("../stream/GenericWorker"), c = n("../utf8"), l = n("../crc32"), h = n("../signature");
        function f(d, p, m, _) {
          u.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = p, this.zipPlatform = m, this.encodeFileName = _, this.streamFiles = d, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
        }
        a.inherits(f, u), f.prototype.push = function(d) {
          var p = d.meta.percent || 0, m = this.entriesCount, _ = this._sources.length;
          this.accumulate ? this.contentBuffer.push(d) : (this.bytesWritten += d.data.length, u.prototype.push.call(this, { data: d.data, meta: { currentFile: this.currentFile, percent: m ? (p + 100 * (m - _ - 1)) / m : 100 } }));
        }, f.prototype.openedSource = function(d) {
          this.currentSourceOffset = this.bytesWritten, this.currentFile = d.file.name;
          var p = this.streamFiles && !d.file.dir;
          if (p) {
            var m = o(d, p, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
            this.push({ data: m.fileRecord, meta: { percent: 0 } });
          } else this.accumulate = !0;
        }, f.prototype.closedSource = function(d) {
          this.accumulate = !1;
          var p = this.streamFiles && !d.file.dir, m = o(d, p, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          if (this.dirRecords.push(m.dirRecord), p) this.push({ data: function(_) {
            return h.DATA_DESCRIPTOR + s(_.crc32, 4) + s(_.compressedSize, 4) + s(_.uncompressedSize, 4);
          }(d), meta: { percent: 100 } });
          else for (this.push({ data: m.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; ) this.push(this.contentBuffer.shift());
          this.currentFile = null;
        }, f.prototype.flush = function() {
          for (var d = this.bytesWritten, p = 0; p < this.dirRecords.length; p++) this.push({ data: this.dirRecords[p], meta: { percent: 100 } });
          var m = this.bytesWritten - d, _ = function(y, b, g, v, w) {
            var E = a.transformTo("string", w(v));
            return h.CENTRAL_DIRECTORY_END + "\0\0\0\0" + s(y, 2) + s(y, 2) + s(b, 4) + s(g, 4) + s(E.length, 2) + E;
          }(this.dirRecords.length, m, d, this.zipComment, this.encodeFileName);
          this.push({ data: _, meta: { percent: 100 } });
        }, f.prototype.prepareNextSource = function() {
          this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
        }, f.prototype.registerPrevious = function(d) {
          this._sources.push(d);
          var p = this;
          return d.on("data", function(m) {
            p.processChunk(m);
          }), d.on("end", function() {
            p.closedSource(p.previous.streamInfo), p._sources.length ? p.prepareNextSource() : p.end();
          }), d.on("error", function(m) {
            p.error(m);
          }), this;
        }, f.prototype.resume = function() {
          return !!u.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
        }, f.prototype.error = function(d) {
          var p = this._sources;
          if (!u.prototype.error.call(this, d)) return !1;
          for (var m = 0; m < p.length; m++) try {
            p[m].error(d);
          } catch {
          }
          return !0;
        }, f.prototype.lock = function() {
          u.prototype.lock.call(this);
          for (var d = this._sources, p = 0; p < d.length; p++) d[p].lock();
        }, i.exports = f;
      }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(n, i, r) {
        var s = n("../compressions"), o = n("./ZipFileWorker");
        r.generateWorker = function(a, u, c) {
          var l = new o(u.streamFiles, c, u.platform, u.encodeFileName), h = 0;
          try {
            a.forEach(function(f, d) {
              h++;
              var p = function(b, g) {
                var v = b || g, w = s[v];
                if (!w) throw new Error(v + " is not a valid compression method !");
                return w;
              }(d.options.compression, u.compression), m = d.options.compressionOptions || u.compressionOptions || {}, _ = d.dir, y = d.date;
              d._compressWorker(p, m).withStreamInfo("file", { name: f, dir: _, date: y, comment: d.comment || "", unixPermissions: d.unixPermissions, dosPermissions: d.dosPermissions }).pipe(l);
            }), l.entriesCount = h;
          } catch (f) {
            l.error(f);
          }
          return l;
        };
      }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(n, i, r) {
        function s() {
          if (!(this instanceof s)) return new s();
          if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
          this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
            var o = new s();
            for (var a in this) typeof this[a] != "function" && (o[a] = this[a]);
            return o;
          };
        }
        (s.prototype = n("./object")).loadAsync = n("./load"), s.support = n("./support"), s.defaults = n("./defaults"), s.version = "3.10.1", s.loadAsync = function(o, a) {
          return new s().loadAsync(o, a);
        }, s.external = n("./external"), i.exports = s;
      }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(n, i, r) {
        var s = n("./utils"), o = n("./external"), a = n("./utf8"), u = n("./zipEntries"), c = n("./stream/Crc32Probe"), l = n("./nodejsUtils");
        function h(f) {
          return new o.Promise(function(d, p) {
            var m = f.decompressed.getContentWorker().pipe(new c());
            m.on("error", function(_) {
              p(_);
            }).on("end", function() {
              m.streamInfo.crc32 !== f.decompressed.crc32 ? p(new Error("Corrupted zip : CRC32 mismatch")) : d();
            }).resume();
          });
        }
        i.exports = function(f, d) {
          var p = this;
          return d = s.extend(d || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: a.utf8decode }), l.isNode && l.isStream(f) ? o.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : s.prepareContent("the loaded zip file", f, !0, d.optimizedBinaryString, d.base64).then(function(m) {
            var _ = new u(d);
            return _.load(m), _;
          }).then(function(m) {
            var _ = [o.Promise.resolve(m)], y = m.files;
            if (d.checkCRC32) for (var b = 0; b < y.length; b++) _.push(h(y[b]));
            return o.Promise.all(_);
          }).then(function(m) {
            for (var _ = m.shift(), y = _.files, b = 0; b < y.length; b++) {
              var g = y[b], v = g.fileNameStr, w = s.resolve(g.fileNameStr);
              p.file(w, g.decompressed, { binary: !0, optimizedBinaryString: !0, date: g.date, dir: g.dir, comment: g.fileCommentStr.length ? g.fileCommentStr : null, unixPermissions: g.unixPermissions, dosPermissions: g.dosPermissions, createFolders: d.createFolders }), g.dir || (p.file(w).unsafeOriginalName = v);
            }
            return _.zipComment.length && (p.comment = _.zipComment), p;
          });
        };
      }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(n, i, r) {
        var s = n("../utils"), o = n("../stream/GenericWorker");
        function a(u, c) {
          o.call(this, "Nodejs stream input adapter for " + u), this._upstreamEnded = !1, this._bindStream(c);
        }
        s.inherits(a, o), a.prototype._bindStream = function(u) {
          var c = this;
          (this._stream = u).pause(), u.on("data", function(l) {
            c.push({ data: l, meta: { percent: 0 } });
          }).on("error", function(l) {
            c.isPaused ? this.generatedError = l : c.error(l);
          }).on("end", function() {
            c.isPaused ? c._upstreamEnded = !0 : c.end();
          });
        }, a.prototype.pause = function() {
          return !!o.prototype.pause.call(this) && (this._stream.pause(), !0);
        }, a.prototype.resume = function() {
          return !!o.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
        }, i.exports = a;
      }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(n, i, r) {
        var s = n("readable-stream").Readable;
        function o(a, u, c) {
          s.call(this, u), this._helper = a;
          var l = this;
          a.on("data", function(h, f) {
            l.push(h) || l._helper.pause(), c && c(f);
          }).on("error", function(h) {
            l.emit("error", h);
          }).on("end", function() {
            l.push(null);
          });
        }
        n("../utils").inherits(o, s), o.prototype._read = function() {
          this._helper.resume();
        }, i.exports = o;
      }, { "../utils": 32, "readable-stream": 16 }], 14: [function(n, i, r) {
        i.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(s, o) {
          if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(s, o);
          if (typeof s == "number") throw new Error('The "data" argument must not be a number');
          return new Buffer(s, o);
        }, allocBuffer: function(s) {
          if (Buffer.alloc) return Buffer.alloc(s);
          var o = new Buffer(s);
          return o.fill(0), o;
        }, isBuffer: function(s) {
          return Buffer.isBuffer(s);
        }, isStream: function(s) {
          return s && typeof s.on == "function" && typeof s.pause == "function" && typeof s.resume == "function";
        } };
      }, {}], 15: [function(n, i, r) {
        function s(w, E, A) {
          var C, O = a.getTypeOf(E), R = a.extend(A || {}, l);
          R.date = R.date || /* @__PURE__ */ new Date(), R.compression !== null && (R.compression = R.compression.toUpperCase()), typeof R.unixPermissions == "string" && (R.unixPermissions = parseInt(R.unixPermissions, 8)), R.unixPermissions && 16384 & R.unixPermissions && (R.dir = !0), R.dosPermissions && 16 & R.dosPermissions && (R.dir = !0), R.dir && (w = y(w)), R.createFolders && (C = _(w)) && b.call(this, C, !0);
          var P = O === "string" && R.binary === !1 && R.base64 === !1;
          A && A.binary !== void 0 || (R.binary = !P), (E instanceof h && E.uncompressedSize === 0 || R.dir || !E || E.length === 0) && (R.base64 = !1, R.binary = !0, E = "", R.compression = "STORE", O = "string");
          var k = null;
          k = E instanceof h || E instanceof u ? E : p.isNode && p.isStream(E) ? new m(w, E) : a.prepareContent(w, E, R.binary, R.optimizedBinaryString, R.base64);
          var S = new f(w, k, R);
          this.files[w] = S;
        }
        var o = n("./utf8"), a = n("./utils"), u = n("./stream/GenericWorker"), c = n("./stream/StreamHelper"), l = n("./defaults"), h = n("./compressedObject"), f = n("./zipObject"), d = n("./generate"), p = n("./nodejsUtils"), m = n("./nodejs/NodejsStreamInputAdapter"), _ = function(w) {
          w.slice(-1) === "/" && (w = w.substring(0, w.length - 1));
          var E = w.lastIndexOf("/");
          return 0 < E ? w.substring(0, E) : "";
        }, y = function(w) {
          return w.slice(-1) !== "/" && (w += "/"), w;
        }, b = function(w, E) {
          return E = E !== void 0 ? E : l.createFolders, w = y(w), this.files[w] || s.call(this, w, null, { dir: !0, createFolders: E }), this.files[w];
        };
        function g(w) {
          return Object.prototype.toString.call(w) === "[object RegExp]";
        }
        var v = { load: function() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        }, forEach: function(w) {
          var E, A, C;
          for (E in this.files) C = this.files[E], (A = E.slice(this.root.length, E.length)) && E.slice(0, this.root.length) === this.root && w(A, C);
        }, filter: function(w) {
          var E = [];
          return this.forEach(function(A, C) {
            w(A, C) && E.push(C);
          }), E;
        }, file: function(w, E, A) {
          if (arguments.length !== 1) return w = this.root + w, s.call(this, w, E, A), this;
          if (g(w)) {
            var C = w;
            return this.filter(function(R, P) {
              return !P.dir && C.test(R);
            });
          }
          var O = this.files[this.root + w];
          return O && !O.dir ? O : null;
        }, folder: function(w) {
          if (!w) return this;
          if (g(w)) return this.filter(function(O, R) {
            return R.dir && w.test(O);
          });
          var E = this.root + w, A = b.call(this, E), C = this.clone();
          return C.root = A.name, C;
        }, remove: function(w) {
          w = this.root + w;
          var E = this.files[w];
          if (E || (w.slice(-1) !== "/" && (w += "/"), E = this.files[w]), E && !E.dir) delete this.files[w];
          else for (var A = this.filter(function(O, R) {
            return R.name.slice(0, w.length) === w;
          }), C = 0; C < A.length; C++) delete this.files[A[C].name];
          return this;
        }, generate: function() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        }, generateInternalStream: function(w) {
          var E, A = {};
          try {
            if ((A = a.extend(w || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: o.utf8encode })).type = A.type.toLowerCase(), A.compression = A.compression.toUpperCase(), A.type === "binarystring" && (A.type = "string"), !A.type) throw new Error("No output type specified.");
            a.checkSupport(A.type), A.platform !== "darwin" && A.platform !== "freebsd" && A.platform !== "linux" && A.platform !== "sunos" || (A.platform = "UNIX"), A.platform === "win32" && (A.platform = "DOS");
            var C = A.comment || this.comment || "";
            E = d.generateWorker(this, A, C);
          } catch (O) {
            (E = new u("error")).error(O);
          }
          return new c(E, A.type || "string", A.mimeType);
        }, generateAsync: function(w, E) {
          return this.generateInternalStream(w).accumulate(E);
        }, generateNodeStream: function(w, E) {
          return (w = w || {}).type || (w.type = "nodebuffer"), this.generateInternalStream(w).toNodejsStream(E);
        } };
        i.exports = v;
      }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(n, i, r) {
        i.exports = n("stream");
      }, { stream: void 0 }], 17: [function(n, i, r) {
        var s = n("./DataReader");
        function o(a) {
          s.call(this, a);
          for (var u = 0; u < this.data.length; u++) a[u] = 255 & a[u];
        }
        n("../utils").inherits(o, s), o.prototype.byteAt = function(a) {
          return this.data[this.zero + a];
        }, o.prototype.lastIndexOfSignature = function(a) {
          for (var u = a.charCodeAt(0), c = a.charCodeAt(1), l = a.charCodeAt(2), h = a.charCodeAt(3), f = this.length - 4; 0 <= f; --f) if (this.data[f] === u && this.data[f + 1] === c && this.data[f + 2] === l && this.data[f + 3] === h) return f - this.zero;
          return -1;
        }, o.prototype.readAndCheckSignature = function(a) {
          var u = a.charCodeAt(0), c = a.charCodeAt(1), l = a.charCodeAt(2), h = a.charCodeAt(3), f = this.readData(4);
          return u === f[0] && c === f[1] && l === f[2] && h === f[3];
        }, o.prototype.readData = function(a) {
          if (this.checkOffset(a), a === 0) return [];
          var u = this.data.slice(this.zero + this.index, this.zero + this.index + a);
          return this.index += a, u;
        }, i.exports = o;
      }, { "../utils": 32, "./DataReader": 18 }], 18: [function(n, i, r) {
        var s = n("../utils");
        function o(a) {
          this.data = a, this.length = a.length, this.index = 0, this.zero = 0;
        }
        o.prototype = { checkOffset: function(a) {
          this.checkIndex(this.index + a);
        }, checkIndex: function(a) {
          if (this.length < this.zero + a || a < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + a + "). Corrupted zip ?");
        }, setIndex: function(a) {
          this.checkIndex(a), this.index = a;
        }, skip: function(a) {
          this.setIndex(this.index + a);
        }, byteAt: function() {
        }, readInt: function(a) {
          var u, c = 0;
          for (this.checkOffset(a), u = this.index + a - 1; u >= this.index; u--) c = (c << 8) + this.byteAt(u);
          return this.index += a, c;
        }, readString: function(a) {
          return s.transformTo("string", this.readData(a));
        }, readData: function() {
        }, lastIndexOfSignature: function() {
        }, readAndCheckSignature: function() {
        }, readDate: function() {
          var a = this.readInt(4);
          return new Date(Date.UTC(1980 + (a >> 25 & 127), (a >> 21 & 15) - 1, a >> 16 & 31, a >> 11 & 31, a >> 5 & 63, (31 & a) << 1));
        } }, i.exports = o;
      }, { "../utils": 32 }], 19: [function(n, i, r) {
        var s = n("./Uint8ArrayReader");
        function o(a) {
          s.call(this, a);
        }
        n("../utils").inherits(o, s), o.prototype.readData = function(a) {
          this.checkOffset(a);
          var u = this.data.slice(this.zero + this.index, this.zero + this.index + a);
          return this.index += a, u;
        }, i.exports = o;
      }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(n, i, r) {
        var s = n("./DataReader");
        function o(a) {
          s.call(this, a);
        }
        n("../utils").inherits(o, s), o.prototype.byteAt = function(a) {
          return this.data.charCodeAt(this.zero + a);
        }, o.prototype.lastIndexOfSignature = function(a) {
          return this.data.lastIndexOf(a) - this.zero;
        }, o.prototype.readAndCheckSignature = function(a) {
          return a === this.readData(4);
        }, o.prototype.readData = function(a) {
          this.checkOffset(a);
          var u = this.data.slice(this.zero + this.index, this.zero + this.index + a);
          return this.index += a, u;
        }, i.exports = o;
      }, { "../utils": 32, "./DataReader": 18 }], 21: [function(n, i, r) {
        var s = n("./ArrayReader");
        function o(a) {
          s.call(this, a);
        }
        n("../utils").inherits(o, s), o.prototype.readData = function(a) {
          if (this.checkOffset(a), a === 0) return new Uint8Array(0);
          var u = this.data.subarray(this.zero + this.index, this.zero + this.index + a);
          return this.index += a, u;
        }, i.exports = o;
      }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(n, i, r) {
        var s = n("../utils"), o = n("../support"), a = n("./ArrayReader"), u = n("./StringReader"), c = n("./NodeBufferReader"), l = n("./Uint8ArrayReader");
        i.exports = function(h) {
          var f = s.getTypeOf(h);
          return s.checkSupport(f), f !== "string" || o.uint8array ? f === "nodebuffer" ? new c(h) : o.uint8array ? new l(s.transformTo("uint8array", h)) : new a(s.transformTo("array", h)) : new u(h);
        };
      }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(n, i, r) {
        r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\x07\b";
      }, {}], 24: [function(n, i, r) {
        var s = n("./GenericWorker"), o = n("../utils");
        function a(u) {
          s.call(this, "ConvertWorker to " + u), this.destType = u;
        }
        o.inherits(a, s), a.prototype.processChunk = function(u) {
          this.push({ data: o.transformTo(this.destType, u.data), meta: u.meta });
        }, i.exports = a;
      }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(n, i, r) {
        var s = n("./GenericWorker"), o = n("../crc32");
        function a() {
          s.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
        }
        n("../utils").inherits(a, s), a.prototype.processChunk = function(u) {
          this.streamInfo.crc32 = o(u.data, this.streamInfo.crc32 || 0), this.push(u);
        }, i.exports = a;
      }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(n, i, r) {
        var s = n("../utils"), o = n("./GenericWorker");
        function a(u) {
          o.call(this, "DataLengthProbe for " + u), this.propName = u, this.withStreamInfo(u, 0);
        }
        s.inherits(a, o), a.prototype.processChunk = function(u) {
          if (u) {
            var c = this.streamInfo[this.propName] || 0;
            this.streamInfo[this.propName] = c + u.data.length;
          }
          o.prototype.processChunk.call(this, u);
        }, i.exports = a;
      }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(n, i, r) {
        var s = n("../utils"), o = n("./GenericWorker");
        function a(u) {
          o.call(this, "DataWorker");
          var c = this;
          this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, u.then(function(l) {
            c.dataIsReady = !0, c.data = l, c.max = l && l.length || 0, c.type = s.getTypeOf(l), c.isPaused || c._tickAndRepeat();
          }, function(l) {
            c.error(l);
          });
        }
        s.inherits(a, o), a.prototype.cleanUp = function() {
          o.prototype.cleanUp.call(this), this.data = null;
        }, a.prototype.resume = function() {
          return !!o.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, s.delay(this._tickAndRepeat, [], this)), !0);
        }, a.prototype._tickAndRepeat = function() {
          this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (s.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
        }, a.prototype._tick = function() {
          if (this.isPaused || this.isFinished) return !1;
          var u = null, c = Math.min(this.max, this.index + 16384);
          if (this.index >= this.max) return this.end();
          switch (this.type) {
            case "string":
              u = this.data.substring(this.index, c);
              break;
            case "uint8array":
              u = this.data.subarray(this.index, c);
              break;
            case "array":
            case "nodebuffer":
              u = this.data.slice(this.index, c);
          }
          return this.index = c, this.push({ data: u, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
        }, i.exports = a;
      }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(n, i, r) {
        function s(o) {
          this.name = o || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
        }
        s.prototype = { push: function(o) {
          this.emit("data", o);
        }, end: function() {
          if (this.isFinished) return !1;
          this.flush();
          try {
            this.emit("end"), this.cleanUp(), this.isFinished = !0;
          } catch (o) {
            this.emit("error", o);
          }
          return !0;
        }, error: function(o) {
          return !this.isFinished && (this.isPaused ? this.generatedError = o : (this.isFinished = !0, this.emit("error", o), this.previous && this.previous.error(o), this.cleanUp()), !0);
        }, on: function(o, a) {
          return this._listeners[o].push(a), this;
        }, cleanUp: function() {
          this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
        }, emit: function(o, a) {
          if (this._listeners[o]) for (var u = 0; u < this._listeners[o].length; u++) this._listeners[o][u].call(this, a);
        }, pipe: function(o) {
          return o.registerPrevious(this);
        }, registerPrevious: function(o) {
          if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
          this.streamInfo = o.streamInfo, this.mergeStreamInfo(), this.previous = o;
          var a = this;
          return o.on("data", function(u) {
            a.processChunk(u);
          }), o.on("end", function() {
            a.end();
          }), o.on("error", function(u) {
            a.error(u);
          }), this;
        }, pause: function() {
          return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
        }, resume: function() {
          if (!this.isPaused || this.isFinished) return !1;
          var o = this.isPaused = !1;
          return this.generatedError && (this.error(this.generatedError), o = !0), this.previous && this.previous.resume(), !o;
        }, flush: function() {
        }, processChunk: function(o) {
          this.push(o);
        }, withStreamInfo: function(o, a) {
          return this.extraStreamInfo[o] = a, this.mergeStreamInfo(), this;
        }, mergeStreamInfo: function() {
          for (var o in this.extraStreamInfo) Object.prototype.hasOwnProperty.call(this.extraStreamInfo, o) && (this.streamInfo[o] = this.extraStreamInfo[o]);
        }, lock: function() {
          if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
          this.isLocked = !0, this.previous && this.previous.lock();
        }, toString: function() {
          var o = "Worker " + this.name;
          return this.previous ? this.previous + " -> " + o : o;
        } }, i.exports = s;
      }, {}], 29: [function(n, i, r) {
        var s = n("../utils"), o = n("./ConvertWorker"), a = n("./GenericWorker"), u = n("../base64"), c = n("../support"), l = n("../external"), h = null;
        if (c.nodestream) try {
          h = n("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
        function f(p, m) {
          return new l.Promise(function(_, y) {
            var b = [], g = p._internalType, v = p._outputType, w = p._mimeType;
            p.on("data", function(E, A) {
              b.push(E), m && m(A);
            }).on("error", function(E) {
              b = [], y(E);
            }).on("end", function() {
              try {
                var E = function(A, C, O) {
                  switch (A) {
                    case "blob":
                      return s.newBlob(s.transformTo("arraybuffer", C), O);
                    case "base64":
                      return u.encode(C);
                    default:
                      return s.transformTo(A, C);
                  }
                }(v, function(A, C) {
                  var O, R = 0, P = null, k = 0;
                  for (O = 0; O < C.length; O++) k += C[O].length;
                  switch (A) {
                    case "string":
                      return C.join("");
                    case "array":
                      return Array.prototype.concat.apply([], C);
                    case "uint8array":
                      for (P = new Uint8Array(k), O = 0; O < C.length; O++) P.set(C[O], R), R += C[O].length;
                      return P;
                    case "nodebuffer":
                      return Buffer.concat(C);
                    default:
                      throw new Error("concat : unsupported type '" + A + "'");
                  }
                }(g, b), w);
                _(E);
              } catch (A) {
                y(A);
              }
              b = [];
            }).resume();
          });
        }
        function d(p, m, _) {
          var y = m;
          switch (m) {
            case "blob":
            case "arraybuffer":
              y = "uint8array";
              break;
            case "base64":
              y = "string";
          }
          try {
            this._internalType = y, this._outputType = m, this._mimeType = _, s.checkSupport(y), this._worker = p.pipe(new o(y)), p.lock();
          } catch (b) {
            this._worker = new a("error"), this._worker.error(b);
          }
        }
        d.prototype = { accumulate: function(p) {
          return f(this, p);
        }, on: function(p, m) {
          var _ = this;
          return p === "data" ? this._worker.on(p, function(y) {
            m.call(_, y.data, y.meta);
          }) : this._worker.on(p, function() {
            s.delay(m, arguments, _);
          }), this;
        }, resume: function() {
          return s.delay(this._worker.resume, [], this._worker), this;
        }, pause: function() {
          return this._worker.pause(), this;
        }, toNodejsStream: function(p) {
          if (s.checkSupport("nodestream"), this._outputType !== "nodebuffer") throw new Error(this._outputType + " is not supported by this method");
          return new h(this, { objectMode: this._outputType !== "nodebuffer" }, p);
        } }, i.exports = d;
      }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(n, i, r) {
        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", r.nodebuffer = typeof Buffer < "u", r.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u") r.blob = !1;
        else {
          var s = new ArrayBuffer(0);
          try {
            r.blob = new Blob([s], { type: "application/zip" }).size === 0;
          } catch {
            try {
              var o = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
              o.append(s), r.blob = o.getBlob("application/zip").size === 0;
            } catch {
              r.blob = !1;
            }
          }
        }
        try {
          r.nodestream = !!n("readable-stream").Readable;
        } catch {
          r.nodestream = !1;
        }
      }, { "readable-stream": 16 }], 31: [function(n, i, r) {
        for (var s = n("./utils"), o = n("./support"), a = n("./nodejsUtils"), u = n("./stream/GenericWorker"), c = new Array(256), l = 0; l < 256; l++) c[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
        c[254] = c[254] = 1;
        function h() {
          u.call(this, "utf-8 decode"), this.leftOver = null;
        }
        function f() {
          u.call(this, "utf-8 encode");
        }
        r.utf8encode = function(d) {
          return o.nodebuffer ? a.newBufferFrom(d, "utf-8") : function(p) {
            var m, _, y, b, g, v = p.length, w = 0;
            for (b = 0; b < v; b++) (64512 & (_ = p.charCodeAt(b))) == 55296 && b + 1 < v && (64512 & (y = p.charCodeAt(b + 1))) == 56320 && (_ = 65536 + (_ - 55296 << 10) + (y - 56320), b++), w += _ < 128 ? 1 : _ < 2048 ? 2 : _ < 65536 ? 3 : 4;
            for (m = o.uint8array ? new Uint8Array(w) : new Array(w), b = g = 0; g < w; b++) (64512 & (_ = p.charCodeAt(b))) == 55296 && b + 1 < v && (64512 & (y = p.charCodeAt(b + 1))) == 56320 && (_ = 65536 + (_ - 55296 << 10) + (y - 56320), b++), _ < 128 ? m[g++] = _ : (_ < 2048 ? m[g++] = 192 | _ >>> 6 : (_ < 65536 ? m[g++] = 224 | _ >>> 12 : (m[g++] = 240 | _ >>> 18, m[g++] = 128 | _ >>> 12 & 63), m[g++] = 128 | _ >>> 6 & 63), m[g++] = 128 | 63 & _);
            return m;
          }(d);
        }, r.utf8decode = function(d) {
          return o.nodebuffer ? s.transformTo("nodebuffer", d).toString("utf-8") : function(p) {
            var m, _, y, b, g = p.length, v = new Array(2 * g);
            for (m = _ = 0; m < g; ) if ((y = p[m++]) < 128) v[_++] = y;
            else if (4 < (b = c[y])) v[_++] = 65533, m += b - 1;
            else {
              for (y &= b === 2 ? 31 : b === 3 ? 15 : 7; 1 < b && m < g; ) y = y << 6 | 63 & p[m++], b--;
              1 < b ? v[_++] = 65533 : y < 65536 ? v[_++] = y : (y -= 65536, v[_++] = 55296 | y >> 10 & 1023, v[_++] = 56320 | 1023 & y);
            }
            return v.length !== _ && (v.subarray ? v = v.subarray(0, _) : v.length = _), s.applyFromCharCode(v);
          }(d = s.transformTo(o.uint8array ? "uint8array" : "array", d));
        }, s.inherits(h, u), h.prototype.processChunk = function(d) {
          var p = s.transformTo(o.uint8array ? "uint8array" : "array", d.data);
          if (this.leftOver && this.leftOver.length) {
            if (o.uint8array) {
              var m = p;
              (p = new Uint8Array(m.length + this.leftOver.length)).set(this.leftOver, 0), p.set(m, this.leftOver.length);
            } else p = this.leftOver.concat(p);
            this.leftOver = null;
          }
          var _ = function(b, g) {
            var v;
            for ((g = g || b.length) > b.length && (g = b.length), v = g - 1; 0 <= v && (192 & b[v]) == 128; ) v--;
            return v < 0 || v === 0 ? g : v + c[b[v]] > g ? v : g;
          }(p), y = p;
          _ !== p.length && (o.uint8array ? (y = p.subarray(0, _), this.leftOver = p.subarray(_, p.length)) : (y = p.slice(0, _), this.leftOver = p.slice(_, p.length))), this.push({ data: r.utf8decode(y), meta: d.meta });
        }, h.prototype.flush = function() {
          this.leftOver && this.leftOver.length && (this.push({ data: r.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
        }, r.Utf8DecodeWorker = h, s.inherits(f, u), f.prototype.processChunk = function(d) {
          this.push({ data: r.utf8encode(d.data), meta: d.meta });
        }, r.Utf8EncodeWorker = f;
      }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(n, i, r) {
        var s = n("./support"), o = n("./base64"), a = n("./nodejsUtils"), u = n("./external");
        function c(m) {
          return m;
        }
        function l(m, _) {
          for (var y = 0; y < m.length; ++y) _[y] = 255 & m.charCodeAt(y);
          return _;
        }
        n("setimmediate"), r.newBlob = function(m, _) {
          r.checkSupport("blob");
          try {
            return new Blob([m], { type: _ });
          } catch {
            try {
              var y = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
              return y.append(m), y.getBlob(_);
            } catch {
              throw new Error("Bug : can't construct the Blob.");
            }
          }
        };
        var h = { stringifyByChunk: function(m, _, y) {
          var b = [], g = 0, v = m.length;
          if (v <= y) return String.fromCharCode.apply(null, m);
          for (; g < v; ) _ === "array" || _ === "nodebuffer" ? b.push(String.fromCharCode.apply(null, m.slice(g, Math.min(g + y, v)))) : b.push(String.fromCharCode.apply(null, m.subarray(g, Math.min(g + y, v)))), g += y;
          return b.join("");
        }, stringifyByChar: function(m) {
          for (var _ = "", y = 0; y < m.length; y++) _ += String.fromCharCode(m[y]);
          return _;
        }, applyCanBeUsed: { uint8array: function() {
          try {
            return s.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
          } catch {
            return !1;
          }
        }(), nodebuffer: function() {
          try {
            return s.nodebuffer && String.fromCharCode.apply(null, a.allocBuffer(1)).length === 1;
          } catch {
            return !1;
          }
        }() } };
        function f(m) {
          var _ = 65536, y = r.getTypeOf(m), b = !0;
          if (y === "uint8array" ? b = h.applyCanBeUsed.uint8array : y === "nodebuffer" && (b = h.applyCanBeUsed.nodebuffer), b) for (; 1 < _; ) try {
            return h.stringifyByChunk(m, y, _);
          } catch {
            _ = Math.floor(_ / 2);
          }
          return h.stringifyByChar(m);
        }
        function d(m, _) {
          for (var y = 0; y < m.length; y++) _[y] = m[y];
          return _;
        }
        r.applyFromCharCode = f;
        var p = {};
        p.string = { string: c, array: function(m) {
          return l(m, new Array(m.length));
        }, arraybuffer: function(m) {
          return p.string.uint8array(m).buffer;
        }, uint8array: function(m) {
          return l(m, new Uint8Array(m.length));
        }, nodebuffer: function(m) {
          return l(m, a.allocBuffer(m.length));
        } }, p.array = { string: f, array: c, arraybuffer: function(m) {
          return new Uint8Array(m).buffer;
        }, uint8array: function(m) {
          return new Uint8Array(m);
        }, nodebuffer: function(m) {
          return a.newBufferFrom(m);
        } }, p.arraybuffer = { string: function(m) {
          return f(new Uint8Array(m));
        }, array: function(m) {
          return d(new Uint8Array(m), new Array(m.byteLength));
        }, arraybuffer: c, uint8array: function(m) {
          return new Uint8Array(m);
        }, nodebuffer: function(m) {
          return a.newBufferFrom(new Uint8Array(m));
        } }, p.uint8array = { string: f, array: function(m) {
          return d(m, new Array(m.length));
        }, arraybuffer: function(m) {
          return m.buffer;
        }, uint8array: c, nodebuffer: function(m) {
          return a.newBufferFrom(m);
        } }, p.nodebuffer = { string: f, array: function(m) {
          return d(m, new Array(m.length));
        }, arraybuffer: function(m) {
          return p.nodebuffer.uint8array(m).buffer;
        }, uint8array: function(m) {
          return d(m, new Uint8Array(m.length));
        }, nodebuffer: c }, r.transformTo = function(m, _) {
          if (_ = _ || "", !m) return _;
          r.checkSupport(m);
          var y = r.getTypeOf(_);
          return p[y][m](_);
        }, r.resolve = function(m) {
          for (var _ = m.split("/"), y = [], b = 0; b < _.length; b++) {
            var g = _[b];
            g === "." || g === "" && b !== 0 && b !== _.length - 1 || (g === ".." ? y.pop() : y.push(g));
          }
          return y.join("/");
        }, r.getTypeOf = function(m) {
          return typeof m == "string" ? "string" : Object.prototype.toString.call(m) === "[object Array]" ? "array" : s.nodebuffer && a.isBuffer(m) ? "nodebuffer" : s.uint8array && m instanceof Uint8Array ? "uint8array" : s.arraybuffer && m instanceof ArrayBuffer ? "arraybuffer" : void 0;
        }, r.checkSupport = function(m) {
          if (!s[m.toLowerCase()]) throw new Error(m + " is not supported by this platform");
        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(m) {
          var _, y, b = "";
          for (y = 0; y < (m || "").length; y++) b += "\\x" + ((_ = m.charCodeAt(y)) < 16 ? "0" : "") + _.toString(16).toUpperCase();
          return b;
        }, r.delay = function(m, _, y) {
          setImmediate(function() {
            m.apply(y || null, _ || []);
          });
        }, r.inherits = function(m, _) {
          function y() {
          }
          y.prototype = _.prototype, m.prototype = new y();
        }, r.extend = function() {
          var m, _, y = {};
          for (m = 0; m < arguments.length; m++) for (_ in arguments[m]) Object.prototype.hasOwnProperty.call(arguments[m], _) && y[_] === void 0 && (y[_] = arguments[m][_]);
          return y;
        }, r.prepareContent = function(m, _, y, b, g) {
          return u.Promise.resolve(_).then(function(v) {
            return s.blob && (v instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(v)) !== -1) && typeof FileReader < "u" ? new u.Promise(function(w, E) {
              var A = new FileReader();
              A.onload = function(C) {
                w(C.target.result);
              }, A.onerror = function(C) {
                E(C.target.error);
              }, A.readAsArrayBuffer(v);
            }) : v;
          }).then(function(v) {
            var w = r.getTypeOf(v);
            return w ? (w === "arraybuffer" ? v = r.transformTo("uint8array", v) : w === "string" && (g ? v = o.decode(v) : y && b !== !0 && (v = function(E) {
              return l(E, s.uint8array ? new Uint8Array(E.length) : new Array(E.length));
            }(v))), v) : u.Promise.reject(new Error("Can't read the data of '" + m + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
          });
        };
      }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(n, i, r) {
        var s = n("./reader/readerFor"), o = n("./utils"), a = n("./signature"), u = n("./zipEntry"), c = n("./support");
        function l(h) {
          this.files = [], this.loadOptions = h;
        }
        l.prototype = { checkSignature: function(h) {
          if (!this.reader.readAndCheckSignature(h)) {
            this.reader.index -= 4;
            var f = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature (" + o.pretty(f) + ", expected " + o.pretty(h) + ")");
          }
        }, isSignature: function(h, f) {
          var d = this.reader.index;
          this.reader.setIndex(h);
          var p = this.reader.readString(4) === f;
          return this.reader.setIndex(d), p;
        }, readBlockEndOfCentral: function() {
          this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
          var h = this.reader.readData(this.zipCommentLength), f = c.uint8array ? "uint8array" : "array", d = o.transformTo(f, h);
          this.zipComment = this.loadOptions.decodeFileName(d);
        }, readBlockZip64EndOfCentral: function() {
          this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
          for (var h, f, d, p = this.zip64EndOfCentralSize - 44; 0 < p; ) h = this.reader.readInt(2), f = this.reader.readInt(4), d = this.reader.readData(f), this.zip64ExtensibleData[h] = { id: h, length: f, value: d };
        }, readBlockZip64EndOfCentralLocator: function() {
          if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
        }, readLocalFiles: function() {
          var h, f;
          for (h = 0; h < this.files.length; h++) f = this.files[h], this.reader.setIndex(f.localHeaderOffset), this.checkSignature(a.LOCAL_FILE_HEADER), f.readLocalPart(this.reader), f.handleUTF8(), f.processAttributes();
        }, readCentralDir: function() {
          var h;
          for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(a.CENTRAL_FILE_HEADER); ) (h = new u({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(h);
          if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
        }, readEndOfCentral: function() {
          var h = this.reader.lastIndexOfSignature(a.CENTRAL_DIRECTORY_END);
          if (h < 0) throw this.isSignature(0, a.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
          this.reader.setIndex(h);
          var f = h;
          if (this.checkSignature(a.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === o.MAX_VALUE_16BITS || this.diskWithCentralDirStart === o.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === o.MAX_VALUE_16BITS || this.centralDirRecords === o.MAX_VALUE_16BITS || this.centralDirSize === o.MAX_VALUE_32BITS || this.centralDirOffset === o.MAX_VALUE_32BITS) {
            if (this.zip64 = !0, (h = this.reader.lastIndexOfSignature(a.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            if (this.reader.setIndex(h), this.checkSignature(a.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, a.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(a.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(a.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
          }
          var d = this.centralDirOffset + this.centralDirSize;
          this.zip64 && (d += 20, d += 12 + this.zip64EndOfCentralSize);
          var p = f - d;
          if (0 < p) this.isSignature(f, a.CENTRAL_FILE_HEADER) || (this.reader.zero = p);
          else if (p < 0) throw new Error("Corrupted zip: missing " + Math.abs(p) + " bytes.");
        }, prepareReader: function(h) {
          this.reader = s(h);
        }, load: function(h) {
          this.prepareReader(h), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
        } }, i.exports = l;
      }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(n, i, r) {
        var s = n("./reader/readerFor"), o = n("./utils"), a = n("./compressedObject"), u = n("./crc32"), c = n("./utf8"), l = n("./compressions"), h = n("./support");
        function f(d, p) {
          this.options = d, this.loadOptions = p;
        }
        f.prototype = { isEncrypted: function() {
          return (1 & this.bitFlag) == 1;
        }, useUTF8: function() {
          return (2048 & this.bitFlag) == 2048;
        }, readLocalPart: function(d) {
          var p, m;
          if (d.skip(22), this.fileNameLength = d.readInt(2), m = d.readInt(2), this.fileName = d.readData(this.fileNameLength), d.skip(m), this.compressedSize === -1 || this.uncompressedSize === -1) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
          if ((p = function(_) {
            for (var y in l) if (Object.prototype.hasOwnProperty.call(l, y) && l[y].magic === _) return l[y];
            return null;
          }(this.compressionMethod)) === null) throw new Error("Corrupted zip : compression " + o.pretty(this.compressionMethod) + " unknown (inner file : " + o.transformTo("string", this.fileName) + ")");
          this.decompressed = new a(this.compressedSize, this.uncompressedSize, this.crc32, p, d.readData(this.compressedSize));
        }, readCentralPart: function(d) {
          this.versionMadeBy = d.readInt(2), d.skip(2), this.bitFlag = d.readInt(2), this.compressionMethod = d.readString(2), this.date = d.readDate(), this.crc32 = d.readInt(4), this.compressedSize = d.readInt(4), this.uncompressedSize = d.readInt(4);
          var p = d.readInt(2);
          if (this.extraFieldsLength = d.readInt(2), this.fileCommentLength = d.readInt(2), this.diskNumberStart = d.readInt(2), this.internalFileAttributes = d.readInt(2), this.externalFileAttributes = d.readInt(4), this.localHeaderOffset = d.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
          d.skip(p), this.readExtraFields(d), this.parseZIP64ExtraField(d), this.fileComment = d.readData(this.fileCommentLength);
        }, processAttributes: function() {
          this.unixPermissions = null, this.dosPermissions = null;
          var d = this.versionMadeBy >> 8;
          this.dir = !!(16 & this.externalFileAttributes), d == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), d == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
        }, parseZIP64ExtraField: function() {
          if (this.extraFields[1]) {
            var d = s(this.extraFields[1].value);
            this.uncompressedSize === o.MAX_VALUE_32BITS && (this.uncompressedSize = d.readInt(8)), this.compressedSize === o.MAX_VALUE_32BITS && (this.compressedSize = d.readInt(8)), this.localHeaderOffset === o.MAX_VALUE_32BITS && (this.localHeaderOffset = d.readInt(8)), this.diskNumberStart === o.MAX_VALUE_32BITS && (this.diskNumberStart = d.readInt(4));
          }
        }, readExtraFields: function(d) {
          var p, m, _, y = d.index + this.extraFieldsLength;
          for (this.extraFields || (this.extraFields = {}); d.index + 4 < y; ) p = d.readInt(2), m = d.readInt(2), _ = d.readData(m), this.extraFields[p] = { id: p, length: m, value: _ };
          d.setIndex(y);
        }, handleUTF8: function() {
          var d = h.uint8array ? "uint8array" : "array";
          if (this.useUTF8()) this.fileNameStr = c.utf8decode(this.fileName), this.fileCommentStr = c.utf8decode(this.fileComment);
          else {
            var p = this.findExtraFieldUnicodePath();
            if (p !== null) this.fileNameStr = p;
            else {
              var m = o.transformTo(d, this.fileName);
              this.fileNameStr = this.loadOptions.decodeFileName(m);
            }
            var _ = this.findExtraFieldUnicodeComment();
            if (_ !== null) this.fileCommentStr = _;
            else {
              var y = o.transformTo(d, this.fileComment);
              this.fileCommentStr = this.loadOptions.decodeFileName(y);
            }
          }
        }, findExtraFieldUnicodePath: function() {
          var d = this.extraFields[28789];
          if (d) {
            var p = s(d.value);
            return p.readInt(1) !== 1 || u(this.fileName) !== p.readInt(4) ? null : c.utf8decode(p.readData(d.length - 5));
          }
          return null;
        }, findExtraFieldUnicodeComment: function() {
          var d = this.extraFields[25461];
          if (d) {
            var p = s(d.value);
            return p.readInt(1) !== 1 || u(this.fileComment) !== p.readInt(4) ? null : c.utf8decode(p.readData(d.length - 5));
          }
          return null;
        } }, i.exports = f;
      }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(n, i, r) {
        function s(p, m, _) {
          this.name = p, this.dir = _.dir, this.date = _.date, this.comment = _.comment, this.unixPermissions = _.unixPermissions, this.dosPermissions = _.dosPermissions, this._data = m, this._dataBinary = _.binary, this.options = { compression: _.compression, compressionOptions: _.compressionOptions };
        }
        var o = n("./stream/StreamHelper"), a = n("./stream/DataWorker"), u = n("./utf8"), c = n("./compressedObject"), l = n("./stream/GenericWorker");
        s.prototype = { internalStream: function(p) {
          var m = null, _ = "string";
          try {
            if (!p) throw new Error("No output type specified.");
            var y = (_ = p.toLowerCase()) === "string" || _ === "text";
            _ !== "binarystring" && _ !== "text" || (_ = "string"), m = this._decompressWorker();
            var b = !this._dataBinary;
            b && !y && (m = m.pipe(new u.Utf8EncodeWorker())), !b && y && (m = m.pipe(new u.Utf8DecodeWorker()));
          } catch (g) {
            (m = new l("error")).error(g);
          }
          return new o(m, _, "");
        }, async: function(p, m) {
          return this.internalStream(p).accumulate(m);
        }, nodeStream: function(p, m) {
          return this.internalStream(p || "nodebuffer").toNodejsStream(m);
        }, _compressWorker: function(p, m) {
          if (this._data instanceof c && this._data.compression.magic === p.magic) return this._data.getCompressedWorker();
          var _ = this._decompressWorker();
          return this._dataBinary || (_ = _.pipe(new u.Utf8EncodeWorker())), c.createWorkerFrom(_, p, m);
        }, _decompressWorker: function() {
          return this._data instanceof c ? this._data.getContentWorker() : this._data instanceof l ? this._data : new a(this._data);
        } };
        for (var h = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], f = function() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        }, d = 0; d < h.length; d++) s.prototype[h[d]] = f;
        i.exports = s;
      }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(n, i, r) {
        (function(s) {
          var o, a, u = s.MutationObserver || s.WebKitMutationObserver;
          if (u) {
            var c = 0, l = new u(p), h = s.document.createTextNode("");
            l.observe(h, { characterData: !0 }), o = function() {
              h.data = c = ++c % 2;
            };
          } else if (s.setImmediate || s.MessageChannel === void 0) o = "document" in s && "onreadystatechange" in s.document.createElement("script") ? function() {
            var m = s.document.createElement("script");
            m.onreadystatechange = function() {
              p(), m.onreadystatechange = null, m.parentNode.removeChild(m), m = null;
            }, s.document.documentElement.appendChild(m);
          } : function() {
            setTimeout(p, 0);
          };
          else {
            var f = new s.MessageChannel();
            f.port1.onmessage = p, o = function() {
              f.port2.postMessage(0);
            };
          }
          var d = [];
          function p() {
            var m, _;
            a = !0;
            for (var y = d.length; y; ) {
              for (_ = d, d = [], m = -1; ++m < y; ) _[m]();
              y = d.length;
            }
            a = !1;
          }
          i.exports = function(m) {
            d.push(m) !== 1 || a || o();
          };
        }).call(this, typeof sn < "u" ? sn : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}], 37: [function(n, i, r) {
        var s = n("immediate");
        function o() {
        }
        var a = {}, u = ["REJECTED"], c = ["FULFILLED"], l = ["PENDING"];
        function h(y) {
          if (typeof y != "function") throw new TypeError("resolver must be a function");
          this.state = l, this.queue = [], this.outcome = void 0, y !== o && m(this, y);
        }
        function f(y, b, g) {
          this.promise = y, typeof b == "function" && (this.onFulfilled = b, this.callFulfilled = this.otherCallFulfilled), typeof g == "function" && (this.onRejected = g, this.callRejected = this.otherCallRejected);
        }
        function d(y, b, g) {
          s(function() {
            var v;
            try {
              v = b(g);
            } catch (w) {
              return a.reject(y, w);
            }
            v === y ? a.reject(y, new TypeError("Cannot resolve promise with itself")) : a.resolve(y, v);
          });
        }
        function p(y) {
          var b = y && y.then;
          if (y && (typeof y == "object" || typeof y == "function") && typeof b == "function") return function() {
            b.apply(y, arguments);
          };
        }
        function m(y, b) {
          var g = !1;
          function v(A) {
            g || (g = !0, a.reject(y, A));
          }
          function w(A) {
            g || (g = !0, a.resolve(y, A));
          }
          var E = _(function() {
            b(w, v);
          });
          E.status === "error" && v(E.value);
        }
        function _(y, b) {
          var g = {};
          try {
            g.value = y(b), g.status = "success";
          } catch (v) {
            g.status = "error", g.value = v;
          }
          return g;
        }
        (i.exports = h).prototype.finally = function(y) {
          if (typeof y != "function") return this;
          var b = this.constructor;
          return this.then(function(g) {
            return b.resolve(y()).then(function() {
              return g;
            });
          }, function(g) {
            return b.resolve(y()).then(function() {
              throw g;
            });
          });
        }, h.prototype.catch = function(y) {
          return this.then(null, y);
        }, h.prototype.then = function(y, b) {
          if (typeof y != "function" && this.state === c || typeof b != "function" && this.state === u) return this;
          var g = new this.constructor(o);
          return this.state !== l ? d(g, this.state === c ? y : b, this.outcome) : this.queue.push(new f(g, y, b)), g;
        }, f.prototype.callFulfilled = function(y) {
          a.resolve(this.promise, y);
        }, f.prototype.otherCallFulfilled = function(y) {
          d(this.promise, this.onFulfilled, y);
        }, f.prototype.callRejected = function(y) {
          a.reject(this.promise, y);
        }, f.prototype.otherCallRejected = function(y) {
          d(this.promise, this.onRejected, y);
        }, a.resolve = function(y, b) {
          var g = _(p, b);
          if (g.status === "error") return a.reject(y, g.value);
          var v = g.value;
          if (v) m(y, v);
          else {
            y.state = c, y.outcome = b;
            for (var w = -1, E = y.queue.length; ++w < E; ) y.queue[w].callFulfilled(b);
          }
          return y;
        }, a.reject = function(y, b) {
          y.state = u, y.outcome = b;
          for (var g = -1, v = y.queue.length; ++g < v; ) y.queue[g].callRejected(b);
          return y;
        }, h.resolve = function(y) {
          return y instanceof this ? y : a.resolve(new this(o), y);
        }, h.reject = function(y) {
          var b = new this(o);
          return a.reject(b, y);
        }, h.all = function(y) {
          var b = this;
          if (Object.prototype.toString.call(y) !== "[object Array]") return this.reject(new TypeError("must be an array"));
          var g = y.length, v = !1;
          if (!g) return this.resolve([]);
          for (var w = new Array(g), E = 0, A = -1, C = new this(o); ++A < g; ) O(y[A], A);
          return C;
          function O(R, P) {
            b.resolve(R).then(function(k) {
              w[P] = k, ++E !== g || v || (v = !0, a.resolve(C, w));
            }, function(k) {
              v || (v = !0, a.reject(C, k));
            });
          }
        }, h.race = function(y) {
          var b = this;
          if (Object.prototype.toString.call(y) !== "[object Array]") return this.reject(new TypeError("must be an array"));
          var g = y.length, v = !1;
          if (!g) return this.resolve([]);
          for (var w = -1, E = new this(o); ++w < g; ) A = y[w], b.resolve(A).then(function(C) {
            v || (v = !0, a.resolve(E, C));
          }, function(C) {
            v || (v = !0, a.reject(E, C));
          });
          var A;
          return E;
        };
      }, { immediate: 36 }], 38: [function(n, i, r) {
        var s = {};
        (0, n("./lib/utils/common").assign)(s, n("./lib/deflate"), n("./lib/inflate"), n("./lib/zlib/constants")), i.exports = s;
      }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(n, i, r) {
        var s = n("./zlib/deflate"), o = n("./utils/common"), a = n("./utils/strings"), u = n("./zlib/messages"), c = n("./zlib/zstream"), l = Object.prototype.toString, h = 0, f = -1, d = 0, p = 8;
        function m(y) {
          if (!(this instanceof m)) return new m(y);
          this.options = o.assign({ level: f, method: p, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: d, to: "" }, y || {});
          var b = this.options;
          b.raw && 0 < b.windowBits ? b.windowBits = -b.windowBits : b.gzip && 0 < b.windowBits && b.windowBits < 16 && (b.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new c(), this.strm.avail_out = 0;
          var g = s.deflateInit2(this.strm, b.level, b.method, b.windowBits, b.memLevel, b.strategy);
          if (g !== h) throw new Error(u[g]);
          if (b.header && s.deflateSetHeader(this.strm, b.header), b.dictionary) {
            var v;
            if (v = typeof b.dictionary == "string" ? a.string2buf(b.dictionary) : l.call(b.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(b.dictionary) : b.dictionary, (g = s.deflateSetDictionary(this.strm, v)) !== h) throw new Error(u[g]);
            this._dict_set = !0;
          }
        }
        function _(y, b) {
          var g = new m(b);
          if (g.push(y, !0), g.err) throw g.msg || u[g.err];
          return g.result;
        }
        m.prototype.push = function(y, b) {
          var g, v, w = this.strm, E = this.options.chunkSize;
          if (this.ended) return !1;
          v = b === ~~b ? b : b === !0 ? 4 : 0, typeof y == "string" ? w.input = a.string2buf(y) : l.call(y) === "[object ArrayBuffer]" ? w.input = new Uint8Array(y) : w.input = y, w.next_in = 0, w.avail_in = w.input.length;
          do {
            if (w.avail_out === 0 && (w.output = new o.Buf8(E), w.next_out = 0, w.avail_out = E), (g = s.deflate(w, v)) !== 1 && g !== h) return this.onEnd(g), !(this.ended = !0);
            w.avail_out !== 0 && (w.avail_in !== 0 || v !== 4 && v !== 2) || (this.options.to === "string" ? this.onData(a.buf2binstring(o.shrinkBuf(w.output, w.next_out))) : this.onData(o.shrinkBuf(w.output, w.next_out)));
          } while ((0 < w.avail_in || w.avail_out === 0) && g !== 1);
          return v === 4 ? (g = s.deflateEnd(this.strm), this.onEnd(g), this.ended = !0, g === h) : v !== 2 || (this.onEnd(h), !(w.avail_out = 0));
        }, m.prototype.onData = function(y) {
          this.chunks.push(y);
        }, m.prototype.onEnd = function(y) {
          y === h && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = y, this.msg = this.strm.msg;
        }, r.Deflate = m, r.deflate = _, r.deflateRaw = function(y, b) {
          return (b = b || {}).raw = !0, _(y, b);
        }, r.gzip = function(y, b) {
          return (b = b || {}).gzip = !0, _(y, b);
        };
      }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(n, i, r) {
        var s = n("./zlib/inflate"), o = n("./utils/common"), a = n("./utils/strings"), u = n("./zlib/constants"), c = n("./zlib/messages"), l = n("./zlib/zstream"), h = n("./zlib/gzheader"), f = Object.prototype.toString;
        function d(m) {
          if (!(this instanceof d)) return new d(m);
          this.options = o.assign({ chunkSize: 16384, windowBits: 0, to: "" }, m || {});
          var _ = this.options;
          _.raw && 0 <= _.windowBits && _.windowBits < 16 && (_.windowBits = -_.windowBits, _.windowBits === 0 && (_.windowBits = -15)), !(0 <= _.windowBits && _.windowBits < 16) || m && m.windowBits || (_.windowBits += 32), 15 < _.windowBits && _.windowBits < 48 && (15 & _.windowBits) == 0 && (_.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l(), this.strm.avail_out = 0;
          var y = s.inflateInit2(this.strm, _.windowBits);
          if (y !== u.Z_OK) throw new Error(c[y]);
          this.header = new h(), s.inflateGetHeader(this.strm, this.header);
        }
        function p(m, _) {
          var y = new d(_);
          if (y.push(m, !0), y.err) throw y.msg || c[y.err];
          return y.result;
        }
        d.prototype.push = function(m, _) {
          var y, b, g, v, w, E, A = this.strm, C = this.options.chunkSize, O = this.options.dictionary, R = !1;
          if (this.ended) return !1;
          b = _ === ~~_ ? _ : _ === !0 ? u.Z_FINISH : u.Z_NO_FLUSH, typeof m == "string" ? A.input = a.binstring2buf(m) : f.call(m) === "[object ArrayBuffer]" ? A.input = new Uint8Array(m) : A.input = m, A.next_in = 0, A.avail_in = A.input.length;
          do {
            if (A.avail_out === 0 && (A.output = new o.Buf8(C), A.next_out = 0, A.avail_out = C), (y = s.inflate(A, u.Z_NO_FLUSH)) === u.Z_NEED_DICT && O && (E = typeof O == "string" ? a.string2buf(O) : f.call(O) === "[object ArrayBuffer]" ? new Uint8Array(O) : O, y = s.inflateSetDictionary(this.strm, E)), y === u.Z_BUF_ERROR && R === !0 && (y = u.Z_OK, R = !1), y !== u.Z_STREAM_END && y !== u.Z_OK) return this.onEnd(y), !(this.ended = !0);
            A.next_out && (A.avail_out !== 0 && y !== u.Z_STREAM_END && (A.avail_in !== 0 || b !== u.Z_FINISH && b !== u.Z_SYNC_FLUSH) || (this.options.to === "string" ? (g = a.utf8border(A.output, A.next_out), v = A.next_out - g, w = a.buf2string(A.output, g), A.next_out = v, A.avail_out = C - v, v && o.arraySet(A.output, A.output, g, v, 0), this.onData(w)) : this.onData(o.shrinkBuf(A.output, A.next_out)))), A.avail_in === 0 && A.avail_out === 0 && (R = !0);
          } while ((0 < A.avail_in || A.avail_out === 0) && y !== u.Z_STREAM_END);
          return y === u.Z_STREAM_END && (b = u.Z_FINISH), b === u.Z_FINISH ? (y = s.inflateEnd(this.strm), this.onEnd(y), this.ended = !0, y === u.Z_OK) : b !== u.Z_SYNC_FLUSH || (this.onEnd(u.Z_OK), !(A.avail_out = 0));
        }, d.prototype.onData = function(m) {
          this.chunks.push(m);
        }, d.prototype.onEnd = function(m) {
          m === u.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = m, this.msg = this.strm.msg;
        }, r.Inflate = d, r.inflate = p, r.inflateRaw = function(m, _) {
          return (_ = _ || {}).raw = !0, p(m, _);
        }, r.ungzip = p;
      }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(n, i, r) {
        var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
        r.assign = function(u) {
          for (var c = Array.prototype.slice.call(arguments, 1); c.length; ) {
            var l = c.shift();
            if (l) {
              if (typeof l != "object") throw new TypeError(l + "must be non-object");
              for (var h in l) l.hasOwnProperty(h) && (u[h] = l[h]);
            }
          }
          return u;
        }, r.shrinkBuf = function(u, c) {
          return u.length === c ? u : u.subarray ? u.subarray(0, c) : (u.length = c, u);
        };
        var o = { arraySet: function(u, c, l, h, f) {
          if (c.subarray && u.subarray) u.set(c.subarray(l, l + h), f);
          else for (var d = 0; d < h; d++) u[f + d] = c[l + d];
        }, flattenChunks: function(u) {
          var c, l, h, f, d, p;
          for (c = h = 0, l = u.length; c < l; c++) h += u[c].length;
          for (p = new Uint8Array(h), c = f = 0, l = u.length; c < l; c++) d = u[c], p.set(d, f), f += d.length;
          return p;
        } }, a = { arraySet: function(u, c, l, h, f) {
          for (var d = 0; d < h; d++) u[f + d] = c[l + d];
        }, flattenChunks: function(u) {
          return [].concat.apply([], u);
        } };
        r.setTyped = function(u) {
          u ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, o)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, a));
        }, r.setTyped(s);
      }, {}], 42: [function(n, i, r) {
        var s = n("./common"), o = !0, a = !0;
        try {
          String.fromCharCode.apply(null, [0]);
        } catch {
          o = !1;
        }
        try {
          String.fromCharCode.apply(null, new Uint8Array(1));
        } catch {
          a = !1;
        }
        for (var u = new s.Buf8(256), c = 0; c < 256; c++) u[c] = 252 <= c ? 6 : 248 <= c ? 5 : 240 <= c ? 4 : 224 <= c ? 3 : 192 <= c ? 2 : 1;
        function l(h, f) {
          if (f < 65537 && (h.subarray && a || !h.subarray && o)) return String.fromCharCode.apply(null, s.shrinkBuf(h, f));
          for (var d = "", p = 0; p < f; p++) d += String.fromCharCode(h[p]);
          return d;
        }
        u[254] = u[254] = 1, r.string2buf = function(h) {
          var f, d, p, m, _, y = h.length, b = 0;
          for (m = 0; m < y; m++) (64512 & (d = h.charCodeAt(m))) == 55296 && m + 1 < y && (64512 & (p = h.charCodeAt(m + 1))) == 56320 && (d = 65536 + (d - 55296 << 10) + (p - 56320), m++), b += d < 128 ? 1 : d < 2048 ? 2 : d < 65536 ? 3 : 4;
          for (f = new s.Buf8(b), m = _ = 0; _ < b; m++) (64512 & (d = h.charCodeAt(m))) == 55296 && m + 1 < y && (64512 & (p = h.charCodeAt(m + 1))) == 56320 && (d = 65536 + (d - 55296 << 10) + (p - 56320), m++), d < 128 ? f[_++] = d : (d < 2048 ? f[_++] = 192 | d >>> 6 : (d < 65536 ? f[_++] = 224 | d >>> 12 : (f[_++] = 240 | d >>> 18, f[_++] = 128 | d >>> 12 & 63), f[_++] = 128 | d >>> 6 & 63), f[_++] = 128 | 63 & d);
          return f;
        }, r.buf2binstring = function(h) {
          return l(h, h.length);
        }, r.binstring2buf = function(h) {
          for (var f = new s.Buf8(h.length), d = 0, p = f.length; d < p; d++) f[d] = h.charCodeAt(d);
          return f;
        }, r.buf2string = function(h, f) {
          var d, p, m, _, y = f || h.length, b = new Array(2 * y);
          for (d = p = 0; d < y; ) if ((m = h[d++]) < 128) b[p++] = m;
          else if (4 < (_ = u[m])) b[p++] = 65533, d += _ - 1;
          else {
            for (m &= _ === 2 ? 31 : _ === 3 ? 15 : 7; 1 < _ && d < y; ) m = m << 6 | 63 & h[d++], _--;
            1 < _ ? b[p++] = 65533 : m < 65536 ? b[p++] = m : (m -= 65536, b[p++] = 55296 | m >> 10 & 1023, b[p++] = 56320 | 1023 & m);
          }
          return l(b, p);
        }, r.utf8border = function(h, f) {
          var d;
          for ((f = f || h.length) > h.length && (f = h.length), d = f - 1; 0 <= d && (192 & h[d]) == 128; ) d--;
          return d < 0 || d === 0 ? f : d + u[h[d]] > f ? d : f;
        };
      }, { "./common": 41 }], 43: [function(n, i, r) {
        i.exports = function(s, o, a, u) {
          for (var c = 65535 & s | 0, l = s >>> 16 & 65535 | 0, h = 0; a !== 0; ) {
            for (a -= h = 2e3 < a ? 2e3 : a; l = l + (c = c + o[u++] | 0) | 0, --h; ) ;
            c %= 65521, l %= 65521;
          }
          return c | l << 16 | 0;
        };
      }, {}], 44: [function(n, i, r) {
        i.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
      }, {}], 45: [function(n, i, r) {
        var s = function() {
          for (var o, a = [], u = 0; u < 256; u++) {
            o = u;
            for (var c = 0; c < 8; c++) o = 1 & o ? 3988292384 ^ o >>> 1 : o >>> 1;
            a[u] = o;
          }
          return a;
        }();
        i.exports = function(o, a, u, c) {
          var l = s, h = c + u;
          o ^= -1;
          for (var f = c; f < h; f++) o = o >>> 8 ^ l[255 & (o ^ a[f])];
          return -1 ^ o;
        };
      }, {}], 46: [function(n, i, r) {
        var s, o = n("../utils/common"), a = n("./trees"), u = n("./adler32"), c = n("./crc32"), l = n("./messages"), h = 0, f = 4, d = 0, p = -2, m = -1, _ = 4, y = 2, b = 8, g = 9, v = 286, w = 30, E = 19, A = 2 * v + 1, C = 15, O = 3, R = 258, P = R + O + 1, k = 42, S = 113, x = 1, I = 2, F = 3, T = 4;
        function L(D, V) {
          return D.msg = l[V], V;
        }
        function M(D) {
          return (D << 1) - (4 < D ? 9 : 0);
        }
        function U(D) {
          for (var V = D.length; 0 <= --V; ) D[V] = 0;
        }
        function $(D) {
          var V = D.state, W = V.pending;
          W > D.avail_out && (W = D.avail_out), W !== 0 && (o.arraySet(D.output, V.pending_buf, V.pending_out, W, D.next_out), D.next_out += W, V.pending_out += W, D.total_out += W, D.avail_out -= W, V.pending -= W, V.pending === 0 && (V.pending_out = 0));
        }
        function z(D, V) {
          a._tr_flush_block(D, 0 <= D.block_start ? D.block_start : -1, D.strstart - D.block_start, V), D.block_start = D.strstart, $(D.strm);
        }
        function X(D, V) {
          D.pending_buf[D.pending++] = V;
        }
        function J(D, V) {
          D.pending_buf[D.pending++] = V >>> 8 & 255, D.pending_buf[D.pending++] = 255 & V;
        }
        function K(D, V) {
          var W, B, N = D.max_chain_length, H = D.strstart, G = D.prev_length, Z = D.nice_match, q = D.strstart > D.w_size - P ? D.strstart - (D.w_size - P) : 0, Q = D.window, se = D.w_mask, ee = D.prev, he = D.strstart + R, Te = Q[H + G - 1], we = Q[H + G];
          D.prev_length >= D.good_match && (N >>= 2), Z > D.lookahead && (Z = D.lookahead);
          do
            if (Q[(W = V) + G] === we && Q[W + G - 1] === Te && Q[W] === Q[H] && Q[++W] === Q[H + 1]) {
              H += 2, W++;
              do
                ;
              while (Q[++H] === Q[++W] && Q[++H] === Q[++W] && Q[++H] === Q[++W] && Q[++H] === Q[++W] && Q[++H] === Q[++W] && Q[++H] === Q[++W] && Q[++H] === Q[++W] && Q[++H] === Q[++W] && H < he);
              if (B = R - (he - H), H = he - R, G < B) {
                if (D.match_start = V, Z <= (G = B)) break;
                Te = Q[H + G - 1], we = Q[H + G];
              }
            }
          while ((V = ee[V & se]) > q && --N != 0);
          return G <= D.lookahead ? G : D.lookahead;
        }
        function be(D) {
          var V, W, B, N, H, G, Z, q, Q, se, ee = D.w_size;
          do {
            if (N = D.window_size - D.lookahead - D.strstart, D.strstart >= ee + (ee - P)) {
              for (o.arraySet(D.window, D.window, ee, ee, 0), D.match_start -= ee, D.strstart -= ee, D.block_start -= ee, V = W = D.hash_size; B = D.head[--V], D.head[V] = ee <= B ? B - ee : 0, --W; ) ;
              for (V = W = ee; B = D.prev[--V], D.prev[V] = ee <= B ? B - ee : 0, --W; ) ;
              N += ee;
            }
            if (D.strm.avail_in === 0) break;
            if (G = D.strm, Z = D.window, q = D.strstart + D.lookahead, Q = N, se = void 0, se = G.avail_in, Q < se && (se = Q), W = se === 0 ? 0 : (G.avail_in -= se, o.arraySet(Z, G.input, G.next_in, se, q), G.state.wrap === 1 ? G.adler = u(G.adler, Z, se, q) : G.state.wrap === 2 && (G.adler = c(G.adler, Z, se, q)), G.next_in += se, G.total_in += se, se), D.lookahead += W, D.lookahead + D.insert >= O) for (H = D.strstart - D.insert, D.ins_h = D.window[H], D.ins_h = (D.ins_h << D.hash_shift ^ D.window[H + 1]) & D.hash_mask; D.insert && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[H + O - 1]) & D.hash_mask, D.prev[H & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = H, H++, D.insert--, !(D.lookahead + D.insert < O)); ) ;
          } while (D.lookahead < P && D.strm.avail_in !== 0);
        }
        function Fe(D, V) {
          for (var W, B; ; ) {
            if (D.lookahead < P) {
              if (be(D), D.lookahead < P && V === h) return x;
              if (D.lookahead === 0) break;
            }
            if (W = 0, D.lookahead >= O && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + O - 1]) & D.hash_mask, W = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart), W !== 0 && D.strstart - W <= D.w_size - P && (D.match_length = K(D, W)), D.match_length >= O) if (B = a._tr_tally(D, D.strstart - D.match_start, D.match_length - O), D.lookahead -= D.match_length, D.match_length <= D.max_lazy_match && D.lookahead >= O) {
              for (D.match_length--; D.strstart++, D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + O - 1]) & D.hash_mask, W = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart, --D.match_length != 0; ) ;
              D.strstart++;
            } else D.strstart += D.match_length, D.match_length = 0, D.ins_h = D.window[D.strstart], D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + 1]) & D.hash_mask;
            else B = a._tr_tally(D, 0, D.window[D.strstart]), D.lookahead--, D.strstart++;
            if (B && (z(D, !1), D.strm.avail_out === 0)) return x;
          }
          return D.insert = D.strstart < O - 1 ? D.strstart : O - 1, V === f ? (z(D, !0), D.strm.avail_out === 0 ? F : T) : D.last_lit && (z(D, !1), D.strm.avail_out === 0) ? x : I;
        }
        function de(D, V) {
          for (var W, B, N; ; ) {
            if (D.lookahead < P) {
              if (be(D), D.lookahead < P && V === h) return x;
              if (D.lookahead === 0) break;
            }
            if (W = 0, D.lookahead >= O && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + O - 1]) & D.hash_mask, W = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart), D.prev_length = D.match_length, D.prev_match = D.match_start, D.match_length = O - 1, W !== 0 && D.prev_length < D.max_lazy_match && D.strstart - W <= D.w_size - P && (D.match_length = K(D, W), D.match_length <= 5 && (D.strategy === 1 || D.match_length === O && 4096 < D.strstart - D.match_start) && (D.match_length = O - 1)), D.prev_length >= O && D.match_length <= D.prev_length) {
              for (N = D.strstart + D.lookahead - O, B = a._tr_tally(D, D.strstart - 1 - D.prev_match, D.prev_length - O), D.lookahead -= D.prev_length - 1, D.prev_length -= 2; ++D.strstart <= N && (D.ins_h = (D.ins_h << D.hash_shift ^ D.window[D.strstart + O - 1]) & D.hash_mask, W = D.prev[D.strstart & D.w_mask] = D.head[D.ins_h], D.head[D.ins_h] = D.strstart), --D.prev_length != 0; ) ;
              if (D.match_available = 0, D.match_length = O - 1, D.strstart++, B && (z(D, !1), D.strm.avail_out === 0)) return x;
            } else if (D.match_available) {
              if ((B = a._tr_tally(D, 0, D.window[D.strstart - 1])) && z(D, !1), D.strstart++, D.lookahead--, D.strm.avail_out === 0) return x;
            } else D.match_available = 1, D.strstart++, D.lookahead--;
          }
          return D.match_available && (B = a._tr_tally(D, 0, D.window[D.strstart - 1]), D.match_available = 0), D.insert = D.strstart < O - 1 ? D.strstart : O - 1, V === f ? (z(D, !0), D.strm.avail_out === 0 ? F : T) : D.last_lit && (z(D, !1), D.strm.avail_out === 0) ? x : I;
        }
        function ge(D, V, W, B, N) {
          this.good_length = D, this.max_lazy = V, this.nice_length = W, this.max_chain = B, this.func = N;
        }
        function Ae() {
          this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = b, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new o.Buf16(2 * A), this.dyn_dtree = new o.Buf16(2 * (2 * w + 1)), this.bl_tree = new o.Buf16(2 * (2 * E + 1)), U(this.dyn_ltree), U(this.dyn_dtree), U(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new o.Buf16(C + 1), this.heap = new o.Buf16(2 * v + 1), U(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new o.Buf16(2 * v + 1), U(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
        }
        function ke(D) {
          var V;
          return D && D.state ? (D.total_in = D.total_out = 0, D.data_type = y, (V = D.state).pending = 0, V.pending_out = 0, V.wrap < 0 && (V.wrap = -V.wrap), V.status = V.wrap ? k : S, D.adler = V.wrap === 2 ? 0 : 1, V.last_flush = h, a._tr_init(V), d) : L(D, p);
        }
        function Le(D) {
          var V = ke(D);
          return V === d && function(W) {
            W.window_size = 2 * W.w_size, U(W.head), W.max_lazy_match = s[W.level].max_lazy, W.good_match = s[W.level].good_length, W.nice_match = s[W.level].nice_length, W.max_chain_length = s[W.level].max_chain, W.strstart = 0, W.block_start = 0, W.lookahead = 0, W.insert = 0, W.match_length = W.prev_length = O - 1, W.match_available = 0, W.ins_h = 0;
          }(D.state), V;
        }
        function Xe(D, V, W, B, N, H) {
          if (!D) return p;
          var G = 1;
          if (V === m && (V = 6), B < 0 ? (G = 0, B = -B) : 15 < B && (G = 2, B -= 16), N < 1 || g < N || W !== b || B < 8 || 15 < B || V < 0 || 9 < V || H < 0 || _ < H) return L(D, p);
          B === 8 && (B = 9);
          var Z = new Ae();
          return (D.state = Z).strm = D, Z.wrap = G, Z.gzhead = null, Z.w_bits = B, Z.w_size = 1 << Z.w_bits, Z.w_mask = Z.w_size - 1, Z.hash_bits = N + 7, Z.hash_size = 1 << Z.hash_bits, Z.hash_mask = Z.hash_size - 1, Z.hash_shift = ~~((Z.hash_bits + O - 1) / O), Z.window = new o.Buf8(2 * Z.w_size), Z.head = new o.Buf16(Z.hash_size), Z.prev = new o.Buf16(Z.w_size), Z.lit_bufsize = 1 << N + 6, Z.pending_buf_size = 4 * Z.lit_bufsize, Z.pending_buf = new o.Buf8(Z.pending_buf_size), Z.d_buf = 1 * Z.lit_bufsize, Z.l_buf = 3 * Z.lit_bufsize, Z.level = V, Z.strategy = H, Z.method = W, Le(D);
        }
        s = [new ge(0, 0, 0, 0, function(D, V) {
          var W = 65535;
          for (W > D.pending_buf_size - 5 && (W = D.pending_buf_size - 5); ; ) {
            if (D.lookahead <= 1) {
              if (be(D), D.lookahead === 0 && V === h) return x;
              if (D.lookahead === 0) break;
            }
            D.strstart += D.lookahead, D.lookahead = 0;
            var B = D.block_start + W;
            if ((D.strstart === 0 || D.strstart >= B) && (D.lookahead = D.strstart - B, D.strstart = B, z(D, !1), D.strm.avail_out === 0) || D.strstart - D.block_start >= D.w_size - P && (z(D, !1), D.strm.avail_out === 0)) return x;
          }
          return D.insert = 0, V === f ? (z(D, !0), D.strm.avail_out === 0 ? F : T) : (D.strstart > D.block_start && (z(D, !1), D.strm.avail_out), x);
        }), new ge(4, 4, 8, 4, Fe), new ge(4, 5, 16, 8, Fe), new ge(4, 6, 32, 32, Fe), new ge(4, 4, 16, 16, de), new ge(8, 16, 32, 32, de), new ge(8, 16, 128, 128, de), new ge(8, 32, 128, 256, de), new ge(32, 128, 258, 1024, de), new ge(32, 258, 258, 4096, de)], r.deflateInit = function(D, V) {
          return Xe(D, V, b, 15, 8, 0);
        }, r.deflateInit2 = Xe, r.deflateReset = Le, r.deflateResetKeep = ke, r.deflateSetHeader = function(D, V) {
          return D && D.state ? D.state.wrap !== 2 ? p : (D.state.gzhead = V, d) : p;
        }, r.deflate = function(D, V) {
          var W, B, N, H;
          if (!D || !D.state || 5 < V || V < 0) return D ? L(D, p) : p;
          if (B = D.state, !D.output || !D.input && D.avail_in !== 0 || B.status === 666 && V !== f) return L(D, D.avail_out === 0 ? -5 : p);
          if (B.strm = D, W = B.last_flush, B.last_flush = V, B.status === k) if (B.wrap === 2) D.adler = 0, X(B, 31), X(B, 139), X(B, 8), B.gzhead ? (X(B, (B.gzhead.text ? 1 : 0) + (B.gzhead.hcrc ? 2 : 0) + (B.gzhead.extra ? 4 : 0) + (B.gzhead.name ? 8 : 0) + (B.gzhead.comment ? 16 : 0)), X(B, 255 & B.gzhead.time), X(B, B.gzhead.time >> 8 & 255), X(B, B.gzhead.time >> 16 & 255), X(B, B.gzhead.time >> 24 & 255), X(B, B.level === 9 ? 2 : 2 <= B.strategy || B.level < 2 ? 4 : 0), X(B, 255 & B.gzhead.os), B.gzhead.extra && B.gzhead.extra.length && (X(B, 255 & B.gzhead.extra.length), X(B, B.gzhead.extra.length >> 8 & 255)), B.gzhead.hcrc && (D.adler = c(D.adler, B.pending_buf, B.pending, 0)), B.gzindex = 0, B.status = 69) : (X(B, 0), X(B, 0), X(B, 0), X(B, 0), X(B, 0), X(B, B.level === 9 ? 2 : 2 <= B.strategy || B.level < 2 ? 4 : 0), X(B, 3), B.status = S);
          else {
            var G = b + (B.w_bits - 8 << 4) << 8;
            G |= (2 <= B.strategy || B.level < 2 ? 0 : B.level < 6 ? 1 : B.level === 6 ? 2 : 3) << 6, B.strstart !== 0 && (G |= 32), G += 31 - G % 31, B.status = S, J(B, G), B.strstart !== 0 && (J(B, D.adler >>> 16), J(B, 65535 & D.adler)), D.adler = 1;
          }
          if (B.status === 69) if (B.gzhead.extra) {
            for (N = B.pending; B.gzindex < (65535 & B.gzhead.extra.length) && (B.pending !== B.pending_buf_size || (B.gzhead.hcrc && B.pending > N && (D.adler = c(D.adler, B.pending_buf, B.pending - N, N)), $(D), N = B.pending, B.pending !== B.pending_buf_size)); ) X(B, 255 & B.gzhead.extra[B.gzindex]), B.gzindex++;
            B.gzhead.hcrc && B.pending > N && (D.adler = c(D.adler, B.pending_buf, B.pending - N, N)), B.gzindex === B.gzhead.extra.length && (B.gzindex = 0, B.status = 73);
          } else B.status = 73;
          if (B.status === 73) if (B.gzhead.name) {
            N = B.pending;
            do {
              if (B.pending === B.pending_buf_size && (B.gzhead.hcrc && B.pending > N && (D.adler = c(D.adler, B.pending_buf, B.pending - N, N)), $(D), N = B.pending, B.pending === B.pending_buf_size)) {
                H = 1;
                break;
              }
              H = B.gzindex < B.gzhead.name.length ? 255 & B.gzhead.name.charCodeAt(B.gzindex++) : 0, X(B, H);
            } while (H !== 0);
            B.gzhead.hcrc && B.pending > N && (D.adler = c(D.adler, B.pending_buf, B.pending - N, N)), H === 0 && (B.gzindex = 0, B.status = 91);
          } else B.status = 91;
          if (B.status === 91) if (B.gzhead.comment) {
            N = B.pending;
            do {
              if (B.pending === B.pending_buf_size && (B.gzhead.hcrc && B.pending > N && (D.adler = c(D.adler, B.pending_buf, B.pending - N, N)), $(D), N = B.pending, B.pending === B.pending_buf_size)) {
                H = 1;
                break;
              }
              H = B.gzindex < B.gzhead.comment.length ? 255 & B.gzhead.comment.charCodeAt(B.gzindex++) : 0, X(B, H);
            } while (H !== 0);
            B.gzhead.hcrc && B.pending > N && (D.adler = c(D.adler, B.pending_buf, B.pending - N, N)), H === 0 && (B.status = 103);
          } else B.status = 103;
          if (B.status === 103 && (B.gzhead.hcrc ? (B.pending + 2 > B.pending_buf_size && $(D), B.pending + 2 <= B.pending_buf_size && (X(B, 255 & D.adler), X(B, D.adler >> 8 & 255), D.adler = 0, B.status = S)) : B.status = S), B.pending !== 0) {
            if ($(D), D.avail_out === 0) return B.last_flush = -1, d;
          } else if (D.avail_in === 0 && M(V) <= M(W) && V !== f) return L(D, -5);
          if (B.status === 666 && D.avail_in !== 0) return L(D, -5);
          if (D.avail_in !== 0 || B.lookahead !== 0 || V !== h && B.status !== 666) {
            var Z = B.strategy === 2 ? function(q, Q) {
              for (var se; ; ) {
                if (q.lookahead === 0 && (be(q), q.lookahead === 0)) {
                  if (Q === h) return x;
                  break;
                }
                if (q.match_length = 0, se = a._tr_tally(q, 0, q.window[q.strstart]), q.lookahead--, q.strstart++, se && (z(q, !1), q.strm.avail_out === 0)) return x;
              }
              return q.insert = 0, Q === f ? (z(q, !0), q.strm.avail_out === 0 ? F : T) : q.last_lit && (z(q, !1), q.strm.avail_out === 0) ? x : I;
            }(B, V) : B.strategy === 3 ? function(q, Q) {
              for (var se, ee, he, Te, we = q.window; ; ) {
                if (q.lookahead <= R) {
                  if (be(q), q.lookahead <= R && Q === h) return x;
                  if (q.lookahead === 0) break;
                }
                if (q.match_length = 0, q.lookahead >= O && 0 < q.strstart && (ee = we[he = q.strstart - 1]) === we[++he] && ee === we[++he] && ee === we[++he]) {
                  Te = q.strstart + R;
                  do
                    ;
                  while (ee === we[++he] && ee === we[++he] && ee === we[++he] && ee === we[++he] && ee === we[++he] && ee === we[++he] && ee === we[++he] && ee === we[++he] && he < Te);
                  q.match_length = R - (Te - he), q.match_length > q.lookahead && (q.match_length = q.lookahead);
                }
                if (q.match_length >= O ? (se = a._tr_tally(q, 1, q.match_length - O), q.lookahead -= q.match_length, q.strstart += q.match_length, q.match_length = 0) : (se = a._tr_tally(q, 0, q.window[q.strstart]), q.lookahead--, q.strstart++), se && (z(q, !1), q.strm.avail_out === 0)) return x;
              }
              return q.insert = 0, Q === f ? (z(q, !0), q.strm.avail_out === 0 ? F : T) : q.last_lit && (z(q, !1), q.strm.avail_out === 0) ? x : I;
            }(B, V) : s[B.level].func(B, V);
            if (Z !== F && Z !== T || (B.status = 666), Z === x || Z === F) return D.avail_out === 0 && (B.last_flush = -1), d;
            if (Z === I && (V === 1 ? a._tr_align(B) : V !== 5 && (a._tr_stored_block(B, 0, 0, !1), V === 3 && (U(B.head), B.lookahead === 0 && (B.strstart = 0, B.block_start = 0, B.insert = 0))), $(D), D.avail_out === 0)) return B.last_flush = -1, d;
          }
          return V !== f ? d : B.wrap <= 0 ? 1 : (B.wrap === 2 ? (X(B, 255 & D.adler), X(B, D.adler >> 8 & 255), X(B, D.adler >> 16 & 255), X(B, D.adler >> 24 & 255), X(B, 255 & D.total_in), X(B, D.total_in >> 8 & 255), X(B, D.total_in >> 16 & 255), X(B, D.total_in >> 24 & 255)) : (J(B, D.adler >>> 16), J(B, 65535 & D.adler)), $(D), 0 < B.wrap && (B.wrap = -B.wrap), B.pending !== 0 ? d : 1);
        }, r.deflateEnd = function(D) {
          var V;
          return D && D.state ? (V = D.state.status) !== k && V !== 69 && V !== 73 && V !== 91 && V !== 103 && V !== S && V !== 666 ? L(D, p) : (D.state = null, V === S ? L(D, -3) : d) : p;
        }, r.deflateSetDictionary = function(D, V) {
          var W, B, N, H, G, Z, q, Q, se = V.length;
          if (!D || !D.state || (H = (W = D.state).wrap) === 2 || H === 1 && W.status !== k || W.lookahead) return p;
          for (H === 1 && (D.adler = u(D.adler, V, se, 0)), W.wrap = 0, se >= W.w_size && (H === 0 && (U(W.head), W.strstart = 0, W.block_start = 0, W.insert = 0), Q = new o.Buf8(W.w_size), o.arraySet(Q, V, se - W.w_size, W.w_size, 0), V = Q, se = W.w_size), G = D.avail_in, Z = D.next_in, q = D.input, D.avail_in = se, D.next_in = 0, D.input = V, be(W); W.lookahead >= O; ) {
            for (B = W.strstart, N = W.lookahead - (O - 1); W.ins_h = (W.ins_h << W.hash_shift ^ W.window[B + O - 1]) & W.hash_mask, W.prev[B & W.w_mask] = W.head[W.ins_h], W.head[W.ins_h] = B, B++, --N; ) ;
            W.strstart = B, W.lookahead = O - 1, be(W);
          }
          return W.strstart += W.lookahead, W.block_start = W.strstart, W.insert = W.lookahead, W.lookahead = 0, W.match_length = W.prev_length = O - 1, W.match_available = 0, D.next_in = Z, D.input = q, D.avail_in = G, W.wrap = H, d;
        }, r.deflateInfo = "pako deflate (from Nodeca project)";
      }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(n, i, r) {
        i.exports = function() {
          this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
        };
      }, {}], 48: [function(n, i, r) {
        i.exports = function(s, o) {
          var a, u, c, l, h, f, d, p, m, _, y, b, g, v, w, E, A, C, O, R, P, k, S, x, I;
          a = s.state, u = s.next_in, x = s.input, c = u + (s.avail_in - 5), l = s.next_out, I = s.output, h = l - (o - s.avail_out), f = l + (s.avail_out - 257), d = a.dmax, p = a.wsize, m = a.whave, _ = a.wnext, y = a.window, b = a.hold, g = a.bits, v = a.lencode, w = a.distcode, E = (1 << a.lenbits) - 1, A = (1 << a.distbits) - 1;
          e: do {
            g < 15 && (b += x[u++] << g, g += 8, b += x[u++] << g, g += 8), C = v[b & E];
            t: for (; ; ) {
              if (b >>>= O = C >>> 24, g -= O, (O = C >>> 16 & 255) === 0) I[l++] = 65535 & C;
              else {
                if (!(16 & O)) {
                  if ((64 & O) == 0) {
                    C = v[(65535 & C) + (b & (1 << O) - 1)];
                    continue t;
                  }
                  if (32 & O) {
                    a.mode = 12;
                    break e;
                  }
                  s.msg = "invalid literal/length code", a.mode = 30;
                  break e;
                }
                R = 65535 & C, (O &= 15) && (g < O && (b += x[u++] << g, g += 8), R += b & (1 << O) - 1, b >>>= O, g -= O), g < 15 && (b += x[u++] << g, g += 8, b += x[u++] << g, g += 8), C = w[b & A];
                n: for (; ; ) {
                  if (b >>>= O = C >>> 24, g -= O, !(16 & (O = C >>> 16 & 255))) {
                    if ((64 & O) == 0) {
                      C = w[(65535 & C) + (b & (1 << O) - 1)];
                      continue n;
                    }
                    s.msg = "invalid distance code", a.mode = 30;
                    break e;
                  }
                  if (P = 65535 & C, g < (O &= 15) && (b += x[u++] << g, (g += 8) < O && (b += x[u++] << g, g += 8)), d < (P += b & (1 << O) - 1)) {
                    s.msg = "invalid distance too far back", a.mode = 30;
                    break e;
                  }
                  if (b >>>= O, g -= O, (O = l - h) < P) {
                    if (m < (O = P - O) && a.sane) {
                      s.msg = "invalid distance too far back", a.mode = 30;
                      break e;
                    }
                    if (S = y, (k = 0) === _) {
                      if (k += p - O, O < R) {
                        for (R -= O; I[l++] = y[k++], --O; ) ;
                        k = l - P, S = I;
                      }
                    } else if (_ < O) {
                      if (k += p + _ - O, (O -= _) < R) {
                        for (R -= O; I[l++] = y[k++], --O; ) ;
                        if (k = 0, _ < R) {
                          for (R -= O = _; I[l++] = y[k++], --O; ) ;
                          k = l - P, S = I;
                        }
                      }
                    } else if (k += _ - O, O < R) {
                      for (R -= O; I[l++] = y[k++], --O; ) ;
                      k = l - P, S = I;
                    }
                    for (; 2 < R; ) I[l++] = S[k++], I[l++] = S[k++], I[l++] = S[k++], R -= 3;
                    R && (I[l++] = S[k++], 1 < R && (I[l++] = S[k++]));
                  } else {
                    for (k = l - P; I[l++] = I[k++], I[l++] = I[k++], I[l++] = I[k++], 2 < (R -= 3); ) ;
                    R && (I[l++] = I[k++], 1 < R && (I[l++] = I[k++]));
                  }
                  break;
                }
              }
              break;
            }
          } while (u < c && l < f);
          u -= R = g >> 3, b &= (1 << (g -= R << 3)) - 1, s.next_in = u, s.next_out = l, s.avail_in = u < c ? c - u + 5 : 5 - (u - c), s.avail_out = l < f ? f - l + 257 : 257 - (l - f), a.hold = b, a.bits = g;
        };
      }, {}], 49: [function(n, i, r) {
        var s = n("../utils/common"), o = n("./adler32"), a = n("./crc32"), u = n("./inffast"), c = n("./inftrees"), l = 1, h = 2, f = 0, d = -2, p = 1, m = 852, _ = 592;
        function y(k) {
          return (k >>> 24 & 255) + (k >>> 8 & 65280) + ((65280 & k) << 8) + ((255 & k) << 24);
        }
        function b() {
          this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new s.Buf16(320), this.work = new s.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
        }
        function g(k) {
          var S;
          return k && k.state ? (S = k.state, k.total_in = k.total_out = S.total = 0, k.msg = "", S.wrap && (k.adler = 1 & S.wrap), S.mode = p, S.last = 0, S.havedict = 0, S.dmax = 32768, S.head = null, S.hold = 0, S.bits = 0, S.lencode = S.lendyn = new s.Buf32(m), S.distcode = S.distdyn = new s.Buf32(_), S.sane = 1, S.back = -1, f) : d;
        }
        function v(k) {
          var S;
          return k && k.state ? ((S = k.state).wsize = 0, S.whave = 0, S.wnext = 0, g(k)) : d;
        }
        function w(k, S) {
          var x, I;
          return k && k.state ? (I = k.state, S < 0 ? (x = 0, S = -S) : (x = 1 + (S >> 4), S < 48 && (S &= 15)), S && (S < 8 || 15 < S) ? d : (I.window !== null && I.wbits !== S && (I.window = null), I.wrap = x, I.wbits = S, v(k))) : d;
        }
        function E(k, S) {
          var x, I;
          return k ? (I = new b(), (k.state = I).window = null, (x = w(k, S)) !== f && (k.state = null), x) : d;
        }
        var A, C, O = !0;
        function R(k) {
          if (O) {
            var S;
            for (A = new s.Buf32(512), C = new s.Buf32(32), S = 0; S < 144; ) k.lens[S++] = 8;
            for (; S < 256; ) k.lens[S++] = 9;
            for (; S < 280; ) k.lens[S++] = 7;
            for (; S < 288; ) k.lens[S++] = 8;
            for (c(l, k.lens, 0, 288, A, 0, k.work, { bits: 9 }), S = 0; S < 32; ) k.lens[S++] = 5;
            c(h, k.lens, 0, 32, C, 0, k.work, { bits: 5 }), O = !1;
          }
          k.lencode = A, k.lenbits = 9, k.distcode = C, k.distbits = 5;
        }
        function P(k, S, x, I) {
          var F, T = k.state;
          return T.window === null && (T.wsize = 1 << T.wbits, T.wnext = 0, T.whave = 0, T.window = new s.Buf8(T.wsize)), I >= T.wsize ? (s.arraySet(T.window, S, x - T.wsize, T.wsize, 0), T.wnext = 0, T.whave = T.wsize) : (I < (F = T.wsize - T.wnext) && (F = I), s.arraySet(T.window, S, x - I, F, T.wnext), (I -= F) ? (s.arraySet(T.window, S, x - I, I, 0), T.wnext = I, T.whave = T.wsize) : (T.wnext += F, T.wnext === T.wsize && (T.wnext = 0), T.whave < T.wsize && (T.whave += F))), 0;
        }
        r.inflateReset = v, r.inflateReset2 = w, r.inflateResetKeep = g, r.inflateInit = function(k) {
          return E(k, 15);
        }, r.inflateInit2 = E, r.inflate = function(k, S) {
          var x, I, F, T, L, M, U, $, z, X, J, K, be, Fe, de, ge, Ae, ke, Le, Xe, D, V, W, B, N = 0, H = new s.Buf8(4), G = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
          if (!k || !k.state || !k.output || !k.input && k.avail_in !== 0) return d;
          (x = k.state).mode === 12 && (x.mode = 13), L = k.next_out, F = k.output, U = k.avail_out, T = k.next_in, I = k.input, M = k.avail_in, $ = x.hold, z = x.bits, X = M, J = U, V = f;
          e: for (; ; ) switch (x.mode) {
            case p:
              if (x.wrap === 0) {
                x.mode = 13;
                break;
              }
              for (; z < 16; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              if (2 & x.wrap && $ === 35615) {
                H[x.check = 0] = 255 & $, H[1] = $ >>> 8 & 255, x.check = a(x.check, H, 2, 0), z = $ = 0, x.mode = 2;
                break;
              }
              if (x.flags = 0, x.head && (x.head.done = !1), !(1 & x.wrap) || (((255 & $) << 8) + ($ >> 8)) % 31) {
                k.msg = "incorrect header check", x.mode = 30;
                break;
              }
              if ((15 & $) != 8) {
                k.msg = "unknown compression method", x.mode = 30;
                break;
              }
              if (z -= 4, D = 8 + (15 & ($ >>>= 4)), x.wbits === 0) x.wbits = D;
              else if (D > x.wbits) {
                k.msg = "invalid window size", x.mode = 30;
                break;
              }
              x.dmax = 1 << D, k.adler = x.check = 1, x.mode = 512 & $ ? 10 : 12, z = $ = 0;
              break;
            case 2:
              for (; z < 16; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              if (x.flags = $, (255 & x.flags) != 8) {
                k.msg = "unknown compression method", x.mode = 30;
                break;
              }
              if (57344 & x.flags) {
                k.msg = "unknown header flags set", x.mode = 30;
                break;
              }
              x.head && (x.head.text = $ >> 8 & 1), 512 & x.flags && (H[0] = 255 & $, H[1] = $ >>> 8 & 255, x.check = a(x.check, H, 2, 0)), z = $ = 0, x.mode = 3;
            case 3:
              for (; z < 32; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              x.head && (x.head.time = $), 512 & x.flags && (H[0] = 255 & $, H[1] = $ >>> 8 & 255, H[2] = $ >>> 16 & 255, H[3] = $ >>> 24 & 255, x.check = a(x.check, H, 4, 0)), z = $ = 0, x.mode = 4;
            case 4:
              for (; z < 16; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              x.head && (x.head.xflags = 255 & $, x.head.os = $ >> 8), 512 & x.flags && (H[0] = 255 & $, H[1] = $ >>> 8 & 255, x.check = a(x.check, H, 2, 0)), z = $ = 0, x.mode = 5;
            case 5:
              if (1024 & x.flags) {
                for (; z < 16; ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                x.length = $, x.head && (x.head.extra_len = $), 512 & x.flags && (H[0] = 255 & $, H[1] = $ >>> 8 & 255, x.check = a(x.check, H, 2, 0)), z = $ = 0;
              } else x.head && (x.head.extra = null);
              x.mode = 6;
            case 6:
              if (1024 & x.flags && (M < (K = x.length) && (K = M), K && (x.head && (D = x.head.extra_len - x.length, x.head.extra || (x.head.extra = new Array(x.head.extra_len)), s.arraySet(x.head.extra, I, T, K, D)), 512 & x.flags && (x.check = a(x.check, I, K, T)), M -= K, T += K, x.length -= K), x.length)) break e;
              x.length = 0, x.mode = 7;
            case 7:
              if (2048 & x.flags) {
                if (M === 0) break e;
                for (K = 0; D = I[T + K++], x.head && D && x.length < 65536 && (x.head.name += String.fromCharCode(D)), D && K < M; ) ;
                if (512 & x.flags && (x.check = a(x.check, I, K, T)), M -= K, T += K, D) break e;
              } else x.head && (x.head.name = null);
              x.length = 0, x.mode = 8;
            case 8:
              if (4096 & x.flags) {
                if (M === 0) break e;
                for (K = 0; D = I[T + K++], x.head && D && x.length < 65536 && (x.head.comment += String.fromCharCode(D)), D && K < M; ) ;
                if (512 & x.flags && (x.check = a(x.check, I, K, T)), M -= K, T += K, D) break e;
              } else x.head && (x.head.comment = null);
              x.mode = 9;
            case 9:
              if (512 & x.flags) {
                for (; z < 16; ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                if ($ !== (65535 & x.check)) {
                  k.msg = "header crc mismatch", x.mode = 30;
                  break;
                }
                z = $ = 0;
              }
              x.head && (x.head.hcrc = x.flags >> 9 & 1, x.head.done = !0), k.adler = x.check = 0, x.mode = 12;
              break;
            case 10:
              for (; z < 32; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              k.adler = x.check = y($), z = $ = 0, x.mode = 11;
            case 11:
              if (x.havedict === 0) return k.next_out = L, k.avail_out = U, k.next_in = T, k.avail_in = M, x.hold = $, x.bits = z, 2;
              k.adler = x.check = 1, x.mode = 12;
            case 12:
              if (S === 5 || S === 6) break e;
            case 13:
              if (x.last) {
                $ >>>= 7 & z, z -= 7 & z, x.mode = 27;
                break;
              }
              for (; z < 3; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              switch (x.last = 1 & $, z -= 1, 3 & ($ >>>= 1)) {
                case 0:
                  x.mode = 14;
                  break;
                case 1:
                  if (R(x), x.mode = 20, S !== 6) break;
                  $ >>>= 2, z -= 2;
                  break e;
                case 2:
                  x.mode = 17;
                  break;
                case 3:
                  k.msg = "invalid block type", x.mode = 30;
              }
              $ >>>= 2, z -= 2;
              break;
            case 14:
              for ($ >>>= 7 & z, z -= 7 & z; z < 32; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              if ((65535 & $) != ($ >>> 16 ^ 65535)) {
                k.msg = "invalid stored block lengths", x.mode = 30;
                break;
              }
              if (x.length = 65535 & $, z = $ = 0, x.mode = 15, S === 6) break e;
            case 15:
              x.mode = 16;
            case 16:
              if (K = x.length) {
                if (M < K && (K = M), U < K && (K = U), K === 0) break e;
                s.arraySet(F, I, T, K, L), M -= K, T += K, U -= K, L += K, x.length -= K;
                break;
              }
              x.mode = 12;
              break;
            case 17:
              for (; z < 14; ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              if (x.nlen = 257 + (31 & $), $ >>>= 5, z -= 5, x.ndist = 1 + (31 & $), $ >>>= 5, z -= 5, x.ncode = 4 + (15 & $), $ >>>= 4, z -= 4, 286 < x.nlen || 30 < x.ndist) {
                k.msg = "too many length or distance symbols", x.mode = 30;
                break;
              }
              x.have = 0, x.mode = 18;
            case 18:
              for (; x.have < x.ncode; ) {
                for (; z < 3; ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                x.lens[G[x.have++]] = 7 & $, $ >>>= 3, z -= 3;
              }
              for (; x.have < 19; ) x.lens[G[x.have++]] = 0;
              if (x.lencode = x.lendyn, x.lenbits = 7, W = { bits: x.lenbits }, V = c(0, x.lens, 0, 19, x.lencode, 0, x.work, W), x.lenbits = W.bits, V) {
                k.msg = "invalid code lengths set", x.mode = 30;
                break;
              }
              x.have = 0, x.mode = 19;
            case 19:
              for (; x.have < x.nlen + x.ndist; ) {
                for (; ge = (N = x.lencode[$ & (1 << x.lenbits) - 1]) >>> 16 & 255, Ae = 65535 & N, !((de = N >>> 24) <= z); ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                if (Ae < 16) $ >>>= de, z -= de, x.lens[x.have++] = Ae;
                else {
                  if (Ae === 16) {
                    for (B = de + 2; z < B; ) {
                      if (M === 0) break e;
                      M--, $ += I[T++] << z, z += 8;
                    }
                    if ($ >>>= de, z -= de, x.have === 0) {
                      k.msg = "invalid bit length repeat", x.mode = 30;
                      break;
                    }
                    D = x.lens[x.have - 1], K = 3 + (3 & $), $ >>>= 2, z -= 2;
                  } else if (Ae === 17) {
                    for (B = de + 3; z < B; ) {
                      if (M === 0) break e;
                      M--, $ += I[T++] << z, z += 8;
                    }
                    z -= de, D = 0, K = 3 + (7 & ($ >>>= de)), $ >>>= 3, z -= 3;
                  } else {
                    for (B = de + 7; z < B; ) {
                      if (M === 0) break e;
                      M--, $ += I[T++] << z, z += 8;
                    }
                    z -= de, D = 0, K = 11 + (127 & ($ >>>= de)), $ >>>= 7, z -= 7;
                  }
                  if (x.have + K > x.nlen + x.ndist) {
                    k.msg = "invalid bit length repeat", x.mode = 30;
                    break;
                  }
                  for (; K--; ) x.lens[x.have++] = D;
                }
              }
              if (x.mode === 30) break;
              if (x.lens[256] === 0) {
                k.msg = "invalid code -- missing end-of-block", x.mode = 30;
                break;
              }
              if (x.lenbits = 9, W = { bits: x.lenbits }, V = c(l, x.lens, 0, x.nlen, x.lencode, 0, x.work, W), x.lenbits = W.bits, V) {
                k.msg = "invalid literal/lengths set", x.mode = 30;
                break;
              }
              if (x.distbits = 6, x.distcode = x.distdyn, W = { bits: x.distbits }, V = c(h, x.lens, x.nlen, x.ndist, x.distcode, 0, x.work, W), x.distbits = W.bits, V) {
                k.msg = "invalid distances set", x.mode = 30;
                break;
              }
              if (x.mode = 20, S === 6) break e;
            case 20:
              x.mode = 21;
            case 21:
              if (6 <= M && 258 <= U) {
                k.next_out = L, k.avail_out = U, k.next_in = T, k.avail_in = M, x.hold = $, x.bits = z, u(k, J), L = k.next_out, F = k.output, U = k.avail_out, T = k.next_in, I = k.input, M = k.avail_in, $ = x.hold, z = x.bits, x.mode === 12 && (x.back = -1);
                break;
              }
              for (x.back = 0; ge = (N = x.lencode[$ & (1 << x.lenbits) - 1]) >>> 16 & 255, Ae = 65535 & N, !((de = N >>> 24) <= z); ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              if (ge && (240 & ge) == 0) {
                for (ke = de, Le = ge, Xe = Ae; ge = (N = x.lencode[Xe + (($ & (1 << ke + Le) - 1) >> ke)]) >>> 16 & 255, Ae = 65535 & N, !(ke + (de = N >>> 24) <= z); ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                $ >>>= ke, z -= ke, x.back += ke;
              }
              if ($ >>>= de, z -= de, x.back += de, x.length = Ae, ge === 0) {
                x.mode = 26;
                break;
              }
              if (32 & ge) {
                x.back = -1, x.mode = 12;
                break;
              }
              if (64 & ge) {
                k.msg = "invalid literal/length code", x.mode = 30;
                break;
              }
              x.extra = 15 & ge, x.mode = 22;
            case 22:
              if (x.extra) {
                for (B = x.extra; z < B; ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                x.length += $ & (1 << x.extra) - 1, $ >>>= x.extra, z -= x.extra, x.back += x.extra;
              }
              x.was = x.length, x.mode = 23;
            case 23:
              for (; ge = (N = x.distcode[$ & (1 << x.distbits) - 1]) >>> 16 & 255, Ae = 65535 & N, !((de = N >>> 24) <= z); ) {
                if (M === 0) break e;
                M--, $ += I[T++] << z, z += 8;
              }
              if ((240 & ge) == 0) {
                for (ke = de, Le = ge, Xe = Ae; ge = (N = x.distcode[Xe + (($ & (1 << ke + Le) - 1) >> ke)]) >>> 16 & 255, Ae = 65535 & N, !(ke + (de = N >>> 24) <= z); ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                $ >>>= ke, z -= ke, x.back += ke;
              }
              if ($ >>>= de, z -= de, x.back += de, 64 & ge) {
                k.msg = "invalid distance code", x.mode = 30;
                break;
              }
              x.offset = Ae, x.extra = 15 & ge, x.mode = 24;
            case 24:
              if (x.extra) {
                for (B = x.extra; z < B; ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                x.offset += $ & (1 << x.extra) - 1, $ >>>= x.extra, z -= x.extra, x.back += x.extra;
              }
              if (x.offset > x.dmax) {
                k.msg = "invalid distance too far back", x.mode = 30;
                break;
              }
              x.mode = 25;
            case 25:
              if (U === 0) break e;
              if (K = J - U, x.offset > K) {
                if ((K = x.offset - K) > x.whave && x.sane) {
                  k.msg = "invalid distance too far back", x.mode = 30;
                  break;
                }
                be = K > x.wnext ? (K -= x.wnext, x.wsize - K) : x.wnext - K, K > x.length && (K = x.length), Fe = x.window;
              } else Fe = F, be = L - x.offset, K = x.length;
              for (U < K && (K = U), U -= K, x.length -= K; F[L++] = Fe[be++], --K; ) ;
              x.length === 0 && (x.mode = 21);
              break;
            case 26:
              if (U === 0) break e;
              F[L++] = x.length, U--, x.mode = 21;
              break;
            case 27:
              if (x.wrap) {
                for (; z < 32; ) {
                  if (M === 0) break e;
                  M--, $ |= I[T++] << z, z += 8;
                }
                if (J -= U, k.total_out += J, x.total += J, J && (k.adler = x.check = x.flags ? a(x.check, F, J, L - J) : o(x.check, F, J, L - J)), J = U, (x.flags ? $ : y($)) !== x.check) {
                  k.msg = "incorrect data check", x.mode = 30;
                  break;
                }
                z = $ = 0;
              }
              x.mode = 28;
            case 28:
              if (x.wrap && x.flags) {
                for (; z < 32; ) {
                  if (M === 0) break e;
                  M--, $ += I[T++] << z, z += 8;
                }
                if ($ !== (4294967295 & x.total)) {
                  k.msg = "incorrect length check", x.mode = 30;
                  break;
                }
                z = $ = 0;
              }
              x.mode = 29;
            case 29:
              V = 1;
              break e;
            case 30:
              V = -3;
              break e;
            case 31:
              return -4;
            case 32:
            default:
              return d;
          }
          return k.next_out = L, k.avail_out = U, k.next_in = T, k.avail_in = M, x.hold = $, x.bits = z, (x.wsize || J !== k.avail_out && x.mode < 30 && (x.mode < 27 || S !== 4)) && P(k, k.output, k.next_out, J - k.avail_out) ? (x.mode = 31, -4) : (X -= k.avail_in, J -= k.avail_out, k.total_in += X, k.total_out += J, x.total += J, x.wrap && J && (k.adler = x.check = x.flags ? a(x.check, F, J, k.next_out - J) : o(x.check, F, J, k.next_out - J)), k.data_type = x.bits + (x.last ? 64 : 0) + (x.mode === 12 ? 128 : 0) + (x.mode === 20 || x.mode === 15 ? 256 : 0), (X == 0 && J === 0 || S === 4) && V === f && (V = -5), V);
        }, r.inflateEnd = function(k) {
          if (!k || !k.state) return d;
          var S = k.state;
          return S.window && (S.window = null), k.state = null, f;
        }, r.inflateGetHeader = function(k, S) {
          var x;
          return k && k.state ? (2 & (x = k.state).wrap) == 0 ? d : ((x.head = S).done = !1, f) : d;
        }, r.inflateSetDictionary = function(k, S) {
          var x, I = S.length;
          return k && k.state ? (x = k.state).wrap !== 0 && x.mode !== 11 ? d : x.mode === 11 && o(1, S, I, 0) !== x.check ? -3 : P(k, S, I, I) ? (x.mode = 31, -4) : (x.havedict = 1, f) : d;
        }, r.inflateInfo = "pako inflate (from Nodeca project)";
      }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(n, i, r) {
        var s = n("../utils/common"), o = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], a = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], u = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], c = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
        i.exports = function(l, h, f, d, p, m, _, y) {
          var b, g, v, w, E, A, C, O, R, P = y.bits, k = 0, S = 0, x = 0, I = 0, F = 0, T = 0, L = 0, M = 0, U = 0, $ = 0, z = null, X = 0, J = new s.Buf16(16), K = new s.Buf16(16), be = null, Fe = 0;
          for (k = 0; k <= 15; k++) J[k] = 0;
          for (S = 0; S < d; S++) J[h[f + S]]++;
          for (F = P, I = 15; 1 <= I && J[I] === 0; I--) ;
          if (I < F && (F = I), I === 0) return p[m++] = 20971520, p[m++] = 20971520, y.bits = 1, 0;
          for (x = 1; x < I && J[x] === 0; x++) ;
          for (F < x && (F = x), k = M = 1; k <= 15; k++) if (M <<= 1, (M -= J[k]) < 0) return -1;
          if (0 < M && (l === 0 || I !== 1)) return -1;
          for (K[1] = 0, k = 1; k < 15; k++) K[k + 1] = K[k] + J[k];
          for (S = 0; S < d; S++) h[f + S] !== 0 && (_[K[h[f + S]]++] = S);
          if (A = l === 0 ? (z = be = _, 19) : l === 1 ? (z = o, X -= 257, be = a, Fe -= 257, 256) : (z = u, be = c, -1), k = x, E = m, L = S = $ = 0, v = -1, w = (U = 1 << (T = F)) - 1, l === 1 && 852 < U || l === 2 && 592 < U) return 1;
          for (; ; ) {
            for (C = k - L, R = _[S] < A ? (O = 0, _[S]) : _[S] > A ? (O = be[Fe + _[S]], z[X + _[S]]) : (O = 96, 0), b = 1 << k - L, x = g = 1 << T; p[E + ($ >> L) + (g -= b)] = C << 24 | O << 16 | R | 0, g !== 0; ) ;
            for (b = 1 << k - 1; $ & b; ) b >>= 1;
            if (b !== 0 ? ($ &= b - 1, $ += b) : $ = 0, S++, --J[k] == 0) {
              if (k === I) break;
              k = h[f + _[S]];
            }
            if (F < k && ($ & w) !== v) {
              for (L === 0 && (L = F), E += x, M = 1 << (T = k - L); T + L < I && !((M -= J[T + L]) <= 0); ) T++, M <<= 1;
              if (U += 1 << T, l === 1 && 852 < U || l === 2 && 592 < U) return 1;
              p[v = $ & w] = F << 24 | T << 16 | E - m | 0;
            }
          }
          return $ !== 0 && (p[E + $] = k - L << 24 | 64 << 16 | 0), y.bits = F, 0;
        };
      }, { "../utils/common": 41 }], 51: [function(n, i, r) {
        i.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
      }, {}], 52: [function(n, i, r) {
        var s = n("../utils/common"), o = 0, a = 1;
        function u(N) {
          for (var H = N.length; 0 <= --H; ) N[H] = 0;
        }
        var c = 0, l = 29, h = 256, f = h + 1 + l, d = 30, p = 19, m = 2 * f + 1, _ = 15, y = 16, b = 7, g = 256, v = 16, w = 17, E = 18, A = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], C = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], O = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], R = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], P = new Array(2 * (f + 2));
        u(P);
        var k = new Array(2 * d);
        u(k);
        var S = new Array(512);
        u(S);
        var x = new Array(256);
        u(x);
        var I = new Array(l);
        u(I);
        var F, T, L, M = new Array(d);
        function U(N, H, G, Z, q) {
          this.static_tree = N, this.extra_bits = H, this.extra_base = G, this.elems = Z, this.max_length = q, this.has_stree = N && N.length;
        }
        function $(N, H) {
          this.dyn_tree = N, this.max_code = 0, this.stat_desc = H;
        }
        function z(N) {
          return N < 256 ? S[N] : S[256 + (N >>> 7)];
        }
        function X(N, H) {
          N.pending_buf[N.pending++] = 255 & H, N.pending_buf[N.pending++] = H >>> 8 & 255;
        }
        function J(N, H, G) {
          N.bi_valid > y - G ? (N.bi_buf |= H << N.bi_valid & 65535, X(N, N.bi_buf), N.bi_buf = H >> y - N.bi_valid, N.bi_valid += G - y) : (N.bi_buf |= H << N.bi_valid & 65535, N.bi_valid += G);
        }
        function K(N, H, G) {
          J(N, G[2 * H], G[2 * H + 1]);
        }
        function be(N, H) {
          for (var G = 0; G |= 1 & N, N >>>= 1, G <<= 1, 0 < --H; ) ;
          return G >>> 1;
        }
        function Fe(N, H, G) {
          var Z, q, Q = new Array(_ + 1), se = 0;
          for (Z = 1; Z <= _; Z++) Q[Z] = se = se + G[Z - 1] << 1;
          for (q = 0; q <= H; q++) {
            var ee = N[2 * q + 1];
            ee !== 0 && (N[2 * q] = be(Q[ee]++, ee));
          }
        }
        function de(N) {
          var H;
          for (H = 0; H < f; H++) N.dyn_ltree[2 * H] = 0;
          for (H = 0; H < d; H++) N.dyn_dtree[2 * H] = 0;
          for (H = 0; H < p; H++) N.bl_tree[2 * H] = 0;
          N.dyn_ltree[2 * g] = 1, N.opt_len = N.static_len = 0, N.last_lit = N.matches = 0;
        }
        function ge(N) {
          8 < N.bi_valid ? X(N, N.bi_buf) : 0 < N.bi_valid && (N.pending_buf[N.pending++] = N.bi_buf), N.bi_buf = 0, N.bi_valid = 0;
        }
        function Ae(N, H, G, Z) {
          var q = 2 * H, Q = 2 * G;
          return N[q] < N[Q] || N[q] === N[Q] && Z[H] <= Z[G];
        }
        function ke(N, H, G) {
          for (var Z = N.heap[G], q = G << 1; q <= N.heap_len && (q < N.heap_len && Ae(H, N.heap[q + 1], N.heap[q], N.depth) && q++, !Ae(H, Z, N.heap[q], N.depth)); ) N.heap[G] = N.heap[q], G = q, q <<= 1;
          N.heap[G] = Z;
        }
        function Le(N, H, G) {
          var Z, q, Q, se, ee = 0;
          if (N.last_lit !== 0) for (; Z = N.pending_buf[N.d_buf + 2 * ee] << 8 | N.pending_buf[N.d_buf + 2 * ee + 1], q = N.pending_buf[N.l_buf + ee], ee++, Z === 0 ? K(N, q, H) : (K(N, (Q = x[q]) + h + 1, H), (se = A[Q]) !== 0 && J(N, q -= I[Q], se), K(N, Q = z(--Z), G), (se = C[Q]) !== 0 && J(N, Z -= M[Q], se)), ee < N.last_lit; ) ;
          K(N, g, H);
        }
        function Xe(N, H) {
          var G, Z, q, Q = H.dyn_tree, se = H.stat_desc.static_tree, ee = H.stat_desc.has_stree, he = H.stat_desc.elems, Te = -1;
          for (N.heap_len = 0, N.heap_max = m, G = 0; G < he; G++) Q[2 * G] !== 0 ? (N.heap[++N.heap_len] = Te = G, N.depth[G] = 0) : Q[2 * G + 1] = 0;
          for (; N.heap_len < 2; ) Q[2 * (q = N.heap[++N.heap_len] = Te < 2 ? ++Te : 0)] = 1, N.depth[q] = 0, N.opt_len--, ee && (N.static_len -= se[2 * q + 1]);
          for (H.max_code = Te, G = N.heap_len >> 1; 1 <= G; G--) ke(N, Q, G);
          for (q = he; G = N.heap[1], N.heap[1] = N.heap[N.heap_len--], ke(N, Q, 1), Z = N.heap[1], N.heap[--N.heap_max] = G, N.heap[--N.heap_max] = Z, Q[2 * q] = Q[2 * G] + Q[2 * Z], N.depth[q] = (N.depth[G] >= N.depth[Z] ? N.depth[G] : N.depth[Z]) + 1, Q[2 * G + 1] = Q[2 * Z + 1] = q, N.heap[1] = q++, ke(N, Q, 1), 2 <= N.heap_len; ) ;
          N.heap[--N.heap_max] = N.heap[1], function(we, rt) {
            var Ln, it, yt, Ie, pn, ir, vt = rt.dyn_tree, Tr = rt.max_code, Es = rt.stat_desc.static_tree, fi = rt.stat_desc.has_stree, Mn = rt.stat_desc.extra_bits, Dr = rt.stat_desc.extra_base, mn = rt.stat_desc.max_length, sr = 0;
            for (Ie = 0; Ie <= _; Ie++) we.bl_count[Ie] = 0;
            for (vt[2 * we.heap[we.heap_max] + 1] = 0, Ln = we.heap_max + 1; Ln < m; Ln++) mn < (Ie = vt[2 * vt[2 * (it = we.heap[Ln]) + 1] + 1] + 1) && (Ie = mn, sr++), vt[2 * it + 1] = Ie, Tr < it || (we.bl_count[Ie]++, pn = 0, Dr <= it && (pn = Mn[it - Dr]), ir = vt[2 * it], we.opt_len += ir * (Ie + pn), fi && (we.static_len += ir * (Es[2 * it + 1] + pn)));
            if (sr !== 0) {
              do {
                for (Ie = mn - 1; we.bl_count[Ie] === 0; ) Ie--;
                we.bl_count[Ie]--, we.bl_count[Ie + 1] += 2, we.bl_count[mn]--, sr -= 2;
              } while (0 < sr);
              for (Ie = mn; Ie !== 0; Ie--) for (it = we.bl_count[Ie]; it !== 0; ) Tr < (yt = we.heap[--Ln]) || (vt[2 * yt + 1] !== Ie && (we.opt_len += (Ie - vt[2 * yt + 1]) * vt[2 * yt], vt[2 * yt + 1] = Ie), it--);
            }
          }(N, H), Fe(Q, Te, N.bl_count);
        }
        function D(N, H, G) {
          var Z, q, Q = -1, se = H[1], ee = 0, he = 7, Te = 4;
          for (se === 0 && (he = 138, Te = 3), H[2 * (G + 1) + 1] = 65535, Z = 0; Z <= G; Z++) q = se, se = H[2 * (Z + 1) + 1], ++ee < he && q === se || (ee < Te ? N.bl_tree[2 * q] += ee : q !== 0 ? (q !== Q && N.bl_tree[2 * q]++, N.bl_tree[2 * v]++) : ee <= 10 ? N.bl_tree[2 * w]++ : N.bl_tree[2 * E]++, Q = q, Te = (ee = 0) === se ? (he = 138, 3) : q === se ? (he = 6, 3) : (he = 7, 4));
        }
        function V(N, H, G) {
          var Z, q, Q = -1, se = H[1], ee = 0, he = 7, Te = 4;
          for (se === 0 && (he = 138, Te = 3), Z = 0; Z <= G; Z++) if (q = se, se = H[2 * (Z + 1) + 1], !(++ee < he && q === se)) {
            if (ee < Te) for (; K(N, q, N.bl_tree), --ee != 0; ) ;
            else q !== 0 ? (q !== Q && (K(N, q, N.bl_tree), ee--), K(N, v, N.bl_tree), J(N, ee - 3, 2)) : ee <= 10 ? (K(N, w, N.bl_tree), J(N, ee - 3, 3)) : (K(N, E, N.bl_tree), J(N, ee - 11, 7));
            Q = q, Te = (ee = 0) === se ? (he = 138, 3) : q === se ? (he = 6, 3) : (he = 7, 4);
          }
        }
        u(M);
        var W = !1;
        function B(N, H, G, Z) {
          J(N, (c << 1) + (Z ? 1 : 0), 3), function(q, Q, se, ee) {
            ge(q), X(q, se), X(q, ~se), s.arraySet(q.pending_buf, q.window, Q, se, q.pending), q.pending += se;
          }(N, H, G);
        }
        r._tr_init = function(N) {
          W || (function() {
            var H, G, Z, q, Q, se = new Array(_ + 1);
            for (q = Z = 0; q < l - 1; q++) for (I[q] = Z, H = 0; H < 1 << A[q]; H++) x[Z++] = q;
            for (x[Z - 1] = q, q = Q = 0; q < 16; q++) for (M[q] = Q, H = 0; H < 1 << C[q]; H++) S[Q++] = q;
            for (Q >>= 7; q < d; q++) for (M[q] = Q << 7, H = 0; H < 1 << C[q] - 7; H++) S[256 + Q++] = q;
            for (G = 0; G <= _; G++) se[G] = 0;
            for (H = 0; H <= 143; ) P[2 * H + 1] = 8, H++, se[8]++;
            for (; H <= 255; ) P[2 * H + 1] = 9, H++, se[9]++;
            for (; H <= 279; ) P[2 * H + 1] = 7, H++, se[7]++;
            for (; H <= 287; ) P[2 * H + 1] = 8, H++, se[8]++;
            for (Fe(P, f + 1, se), H = 0; H < d; H++) k[2 * H + 1] = 5, k[2 * H] = be(H, 5);
            F = new U(P, A, h + 1, f, _), T = new U(k, C, 0, d, _), L = new U(new Array(0), O, 0, p, b);
          }(), W = !0), N.l_desc = new $(N.dyn_ltree, F), N.d_desc = new $(N.dyn_dtree, T), N.bl_desc = new $(N.bl_tree, L), N.bi_buf = 0, N.bi_valid = 0, de(N);
        }, r._tr_stored_block = B, r._tr_flush_block = function(N, H, G, Z) {
          var q, Q, se = 0;
          0 < N.level ? (N.strm.data_type === 2 && (N.strm.data_type = function(ee) {
            var he, Te = 4093624447;
            for (he = 0; he <= 31; he++, Te >>>= 1) if (1 & Te && ee.dyn_ltree[2 * he] !== 0) return o;
            if (ee.dyn_ltree[18] !== 0 || ee.dyn_ltree[20] !== 0 || ee.dyn_ltree[26] !== 0) return a;
            for (he = 32; he < h; he++) if (ee.dyn_ltree[2 * he] !== 0) return a;
            return o;
          }(N)), Xe(N, N.l_desc), Xe(N, N.d_desc), se = function(ee) {
            var he;
            for (D(ee, ee.dyn_ltree, ee.l_desc.max_code), D(ee, ee.dyn_dtree, ee.d_desc.max_code), Xe(ee, ee.bl_desc), he = p - 1; 3 <= he && ee.bl_tree[2 * R[he] + 1] === 0; he--) ;
            return ee.opt_len += 3 * (he + 1) + 5 + 5 + 4, he;
          }(N), q = N.opt_len + 3 + 7 >>> 3, (Q = N.static_len + 3 + 7 >>> 3) <= q && (q = Q)) : q = Q = G + 5, G + 4 <= q && H !== -1 ? B(N, H, G, Z) : N.strategy === 4 || Q === q ? (J(N, 2 + (Z ? 1 : 0), 3), Le(N, P, k)) : (J(N, 4 + (Z ? 1 : 0), 3), function(ee, he, Te, we) {
            var rt;
            for (J(ee, he - 257, 5), J(ee, Te - 1, 5), J(ee, we - 4, 4), rt = 0; rt < we; rt++) J(ee, ee.bl_tree[2 * R[rt] + 1], 3);
            V(ee, ee.dyn_ltree, he - 1), V(ee, ee.dyn_dtree, Te - 1);
          }(N, N.l_desc.max_code + 1, N.d_desc.max_code + 1, se + 1), Le(N, N.dyn_ltree, N.dyn_dtree)), de(N), Z && ge(N);
        }, r._tr_tally = function(N, H, G) {
          return N.pending_buf[N.d_buf + 2 * N.last_lit] = H >>> 8 & 255, N.pending_buf[N.d_buf + 2 * N.last_lit + 1] = 255 & H, N.pending_buf[N.l_buf + N.last_lit] = 255 & G, N.last_lit++, H === 0 ? N.dyn_ltree[2 * G]++ : (N.matches++, H--, N.dyn_ltree[2 * (x[G] + h + 1)]++, N.dyn_dtree[2 * z(H)]++), N.last_lit === N.lit_bufsize - 1;
        }, r._tr_align = function(N) {
          J(N, 2, 3), K(N, g, P), function(H) {
            H.bi_valid === 16 ? (X(H, H.bi_buf), H.bi_buf = 0, H.bi_valid = 0) : 8 <= H.bi_valid && (H.pending_buf[H.pending++] = 255 & H.bi_buf, H.bi_buf >>= 8, H.bi_valid -= 8);
          }(N);
        };
      }, { "../utils/common": 41 }], 53: [function(n, i, r) {
        i.exports = function() {
          this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
        };
      }, {}], 54: [function(n, i, r) {
        (function(s) {
          (function(o, a) {
            if (!o.setImmediate) {
              var u, c, l, h, f = 1, d = {}, p = !1, m = o.document, _ = Object.getPrototypeOf && Object.getPrototypeOf(o);
              _ = _ && _.setTimeout ? _ : o, u = {}.toString.call(o.process) === "[object process]" ? function(v) {
                process.nextTick(function() {
                  b(v);
                });
              } : function() {
                if (o.postMessage && !o.importScripts) {
                  var v = !0, w = o.onmessage;
                  return o.onmessage = function() {
                    v = !1;
                  }, o.postMessage("", "*"), o.onmessage = w, v;
                }
              }() ? (h = "setImmediate$" + Math.random() + "$", o.addEventListener ? o.addEventListener("message", g, !1) : o.attachEvent("onmessage", g), function(v) {
                o.postMessage(h + v, "*");
              }) : o.MessageChannel ? ((l = new MessageChannel()).port1.onmessage = function(v) {
                b(v.data);
              }, function(v) {
                l.port2.postMessage(v);
              }) : m && "onreadystatechange" in m.createElement("script") ? (c = m.documentElement, function(v) {
                var w = m.createElement("script");
                w.onreadystatechange = function() {
                  b(v), w.onreadystatechange = null, c.removeChild(w), w = null;
                }, c.appendChild(w);
              }) : function(v) {
                setTimeout(b, 0, v);
              }, _.setImmediate = function(v) {
                typeof v != "function" && (v = new Function("" + v));
                for (var w = new Array(arguments.length - 1), E = 0; E < w.length; E++) w[E] = arguments[E + 1];
                var A = { callback: v, args: w };
                return d[f] = A, u(f), f++;
              }, _.clearImmediate = y;
            }
            function y(v) {
              delete d[v];
            }
            function b(v) {
              if (p) setTimeout(b, 0, v);
              else {
                var w = d[v];
                if (w) {
                  p = !0;
                  try {
                    (function(E) {
                      var A = E.callback, C = E.args;
                      switch (C.length) {
                        case 0:
                          A();
                          break;
                        case 1:
                          A(C[0]);
                          break;
                        case 2:
                          A(C[0], C[1]);
                          break;
                        case 3:
                          A(C[0], C[1], C[2]);
                          break;
                        default:
                          A.apply(a, C);
                      }
                    })(w);
                  } finally {
                    y(v), p = !1;
                  }
                }
              }
            }
            function g(v) {
              v.source === o && typeof v.data == "string" && v.data.indexOf(h) === 0 && b(+v.data.slice(h.length));
            }
          })(typeof self > "u" ? s === void 0 ? this : s : self);
        }).call(this, typeof sn < "u" ? sn : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}] }, {}, [10])(10);
    });
  }(Gs)), Gs.exports;
}
var pg = dg();
const Sh = /* @__PURE__ */ Pn(pg);
var Bi = { exports: {} }, mg = Bi.exports, Pu;
function gg() {
  return Pu || (Pu = 1, function(t, e) {
    (function(n, i) {
      t.exports = i();
    })(mg, () => (() => {
      var n = { d: (f, d) => {
        for (var p in d) n.o(d, p) && !n.o(f, p) && Object.defineProperty(f, p, { enumerable: !0, get: d[p] });
      }, o: (f, d) => Object.prototype.hasOwnProperty.call(f, d) }, i = {};
      function r(f) {
        return Array.isArray(f) ? "array" : f instanceof Date ? "date" : f instanceof Error ? "error" : f instanceof RegExp ? "regexp" : f === null ? "null" : typeof f == "object" && Object.prototype.toString.call(f) === "[object Object]" ? "object" : typeof f;
      }
      n.d(i, { default: () => h });
      var s = { base: o, date: o, error: o, symbol: o, string: o, number: o, boolean: o, regexp: o, null: o, undefined: o };
      function o(f) {
        return f;
      }
      var a = { indent: " ", prefix: `
`, postfix: "", errorToString: function(f, d) {
        return Error.prototype.toString.call(f);
      }, dateToString: function(f) {
        return "new Date(".concat(Date.prototype.toISOString.call(f), ")");
      }, colors: s };
      function u(f) {
        return f === void 0 && (f = {}), Object.assign({}, a, f, { colors: Object.assign({}, s, f.colors) });
      }
      function c(f, d) {
        f === void 0 && (f = 1), d === void 0 && (d = "  ");
        for (var p = "", m = 0; m < f; m += 1) p += d;
        return p;
      }
      var l = ["object", "array"];
      function h(f, d) {
        var p = u(d), m = p.colors, _ = p.prefix, y = p.postfix, b = p.dateToString, g = p.errorToString, v = p.indent, w = /* @__PURE__ */ new Map();
        function E(P, k, S) {
          if (k === void 0 && (k = 1), S === void 0 && (S = 0), Object.keys(P).length === 0) return " ".concat(m.base("{}"));
          var x = `
`, I = c(k, v);
          return Object.keys(P).forEach(function(F) {
            var T = P[F], L = r(T), M = c(S, "  "), U = l.includes(L) ? "" : " ", $ = O(T) ? " ".concat(m.base("[Circular]")) : C(L, T, k + 1, S);
            x += "".concat(M).concat(I).concat(m.base("".concat(F, ":"))).concat(U).concat($, `
`);
          }), x.substring(0, x.length - 1);
        }
        function A(P, k, S) {
          if (k === void 0 && (k = 1), S === void 0 && (S = 0), P.length === 0) return " ".concat(m.base("[]"));
          var x = `
`, I = c(k, v);
          return P.forEach(function(F) {
            var T = r(F), L = c(S, "  "), M = O(F) ? m.base("[Circular]") : C(T, F, k, S + 1).toString().trimLeft();
            x += "".concat(L).concat(I).concat("".concat(m.base("-"), " ")).concat(M, `
`);
          }), x.substring(0, x.length - 1);
        }
        function C(P, k, S, x) {
          switch (P) {
            case "array":
              return A(k, S, x);
            case "object":
              return E(k, S, x);
            case "string":
              return m.string(k);
            case "symbol":
              return m.symbol(k.toString());
            case "number":
              return m.number(k);
            case "boolean":
              return m.boolean(k);
            case "null":
              return m.null("null");
            case "undefined":
              return m.undefined("undefined");
            case "date":
              return m.date(b(k));
            case "error":
              return m.error(g(k, c(S, v)));
            case "regexp":
              return m.regexp(k.toString());
            default:
              return k && k.toString ? k.toString() : Object.prototype.toString.call(k);
          }
        }
        function O(P) {
          return !(!["object", "array"].includes(r(P)) || !w.has(P) && (w.set(P, !0), 1));
        }
        var R = "";
        return w.set(f, !0), r(f) === "object" && Object.keys(f).length > 0 ? R = E(f) : r(f) === "array" && f.length > 0 && (R = A(f)), R.length === 0 ? "" : "".concat(_).concat(R.slice(1)).concat(y);
      }
      return i.default;
    })());
  }(Bi)), Bi.exports;
}
var bg = gg();
const _g = /* @__PURE__ */ Pn(bg), Ru = {};
function yg(t) {
  let e = Ru[t];
  if (e)
    return e;
  e = Ru[t] = [];
  for (let n = 0; n < 128; n++) {
    const i = String.fromCharCode(n);
    e.push(i);
  }
  for (let n = 0; n < t.length; n++) {
    const i = t.charCodeAt(n);
    e[i] = "%" + ("0" + i.toString(16).toUpperCase()).slice(-2);
  }
  return e;
}
function wr(t, e) {
  typeof e != "string" && (e = wr.defaultChars);
  const n = yg(e);
  return t.replace(/(%[a-f0-9]{2})+/gi, function(i) {
    let r = "";
    for (let s = 0, o = i.length; s < o; s += 3) {
      const a = parseInt(i.slice(s + 1, s + 3), 16);
      if (a < 128) {
        r += n[a];
        continue;
      }
      if ((a & 224) === 192 && s + 3 < o) {
        const u = parseInt(i.slice(s + 4, s + 6), 16);
        if ((u & 192) === 128) {
          const c = a << 6 & 1984 | u & 63;
          c < 128 ? r += "��" : r += String.fromCharCode(c), s += 3;
          continue;
        }
      }
      if ((a & 240) === 224 && s + 6 < o) {
        const u = parseInt(i.slice(s + 4, s + 6), 16), c = parseInt(i.slice(s + 7, s + 9), 16);
        if ((u & 192) === 128 && (c & 192) === 128) {
          const l = a << 12 & 61440 | u << 6 & 4032 | c & 63;
          l < 2048 || l >= 55296 && l <= 57343 ? r += "���" : r += String.fromCharCode(l), s += 6;
          continue;
        }
      }
      if ((a & 248) === 240 && s + 9 < o) {
        const u = parseInt(i.slice(s + 4, s + 6), 16), c = parseInt(i.slice(s + 7, s + 9), 16), l = parseInt(i.slice(s + 10, s + 12), 16);
        if ((u & 192) === 128 && (c & 192) === 128 && (l & 192) === 128) {
          let h = a << 18 & 1835008 | u << 12 & 258048 | c << 6 & 4032 | l & 63;
          h < 65536 || h > 1114111 ? r += "����" : (h -= 65536, r += String.fromCharCode(55296 + (h >> 10), 56320 + (h & 1023))), s += 9;
          continue;
        }
      }
      r += "�";
    }
    return r;
  });
}
wr.defaultChars = ";/?:@&=+$,#";
wr.componentChars = "";
const Lu = {};
function vg(t) {
  let e = Lu[t];
  if (e)
    return e;
  e = Lu[t] = [];
  for (let n = 0; n < 128; n++) {
    const i = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(i) ? e.push(i) : e.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < t.length; n++)
    e[t.charCodeAt(n)] = t[n];
  return e;
}
function ui(t, e, n) {
  typeof e != "string" && (n = e, e = ui.defaultChars), typeof n > "u" && (n = !0);
  const i = vg(e);
  let r = "";
  for (let s = 0, o = t.length; s < o; s++) {
    const a = t.charCodeAt(s);
    if (n && a === 37 && s + 2 < o && /^[0-9a-f]{2}$/i.test(t.slice(s + 1, s + 3))) {
      r += t.slice(s, s + 3), s += 2;
      continue;
    }
    if (a < 128) {
      r += i[a];
      continue;
    }
    if (a >= 55296 && a <= 57343) {
      if (a >= 55296 && a <= 56319 && s + 1 < o) {
        const u = t.charCodeAt(s + 1);
        if (u >= 56320 && u <= 57343) {
          r += encodeURIComponent(t[s] + t[s + 1]), s++;
          continue;
        }
      }
      r += "%EF%BF%BD";
      continue;
    }
    r += encodeURIComponent(t[s]);
  }
  return r;
}
ui.defaultChars = ";/?:@&=+$,-_.!~*'()#";
ui.componentChars = "-_.!~*'()";
function Ea(t) {
  let e = "";
  return e += t.protocol || "", e += t.slashes ? "//" : "", e += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? e += "[" + t.hostname + "]" : e += t.hostname || "", e += t.port ? ":" + t.port : "", e += t.pathname || "", e += t.search || "", e += t.hash || "", e;
}
function rs() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const wg = /^([a-z0-9.+-]+:)/i, xg = /:[0-9]*$/, kg = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, Sg = ["<", ">", '"', "`", " ", "\r", `
`, "	"], Ag = ["{", "}", "|", "\\", "^", "`"].concat(Sg), Eg = ["'"].concat(Ag), Mu = ["%", "/", "?", ";", "#"].concat(Eg), ju = ["/", "?", "#"], Cg = 255, Nu = /^[+a-z0-9A-Z_-]{0,63}$/, Tg = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, Bu = {
  javascript: !0,
  "javascript:": !0
}, $u = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function Ca(t, e) {
  if (t && t instanceof rs) return t;
  const n = new rs();
  return n.parse(t, e), n;
}
rs.prototype.parse = function(t, e) {
  let n, i, r, s = t;
  if (s = s.trim(), !e && t.split("#").length === 1) {
    const c = kg.exec(s);
    if (c)
      return this.pathname = c[1], c[2] && (this.search = c[2]), this;
  }
  let o = wg.exec(s);
  if (o && (o = o[0], n = o.toLowerCase(), this.protocol = o, s = s.substr(o.length)), (e || o || s.match(/^\/\/[^@\/]+@[^@\/]+/)) && (r = s.substr(0, 2) === "//", r && !(o && Bu[o]) && (s = s.substr(2), this.slashes = !0)), !Bu[o] && (r || o && !$u[o])) {
    let c = -1;
    for (let p = 0; p < ju.length; p++)
      i = s.indexOf(ju[p]), i !== -1 && (c === -1 || i < c) && (c = i);
    let l, h;
    c === -1 ? h = s.lastIndexOf("@") : h = s.lastIndexOf("@", c), h !== -1 && (l = s.slice(0, h), s = s.slice(h + 1), this.auth = l), c = -1;
    for (let p = 0; p < Mu.length; p++)
      i = s.indexOf(Mu[p]), i !== -1 && (c === -1 || i < c) && (c = i);
    c === -1 && (c = s.length), s[c - 1] === ":" && c--;
    const f = s.slice(0, c);
    s = s.slice(c), this.parseHost(f), this.hostname = this.hostname || "";
    const d = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!d) {
      const p = this.hostname.split(/\./);
      for (let m = 0, _ = p.length; m < _; m++) {
        const y = p[m];
        if (y && !y.match(Nu)) {
          let b = "";
          for (let g = 0, v = y.length; g < v; g++)
            y.charCodeAt(g) > 127 ? b += "x" : b += y[g];
          if (!b.match(Nu)) {
            const g = p.slice(0, m), v = p.slice(m + 1), w = y.match(Tg);
            w && (g.push(w[1]), v.unshift(w[2])), v.length && (s = v.join(".") + s), this.hostname = g.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > Cg && (this.hostname = ""), d && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const a = s.indexOf("#");
  a !== -1 && (this.hash = s.substr(a), s = s.slice(0, a));
  const u = s.indexOf("?");
  return u !== -1 && (this.search = s.substr(u), s = s.slice(0, u)), s && (this.pathname = s), $u[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
rs.prototype.parseHost = function(t) {
  let e = xg.exec(t);
  e && (e = e[0], e !== ":" && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
};
const Dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: wr,
  encode: ui,
  format: Ea,
  parse: Ca
}, Symbol.toStringTag, { value: "Module" })), Ah = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, Eh = /[\0-\x1F\x7F-\x9F]/, Fg = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, Ta = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, Ch = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, Th = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: Ah,
  Cc: Eh,
  Cf: Fg,
  P: Ta,
  S: Ch,
  Z: Th
}, Symbol.toStringTag, { value: "Module" })), Ig = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), Pg = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((t) => t.charCodeAt(0))
);
var Ks;
const Rg = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), Lg = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (Ks = String.fromCodePoint) !== null && Ks !== void 0 ? Ks : function(t) {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function Mg(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = Rg.get(t)) !== null && e !== void 0 ? e : t;
}
var Je;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(Je || (Je = {}));
const jg = 32;
var Tn;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Tn || (Tn = {}));
function $o(t) {
  return t >= Je.ZERO && t <= Je.NINE;
}
function Ng(t) {
  return t >= Je.UPPER_A && t <= Je.UPPER_F || t >= Je.LOWER_A && t <= Je.LOWER_F;
}
function Bg(t) {
  return t >= Je.UPPER_A && t <= Je.UPPER_Z || t >= Je.LOWER_A && t <= Je.LOWER_Z || $o(t);
}
function $g(t) {
  return t === Je.EQUALS || Bg(t);
}
var Ze;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(Ze || (Ze = {}));
var En;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(En || (En = {}));
class zg {
  constructor(e, n, i) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = i, this.state = Ze.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = En.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = Ze.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case Ze.EntityStart:
        return e.charCodeAt(n) === Je.NUM ? (this.state = Ze.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = Ze.NamedEntity, this.stateNamedEntity(e, n));
      case Ze.NumericStart:
        return this.stateNumericStart(e, n);
      case Ze.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case Ze.NumericHex:
        return this.stateNumericHex(e, n);
      case Ze.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | jg) === Je.LOWER_X ? (this.state = Ze.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = Ze.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, i, r) {
    if (n !== i) {
      const s = i - n;
      this.result = this.result * Math.pow(r, s) + parseInt(e.substr(n, s), r), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const i = n;
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if ($o(r) || Ng(r))
        n += 1;
      else
        return this.addToNumericResult(e, i, n, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(e, i, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const i = n;
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if ($o(r))
        n += 1;
      else
        return this.addToNumericResult(e, i, n, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(e, i, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var i;
    if (this.consumed <= n)
      return (i = this.errors) === null || i === void 0 || i.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === Je.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === En.Strict)
      return 0;
    return this.emitCodePoint(Mg(this.result), this.consumed), this.errors && (e !== Je.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: i } = this;
    let r = i[this.treeIndex], s = (r & Tn.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const o = e.charCodeAt(n);
      if (this.treeIndex = Ug(i, r, this.treeIndex + Math.max(1, s), o), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === En.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        $g(o)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = i[this.treeIndex], s = (r & Tn.VALUE_LENGTH) >> 14, s !== 0) {
        if (o === Je.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== En.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: i } = this, r = (i[n] & Tn.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, r, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, i) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(n === 1 ? r[e] & ~Tn.VALUE_LENGTH : r[e + 1], i), n === 3 && this.emitCodePoint(r[e + 2], i), i;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case Ze.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== En.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Ze.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ze.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ze.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ze.EntityStart:
        return 0;
    }
  }
}
function Dh(t) {
  let e = "";
  const n = new zg(t, (i) => e += Lg(i));
  return function(r, s) {
    let o = 0, a = 0;
    for (; (a = r.indexOf("&", a)) >= 0; ) {
      e += r.slice(o, a), n.startEntity(s);
      const c = n.write(
        r,
        // Skip the "&"
        a + 1
      );
      if (c < 0) {
        o = a + n.end();
        break;
      }
      o = a + c, a = c === 0 ? o + 1 : o;
    }
    const u = e + r.slice(o);
    return e = "", u;
  };
}
function Ug(t, e, n, i) {
  const r = (e & Tn.BRANCH_LENGTH) >> 7, s = e & Tn.JUMP_TABLE;
  if (r === 0)
    return s !== 0 && i === s ? n : -1;
  if (s) {
    const u = i - s;
    return u < 0 || u >= r ? -1 : t[n + u] - 1;
  }
  let o = n, a = o + r - 1;
  for (; o <= a; ) {
    const u = o + a >>> 1, c = t[u];
    if (c < i)
      o = u + 1;
    else if (c > i)
      a = u - 1;
    else
      return t[u + r];
  }
  return -1;
}
const Hg = Dh(Ig);
Dh(Pg);
function Fh(t, e = En.Legacy) {
  return Hg(t, e);
}
function qg(t) {
  return Object.prototype.toString.call(t);
}
function Da(t) {
  return qg(t) === "[object String]";
}
const Wg = Object.prototype.hasOwnProperty;
function Vg(t, e) {
  return Wg.call(t, e);
}
function vs(t) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(i) {
        t[i] = n[i];
      });
    }
  }), t;
}
function Oh(t, e, n) {
  return [].concat(t.slice(0, e), n, t.slice(e + 1));
}
function Fa(t) {
  return !(t >= 55296 && t <= 57343 || t >= 64976 && t <= 65007 || (t & 65535) === 65535 || (t & 65535) === 65534 || t >= 0 && t <= 8 || t === 11 || t >= 14 && t <= 31 || t >= 127 && t <= 159 || t > 1114111);
}
function is(t) {
  if (t > 65535) {
    t -= 65536;
    const e = 55296 + (t >> 10), n = 56320 + (t & 1023);
    return String.fromCharCode(e, n);
  }
  return String.fromCharCode(t);
}
const Ih = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, Gg = /&([a-z#][a-z0-9]{1,31});/gi, Kg = new RegExp(Ih.source + "|" + Gg.source, "gi"), Zg = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function Jg(t, e) {
  if (e.charCodeAt(0) === 35 && Zg.test(e)) {
    const i = e[1].toLowerCase() === "x" ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
    return Fa(i) ? is(i) : t;
  }
  const n = Fh(t);
  return n !== t ? n : t;
}
function Yg(t) {
  return t.indexOf("\\") < 0 ? t : t.replace(Ih, "$1");
}
function xr(t) {
  return t.indexOf("\\") < 0 && t.indexOf("&") < 0 ? t : t.replace(Kg, function(e, n, i) {
    return n || Jg(e, i);
  });
}
const Xg = /[&<>"]/, Qg = /[&<>"]/g, e1 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function t1(t) {
  return e1[t];
}
function In(t) {
  return Xg.test(t) ? t.replace(Qg, t1) : t;
}
const n1 = /[.?*+^$[\]\\(){}|-]/g;
function r1(t) {
  return t.replace(n1, "\\$&");
}
function Oe(t) {
  switch (t) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function Xr(t) {
  if (t >= 8192 && t <= 8202)
    return !0;
  switch (t) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Qr(t) {
  return Ta.test(t) || Ch.test(t);
}
function ei(t) {
  switch (t) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function ws(t) {
  return t = t.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (t = t.replace(/ẞ/g, "ß")), t.toLowerCase().toUpperCase();
}
const i1 = { mdurl: Dg, ucmicro: Og }, s1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: Oh,
  assign: vs,
  escapeHtml: In,
  escapeRE: r1,
  fromCodePoint: is,
  has: Vg,
  isMdAsciiPunct: ei,
  isPunctChar: Qr,
  isSpace: Oe,
  isString: Da,
  isValidEntityCode: Fa,
  isWhiteSpace: Xr,
  lib: i1,
  normalizeReference: ws,
  unescapeAll: xr,
  unescapeMd: Yg
}, Symbol.toStringTag, { value: "Module" }));
function o1(t, e, n) {
  let i, r, s, o;
  const a = t.posMax, u = t.pos;
  for (t.pos = e + 1, i = 1; t.pos < a; ) {
    if (s = t.src.charCodeAt(t.pos), s === 93 && (i--, i === 0)) {
      r = !0;
      break;
    }
    if (o = t.pos, t.md.inline.skipToken(t), s === 91) {
      if (o === t.pos - 1)
        i++;
      else if (n)
        return t.pos = u, -1;
    }
  }
  let c = -1;
  return r && (c = t.pos), t.pos = u, c;
}
function a1(t, e, n) {
  let i, r = e;
  const s = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (t.charCodeAt(r) === 60) {
    for (r++; r < n; ) {
      if (i = t.charCodeAt(r), i === 10 || i === 60)
        return s;
      if (i === 62)
        return s.pos = r + 1, s.str = xr(t.slice(e + 1, r)), s.ok = !0, s;
      if (i === 92 && r + 1 < n) {
        r += 2;
        continue;
      }
      r++;
    }
    return s;
  }
  let o = 0;
  for (; r < n && (i = t.charCodeAt(r), !(i === 32 || i < 32 || i === 127)); ) {
    if (i === 92 && r + 1 < n) {
      if (t.charCodeAt(r + 1) === 32)
        break;
      r += 2;
      continue;
    }
    if (i === 40 && (o++, o > 32))
      return s;
    if (i === 41) {
      if (o === 0)
        break;
      o--;
    }
    r++;
  }
  return e === r || o !== 0 || (s.str = xr(t.slice(e, r)), s.pos = r, s.ok = !0), s;
}
function u1(t, e, n, i) {
  let r, s = e;
  const o = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (i)
    o.str = i.str, o.marker = i.marker;
  else {
    if (s >= n)
      return o;
    let a = t.charCodeAt(s);
    if (a !== 34 && a !== 39 && a !== 40)
      return o;
    e++, s++, a === 40 && (a = 41), o.marker = a;
  }
  for (; s < n; ) {
    if (r = t.charCodeAt(s), r === o.marker)
      return o.pos = s + 1, o.str += xr(t.slice(e, s)), o.ok = !0, o;
    if (r === 40 && o.marker === 41)
      return o;
    r === 92 && s + 1 < n && s++, s++;
  }
  return o.can_continue = !0, o.str += xr(t.slice(e, s)), o;
}
const c1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: a1,
  parseLinkLabel: o1,
  parseLinkTitle: u1
}, Symbol.toStringTag, { value: "Module" })), Kt = {};
Kt.code_inline = function(t, e, n, i, r) {
  const s = t[e];
  return "<code" + r.renderAttrs(s) + ">" + In(s.content) + "</code>";
};
Kt.code_block = function(t, e, n, i, r) {
  const s = t[e];
  return "<pre" + r.renderAttrs(s) + "><code>" + In(t[e].content) + `</code></pre>
`;
};
Kt.fence = function(t, e, n, i, r) {
  const s = t[e], o = s.info ? xr(s.info).trim() : "";
  let a = "", u = "";
  if (o) {
    const l = o.split(/(\s+)/g);
    a = l[0], u = l.slice(2).join("");
  }
  let c;
  if (n.highlight ? c = n.highlight(s.content, a, u) || In(s.content) : c = In(s.content), c.indexOf("<pre") === 0)
    return c + `
`;
  if (o) {
    const l = s.attrIndex("class"), h = s.attrs ? s.attrs.slice() : [];
    l < 0 ? h.push(["class", n.langPrefix + a]) : (h[l] = h[l].slice(), h[l][1] += " " + n.langPrefix + a);
    const f = {
      attrs: h
    };
    return `<pre><code${r.renderAttrs(f)}>${c}</code></pre>
`;
  }
  return `<pre><code${r.renderAttrs(s)}>${c}</code></pre>
`;
};
Kt.image = function(t, e, n, i, r) {
  const s = t[e];
  return s.attrs[s.attrIndex("alt")][1] = r.renderInlineAsText(s.children, n, i), r.renderToken(t, e, n);
};
Kt.hardbreak = function(t, e, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
Kt.softbreak = function(t, e, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
Kt.text = function(t, e) {
  return In(t[e].content);
};
Kt.html_block = function(t, e) {
  return t[e].content;
};
Kt.html_inline = function(t, e) {
  return t[e].content;
};
function Er() {
  this.rules = vs({}, Kt);
}
Er.prototype.renderAttrs = function(e) {
  let n, i, r;
  if (!e.attrs)
    return "";
  for (r = "", n = 0, i = e.attrs.length; n < i; n++)
    r += " " + In(e.attrs[n][0]) + '="' + In(e.attrs[n][1]) + '"';
  return r;
};
Er.prototype.renderToken = function(e, n, i) {
  const r = e[n];
  let s = "";
  if (r.hidden)
    return "";
  r.block && r.nesting !== -1 && n && e[n - 1].hidden && (s += `
`), s += (r.nesting === -1 ? "</" : "<") + r.tag, s += this.renderAttrs(r), r.nesting === 0 && i.xhtmlOut && (s += " /");
  let o = !1;
  if (r.block && (o = !0, r.nesting === 1 && n + 1 < e.length)) {
    const a = e[n + 1];
    (a.type === "inline" || a.hidden || a.nesting === -1 && a.tag === r.tag) && (o = !1);
  }
  return s += o ? `>
` : ">", s;
};
Er.prototype.renderInline = function(t, e, n) {
  let i = "";
  const r = this.rules;
  for (let s = 0, o = t.length; s < o; s++) {
    const a = t[s].type;
    typeof r[a] < "u" ? i += r[a](t, s, e, n, this) : i += this.renderToken(t, s, e);
  }
  return i;
};
Er.prototype.renderInlineAsText = function(t, e, n) {
  let i = "";
  for (let r = 0, s = t.length; r < s; r++)
    switch (t[r].type) {
      case "text":
        i += t[r].content;
        break;
      case "image":
        i += this.renderInlineAsText(t[r].children, e, n);
        break;
      case "html_inline":
      case "html_block":
        i += t[r].content;
        break;
      case "softbreak":
      case "hardbreak":
        i += `
`;
        break;
    }
  return i;
};
Er.prototype.render = function(t, e, n) {
  let i = "";
  const r = this.rules;
  for (let s = 0, o = t.length; s < o; s++) {
    const a = t[s].type;
    a === "inline" ? i += this.renderInline(t[s].children, e, n) : typeof r[a] < "u" ? i += r[a](t, s, e, n, this) : i += this.renderToken(t, s, e, n);
  }
  return i;
};
function at() {
  this.__rules__ = [], this.__cache__ = null;
}
at.prototype.__find__ = function(t) {
  for (let e = 0; e < this.__rules__.length; e++)
    if (this.__rules__[e].name === t)
      return e;
  return -1;
};
at.prototype.__compile__ = function() {
  const t = this, e = [""];
  t.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(i) {
      e.indexOf(i) < 0 && e.push(i);
    });
  }), t.__cache__ = {}, e.forEach(function(n) {
    t.__cache__[n] = [], t.__rules__.forEach(function(i) {
      i.enabled && (n && i.alt.indexOf(n) < 0 || t.__cache__[n].push(i.fn));
    });
  });
};
at.prototype.at = function(t, e, n) {
  const i = this.__find__(t), r = n || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__[i].fn = e, this.__rules__[i].alt = r.alt || [], this.__cache__ = null;
};
at.prototype.before = function(t, e, n, i) {
  const r = this.__find__(t), s = i || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(r, 0, {
    name: e,
    enabled: !0,
    fn: n,
    alt: s.alt || []
  }), this.__cache__ = null;
};
at.prototype.after = function(t, e, n, i) {
  const r = this.__find__(t), s = i || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(r + 1, 0, {
    name: e,
    enabled: !0,
    fn: n,
    alt: s.alt || []
  }), this.__cache__ = null;
};
at.prototype.push = function(t, e, n) {
  const i = n || {};
  this.__rules__.push({
    name: t,
    enabled: !0,
    fn: e,
    alt: i.alt || []
  }), this.__cache__ = null;
};
at.prototype.enable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  const n = [];
  return t.forEach(function(i) {
    const r = this.__find__(i);
    if (r < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + i);
    }
    this.__rules__[r].enabled = !0, n.push(i);
  }, this), this.__cache__ = null, n;
};
at.prototype.enableOnly = function(t, e) {
  Array.isArray(t) || (t = [t]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(t, e);
};
at.prototype.disable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  const n = [];
  return t.forEach(function(i) {
    const r = this.__find__(i);
    if (r < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + i);
    }
    this.__rules__[r].enabled = !1, n.push(i);
  }, this), this.__cache__ = null, n;
};
at.prototype.getRules = function(t) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[t] || [];
};
function Tt(t, e, n) {
  this.type = t, this.tag = e, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
Tt.prototype.attrIndex = function(e) {
  if (!this.attrs)
    return -1;
  const n = this.attrs;
  for (let i = 0, r = n.length; i < r; i++)
    if (n[i][0] === e)
      return i;
  return -1;
};
Tt.prototype.attrPush = function(e) {
  this.attrs ? this.attrs.push(e) : this.attrs = [e];
};
Tt.prototype.attrSet = function(e, n) {
  const i = this.attrIndex(e), r = [e, n];
  i < 0 ? this.attrPush(r) : this.attrs[i] = r;
};
Tt.prototype.attrGet = function(e) {
  const n = this.attrIndex(e);
  let i = null;
  return n >= 0 && (i = this.attrs[n][1]), i;
};
Tt.prototype.attrJoin = function(e, n) {
  const i = this.attrIndex(e);
  i < 0 ? this.attrPush([e, n]) : this.attrs[i][1] = this.attrs[i][1] + " " + n;
};
function Ph(t, e, n) {
  this.src = t, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = e;
}
Ph.prototype.Token = Tt;
const l1 = /\r\n?|\n/g, h1 = /\0/g;
function f1(t) {
  let e;
  e = t.src.replace(l1, `
`), e = e.replace(h1, "�"), t.src = e;
}
function d1(t) {
  let e;
  t.inlineMode ? (e = new t.Token("inline", "", 0), e.content = t.src, e.map = [0, 1], e.children = [], t.tokens.push(e)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
}
function p1(t) {
  const e = t.tokens;
  for (let n = 0, i = e.length; n < i; n++) {
    const r = e[n];
    r.type === "inline" && t.md.inline.parse(r.content, t.md, t.env, r.children);
  }
}
function m1(t) {
  return /^<a[>\s]/i.test(t);
}
function g1(t) {
  return /^<\/a\s*>/i.test(t);
}
function b1(t) {
  const e = t.tokens;
  if (t.md.options.linkify)
    for (let n = 0, i = e.length; n < i; n++) {
      if (e[n].type !== "inline" || !t.md.linkify.pretest(e[n].content))
        continue;
      let r = e[n].children, s = 0;
      for (let o = r.length - 1; o >= 0; o--) {
        const a = r[o];
        if (a.type === "link_close") {
          for (o--; r[o].level !== a.level && r[o].type !== "link_open"; )
            o--;
          continue;
        }
        if (a.type === "html_inline" && (m1(a.content) && s > 0 && s--, g1(a.content) && s++), !(s > 0) && a.type === "text" && t.md.linkify.test(a.content)) {
          const u = a.content;
          let c = t.md.linkify.match(u);
          const l = [];
          let h = a.level, f = 0;
          c.length > 0 && c[0].index === 0 && o > 0 && r[o - 1].type === "text_special" && (c = c.slice(1));
          for (let d = 0; d < c.length; d++) {
            const p = c[d].url, m = t.md.normalizeLink(p);
            if (!t.md.validateLink(m))
              continue;
            let _ = c[d].text;
            c[d].schema ? c[d].schema === "mailto:" && !/^mailto:/i.test(_) ? _ = t.md.normalizeLinkText("mailto:" + _).replace(/^mailto:/, "") : _ = t.md.normalizeLinkText(_) : _ = t.md.normalizeLinkText("http://" + _).replace(/^http:\/\//, "");
            const y = c[d].index;
            if (y > f) {
              const w = new t.Token("text", "", 0);
              w.content = u.slice(f, y), w.level = h, l.push(w);
            }
            const b = new t.Token("link_open", "a", 1);
            b.attrs = [["href", m]], b.level = h++, b.markup = "linkify", b.info = "auto", l.push(b);
            const g = new t.Token("text", "", 0);
            g.content = _, g.level = h, l.push(g);
            const v = new t.Token("link_close", "a", -1);
            v.level = --h, v.markup = "linkify", v.info = "auto", l.push(v), f = c[d].lastIndex;
          }
          if (f < u.length) {
            const d = new t.Token("text", "", 0);
            d.content = u.slice(f), d.level = h, l.push(d);
          }
          e[n].children = r = Oh(r, o, l);
        }
      }
    }
}
const Rh = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, _1 = /\((c|tm|r)\)/i, y1 = /\((c|tm|r)\)/ig, v1 = {
  c: "©",
  r: "®",
  tm: "™"
};
function w1(t, e) {
  return v1[e.toLowerCase()];
}
function x1(t) {
  let e = 0;
  for (let n = t.length - 1; n >= 0; n--) {
    const i = t[n];
    i.type === "text" && !e && (i.content = i.content.replace(y1, w1)), i.type === "link_open" && i.info === "auto" && e--, i.type === "link_close" && i.info === "auto" && e++;
  }
}
function k1(t) {
  let e = 0;
  for (let n = t.length - 1; n >= 0; n--) {
    const i = t[n];
    i.type === "text" && !e && Rh.test(i.content) && (i.content = i.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), i.type === "link_open" && i.info === "auto" && e--, i.type === "link_close" && i.info === "auto" && e++;
  }
}
function S1(t) {
  let e;
  if (t.md.options.typographer)
    for (e = t.tokens.length - 1; e >= 0; e--)
      t.tokens[e].type === "inline" && (_1.test(t.tokens[e].content) && x1(t.tokens[e].children), Rh.test(t.tokens[e].content) && k1(t.tokens[e].children));
}
const A1 = /['"]/, zu = /['"]/g, Uu = "’";
function ki(t, e, n) {
  return t.slice(0, e) + n + t.slice(e + 1);
}
function E1(t, e) {
  let n;
  const i = [];
  for (let r = 0; r < t.length; r++) {
    const s = t[r], o = t[r].level;
    for (n = i.length - 1; n >= 0 && !(i[n].level <= o); n--)
      ;
    if (i.length = n + 1, s.type !== "text")
      continue;
    let a = s.content, u = 0, c = a.length;
    e:
      for (; u < c; ) {
        zu.lastIndex = u;
        const l = zu.exec(a);
        if (!l)
          break;
        let h = !0, f = !0;
        u = l.index + 1;
        const d = l[0] === "'";
        let p = 32;
        if (l.index - 1 >= 0)
          p = a.charCodeAt(l.index - 1);
        else
          for (n = r - 1; n >= 0 && !(t[n].type === "softbreak" || t[n].type === "hardbreak"); n--)
            if (t[n].content) {
              p = t[n].content.charCodeAt(t[n].content.length - 1);
              break;
            }
        let m = 32;
        if (u < c)
          m = a.charCodeAt(u);
        else
          for (n = r + 1; n < t.length && !(t[n].type === "softbreak" || t[n].type === "hardbreak"); n++)
            if (t[n].content) {
              m = t[n].content.charCodeAt(0);
              break;
            }
        const _ = ei(p) || Qr(String.fromCharCode(p)), y = ei(m) || Qr(String.fromCharCode(m)), b = Xr(p), g = Xr(m);
        if (g ? h = !1 : y && (b || _ || (h = !1)), b ? f = !1 : _ && (g || y || (f = !1)), m === 34 && l[0] === '"' && p >= 48 && p <= 57 && (f = h = !1), h && f && (h = _, f = y), !h && !f) {
          d && (s.content = ki(s.content, l.index, Uu));
          continue;
        }
        if (f)
          for (n = i.length - 1; n >= 0; n--) {
            let v = i[n];
            if (i[n].level < o)
              break;
            if (v.single === d && i[n].level === o) {
              v = i[n];
              let w, E;
              d ? (w = e.md.options.quotes[2], E = e.md.options.quotes[3]) : (w = e.md.options.quotes[0], E = e.md.options.quotes[1]), s.content = ki(s.content, l.index, E), t[v.token].content = ki(
                t[v.token].content,
                v.pos,
                w
              ), u += E.length - 1, v.token === r && (u += w.length - 1), a = s.content, c = a.length, i.length = n;
              continue e;
            }
          }
        h ? i.push({
          token: r,
          pos: l.index,
          single: d,
          level: o
        }) : f && d && (s.content = ki(s.content, l.index, Uu));
      }
  }
}
function C1(t) {
  if (t.md.options.typographer)
    for (let e = t.tokens.length - 1; e >= 0; e--)
      t.tokens[e].type !== "inline" || !A1.test(t.tokens[e].content) || E1(t.tokens[e].children, t);
}
function T1(t) {
  let e, n;
  const i = t.tokens, r = i.length;
  for (let s = 0; s < r; s++) {
    if (i[s].type !== "inline") continue;
    const o = i[s].children, a = o.length;
    for (e = 0; e < a; e++)
      o[e].type === "text_special" && (o[e].type = "text");
    for (e = n = 0; e < a; e++)
      o[e].type === "text" && e + 1 < a && o[e + 1].type === "text" ? o[e + 1].content = o[e].content + o[e + 1].content : (e !== n && (o[n] = o[e]), n++);
    e !== n && (o.length = n);
  }
}
const Zs = [
  ["normalize", f1],
  ["block", d1],
  ["inline", p1],
  ["linkify", b1],
  ["replacements", S1],
  ["smartquotes", C1],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", T1]
];
function Oa() {
  this.ruler = new at();
  for (let t = 0; t < Zs.length; t++)
    this.ruler.push(Zs[t][0], Zs[t][1]);
}
Oa.prototype.process = function(t) {
  const e = this.ruler.getRules("");
  for (let n = 0, i = e.length; n < i; n++)
    e[n](t);
};
Oa.prototype.State = Ph;
function Zt(t, e, n, i) {
  this.src = t, this.md = e, this.env = n, this.tokens = i, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const r = this.src;
  for (let s = 0, o = 0, a = 0, u = 0, c = r.length, l = !1; o < c; o++) {
    const h = r.charCodeAt(o);
    if (!l)
      if (Oe(h)) {
        a++, h === 9 ? u += 4 - u % 4 : u++;
        continue;
      } else
        l = !0;
    (h === 10 || o === c - 1) && (h !== 10 && o++, this.bMarks.push(s), this.eMarks.push(o), this.tShift.push(a), this.sCount.push(u), this.bsCount.push(0), l = !1, a = 0, u = 0, s = o + 1);
  }
  this.bMarks.push(r.length), this.eMarks.push(r.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
Zt.prototype.push = function(t, e, n) {
  const i = new Tt(t, e, n);
  return i.block = !0, n < 0 && this.level--, i.level = this.level, n > 0 && this.level++, this.tokens.push(i), i;
};
Zt.prototype.isEmpty = function(e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
Zt.prototype.skipEmptyLines = function(e) {
  for (let n = this.lineMax; e < n && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++)
    ;
  return e;
};
Zt.prototype.skipSpaces = function(e) {
  for (let n = this.src.length; e < n; e++) {
    const i = this.src.charCodeAt(e);
    if (!Oe(i))
      break;
  }
  return e;
};
Zt.prototype.skipSpacesBack = function(e, n) {
  if (e <= n)
    return e;
  for (; e > n; )
    if (!Oe(this.src.charCodeAt(--e)))
      return e + 1;
  return e;
};
Zt.prototype.skipChars = function(e, n) {
  for (let i = this.src.length; e < i && this.src.charCodeAt(e) === n; e++)
    ;
  return e;
};
Zt.prototype.skipCharsBack = function(e, n, i) {
  if (e <= i)
    return e;
  for (; e > i; )
    if (n !== this.src.charCodeAt(--e))
      return e + 1;
  return e;
};
Zt.prototype.getLines = function(e, n, i, r) {
  if (e >= n)
    return "";
  const s = new Array(n - e);
  for (let o = 0, a = e; a < n; a++, o++) {
    let u = 0;
    const c = this.bMarks[a];
    let l = c, h;
    for (a + 1 < n || r ? h = this.eMarks[a] + 1 : h = this.eMarks[a]; l < h && u < i; ) {
      const f = this.src.charCodeAt(l);
      if (Oe(f))
        f === 9 ? u += 4 - (u + this.bsCount[a]) % 4 : u++;
      else if (l - c < this.tShift[a])
        u++;
      else
        break;
      l++;
    }
    u > i ? s[o] = new Array(u - i + 1).join(" ") + this.src.slice(l, h) : s[o] = this.src.slice(l, h);
  }
  return s.join("");
};
Zt.prototype.Token = Tt;
const D1 = 65536;
function Js(t, e) {
  const n = t.bMarks[e] + t.tShift[e], i = t.eMarks[e];
  return t.src.slice(n, i);
}
function Hu(t) {
  const e = [], n = t.length;
  let i = 0, r = t.charCodeAt(i), s = !1, o = 0, a = "";
  for (; i < n; )
    r === 124 && (s ? (a += t.substring(o, i - 1), o = i) : (e.push(a + t.substring(o, i)), a = "", o = i + 1)), s = r === 92, i++, r = t.charCodeAt(i);
  return e.push(a + t.substring(o)), e;
}
function F1(t, e, n, i) {
  if (e + 2 > n)
    return !1;
  let r = e + 1;
  if (t.sCount[r] < t.blkIndent || t.sCount[r] - t.blkIndent >= 4)
    return !1;
  let s = t.bMarks[r] + t.tShift[r];
  if (s >= t.eMarks[r])
    return !1;
  const o = t.src.charCodeAt(s++);
  if (o !== 124 && o !== 45 && o !== 58 || s >= t.eMarks[r])
    return !1;
  const a = t.src.charCodeAt(s++);
  if (a !== 124 && a !== 45 && a !== 58 && !Oe(a) || o === 45 && Oe(a))
    return !1;
  for (; s < t.eMarks[r]; ) {
    const v = t.src.charCodeAt(s);
    if (v !== 124 && v !== 45 && v !== 58 && !Oe(v))
      return !1;
    s++;
  }
  let u = Js(t, e + 1), c = u.split("|");
  const l = [];
  for (let v = 0; v < c.length; v++) {
    const w = c[v].trim();
    if (!w) {
      if (v === 0 || v === c.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(w))
      return !1;
    w.charCodeAt(w.length - 1) === 58 ? l.push(w.charCodeAt(0) === 58 ? "center" : "right") : w.charCodeAt(0) === 58 ? l.push("left") : l.push("");
  }
  if (u = Js(t, e).trim(), u.indexOf("|") === -1 || t.sCount[e] - t.blkIndent >= 4)
    return !1;
  c = Hu(u), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop();
  const h = c.length;
  if (h === 0 || h !== l.length)
    return !1;
  if (i)
    return !0;
  const f = t.parentType;
  t.parentType = "table";
  const d = t.md.block.ruler.getRules("blockquote"), p = t.push("table_open", "table", 1), m = [e, 0];
  p.map = m;
  const _ = t.push("thead_open", "thead", 1);
  _.map = [e, e + 1];
  const y = t.push("tr_open", "tr", 1);
  y.map = [e, e + 1];
  for (let v = 0; v < c.length; v++) {
    const w = t.push("th_open", "th", 1);
    l[v] && (w.attrs = [["style", "text-align:" + l[v]]]);
    const E = t.push("inline", "", 0);
    E.content = c[v].trim(), E.children = [], t.push("th_close", "th", -1);
  }
  t.push("tr_close", "tr", -1), t.push("thead_close", "thead", -1);
  let b, g = 0;
  for (r = e + 2; r < n && !(t.sCount[r] < t.blkIndent); r++) {
    let v = !1;
    for (let E = 0, A = d.length; E < A; E++)
      if (d[E](t, r, n, !0)) {
        v = !0;
        break;
      }
    if (v || (u = Js(t, r).trim(), !u) || t.sCount[r] - t.blkIndent >= 4 || (c = Hu(u), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop(), g += h - c.length, g > D1))
      break;
    if (r === e + 2) {
      const E = t.push("tbody_open", "tbody", 1);
      E.map = b = [e + 2, 0];
    }
    const w = t.push("tr_open", "tr", 1);
    w.map = [r, r + 1];
    for (let E = 0; E < h; E++) {
      const A = t.push("td_open", "td", 1);
      l[E] && (A.attrs = [["style", "text-align:" + l[E]]]);
      const C = t.push("inline", "", 0);
      C.content = c[E] ? c[E].trim() : "", C.children = [], t.push("td_close", "td", -1);
    }
    t.push("tr_close", "tr", -1);
  }
  return b && (t.push("tbody_close", "tbody", -1), b[1] = r), t.push("table_close", "table", -1), m[1] = r, t.parentType = f, t.line = r, !0;
}
function O1(t, e, n) {
  if (t.sCount[e] - t.blkIndent < 4)
    return !1;
  let i = e + 1, r = i;
  for (; i < n; ) {
    if (t.isEmpty(i)) {
      i++;
      continue;
    }
    if (t.sCount[i] - t.blkIndent >= 4) {
      i++, r = i;
      continue;
    }
    break;
  }
  t.line = r;
  const s = t.push("code_block", "code", 0);
  return s.content = t.getLines(e, r, 4 + t.blkIndent, !1) + `
`, s.map = [e, t.line], !0;
}
function I1(t, e, n, i) {
  let r = t.bMarks[e] + t.tShift[e], s = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4 || r + 3 > s)
    return !1;
  const o = t.src.charCodeAt(r);
  if (o !== 126 && o !== 96)
    return !1;
  let a = r;
  r = t.skipChars(r, o);
  let u = r - a;
  if (u < 3)
    return !1;
  const c = t.src.slice(a, r), l = t.src.slice(r, s);
  if (o === 96 && l.indexOf(String.fromCharCode(o)) >= 0)
    return !1;
  if (i)
    return !0;
  let h = e, f = !1;
  for (; h++, !(h >= n || (r = a = t.bMarks[h] + t.tShift[h], s = t.eMarks[h], r < s && t.sCount[h] < t.blkIndent)); )
    if (t.src.charCodeAt(r) === o && !(t.sCount[h] - t.blkIndent >= 4) && (r = t.skipChars(r, o), !(r - a < u) && (r = t.skipSpaces(r), !(r < s)))) {
      f = !0;
      break;
    }
  u = t.sCount[e], t.line = h + (f ? 1 : 0);
  const d = t.push("fence", "code", 0);
  return d.info = l, d.content = t.getLines(e + 1, h, u, !0), d.markup = c, d.map = [e, t.line], !0;
}
function P1(t, e, n, i) {
  let r = t.bMarks[e] + t.tShift[e], s = t.eMarks[e];
  const o = t.lineMax;
  if (t.sCount[e] - t.blkIndent >= 4 || t.src.charCodeAt(r) !== 62)
    return !1;
  if (i)
    return !0;
  const a = [], u = [], c = [], l = [], h = t.md.block.ruler.getRules("blockquote"), f = t.parentType;
  t.parentType = "blockquote";
  let d = !1, p;
  for (p = e; p < n; p++) {
    const g = t.sCount[p] < t.blkIndent;
    if (r = t.bMarks[p] + t.tShift[p], s = t.eMarks[p], r >= s)
      break;
    if (t.src.charCodeAt(r++) === 62 && !g) {
      let w = t.sCount[p] + 1, E, A;
      t.src.charCodeAt(r) === 32 ? (r++, w++, A = !1, E = !0) : t.src.charCodeAt(r) === 9 ? (E = !0, (t.bsCount[p] + w) % 4 === 3 ? (r++, w++, A = !1) : A = !0) : E = !1;
      let C = w;
      for (a.push(t.bMarks[p]), t.bMarks[p] = r; r < s; ) {
        const O = t.src.charCodeAt(r);
        if (Oe(O))
          O === 9 ? C += 4 - (C + t.bsCount[p] + (A ? 1 : 0)) % 4 : C++;
        else
          break;
        r++;
      }
      d = r >= s, u.push(t.bsCount[p]), t.bsCount[p] = t.sCount[p] + 1 + (E ? 1 : 0), c.push(t.sCount[p]), t.sCount[p] = C - w, l.push(t.tShift[p]), t.tShift[p] = r - t.bMarks[p];
      continue;
    }
    if (d)
      break;
    let v = !1;
    for (let w = 0, E = h.length; w < E; w++)
      if (h[w](t, p, n, !0)) {
        v = !0;
        break;
      }
    if (v) {
      t.lineMax = p, t.blkIndent !== 0 && (a.push(t.bMarks[p]), u.push(t.bsCount[p]), l.push(t.tShift[p]), c.push(t.sCount[p]), t.sCount[p] -= t.blkIndent);
      break;
    }
    a.push(t.bMarks[p]), u.push(t.bsCount[p]), l.push(t.tShift[p]), c.push(t.sCount[p]), t.sCount[p] = -1;
  }
  const m = t.blkIndent;
  t.blkIndent = 0;
  const _ = t.push("blockquote_open", "blockquote", 1);
  _.markup = ">";
  const y = [e, 0];
  _.map = y, t.md.block.tokenize(t, e, p);
  const b = t.push("blockquote_close", "blockquote", -1);
  b.markup = ">", t.lineMax = o, t.parentType = f, y[1] = t.line;
  for (let g = 0; g < l.length; g++)
    t.bMarks[g + e] = a[g], t.tShift[g + e] = l[g], t.sCount[g + e] = c[g], t.bsCount[g + e] = u[g];
  return t.blkIndent = m, !0;
}
function R1(t, e, n, i) {
  const r = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  let s = t.bMarks[e] + t.tShift[e];
  const o = t.src.charCodeAt(s++);
  if (o !== 42 && o !== 45 && o !== 95)
    return !1;
  let a = 1;
  for (; s < r; ) {
    const c = t.src.charCodeAt(s++);
    if (c !== o && !Oe(c))
      return !1;
    c === o && a++;
  }
  if (a < 3)
    return !1;
  if (i)
    return !0;
  t.line = e + 1;
  const u = t.push("hr", "hr", 0);
  return u.map = [e, t.line], u.markup = Array(a + 1).join(String.fromCharCode(o)), !0;
}
function qu(t, e) {
  const n = t.eMarks[e];
  let i = t.bMarks[e] + t.tShift[e];
  const r = t.src.charCodeAt(i++);
  if (r !== 42 && r !== 45 && r !== 43)
    return -1;
  if (i < n) {
    const s = t.src.charCodeAt(i);
    if (!Oe(s))
      return -1;
  }
  return i;
}
function Wu(t, e) {
  const n = t.bMarks[e] + t.tShift[e], i = t.eMarks[e];
  let r = n;
  if (r + 1 >= i)
    return -1;
  let s = t.src.charCodeAt(r++);
  if (s < 48 || s > 57)
    return -1;
  for (; ; ) {
    if (r >= i)
      return -1;
    if (s = t.src.charCodeAt(r++), s >= 48 && s <= 57) {
      if (r - n >= 10)
        return -1;
      continue;
    }
    if (s === 41 || s === 46)
      break;
    return -1;
  }
  return r < i && (s = t.src.charCodeAt(r), !Oe(s)) ? -1 : r;
}
function L1(t, e) {
  const n = t.level + 2;
  for (let i = e + 2, r = t.tokens.length - 2; i < r; i++)
    t.tokens[i].level === n && t.tokens[i].type === "paragraph_open" && (t.tokens[i + 2].hidden = !0, t.tokens[i].hidden = !0, i += 2);
}
function M1(t, e, n, i) {
  let r, s, o, a, u = e, c = !0;
  if (t.sCount[u] - t.blkIndent >= 4 || t.listIndent >= 0 && t.sCount[u] - t.listIndent >= 4 && t.sCount[u] < t.blkIndent)
    return !1;
  let l = !1;
  i && t.parentType === "paragraph" && t.sCount[u] >= t.blkIndent && (l = !0);
  let h, f, d;
  if ((d = Wu(t, u)) >= 0) {
    if (h = !0, o = t.bMarks[u] + t.tShift[u], f = Number(t.src.slice(o, d - 1)), l && f !== 1) return !1;
  } else if ((d = qu(t, u)) >= 0)
    h = !1;
  else
    return !1;
  if (l && t.skipSpaces(d) >= t.eMarks[u])
    return !1;
  if (i)
    return !0;
  const p = t.src.charCodeAt(d - 1), m = t.tokens.length;
  h ? (a = t.push("ordered_list_open", "ol", 1), f !== 1 && (a.attrs = [["start", f]])) : a = t.push("bullet_list_open", "ul", 1);
  const _ = [u, 0];
  a.map = _, a.markup = String.fromCharCode(p);
  let y = !1;
  const b = t.md.block.ruler.getRules("list"), g = t.parentType;
  for (t.parentType = "list"; u < n; ) {
    s = d, r = t.eMarks[u];
    const v = t.sCount[u] + d - (t.bMarks[u] + t.tShift[u]);
    let w = v;
    for (; s < r; ) {
      const I = t.src.charCodeAt(s);
      if (I === 9)
        w += 4 - (w + t.bsCount[u]) % 4;
      else if (I === 32)
        w++;
      else
        break;
      s++;
    }
    const E = s;
    let A;
    E >= r ? A = 1 : A = w - v, A > 4 && (A = 1);
    const C = v + A;
    a = t.push("list_item_open", "li", 1), a.markup = String.fromCharCode(p);
    const O = [u, 0];
    a.map = O, h && (a.info = t.src.slice(o, d - 1));
    const R = t.tight, P = t.tShift[u], k = t.sCount[u], S = t.listIndent;
    if (t.listIndent = t.blkIndent, t.blkIndent = C, t.tight = !0, t.tShift[u] = E - t.bMarks[u], t.sCount[u] = w, E >= r && t.isEmpty(u + 1) ? t.line = Math.min(t.line + 2, n) : t.md.block.tokenize(t, u, n, !0), (!t.tight || y) && (c = !1), y = t.line - u > 1 && t.isEmpty(t.line - 1), t.blkIndent = t.listIndent, t.listIndent = S, t.tShift[u] = P, t.sCount[u] = k, t.tight = R, a = t.push("list_item_close", "li", -1), a.markup = String.fromCharCode(p), u = t.line, O[1] = u, u >= n || t.sCount[u] < t.blkIndent || t.sCount[u] - t.blkIndent >= 4)
      break;
    let x = !1;
    for (let I = 0, F = b.length; I < F; I++)
      if (b[I](t, u, n, !0)) {
        x = !0;
        break;
      }
    if (x)
      break;
    if (h) {
      if (d = Wu(t, u), d < 0)
        break;
      o = t.bMarks[u] + t.tShift[u];
    } else if (d = qu(t, u), d < 0)
      break;
    if (p !== t.src.charCodeAt(d - 1))
      break;
  }
  return h ? a = t.push("ordered_list_close", "ol", -1) : a = t.push("bullet_list_close", "ul", -1), a.markup = String.fromCharCode(p), _[1] = u, t.line = u, t.parentType = g, c && L1(t, m), !0;
}
function j1(t, e, n, i) {
  let r = t.bMarks[e] + t.tShift[e], s = t.eMarks[e], o = e + 1;
  if (t.sCount[e] - t.blkIndent >= 4 || t.src.charCodeAt(r) !== 91)
    return !1;
  function a(b) {
    const g = t.lineMax;
    if (b >= g || t.isEmpty(b))
      return null;
    let v = !1;
    if (t.sCount[b] - t.blkIndent > 3 && (v = !0), t.sCount[b] < 0 && (v = !0), !v) {
      const A = t.md.block.ruler.getRules("reference"), C = t.parentType;
      t.parentType = "reference";
      let O = !1;
      for (let R = 0, P = A.length; R < P; R++)
        if (A[R](t, b, g, !0)) {
          O = !0;
          break;
        }
      if (t.parentType = C, O)
        return null;
    }
    const w = t.bMarks[b] + t.tShift[b], E = t.eMarks[b];
    return t.src.slice(w, E + 1);
  }
  let u = t.src.slice(r, s + 1);
  s = u.length;
  let c = -1;
  for (r = 1; r < s; r++) {
    const b = u.charCodeAt(r);
    if (b === 91)
      return !1;
    if (b === 93) {
      c = r;
      break;
    } else if (b === 10) {
      const g = a(o);
      g !== null && (u += g, s = u.length, o++);
    } else if (b === 92 && (r++, r < s && u.charCodeAt(r) === 10)) {
      const g = a(o);
      g !== null && (u += g, s = u.length, o++);
    }
  }
  if (c < 0 || u.charCodeAt(c + 1) !== 58)
    return !1;
  for (r = c + 2; r < s; r++) {
    const b = u.charCodeAt(r);
    if (b === 10) {
      const g = a(o);
      g !== null && (u += g, s = u.length, o++);
    } else if (!Oe(b)) break;
  }
  const l = t.md.helpers.parseLinkDestination(u, r, s);
  if (!l.ok)
    return !1;
  const h = t.md.normalizeLink(l.str);
  if (!t.md.validateLink(h))
    return !1;
  r = l.pos;
  const f = r, d = o, p = r;
  for (; r < s; r++) {
    const b = u.charCodeAt(r);
    if (b === 10) {
      const g = a(o);
      g !== null && (u += g, s = u.length, o++);
    } else if (!Oe(b)) break;
  }
  let m = t.md.helpers.parseLinkTitle(u, r, s);
  for (; m.can_continue; ) {
    const b = a(o);
    if (b === null) break;
    u += b, r = s, s = u.length, o++, m = t.md.helpers.parseLinkTitle(u, r, s, m);
  }
  let _;
  for (r < s && p !== r && m.ok ? (_ = m.str, r = m.pos) : (_ = "", r = f, o = d); r < s; ) {
    const b = u.charCodeAt(r);
    if (!Oe(b))
      break;
    r++;
  }
  if (r < s && u.charCodeAt(r) !== 10 && _)
    for (_ = "", r = f, o = d; r < s; ) {
      const b = u.charCodeAt(r);
      if (!Oe(b))
        break;
      r++;
    }
  if (r < s && u.charCodeAt(r) !== 10)
    return !1;
  const y = ws(u.slice(1, c));
  return y ? (i || (typeof t.env.references > "u" && (t.env.references = {}), typeof t.env.references[y] > "u" && (t.env.references[y] = { title: _, href: h }), t.line = o), !0) : !1;
}
const N1 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], B1 = "[a-zA-Z_:][a-zA-Z0-9:._-]*", $1 = "[^\"'=<>`\\x00-\\x20]+", z1 = "'[^']*'", U1 = '"[^"]*"', H1 = "(?:" + $1 + "|" + z1 + "|" + U1 + ")", q1 = "(?:\\s+" + B1 + "(?:\\s*=\\s*" + H1 + ")?)", Lh = "<[A-Za-z][A-Za-z0-9\\-]*" + q1 + "*\\s*\\/?>", Mh = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", W1 = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", V1 = "<[?][\\s\\S]*?[?]>", G1 = "<![A-Za-z][^>]*>", K1 = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", Z1 = new RegExp("^(?:" + Lh + "|" + Mh + "|" + W1 + "|" + V1 + "|" + G1 + "|" + K1 + ")"), J1 = new RegExp("^(?:" + Lh + "|" + Mh + ")"), ar = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + N1.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(J1.source + "\\s*$"), /^$/, !1]
];
function Y1(t, e, n, i) {
  let r = t.bMarks[e] + t.tShift[e], s = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4 || !t.md.options.html || t.src.charCodeAt(r) !== 60)
    return !1;
  let o = t.src.slice(r, s), a = 0;
  for (; a < ar.length && !ar[a][0].test(o); a++)
    ;
  if (a === ar.length)
    return !1;
  if (i)
    return ar[a][2];
  let u = e + 1;
  if (!ar[a][1].test(o)) {
    for (; u < n && !(t.sCount[u] < t.blkIndent); u++)
      if (r = t.bMarks[u] + t.tShift[u], s = t.eMarks[u], o = t.src.slice(r, s), ar[a][1].test(o)) {
        o.length !== 0 && u++;
        break;
      }
  }
  t.line = u;
  const c = t.push("html_block", "", 0);
  return c.map = [e, u], c.content = t.getLines(e, u, t.blkIndent, !0), !0;
}
function X1(t, e, n, i) {
  let r = t.bMarks[e] + t.tShift[e], s = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  let o = t.src.charCodeAt(r);
  if (o !== 35 || r >= s)
    return !1;
  let a = 1;
  for (o = t.src.charCodeAt(++r); o === 35 && r < s && a <= 6; )
    a++, o = t.src.charCodeAt(++r);
  if (a > 6 || r < s && !Oe(o))
    return !1;
  if (i)
    return !0;
  s = t.skipSpacesBack(s, r);
  const u = t.skipCharsBack(s, 35, r);
  u > r && Oe(t.src.charCodeAt(u - 1)) && (s = u), t.line = e + 1;
  const c = t.push("heading_open", "h" + String(a), 1);
  c.markup = "########".slice(0, a), c.map = [e, t.line];
  const l = t.push("inline", "", 0);
  l.content = t.src.slice(r, s).trim(), l.map = [e, t.line], l.children = [];
  const h = t.push("heading_close", "h" + String(a), -1);
  return h.markup = "########".slice(0, a), !0;
}
function Q1(t, e, n) {
  const i = t.md.block.ruler.getRules("paragraph");
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  const r = t.parentType;
  t.parentType = "paragraph";
  let s = 0, o, a = e + 1;
  for (; a < n && !t.isEmpty(a); a++) {
    if (t.sCount[a] - t.blkIndent > 3)
      continue;
    if (t.sCount[a] >= t.blkIndent) {
      let d = t.bMarks[a] + t.tShift[a];
      const p = t.eMarks[a];
      if (d < p && (o = t.src.charCodeAt(d), (o === 45 || o === 61) && (d = t.skipChars(d, o), d = t.skipSpaces(d), d >= p))) {
        s = o === 61 ? 1 : 2;
        break;
      }
    }
    if (t.sCount[a] < 0)
      continue;
    let f = !1;
    for (let d = 0, p = i.length; d < p; d++)
      if (i[d](t, a, n, !0)) {
        f = !0;
        break;
      }
    if (f)
      break;
  }
  if (!s)
    return !1;
  const u = t.getLines(e, a, t.blkIndent, !1).trim();
  t.line = a + 1;
  const c = t.push("heading_open", "h" + String(s), 1);
  c.markup = String.fromCharCode(o), c.map = [e, t.line];
  const l = t.push("inline", "", 0);
  l.content = u, l.map = [e, t.line - 1], l.children = [];
  const h = t.push("heading_close", "h" + String(s), -1);
  return h.markup = String.fromCharCode(o), t.parentType = r, !0;
}
function eb(t, e, n) {
  const i = t.md.block.ruler.getRules("paragraph"), r = t.parentType;
  let s = e + 1;
  for (t.parentType = "paragraph"; s < n && !t.isEmpty(s); s++) {
    if (t.sCount[s] - t.blkIndent > 3 || t.sCount[s] < 0)
      continue;
    let c = !1;
    for (let l = 0, h = i.length; l < h; l++)
      if (i[l](t, s, n, !0)) {
        c = !0;
        break;
      }
    if (c)
      break;
  }
  const o = t.getLines(e, s, t.blkIndent, !1).trim();
  t.line = s;
  const a = t.push("paragraph_open", "p", 1);
  a.map = [e, t.line];
  const u = t.push("inline", "", 0);
  return u.content = o, u.map = [e, t.line], u.children = [], t.push("paragraph_close", "p", -1), t.parentType = r, !0;
}
const Si = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", F1, ["paragraph", "reference"]],
  ["code", O1],
  ["fence", I1, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", P1, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", R1, ["paragraph", "reference", "blockquote", "list"]],
  ["list", M1, ["paragraph", "reference", "blockquote"]],
  ["reference", j1],
  ["html_block", Y1, ["paragraph", "reference", "blockquote"]],
  ["heading", X1, ["paragraph", "reference", "blockquote"]],
  ["lheading", Q1],
  ["paragraph", eb]
];
function xs() {
  this.ruler = new at();
  for (let t = 0; t < Si.length; t++)
    this.ruler.push(Si[t][0], Si[t][1], { alt: (Si[t][2] || []).slice() });
}
xs.prototype.tokenize = function(t, e, n) {
  const i = this.ruler.getRules(""), r = i.length, s = t.md.options.maxNesting;
  let o = e, a = !1;
  for (; o < n && (t.line = o = t.skipEmptyLines(o), !(o >= n || t.sCount[o] < t.blkIndent)); ) {
    if (t.level >= s) {
      t.line = n;
      break;
    }
    const u = t.line;
    let c = !1;
    for (let l = 0; l < r; l++)
      if (c = i[l](t, o, n, !1), c) {
        if (u >= t.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!c) throw new Error("none of the block rules matched");
    t.tight = !a, t.isEmpty(t.line - 1) && (a = !0), o = t.line, o < n && t.isEmpty(o) && (a = !0, o++, t.line = o);
  }
};
xs.prototype.parse = function(t, e, n, i) {
  if (!t)
    return;
  const r = new this.State(t, e, n, i);
  this.tokenize(r, r.line, r.lineMax);
};
xs.prototype.State = Zt;
function ci(t, e, n, i) {
  this.src = t, this.env = n, this.md = e, this.tokens = i, this.tokens_meta = Array(i.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
ci.prototype.pushPending = function() {
  const t = new Tt("text", "", 0);
  return t.content = this.pending, t.level = this.pendingLevel, this.tokens.push(t), this.pending = "", t;
};
ci.prototype.push = function(t, e, n) {
  this.pending && this.pushPending();
  const i = new Tt(t, e, n);
  let r = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), i.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], r = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(i), this.tokens_meta.push(r), i;
};
ci.prototype.scanDelims = function(t, e) {
  const n = this.posMax, i = this.src.charCodeAt(t), r = t > 0 ? this.src.charCodeAt(t - 1) : 32;
  let s = t;
  for (; s < n && this.src.charCodeAt(s) === i; )
    s++;
  const o = s - t, a = s < n ? this.src.charCodeAt(s) : 32, u = ei(r) || Qr(String.fromCharCode(r)), c = ei(a) || Qr(String.fromCharCode(a)), l = Xr(r), h = Xr(a), f = !h && (!c || l || u), d = !l && (!u || h || c);
  return { can_open: f && (e || !d || u), can_close: d && (e || !f || c), length: o };
};
ci.prototype.Token = Tt;
function tb(t) {
  switch (t) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function nb(t, e) {
  let n = t.pos;
  for (; n < t.posMax && !tb(t.src.charCodeAt(n)); )
    n++;
  return n === t.pos ? !1 : (e || (t.pending += t.src.slice(t.pos, n)), t.pos = n, !0);
}
const rb = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function ib(t, e) {
  if (!t.md.options.linkify || t.linkLevel > 0) return !1;
  const n = t.pos, i = t.posMax;
  if (n + 3 > i || t.src.charCodeAt(n) !== 58 || t.src.charCodeAt(n + 1) !== 47 || t.src.charCodeAt(n + 2) !== 47) return !1;
  const r = t.pending.match(rb);
  if (!r) return !1;
  const s = r[1], o = t.md.linkify.matchAtStart(t.src.slice(n - s.length));
  if (!o) return !1;
  let a = o.url;
  if (a.length <= s.length) return !1;
  a = a.replace(/\*+$/, "");
  const u = t.md.normalizeLink(a);
  if (!t.md.validateLink(u)) return !1;
  if (!e) {
    t.pending = t.pending.slice(0, -s.length);
    const c = t.push("link_open", "a", 1);
    c.attrs = [["href", u]], c.markup = "linkify", c.info = "auto";
    const l = t.push("text", "", 0);
    l.content = t.md.normalizeLinkText(a);
    const h = t.push("link_close", "a", -1);
    h.markup = "linkify", h.info = "auto";
  }
  return t.pos += a.length - s.length, !0;
}
function sb(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 10)
    return !1;
  const i = t.pending.length - 1, r = t.posMax;
  if (!e)
    if (i >= 0 && t.pending.charCodeAt(i) === 32)
      if (i >= 1 && t.pending.charCodeAt(i - 1) === 32) {
        let s = i - 1;
        for (; s >= 1 && t.pending.charCodeAt(s - 1) === 32; ) s--;
        t.pending = t.pending.slice(0, s), t.push("hardbreak", "br", 0);
      } else
        t.pending = t.pending.slice(0, -1), t.push("softbreak", "br", 0);
    else
      t.push("softbreak", "br", 0);
  for (n++; n < r && Oe(t.src.charCodeAt(n)); )
    n++;
  return t.pos = n, !0;
}
const Ia = [];
for (let t = 0; t < 256; t++)
  Ia.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(t) {
  Ia[t.charCodeAt(0)] = 1;
});
function ob(t, e) {
  let n = t.pos;
  const i = t.posMax;
  if (t.src.charCodeAt(n) !== 92 || (n++, n >= i)) return !1;
  let r = t.src.charCodeAt(n);
  if (r === 10) {
    for (e || t.push("hardbreak", "br", 0), n++; n < i && (r = t.src.charCodeAt(n), !!Oe(r)); )
      n++;
    return t.pos = n, !0;
  }
  let s = t.src[n];
  if (r >= 55296 && r <= 56319 && n + 1 < i) {
    const a = t.src.charCodeAt(n + 1);
    a >= 56320 && a <= 57343 && (s += t.src[n + 1], n++);
  }
  const o = "\\" + s;
  if (!e) {
    const a = t.push("text_special", "", 0);
    r < 256 && Ia[r] !== 0 ? a.content = s : a.content = o, a.markup = o, a.info = "escape";
  }
  return t.pos = n + 1, !0;
}
function ab(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 96)
    return !1;
  const r = n;
  n++;
  const s = t.posMax;
  for (; n < s && t.src.charCodeAt(n) === 96; )
    n++;
  const o = t.src.slice(r, n), a = o.length;
  if (t.backticksScanned && (t.backticks[a] || 0) <= r)
    return e || (t.pending += o), t.pos += a, !0;
  let u = n, c;
  for (; (c = t.src.indexOf("`", u)) !== -1; ) {
    for (u = c + 1; u < s && t.src.charCodeAt(u) === 96; )
      u++;
    const l = u - c;
    if (l === a) {
      if (!e) {
        const h = t.push("code_inline", "code", 0);
        h.markup = o, h.content = t.src.slice(n, c).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return t.pos = u, !0;
    }
    t.backticks[l] = c;
  }
  return t.backticksScanned = !0, e || (t.pending += o), t.pos += a, !0;
}
function ub(t, e) {
  const n = t.pos, i = t.src.charCodeAt(n);
  if (e || i !== 126)
    return !1;
  const r = t.scanDelims(t.pos, !0);
  let s = r.length;
  const o = String.fromCharCode(i);
  if (s < 2)
    return !1;
  let a;
  s % 2 && (a = t.push("text", "", 0), a.content = o, s--);
  for (let u = 0; u < s; u += 2)
    a = t.push("text", "", 0), a.content = o + o, t.delimiters.push({
      marker: i,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: t.tokens.length - 1,
      end: -1,
      open: r.can_open,
      close: r.can_close
    });
  return t.pos += r.length, !0;
}
function Vu(t, e) {
  let n;
  const i = [], r = e.length;
  for (let s = 0; s < r; s++) {
    const o = e[s];
    if (o.marker !== 126 || o.end === -1)
      continue;
    const a = e[o.end];
    n = t.tokens[o.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = t.tokens[a.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", t.tokens[a.token - 1].type === "text" && t.tokens[a.token - 1].content === "~" && i.push(a.token - 1);
  }
  for (; i.length; ) {
    const s = i.pop();
    let o = s + 1;
    for (; o < t.tokens.length && t.tokens[o].type === "s_close"; )
      o++;
    o--, s !== o && (n = t.tokens[o], t.tokens[o] = t.tokens[s], t.tokens[s] = n);
  }
}
function cb(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  Vu(t, t.delimiters);
  for (let i = 0; i < n; i++)
    e[i] && e[i].delimiters && Vu(t, e[i].delimiters);
}
const jh = {
  tokenize: ub,
  postProcess: cb
};
function lb(t, e) {
  const n = t.pos, i = t.src.charCodeAt(n);
  if (e || i !== 95 && i !== 42)
    return !1;
  const r = t.scanDelims(t.pos, i === 42);
  for (let s = 0; s < r.length; s++) {
    const o = t.push("text", "", 0);
    o.content = String.fromCharCode(i), t.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: i,
      // Total length of these series of delimiters.
      //
      length: r.length,
      // A position of the token this delimiter corresponds to.
      //
      token: t.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: r.can_open,
      close: r.can_close
    });
  }
  return t.pos += r.length, !0;
}
function Gu(t, e) {
  const n = e.length;
  for (let i = n - 1; i >= 0; i--) {
    const r = e[i];
    if (r.marker !== 95 && r.marker !== 42 || r.end === -1)
      continue;
    const s = e[r.end], o = i > 0 && e[i - 1].end === r.end + 1 && // check that first two markers match and adjacent
    e[i - 1].marker === r.marker && e[i - 1].token === r.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    e[r.end + 1].token === s.token + 1, a = String.fromCharCode(r.marker), u = t.tokens[r.token];
    u.type = o ? "strong_open" : "em_open", u.tag = o ? "strong" : "em", u.nesting = 1, u.markup = o ? a + a : a, u.content = "";
    const c = t.tokens[s.token];
    c.type = o ? "strong_close" : "em_close", c.tag = o ? "strong" : "em", c.nesting = -1, c.markup = o ? a + a : a, c.content = "", o && (t.tokens[e[i - 1].token].content = "", t.tokens[e[r.end + 1].token].content = "", i--);
  }
}
function hb(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  Gu(t, t.delimiters);
  for (let i = 0; i < n; i++)
    e[i] && e[i].delimiters && Gu(t, e[i].delimiters);
}
const Nh = {
  tokenize: lb,
  postProcess: hb
};
function fb(t, e) {
  let n, i, r, s, o = "", a = "", u = t.pos, c = !0;
  if (t.src.charCodeAt(t.pos) !== 91)
    return !1;
  const l = t.pos, h = t.posMax, f = t.pos + 1, d = t.md.helpers.parseLinkLabel(t, t.pos, !0);
  if (d < 0)
    return !1;
  let p = d + 1;
  if (p < h && t.src.charCodeAt(p) === 40) {
    for (c = !1, p++; p < h && (n = t.src.charCodeAt(p), !(!Oe(n) && n !== 10)); p++)
      ;
    if (p >= h)
      return !1;
    if (u = p, r = t.md.helpers.parseLinkDestination(t.src, p, t.posMax), r.ok) {
      for (o = t.md.normalizeLink(r.str), t.md.validateLink(o) ? p = r.pos : o = "", u = p; p < h && (n = t.src.charCodeAt(p), !(!Oe(n) && n !== 10)); p++)
        ;
      if (r = t.md.helpers.parseLinkTitle(t.src, p, t.posMax), p < h && u !== p && r.ok)
        for (a = r.str, p = r.pos; p < h && (n = t.src.charCodeAt(p), !(!Oe(n) && n !== 10)); p++)
          ;
    }
    (p >= h || t.src.charCodeAt(p) !== 41) && (c = !0), p++;
  }
  if (c) {
    if (typeof t.env.references > "u")
      return !1;
    if (p < h && t.src.charCodeAt(p) === 91 ? (u = p + 1, p = t.md.helpers.parseLinkLabel(t, p), p >= 0 ? i = t.src.slice(u, p++) : p = d + 1) : p = d + 1, i || (i = t.src.slice(f, d)), s = t.env.references[ws(i)], !s)
      return t.pos = l, !1;
    o = s.href, a = s.title;
  }
  if (!e) {
    t.pos = f, t.posMax = d;
    const m = t.push("link_open", "a", 1), _ = [["href", o]];
    m.attrs = _, a && _.push(["title", a]), t.linkLevel++, t.md.inline.tokenize(t), t.linkLevel--, t.push("link_close", "a", -1);
  }
  return t.pos = p, t.posMax = h, !0;
}
function db(t, e) {
  let n, i, r, s, o, a, u, c, l = "";
  const h = t.pos, f = t.posMax;
  if (t.src.charCodeAt(t.pos) !== 33 || t.src.charCodeAt(t.pos + 1) !== 91)
    return !1;
  const d = t.pos + 2, p = t.md.helpers.parseLinkLabel(t, t.pos + 1, !1);
  if (p < 0)
    return !1;
  if (s = p + 1, s < f && t.src.charCodeAt(s) === 40) {
    for (s++; s < f && (n = t.src.charCodeAt(s), !(!Oe(n) && n !== 10)); s++)
      ;
    if (s >= f)
      return !1;
    for (c = s, a = t.md.helpers.parseLinkDestination(t.src, s, t.posMax), a.ok && (l = t.md.normalizeLink(a.str), t.md.validateLink(l) ? s = a.pos : l = ""), c = s; s < f && (n = t.src.charCodeAt(s), !(!Oe(n) && n !== 10)); s++)
      ;
    if (a = t.md.helpers.parseLinkTitle(t.src, s, t.posMax), s < f && c !== s && a.ok)
      for (u = a.str, s = a.pos; s < f && (n = t.src.charCodeAt(s), !(!Oe(n) && n !== 10)); s++)
        ;
    else
      u = "";
    if (s >= f || t.src.charCodeAt(s) !== 41)
      return t.pos = h, !1;
    s++;
  } else {
    if (typeof t.env.references > "u")
      return !1;
    if (s < f && t.src.charCodeAt(s) === 91 ? (c = s + 1, s = t.md.helpers.parseLinkLabel(t, s), s >= 0 ? r = t.src.slice(c, s++) : s = p + 1) : s = p + 1, r || (r = t.src.slice(d, p)), o = t.env.references[ws(r)], !o)
      return t.pos = h, !1;
    l = o.href, u = o.title;
  }
  if (!e) {
    i = t.src.slice(d, p);
    const m = [];
    t.md.inline.parse(
      i,
      t.md,
      t.env,
      m
    );
    const _ = t.push("image", "img", 0), y = [["src", l], ["alt", ""]];
    _.attrs = y, _.children = m, _.content = i, u && y.push(["title", u]);
  }
  return t.pos = s, t.posMax = f, !0;
}
const pb = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, mb = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function gb(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 60)
    return !1;
  const i = t.pos, r = t.posMax;
  for (; ; ) {
    if (++n >= r) return !1;
    const o = t.src.charCodeAt(n);
    if (o === 60) return !1;
    if (o === 62) break;
  }
  const s = t.src.slice(i + 1, n);
  if (mb.test(s)) {
    const o = t.md.normalizeLink(s);
    if (!t.md.validateLink(o))
      return !1;
    if (!e) {
      const a = t.push("link_open", "a", 1);
      a.attrs = [["href", o]], a.markup = "autolink", a.info = "auto";
      const u = t.push("text", "", 0);
      u.content = t.md.normalizeLinkText(s);
      const c = t.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return t.pos += s.length + 2, !0;
  }
  if (pb.test(s)) {
    const o = t.md.normalizeLink("mailto:" + s);
    if (!t.md.validateLink(o))
      return !1;
    if (!e) {
      const a = t.push("link_open", "a", 1);
      a.attrs = [["href", o]], a.markup = "autolink", a.info = "auto";
      const u = t.push("text", "", 0);
      u.content = t.md.normalizeLinkText(s);
      const c = t.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return t.pos += s.length + 2, !0;
  }
  return !1;
}
function bb(t) {
  return /^<a[>\s]/i.test(t);
}
function _b(t) {
  return /^<\/a\s*>/i.test(t);
}
function yb(t) {
  const e = t | 32;
  return e >= 97 && e <= 122;
}
function vb(t, e) {
  if (!t.md.options.html)
    return !1;
  const n = t.posMax, i = t.pos;
  if (t.src.charCodeAt(i) !== 60 || i + 2 >= n)
    return !1;
  const r = t.src.charCodeAt(i + 1);
  if (r !== 33 && r !== 63 && r !== 47 && !yb(r))
    return !1;
  const s = t.src.slice(i).match(Z1);
  if (!s)
    return !1;
  if (!e) {
    const o = t.push("html_inline", "", 0);
    o.content = s[0], bb(o.content) && t.linkLevel++, _b(o.content) && t.linkLevel--;
  }
  return t.pos += s[0].length, !0;
}
const wb = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, xb = /^&([a-z][a-z0-9]{1,31});/i;
function kb(t, e) {
  const n = t.pos, i = t.posMax;
  if (t.src.charCodeAt(n) !== 38 || n + 1 >= i) return !1;
  if (t.src.charCodeAt(n + 1) === 35) {
    const s = t.src.slice(n).match(wb);
    if (s) {
      if (!e) {
        const o = s[1][0].toLowerCase() === "x" ? parseInt(s[1].slice(1), 16) : parseInt(s[1], 10), a = t.push("text_special", "", 0);
        a.content = Fa(o) ? is(o) : is(65533), a.markup = s[0], a.info = "entity";
      }
      return t.pos += s[0].length, !0;
    }
  } else {
    const s = t.src.slice(n).match(xb);
    if (s) {
      const o = Fh(s[0]);
      if (o !== s[0]) {
        if (!e) {
          const a = t.push("text_special", "", 0);
          a.content = o, a.markup = s[0], a.info = "entity";
        }
        return t.pos += s[0].length, !0;
      }
    }
  }
  return !1;
}
function Ku(t) {
  const e = {}, n = t.length;
  if (!n) return;
  let i = 0, r = -2;
  const s = [];
  for (let o = 0; o < n; o++) {
    const a = t[o];
    if (s.push(0), (t[i].marker !== a.marker || r !== a.token - 1) && (i = o), r = a.token, a.length = a.length || 0, !a.close) continue;
    e.hasOwnProperty(a.marker) || (e[a.marker] = [-1, -1, -1, -1, -1, -1]);
    const u = e[a.marker][(a.open ? 3 : 0) + a.length % 3];
    let c = i - s[i] - 1, l = c;
    for (; c > u; c -= s[c] + 1) {
      const h = t[c];
      if (h.marker === a.marker && h.open && h.end < 0) {
        let f = !1;
        if ((h.close || a.open) && (h.length + a.length) % 3 === 0 && (h.length % 3 !== 0 || a.length % 3 !== 0) && (f = !0), !f) {
          const d = c > 0 && !t[c - 1].open ? s[c - 1] + 1 : 0;
          s[o] = o - c + d, s[c] = d, a.open = !1, h.end = o, h.close = !1, l = -1, r = -2;
          break;
        }
      }
    }
    l !== -1 && (e[a.marker][(a.open ? 3 : 0) + (a.length || 0) % 3] = l);
  }
}
function Sb(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  Ku(t.delimiters);
  for (let i = 0; i < n; i++)
    e[i] && e[i].delimiters && Ku(e[i].delimiters);
}
function Ab(t) {
  let e, n, i = 0;
  const r = t.tokens, s = t.tokens.length;
  for (e = n = 0; e < s; e++)
    r[e].nesting < 0 && i--, r[e].level = i, r[e].nesting > 0 && i++, r[e].type === "text" && e + 1 < s && r[e + 1].type === "text" ? r[e + 1].content = r[e].content + r[e + 1].content : (e !== n && (r[n] = r[e]), n++);
  e !== n && (r.length = n);
}
const Ys = [
  ["text", nb],
  ["linkify", ib],
  ["newline", sb],
  ["escape", ob],
  ["backticks", ab],
  ["strikethrough", jh.tokenize],
  ["emphasis", Nh.tokenize],
  ["link", fb],
  ["image", db],
  ["autolink", gb],
  ["html_inline", vb],
  ["entity", kb]
], Xs = [
  ["balance_pairs", Sb],
  ["strikethrough", jh.postProcess],
  ["emphasis", Nh.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", Ab]
];
function li() {
  this.ruler = new at();
  for (let t = 0; t < Ys.length; t++)
    this.ruler.push(Ys[t][0], Ys[t][1]);
  this.ruler2 = new at();
  for (let t = 0; t < Xs.length; t++)
    this.ruler2.push(Xs[t][0], Xs[t][1]);
}
li.prototype.skipToken = function(t) {
  const e = t.pos, n = this.ruler.getRules(""), i = n.length, r = t.md.options.maxNesting, s = t.cache;
  if (typeof s[e] < "u") {
    t.pos = s[e];
    return;
  }
  let o = !1;
  if (t.level < r) {
    for (let a = 0; a < i; a++)
      if (t.level++, o = n[a](t, !0), t.level--, o) {
        if (e >= t.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    t.pos = t.posMax;
  o || t.pos++, s[e] = t.pos;
};
li.prototype.tokenize = function(t) {
  const e = this.ruler.getRules(""), n = e.length, i = t.posMax, r = t.md.options.maxNesting;
  for (; t.pos < i; ) {
    const s = t.pos;
    let o = !1;
    if (t.level < r) {
      for (let a = 0; a < n; a++)
        if (o = e[a](t, !1), o) {
          if (s >= t.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (o) {
      if (t.pos >= i)
        break;
      continue;
    }
    t.pending += t.src[t.pos++];
  }
  t.pending && t.pushPending();
};
li.prototype.parse = function(t, e, n, i) {
  const r = new this.State(t, e, n, i);
  this.tokenize(r);
  const s = this.ruler2.getRules(""), o = s.length;
  for (let a = 0; a < o; a++)
    s[a](r);
};
li.prototype.State = ci;
function Eb(t) {
  const e = {};
  t = t || {}, e.src_Any = Ah.source, e.src_Cc = Eh.source, e.src_Z = Th.source, e.src_P = Ta.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
  const n = "[><｜]";
  return e.src_pseudo_letter = "(?:(?!" + n + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + n + "|" + e.src_ZPCc + ")(?!" + (t["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (t["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
}
function zo(t) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      t[i] = n[i];
    });
  }), t;
}
function ks(t) {
  return Object.prototype.toString.call(t);
}
function Cb(t) {
  return ks(t) === "[object String]";
}
function Tb(t) {
  return ks(t) === "[object Object]";
}
function Db(t) {
  return ks(t) === "[object RegExp]";
}
function Zu(t) {
  return ks(t) === "[object Function]";
}
function Fb(t) {
  return t.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const Bh = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function Ob(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e || Bh.hasOwnProperty(n);
  }, !1);
}
const Ib = {
  "http:": {
    validate: function(t, e, n) {
      const i = t.slice(e);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(i) ? i.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(t, e, n) {
      const i = t.slice(e);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(i) ? e >= 3 && t[e - 3] === ":" || e >= 3 && t[e - 3] === "/" ? 0 : i.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(t, e, n) {
      const i = t.slice(e);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(i) ? i.match(n.re.mailto)[0].length : 0;
    }
  }
}, Pb = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", Rb = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function Lb(t) {
  t.__index__ = -1, t.__text_cache__ = "";
}
function Mb(t) {
  return function(e, n) {
    const i = e.slice(n);
    return t.test(i) ? i.match(t)[0].length : 0;
  };
}
function Ju() {
  return function(t, e) {
    e.normalize(t);
  };
}
function ss(t) {
  const e = t.re = Eb(t.__opts__), n = t.__tlds__.slice();
  t.onCompile(), t.__tlds_replaced__ || n.push(Pb), n.push(e.src_xn), e.src_tlds = n.join("|");
  function i(a) {
    return a.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(i(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(i(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(i(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(i(e.tpl_host_fuzzy_test), "i");
  const r = [];
  t.__compiled__ = {};
  function s(a, u) {
    throw new Error('(LinkifyIt) Invalid schema "' + a + '": ' + u);
  }
  Object.keys(t.__schemas__).forEach(function(a) {
    const u = t.__schemas__[a];
    if (u === null)
      return;
    const c = { validate: null, link: null };
    if (t.__compiled__[a] = c, Tb(u)) {
      Db(u.validate) ? c.validate = Mb(u.validate) : Zu(u.validate) ? c.validate = u.validate : s(a, u), Zu(u.normalize) ? c.normalize = u.normalize : u.normalize ? s(a, u) : c.normalize = Ju();
      return;
    }
    if (Cb(u)) {
      r.push(a);
      return;
    }
    s(a, u);
  }), r.forEach(function(a) {
    t.__compiled__[t.__schemas__[a]] && (t.__compiled__[a].validate = t.__compiled__[t.__schemas__[a]].validate, t.__compiled__[a].normalize = t.__compiled__[t.__schemas__[a]].normalize);
  }), t.__compiled__[""] = { validate: null, normalize: Ju() };
  const o = Object.keys(t.__compiled__).filter(function(a) {
    return a.length > 0 && t.__compiled__[a];
  }).map(Fb).join("|");
  t.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + o + ")", "i"), t.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + o + ")", "ig"), t.re.schema_at_start = RegExp("^" + t.re.schema_search.source, "i"), t.re.pretest = RegExp(
    "(" + t.re.schema_test.source + ")|(" + t.re.host_fuzzy_test.source + ")|@",
    "i"
  ), Lb(t);
}
function jb(t, e) {
  const n = t.__index__, i = t.__last_index__, r = t.__text_cache__.slice(n, i);
  this.schema = t.__schema__.toLowerCase(), this.index = n + e, this.lastIndex = i + e, this.raw = r, this.text = r, this.url = r;
}
function Uo(t, e) {
  const n = new jb(t, e);
  return t.__compiled__[n.schema].normalize(n, t), n;
}
function ht(t, e) {
  if (!(this instanceof ht))
    return new ht(t, e);
  e || Ob(t) && (e = t, t = {}), this.__opts__ = zo({}, Bh, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = zo({}, Ib, t), this.__compiled__ = {}, this.__tlds__ = Rb, this.__tlds_replaced__ = !1, this.re = {}, ss(this);
}
ht.prototype.add = function(e, n) {
  return this.__schemas__[e] = n, ss(this), this;
};
ht.prototype.set = function(e) {
  return this.__opts__ = zo(this.__opts__, e), this;
};
ht.prototype.test = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return !1;
  let n, i, r, s, o, a, u, c, l;
  if (this.re.schema_test.test(e)) {
    for (u = this.re.schema_search, u.lastIndex = 0; (n = u.exec(e)) !== null; )
      if (s = this.testSchemaAt(e, n[2], u.lastIndex), s) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + s;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (c = e.search(this.re.host_fuzzy_test), c >= 0 && (this.__index__ < 0 || c < this.__index__) && (i = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (o = i.index + i[1].length, (this.__index__ < 0 || o < this.__index__) && (this.__schema__ = "", this.__index__ = o, this.__last_index__ = i.index + i[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (l = e.indexOf("@"), l >= 0 && (r = e.match(this.re.email_fuzzy)) !== null && (o = r.index + r[1].length, a = r.index + r[0].length, (this.__index__ < 0 || o < this.__index__ || o === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = o, this.__last_index__ = a))), this.__index__ >= 0;
};
ht.prototype.pretest = function(e) {
  return this.re.pretest.test(e);
};
ht.prototype.testSchemaAt = function(e, n, i) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(e, i, this) : 0;
};
ht.prototype.match = function(e) {
  const n = [];
  let i = 0;
  this.__index__ >= 0 && this.__text_cache__ === e && (n.push(Uo(this, i)), i = this.__last_index__);
  let r = i ? e.slice(i) : e;
  for (; this.test(r); )
    n.push(Uo(this, i)), r = r.slice(this.__last_index__), i += this.__last_index__;
  return n.length ? n : null;
};
ht.prototype.matchAtStart = function(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
  const n = this.re.schema_at_start.exec(e);
  if (!n) return null;
  const i = this.testSchemaAt(e, n[2], n[0].length);
  return i ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + i, Uo(this, 0)) : null;
};
ht.prototype.tlds = function(e, n) {
  return e = Array.isArray(e) ? e : [e], n ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(i, r, s) {
    return i !== s[r - 1];
  }).reverse(), ss(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, ss(this), this);
};
ht.prototype.normalize = function(e) {
  e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
ht.prototype.onCompile = function() {
};
const _r = 2147483647, Ht = 36, Pa = 1, ti = 26, Nb = 38, Bb = 700, $h = 72, zh = 128, Uh = "-", $b = /^xn--/, zb = /[^\0-\x7F]/, Ub = /[\x2E\u3002\uFF0E\uFF61]/g, Hb = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, Qs = Ht - Pa, qt = Math.floor, eo = String.fromCharCode;
function xn(t) {
  throw new RangeError(Hb[t]);
}
function qb(t, e) {
  const n = [];
  let i = t.length;
  for (; i--; )
    n[i] = e(t[i]);
  return n;
}
function Hh(t, e) {
  const n = t.split("@");
  let i = "";
  n.length > 1 && (i = n[0] + "@", t = n[1]), t = t.replace(Ub, ".");
  const r = t.split("."), s = qb(r, e).join(".");
  return i + s;
}
function qh(t) {
  const e = [];
  let n = 0;
  const i = t.length;
  for (; n < i; ) {
    const r = t.charCodeAt(n++);
    if (r >= 55296 && r <= 56319 && n < i) {
      const s = t.charCodeAt(n++);
      (s & 64512) == 56320 ? e.push(((r & 1023) << 10) + (s & 1023) + 65536) : (e.push(r), n--);
    } else
      e.push(r);
  }
  return e;
}
const Wb = (t) => String.fromCodePoint(...t), Vb = function(t) {
  return t >= 48 && t < 58 ? 26 + (t - 48) : t >= 65 && t < 91 ? t - 65 : t >= 97 && t < 123 ? t - 97 : Ht;
}, Yu = function(t, e) {
  return t + 22 + 75 * (t < 26) - ((e != 0) << 5);
}, Wh = function(t, e, n) {
  let i = 0;
  for (t = n ? qt(t / Bb) : t >> 1, t += qt(t / e); t > Qs * ti >> 1; i += Ht)
    t = qt(t / Qs);
  return qt(i + (Qs + 1) * t / (t + Nb));
}, Vh = function(t) {
  const e = [], n = t.length;
  let i = 0, r = zh, s = $h, o = t.lastIndexOf(Uh);
  o < 0 && (o = 0);
  for (let a = 0; a < o; ++a)
    t.charCodeAt(a) >= 128 && xn("not-basic"), e.push(t.charCodeAt(a));
  for (let a = o > 0 ? o + 1 : 0; a < n; ) {
    const u = i;
    for (let l = 1, h = Ht; ; h += Ht) {
      a >= n && xn("invalid-input");
      const f = Vb(t.charCodeAt(a++));
      f >= Ht && xn("invalid-input"), f > qt((_r - i) / l) && xn("overflow"), i += f * l;
      const d = h <= s ? Pa : h >= s + ti ? ti : h - s;
      if (f < d)
        break;
      const p = Ht - d;
      l > qt(_r / p) && xn("overflow"), l *= p;
    }
    const c = e.length + 1;
    s = Wh(i - u, c, u == 0), qt(i / c) > _r - r && xn("overflow"), r += qt(i / c), i %= c, e.splice(i++, 0, r);
  }
  return String.fromCodePoint(...e);
}, Gh = function(t) {
  const e = [];
  t = qh(t);
  const n = t.length;
  let i = zh, r = 0, s = $h;
  for (const u of t)
    u < 128 && e.push(eo(u));
  const o = e.length;
  let a = o;
  for (o && e.push(Uh); a < n; ) {
    let u = _r;
    for (const l of t)
      l >= i && l < u && (u = l);
    const c = a + 1;
    u - i > qt((_r - r) / c) && xn("overflow"), r += (u - i) * c, i = u;
    for (const l of t)
      if (l < i && ++r > _r && xn("overflow"), l === i) {
        let h = r;
        for (let f = Ht; ; f += Ht) {
          const d = f <= s ? Pa : f >= s + ti ? ti : f - s;
          if (h < d)
            break;
          const p = h - d, m = Ht - d;
          e.push(
            eo(Yu(d + p % m, 0))
          ), h = qt(p / m);
        }
        e.push(eo(Yu(h, 0))), s = Wh(r, c, a === o), r = 0, ++a;
      }
    ++r, ++i;
  }
  return e.join("");
}, Gb = function(t) {
  return Hh(t, function(e) {
    return $b.test(e) ? Vh(e.slice(4).toLowerCase()) : e;
  });
}, Kb = function(t) {
  return Hh(t, function(e) {
    return zb.test(e) ? "xn--" + Gh(e) : e;
  });
}, Kh = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: qh,
    encode: Wb
  },
  decode: Vh,
  encode: Gh,
  toASCII: Kb,
  toUnicode: Gb
}, Zb = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, Jb = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, Yb = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, Xb = {
  default: Zb,
  zero: Jb,
  commonmark: Yb
}, Qb = /^(vbscript|javascript|file|data):/, e_ = /^data:image\/(gif|png|jpeg|webp);/;
function t_(t) {
  const e = t.trim().toLowerCase();
  return Qb.test(e) ? e_.test(e) : !0;
}
const Zh = ["http:", "https:", "mailto:"];
function n_(t) {
  const e = Ca(t, !0);
  if (e.hostname && (!e.protocol || Zh.indexOf(e.protocol) >= 0))
    try {
      e.hostname = Kh.toASCII(e.hostname);
    } catch {
    }
  return ui(Ea(e));
}
function r_(t) {
  const e = Ca(t, !0);
  if (e.hostname && (!e.protocol || Zh.indexOf(e.protocol) >= 0))
    try {
      e.hostname = Kh.toUnicode(e.hostname);
    } catch {
    }
  return wr(Ea(e), wr.defaultChars + "%");
}
function _t(t, e) {
  if (!(this instanceof _t))
    return new _t(t, e);
  e || Da(t) || (e = t || {}, t = "default"), this.inline = new li(), this.block = new xs(), this.core = new Oa(), this.renderer = new Er(), this.linkify = new ht(), this.validateLink = t_, this.normalizeLink = n_, this.normalizeLinkText = r_, this.utils = s1, this.helpers = vs({}, c1), this.options = {}, this.configure(t), e && this.set(e);
}
_t.prototype.set = function(t) {
  return vs(this.options, t), this;
};
_t.prototype.configure = function(t) {
  const e = this;
  if (Da(t)) {
    const n = t;
    if (t = Xb[n], !t)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!t)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return t.options && e.set(t.options), t.components && Object.keys(t.components).forEach(function(n) {
    t.components[n].rules && e[n].ruler.enableOnly(t.components[n].rules), t.components[n].rules2 && e[n].ruler2.enableOnly(t.components[n].rules2);
  }), this;
};
_t.prototype.enable = function(t, e) {
  let n = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(r) {
    n = n.concat(this[r].ruler.enable(t, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(t, !0));
  const i = t.filter(function(r) {
    return n.indexOf(r) < 0;
  });
  if (i.length && !e)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + i);
  return this;
};
_t.prototype.disable = function(t, e) {
  let n = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(r) {
    n = n.concat(this[r].ruler.disable(t, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(t, !0));
  const i = t.filter(function(r) {
    return n.indexOf(r) < 0;
  });
  if (i.length && !e)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + i);
  return this;
};
_t.prototype.use = function(t) {
  const e = [this].concat(Array.prototype.slice.call(arguments, 1));
  return t.apply(t, e), this;
};
_t.prototype.parse = function(t, e) {
  if (typeof t != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(t, this, e);
  return this.core.process(n), n.tokens;
};
_t.prototype.render = function(t, e) {
  return e = e || {}, this.renderer.render(this.parse(t, e), this.options, e);
};
_t.prototype.parseInline = function(t, e) {
  const n = new this.core.State(t, this, e);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
_t.prototype.renderInline = function(t, e) {
  return e = e || {}, this.renderer.render(this.parseInline(t, e), this.options, e);
};
var to, Xu;
function i_() {
  if (Xu) return to;
  Xu = 1;
  function t(e, n) {
    n = n || {};
    let i = typeof n.externalClassName == "string" || n.externalClassName === null ? n.externalClassName : "external-link", r = typeof n.internalClassName == "string" || n.internalClassName === null ? n.internalClassName : null, s = Array.isArray(n.internalDomains) ? n.internalDomains.map((d) => d.toLowerCase()) : [], o = n.externalTarget || "_self", a = n.internalTarget || "_self", u = n.externalRel || null, c = n.internalRel || null;
    if (i === null && r === null && o === "_self" && a === "_self" && u === null && c === null)
      return;
    function l(d) {
      function p(m) {
        if (m.children && m.children.map(p), m.type === "link_open") {
          let _ = m.attrGet("href"), y = h(_), b = y ? r : i;
          if (b) {
            let w = m.attrGet("class") || "";
            w !== "" && (b = w + " " + b), m.attrSet("class", b);
          }
          let g = y ? a : o;
          g !== "_self" && m.attrSet("target", g);
          let v = y ? c : u;
          if (v) {
            let w = m.attrGet("rel") || "";
            w !== "" && (v = w + " " + v), m.attrSet("rel", v);
          }
        }
      }
      d.tokens.map(p);
    }
    function h(d) {
      let p = f(d);
      return p === null || s.indexOf(p) !== -1;
    }
    function f(d) {
      let p = d.split("//")[1];
      return p ? (p = p.split("/")[0].toLowerCase(), p || null) : null;
    }
    e.core.ruler.push("external_links", l);
  }
  return to = t, to;
}
var s_ = i_();
const o_ = /* @__PURE__ */ Pn(s_);
function a_(t) {
  let e = 0, n = "default", i = [];
  for (let r = 0; r < t.length; r++) {
    if (t[r] === "-") if (e === 0) if (n === "default" && r == 0 || n === "open" && t[r - 1] === `
`) e = 1;
    else continue;
    else e++;
    else e = 0;
    e === 3 && (n = n === "default" ? "open" : "closed", i.push(r + 1));
  }
  switch (n) {
    case "default":
      return ["", t];
    case "open":
      return ["", t];
    case "closed":
      return [t.slice(i[0], i[1] - 3).trim(), t.slice(i[1]).trimStart()];
  }
}
var Ho = (t) => t.slice(0, t.length - t.trimStart().length), no = (t) => {
  let e = Ho(t);
  return t.split(`
`).map((n) => n.slice(e.length)).join(`
`);
}, u_ = (t) => {
  if (t[0] === '"' || t[0] === "'") {
    let e = t[0];
    if (t[t.length - 1] === e) return t.slice(1, -1);
  }
  return t;
}, ro = (t) => t === "true" || t === "false" ? t === "true" : Number.isNaN(Number(t)) ? u_(t) : Number(t), $i = (t) => {
  let e = /(^[^\:\s]+):(?!\/)\n?([\s\S]*?(?=^\S)|[\s\S]*$)/gm, n = /[\:\-\[\]\|\#]/gm, i = /#.*$/gm, r = Ho(t);
  if (!n.test(t)) return r.length > 1 ? no(t) : ro(t.trim());
  r.length <= 1 && (t = t.trimStart());
  let s, o = {};
  for (; s = e.exec(t); ) {
    let [u, c, l] = s;
    if (Ho(l).length > 1) {
      let h = no(l);
      o[c] = $i(h);
    } else o[c] = $i(l);
  }
  if (Object.keys(o).length > 0) return o;
  let a = t.trim().replace(i, "").trim();
  return a.startsWith("-") ? a.split(/^\-/gm).filter((u) => u).map((u) => $i(u.trimEnd())) : a.startsWith("[") ? (a = a.slice(1, -1), a.split(",").map((u) => ro(u.trim()))) : a.startsWith("|") ? no(a.replace("|", "").replace(`
`, "")) : ro(a.trim());
};
function c_(t) {
  let [e, n] = a_(t);
  return e ? { frontmatter: $i(e), content: n } : { content: n };
}
function l_({ frontmatter: t = null, content: e = "" }) {
  let n = "";
  return t && typeof t == "object" && Object.keys(t).length > 0 && (n = _g(t, {
    indent: "",
    prefix: `---
`,
    postfix: `
---
`
  })), n + e;
}
function h_(t) {
  return c_(t);
}
let Ai;
function Sv() {
  return Ai || (Ai = new _t({
    linkify: !0,
    typographer: !0
  }), Ai.use(o_, {
    externalTarget: "_blank"
  })), Ai;
}
function f_({ hash: t = "", loadMedia: e = !0 }) {
  const n = ue(), i = ie({});
  n.get("posts").get("#index").get(t).on(async (o) => {
    try {
      Object.assign(i, JSON.parse(o));
    } catch {
      i.raw = o;
    }
    e && ["icon", "cover", "text"].forEach((a) => {
      i[a] && n.get("posts").get(`#${a}`).get(i[a]).on((u) => {
        i[a] = u;
      });
    });
  });
  const r = ye(!1);
  async function s() {
    r.value = !0, await p_(i), r.value = !1;
  }
  return { post: i, download: s, downloading: r };
}
async function d_(t, e) {
  var c;
  const n = ue(), { user: i } = Re(), { icon: r, cover: s, content: o } = e;
  e.icon = await io("icon", r), e.cover = await io("cover", s), e.content = await io("content", o), e = Ma(e);
  const { hashed: a, hash: u } = await es(e);
  console.log(u, e, t), n.get("posts").get("#index").get(`${u}`).put(a), n.user(ne.pub).get("posts").get(`${t}:${u}@${i.pub}`).put(!0, null, { opt: { cert: (c = ne.features) == null ? void 0 : c.posts } });
}
async function p_(t) {
  let { title: e, statement: n } = t;
  const { zipPost: i, addFile: r, downloadZip: s } = Yh();
  if ((e || n) && !t.raw)
    await i({ ...t });
  else {
    e = "file";
    const o = await hn(t.raw);
    await r({
      title: _m(o),
      file: t.raw
    });
  }
  return await s({ title: e }), !0;
}
async function Qu(t, e) {
  return t && e && typeof e == "string" && e.length == 44 && e.slice(0, 5) != "data:" ? await ue().get("posts").get(`#${t}`).get(e).then() : e;
}
async function io(t, e) {
  if (t && e) {
    const n = await hn(e);
    return ue().get("posts").get(`#${t}`).get(`${n}`).put(e), n;
  } else
    return e;
}
async function Av(t) {
  let e;
  try {
    e = JSON.parse(t);
  } catch {
    e = t;
  }
  return e;
}
function Ev({ hash: t }) {
  const e = ue(), n = ye(0), i = te(() => va(Date.now() - n.value || 1e3));
  e.get("posts").get("#index").get(t).on(function(s, o, a) {
    n.value = a.put[">"];
  });
  async function r() {
    let s = await e.get("posts").get("#index").get(t).then();
    e.get("posts").get("#index").get(t).put(s);
  }
  return { timestamp: n, msTime: i, refresh: r };
}
function Cv(t) {
  if (!t) return;
  const e = ue(), n = ie({}), i = ie({});
  e.user(ne.pub).get("posts").map().on(function(c, l) {
    let h = l.indexOf(t);
    if (h == -1) return;
    let f = l.slice(-87), d = l.slice(0, 44), p = l.slice(45, 89);
    h == 0 ? (n[p] = n[p] || {}, n[p][f] = c) : (i[d] = i[d] || {}, i[d][f] = c);
  });
  const r = te(() => {
    let c = 0;
    for (let l in n)
      e: for (let h in n[l])
        if (n[l][h]) {
          c++;
          break e;
        }
    return c;
  }), s = te(() => {
    let c = 0;
    for (let l in i)
      e: for (let h in i[l])
        if (i[l][h]) {
          c++;
          break e;
        }
    return c;
  }), o = ye(!1);
  async function a() {
    o.value = !0, o.value = !await m_(t, n);
  }
  function u(c) {
    g_(t, c);
  }
  return {
    posts: n,
    backlinks: i,
    countPosts: r,
    countBacklinks: s,
    downloadPosts: a,
    downloading: o,
    uploadPosts: u
  };
}
async function m_(t, e) {
  if (!e) return;
  const { zip: n, zipPost: i, downloadZip: r } = Yh(), s = cd({});
  for (let o in e) {
    const { post: a } = f_({ hash: o });
    s[o] = a, a.title && await i(a);
  }
  return await r({ title: `#${t}` }), !0;
}
function g_(t, e) {
  Array.from(e).forEach(async (n) => {
    const i = await Sh.loadAsync(n);
    i.comment && console.info("Zip file comment: " + i.comment), i.forEach(async (r, s) => {
      var o;
      if (r.endsWith("index.md")) {
        let a = r.slice(0, -9), u = await s.async("string"), { frontmatter: c, content: l } = h_(u);
        if (c = c || {}, c.title = (c == null ? void 0 : c.title) || a, c.icon) {
          const f = await i.file(`${a}/${c.icon}`).async("base64"), d = Ou(f);
          c.icon = `data:${d};base64,${f}`;
        }
        if (c.cover) {
          const f = await ((o = i == null ? void 0 : i.file(`${a}/${c.cover}`)) == null ? void 0 : o.async("base64")), d = Ou(f);
          c.cover = `data:${d};base64,${f}`;
        }
        let h = { ...c, content: l };
        d_(t, h);
      }
    });
  });
}
const Yn = Gn.room, Tv = ye(null), ne = ie({
  pub: Gt("current-room", Yn.pub),
  isRoot: te(() => ne.pub == Yn.pub),
  hosts: {},
  features: {},
  profile: {}
});
nr(() => {
  const t = ue();
  ne.pub == Yn.pub ? (ne.hosts = Yn.hosts, ne.features = Yn.features) : (ne.features = {}, ne.hosts = {}, t.user(ne.pub).get("hosts").map().once((e, n) => {
    ne.hosts[n] = e;
  }), t.user(ne.pub).get("features").map().once((e, n) => {
    ne.features[n] = e;
  }));
});
function Dv(t = ne.pub) {
  const e = ie({
    pub: t,
    isFavourite: !1,
    isRoot: te(() => t == Yn.pub),
    hosts: {},
    features: {},
    profile: {}
  }), n = ue(), { user: i } = Re();
  return n.user(t).get("profile").map().on((r, s) => {
    e.profile[s] = r;
  }), n.user(t).get("hosts").map().once((r, s) => {
    e.hosts[s] = r;
  }), n.user(t).get("features").map().once((r, s) => {
    e.features[s] = r;
  }), n.user().get("rooms").get(`${t}@${i == null ? void 0 : i.pub}`).on((r) => {
    e.isFavourite = r;
  }), {
    room: e,
    submitRoom: b_,
    enterRoom: __,
    createRoom: Jh,
    leaveRoom: y_,
    updateRoomProfile: qo
  };
}
function qo(t, e) {
  var s, o;
  const n = ue(), { user: i } = Re();
  let r = (o = (s = ne.hosts) == null ? void 0 : s[i.pub]) == null ? void 0 : o.profile;
  if (!r) {
    console.warn("Profile certificate not found");
    return;
  }
  n.user(ne.pub).get("profile").get(t).put(e, null, { opt: { cert: r } });
}
async function Jh({
  pair: t,
  name: e,
  featureList: n = Object.keys(Gn == null ? void 0 : Gn.features),
  publish: i = !0
} = {}) {
  var f;
  const { user: r } = Re();
  if (!t) return;
  const s = t.pub, o = await Su({
    pair: t,
    list: [
      { tag: "profile", users: [r.pub] },
      { tag: "features", users: [r.pub] },
      { tag: "hosts", users: [r.pub] }
    ]
  }), a = await Su({
    pair: t,
    list: n.map((d) => ({
      tag: d,
      personal: !0
    }))
  }), u = await r.encrypt(t), c = await r.encrypt(s), l = {
    ...Gn,
    relay: je.peer,
    room: {
      pub: t.pub,
      hosts: { [r.pub]: { enc: u, ...o } },
      features: a
    }
  };
  console.log(
    "COPY THIS ROOM INFO TO USE IT AS A ROOT",
    l,
    "STORE THIS KEY PAIR IN A SAFE PLACE",
    t
  );
  const h = ue();
  await h.user().get("rooms").get(`${s}@${r.pub}`).put(!0).then(), await h.user().get("my_rooms").get(c).put(u).then(), await h.user(s).get("hosts").get(r.pub).put(
    {
      enc: u,
      ...o
    },
    null,
    { opt: { cert: o.hosts } }
  ).then(), await h.user(s).get("features").put(a, null, { opt: { cert: o.features } }).then(), e && await h.user(s).get("profile").put({ name: e }, null, { opt: { cert: o.profile } }).then(), i && await h.user(ne.pub).get("rooms").get(`${s}@${r.pub}`).put(!0, null, { opt: { cert: (f = ne == null ? void 0 : ne.features) == null ? void 0 : f.rooms } }).then(), Bo(
    JSON.stringify(l),
    "application/json",
    "gun.config.json"
  ), Bo(
    JSON.stringify(t),
    "application/json",
    `room_${e || s}.json`
  );
}
async function Fv(t, e) {
  const n = await xe.decrypt(t);
  Jh({
    pair: n,
    name: e
  });
}
async function b_(t) {
  var i;
  const e = ue(), n = await e.user(ne.pub).get("rooms").get(`${t}@${xe.pub}`).then();
  e.user(ne.pub).get("rooms").get(`${t}@${xe.pub}`).put(!n, null, { opt: { cert: (i = ne.features) == null ? void 0 : i.rooms } });
}
function __(t) {
  ne.pub = t;
}
function y_() {
  ne.pub = Yn.pub;
}
function Ov(t = ne.pub) {
  const e = ue(), n = ie({});
  return e.user(t).get("rooms").map().on(function(i, r) {
    let s = r.substring(0, 87);
    n[s] = n[s] || {}, n[s][r.substring(88)] = i;
  }), n;
}
function Iv(t = ne.pub) {
  var i;
  const e = ue(), { user: n } = Re();
  e.user(t).get("space").get(n.pub).put(JSON.stringify({ x: Math.random(), y: Math.random() }), null, {
    opt: { cert: (i = ne.features) == null ? void 0 : i.space }
  });
}
async function Pv(t = ne.pub) {
  const e = ue(), { user: n } = Re(), i = await e.user().get("rooms").get(`${t}@${n.pub}`).then();
  e.user().get("rooms").get(`${t}@${n.pub}`).put(!i);
}
let so = Date.now();
function Rv(t = ne.pub, { TIMEOUT: e = 1e4 } = {}) {
  const n = ue(), i = ie({}), r = ie({}), s = ie({}), o = ie({
    total: te(() => Object.keys(i).length),
    online: te(() => Object.keys(r).length),
    offline: te(() => Object.keys(s).length)
  });
  return n.user(t).get("space").map().once((a, u) => {
    const { account: c } = pp(u);
    i[u] = c, i[u].order = te(
      () => so - c.value.pulse < e ? 1 : so - c.value.pulse
    ), i[u].online = te(() => so - c.value.pulse < e);
  }), nr(() => {
    var a, u;
    for (let c in i)
      (u = (a = i == null ? void 0 : i[c]) == null ? void 0 : a.online) != null && u.value ? (r[c] = i[c], delete s[c]) : (s[c] = i[c], delete r[c]);
  }), { guests: i, online: r, offline: s, count: o };
}
function Lv(t = ne.pub) {
  const e = ye(), n = ue();
  n.user(t).get("profile").get("logo").once((s) => {
    if (!s) {
      e.value = null;
      return;
    }
    n.get("#logos").get(s).once((o) => {
      e.value = o;
    });
  });
  async function i(s) {
    if (s) {
      const o = await hn(s);
      n.get("#logos").get(o).put(s), qo("logo", o);
    } else
      r();
  }
  function r() {
    qo("logo", null);
  }
  return {
    logo: e,
    uploadLogo: i,
    removeLogo: r
  };
}
function Mv() {
  const t = ue(), e = ye(), n = te(() => Qi(e.value)), i = ie({
    list: {},
    all: te(() => {
      const s = [];
      for (let o in i.list)
        s.push({
          hash: o,
          tag: i.list[o]
        });
      return s.sort(
        (o, a) => o && a && o.tag.toLowerCase() < a.tag.toLowerCase() ? -1 : 1
      );
    }),
    count: te(() => i.all.length),
    fuse: te(() => new fn(i.all, {
      includeScore: !0,
      keys: ["tag"]
    })),
    results: te(() => e.value ? i.fuse.search(n.value) : []),
    minScore: te(() => {
      let s = 100;
      return i.results.forEach((o) => {
        o.score < s && (s = o.score);
      }), s;
    })
  });
  t.get("#tags").map().on((s, o) => {
    if (s)
      try {
        JSON.parse(s);
      } catch {
        i.list[o] = s;
      }
  });
  async function r(s = n.value) {
    if (!s) return;
    let o = Qi(s);
    const a = await hn(o);
    t.get("#tags").get(`${a}`).put(o);
  }
  return { search: e, slug: n, tags: i, addTag: r };
}
function jv(t, e = ne.pub) {
  const n = ue(), i = ie({});
  return n.user(e).get(`${t}`).map().on(function(r, s) {
    let o = s.substring(0, 87);
    i[o] = i[o] || {}, i[o][s.substring(88)] = r;
  }), i;
}
const v_ = ["rooms"];
function Nv({ tag: t, hash: e, back: n }) {
  const { user: i } = Re(), r = ye("👍"), o = ue().user(ne.pub);
  nr(() => {
    v_.includes(t) ? o.get(t).get(`${e}@${i.pub}`).on((u) => {
      u && u !== !0 && (r.value = u);
    }) : o.get("posts").get(`${t}:${e}@${i.pub}`).on((u) => {
      u && u !== !0 && (r.value = u);
    });
  });
  function a(u) {
    w_({
      tag: t,
      hash: e,
      back: n,
      reaction: kr(u || r.value)
    });
  }
  return { reaction: r, react: a };
}
async function w_({ tag: t, hash: e, back: n, reaction: i = !0 }) {
  var o, a;
  const { user: r } = Re(), s = ue();
  if (t == "rooms") {
    let u = s.user(ne.pub).get(t).get(`${e}@${r.pub}`), c = await u.then();
    u.put(c ? null : i, null, {
      opt: { cert: (o = ne.features) == null ? void 0 : o[t] }
    });
  } else {
    const u = s.user(ne.pub).get("posts");
    let c = n ? `${e}:${t}@${r.pub}` : `${t}:${e}@${r.pub}`;
    const l = u.get(c);
    let h = await l.then();
    l.put(h ? null : i, null, {
      opt: { cert: (a = ne.features) == null ? void 0 : a.posts }
    });
  }
}
function Bv(t) {
  const e = {};
  for (let n in t) {
    let i = t[n];
    i && (e[i] = e[i] || [], e[i].push(n));
  }
  return e;
}
function $v(t) {
  let e = 0;
  for (let n in t)
    t[n] && t[n] != "🗑" ? e++ : t[n] == "🗑" && e--;
  return e;
}
function zv(t) {
  const e = ue(), n = ie({});
  return e.user(ne.pub).get("posts").map().on((i, r) => {
    var u;
    let s = r.slice(90), o = r.substring(0, 44), a = r.substring(45, 89);
    s == t && (i ? (n[i] = n[i] || {}, n[i][a] = o) : (u = n == null ? void 0 : n[i]) == null || delete u[a]);
  }), n;
}
function Yh() {
  const t = new Sh();
  async function e({ title: s, file: o, folder: a = "." }) {
    hg(o);
    const u = fg(o), c = await fetch(o).then((h) => h.blob()), l = `${s}.${u}`;
    return t.file(`${a}/${l}`, c), l;
  }
  function n({ md: s, title: o }) {
    t.file(`${o}/index.md`, l_(s));
  }
  async function i(s) {
    let { text: o, title: a, statement: u, content: c } = s;
    s == null || delete s.text, s == null || delete s.content, a || (a = u ? u.slice(0, 12) : dh());
    const l = ["cover", "icon"];
    for (let h of l) {
      let f = await Qu(h, s[h]);
      if (f) {
        const d = await e({
          title: h,
          file: f,
          folder: a
        });
        s[h] = d;
      }
    }
    o = await Qu("text", o), n({
      title: a,
      md: {
        frontmatter: s,
        content: o || c
      }
    });
  }
  async function r({ title: s = "" } = {}) {
    let o = /* @__PURE__ */ new Date();
    const a = o.getTimezoneOffset();
    o = new Date(o.getTime() - a * 60 * 1e3);
    const u = o.toISOString().split("T")[0], c = await t.generateAsync({
      type: "blob",
      comment: `Exported from ${s} at ${location} on ${u}`,
      compression: "DEFLATE",
      compressionOptions: {
        level: 9
      }
    }), l = `${s}-${u}.zip`;
    return Bo(c, "application/zip", l), !0;
  }
  return { zip: t, zipPost: i, addMd: n, addFile: e, downloadZip: r };
}
var oo, ur, x_ = { 61: () => {
}, 405: (t) => {
  t.exports = async function* (e) {
    for (let n of e) typeof n == "function" && (n = n()), yield* n;
  };
}, 580: (t) => {
  var e = /["'&<>]/;
  t.exports = function(n) {
    var i, r = "" + n, s = e.exec(r);
    if (!s) return r;
    var o = "", a = 0, u = 0;
    for (a = s.index; a < r.length; a++) {
      switch (r.charCodeAt(a)) {
        case 34:
          i = "&quot;";
          break;
        case 38:
          i = "&amp;";
          break;
        case 39:
          i = "&#39;";
          break;
        case 60:
          i = "&lt;";
          break;
        case 62:
          i = "&gt;";
          break;
        default:
          continue;
      }
      u !== a && (o += r.substring(u, a)), u = a + 1, o += i;
    }
    return u !== a ? o + r.substring(u, a) : o;
  };
}, 717: (t, e, n) => {
  n.r(e), n.d(e, { addListener: () => f, argv: () => a, binding: () => C, browser: () => s, chdir: () => O, cwd: () => E, emit: () => y, env: () => o, listeners: () => w, nextTick: () => v, off: () => p, on: () => h, once: () => d, prependListener: () => b, prependOnceListener: () => g, removeAllListeners: () => _, removeListener: () => m, title: () => r, umask: () => A, version: () => u, versions: () => c });
  var i = n(9596);
  const r = "browser", s = !0, o = {}, a = [], u = "", c = {};
  function l() {
  }
  const h = l, f = l, d = l, p = l, m = l, _ = l, y = l, b = l, g = l, v = (R, ...P) => i(() => R(...P)), w = (R) => [], E = () => "/", A = () => 0, C = (R) => {
    throw new Error("process.binding is not supported");
  }, O = (R) => {
    throw new Error("process.chdir is not supported");
  };
}, 736: (t, e, n) => {
  t.exports = function(i) {
    function r(a) {
      let u, c, l, h = null;
      function f(...d) {
        if (!f.enabled) return;
        const p = f, m = Number(/* @__PURE__ */ new Date()), _ = m - (u || m);
        p.diff = _, p.prev = u, p.curr = m, u = m, d[0] = r.coerce(d[0]), typeof d[0] != "string" && d.unshift("%O");
        let y = 0;
        d[0] = d[0].replace(/%([a-zA-Z%])/g, (b, g) => {
          if (b === "%%") return "%";
          y++;
          const v = r.formatters[g];
          if (typeof v == "function") {
            const w = d[y];
            b = v.call(p, w), d.splice(y, 1), y--;
          }
          return b;
        }), r.formatArgs.call(p, d), (p.log || r.log).apply(p, d);
      }
      return f.namespace = a, f.useColors = r.useColors(), f.color = r.selectColor(a), f.extend = s, f.destroy = r.destroy, Object.defineProperty(f, "enabled", { enumerable: !0, configurable: !1, get: () => h !== null ? h : (c !== r.namespaces && (c = r.namespaces, l = r.enabled(a)), l), set: (d) => {
        h = d;
      } }), typeof r.init == "function" && r.init(f), f;
    }
    function s(a, u) {
      const c = r(this.namespace + (u === void 0 ? ":" : u) + a);
      return c.log = this.log, c;
    }
    function o(a, u) {
      let c = 0, l = 0, h = -1, f = 0;
      for (; c < a.length; ) if (l < u.length && (u[l] === a[c] || u[l] === "*")) u[l] === "*" ? (h = l, f = c, l++) : (c++, l++);
      else {
        if (h === -1) return !1;
        l = h + 1, f++, c = f;
      }
      for (; l < u.length && u[l] === "*"; ) l++;
      return l === u.length;
    }
    return r.debug = r, r.default = r, r.coerce = function(a) {
      return a instanceof Error ? a.stack || a.message : a;
    }, r.disable = function() {
      const a = [...r.names, ...r.skips.map((u) => "-" + u)].join(",");
      return r.enable(""), a;
    }, r.enable = function(a) {
      r.save(a), r.namespaces = a, r.names = [], r.skips = [];
      const u = (typeof a == "string" ? a : "").trim().replace(" ", ",").split(",").filter(Boolean);
      for (const c of u) c[0] === "-" ? r.skips.push(c.slice(1)) : r.names.push(c);
    }, r.enabled = function(a) {
      for (const u of r.skips) if (o(a, u)) return !1;
      for (const u of r.names) if (o(a, u)) return !0;
      return !1;
    }, r.humanize = n(6585), r.destroy = function() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }, Object.keys(i).forEach((a) => {
      r[a] = i[a];
    }), r.names = [], r.skips = [], r.formatters = {}, r.selectColor = function(a) {
      let u = 0;
      for (let c = 0; c < a.length; c++) u = (u << 5) - u + a.charCodeAt(c), u |= 0;
      return r.colors[Math.abs(u) % r.colors.length];
    }, r.enable(r.load()), r;
  };
}, 815: (t, e, n) => {
  var i, r = n(717), s = n(3519), o = n(6611);
  try {
    i = n(2376);
  } catch {
  }
  var a = function() {
  }, u = /^v?\.0/.test(r.version), c = function(d) {
    return typeof d == "function";
  }, l = function(d, p, m, _) {
    _ = s(_);
    var y = !1;
    d.on("close", function() {
      y = !0;
    }), o(d, { readable: p, writable: m }, function(g) {
      if (g) return _(g);
      y = !0, _();
    });
    var b = !1;
    return function(g) {
      if (!y && !b) return b = !0, function(v) {
        return !!u && !!i && (v instanceof (i.ReadStream || a) || v instanceof (i.WriteStream || a)) && c(v.close);
      }(d) ? d.close(a) : function(v) {
        return v.setHeader && c(v.abort);
      }(d) ? d.abort() : c(d.destroy) ? d.destroy() : void _(g || new Error("stream was destroyed"));
    };
  }, h = function(d) {
    d();
  }, f = function(d, p) {
    return d.pipe(p);
  };
  t.exports = function() {
    var d, p = Array.prototype.slice.call(arguments), m = c(p[p.length - 1] || a) && p.pop() || a;
    if (Array.isArray(p[0]) && (p = p[0]), p.length < 2) throw new Error("pump requires two streams per minimum");
    var _ = p.map(function(y, b) {
      var g = b < p.length - 1;
      return l(y, g, b > 0, function(v) {
        d || (d = v), v && _.forEach(h), g || (_.forEach(h), m(d));
      });
    });
    return p.reduce(f);
  };
}, 826: () => {
}, 988: (t, e, n) => {
  n.d(e, { A: () => p });
  var i = n(9639);
  function r(m) {
    const _ = m < 0 ? 1 : 0;
    return m = Math.abs(Number(m || 1)), Math.floor(Math.log10(m)) + 1 + _;
  }
  function s(m) {
    return ArrayBuffer.isView(m) ? "arraybufferview" : Array.isArray(m) ? "array" : m instanceof Number ? "number" : m instanceof Boolean ? "boolean" : m instanceof Set ? "set" : m instanceof Map ? "map" : m instanceof String ? "string" : m instanceof ArrayBuffer ? "arraybuffer" : typeof m;
  }
  function o(m, _, y) {
    const b = [];
    let g = null;
    return o._encode(b, m), g = (0, i.xW)(b), o.bytes = g.length, ArrayBuffer.isView(_) ? (_.set(g, y), _) : g;
  }
  o.bytes = -1, o._floatConversionDetected = !1, o._encode = function(m, _) {
    if (_ != null) switch (s(_)) {
      case "object":
        o.dict(m, _);
        break;
      case "map":
        o.dictMap(m, _);
        break;
      case "array":
        o.list(m, _);
        break;
      case "set":
        o.listSet(m, _);
        break;
      case "string":
        o.string(m, _);
        break;
      case "number":
      case "boolean":
        o.number(m, _);
        break;
      case "arraybufferview":
        o.buffer(m, new Uint8Array(_.buffer, _.byteOffset, _.byteLength));
        break;
      case "arraybuffer":
        o.buffer(m, new Uint8Array(_));
    }
  };
  const a = new Uint8Array([101]), u = new Uint8Array([100]), c = new Uint8Array([108]);
  o.buffer = function(m, _) {
    m.push((0, i.L0)(_.length + ":"), _);
  }, o.string = function(m, _) {
    m.push((0, i.L0)((0, i.L0)(_).byteLength + ":" + _));
  }, o.number = function(m, _) {
    if (Number.isInteger(_)) return m.push((0, i.L0)("i" + BigInt(_) + "e"));
    const y = 2147483648, b = (_ / y | 0) * y + (_ % y | 0);
    m.push((0, i.L0)("i" + b + "e")), b === _ || o._floatConversionDetected || (o._floatConversionDetected = !0, console.warn('WARNING: Possible data corruption detected with value "' + _ + '":', 'Bencoding only defines support for integers, value was converted to "' + b + '"'), console.trace());
  }, o.dict = function(m, _) {
    m.push(u);
    let y, b = 0;
    const g = Object.keys(_).sort(), v = g.length;
    for (; b < v; b++) y = g[b], _[y] != null && (o.string(m, y), o._encode(m, _[y]));
    m.push(a);
  }, o.dictMap = function(m, _) {
    m.push(u);
    const y = Array.from(_.keys()).sort();
    for (const b of y) _.get(b) != null && (ArrayBuffer.isView(b) ? o._encode(m, b) : o.string(m, String(b)), o._encode(m, _.get(b)));
    m.push(a);
  }, o.list = function(m, _) {
    let y = 0;
    const b = _.length;
    for (m.push(c); y < b; y++) _[y] != null && o._encode(m, _[y]);
    m.push(a);
  }, o.listSet = function(m, _) {
    m.push(c);
    for (const y of _) y != null && o._encode(m, y);
    m.push(a);
  };
  const l = o;
  function h(m, _, y) {
    let b = 0, g = 1;
    for (let v = _; v < y; v++) {
      const w = m[v];
      if (w < 58 && w >= 48) b = 10 * b + (w - 48);
      else if (v !== _ || w !== 43) {
        if (v !== _ || w !== 45) {
          if (w === 46) break;
          throw new Error("not a number: buffer[" + v + "] = " + w);
        }
        g = -1;
      }
    }
    return b * g;
  }
  function f(m, _, y, b) {
    return m == null || m.length === 0 ? null : (typeof _ != "number" && b == null && (b = _, _ = void 0), typeof y != "number" && b == null && (b = y, y = void 0), f.position = 0, f.encoding = b || null, f.data = ArrayBuffer.isView(m) ? new Uint8Array(m.slice(_, y)) : (0, i.L0)(m), f.bytes = f.data.length, f.next());
  }
  f.bytes = 0, f.position = 0, f.data = null, f.encoding = null, f.next = function() {
    switch (f.data[f.position]) {
      case 100:
        return f.dictionary();
      case 108:
        return f.list();
      case 105:
        return f.integer();
      default:
        return f.buffer();
    }
  }, f.find = function(m) {
    let _ = f.position;
    const y = f.data.length, b = f.data;
    for (; _ < y; ) {
      if (b[_] === m) return _;
      _++;
    }
    throw new Error('Invalid data: Missing delimiter "' + String.fromCharCode(m) + '" [0x' + m.toString(16) + "]");
  }, f.dictionary = function() {
    f.position++;
    const m = {};
    for (; f.data[f.position] !== 101; ) {
      const _ = f.buffer();
      let y = (0, i.dU)(_);
      y.includes("�") && (y = (0, i.V5)(_)), m[y] = f.next();
    }
    return f.position++, m;
  }, f.list = function() {
    f.position++;
    const m = [];
    for (; f.data[f.position] !== 101; ) m.push(f.next());
    return f.position++, m;
  }, f.integer = function() {
    const m = f.find(101), _ = h(f.data, f.position + 1, m);
    return f.position += m + 1 - f.position, _;
  }, f.buffer = function() {
    let m = f.find(58);
    const _ = h(f.data, f.position, m), y = ++m + _;
    return f.position = y, f.encoding ? (0, i.dU)(f.data.slice(m, y)) : f.data.slice(m, y);
  };
  function d(m) {
    if (m == null) return 0;
    const _ = s(m);
    switch (_) {
      case "arraybufferview":
        return function(y) {
          const b = y.byteLength - y.byteOffset;
          return r(b) + 1 + b;
        }(m);
      case "string":
        return function(y) {
          const b = (0, i.L0)(y).byteLength;
          return r(b) + 1 + b;
        }(m);
      case "array":
      case "set":
        return function(y) {
          let b = 2;
          for (const g of y) b += d(g);
          return b;
        }(m);
      case "number":
        return 1 + r(Math.floor(m)) + 1;
      case "bigint":
        return 1 + m.toString().length + 1;
      case "object":
        return function(y) {
          let b = 2;
          const g = Object.keys(y);
          for (let v = 0; v < g.length; v++) {
            const w = (0, i.L0)(g[v]).byteLength;
            b += r(w) + 1 + w, b += d(y[g[v]]);
          }
          return b;
        }(m);
      case "map":
        return function(y) {
          let b = 2;
          for (const [g, v] of y) {
            const w = (0, i.L0)(g).byteLength;
            b += r(w) + 1 + w, b += d(v);
          }
          return b;
        }(m);
      default:
        throw new TypeError(`Unsupported value of type "${_}"`);
    }
  }
  const p = { encode: l, decode: f, byteLength: d, encodingLength: d };
}, 1035: (t) => {
  function e(n) {
    return (+Date.now() - n) / 100 & 65535;
  }
  t.exports = function(n) {
    const i = +Date.now(), r = 10 * (n || 5), s = [0];
    let o = 1, a = e(i) - 1 & 65535;
    return function(u) {
      const c = e(i);
      let l = c - a & 65535;
      for (l > r && (l = r), a = c; l--; ) o === r && (o = 0), s[o] = s[o === 0 ? r - 1 : o - 1], o++;
      u && (s[o - 1] += u);
      const h = s[o - 1], f = s.length < r ? 0 : s[o === r ? 0 : o];
      return s.length < 10 ? h : 10 * (h - f) / s.length;
    };
  };
}, 1133: (t, e, n) => {
  let i = n(8673);
  t.exports = new i(n(8446));
}, 1314: (t) => {
  t.exports = function(e, n) {
    if (!(n >= e.length || n < 0)) {
      var i = e.pop();
      if (n < e.length) {
        var r = e[n];
        return e[n] = i, r;
      }
      return i;
    }
  };
}, 1467: (t) => {
  function e(n, i) {
    if (typeof n[0] == "string") return n.join("");
    if (typeof n[0] == "number") return new Uint8Array(n);
    const r = new Uint8Array(i);
    let s = 0;
    for (let o = 0, a = n.length; o < a; o++) {
      const u = n[o];
      r.set(u, s), s += u.byteLength || u.length;
    }
    return r;
  }
  t.exports = async function* (n, i = 512, r = {}) {
    typeof i == "object" && (i = (r = i).size);
    let { nopad: s, zeroPadding: o = !0 } = r;
    s && (o = !1);
    let a = [], u = 0;
    for await (const c of n) if (u += c.byteLength || c.length || 1, a.push(c), u >= i) {
      const l = e(a, u);
      let h = 0;
      for (; u >= i; ) yield l.slice(h, h + i), u -= i, h += i;
      a = [l.slice(h, l.length)];
    }
    u && (yield e(a, o ? i : u));
  };
}, 1551: () => {
}, 1827: () => {
}, 2072: (t) => {
  t.exports = { wait: function(e) {
    return new Promise((n) => setTimeout(n, e));
  } };
}, 2123: () => {
}, 2376: () => {
}, 2532: () => {
}, 2701: () => {
}, 2799: () => {
}, 2878: (t) => {
  function e(s, o) {
    return { start: s.start, end: s.end, index: o };
  }
  function n(s) {
    return { start: s.start, end: s.end };
  }
  function i(s, o) {
    return s.index - o.index;
  }
  function r(s, o) {
    return s.start - o.start;
  }
  t.exports = function(s, o, a) {
    if (typeof o != "string") throw new TypeError("argument str must be a string");
    var u = o.indexOf("=");
    if (u === -1) return -2;
    var c = o.slice(u + 1).split(","), l = [];
    l.type = o.slice(0, u);
    for (var h = 0; h < c.length; h++) {
      var f = c[h].split("-"), d = parseInt(f[0], 10), p = parseInt(f[1], 10);
      isNaN(d) ? (d = s - p, p = s - 1) : isNaN(p) && (p = s - 1), p > s - 1 && (p = s - 1), isNaN(d) || isNaN(p) || d > p || d < 0 || l.push({ start: d, end: p });
    }
    return l.length < 1 ? -1 : a && a.combine ? function(m) {
      for (var _ = m.map(e).sort(r), y = 0, b = 1; b < _.length; b++) {
        var g = _[b], v = _[y];
        g.start > v.end + 1 ? _[++y] = g : g.end > v.end && (v.end = g.end, v.index = Math.min(v.index, g.index));
      }
      _.length = y + 1;
      var w = _.sort(i).map(n);
      return w.type = m.type, w;
    }(l) : l;
  };
}, 3033: (t, e, n) => {
  function i(s) {
    return (s >> 3) + +(s % 8 != 0);
  }
  n.d(e, { A: () => r });
  class r {
    get length() {
      return this.buffer.length << 3;
    }
    constructor(o = 0, a) {
      const u = a == null ? void 0 : a.grow;
      this.grow = u ? Number.isFinite(u) ? i(u) : u : 0, this.buffer = typeof o == "number" ? new Uint8Array(i(o)) : o;
    }
    get(o) {
      const a = o >> 3;
      return a < this.buffer.length && !!(this.buffer[a] & 128 >> o % 8);
    }
    set(o, a = !0) {
      const u = o >> 3;
      if (a) {
        if (u >= this.buffer.length) {
          const c = Math.max(u + 1, Math.min(2 * this.buffer.length, this.grow));
          if (c <= this.grow) {
            const l = new Uint8Array(c);
            l.set(this.buffer), this.buffer = l;
          }
        }
        this.buffer[u] |= 128 >> o % 8;
      } else u < this.buffer.length && (this.buffer[u] &= ~(128 >> o % 8));
    }
    setAll(o, a = 0) {
      const u = Math.min(i(a + o.length), this.grow);
      if (this.buffer.length < u) {
        const h = new Uint8Array(u);
        h.set(this.buffer), this.buffer = h;
      }
      let c = a >> 3, l = 128 >> a % 8;
      for (let h = 0; h < o.length; h++) if (o[h] ? this.buffer[c] |= l : this.buffer[c] &= ~l, l === 1) {
        if (c += 1, c >= this.buffer.length) break;
        l = 128;
      } else l >>= 1;
    }
    forEach(o, a = 0, u = 8 * this.buffer.length) {
      let c = a >> 3, l = 128 >> a % 8;
      for (let h = a; h < u; h++) o(!!(this.buffer[c] & l), h), l === 1 ? (c += 1, l = 128) : l >>= 1;
    }
    isEmpty() {
      for (let o = 0; o < this.buffer.length; o++) if (this.buffer[o] !== 0) return !1;
      return !0;
    }
  }
}, 3065: (t, e, n) => {
  var i = n(717), r = n(5472), s = n(3085), o = function(a, u, c) {
    this.tokenBucket = new r(a, a, u, null), this.tokenBucket.content = a, this.curIntervalStart = s(), this.tokensThisInterval = 0, this.fireImmediately = c;
  };
  o.prototype = { tokenBucket: null, curIntervalStart: 0, tokensThisInterval: 0, fireImmediately: !1, removeTokens: function(a, u) {
    if (a > this.tokenBucket.bucketSize) return i.nextTick(u.bind(null, "Requested tokens " + a + " exceeds maximum tokens per interval " + this.tokenBucket.bucketSize, null)), !1;
    var c = this, l = s();
    if ((l < this.curIntervalStart || l - this.curIntervalStart >= this.tokenBucket.interval) && (this.curIntervalStart = l, this.tokensThisInterval = 0), a > this.tokenBucket.tokensPerInterval - this.tokensThisInterval) {
      if (this.fireImmediately) i.nextTick(u.bind(null, null, -1));
      else {
        var h = Math.ceil(this.curIntervalStart + this.tokenBucket.interval - l);
        setTimeout(function() {
          c.tokenBucket.removeTokens(a, f);
        }, h);
      }
      return !1;
    }
    return this.tokenBucket.removeTokens(a, f);
    function f(d, p) {
      if (d) return u(d, null);
      c.tokensThisInterval += a, u(null, p);
    }
  }, tryRemoveTokens: function(a) {
    if (a > this.tokenBucket.bucketSize) return !1;
    var u = s();
    if ((u < this.curIntervalStart || u - this.curIntervalStart >= this.tokenBucket.interval) && (this.curIntervalStart = u, this.tokensThisInterval = 0), a > this.tokenBucket.tokensPerInterval - this.tokensThisInterval) return !1;
    var c = this.tokenBucket.tryRemoveTokens(a);
    return c && (this.tokensThisInterval += a), c;
  }, getTokensRemaining: function() {
    return this.tokenBucket.drip(), this.tokenBucket.content;
  } }, t.exports = o;
}, 3085: (t, e, n) => {
  var i = n(717);
  t.exports = function() {
    if (i !== void 0 && i.hrtime) {
      var r = i.hrtime(), s = r[0], o = r[1];
      return 1e3 * s + Math.floor(o / 1e6);
    }
    return (/* @__PURE__ */ new Date()).getTime();
  };
}, 3198: (t) => {
  t.exports = class {
    constructor(e) {
      this.decoder = new TextDecoder(e === "utf16le" ? "utf16-le" : e);
    }
    get remaining() {
      return -1;
    }
    decode(e) {
      return this.decoder.decode(e, { stream: !0 });
    }
    flush() {
      return this.decoder.decode(new Uint8Array(0));
    }
  };
}, 3208: () => {
}, 3278: () => {
}, 3468: () => {
  typeof ReadableStream < "u" && (ReadableStream.prototype[Symbol.asyncIterator] || (ReadableStream.prototype[Symbol.asyncIterator] = function({ preventCancel: t } = {}) {
    const e = this.getReader(), n = this;
    let i = e.read();
    return { next() {
      const r = i;
      return i = e.read(), r;
    }, return: async (r) => (await i, e.releaseLock(), t || n.cancel(), { done: !0, value: r }), async throw(r) {
      throw await this.return(), r;
    }, [Symbol.asyncIterator]() {
      return this;
    } };
  }), ReadableStream.prototype.getIterator || (ReadableStream.prototype.getIterator = function({ preventCancel: t } = {}) {
    return this[Symbol.asyncIterator]({ preventCancel: t });
  }));
}, 3519: (t, e, n) => {
  var i = n(6587);
  function r(o) {
    var a = function() {
      return a.called ? a.value : (a.called = !0, a.value = o.apply(this, arguments));
    };
    return a.called = !1, a;
  }
  function s(o) {
    var a = function() {
      if (a.called) throw new Error(a.onceError);
      return a.called = !0, a.value = o.apply(this, arguments);
    }, u = o.name || "Function wrapped with `once`";
    return a.onceError = u + " shouldn't be called more than once", a.called = !1, a;
  }
  t.exports = i(r), t.exports.strict = i(s), r.proto = r(function() {
    Object.defineProperty(Function.prototype, "once", { value: function() {
      return r(this);
    }, configurable: !0 }), Object.defineProperty(Function.prototype, "onceStrict", { value: function() {
      return s(this);
    }, configurable: !0 });
  });
}, 3714: (t, e, n) => {
  const i = n(9596);
  t.exports = class {
    constructor(r) {
      if (this.store = r, this.chunkLength = r.chunkLength, !this.store || !this.store.get || !this.store.put) throw new Error("First argument must be abstract-chunk-store compliant");
      this.mem = [];
    }
    put(r, s, o = () => {
    }) {
      this.mem[r] = s, this.store.put(r, s, (a) => {
        this.mem[r] = null, o(a);
      });
    }
    get(r, s, o = () => {
    }) {
      if (typeof s == "function") return this.get(r, null, s);
      let a = this.mem[r];
      if (!a) return this.store.get(r, s, o);
      s || (s = {});
      const u = s.offset || 0, c = s.length || a.length - u;
      u === 0 && c === a.length || (a = a.slice(u, c + u)), i(() => o(null, a));
    }
    close(r = () => {
    }) {
      this.store.close(r);
    }
    destroy(r = () => {
    }) {
      this.store.destroy(r);
    }
  };
}, 3970: () => {
}, 4018: (t) => {
  t.exports = function() {
    for (var e = navigator.hardwareConcurrency || 1, n = [], i = 0; i < e; i++) n.push({ model: "", speed: 0, times: { user: 0, nice: 0, sys: 0, idle: 0, irq: 0 } });
    return n;
  };
}, 4043: () => {
}, 4343: () => {
}, 4497: (t, e, n) => {
  const i = n(8454), r = n(9596);
  t.exports = class {
    constructor(s, o) {
      if (this.store = s, this.chunkLength = s.chunkLength, this.inProgressGets = /* @__PURE__ */ new Map(), !this.store || !this.store.get || !this.store.put) throw new Error("First argument must be abstract-chunk-store compliant");
      this.cache = new i(o);
    }
    put(s, o, a = () => {
    }) {
      if (!this.cache) return r(() => a(new Error("CacheStore closed")));
      this.cache.remove(s), this.store.put(s, o, a);
    }
    get(s, o, a = () => {
    }) {
      if (typeof o == "function") return this.get(s, null, o);
      if (!this.cache) return r(() => a(new Error("CacheStore closed")));
      o || (o = {});
      let u = this.cache.get(s);
      if (u) {
        const h = o.offset || 0, f = o.length || u.length - h;
        return h === 0 && f === u.length || (u = u.slice(h, f + h)), r(() => a(null, u));
      }
      let c = this.inProgressGets.get(s);
      const l = !!c;
      c || (c = [], this.inProgressGets.set(s, c)), c.push({ opts: o, cb: a }), l || this.store.get(s, (h, f) => {
        h || this.cache == null || this.cache.set(s, f);
        const d = this.inProgressGets.get(s);
        this.inProgressGets.delete(s);
        for (const { opts: p, cb: m } of d) if (h) m(h);
        else {
          const _ = p.offset || 0, y = p.length || f.length - _;
          let b = f;
          _ === 0 && y === f.length || (b = f.slice(_, y + _)), m(null, b);
        }
      });
    }
    close(s = () => {
    }) {
      if (!this.cache) return r(() => s(new Error("CacheStore closed")));
      this.cache = null, this.store.close(s);
    }
    destroy(s = () => {
    }) {
      if (!this.cache) return r(() => s(new Error("CacheStore closed")));
      this.cache = null, this.store.destroy(s);
    }
  };
}, 4862: (t, e, n) => {
  t.exports = r;
  const i = n(9596);
  function r(s, o) {
    if (!(this instanceof r)) return new r(s, o);
    if (o || (o = {}), this.chunkLength = Number(s), !this.chunkLength) throw new Error("First argument must be a chunk length");
    this.chunks = [], this.closed = !1, this.length = Number(o.length) || 1 / 0, this.length !== 1 / 0 && (this.lastChunkLength = this.length % this.chunkLength || this.chunkLength, this.lastChunkIndex = Math.ceil(this.length / this.chunkLength) - 1);
  }
  r.prototype.put = function(s, o, a = () => {
  }) {
    if (this.closed) return i(() => a(new Error("Storage is closed")));
    const u = s === this.lastChunkIndex;
    return u && o.length !== this.lastChunkLength ? i(() => a(new Error("Last chunk length must be " + this.lastChunkLength))) : u || o.length === this.chunkLength ? (this.chunks[s] = o, void i(() => a(null))) : i(() => a(new Error("Chunk length must be " + this.chunkLength)));
  }, r.prototype.get = function(s, o, a = () => {
  }) {
    if (typeof o == "function") return this.get(s, null, o);
    if (this.closed) return i(() => a(new Error("Storage is closed")));
    let u = this.chunks[s];
    if (!u) {
      const h = new Error("Chunk not found");
      return h.notFound = !0, i(() => a(h));
    }
    o || (o = {});
    const c = o.offset || 0, l = o.length || u.length - c;
    c === 0 && l === u.length || (u = u.slice(c, l + c)), i(() => a(null, u));
  }, r.prototype.close = r.prototype.destroy = function(s = () => {
  }) {
    if (this.closed) return i(() => s(new Error("Storage is closed")));
    this.closed = !0, this.chunks = null, i(() => s(null));
  };
}, 5335: (t, e, n) => {
  const i = n(3198), r = n(3198);
  t.exports = class {
    constructor(s = "utf8") {
      switch (this.encoding = function(o) {
        switch (o = o.toLowerCase()) {
          case "utf8":
          case "utf-8":
            return "utf8";
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return "utf16le";
          case "latin1":
          case "binary":
            return "latin1";
          case "base64":
          case "ascii":
          case "hex":
            return o;
          default:
            throw new Error("Unknown encoding: " + o);
        }
      }(s), this.encoding) {
        case "utf8":
          this.decoder = new r();
          break;
        case "utf16le":
        case "base64":
          throw new Error("Unsupported encoding: " + this.encoding);
        default:
          this.decoder = new i(this.encoding);
      }
    }
    get remaining() {
      return this.decoder.remaining;
    }
    push(s) {
      return typeof s == "string" ? s : this.decoder.decode(s);
    }
    write(s) {
      return this.push(s);
    }
    end(s) {
      let o = "";
      return s && (o = this.push(s)), o += this.decoder.flush(), o;
    }
  };
}, 5372: (t, e, n) => {
  t.exports = function(r, s, o) {
    if (typeof s != "number") throw new Error("second argument must be a Number");
    let a, u, c, l, h, f, d = !0;
    Array.isArray(r) ? (a = [], c = u = r.length) : (l = Object.keys(r), a = {}, c = u = l.length);
    function p(_) {
      function y() {
        o && o(_, a), o = null;
      }
      d ? i(y) : y();
    }
    function m(_, y, b) {
      if (a[_] = b, y && (h = !0), --c == 0 || y) p(y);
      else if (!h && f < u) {
        let g;
        l ? (g = l[f], f += 1, r[g](function(v, w) {
          m(g, v, w);
        })) : (g = f, f += 1, r[g](function(v, w) {
          m(g, v, w);
        }));
      }
    }
    f = s, c ? l ? l.some(function(_, y) {
      return r[_](function(b, g) {
        m(_, b, g);
      }), y === s - 1;
    }) : r.some(function(_, y) {
      return _(function(b, g) {
        m(y, b, g);
      }), y === s - 1;
    }) : p(null), d = !1;
  };
  const i = n(9596);
}, 5472: (t, e, n) => {
  var i = n(717), r = function(s, o, a, u) {
    if (this.bucketSize = s, this.tokensPerInterval = o, typeof a == "string") switch (a) {
      case "sec":
      case "second":
        this.interval = 1e3;
        break;
      case "min":
      case "minute":
        this.interval = 6e4;
        break;
      case "hr":
      case "hour":
        this.interval = 36e5;
        break;
      case "day":
        this.interval = 864e5;
        break;
      default:
        throw new Error("Invaid interval " + a);
    }
    else this.interval = a;
    this.parentBucket = u, this.content = 0, this.lastDrip = +/* @__PURE__ */ new Date();
  };
  r.prototype = { bucketSize: 1, tokensPerInterval: 1, interval: 1e3, parentBucket: null, content: 0, lastDrip: 0, removeTokens: function(s, o) {
    var a = this;
    return this.bucketSize ? s > this.bucketSize ? (i.nextTick(o.bind(null, "Requested tokens " + s + " exceeds bucket size " + this.bucketSize, null)), !1) : (this.drip(), s > this.content ? u() : this.parentBucket ? this.parentBucket.removeTokens(s, function(c, l) {
      return c ? o(c, null) : s > a.content ? u() : (a.content -= s, void o(null, Math.min(l, a.content)));
    }) : (this.content -= s, i.nextTick(o.bind(null, null, this.content)), !0)) : (i.nextTick(o.bind(null, null, s, Number.POSITIVE_INFINITY)), !0);
    function u() {
      var c = Math.ceil((s - a.content) * (a.interval / a.tokensPerInterval));
      return setTimeout(function() {
        a.removeTokens(s, o);
      }, c), !1;
    }
  }, tryRemoveTokens: function(s) {
    return !this.bucketSize || !(s > this.bucketSize) && (this.drip(), !(s > this.content) && !(this.parentBucket && !this.parentBucket.tryRemoveTokens(s)) && (this.content -= s, !0));
  }, drip: function() {
    if (this.tokensPerInterval) {
      var s = +/* @__PURE__ */ new Date(), o = Math.max(s - this.lastDrip, 0);
      this.lastDrip = s;
      var a = o * (this.tokensPerInterval / this.interval);
      this.content = Math.min(this.content + a, this.bucketSize);
    } else this.content = this.bucketSize;
  } }, t.exports = r;
}, 5658: (t, e, n) => {
  n.r(e), n.d(e, { default: () => _, enableSecure: () => m });
  var i = n(7007), r = n(8179), s = n(1314), o = n(7833), a = n(6458);
  const u = "tcpIncoming", c = "tcpOutgoing", l = "utpIncoming", h = "utpOutgoing", f = "webSeed", d = o("webtorrent:peer");
  let p = !1;
  const m = () => {
    p = !0;
  };
  class _ extends i {
    constructor(b, g) {
      super(), this.id = b, this.type = g, d("new %s Peer %s", g, b), this.addr = null, this.conn = null, this.swarm = null, this.wire = null, this.source = null, this.connected = !1, this.destroyed = !1, this.timeout = null, this.retries = 0, this.sentPe1 = !1, this.sentPe2 = !1, this.sentPe3 = !1, this.sentPe4 = !1, this.sentHandshake = !1;
    }
    onConnect() {
      if (this.destroyed) return;
      this.connected = !0, d("Peer %s connected", this.id), clearTimeout(this.connectTimeout);
      const b = this.conn;
      b.once("end", () => {
        this.destroy();
      }), b.once("close", () => {
        this.destroy();
      }), b.once("finish", () => {
        this.destroy();
      }), b.once("error", (v) => {
        this.destroy(v);
      });
      const g = this.wire = new a.A(this.type, this.retries, p);
      g.once("end", () => {
        this.destroy();
      }), g.once("close", () => {
        this.destroy();
      }), g.once("finish", () => {
        this.destroy();
      }), g.once("error", (v) => {
        this.destroy(v);
      }), g.once("pe1", () => {
        this.onPe1();
      }), g.once("pe2", () => {
        this.onPe2();
      }), g.once("pe3", () => {
        this.onPe3();
      }), g.once("pe4", () => {
        this.onPe4();
      }), g.once("handshake", (v, w) => {
        this.onHandshake(v, w);
      }), this.startHandshakeTimeout(), this.setThrottlePipes(), this.swarm && (this.type === "tcpOutgoing" ? p && this.retries === 0 && !this.sentPe1 ? this.sendPe1() : this.sentHandshake || this.handshake() : this.type === "tcpIncoming" || this.sentHandshake || this.handshake());
    }
    sendPe1() {
      this.wire.sendPe1(), this.sentPe1 = !0;
    }
    onPe1() {
      this.sendPe2();
    }
    sendPe2() {
      this.wire.sendPe2(), this.sentPe2 = !0;
    }
    onPe2() {
      this.sendPe3();
    }
    sendPe3() {
      this.wire.sendPe3(this.swarm.infoHash), this.sentPe3 = !0;
    }
    onPe3(b) {
      this.swarm && (this.swarm.infoHashHash !== b && this.destroy(new Error("unexpected crypto handshake info hash for this swarm")), this.sendPe4());
    }
    sendPe4() {
      this.wire.sendPe4(this.swarm.infoHash), this.sentPe4 = !0;
    }
    onPe4() {
      this.sentHandshake || this.handshake();
    }
    clearPipes() {
      this.conn.unpipe(), this.wire.unpipe();
    }
    setThrottlePipes() {
      const b = this;
      (0, r.pipeline)(this.conn, this.throttleGroups.down.throttle(), new r.Transform({ transform(g, v) {
        b.emit("download", g.length), b.destroyed || v(null, g);
      } }), this.wire, this.throttleGroups.up.throttle(), new r.Transform({ transform(g, v) {
        b.emit("upload", g.length), b.destroyed || v(null, g);
      } }), this.conn);
    }
    onHandshake(b, g) {
      if (!this.swarm || this.destroyed) return;
      if (this.swarm.destroyed) return this.destroy(new Error("swarm already destroyed"));
      if (b !== this.swarm.infoHash) return this.destroy(new Error("unexpected handshake info hash for this swarm"));
      if (g === this.swarm.peerId) return this.destroy(new Error("refusing to connect to ourselves"));
      d("Peer %s got handshake %s", this.id, b), clearTimeout(this.handshakeTimeout), this.retries = 0;
      let v = this.addr;
      !v && this.conn.remoteAddress && this.conn.remotePort && (v = `${this.conn.remoteAddress}:${this.conn.remotePort}`), this.swarm._onWire(this.wire, v), this.swarm && !this.swarm.destroyed && (this.sentHandshake || this.handshake());
    }
    handshake() {
      const b = { dht: !this.swarm.private && !!this.swarm.client.dht, fast: !0 };
      this.wire.handshake(this.swarm.infoHash, this.swarm.client.peerId, b), this.sentHandshake = !0;
    }
    startConnectTimeout() {
      clearTimeout(this.connectTimeout);
      const b = { webrtc: 25e3, tcpOutgoing: 5e3, utpOutgoing: 5e3 };
      this.connectTimeout = setTimeout(() => {
        this.destroy(new Error("connect timeout"));
      }, b[this.type]), this.connectTimeout.unref && this.connectTimeout.unref();
    }
    startHandshakeTimeout() {
      clearTimeout(this.handshakeTimeout), this.handshakeTimeout = setTimeout(() => {
        this.destroy(new Error("handshake timeout"));
      }, 25e3), this.handshakeTimeout.unref && this.handshakeTimeout.unref();
    }
    destroy(b) {
      if (this.destroyed) return;
      this.destroyed = !0, this.connected = !1, d("destroy %s %s (error: %s)", this.type, this.id, b && (b.message || b)), clearTimeout(this.connectTimeout), clearTimeout(this.handshakeTimeout);
      const g = this.swarm, v = this.conn, w = this.wire;
      this.swarm = null, this.conn = null, this.wire = null, g && w && s(g.wires, g.wires.indexOf(w)), v && (v.on("error", () => {
      }), v.destroy()), w && w.destroy(), g && g.removePeer(this.id);
    }
  }
  _.TYPE_TCP_INCOMING = u, _.TYPE_TCP_OUTGOING = c, _.TYPE_UTP_INCOMING = l, _.TYPE_UTP_OUTGOING = h, _.TYPE_WEBRTC = "webrtc", _.TYPE_WEBSEED = f, _.SOURCE_MANUAL = "manual", _.SOURCE_TRACKER = "tracker", _.SOURCE_DHT = "dht", _.SOURCE_LSD = "lsd", _.SOURCE_UT_PEX = "ut_pex", _.createWebRTCPeer = (y, b, g, v = null) => {
    const w = new _(y.id, "webrtc");
    if (w.conn = y, w.swarm = b, w.throttleGroups = g, w.source = v, w.conn.connected) w.onConnect();
    else {
      const E = () => {
        w.conn.removeListener("connect", A), w.conn.removeListener("error", C);
      }, A = () => {
        E(), w.onConnect();
      }, C = (O) => {
        E(), w.destroy(O);
      };
      w.conn.once("connect", A), w.conn.once("error", C), w.startConnectTimeout();
    }
    return w;
  }, _.createTCPIncomingPeer = (y, b) => _._createIncomingPeer(y, u, b), _.createUTPIncomingPeer = (y, b) => _._createIncomingPeer(y, l, b), _.createTCPOutgoingPeer = (y, b, g, v) => _._createOutgoingPeer(y, b, c, g, v), _.createUTPOutgoingPeer = (y, b, g, v) => _._createOutgoingPeer(y, b, h, g, v), _._createIncomingPeer = (y, b, g) => {
    const v = `${y.remoteAddress}:${y.remotePort}`, w = new _(v, b);
    return w.conn = y, w.addr = v, w.throttleGroups = g, w.onConnect(), w;
  }, _._createOutgoingPeer = (y, b, g, v, w = null) => {
    const E = new _(y, g);
    return E.addr = y, E.swarm = b, E.throttleGroups = v, E.source = w, E;
  }, _.createWebSeedPeer = (y, b, g, v) => {
    const w = new _(b, f);
    return w.swarm = g, w.conn = y, w.throttleGroups = v, w.onConnect(), w;
  };
}, 5809: (t) => {
  t.exports = class {
    constructor(e) {
      if (!(e > 0) || e - 1 & e) throw new Error("Max size for a FixedFIFO should be a power of two");
      this.buffer = new Array(e), this.mask = e - 1, this.top = 0, this.btm = 0, this.next = null;
    }
    clear() {
      this.top = this.btm = 0, this.next = null, this.buffer.fill(void 0);
    }
    push(e) {
      return this.buffer[this.top] === void 0 && (this.buffer[this.top] = e, this.top = this.top + 1 & this.mask, !0);
    }
    shift() {
      const e = this.buffer[this.btm];
      if (e !== void 0) return this.buffer[this.btm] = void 0, this.btm = this.btm + 1 & this.mask, e;
    }
    peek() {
      return this.buffer[this.btm];
    }
    isEmpty() {
      return this.buffer[this.btm] === void 0;
    }
  };
}, 6080: (t, e, n) => {
  const i = n(5809);
  t.exports = class {
    constructor(r) {
      this.hwm = r || 16, this.head = new i(this.hwm), this.tail = this.head, this.length = 0;
    }
    clear() {
      this.head = this.tail, this.head.clear(), this.length = 0;
    }
    push(r) {
      if (this.length++, !this.head.push(r)) {
        const s = this.head;
        this.head = s.next = new i(2 * this.head.buffer.length), this.head.push(r);
      }
    }
    shift() {
      this.length !== 0 && this.length--;
      const r = this.tail.shift();
      if (r === void 0 && this.tail.next) {
        const s = this.tail.next;
        return this.tail.next = null, this.tail = s, this.tail.shift();
      }
      return r;
    }
    peek() {
      const r = this.tail.peek();
      return r === void 0 && this.tail.next ? this.tail.next.peek() : r;
    }
    isEmpty() {
      return this.length === 0;
    }
  };
}, 6310: (t) => {
  function e(n, i) {
    for (const r in i) Object.defineProperty(n, r, { value: i[r], enumerable: !0, configurable: !0 });
    return n;
  }
  t.exports = function(n, i, r) {
    if (!n || typeof n == "string") throw new TypeError("Please pass an Error to err-code");
    r || (r = {}), typeof i == "object" && (r = i, i = ""), i && (r.code = i);
    try {
      return e(n, r);
    } catch {
      r.message = n.message, r.stack = n.stack;
      const o = function() {
      };
      return o.prototype = Object.create(Object.getPrototypeOf(n)), e(new o(), r);
    }
  };
}, 6458: (t, e, n) => {
  n.d(e, { A: () => x });
  var i = n(988), r = n(3033), s = n(7264), o = n(7833), a = n(8727), u = n(8179), c = n(9639), l = n(1035), h = n(1314);
  const f = o("bittorrent-protocol"), d = (0, c.L0)("BitTorrent protocol"), p = new Uint8Array([0, 0, 0, 0]), m = new Uint8Array([0, 0, 0, 1, 0]), _ = new Uint8Array([0, 0, 0, 1, 1]), y = new Uint8Array([0, 0, 0, 1, 2]), b = new Uint8Array([0, 0, 0, 1, 3]), g = [0, 0, 0, 0, 0, 0, 0, 0], v = [0, 0, 0, 3, 9, 0, 0], w = new Uint8Array([0, 0, 0, 1, 14]), E = new Uint8Array([0, 0, 0, 1, 15]), A = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]), C = new Uint8Array([0, 0, 1, 2]), O = new Uint8Array([0, 0, 0, 2]);
  function R(I, F) {
    for (let T = I.length; T--; ) I[T] ^= F[T];
    return I;
  }
  class P {
    constructor(F, T, L, M) {
      this.piece = F, this.offset = T, this.length = L, this.callback = M;
    }
  }
  class k {
    constructor() {
      this.buffer = new Uint8Array();
    }
    get(F) {
      return !0;
    }
    set(F) {
    }
  }
  class S extends u.Duplex {
    constructor(F = null, T = 0, L = !1) {
      super(), this._debugId = (0, c.V5)((0, c.po)(4)), this._debug("new wire"), this.peerId = null, this.peerIdBuffer = null, this.type = F, this.amChoking = !0, this.amInterested = !1, this.peerChoking = !0, this.peerInterested = !1, this.peerPieces = new r.A(0, { grow: 4e5 }), this.extensions = {}, this.peerExtensions = {}, this.requests = [], this.peerRequests = [], this.extendedMapping = {}, this.peerExtendedMapping = {}, this.extendedHandshake = {}, this.peerExtendedHandshake = {}, this.hasFast = !1, this.allowedFastSet = [], this.peerAllowedFastSet = [], this._ext = {}, this._nextExt = 1, this.uploaded = 0, this.downloaded = 0, this.uploadSpeed = l(), this.downloadSpeed = l(), this._keepAliveInterval = null, this._timeout = null, this._timeoutMs = 0, this._timeoutExpiresAt = null, this._finished = !1, this._parserSize = 0, this._parser = null, this._buffer = [], this._bufferSize = 0, this._peEnabled = L, L ? (this._dh = s.createDiffieHellman("ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a36210000000000090563", "hex", 2), this._myPubKey = this._dh.generateKeys("hex")) : this._myPubKey = null, this._peerPubKey = null, this._sharedSecret = null, this._peerCryptoProvide = [], this._cryptoHandshakeDone = !1, this._cryptoSyncPattern = null, this._waitMaxBytes = null, this._encryptionMethod = null, this._encryptGenerator = null, this._decryptGenerator = null, this._setGenerators = !1, this.once("finish", () => this._onFinish()), this.on("finish", this._onFinish), this._debug("type:", this.type), this.type === "tcpIncoming" && this._peEnabled ? this._determineHandshakeType() : this.type === "tcpOutgoing" && this._peEnabled && T === 0 ? this._parsePe2() : this._parseHandshake(null);
    }
    setKeepAlive(F) {
      this._debug("setKeepAlive %s", F), clearInterval(this._keepAliveInterval), F !== !1 && (this._keepAliveInterval = setInterval(() => {
        this.keepAlive();
      }, 55e3));
    }
    setTimeout(F, T) {
      this._debug("setTimeout ms=%d unref=%s", F, T), this._timeoutMs = F, this._timeoutUnref = !!T, this._resetTimeout(!0);
    }
    destroy() {
      if (!this.destroyed) return this._debug("destroy"), this.end(), this;
    }
    end(F) {
      if (!this.destroyed && !this.destroying) return this._debug("end"), this._onUninterested(), this._onChoke(), super.end(F);
    }
    use(F) {
      const T = F.prototype.name;
      if (!T) throw new Error('Extension class requires a "name" property on the prototype');
      this._debug("use extension.name=%s", T);
      const L = this._nextExt, M = new F(this);
      function U() {
      }
      typeof M.onHandshake != "function" && (M.onHandshake = U), typeof M.onExtendedHandshake != "function" && (M.onExtendedHandshake = U), typeof M.onMessage != "function" && (M.onMessage = U), this.extendedMapping[L] = T, this._ext[T] = M, this[T] = M, this._nextExt += 1;
    }
    keepAlive() {
      this._debug("keep-alive"), this._push(p);
    }
    sendPe1() {
      if (this._peEnabled) {
        const F = Math.floor(513 * Math.random()), T = (0, c.po)(F);
        this._push((0, c.xW)([(0, c.fk)(this._myPubKey), T]));
      }
    }
    sendPe2() {
      const F = Math.floor(513 * Math.random()), T = (0, c.po)(F);
      this._push((0, c.xW)([(0, c.fk)(this._myPubKey), T]));
    }
    async sendPe3(F) {
      await this.setEncrypt(this._sharedSecret, F);
      const T = await (0, c.tW)((0, c.fk)(this._utfToHex("req1") + this._sharedSecret)), L = R(await (0, c.tW)((0, c.fk)(this._utfToHex("req2") + F)), await (0, c.tW)((0, c.fk)(this._utfToHex("req3") + this._sharedSecret))), M = new DataView((0, c.po)(2).buffer).getUint16(0) % 512, U = (0, c.po)(M);
      let $ = new Uint8Array(14 + M + 2);
      $.set(A), $.set(C, 8);
      const z = new DataView($.buffer);
      z.setInt16(12, M), U.copy($, 14), z.setInt16(14 + M, 0), $ = this._encryptHandshake($), this._push((0, c.xW)([T, L, $]));
    }
    async sendPe4(F) {
      await this.setEncrypt(this._sharedSecret, F);
      const T = new DataView((0, c.po)(2).buffer).getUint16(0) % 512, L = (0, c.po)(T);
      let M = new Uint8Array(14 + T);
      const U = new DataView(M.buffer);
      M.set(A), M.set(O, 8), U.setInt16(12, T), M.set(L, 14), M = this._encryptHandshake(M), this._push(M), this._cryptoHandshakeDone = !0, this._debug("completed crypto handshake");
    }
    handshake(F, T, L) {
      let M, U;
      if (typeof F == "string" ? (F = F.toLowerCase(), M = (0, c.fk)(F)) : (M = F, F = (0, c.V5)(M)), typeof T == "string" ? U = (0, c.fk)(T) : (U = T, T = (0, c.V5)(U)), this._infoHash = M, M.length !== 20 || U.length !== 20) throw new Error("infoHash and peerId MUST have length 20");
      this._debug("handshake i=%s p=%s exts=%o", F, T, L);
      const $ = new Uint8Array(g);
      this.extensions = { extended: !0, dht: !(!L || !L.dht), fast: !(!L || !L.fast) }, $[5] |= 16, this.extensions.dht && ($[7] |= 1), this.extensions.fast && ($[7] |= 4), this.extensions.fast && this.peerExtensions.fast && (this._debug("fast extension is enabled"), this.hasFast = !0), this._push((0, c.xW)([d, $, M, U])), this._handshakeSent = !0, this.peerExtensions.extended && !this._extendedHandshakeSent && this._sendExtendedHandshake();
    }
    _sendExtendedHandshake() {
      const F = Object.assign({}, this.extendedHandshake);
      F.m = {};
      for (const T in this.extendedMapping) {
        const L = this.extendedMapping[T];
        F.m[L] = Number(T);
      }
      this.extended(0, i.A.encode(F)), this._extendedHandshakeSent = !0;
    }
    choke() {
      if (!this.amChoking) if (this.amChoking = !0, this._debug("choke"), this._push(m), this.hasFast) {
        let F = 0;
        for (; this.peerRequests.length > F; ) {
          const T = this.peerRequests[F];
          this.allowedFastSet.includes(T.piece) ? ++F : this.reject(T.piece, T.offset, T.length);
        }
      } else for (; this.peerRequests.length; ) this.peerRequests.pop();
    }
    unchoke() {
      this.amChoking && (this.amChoking = !1, this._debug("unchoke"), this._push(_));
    }
    interested() {
      this.amInterested || (this.amInterested = !0, this._debug("interested"), this._push(y));
    }
    uninterested() {
      this.amInterested && (this.amInterested = !1, this._debug("uninterested"), this._push(b));
    }
    have(F) {
      this._debug("have %d", F), this._message(4, [F], null);
    }
    bitfield(F) {
      this._debug("bitfield"), ArrayBuffer.isView(F) || (F = F.buffer), this._message(5, [], F);
    }
    request(F, T, L, M) {
      return M || (M = () => {
      }), this._finished ? M(new Error("wire is closed")) : !this.peerChoking || this.hasFast && this.peerAllowedFastSet.includes(F) ? (this._debug("request index=%d offset=%d length=%d", F, T, L), this.requests.push(new P(F, T, L, M)), this._timeout || this._resetTimeout(!0), void this._message(6, [F, T, L], null)) : M(new Error("peer is choking"));
    }
    piece(F, T, L) {
      this._debug("piece index=%d offset=%d", F, T), this._message(7, [F, T], L), this.uploaded += L.length, this.uploadSpeed(L.length), this.emit("upload", L.length);
    }
    cancel(F, T, L) {
      this._debug("cancel index=%d offset=%d length=%d", F, T, L), this._callback(this._pull(this.requests, F, T, L), new Error("request was cancelled"), null), this._message(8, [F, T, L], null);
    }
    port(F) {
      this._debug("port %d", F);
      const T = new Uint8Array(v);
      new DataView(T.buffer).setUint16(5, F), this._push(T);
    }
    suggest(F) {
      if (!this.hasFast) throw Error("fast extension is disabled");
      this._debug("suggest %d", F), this._message(13, [F], null);
    }
    haveAll() {
      if (!this.hasFast) throw Error("fast extension is disabled");
      this._debug("have-all"), this._push(w);
    }
    haveNone() {
      if (!this.hasFast) throw Error("fast extension is disabled");
      this._debug("have-none"), this._push(E);
    }
    reject(F, T, L) {
      if (!this.hasFast) throw Error("fast extension is disabled");
      this._debug("reject index=%d offset=%d length=%d", F, T, L), this._pull(this.peerRequests, F, T, L), this._message(16, [F, T, L], null);
    }
    allowedFast(F) {
      if (!this.hasFast) throw Error("fast extension is disabled");
      this._debug("allowed-fast %d", F), this.allowedFastSet.includes(F) || this.allowedFastSet.push(F), this._message(17, [F], null);
    }
    extended(F, T) {
      if (this._debug("extended ext=%s", F), typeof F == "string" && this.peerExtendedMapping[F] && (F = this.peerExtendedMapping[F]), typeof F != "number") throw new Error(`Unrecognized extension: ${F}`);
      {
        const L = new Uint8Array([F]), M = ArrayBuffer.isView(T) ? T : i.A.encode(T);
        this._message(20, [], (0, c.xW)([L, M]));
      }
    }
    async setEncrypt(F, T) {
      let L, M, U, $;
      switch (this.type) {
        case "tcpIncoming":
          L = await (0, c.tW)((0, c.fk)(this._utfToHex("keyB") + F + T)), U = await (0, c.tW)((0, c.fk)(this._utfToHex("keyA") + F + T)), M = [];
          for (const z of L.values()) M.push(z);
          $ = [];
          for (const z of U.values()) $.push(z);
          this._encryptGenerator = new a(M), this._decryptGenerator = new a($);
          break;
        case "tcpOutgoing":
          L = await (0, c.tW)((0, c.fk)(this._utfToHex("keyA") + F + T)), U = await (0, c.tW)((0, c.fk)(this._utfToHex("keyB") + F + T)), M = [];
          for (const z of L.values()) M.push(z);
          $ = [];
          for (const z of U.values()) $.push(z);
          this._encryptGenerator = new a(M), this._decryptGenerator = new a($);
          break;
        default:
          return !1;
      }
      for (let z = 0; z < 1024; z++) this._encryptGenerator.randomByte(), this._decryptGenerator.randomByte();
      return this._setGenerators = !0, !0;
    }
    _message(F, T, L) {
      const M = L ? L.length : 0, U = new Uint8Array(5 + 4 * T.length), $ = new DataView(U.buffer);
      $.setUint32(0, U.length + M - 4), U[4] = F;
      for (let z = 0; z < T.length; z++) $.setUint32(5 + 4 * z, T[z]);
      this._push(U), L && this._push(L);
    }
    _push(F) {
      if (!this._finished) return this._encryptionMethod === 2 && this._cryptoHandshakeDone && (F = this._encrypt(F)), this.push(F);
    }
    _onKeepAlive() {
      this._debug("got keep-alive"), this.emit("keep-alive");
    }
    _onPe1(F) {
      this._peerPubKey = (0, c.V5)(F), this._sharedSecret = this._dh.computeSecret(this._peerPubKey, "hex", "hex"), this.emit("pe1");
    }
    _onPe2(F) {
      this._peerPubKey = (0, c.V5)(F), this._sharedSecret = this._dh.computeSecret(this._peerPubKey, "hex", "hex"), this.emit("pe2");
    }
    async _onPe3(F) {
      const T = await (0, c.V5)(this._utfToHex("req3") + this._sharedSecret), L = (0, c.V5)(R(T, F));
      this.emit("pe3", L);
    }
    _onPe3Encrypted(F, T) {
      if (!(0, c.LC)(F, A)) return this._debug("Error: verification constant did not match"), void this.destroy();
      for (const L of T.values()) L !== 0 && this._peerCryptoProvide.push(L);
      this._peerCryptoProvide.includes(2) ? this._encryptionMethod = 2 : (this._debug("Error: RC4 encryption method not provided by peer"), this.destroy());
    }
    _onPe4(F) {
      this._encryptionMethod = F[3], C.includes(this._encryptionMethod) || (this._debug("Error: peer selected invalid crypto method"), this.destroy()), this._cryptoHandshakeDone = !0, this._debug("crypto handshake done"), this.emit("pe4");
    }
    _onHandshake(F, T, L) {
      const M = (0, c.V5)(F), U = (0, c.V5)(T);
      this._debug("got handshake i=%s p=%s exts=%o", M, U, L), this.peerId = U, this.peerIdBuffer = T, this.peerExtensions = L, this.extensions.fast && this.peerExtensions.fast && (this._debug("fast extension is enabled"), this.hasFast = !0), this.emit("handshake", M, U, L);
      for (const $ in this._ext) this._ext[$].onHandshake(M, U, L);
      L.extended && this._handshakeSent && !this._extendedHandshakeSent && this._sendExtendedHandshake();
    }
    _onChoke() {
      if (this.peerChoking = !0, this._debug("got choke"), this.emit("choke"), !this.hasFast) for (; this.requests.length; ) this._callback(this.requests.pop(), new Error("peer is choking"), null);
    }
    _onUnchoke() {
      this.peerChoking = !1, this._debug("got unchoke"), this.emit("unchoke");
    }
    _onInterested() {
      this.peerInterested = !0, this._debug("got interested"), this.emit("interested");
    }
    _onUninterested() {
      this.peerInterested = !1, this._debug("got uninterested"), this.emit("uninterested");
    }
    _onHave(F) {
      this.peerPieces.get(F) || (this._debug("got have %d", F), this.peerPieces.set(F, !0), this.emit("have", F));
    }
    _onBitField(F) {
      this.peerPieces = new r.A(F), this._debug("got bitfield"), this.emit("bitfield", this.peerPieces);
    }
    _onRequest(F, T, L) {
      if (this.amChoking && (!this.hasFast || !this.allowedFastSet.includes(F))) return void (this.hasFast && this.reject(F, T, L));
      this._debug("got request index=%d offset=%d length=%d", F, T, L);
      const M = ($, z) => {
        if (U === this._pull(this.peerRequests, F, T, L)) return $ ? (this._debug("error satisfying request index=%d offset=%d length=%d (%s)", F, T, L, $.message), void (this.hasFast && this.reject(F, T, L))) : void this.piece(F, T, z);
      }, U = new P(F, T, L, M);
      this.peerRequests.push(U), this.emit("request", F, T, L, M);
    }
    _onPiece(F, T, L) {
      this._debug("got piece index=%d offset=%d", F, T), this._callback(this._pull(this.requests, F, T, L.length), null, L), this.downloaded += L.length, this.downloadSpeed(L.length), this.emit("download", L.length), this.emit("piece", F, T, L);
    }
    _onCancel(F, T, L) {
      this._debug("got cancel index=%d offset=%d length=%d", F, T, L), this._pull(this.peerRequests, F, T, L), this.emit("cancel", F, T, L);
    }
    _onPort(F) {
      this._debug("got port %d", F), this.emit("port", F);
    }
    _onSuggest(F) {
      if (!this.hasFast) return this._debug("Error: got suggest whereas fast extension is disabled"), void this.destroy();
      this._debug("got suggest %d", F), this.emit("suggest", F);
    }
    _onHaveAll() {
      if (!this.hasFast) return this._debug("Error: got have-all whereas fast extension is disabled"), void this.destroy();
      this._debug("got have-all"), this.peerPieces = new k(), this.emit("have-all");
    }
    _onHaveNone() {
      if (!this.hasFast) return this._debug("Error: got have-none whereas fast extension is disabled"), void this.destroy();
      this._debug("got have-none"), this.emit("have-none");
    }
    _onReject(F, T, L) {
      if (!this.hasFast) return this._debug("Error: got reject whereas fast extension is disabled"), void this.destroy();
      this._debug("got reject index=%d offset=%d length=%d", F, T, L), this._callback(this._pull(this.requests, F, T, L), new Error("request was rejected"), null), this.emit("reject", F, T, L);
    }
    _onAllowedFast(F) {
      if (!this.hasFast) return this._debug("Error: got allowed-fast whereas fast extension is disabled"), void this.destroy();
      this._debug("got allowed-fast %d", F), this.peerAllowedFastSet.includes(F) || this.peerAllowedFastSet.push(F), this.peerAllowedFastSet.length > 100 && this.peerAllowedFastSet.shift(), this.emit("allowed-fast", F);
    }
    _onExtended(F, T) {
      if (F === 0) {
        let L;
        try {
          L = i.A.decode(T);
        } catch (M) {
          this._debug("ignoring invalid extended handshake: %s", M.message || M);
        }
        if (!L) return;
        if (this.peerExtendedHandshake = L, typeof L.m == "object") for (const M in L.m) this.peerExtendedMapping[M] = Number(L.m[M].toString());
        for (const M in this._ext) this.peerExtendedMapping[M] && this._ext[M].onExtendedHandshake(this.peerExtendedHandshake);
        this._debug("got extended handshake"), this.emit("extended", "handshake", this.peerExtendedHandshake);
      } else this.extendedMapping[F] && (F = this.extendedMapping[F], this._ext[F] && this._ext[F].onMessage(T)), this._debug("got extended message ext=%s", F), this.emit("extended", F, T);
    }
    _onTimeout() {
      this._debug("request timed out"), this._callback(this.requests.shift(), new Error("request has timed out"), null), this.emit("timeout");
    }
    _write(F, T) {
      if (this._encryptionMethod === 2 && this._cryptoHandshakeDone && (F = this._decrypt(F)), this._bufferSize += F.length, this._buffer.push(F), this._buffer.length > 1 && (this._buffer = [(0, c.xW)(this._buffer, this._bufferSize)]), this._cryptoSyncPattern) {
        const L = this._buffer[0].indexOf(this._cryptoSyncPattern);
        if (L !== -1) this._buffer[0] = this._buffer[0].slice(L + this._cryptoSyncPattern.length), this._bufferSize -= L + this._cryptoSyncPattern.length, this._cryptoSyncPattern = null;
        else if (this._bufferSize + F.length > this._waitMaxBytes + this._cryptoSyncPattern.length) return this._debug("Error: could not resynchronize"), void this.destroy();
      }
      for (; this._bufferSize >= this._parserSize && !this._cryptoSyncPattern; ) if (this._parserSize === 0) this._parser(new Uint8Array());
      else {
        const L = this._buffer[0];
        this._bufferSize -= this._parserSize, this._buffer = this._bufferSize ? [L.slice(this._parserSize)] : [], this._parser(L.slice(0, this._parserSize));
      }
      T(null);
    }
    _callback(F, T, L) {
      F && (this._resetTimeout(!this.peerChoking && !this._finished), F.callback(T, L));
    }
    _resetTimeout(F) {
      if (!F || !this._timeoutMs || !this.requests.length) return clearTimeout(this._timeout), this._timeout = null, void (this._timeoutExpiresAt = null);
      const T = Date.now() + this._timeoutMs;
      if (this._timeout) {
        if (T - this._timeoutExpiresAt < 0.05 * this._timeoutMs) return;
        clearTimeout(this._timeout);
      }
      this._timeoutExpiresAt = T, this._timeout = setTimeout(() => this._onTimeout(), this._timeoutMs), this._timeoutUnref && this._timeout.unref && this._timeout.unref();
    }
    _parse(F, T) {
      this._parserSize = F, this._parser = T;
    }
    _parseUntil(F, T) {
      this._cryptoSyncPattern = F, this._waitMaxBytes = T;
    }
    _onMessageLength(F) {
      const T = new DataView(F.buffer, F.byteOffset, F.byteLength).getUint32(0);
      T > 0 ? this._parse(T, this._onMessage) : (this._onKeepAlive(), this._parse(4, this._onMessageLength));
    }
    _onMessage(F) {
      this._parse(4, this._onMessageLength);
      const T = new DataView(F.buffer, F.byteOffset, F.byteLength);
      switch (F[0]) {
        case 0:
          return this._onChoke();
        case 1:
          return this._onUnchoke();
        case 2:
          return this._onInterested();
        case 3:
          return this._onUninterested();
        case 4:
          return this._onHave(T.getUint32(1));
        case 5:
          return this._onBitField(F.slice(1));
        case 6:
          return this._onRequest(T.getUint32(1), T.getUint32(5), T.getUint32(9));
        case 7:
          return this._onPiece(T.getUint32(1), T.getUint32(5), F.slice(9));
        case 8:
          return this._onCancel(T.getUint32(1), T.getUint32(5), T.getUint32(9));
        case 9:
          return this._onPort(T.getUint16(1));
        case 13:
          return this._onSuggest(T.getUint32(1));
        case 14:
          return this._onHaveAll();
        case 15:
          return this._onHaveNone();
        case 16:
          return this._onReject(T.getUint32(1), T.getUint32(5), T.getUint32(9));
        case 17:
          return this._onAllowedFast(T.getUint32(1));
        case 20:
          return this._onExtended(F[1], F.slice(2));
        default:
          return this._debug("got unknown message"), this.emit("unknownmessage", F);
      }
    }
    _determineHandshakeType() {
      this._parse(1, (F) => {
        const T = F[0];
        T === 19 ? this._parse(T + 48, this._onHandshakeBuffer) : this._parsePe1(F);
      });
    }
    _parsePe1(F) {
      this._parse(95, (T) => {
        this._onPe1((0, c.xW)([F, T])), this._parsePe3();
      });
    }
    _parsePe2() {
      this._parse(96, (F) => {
        for (this._onPe2(F); !this._setGenerators; ) ;
        this._parsePe4();
      });
    }
    async _parsePe3() {
      const F = await (0, c.tW)((0, c.fk)(this._utfToHex("req1") + this._sharedSecret));
      this._parseUntil(F, 512), this._parse(20, (T) => {
        for (this._onPe3(T); !this._setGenerators; ) ;
        this._parsePe3Encrypted();
      });
    }
    _parsePe3Encrypted() {
      this._parse(14, (F) => {
        const T = this._decryptHandshake(F.slice(0, 8)), L = this._decryptHandshake(F.slice(8, 12)), M = new DataView(this._decryptHandshake(F.slice(12, 14)).buffer).getUint16(0);
        this._parse(M, (U) => {
          U = this._decryptHandshake(U), this._parse(2, ($) => {
            const z = new DataView(this._decryptHandshake($).buffer).getUint16(0);
            this._parse(z, (X) => {
              X = this._decryptHandshake(X), this._onPe3Encrypted(T, L, U, X);
              const J = z ? X[0] : null, K = z ? X.slice(1, 20) : null;
              J === 19 && (0, c.dU)(K) === "BitTorrent protocol" ? this._onHandshakeBuffer(X.slice(1)) : this._parseHandshake();
            });
          });
        });
      });
    }
    _parsePe4() {
      const F = this._decryptHandshake(A);
      this._parseUntil(F, 512), this._parse(6, (T) => {
        const L = this._decryptHandshake(T.slice(0, 4)), M = new DataView(this._decryptHandshake(T.slice(4, 6)).buffer).getUint16(0);
        this._parse(M, (U) => {
          this._decryptHandshake(U), this._onPe4(L), this._parseHandshake(null);
        });
      });
    }
    _parseHandshake() {
      this._parse(1, (F) => {
        const T = F[0];
        if (T !== 19) return this._debug("Error: wire not speaking BitTorrent protocol (%s)", T.toString()), void this.end();
        this._parse(T + 48, this._onHandshakeBuffer);
      });
    }
    _onHandshakeBuffer(F) {
      const T = F.slice(0, 19);
      if ((0, c.dU)(T) !== "BitTorrent protocol") return this._debug("Error: wire not speaking BitTorrent protocol (%s)", (0, c.dU)(T)), void this.end();
      F = F.slice(19), this._onHandshake(F.slice(8, 28), F.slice(28, 48), { dht: !!(1 & F[7]), fast: !!(4 & F[7]), extended: !!(16 & F[5]) }), this._parse(4, this._onMessageLength);
    }
    _onFinish() {
      for (this._finished = !0, this.push(null); this.read(); ) ;
      for (clearInterval(this._keepAliveInterval), this._parse(Number.MAX_VALUE, () => {
      }); this.peerRequests.length; ) this.peerRequests.pop();
      for (; this.requests.length; ) this._callback(this.requests.pop(), new Error("wire was closed"), null);
    }
    _debug(...F) {
      F[0] = `[${this._debugId}] ${F[0]}`, f(...F);
    }
    _pull(F, T, L, M) {
      for (let U = 0; U < F.length; U++) {
        const $ = F[U];
        if ($.piece === T && $.offset === L && $.length === M) return h(F, U), $;
      }
      return null;
    }
    _encryptHandshake(F) {
      const T = new Uint8Array(F);
      if (!this._encryptGenerator) return this._debug("Warning: Encrypting without any generator"), T;
      for (let L = 0; L < F.length; L++) {
        const M = this._encryptGenerator.randomByte();
        T[L] = T[L] ^ M;
      }
      return T;
    }
    _encrypt(F) {
      const T = new Uint8Array(F);
      if (!this._encryptGenerator || this._encryptionMethod !== 2) return T;
      for (let L = 0; L < F.length; L++) {
        const M = this._encryptGenerator.randomByte();
        T[L] = T[L] ^ M;
      }
      return T;
    }
    _decryptHandshake(F) {
      const T = new Uint8Array(F);
      if (!this._decryptGenerator) return this._debug("Warning: Decrypting without any generator"), T;
      for (let L = 0; L < F.length; L++) {
        const M = this._decryptGenerator.randomByte();
        T[L] = T[L] ^ M;
      }
      return T;
    }
    _decrypt(F) {
      const T = new Uint8Array(F);
      if (!this._decryptGenerator || this._encryptionMethod !== 2) return T;
      for (let L = 0; L < F.length; L++) {
        const M = this._decryptGenerator.randomByte();
        T[L] = T[L] ^ M;
      }
      return T;
    }
    _utfToHex(F) {
      return (0, c.V5)((0, c.L0)(F));
    }
  }
  const x = S;
}, 6585: (t) => {
  var e = 1e3, n = 60 * e, i = 60 * n, r = 24 * i, s = 7 * r, o = 365.25 * r;
  function a(u, c, l, h) {
    var f = c >= 1.5 * l;
    return Math.round(u / l) + " " + h + (f ? "s" : "");
  }
  t.exports = function(u, c) {
    c = c || {};
    var l = typeof u;
    if (l === "string" && u.length > 0) return function(h) {
      if (!((h = String(h)).length > 100)) {
        var f = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(h);
        if (f) {
          var d = parseFloat(f[1]);
          switch ((f[2] || "ms").toLowerCase()) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return d * o;
            case "weeks":
            case "week":
            case "w":
              return d * s;
            case "days":
            case "day":
            case "d":
              return d * r;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return d * i;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return d * n;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return d * e;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return d;
            default:
              return;
          }
        }
      }
    }(u);
    if (l === "number" && isFinite(u)) return c.long ? function(h) {
      var f = Math.abs(h);
      return f >= r ? a(h, f, r, "day") : f >= i ? a(h, f, i, "hour") : f >= n ? a(h, f, n, "minute") : f >= e ? a(h, f, e, "second") : h + " ms";
    }(u) : function(h) {
      var f = Math.abs(h);
      return f >= r ? Math.round(h / r) + "d" : f >= i ? Math.round(h / i) + "h" : f >= n ? Math.round(h / n) + "m" : f >= e ? Math.round(h / e) + "s" : h + "ms";
    }(u);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(u));
  };
}, 6587: (t) => {
  t.exports = function e(n, i) {
    if (n && i) return e(n)(i);
    if (typeof n != "function") throw new TypeError("need wrapper function");
    return Object.keys(n).forEach(function(s) {
      r[s] = n[s];
    }), r;
    function r() {
      for (var s = new Array(arguments.length), o = 0; o < s.length; o++) s[o] = arguments[o];
      var a = n.apply(this, s), u = s[s.length - 1];
      return typeof a == "function" && a !== u && Object.keys(u).forEach(function(c) {
        a[c] = u[c];
      }), a;
    }
  };
}, 6611: (t, e, n) => {
  var i = n(717), r = n(3519), s = function() {
  }, o = function(a, u, c) {
    if (typeof u == "function") return o(a, null, u);
    u || (u = {}), c = r(c || s);
    var l = a._writableState, h = a._readableState, f = u.readable || u.readable !== !1 && a.readable, d = u.writable || u.writable !== !1 && a.writable, p = !1, m = function() {
      a.writable || _();
    }, _ = function() {
      d = !1, f || c.call(a);
    }, y = function() {
      f = !1, d || c.call(a);
    }, b = function(A) {
      c.call(a, A ? new Error("exited with error code: " + A) : null);
    }, g = function(A) {
      c.call(a, A);
    }, v = function() {
      i.nextTick(w);
    }, w = function() {
      if (!p) return (!f || h && h.ended && !h.destroyed) && (!d || l && l.ended && !l.destroyed) ? void 0 : c.call(a, new Error("premature close"));
    }, E = function() {
      a.req.on("finish", _);
    };
    return function(A) {
      return A.setHeader && typeof A.abort == "function";
    }(a) ? (a.on("complete", _), a.on("abort", v), a.req ? E() : a.on("request", E)) : d && !l && (a.on("end", m), a.on("close", m)), function(A) {
      return A.stdio && Array.isArray(A.stdio) && A.stdio.length === 3;
    }(a) && a.on("exit", b), a.on("end", y), a.on("finish", _), u.error !== !1 && a.on("error", g), a.on("close", v), function() {
      p = !0, a.removeListener("complete", _), a.removeListener("abort", v), a.removeListener("request", E), a.req && a.req.removeListener("finish", _), a.removeListener("end", m), a.removeListener("close", m), a.removeListener("finish", _), a.removeListener("exit", b), a.removeListener("end", y), a.removeListener("error", g), a.removeListener("close", v);
    };
  };
  t.exports = o;
}, 6664: () => {
}, 6686: () => {
}, 6698: (t) => {
  typeof Object.create == "function" ? t.exports = function(e, n) {
    n && (e.super_ = n, e.prototype = Object.create(n.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }));
  } : t.exports = function(e, n) {
    if (n) {
      e.super_ = n;
      var i = function() {
      };
      i.prototype = n.prototype, e.prototype = new i(), e.prototype.constructor = e;
    }
  };
}, 6819: (t, e, n) => {
  t.exports = n(8330).version;
}, 6889: () => {
}, 7007: (t) => {
  var e = Object.create || function(m) {
    var _ = function() {
    };
    return _.prototype = m, new _();
  }, n = Object.keys || function(m) {
    var _ = [];
    for (var y in m) Object.prototype.hasOwnProperty.call(m, y) && _.push(y);
    return y;
  }, i = Function.prototype.bind || function(m) {
    var _ = this;
    return function() {
      return _.apply(m, arguments);
    };
  };
  function r() {
    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = e(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }
  t.exports = r, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._maxListeners = void 0;
  var s, o = 10;
  try {
    var a = {};
    Object.defineProperty && Object.defineProperty(a, "x", { value: 0 }), s = a.x === 0;
  } catch {
    s = !1;
  }
  function u(m) {
    return m._maxListeners === void 0 ? r.defaultMaxListeners : m._maxListeners;
  }
  function c(m, _, y, b) {
    var g, v, w;
    if (typeof y != "function") throw new TypeError('"listener" argument must be a function');
    if ((v = m._events) ? (v.newListener && (m.emit("newListener", _, y.listener ? y.listener : y), v = m._events), w = v[_]) : (v = m._events = e(null), m._eventsCount = 0), w) {
      if (typeof w == "function" ? w = v[_] = b ? [y, w] : [w, y] : b ? w.unshift(y) : w.push(y), !w.warned && (g = u(m)) && g > 0 && w.length > g) {
        w.warned = !0;
        var E = new Error("Possible EventEmitter memory leak detected. " + w.length + ' "' + String(_) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
        E.name = "MaxListenersExceededWarning", E.emitter = m, E.type = _, E.count = w.length, typeof console == "object" && console.warn && console.warn("%s: %s", E.name, E.message);
      }
    } else w = v[_] = y, ++m._eventsCount;
    return m;
  }
  function l() {
    if (!this.fired) switch (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
      default:
        for (var m = new Array(arguments.length), _ = 0; _ < m.length; ++_) m[_] = arguments[_];
        this.listener.apply(this.target, m);
    }
  }
  function h(m, _, y) {
    var b = { fired: !1, wrapFn: void 0, target: m, type: _, listener: y }, g = i.call(l, b);
    return g.listener = y, b.wrapFn = g, g;
  }
  function f(m, _, y) {
    var b = m._events;
    if (!b) return [];
    var g = b[_];
    return g ? typeof g == "function" ? y ? [g.listener || g] : [g] : y ? function(v) {
      for (var w = new Array(v.length), E = 0; E < w.length; ++E) w[E] = v[E].listener || v[E];
      return w;
    }(g) : p(g, g.length) : [];
  }
  function d(m) {
    var _ = this._events;
    if (_) {
      var y = _[m];
      if (typeof y == "function") return 1;
      if (y) return y.length;
    }
    return 0;
  }
  function p(m, _) {
    for (var y = new Array(_), b = 0; b < _; ++b) y[b] = m[b];
    return y;
  }
  s ? Object.defineProperty(r, "defaultMaxListeners", { enumerable: !0, get: function() {
    return o;
  }, set: function(m) {
    if (typeof m != "number" || m < 0 || m != m) throw new TypeError('"defaultMaxListeners" must be a positive number');
    o = m;
  } }) : r.defaultMaxListeners = o, r.prototype.setMaxListeners = function(m) {
    if (typeof m != "number" || m < 0 || isNaN(m)) throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = m, this;
  }, r.prototype.getMaxListeners = function() {
    return u(this);
  }, r.prototype.emit = function(m) {
    var _, y, b, g, v, w, E = m === "error";
    if (w = this._events) E = E && w.error == null;
    else if (!E) return !1;
    if (E) {
      if (arguments.length > 1 && (_ = arguments[1]), _ instanceof Error) throw _;
      var A = new Error('Unhandled "error" event. (' + _ + ")");
      throw A.context = _, A;
    }
    if (!(y = w[m])) return !1;
    var C = typeof y == "function";
    switch (b = arguments.length) {
      case 1:
        (function(O, R, P) {
          if (R) O.call(P);
          else for (var k = O.length, S = p(O, k), x = 0; x < k; ++x) S[x].call(P);
        })(y, C, this);
        break;
      case 2:
        (function(O, R, P, k) {
          if (R) O.call(P, k);
          else for (var S = O.length, x = p(O, S), I = 0; I < S; ++I) x[I].call(P, k);
        })(y, C, this, arguments[1]);
        break;
      case 3:
        (function(O, R, P, k, S) {
          if (R) O.call(P, k, S);
          else for (var x = O.length, I = p(O, x), F = 0; F < x; ++F) I[F].call(P, k, S);
        })(y, C, this, arguments[1], arguments[2]);
        break;
      case 4:
        (function(O, R, P, k, S, x) {
          if (R) O.call(P, k, S, x);
          else for (var I = O.length, F = p(O, I), T = 0; T < I; ++T) F[T].call(P, k, S, x);
        })(y, C, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        for (g = new Array(b - 1), v = 1; v < b; v++) g[v - 1] = arguments[v];
        (function(O, R, P, k) {
          if (R) O.apply(P, k);
          else for (var S = O.length, x = p(O, S), I = 0; I < S; ++I) x[I].apply(P, k);
        })(y, C, this, g);
    }
    return !0;
  }, r.prototype.addListener = function(m, _) {
    return c(this, m, _, !1);
  }, r.prototype.on = r.prototype.addListener, r.prototype.prependListener = function(m, _) {
    return c(this, m, _, !0);
  }, r.prototype.once = function(m, _) {
    if (typeof _ != "function") throw new TypeError('"listener" argument must be a function');
    return this.on(m, h(this, m, _)), this;
  }, r.prototype.prependOnceListener = function(m, _) {
    if (typeof _ != "function") throw new TypeError('"listener" argument must be a function');
    return this.prependListener(m, h(this, m, _)), this;
  }, r.prototype.removeListener = function(m, _) {
    var y, b, g, v, w;
    if (typeof _ != "function") throw new TypeError('"listener" argument must be a function');
    if (!(b = this._events)) return this;
    if (!(y = b[m])) return this;
    if (y === _ || y.listener === _) --this._eventsCount == 0 ? this._events = e(null) : (delete b[m], b.removeListener && this.emit("removeListener", m, y.listener || _));
    else if (typeof y != "function") {
      for (g = -1, v = y.length - 1; v >= 0; v--) if (y[v] === _ || y[v].listener === _) {
        w = y[v].listener, g = v;
        break;
      }
      if (g < 0) return this;
      g === 0 ? y.shift() : function(E, A) {
        for (var C = A, O = C + 1, R = E.length; O < R; C += 1, O += 1) E[C] = E[O];
        E.pop();
      }(y, g), y.length === 1 && (b[m] = y[0]), b.removeListener && this.emit("removeListener", m, w || _);
    }
    return this;
  }, r.prototype.removeAllListeners = function(m) {
    var _, y, b;
    if (!(y = this._events)) return this;
    if (!y.removeListener) return arguments.length === 0 ? (this._events = e(null), this._eventsCount = 0) : y[m] && (--this._eventsCount == 0 ? this._events = e(null) : delete y[m]), this;
    if (arguments.length === 0) {
      var g, v = n(y);
      for (b = 0; b < v.length; ++b) (g = v[b]) !== "removeListener" && this.removeAllListeners(g);
      return this.removeAllListeners("removeListener"), this._events = e(null), this._eventsCount = 0, this;
    }
    if (typeof (_ = y[m]) == "function") this.removeListener(m, _);
    else if (_) for (b = _.length - 1; b >= 0; b--) this.removeListener(m, _[b]);
    return this;
  }, r.prototype.listeners = function(m) {
    return f(this, m, !0);
  }, r.prototype.rawListeners = function(m) {
    return f(this, m, !1);
  }, r.listenerCount = function(m, _) {
    return typeof m.listenerCount == "function" ? m.listenerCount(_) : d.call(m, _);
  }, r.prototype.listenerCount = d, r.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
}, 7264: () => {
}, 7373: (t) => {
  t.exports = function(e) {
    var n = 0;
    return function() {
      if (n === e.length) return null;
      var i = e.length - n, r = Math.random() * i | 0, s = e[n + r], o = e[n];
      return e[n] = s, e[n + r] = o, n++, s;
    };
  };
}, 7541: (t, e, n) => {
  const i = n(8765), r = n(8499);
  t.exports = { Throttle: i, ThrottleGroup: r };
}, 7828: () => {
}, 7833: (t, e, n) => {
  var i = n(717);
  e.formatArgs = function(s) {
    if (s[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + s[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors) return;
    const o = "color: " + this.color;
    s.splice(1, 0, o, "color: inherit");
    let a = 0, u = 0;
    s[0].replace(/%[a-zA-Z%]/g, (c) => {
      c !== "%%" && (a++, c === "%c" && (u = a));
    }), s.splice(u, 0, o);
  }, e.save = function(s) {
    try {
      s ? e.storage.setItem("debug", s) : e.storage.removeItem("debug");
    } catch {
    }
  }, e.load = function() {
    let s;
    try {
      s = e.storage.getItem("debug");
    } catch {
    }
    return !s && i !== void 0 && "env" in i && (s = i.env.DEBUG), s;
  }, e.useColors = function() {
    if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return !0;
    if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
    let s;
    return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (s = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(s[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, e.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), e.destroy = /* @__PURE__ */ (() => {
    let s = !1;
    return () => {
      s || (s = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.log = console.debug || console.log || (() => {
  }), t.exports = n(736)(e);
  const { formatters: r } = t.exports;
  r.j = function(s) {
    try {
      return JSON.stringify(s);
    } catch (o) {
      return "[UnexpectedJSONParseError]: " + o.message;
    }
  };
}, 7936: () => {
}, 8179: (t, e, n) => {
  const { EventEmitter: i } = n(7007), r = new Error("Stream was destroyed"), s = new Error("Premature close"), o = n(6080), a = n(5335), u = 536870911, c = 1 ^ u, l = 2 ^ u, h = 32, f = 64, d = 128, p = 256, m = 1024, _ = 2048, y = 4096, b = 8192, g = 16384, v = 32768, w = 131072, E = 131328, A = 16 ^ u, C = 536805375, O = 768 ^ u, R = 536838143, P = 536739839, k = 1 << 18, S = 2 << 18, x = 4 << 18, I = 8 << 18, F = 16 << 18, T = 32 << 18, L = 64 << 18, M = 128 << 18, U = 256 << 18, $ = 512 << 18, z = 1024 << 18, X = 535822335, J = 503316479, K = 268435455, be = 262160, Fe = 536608751, de = 8404992, ge = 14, Ae = 15, ke = 8405006, Le = 33587200, Xe = 33587215, D = 2359296, V = 270794767, W = Symbol.asyncIterator || Symbol("asyncIterator");
  class B {
    constructor(j, { highWaterMark: Y = 16384, map: fe = null, mapWritable: ve, byteLength: Ce, byteLengthWritable: Ne } = {}) {
      this.stream = j, this.queue = new o(), this.highWaterMark = Y, this.buffered = 0, this.error = null, this.pipeline = null, this.drains = null, this.byteLength = Ne || Ce || Dr, this.map = ve || fe, this.afterWrite = se.bind(this), this.afterUpdateNextTick = Te.bind(this);
    }
    get ended() {
      return !!(this.stream._duplexState & T);
    }
    push(j) {
      return !(142606350 & this.stream._duplexState) && (this.map !== null && (j = this.map(j)), this.buffered += this.byteLength(j), this.queue.push(j), this.buffered < this.highWaterMark ? (this.stream._duplexState |= I, !0) : (this.stream._duplexState |= 6291456, !1));
    }
    shift() {
      const j = this.queue.shift();
      return this.buffered -= this.byteLength(j), this.buffered === 0 && (this.stream._duplexState &= 534773759), j;
    }
    end(j) {
      typeof j == "function" ? this.stream.once("finish", j) : j != null && this.push(j), this.stream._duplexState = (this.stream._duplexState | $) & X;
    }
    autoBatch(j, Y) {
      const fe = [], ve = this.stream;
      for (fe.push(j); (ve._duplexState & V) === D; ) fe.push(ve._writableState.shift());
      if (ve._duplexState & Ae) return Y(null);
      ve._writev(fe, Y);
    }
    update() {
      const j = this.stream;
      j._duplexState |= S;
      do {
        for (; (j._duplexState & V) === I; ) {
          const Y = this.shift();
          j._duplexState |= 67371008, j._write(Y, this.afterWrite);
        }
        1310720 & j._duplexState || this.updateNonPrimary();
      } while (this.continueUpdate() === !0);
      j._duplexState &= 536346623;
    }
    updateNonPrimary() {
      const j = this.stream;
      if ((144965647 & j._duplexState) === $) return j._duplexState = j._duplexState | k, void j._final(q.bind(this));
      (j._duplexState & ge) != 4 ? (j._duplexState & Xe) == 1 && (j._duplexState = (j._duplexState | be) & c, j._open(we.bind(this))) : j._duplexState & Le || (j._duplexState |= be, j._destroy(Q.bind(this)));
    }
    continueUpdate() {
      return !!(this.stream._duplexState & M) && (this.stream._duplexState &= J, !0);
    }
    updateCallback() {
      (35127311 & this.stream._duplexState) === x ? this.update() : this.updateNextTick();
    }
    updateNextTick() {
      this.stream._duplexState & M || (this.stream._duplexState |= M, this.stream._duplexState & S || queueMicrotask(this.afterUpdateNextTick));
    }
  }
  class N {
    constructor(j, { highWaterMark: Y = 16384, map: fe = null, mapReadable: ve, byteLength: Ce, byteLengthReadable: Ne } = {}) {
      this.stream = j, this.queue = new o(), this.highWaterMark = Y === 0 ? 1 : Y, this.buffered = 0, this.readAhead = Y > 0, this.error = null, this.pipeline = null, this.byteLength = Ne || Ce || Dr, this.map = ve || fe, this.pipeTo = null, this.afterRead = ee.bind(this), this.afterUpdateNextTick = he.bind(this);
    }
    get ended() {
      return !!(this.stream._duplexState & g);
    }
    pipe(j, Y) {
      if (this.pipeTo !== null) throw new Error("Can only pipe to one destination");
      if (typeof Y != "function" && (Y = null), this.stream._duplexState |= 512, this.pipeTo = j, this.pipeline = new G(this.stream, j, Y), Y && this.stream.on("error", mn), Mn(j)) j._writableState.pipeline = this.pipeline, Y && j.on("error", mn), j.on("finish", this.pipeline.finished.bind(this.pipeline));
      else {
        const fe = this.pipeline.done.bind(this.pipeline, j), ve = this.pipeline.done.bind(this.pipeline, j, null);
        j.on("error", fe), j.on("close", ve), j.on("finish", this.pipeline.finished.bind(this.pipeline));
      }
      j.on("drain", Z.bind(this)), this.stream.emit("piping", j), j.emit("pipe", this.stream);
    }
    push(j) {
      const Y = this.stream;
      return j === null ? (this.highWaterMark = 0, Y._duplexState = 536805311 & Y._duplexState | 1024, !1) : this.map !== null && (j = this.map(j)) === null ? (Y._duplexState &= C, this.buffered < this.highWaterMark) : (this.buffered += this.byteLength(j), this.queue.push(j), Y._duplexState = (Y._duplexState | d) & C, this.buffered < this.highWaterMark);
    }
    shift() {
      const j = this.queue.shift();
      return this.buffered -= this.byteLength(j), this.buffered === 0 && (this.stream._duplexState &= 536862591), j;
    }
    unshift(j) {
      const Y = [this.map !== null ? this.map(j) : j];
      for (; this.buffered > 0; ) Y.push(this.shift());
      for (let fe = 0; fe < Y.length - 1; fe++) {
        const ve = Y[fe];
        this.buffered += this.byteLength(ve), this.queue.push(ve);
      }
      this.push(Y[Y.length - 1]);
    }
    read() {
      const j = this.stream;
      if ((16527 & j._duplexState) === d) {
        const Y = this.shift();
        return this.pipeTo !== null && this.pipeTo.write(Y) === !1 && (j._duplexState &= O), j._duplexState & _ && j.emit("data", Y), Y;
      }
      return this.readAhead === !1 && (j._duplexState |= w, this.updateNextTick()), null;
    }
    drain() {
      const j = this.stream;
      for (; (16527 & j._duplexState) === d && 768 & j._duplexState; ) {
        const Y = this.shift();
        this.pipeTo !== null && this.pipeTo.write(Y) === !1 && (j._duplexState &= O), j._duplexState & _ && j.emit("data", Y);
      }
    }
    update() {
      const j = this.stream;
      j._duplexState |= h;
      do {
        for (this.drain(); this.buffered < this.highWaterMark && (214047 & j._duplexState) === w; ) j._duplexState |= 65552, j._read(this.afterRead), this.drain();
        (12431 & j._duplexState) == 4224 && (j._duplexState |= b, j.emit("readable")), 80 & j._duplexState || this.updateNonPrimary();
      } while (this.continueUpdate() === !0);
      j._duplexState &= 536870879;
    }
    updateNonPrimary() {
      const j = this.stream;
      (1167 & j._duplexState) === m && (j._duplexState = 536869887 & j._duplexState | 16384, j.emit("end"), (j._duplexState & ke) === de && (j._duplexState |= 4), this.pipeTo !== null && this.pipeTo.end()), (j._duplexState & ge) != 4 ? (j._duplexState & Xe) == 1 && (j._duplexState = (j._duplexState | be) & c, j._open(we.bind(this))) : j._duplexState & Le || (j._duplexState |= be, j._destroy(Q.bind(this)));
    }
    continueUpdate() {
      return !!(this.stream._duplexState & v) && (this.stream._duplexState &= R, !0);
    }
    updateCallback() {
      (32879 & this.stream._duplexState) === f ? this.update() : this.updateNextTick();
    }
    updateNextTickIfOpen() {
      32769 & this.stream._duplexState || (this.stream._duplexState |= v, this.stream._duplexState & h || queueMicrotask(this.afterUpdateNextTick));
    }
    updateNextTick() {
      this.stream._duplexState & v || (this.stream._duplexState |= v, this.stream._duplexState & h || queueMicrotask(this.afterUpdateNextTick));
    }
  }
  class H {
    constructor(j) {
      this.data = null, this.afterTransform = rt.bind(j), this.afterFinal = null;
    }
  }
  class G {
    constructor(j, Y, fe) {
      this.from = j, this.to = Y, this.afterPipe = fe, this.error = null, this.pipeToFinished = !1;
    }
    finished() {
      this.pipeToFinished = !0;
    }
    done(j, Y) {
      Y && (this.error = Y), j !== this.to || (this.to = null, this.from === null) ? j !== this.from || (this.from = null, this.to === null) ? (this.afterPipe !== null && this.afterPipe(this.error), this.to = this.from = this.afterPipe = null) : j._duplexState & g || this.to.destroy(this.error || new Error("Readable stream closed before ending")) : this.from._duplexState & g && this.pipeToFinished || this.from.destroy(this.error || new Error("Writable stream closed prematurely"));
    }
  }
  function Z() {
    this.stream._duplexState |= 512, this.updateCallback();
  }
  function q(ce) {
    const j = this.stream;
    ce && j.destroy(ce), j._duplexState & ge || (j._duplexState |= T, j.emit("finish")), (j._duplexState & ke) === de && (j._duplexState |= 4), j._duplexState &= 402391039, j._duplexState & S ? this.updateNextTick() : this.update();
  }
  function Q(ce) {
    const j = this.stream;
    ce || this.error === r || (ce = this.error), ce && j.emit("error", ce), j._duplexState |= 8, j.emit("close");
    const Y = j._readableState, fe = j._writableState;
    if (Y !== null && Y.pipeline !== null && Y.pipeline.done(j, ce), fe !== null) {
      for (; fe.drains !== null && fe.drains.length > 0; ) fe.drains.shift().resolve(!1);
      fe.pipeline !== null && fe.pipeline.done(j, ce);
    }
  }
  function se(ce) {
    const j = this.stream;
    ce && j.destroy(ce), j._duplexState &= 469499903, this.drains !== null && function(Y) {
      for (let fe = 0; fe < Y.length; fe++) --Y[fe].writes == 0 && (Y.shift().resolve(!0), fe--);
    }(this.drains), (6553615 & j._duplexState) === F && (j._duplexState &= 532676607, (j._duplexState & L) === L && j.emit("drain")), this.updateCallback();
  }
  function ee(ce) {
    ce && this.stream.destroy(ce), this.stream._duplexState &= A, this.readAhead !== !1 || this.stream._duplexState & p || (this.stream._duplexState &= P), this.updateCallback();
  }
  function he() {
    this.stream._duplexState & h || (this.stream._duplexState &= R, this.update());
  }
  function Te() {
    this.stream._duplexState & S || (this.stream._duplexState &= J, this.update());
  }
  function we(ce) {
    const j = this.stream;
    ce && j.destroy(ce), 4 & j._duplexState || (17423 & j._duplexState || (j._duplexState |= f), 142606351 & j._duplexState || (j._duplexState |= x), j.emit("open")), j._duplexState &= Fe, j._writableState !== null && j._writableState.updateCallback(), j._readableState !== null && j._readableState.updateCallback();
  }
  function rt(ce, j) {
    j != null && this.push(j), this._writableState.afterWrite(ce);
  }
  function Ln(ce) {
    this._readableState !== null && (ce === "data" && (this._duplexState |= 133376, this._readableState.updateNextTick()), ce === "readable" && (this._duplexState |= y, this._readableState.updateNextTick())), this._writableState !== null && ce === "drain" && (this._duplexState |= L, this._writableState.updateNextTick());
  }
  class it extends i {
    constructor(j) {
      super(), this._duplexState = 0, this._readableState = null, this._writableState = null, j && (j.open && (this._open = j.open), j.destroy && (this._destroy = j.destroy), j.predestroy && (this._predestroy = j.predestroy), j.signal && j.signal.addEventListener("abort", sr.bind(this))), this.on("newListener", Ln);
    }
    _open(j) {
      j(null);
    }
    _destroy(j) {
      j(null);
    }
    _predestroy() {
    }
    get readable() {
      return this._readableState !== null || void 0;
    }
    get writable() {
      return this._writableState !== null || void 0;
    }
    get destroyed() {
      return !!(8 & this._duplexState);
    }
    get destroying() {
      return !!(this._duplexState & ge);
    }
    destroy(j) {
      this._duplexState & ge || (j || (j = r), this._duplexState = 535822271 & this._duplexState | 4, this._readableState !== null && (this._readableState.highWaterMark = 0, this._readableState.error = j), this._writableState !== null && (this._writableState.highWaterMark = 0, this._writableState.error = j), this._duplexState |= 2, this._predestroy(), this._duplexState &= l, this._readableState !== null && this._readableState.updateNextTick(), this._writableState !== null && this._writableState.updateNextTick());
    }
  }
  class yt extends it {
    constructor(j) {
      super(j), this._duplexState |= 8519681, this._readableState = new N(this, j), j && (this._readableState.readAhead === !1 && (this._duplexState &= P), j.read && (this._read = j.read), j.eagerOpen && this._readableState.updateNextTick(), j.encoding && this.setEncoding(j.encoding));
    }
    setEncoding(j) {
      const Y = new a(j), fe = this._readableState.map || Es;
      return this._readableState.map = function(ve) {
        const Ce = Y.push(ve);
        return Ce === "" && (ve.byteLength !== 0 || Y.remaining > 0) ? null : fe(Ce);
      }, this;
    }
    _read(j) {
      j(null);
    }
    pipe(j, Y) {
      return this._readableState.updateNextTick(), this._readableState.pipe(j, Y), j;
    }
    read() {
      return this._readableState.updateNextTick(), this._readableState.read();
    }
    push(j) {
      return this._readableState.updateNextTickIfOpen(), this._readableState.push(j);
    }
    unshift(j) {
      return this._readableState.updateNextTickIfOpen(), this._readableState.unshift(j);
    }
    resume() {
      return this._duplexState |= E, this._readableState.updateNextTick(), this;
    }
    pause() {
      return this._duplexState &= this._readableState.readAhead === !1 ? 536739583 : 536870655, this;
    }
    static _fromAsyncIterator(j, Y) {
      let fe;
      const ve = new yt({ ...Y, read(Ne) {
        j.next().then(Ce).then(Ne.bind(null, null)).catch(Ne);
      }, predestroy() {
        fe = j.return();
      }, destroy(Ne) {
        if (!fe) return Ne(null);
        fe.then(Ne.bind(null, null)).catch(Ne);
      } });
      return ve;
      function Ce(Ne) {
        Ne.done ? ve.push(null) : ve.push(Ne.value);
      }
    }
    static from(j, Y) {
      if (Mn(fe = j) && fe.readable) return j;
      var fe;
      if (j[W]) return this._fromAsyncIterator(j[W](), Y);
      Array.isArray(j) || (j = j === void 0 ? [] : [j]);
      let ve = 0;
      return new yt({ ...Y, read(Ce) {
        this.push(ve === j.length ? null : j[ve++]), Ce(null);
      } });
    }
    static isBackpressured(j) {
      return !!(17422 & j._duplexState) || j._readableState.buffered >= j._readableState.highWaterMark;
    }
    static isPaused(j) {
      return !(j._duplexState & p);
    }
    [W]() {
      const j = this;
      let Y = null, fe = null, ve = null;
      return this.on("error", (Qe) => {
        Y = Qe;
      }), this.on("readable", function() {
        fe !== null && Ce(j.read());
      }), this.on("close", function() {
        fe !== null && Ce(null);
      }), { [W]() {
        return this;
      }, next: () => new Promise(function(Qe, jn) {
        fe = Qe, ve = jn;
        const Be = j.read();
        Be !== null ? Ce(Be) : 8 & j._duplexState && Ce(null);
      }), return: () => Ne(null), throw: (Qe) => Ne(Qe) };
      function Ce(Qe) {
        ve !== null && (Y ? ve(Y) : Qe !== null || j._duplexState & g ? fe({ value: Qe, done: Qe === null }) : ve(r), ve = fe = null);
      }
      function Ne(Qe) {
        return j.destroy(Qe), new Promise((jn, Be) => {
          if (8 & j._duplexState) return jn({ value: void 0, done: !0 });
          j.once("close", function() {
            Qe ? Be(Qe) : jn({ value: void 0, done: !0 });
          });
        });
      }
    }
  }
  class Ie extends it {
    constructor(j) {
      super(j), this._duplexState |= 16385, this._writableState = new B(this, j), j && (j.writev && (this._writev = j.writev), j.write && (this._write = j.write), j.final && (this._final = j.final), j.eagerOpen && this._writableState.updateNextTick());
    }
    cork() {
      this._duplexState |= z;
    }
    uncork() {
      this._duplexState &= K, this._writableState.updateNextTick();
    }
    _writev(j, Y) {
      Y(null);
    }
    _write(j, Y) {
      this._writableState.autoBatch(j, Y);
    }
    _final(j) {
      j(null);
    }
    static isBackpressured(j) {
      return !!(146800654 & j._duplexState);
    }
    static drained(j) {
      if (j.destroyed) return Promise.resolve(!1);
      const Y = j._writableState;
      var fe;
      const ve = ((fe = j)._writev !== Ie.prototype._writev && fe._writev !== pn.prototype._writev ? Math.min(1, Y.queue.length) : Y.queue.length) + (j._duplexState & U ? 1 : 0);
      return ve === 0 ? Promise.resolve(!0) : (Y.drains === null && (Y.drains = []), new Promise((Ce) => {
        Y.drains.push({ writes: ve, resolve: Ce });
      }));
    }
    write(j) {
      return this._writableState.updateNextTick(), this._writableState.push(j);
    }
    end(j) {
      return this._writableState.updateNextTick(), this._writableState.end(j), this;
    }
  }
  class pn extends yt {
    constructor(j) {
      super(j), this._duplexState = 1 | this._duplexState & w, this._writableState = new B(this, j), j && (j.writev && (this._writev = j.writev), j.write && (this._write = j.write), j.final && (this._final = j.final));
    }
    cork() {
      this._duplexState |= z;
    }
    uncork() {
      this._duplexState &= K, this._writableState.updateNextTick();
    }
    _writev(j, Y) {
      Y(null);
    }
    _write(j, Y) {
      this._writableState.autoBatch(j, Y);
    }
    _final(j) {
      j(null);
    }
    write(j) {
      return this._writableState.updateNextTick(), this._writableState.push(j);
    }
    end(j) {
      return this._writableState.updateNextTick(), this._writableState.end(j), this;
    }
  }
  class ir extends pn {
    constructor(j) {
      super(j), this._transformState = new H(this), j && (j.transform && (this._transform = j.transform), j.flush && (this._flush = j.flush));
    }
    _write(j, Y) {
      this._readableState.buffered >= this._readableState.highWaterMark ? this._transformState.data = j : this._transform(j, this._transformState.afterTransform);
    }
    _read(j) {
      if (this._transformState.data !== null) {
        const Y = this._transformState.data;
        this._transformState.data = null, j(null), this._transform(Y, this._transformState.afterTransform);
      } else j(null);
    }
    destroy(j) {
      super.destroy(j), this._transformState.data !== null && (this._transformState.data = null, this._transformState.afterTransform());
    }
    _transform(j, Y) {
      Y(null, j);
    }
    _flush(j) {
      j(null);
    }
    _final(j) {
      this._transformState.afterFinal = j, this._flush(vt.bind(this));
    }
  }
  function vt(ce, j) {
    const Y = this._transformState.afterFinal;
    if (ce) return Y(ce);
    j != null && this.push(j), this.push(null), Y(null);
  }
  function Tr(ce, ...j) {
    const Y = Array.isArray(ce) ? [...ce, ...j] : [ce, ...j], fe = Y.length && typeof Y[Y.length - 1] == "function" ? Y.pop() : null;
    if (Y.length < 2) throw new Error("Pipeline requires at least 2 streams");
    let ve = Y[0], Ce = null, Ne = null;
    for (let Be = 1; Be < Y.length; Be++) Ce = Y[Be], Mn(ve) ? ve.pipe(Ce, jn) : (Qe(ve, !0, Be > 1, jn), ve.pipe(Ce)), ve = Ce;
    if (fe) {
      let Be = !1;
      const Fr = Mn(Ce) || !(!Ce._writableState || !Ce._writableState.autoDestroy);
      Ce.on("error", (Cs) => {
        Ne === null && (Ne = Cs);
      }), Ce.on("finish", () => {
        Be = !0, Fr || fe(Ne);
      }), Fr && Ce.on("close", () => fe(Ne || (Be ? null : s)));
    }
    return Ce;
    function Qe(Be, Fr, Cs, Ts) {
      Be.on("error", Ts), Be.on("close", function() {
        if (Be._readableState && !Be._readableState.ended || Cs && Be._writableState && !Be._writableState.ended) return Ts(s);
      });
    }
    function jn(Be) {
      if (Be && !Ne) {
        Ne = Be;
        for (const Fr of Y) Fr.destroy(Be);
      }
    }
  }
  function Es(ce) {
    return ce;
  }
  function fi(ce) {
    return !!ce._readableState || !!ce._writableState;
  }
  function Mn(ce) {
    return typeof ce._duplexState == "number" && fi(ce);
  }
  function Dr(ce) {
    return function(j) {
      return typeof j == "object" && j !== null && typeof j.byteLength == "number";
    }(ce) ? ce.byteLength : 1024;
  }
  function mn() {
  }
  function sr() {
    this.destroy(new Error("Stream aborted."));
  }
  t.exports = { pipeline: Tr, pipelinePromise: function(...ce) {
    return new Promise((j, Y) => Tr(...ce, (fe) => {
      if (fe) return Y(fe);
      j();
    }));
  }, isStream: fi, isStreamx: Mn, isEnded: function(ce) {
    return !!ce._readableState && ce._readableState.ended;
  }, isFinished: function(ce) {
    return !!ce._writableState && ce._writableState.ended;
  }, isDisturbed: function(ce) {
    return !!(1 & ~ce._duplexState) || !!(ce._duplexState & Le);
  }, getStreamError: function(ce, j = {}) {
    const Y = ce._readableState && ce._readableState.error || ce._writableState && ce._writableState.error;
    return j.all || Y !== r ? Y : null;
  }, Stream: it, Writable: Ie, Readable: yt, Duplex: pn, Transform: ir, PassThrough: class extends ir {
  } };
}, 8190: (t, e, n) => {
  t.exports = function(r, s) {
    let o, a, u, c = !0;
    Array.isArray(r) ? (o = [], a = r.length) : (u = Object.keys(r), o = {}, a = u.length);
    function l(f) {
      function d() {
        s && s(f, o), s = null;
      }
      c ? i(d) : d();
    }
    function h(f, d, p) {
      o[f] = p, (--a == 0 || d) && l(d);
    }
    a ? u ? u.forEach(function(f) {
      r[f](function(d, p) {
        h(f, d, p);
      });
    }) : r.forEach(function(f, d) {
      f(function(p, m) {
        h(d, p, m);
      });
    }) : l(null), c = !1;
  };
  const i = n(9596);
}, 8271: () => {
}, 8330: (t) => {
  t.exports = { version: "2.6.3" };
}, 8444: (t) => {
  t.exports = function(e) {
    return Math.max(16384, 1 << Math.log2(e < 1024 ? 1 : e / 1024) + 0.5);
  };
}, 8446: (t) => {
  t.exports = { "application/andrew-inset": ["ez"], "application/applixware": ["aw"], "application/atom+xml": ["atom"], "application/atomcat+xml": ["atomcat"], "application/atomdeleted+xml": ["atomdeleted"], "application/atomsvc+xml": ["atomsvc"], "application/atsc-dwd+xml": ["dwd"], "application/atsc-held+xml": ["held"], "application/atsc-rsat+xml": ["rsat"], "application/bdoc": ["bdoc"], "application/calendar+xml": ["xcs"], "application/ccxml+xml": ["ccxml"], "application/cdfx+xml": ["cdfx"], "application/cdmi-capability": ["cdmia"], "application/cdmi-container": ["cdmic"], "application/cdmi-domain": ["cdmid"], "application/cdmi-object": ["cdmio"], "application/cdmi-queue": ["cdmiq"], "application/cu-seeme": ["cu"], "application/dash+xml": ["mpd"], "application/davmount+xml": ["davmount"], "application/docbook+xml": ["dbk"], "application/dssc+der": ["dssc"], "application/dssc+xml": ["xdssc"], "application/ecmascript": ["es", "ecma"], "application/emma+xml": ["emma"], "application/emotionml+xml": ["emotionml"], "application/epub+zip": ["epub"], "application/exi": ["exi"], "application/express": ["exp"], "application/fdt+xml": ["fdt"], "application/font-tdpfr": ["pfr"], "application/geo+json": ["geojson"], "application/gml+xml": ["gml"], "application/gpx+xml": ["gpx"], "application/gxf": ["gxf"], "application/gzip": ["gz"], "application/hjson": ["hjson"], "application/hyperstudio": ["stk"], "application/inkml+xml": ["ink", "inkml"], "application/ipfix": ["ipfix"], "application/its+xml": ["its"], "application/java-archive": ["jar", "war", "ear"], "application/java-serialized-object": ["ser"], "application/java-vm": ["class"], "application/javascript": ["js", "mjs"], "application/json": ["json", "map"], "application/json5": ["json5"], "application/jsonml+json": ["jsonml"], "application/ld+json": ["jsonld"], "application/lgr+xml": ["lgr"], "application/lost+xml": ["lostxml"], "application/mac-binhex40": ["hqx"], "application/mac-compactpro": ["cpt"], "application/mads+xml": ["mads"], "application/manifest+json": ["webmanifest"], "application/marc": ["mrc"], "application/marcxml+xml": ["mrcx"], "application/mathematica": ["ma", "nb", "mb"], "application/mathml+xml": ["mathml"], "application/mbox": ["mbox"], "application/mediaservercontrol+xml": ["mscml"], "application/metalink+xml": ["metalink"], "application/metalink4+xml": ["meta4"], "application/mets+xml": ["mets"], "application/mmt-aei+xml": ["maei"], "application/mmt-usd+xml": ["musd"], "application/mods+xml": ["mods"], "application/mp21": ["m21", "mp21"], "application/mp4": ["mp4s", "m4p"], "application/msword": ["doc", "dot"], "application/mxf": ["mxf"], "application/n-quads": ["nq"], "application/n-triples": ["nt"], "application/node": ["cjs"], "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"], "application/oda": ["oda"], "application/oebps-package+xml": ["opf"], "application/ogg": ["ogx"], "application/omdoc+xml": ["omdoc"], "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"], "application/oxps": ["oxps"], "application/p2p-overlay+xml": ["relo"], "application/patch-ops-error+xml": ["xer"], "application/pdf": ["pdf"], "application/pgp-encrypted": ["pgp"], "application/pgp-signature": ["asc", "sig"], "application/pics-rules": ["prf"], "application/pkcs10": ["p10"], "application/pkcs7-mime": ["p7m", "p7c"], "application/pkcs7-signature": ["p7s"], "application/pkcs8": ["p8"], "application/pkix-attr-cert": ["ac"], "application/pkix-cert": ["cer"], "application/pkix-crl": ["crl"], "application/pkix-pkipath": ["pkipath"], "application/pkixcmp": ["pki"], "application/pls+xml": ["pls"], "application/postscript": ["ai", "eps", "ps"], "application/provenance+xml": ["provx"], "application/pskc+xml": ["pskcxml"], "application/raml+yaml": ["raml"], "application/rdf+xml": ["rdf", "owl"], "application/reginfo+xml": ["rif"], "application/relax-ng-compact-syntax": ["rnc"], "application/resource-lists+xml": ["rl"], "application/resource-lists-diff+xml": ["rld"], "application/rls-services+xml": ["rs"], "application/route-apd+xml": ["rapd"], "application/route-s-tsid+xml": ["sls"], "application/route-usd+xml": ["rusd"], "application/rpki-ghostbusters": ["gbr"], "application/rpki-manifest": ["mft"], "application/rpki-roa": ["roa"], "application/rsd+xml": ["rsd"], "application/rss+xml": ["rss"], "application/rtf": ["rtf"], "application/sbml+xml": ["sbml"], "application/scvp-cv-request": ["scq"], "application/scvp-cv-response": ["scs"], "application/scvp-vp-request": ["spq"], "application/scvp-vp-response": ["spp"], "application/sdp": ["sdp"], "application/senml+xml": ["senmlx"], "application/sensml+xml": ["sensmlx"], "application/set-payment-initiation": ["setpay"], "application/set-registration-initiation": ["setreg"], "application/shf+xml": ["shf"], "application/sieve": ["siv", "sieve"], "application/smil+xml": ["smi", "smil"], "application/sparql-query": ["rq"], "application/sparql-results+xml": ["srx"], "application/srgs": ["gram"], "application/srgs+xml": ["grxml"], "application/sru+xml": ["sru"], "application/ssdl+xml": ["ssdl"], "application/ssml+xml": ["ssml"], "application/swid+xml": ["swidtag"], "application/tei+xml": ["tei", "teicorpus"], "application/thraud+xml": ["tfi"], "application/timestamped-data": ["tsd"], "application/toml": ["toml"], "application/trig": ["trig"], "application/ttml+xml": ["ttml"], "application/ubjson": ["ubj"], "application/urc-ressheet+xml": ["rsheet"], "application/urc-targetdesc+xml": ["td"], "application/voicexml+xml": ["vxml"], "application/wasm": ["wasm"], "application/widget": ["wgt"], "application/winhlp": ["hlp"], "application/wsdl+xml": ["wsdl"], "application/wspolicy+xml": ["wspolicy"], "application/xaml+xml": ["xaml"], "application/xcap-att+xml": ["xav"], "application/xcap-caps+xml": ["xca"], "application/xcap-diff+xml": ["xdf"], "application/xcap-el+xml": ["xel"], "application/xcap-ns+xml": ["xns"], "application/xenc+xml": ["xenc"], "application/xhtml+xml": ["xhtml", "xht"], "application/xliff+xml": ["xlf"], "application/xml": ["xml", "xsl", "xsd", "rng"], "application/xml-dtd": ["dtd"], "application/xop+xml": ["xop"], "application/xproc+xml": ["xpl"], "application/xslt+xml": ["*xsl", "xslt"], "application/xspf+xml": ["xspf"], "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"], "application/yang": ["yang"], "application/yin+xml": ["yin"], "application/zip": ["zip"], "audio/3gpp": ["*3gpp"], "audio/adpcm": ["adp"], "audio/amr": ["amr"], "audio/basic": ["au", "snd"], "audio/midi": ["mid", "midi", "kar", "rmi"], "audio/mobile-xmf": ["mxmf"], "audio/mp3": ["*mp3"], "audio/mp4": ["m4a", "mp4a"], "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"], "audio/ogg": ["oga", "ogg", "spx", "opus"], "audio/s3m": ["s3m"], "audio/silk": ["sil"], "audio/wav": ["wav"], "audio/wave": ["*wav"], "audio/webm": ["weba"], "audio/xm": ["xm"], "font/collection": ["ttc"], "font/otf": ["otf"], "font/ttf": ["ttf"], "font/woff": ["woff"], "font/woff2": ["woff2"], "image/aces": ["exr"], "image/apng": ["apng"], "image/avif": ["avif"], "image/bmp": ["bmp"], "image/cgm": ["cgm"], "image/dicom-rle": ["drle"], "image/emf": ["emf"], "image/fits": ["fits"], "image/g3fax": ["g3"], "image/gif": ["gif"], "image/heic": ["heic"], "image/heic-sequence": ["heics"], "image/heif": ["heif"], "image/heif-sequence": ["heifs"], "image/hej2k": ["hej2"], "image/hsj2": ["hsj2"], "image/ief": ["ief"], "image/jls": ["jls"], "image/jp2": ["jp2", "jpg2"], "image/jpeg": ["jpeg", "jpg", "jpe"], "image/jph": ["jph"], "image/jphc": ["jhc"], "image/jpm": ["jpm"], "image/jpx": ["jpx", "jpf"], "image/jxr": ["jxr"], "image/jxra": ["jxra"], "image/jxrs": ["jxrs"], "image/jxs": ["jxs"], "image/jxsc": ["jxsc"], "image/jxsi": ["jxsi"], "image/jxss": ["jxss"], "image/ktx": ["ktx"], "image/ktx2": ["ktx2"], "image/png": ["png"], "image/sgi": ["sgi"], "image/svg+xml": ["svg", "svgz"], "image/t38": ["t38"], "image/tiff": ["tif", "tiff"], "image/tiff-fx": ["tfx"], "image/webp": ["webp"], "image/wmf": ["wmf"], "message/disposition-notification": ["disposition-notification"], "message/global": ["u8msg"], "message/global-delivery-status": ["u8dsn"], "message/global-disposition-notification": ["u8mdn"], "message/global-headers": ["u8hdr"], "message/rfc822": ["eml", "mime"], "model/3mf": ["3mf"], "model/gltf+json": ["gltf"], "model/gltf-binary": ["glb"], "model/iges": ["igs", "iges"], "model/mesh": ["msh", "mesh", "silo"], "model/mtl": ["mtl"], "model/obj": ["obj"], "model/step+xml": ["stpx"], "model/step+zip": ["stpz"], "model/step-xml+zip": ["stpxz"], "model/stl": ["stl"], "model/vrml": ["wrl", "vrml"], "model/x3d+binary": ["*x3db", "x3dbz"], "model/x3d+fastinfoset": ["x3db"], "model/x3d+vrml": ["*x3dv", "x3dvz"], "model/x3d+xml": ["x3d", "x3dz"], "model/x3d-vrml": ["x3dv"], "text/cache-manifest": ["appcache", "manifest"], "text/calendar": ["ics", "ifb"], "text/coffeescript": ["coffee", "litcoffee"], "text/css": ["css"], "text/csv": ["csv"], "text/html": ["html", "htm", "shtml"], "text/jade": ["jade"], "text/jsx": ["jsx"], "text/less": ["less"], "text/markdown": ["markdown", "md"], "text/mathml": ["mml"], "text/mdx": ["mdx"], "text/n3": ["n3"], "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"], "text/richtext": ["rtx"], "text/rtf": ["*rtf"], "text/sgml": ["sgml", "sgm"], "text/shex": ["shex"], "text/slim": ["slim", "slm"], "text/spdx": ["spdx"], "text/stylus": ["stylus", "styl"], "text/tab-separated-values": ["tsv"], "text/troff": ["t", "tr", "roff", "man", "me", "ms"], "text/turtle": ["ttl"], "text/uri-list": ["uri", "uris", "urls"], "text/vcard": ["vcard"], "text/vtt": ["vtt"], "text/xml": ["*xml"], "text/yaml": ["yaml", "yml"], "video/3gpp": ["3gp", "3gpp"], "video/3gpp2": ["3g2"], "video/h261": ["h261"], "video/h263": ["h263"], "video/h264": ["h264"], "video/iso.segment": ["m4s"], "video/jpeg": ["jpgv"], "video/jpm": ["*jpm", "jpgm"], "video/mj2": ["mj2", "mjp2"], "video/mp2t": ["ts"], "video/mp4": ["mp4", "mp4v", "mpg4"], "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"], "video/ogg": ["ogv"], "video/quicktime": ["qt", "mov"], "video/webm": ["webm"] };
}, 8454: (t, e, n) => {
  var i = n(7007), r = n(6698);
  function s(o) {
    if (!(this instanceof s)) return new s(o);
    typeof o == "number" && (o = { max: o }), o || (o = {}), i.EventEmitter.call(this), this.cache = {}, this.head = this.tail = null, this.length = 0, this.max = o.max || 1e3, this.maxAge = o.maxAge || 0;
  }
  t.exports = s, r(s, i.EventEmitter), Object.defineProperty(s.prototype, "keys", { get: function() {
    return Object.keys(this.cache);
  } }), s.prototype.clear = function() {
    this.cache = {}, this.head = this.tail = null, this.length = 0;
  }, s.prototype.remove = function(o) {
    if (typeof o != "string" && (o = "" + o), this.cache.hasOwnProperty(o)) {
      var a = this.cache[o];
      return delete this.cache[o], this._unlink(o, a.prev, a.next), a.value;
    }
  }, s.prototype._unlink = function(o, a, u) {
    this.length--, this.length === 0 ? this.head = this.tail = null : this.head === o ? (this.head = a, this.cache[this.head].next = null) : this.tail === o ? (this.tail = u, this.cache[this.tail].prev = null) : (this.cache[a].next = u, this.cache[u].prev = a);
  }, s.prototype.peek = function(o) {
    if (this.cache.hasOwnProperty(o)) {
      var a = this.cache[o];
      if (this._checkAge(o, a)) return a.value;
    }
  }, s.prototype.set = function(o, a) {
    var u;
    if (typeof o != "string" && (o = "" + o), this.cache.hasOwnProperty(o)) {
      if ((u = this.cache[o]).value = a, this.maxAge && (u.modified = Date.now()), o === this.head) return a;
      this._unlink(o, u.prev, u.next);
    } else u = { value: a, modified: 0, next: null, prev: null }, this.maxAge && (u.modified = Date.now()), this.cache[o] = u, this.length === this.max && this.evict();
    return this.length++, u.next = null, u.prev = this.head, this.head && (this.cache[this.head].next = o), this.head = o, this.tail || (this.tail = o), a;
  }, s.prototype._checkAge = function(o, a) {
    return !(this.maxAge && Date.now() - a.modified > this.maxAge) || (this.remove(o), this.emit("evict", { key: o, value: a.value }), !1);
  }, s.prototype.get = function(o) {
    if (typeof o != "string" && (o = "" + o), this.cache.hasOwnProperty(o)) {
      var a = this.cache[o];
      if (this._checkAge(o, a)) return this.head !== o && (o === this.tail ? (this.tail = a.next, this.cache[this.tail].prev = null) : this.cache[a.prev].next = a.next, this.cache[a.next].prev = a.prev, this.cache[this.head].next = o, a.prev = this.head, a.next = null, this.head = o), a.value;
    }
  }, s.prototype.evict = function() {
    if (this.tail) {
      var o = this.tail, a = this.remove(this.tail);
      this.emit("evict", { key: o, value: a });
    }
  };
}, 8499: (t, e, n) => {
  const { TokenBucket: i } = n(9439), r = n(8765);
  t.exports = class {
    constructor(s = {}) {
      if (typeof s != "object") throw new Error("Options must be an object");
      this.throttles = [], this.setEnabled(s.enabled), this.setRate(s.rate, s.chunksize);
    }
    getEnabled() {
      return this._enabled;
    }
    getRate() {
      return this.bucket.tokensPerInterval;
    }
    getChunksize() {
      return this.chunksize;
    }
    setEnabled(s = !0) {
      if (typeof s != "boolean") throw new Error("Enabled must be a boolean");
      this._enabled = s;
      for (const o of this.throttles) o.setEnabled(s);
    }
    setRate(s, o = null) {
      if (!Number.isInteger(s) || s < 0) throw new Error("Rate must be an integer bigger than zero");
      if (s = parseInt(s), o && (typeof o != "number" || o <= 0)) throw new Error("Chunksize must be bigger than zero");
      if (o = o || Math.max(parseInt(s / 10), 1), o = parseInt(o), s > 0 && o > s) throw new Error("Chunk size must be smaller than rate");
      this.bucket || (this.bucket = new i(s, s, "second", null)), this.bucket.bucketSize = s, this.bucket.tokensPerInterval = s, this.chunksize = o;
    }
    setChunksize(s) {
      if (!Number.isInteger(s) || s <= 0) throw new Error("Chunk size must be an integer bigger than zero");
      const o = this.getRate();
      if (s = parseInt(s), o > 0 && s > o) throw new Error("Chunk size must be smaller than rate");
      this.chunksize = s;
    }
    throttle(s = {}) {
      if (typeof s != "object") throw new Error("Options must be an object");
      return new r({ ...s, group: this });
    }
    destroy() {
      for (const s of this.throttles) s.destroy();
      this.throttles = [];
    }
    _addThrottle(s) {
      if (!(s instanceof r)) throw new Error("Throttle must be an instance of Throttle");
      this.throttles.push(s);
    }
    _removeThrottle(s) {
      const o = this.throttles.indexOf(s);
      o > -1 && this.throttles.splice(o, 1);
    }
  };
}, 8673: (t) => {
  function e() {
    this._types = /* @__PURE__ */ Object.create(null), this._extensions = /* @__PURE__ */ Object.create(null);
    for (let n = 0; n < arguments.length; n++) this.define(arguments[n]);
    this.define = this.define.bind(this), this.getType = this.getType.bind(this), this.getExtension = this.getExtension.bind(this);
  }
  e.prototype.define = function(n, i) {
    for (let r in n) {
      let s = n[r].map(function(o) {
        return o.toLowerCase();
      });
      r = r.toLowerCase();
      for (let o = 0; o < s.length; o++) {
        const a = s[o];
        if (a[0] !== "*") {
          if (!i && a in this._types) throw new Error('Attempt to change mapping for "' + a + '" extension from "' + this._types[a] + '" to "' + r + '". Pass `force=true` to allow this, otherwise remove "' + a + '" from the list of extensions for "' + r + '".');
          this._types[a] = r;
        }
      }
      if (i || !this._extensions[r]) {
        const o = s[0];
        this._extensions[r] = o[0] !== "*" ? o : o.substr(1);
      }
    }
  }, e.prototype.getType = function(n) {
    let i = (n = String(n)).replace(/^.*[/\\]/, "").toLowerCase(), r = i.replace(/^.*\./, "").toLowerCase(), s = i.length < n.length;
    return (r.length < i.length - 1 || !s) && this._types[r] || null;
  }, e.prototype.getExtension = function(n) {
    return (n = /^\s*([^;\s]*)/.test(n) && RegExp.$1) && this._extensions[n.toLowerCase()] || null;
  }, t.exports = e;
}, 8727: (t) => {
  function e(c) {
    return parseInt(c, 10) === c;
  }
  function n(c) {
    function l(f) {
      if (f === void 0) {
        f = new Array(c);
        for (var d = 0; d < c; d++) f[d] = Math.floor(Math.random() * c);
      } else if (typeof f == "string") f = (f = "" + f).split("").map(function(g) {
        return g.charCodeAt(0) % c;
      });
      else {
        if (!Array.isArray(f)) throw new TypeError("invalid seed key specified");
        if (!f.every(function(g) {
          return typeof g == "number" && g === (0 | g);
        })) throw new TypeError("invalid seed key specified: not array of integers");
      }
      for (var p = f.length, m = function() {
        for (var g = new Array(c), v = 0; v < c; v++) g[v] = v;
        return g;
      }(), _ = 0, y = 0; y < c; y++) {
        _ = (_ + m[y] + f[y % p]) % c;
        var b = m[y];
        m[y] = m[_], m[_] = b;
      }
      return m;
    }
    function h(f) {
      this.s = l(f), this.i = 0, this.j = 0;
    }
    return h.prototype.randomNative = function() {
      this.i = (this.i + 1) % c, this.j = (this.j + this.s[this.i]) % c;
      var f = this.s[this.i];
      return this.s[this.i] = this.s[this.j], this.s[this.j] = f, this.s[(this.s[this.i] + this.s[this.j]) % c];
    }, h.prototype.randomUInt32 = function() {
      return 256 * (256 * (256 * this.randomByte() + this.randomByte()) + this.randomByte()) + this.randomByte();
    }, h.prototype.randomFloat = function() {
      return this.randomUInt32() / 4294967296;
    }, h.prototype.random = function() {
      var f, d;
      if (arguments.length === 1) f = 0, d = arguments[0];
      else {
        if (arguments.length !== 2) throw new TypeError("random takes one or two integer arguments");
        f = arguments[0], d = arguments[1];
      }
      if (!e(f) || !e(d)) throw new TypeError("random takes one or two integer arguments");
      return f + this.randomUInt32() % (d - f + 1);
    }, h.prototype.currentState = function() {
      return { i: this.i, j: this.j, s: this.s.slice() };
    }, h.prototype.setState = function(f) {
      var d = f.s, p = f.i, m = f.j;
      if (!(p === (0 | p) && 0 <= p && p < c)) throw new Error("state.i should be integer [0, " + (c - 1) + "]");
      if (!(m === (0 | m) && 0 <= m && m < c)) throw new Error("state.j should be integer [0, " + (c - 1) + "]");
      if (!Array.isArray(d) || d.length !== c) throw new Error("state should be array of length " + c);
      for (var _ = 0; _ < c; _++) if (d.indexOf(_) === -1) throw new Error("state should be permutation of 0.." + (c - 1) + ": " + _ + " is missing");
      this.i = p, this.j = m, this.s = d.slice();
    }, h;
  }
  var i = n(256);
  i.prototype.randomByte = i.prototype.randomNative;
  var r = n(16);
  r.prototype.randomByte = function() {
    return 16 * this.randomNative() + this.randomNative();
  };
  var s = 97, o = 48;
  function a(c) {
    return c < 10 ? String.fromCharCode(o + c) : String.fromCharCode(s + c - 10);
  }
  function u(c) {
    return parseInt(c, 16);
  }
  r.prototype.currentStateString = function() {
    var c = this.currentState();
    return a(c.i) + a(c.j) + c.s.map(a).join("");
  }, r.prototype.setStateString = function(c) {
    if (!c.match(/^[0-9a-f]{18}$/)) throw new TypeError("RC4small stateString should be 18 hex character string");
    var l = u(c[0]), h = u(c[1]), f = c.split("").slice(2).map(u);
    this.setState({ i: l, j: h, s: f });
  }, i.RC4small = r, t.exports = i;
}, 8765: (t, e, n) => {
  const { EventEmitter: i } = n(7007), { Transform: r } = n(8179), { wait: s } = n(2072);
  t.exports = class extends r {
    constructor(a = {}) {
      if (super(), typeof a != "object") throw new Error("Options must be an object");
      const u = Object.assign({}, a);
      if (u.group && !(u.group instanceof o)) throw new Error("Group must be an instanece of ThrottleGroup");
      u.group || (u.group = new o(u)), this._setEnabled(u.enabled || u.group.enabled), this._group = u.group, this._emitter = new i(), this._destroyed = !1, this._group._addThrottle(this);
    }
    getEnabled() {
      return this._enabled;
    }
    getGroup() {
      return this._group;
    }
    _setEnabled(a = !0) {
      if (typeof a != "boolean") throw new Error("Enabled must be a boolean");
      this._enabled = a;
    }
    setEnabled(a) {
      this._setEnabled(a), this._enabled ? this._emitter.emit("enabled") : this._emitter.emit("disabled");
    }
    _transform(a, u) {
      this._processChunk(a, u);
    }
    async _waitForTokens(a) {
      return new Promise((u, c) => {
        let l = !1;
        const h = this;
        function f(d) {
          if (h._emitter.removeListener("disabled", f), h._emitter.removeListener("destroyed", f), !l) {
            if (l = !0, d) return c(d);
            u();
          }
        }
        this._emitter.once("disabled", f), this._emitter.once("destroyed", f), this._group.bucket.removeTokens(a, f);
      });
    }
    _areBothEnabled() {
      return this._enabled && this._group.getEnabled();
    }
    async _processChunk(a, u) {
      if (!this._areBothEnabled()) return u(null, a);
      let c = 0, l = this._group.getChunksize(), h = a.slice(c, c + l);
      for (; h.length > 0; ) {
        if (this._areBothEnabled()) try {
          for (; this._group.getRate() === 0 && !this._destroyed && this._areBothEnabled(); ) if (await s(1e3), this._destroyed) return;
          if (this._areBothEnabled() && !this._group.bucket.tryRemoveTokens(h.length) && (await this._waitForTokens(h.length), this._destroyed)) return;
        } catch (f) {
          return u(f);
        }
        this.push(h), c += l, l = this._areBothEnabled() ? this._group.getChunksize() : a.length - c, h = a.slice(c, c + l);
      }
      return u();
    }
    destroy(...a) {
      this._group._removeThrottle(this), this._destroyed = !0, this._emitter.emit("destroyed"), super.destroy(...a);
    }
  };
  const o = n(8499);
}, 8878: () => {
}, 9439: (t, e, n) => {
  e.RateLimiter = n(3065), e.TokenBucket = n(5472);
}, 9596: (t) => {
  let e;
  t.exports = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window < "u" ? window : globalThis) : (n) => (e || (e = Promise.resolve())).then(n).catch((i) => setTimeout(() => {
    throw i;
  }, 0));
}, 9639: (t, e, n) => {
  n.d(e, { NJ: () => y, V5: () => o, dU: () => p, HB: () => b, xW: () => u, LC: () => c, tW: () => C, fk: () => a, Ht: () => g, po: () => O, L0: () => _ });
  const i = "0123456789abcdef", r = [], s = [];
  for (let R = 0; R < 256; R++) r[R] = i[R >> 4 & 15] + i[15 & R], R < 16 && (R < 10 ? s[48 + R] = R : s[87 + R] = R);
  const o = (R) => {
    const P = R.length;
    let k = "", S = 0;
    for (; S < P; ) k += r[R[S++]];
    return k;
  }, a = (R) => {
    const P = R.length >> 1, k = P << 1, S = new Uint8Array(P);
    let x = 0, I = 0;
    for (; I < k; ) S[x++] = s[R.charCodeAt(I++)] << 4 | s[R.charCodeAt(I++)];
    return S;
  }, u = (R, P = 0) => {
    const k = R.length || 0;
    if (!P) {
      let F = k;
      for (; F--; ) P += R[F].length;
    }
    const S = new Uint8Array(P);
    let x = P, I = k;
    for (; I--; ) x -= R[I].length, S.set(R[I], x);
    return S;
  }, c = (R, P) => {
    if (R.length !== P.length) return !1;
    for (let k = R.length; k > -1; k -= 1) if (R[k] !== P[k]) return !1;
    return !0;
  };
  for (var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = typeof Uint8Array > "u" ? [] : new Uint8Array(256), f = 0; f < 64; f++) h[l.charCodeAt(f)] = f;
  const d = new TextDecoder(), p = (R, P) => P ? new TextDecoder(P).decode(R) : d.decode(R), m = new TextEncoder(), _ = (R) => m.encode(R), y = (R) => function(P) {
    var k, S = new Uint8Array(P), x = S.length, I = "";
    for (k = 0; k < x; k += 3) I += l[S[k] >> 2], I += l[(3 & S[k]) << 4 | S[k + 1] >> 4], I += l[(15 & S[k + 1]) << 2 | S[k + 2] >> 6], I += l[63 & S[k + 2]];
    return x % 3 == 2 ? I = I.substring(0, I.length - 1) + "=" : x % 3 == 1 && (I = I.substring(0, I.length - 2) + "=="), I;
  }(R), b = (R) => {
    let P, k = "", S = 0;
    const x = R.length;
    for (; S < x; ) P = R.charCodeAt(S++), k += i[P >> 4] + i[15 & P];
    return k;
  }, g = (R) => {
    const P = a(R);
    if (P.length <= 65536) return String.fromCharCode(...P);
    let k = "", S = 0;
    for (; S < P.length; ) k += String.fromCharCode(...P.subarray(S, S += 65536));
    return k;
  }, v = typeof window < "u" ? window : self, w = v.crypto || v.msCrypto || {}, E = w.subtle || w.webkitSubtle, A = { hex: o, base64: y }, C = async (R, P, k = "sha-1") => {
    if (!E) throw new Error("no web crypto support");
    typeof R == "string" && (R = _(R));
    const S = new Uint8Array(await E.digest(k, R));
    return P ? A[P](S) : S;
  }, O = (R) => {
    const P = new Uint8Array(R);
    return w.getRandomValues(P);
  };
} }, ec = {};
function ae(t) {
  var e = ec[t];
  if (e !== void 0) return e.exports;
  var n = ec[t] = { exports: {} };
  return x_[t](n, n.exports, ae), n.exports;
}
ur = Object.getPrototypeOf ? (t) => Object.getPrototypeOf(t) : (t) => t.__proto__, ae.t = function(t, e) {
  if (1 & e && (t = this(t)), 8 & e || typeof t == "object" && t && (4 & e && t.__esModule || 16 & e && typeof t.then == "function"))
    return t;
  var n = /* @__PURE__ */ Object.create(null);
  ae.r(n);
  var i = {};
  oo = oo || [null, ur({}), ur([]), ur(ur)];
  for (var r = 2 & e && t; typeof r == "object" && !~oo.indexOf(r); r = ur(r)) Object.getOwnPropertyNames(r).forEach((s) => i[s] = () => t[s]);
  return i.default = () => t, ae.d(n, i), n;
}, ae.d = (t, e) => {
  for (var n in e) ae.o(e, n) && !ae.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, ae.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), ae.r = (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
};
var dn = ae(7007);
function os(t) {
  if (typeof t != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
}
function k_(t, e) {
  let n, i = "", r = 0, s = -1, o = 0;
  for (let a = 0; a <= t.length; ++a) {
    if (a < t.length) n = t.charCodeAt(a);
    else {
      if (n === 47) break;
      n = 47;
    }
    if (n === 47) {
      if (!(s === a - 1 || o === 1)) if (s !== a - 1 && o === 2) {
        if (i.length < 2 || r !== 2 || i.charCodeAt(i.length - 1) !== 46 || i.charCodeAt(i.length - 2) !== 46) {
          if (i.length > 2) {
            const u = i.lastIndexOf("/");
            if (u !== i.length - 1) {
              u === -1 ? (i = "", r = 0) : (i = i.slice(0, u), r = i.length - 1 - i.lastIndexOf("/")), s = a, o = 0;
              continue;
            }
          } else if (i.length === 2 || i.length === 1) {
            i = "", r = 0, s = a, o = 0;
            continue;
          }
        }
        e && (i.length > 0 ? i += "/.." : i = "..", r = 2);
      } else i.length > 0 ? i += "/" + t.slice(s + 1, a) : i = t.slice(s + 1, a), r = a - s - 1;
      s = a, o = 0;
    } else n === 46 && o !== -1 ? ++o : o = -1;
  }
  return i;
}
function ni() {
  if (arguments.length === 0) return ".";
  let t;
  for (let e = 0; e < arguments.length; ++e) {
    const n = arguments[e];
    os(n), n.length > 0 && (t === void 0 ? t = n : t += "/" + n);
  }
  return t === void 0 ? "." : function(e) {
    if (os(e), e.length === 0) return ".";
    const n = e.charCodeAt(0) === 47, i = e.charCodeAt(e.length - 1) === 47;
    return (e = k_(e, !n)).length !== 0 || n || (e = "."), e.length > 0 && i && (e += "/"), n ? "/" + e : e;
  }(t);
}
ae(717);
const S_ = "/";
var zt = ae(988), Xh = ae(1467), A_ = ae(8444), E_ = ae(2123);
const C_ = new RegExp(["^npm-debug\\.log$", "^\\..*\\.swp$", "^\\.DS_Store$", "^\\.AppleDouble$", "^\\.LSOverride$", "^Icon\\r$", "^\\._.*", "^\\.Spotlight-V100(?:$|\\/)", "\\.Trashes", "^__MACOSX$", "~$", "^Thumbs\\.db$", "^ehthumbs\\.db$", "^[Dd]esktop\\.ini$", "@eaDir$"].join("|"));
function T_(t) {
  return C_.test(t);
}
var Qh = ae(405), On = ae(8190), tt = ae(9596), re = ae(9639), Ei = (ae(3468), ae(2532));
const D_ = [["udp://tracker.leechers-paradise.org:6969"], ["udp://tracker.coppersurfer.tk:6969"], ["udp://tracker.opentrackr.org:1337"], ["udp://explodie.org:6969"], ["udp://tracker.empire-js.us:1337"], ["wss://tracker.btorrent.xyz"], ["wss://tracker.openwebtorrent.com"], ["wss://tracker.webtorrent.dev"]], ft = Symbol("itemPath");
function ef(t, e, n) {
  var i;
  if (i = t, typeof FileList < "u" && i instanceof FileList && (t = Array.from(t)), Array.isArray(t) || (t = [t]), t.length === 0) throw new Error("invalid input type");
  t.forEach((u) => {
    if (u == null) throw new Error(`invalid input type: ${u}`);
  }), (t = t.map((u) => tc(u) && typeof u.path == "string" && typeof Ei == "function" ? u.path : u)).length !== 1 || typeof t[0] == "string" || t[0].name || (t[0].name = e.name);
  let r = null;
  t.forEach((u, c) => {
    if (typeof u == "string") return;
    let l = u.fullPath || u.name;
    l || (l = `Unknown File ${c + 1}`, u.unknownName = !0), u[ft] = l.split("/"), u[ft][0] || u[ft].shift(), u[ft].length < 2 ? r = null : c === 0 && t.length > 1 ? r = u[ft][0] : u[ft][0] !== r && (r = null);
  }), (e.filterJunkFiles === void 0 || e.filterJunkFiles) && (t = t.filter((u) => typeof u == "string" || !function(c) {
    const l = c[c.length - 1];
    return l[0] === "." && T_(l);
  }(u[ft]))), r && t.forEach((u) => {
    const c = (ArrayBuffer.isView(u) || nc(u)) && !u[ft];
    typeof u == "string" || c || u[ft].shift();
  }), !e.name && r && (e.name = r), e.name || t.some((u) => typeof u == "string" ? (e.name = function(c, l) {
    os(c);
    let h, f = 0, d = -1, p = !0;
    for (h = c.length - 1; h >= 0; --h) if (c.charCodeAt(h) === 47) {
      if (!p) {
        f = h + 1;
        break;
      }
    } else d === -1 && (p = !1, d = h + 1);
    return d === -1 ? "" : c.slice(f, d);
  }(u), !0) : !u.unknownName && (e.name = u[ft][u[ft].length - 1], !0)), e.name || (e.name = `Unnamed Torrent ${Date.now()}`), e.maxPieceLength || (e.maxPieceLength = 4194304);
  const s = t.reduce((u, c) => u + +(typeof c == "string"), 0);
  let o = t.length === 1;
  if (t.length === 1 && typeof t[0] == "string") {
    if (typeof Ei != "function") throw new Error("filesystem paths do not work in the browser");
    E_(t[0], (u, c) => {
      if (u) return n(u);
      o = c, a();
    });
  } else tt(a);
  function a() {
    On(t.map((u) => (c) => {
      const l = {};
      if (tc(u)) l.getStream = u.stream(), l.length = u.size;
      else if (ArrayBuffer.isView(u)) l.getStream = [u], l.length = u.length;
      else {
        if (!nc(u)) {
          if (typeof u == "string") {
            if (typeof Ei != "function") throw new Error("filesystem paths do not work in the browser");
            return void Ei(u, s > 1 || o, c);
          }
          throw new Error("invalid input type");
        }
        l.getStream = async function* (h, f) {
          for await (const d of h) f.length += d.length, yield d;
        }(u, l), l.length = 0;
      }
      l.path = u[ft], c(null, l);
    }), (u, c) => {
      if (u) return n(u);
      c = c.flat(), n(null, c, o);
    });
  }
}
const F_ = 5;
function O_(t, e) {
  return t + e.length;
}
function tc(t) {
  return typeof Blob < "u" && t instanceof Blob;
}
function nc(t) {
  return typeof t == "object" && t != null && typeof t.pipe == "function";
}
const I_ = function(t, e, n) {
  typeof e == "function" && ([e, n] = [n, e]), ef(t, e = e ? Object.assign({}, e) : {}, (i, r, s) => {
    if (i) return n(i);
    e.singleFileTorrent = s, function(o, a, u) {
      let c = a.announceList;
      c || (typeof a.announce == "string" ? c = [[a.announce]] : Array.isArray(a.announce) && (c = a.announce.map((d) => [d]))), c || (c = []), globalThis.WEBTORRENT_ANNOUNCE && (typeof globalThis.WEBTORRENT_ANNOUNCE == "string" ? c.push([[globalThis.WEBTORRENT_ANNOUNCE]]) : Array.isArray(globalThis.WEBTORRENT_ANNOUNCE) && (c = c.concat(globalThis.WEBTORRENT_ANNOUNCE.map((d) => [d])))), a.announce === void 0 && a.announceList === void 0 && (c = c.concat(D_)), typeof a.urlList == "string" && (a.urlList = [a.urlList]);
      const l = { info: { name: a.name }, "creation date": Math.ceil((Number(a.creationDate) || Date.now()) / 1e3), encoding: "UTF-8" };
      c.length !== 0 && (l.announce = c[0][0], l["announce-list"] = c), a.comment !== void 0 && (l.comment = a.comment), a.createdBy !== void 0 && (l["created by"] = a.createdBy), a.private !== void 0 && (l.info.private = Number(a.private)), a.info !== void 0 && Object.assign(l.info, a.info), a.sslCert !== void 0 && (l.info["ssl-cert"] = a.sslCert), a.urlList !== void 0 && (l["url-list"] = a.urlList);
      const h = o.reduce(O_, 0), f = a.pieceLength || Math.min(A_(h), a.maxPieceLength);
      l.info["piece length"] = f, async function(d, p, m, _, y) {
        const b = [];
        let g = 0, v = 0;
        const w = d.map((P) => P.getStream), E = _.onProgress;
        let A = 0, C = 0, O = !1;
        const R = Xh(Qh(w), p, { zeroPadding: !1 });
        try {
          for await (const P of R) await new Promise((k) => {
            g += P.length;
            const S = C;
            ++C, ++A < F_ && k(), (0, re.tW)(P, "hex").then((x) => {
              b[S] = x, --A, v += P.length, E && E(v, m), k(), O && A === 0 && y(null, (0, re.fk)(b.join("")), g);
            });
          });
          if (A === 0) return y(null, (0, re.fk)(b.join("")), g);
          O = !0;
        } catch (P) {
          y(P);
        }
      }(o, f, h, a, (d, p, m) => {
        if (d) return u(d);
        l.info.pieces = p, o.forEach((_) => {
          delete _.getStream;
        }), a.singleFileTorrent ? l.info.length = m : l.info.files = o, u(null, zt.A.encode(l));
      });
    }(r, e, n);
  });
};
var Dt = ae(7833), rc = ae(6664), ic = ae(1827), sc = ae(3208);
const Ra = self.fetch || (() => {
  throw new Error("global fetch is not available!");
}), oc = [255, 255, 26, 27, 28, 29, 30, 31, 255, 255, 255, 255, 255, 255, 255, 255, 255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 255, 255, 255, 255, 255], P_ = function(t) {
  if (!ArrayBuffer.isView(t) && typeof t != "string") throw new TypeError("base32.decode only takes Buffer or string as parameter");
  let e, n = 0, i = 0, r = 0;
  ArrayBuffer.isView(t) || (t = (0, re.L0)(t));
  const s = new Uint8Array(Math.ceil(5 * t.length / 8));
  for (let o = 0; o < t.length && t[o] !== 61; o++) {
    const a = t[o] - 48;
    if (!(a < oc.length)) throw new Error("Invalid input - it is not base32 encoded string");
    i = oc[a], n <= 3 ? (n = (n + 5) % 8, n === 0 ? (e |= i, s[r] = e, r++, e = 0) : e |= 255 & i << 8 - n) : (n = (n + 5) % 8, e |= 255 & i >>> n, s[r] = e, r++, e = 255 & i << 8 - n);
  }
  return s.subarray(0, r);
};
function R_(t) {
  return t.reduce((e, n, i, r) => {
    const s = n.split("-").map((o) => parseInt(o));
    return e.concat(((o, a = o) => Array.from({ length: a - o + 1 }, (u, c) => c + o))(...s));
  }, []);
}
const ao = function(t) {
  const e = {}, n = t.split("magnet:?")[1];
  let i;
  return (n && n.length >= 0 ? n.split("&") : []).forEach((r) => {
    const s = r.split("=");
    if (s.length !== 2) return;
    const o = s[0];
    let a = s[1];
    o === "dn" && (a = decodeURIComponent(a).replace(/\+/g, " ")), o !== "tr" && o !== "xs" && o !== "as" && o !== "ws" || (a = decodeURIComponent(a)), o === "kt" && (a = decodeURIComponent(a).split("+")), o === "ix" && (a = Number(a)), o === "so" && (a = R_(decodeURIComponent(a).split(","))), e[o] ? (Array.isArray(e[o]) || (e[o] = [e[o]]), e[o].push(a)) : e[o] = a;
  }), e.xt && (Array.isArray(e.xt) ? e.xt : [e.xt]).forEach((r) => {
    (i = r.match(/^urn:btih:(.{40})/)) ? e.infoHash = i[1].toLowerCase() : (i = r.match(/^urn:btih:(.{32})/)) ? e.infoHash = (0, re.V5)(P_(i[1])) : (i = r.match(/^urn:btmh:1220(.{64})/)) && (e.infoHashV2 = i[1].toLowerCase());
  }), e.xs && (Array.isArray(e.xs) ? e.xs : [e.xs]).forEach((r) => {
    (i = r.match(/^urn:btpk:(.{64})/)) && (e.publicKey = i[1].toLowerCase());
  }), e.infoHash && (e.infoHashBuffer = (0, re.fk)(e.infoHash)), e.infoHashV2 && (e.infoHashV2Buffer = (0, re.fk)(e.infoHashV2)), e.publicKey && (e.publicKeyBuffer = (0, re.fk)(e.publicKey)), e.dn && (e.name = e.dn), e.kt && (e.keywords = e.kt), e.announce = [], (typeof e.tr == "string" || Array.isArray(e.tr)) && (e.announce = e.announce.concat(e.tr)), e.urlList = [], (typeof e.as == "string" || Array.isArray(e.as)) && (e.urlList = e.urlList.concat(e.as)), (typeof e.ws == "string" || Array.isArray(e.ws)) && (e.urlList = e.urlList.concat(e.ws)), e.peerAddresses = [], (typeof e["x.pe"] == "string" || Array.isArray(e["x.pe"])) && (e.peerAddresses = e.peerAddresses.concat(e["x.pe"])), e.announce = Array.from(new Set(e.announce)), e.urlList = Array.from(new Set(e.urlList)), e.peerAddresses = Array.from(new Set(e.peerAddresses)), e;
};
async function Wo(t) {
  if (typeof t == "string" && /^(stream-)?magnet:/.test(t)) {
    const e = ao(t);
    if (!e.infoHash) throw new Error("Invalid torrent identifier");
    return e;
  }
  if (typeof t == "string" && (/^[a-f0-9]{40}$/i.test(t) || /^[a-z2-7]{32}$/i.test(t))) return ao(`magnet:?xt=urn:btih:${t}`);
  if (ArrayBuffer.isView(t) && t.length === 20) return ao(`magnet:?xt=urn:btih:${(0, re.V5)(t)}`);
  if (ArrayBuffer.isView(t)) return await async function(e) {
    ArrayBuffer.isView(e) && (e = zt.A.decode(e)), Nn(e.info, "info"), Nn(e.info["name.utf-8"] || e.info.name, "info.name"), Nn(e.info["piece length"], "info['piece length']"), Nn(e.info.pieces, "info.pieces"), e.info.files ? e.info.files.forEach((s) => {
      Nn(typeof s.length == "number", "info.files[0].length"), Nn(s["path.utf-8"] || s.path, "info.files[0].path");
    }) : Nn(typeof e.info.length == "number", "info.length");
    const n = { info: e.info, infoBuffer: zt.A.encode(e.info), name: (0, re.dU)(e.info["name.utf-8"] || e.info.name), announce: [] };
    n.infoHashBuffer = await (0, re.tW)(n.infoBuffer), n.infoHash = (0, re.V5)(n.infoHashBuffer), e.info.private !== void 0 && (n.private = !!e.info.private), e["creation date"] && (n.created = new Date(1e3 * e["creation date"])), e["created by"] && (n.createdBy = (0, re.dU)(e["created by"])), ArrayBuffer.isView(e.comment) && (n.comment = (0, re.dU)(e.comment)), Array.isArray(e["announce-list"]) && e["announce-list"].length > 0 ? e["announce-list"].forEach((s) => {
      s.forEach((o) => {
        n.announce.push((0, re.dU)(o));
      });
    }) : e.announce && n.announce.push((0, re.dU)(e.announce)), ArrayBuffer.isView(e["url-list"]) && (e["url-list"] = e["url-list"].length > 0 ? [e["url-list"]] : []), n.urlList = (e["url-list"] || []).map((s) => (0, re.dU)(s)), n.announce = Array.from(new Set(n.announce)), n.urlList = Array.from(new Set(n.urlList));
    const i = e.info.files || [e.info];
    n.files = i.map((s, o) => {
      const a = [].concat(n.name, s["path.utf-8"] || s.path || []).map((u) => ArrayBuffer.isView(u) ? (0, re.dU)(u) : u);
      return { path: ni.apply(null, [S_].concat(a)).slice(1), name: a[a.length - 1], length: s.length, offset: i.slice(0, o).reduce(ac, 0) };
    }), n.length = i.reduce(ac, 0);
    const r = n.files[n.files.length - 1];
    return n.pieceLength = e.info["piece length"], n.lastPieceLength = (r.offset + r.length) % n.pieceLength || n.pieceLength, n.pieces = function(s) {
      const o = [];
      for (let a = 0; a < s.length; a += 20) o.push((0, re.V5)(s.slice(a, a + 20)));
      return o;
    }(e.info.pieces), n;
  }(t);
  if (t && t.infoHash) return t.infoHash = t.infoHash.toLowerCase(), t.announce || (t.announce = []), typeof t.announce == "string" && (t.announce = [t.announce]), t.urlList || (t.urlList = []), t;
  throw new Error("Invalid torrent identifier");
}
async function tf(t, e, n) {
  if (typeof e == "function") return tf(t, {}, e);
  if (typeof n != "function") throw new Error("second argument must be a Function");
  let i;
  try {
    i = await Wo(t);
  } catch {
  }
  if (i && i.infoHash) tt(() => {
    n(null, i);
  });
  else if (r = t, typeof Blob < "u" && r instanceof Blob) try {
    s(new Uint8Array(await t.arrayBuffer()));
  } catch (o) {
    return n(new Error(`Error converting Blob: ${o.message}`));
  }
  else if (/^https?:/.test(t)) try {
    const o = await Ra(t, { headers: { "user-agent": "WebTorrent (https://webtorrent.io)" }, signal: AbortSignal.timeout(3e4), ...e });
    s(new Uint8Array(await o.arrayBuffer()));
  } catch (o) {
    return n(new Error(`Error downloading torrent: ${o.message}`));
  }
  else typeof sc.readFile == "function" && typeof t == "string" ? sc.readFile(t, (o, a) => {
    if (o) return n(new Error("Invalid torrent identifier"));
    s(a);
  }) : tt(() => {
    n(new Error("Invalid torrent identifier"));
  });
  var r;
  async function s(o) {
    try {
      i = await Wo(o);
    } catch (a) {
      return n(a);
    }
    i && i.infoHash ? n(null, i) : n(new Error("Invalid torrent identifier"));
  }
}
function ac(t, e) {
  return t + e.length;
}
function Nn(t, e) {
  if (!t) throw new Error(`Torrent is missing required field: ${e}`);
}
const zi = Wo, L_ = function(t) {
  t = Object.assign({}, t);
  let e = /* @__PURE__ */ new Set();
  t.xt && typeof t.xt == "string" && e.add(t.xt), t.xt && Array.isArray(t.xt) && (e = new Set(t.xt)), t.infoHashBuffer && e.add(`urn:btih:${(0, re.V5)(t.infoHashBuffer)}`), t.infoHash && e.add(`urn:btih:${t.infoHash}`), t.infoHashV2Buffer && e.add(t.xt = `urn:btmh:1220${(0, re.V5)(t.infoHashV2Buffer)}`), t.infoHashV2 && e.add(`urn:btmh:1220${t.infoHashV2}`);
  const n = Array.from(e);
  n.length === 1 && (t.xt = n[0]), n.length > 1 && (t.xt = n), t.publicKeyBuffer && (t.xs = `urn:btpk:${(0, re.V5)(t.publicKeyBuffer)}`), t.publicKey && (t.xs = `urn:btpk:${t.publicKey}`), t.name && (t.dn = t.name), t.keywords && (t.kt = t.keywords), t.announce && (t.tr = t.announce), t.urlList && (t.ws = t.urlList, delete t.as), t.peerAddresses && (t["x.pe"] = t.peerAddresses);
  let i = "magnet:?";
  return Object.keys(t).filter((r) => r.length === 2 || r === "x.pe").forEach((r, s) => {
    const o = Array.isArray(t[r]) ? t[r] : [t[r]];
    var a;
    o.forEach((u, c) => {
      (s > 0 || c > 0) && (r !== "kt" && r !== "so" || c === 0) && (i += "&"), r === "dn" && (u = encodeURIComponent(u).replace(/%20/g, "+")), r !== "tr" && r !== "as" && r !== "ws" || (u = encodeURIComponent(u)), r !== "xs" || u.startsWith("urn:btpk:") || (u = encodeURIComponent(u)), r === "kt" && (u = encodeURIComponent(u)), r !== "so" && (i += r === "kt" && c > 0 ? `+${u}` : `${r}=${u}`);
    }), r === "so" && (i += `${r}=${a = o, a.reduce((u, c, l, h) => (l !== 0 && c === h[l - 1] + 1 || u.push([]), u[u.length - 1].push(c), u), []).map((u) => u.length > 1 ? `${u[0]}-${u[u.length - 1]}` : `${u[0]}`)}`);
  }), i;
}, on = typeof window < "u" ? window : self, Vo = on.RTCPeerConnection || on.mozRTCPeerConnection || on.webkitRTCPeerConnection, M_ = on.RTCSessionDescription || on.mozRTCSessionDescription || on.webkitRTCSessionDescription, j_ = on.RTCIceCandidate || on.mozRTCIceCandidate || on.webkitRTCIceCandidate;
var Ss = ae(8179), $e = ae(6310);
const N_ = Dt("simple-peer"), uo = 65536;
function uc(t) {
  return t.replace(/a=ice-options:trickle\s\n/g, "");
}
class Xn extends Ss.Duplex {
  constructor(n) {
    super(n = Object.assign({ allowHalfOpen: !1 }, n));
    ut(this, "_pc");
    if (this.__objectMode = !!n.objectMode, this._id = (0, re.V5)((0, re.po)(4)).slice(0, 7), this._debug("new peer %o", n), this.channelName = n.initiator ? n.channelName || (0, re.V5)((0, re.po)(20)) : null, this.initiator = n.initiator || !1, this.channelConfig = n.channelConfig || Xn.channelConfig, this.channelNegotiated = this.channelConfig.negotiated, this.config = Object.assign({}, Xn.config, n.config), this.offerOptions = n.offerOptions || {}, this.answerOptions = n.answerOptions || {}, this.sdpTransform = n.sdpTransform || ((i) => i), this.trickle = n.trickle === void 0 || n.trickle, this.allowHalfTrickle = n.allowHalfTrickle !== void 0 && n.allowHalfTrickle, this.iceCompleteTimeout = n.iceCompleteTimeout || 5e3, this._destroying = !1, this._connected = !1, this.remoteAddress = void 0, this.remoteFamily = void 0, this.remotePort = void 0, this.localAddress = void 0, this.localFamily = void 0, this.localPort = void 0, !Vo) throw $e(typeof window > "u" ? new Error("No WebRTC support: Specify `opts.wrtc` option in this environment") : new Error("No WebRTC support: Not a supported browser"), "ERR_WEBRTC_SUPPORT");
    this._pcReady = !1, this._channelReady = !1, this._iceComplete = !1, this._iceCompleteTimer = null, this._channel = null, this._pendingCandidates = [], this._isNegotiating = !1, this._firstNegotiation = !0, this._batchedNegotiation = !1, this._queuedNegotiation = !1, this._sendersAwaitingStable = [], this._closingInterval = null, this._remoteTracks = [], this._remoteStreams = [], this._chunk = null, this._cb = null, this._interval = null;
    try {
      this._pc = new Vo(this.config);
    } catch (i) {
      return void this.__destroy($e(i, "ERR_PC_CONSTRUCTOR"));
    }
    this._isReactNativeWebrtc = typeof this._pc._peerConnectionId == "number", this._pc.oniceconnectionstatechange = () => {
      this._onIceStateChange();
    }, this._pc.onicegatheringstatechange = () => {
      this._onIceStateChange();
    }, this._pc.onconnectionstatechange = () => {
      this._onConnectionStateChange();
    }, this._pc.onsignalingstatechange = () => {
      this._onSignalingStateChange();
    }, this._pc.onicecandidate = (i) => {
      this._onIceCandidate(i);
    }, typeof this._pc.peerIdentity == "object" && this._pc.peerIdentity.catch((i) => {
      this.__destroy($e(i, "ERR_PC_PEER_IDENTITY"));
    }), this.initiator || this.channelNegotiated ? this._setupData({ channel: this._pc.createDataChannel(this.channelName, this.channelConfig) }) : this._pc.ondatachannel = (i) => {
      this._setupData(i);
    }, this._debug("initial negotiation"), this._needsNegotiation(), this._onFinishBound = () => {
      this._onFinish();
    }, this.once("finish", this._onFinishBound);
  }
  get bufferSize() {
    return this._channel && this._channel.bufferedAmount || 0;
  }
  get connected() {
    return this._connected && this._channel.readyState === "open";
  }
  address() {
    return { port: this.localPort, family: this.localFamily, address: this.localAddress };
  }
  signal(n) {
    if (!this._destroying) {
      if (this.destroyed) throw $e(new Error("cannot signal after peer is destroyed"), "ERR_DESTROYED");
      if (typeof n == "string") try {
        n = JSON.parse(n);
      } catch {
        n = {};
      }
      this._debug("signal()"), n.renegotiate && this.initiator && (this._debug("got request to renegotiate"), this._needsNegotiation()), n.transceiverRequest && this.initiator && (this._debug("got request for transceiver"), this.addTransceiver(n.transceiverRequest.kind, n.transceiverRequest.init)), n.candidate && (this._pc.remoteDescription && this._pc.remoteDescription.type ? this._addIceCandidate(n.candidate) : this._pendingCandidates.push(n.candidate)), n.sdp && this._pc.setRemoteDescription(new M_(n)).then(() => {
        this.destroyed || (this._pendingCandidates.forEach((i) => {
          this._addIceCandidate(i);
        }), this._pendingCandidates = [], this._pc.remoteDescription.type === "offer" && this._createAnswer());
      }).catch((i) => {
        this.__destroy($e(i, "ERR_SET_REMOTE_DESCRIPTION"));
      }), n.sdp || n.candidate || n.renegotiate || n.transceiverRequest || this.__destroy($e(new Error("signal() called with invalid signal data"), "ERR_SIGNALING"));
    }
  }
  _addIceCandidate(n) {
    const i = new j_(n);
    this._pc.addIceCandidate(i).catch((r) => {
      var s;
      !i.address || i.address.endsWith(".local") ? (s = "Ignoring unsupported ICE candidate.", console.warn(s)) : this.__destroy($e(r, "ERR_ADD_ICE_CANDIDATE"));
    });
  }
  send(n) {
    if (!this._destroying) {
      if (this.destroyed) throw $e(new Error("cannot send after peer is destroyed"), "ERR_DESTROYED");
      this._channel.send(n);
    }
  }
  _needsNegotiation() {
    this._debug("_needsNegotiation"), this._batchedNegotiation || (this._batchedNegotiation = !0, queueMicrotask(() => {
      this._batchedNegotiation = !1, this.initiator || !this._firstNegotiation ? (this._debug("starting batched negotiation"), this.negotiate()) : this._debug("non-initiator initial negotiation request discarded"), this._firstNegotiation = !1;
    }));
  }
  negotiate() {
    if (!this._destroying) {
      if (this.destroyed) throw $e(new Error("cannot negotiate after peer is destroyed"), "ERR_DESTROYED");
      this.initiator ? this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("start negotiation"), setTimeout(() => {
        this._createOffer();
      }, 0)) : this._isNegotiating ? (this._queuedNegotiation = !0, this._debug("already negotiating, queueing")) : (this._debug("requesting negotiation from initiator"), this.emit("signal", { type: "renegotiate", renegotiate: !0 })), this._isNegotiating = !0;
    }
  }
  _final(n) {
    this._readableState.ended || this.push(null), n(null);
  }
  __destroy(n) {
    this.end(), this._destroy(() => {
    }, n);
  }
  _destroy(n, i) {
    this.destroyed || this._destroying || (this._destroying = !0, this._debug("destroying (error: %s)", i && (i.message || i)), setTimeout(() => {
      if (this._connected = !1, this._pcReady = !1, this._channelReady = !1, this._remoteTracks = null, this._remoteStreams = null, this._senderMap = null, clearInterval(this._closingInterval), this._closingInterval = null, clearInterval(this._interval), this._interval = null, this._chunk = null, this._cb = null, this._onFinishBound && this.removeListener("finish", this._onFinishBound), this._onFinishBound = null, this._channel) {
        try {
          this._channel.close();
        } catch {
        }
        this._channel.onmessage = null, this._channel.onopen = null, this._channel.onclose = null, this._channel.onerror = null;
      }
      if (this._pc) {
        try {
          this._pc.close();
        } catch {
        }
        this._pc.oniceconnectionstatechange = null, this._pc.onicegatheringstatechange = null, this._pc.onsignalingstatechange = null, this._pc.onicecandidate = null, this._pc.ontrack = null, this._pc.ondatachannel = null;
      }
      this._pc = null, this._channel = null, i && this.emit("error", i), n();
    }, 0));
  }
  _setupData(n) {
    if (!n.channel) return this.__destroy($e(new Error("Data channel event is missing `channel` property"), "ERR_DATA_CHANNEL"));
    this._channel = n.channel, this._channel.binaryType = "arraybuffer", typeof this._channel.bufferedAmountLowThreshold == "number" && (this._channel.bufferedAmountLowThreshold = uo), this.channelName = this._channel.label, this._channel.onmessage = (r) => {
      this._onChannelMessage(r);
    }, this._channel.onbufferedamountlow = () => {
      this._onChannelBufferedAmountLow();
    }, this._channel.onopen = () => {
      this._onChannelOpen();
    }, this._channel.onclose = () => {
      this._onChannelClose();
    }, this._channel.onerror = (r) => {
      const s = r.error instanceof Error ? r.error : new Error(`Datachannel error: ${r.message} ${r.filename}:${r.lineno}:${r.colno}`);
      this.__destroy($e(s, "ERR_DATA_CHANNEL"));
    };
    let i = !1;
    this._closingInterval = setInterval(() => {
      this._channel && this._channel.readyState === "closing" ? (i && this._onChannelClose(), i = !0) : i = !1;
    }, 5e3);
  }
  _write(n, i) {
    if (this.destroyed) return i($e(new Error("cannot write after peer is destroyed"), "ERR_DATA_CHANNEL"));
    if (this._connected) {
      try {
        this.send(n);
      } catch (r) {
        return this.__destroy($e(r, "ERR_DATA_CHANNEL"));
      }
      this._channel.bufferedAmount > uo ? (this._debug("start backpressure: bufferedAmount %d", this._channel.bufferedAmount), this._cb = i) : i(null);
    } else this._debug("write before connect"), this._chunk = n, this._cb = i;
  }
  _onFinish() {
    if (this.destroyed) return;
    const n = () => {
      setTimeout(() => this.__destroy(), 1e3);
    };
    this._connected ? n() : this.once("connect", n);
  }
  _startIceCompleteTimeout() {
    this.destroyed || this._iceCompleteTimer || (this._debug("started iceComplete timeout"), this._iceCompleteTimer = setTimeout(() => {
      this._iceComplete || (this._iceComplete = !0, this._debug("iceComplete timeout completed"), this.emit("iceTimeout"), this.emit("_iceComplete"));
    }, this.iceCompleteTimeout));
  }
  _createOffer() {
    this.destroyed || this._pc.createOffer(this.offerOptions).then((n) => {
      if (this.destroyed) return;
      this.trickle || this.allowHalfTrickle || (n.sdp = uc(n.sdp)), n.sdp = this.sdpTransform(n.sdp);
      const i = () => {
        if (this.destroyed) return;
        const r = this._pc.localDescription || n;
        this._debug("signal"), this.emit("signal", { type: r.type, sdp: r.sdp });
      };
      this._pc.setLocalDescription(n).then(() => {
        this._debug("createOffer success"), this.destroyed || (this.trickle || this._iceComplete ? i() : this.once("_iceComplete", i));
      }).catch((r) => {
        this.__destroy($e(r, "ERR_SET_LOCAL_DESCRIPTION"));
      });
    }).catch((n) => {
      this.__destroy($e(n, "ERR_CREATE_OFFER"));
    });
  }
  _createAnswer() {
    this.destroyed || this._pc.createAnswer(this.answerOptions).then((n) => {
      if (this.destroyed) return;
      this.trickle || this.allowHalfTrickle || (n.sdp = uc(n.sdp)), n.sdp = this.sdpTransform(n.sdp);
      const i = () => {
        var s;
        if (this.destroyed) return;
        const r = this._pc.localDescription || n;
        this._debug("signal"), this.emit("signal", { type: r.type, sdp: r.sdp }), this.initiator || ((s = this._requestMissingTransceivers) == null || s.call(this));
      };
      this._pc.setLocalDescription(n).then(() => {
        this.destroyed || (this.trickle || this._iceComplete ? i() : this.once("_iceComplete", i));
      }).catch((r) => {
        this.__destroy($e(r, "ERR_SET_LOCAL_DESCRIPTION"));
      });
    }).catch((n) => {
      this.__destroy($e(n, "ERR_CREATE_ANSWER"));
    });
  }
  _onConnectionStateChange() {
    this.destroyed || this._destroying || this._pc.connectionState === "failed" && this.__destroy($e(new Error("Connection failed."), "ERR_CONNECTION_FAILURE"));
  }
  _onIceStateChange() {
    if (this.destroyed) return;
    const n = this._pc.iceConnectionState, i = this._pc.iceGatheringState;
    this._debug("iceStateChange (connection: %s) (gathering: %s)", n, i), this.emit("iceStateChange", n, i), n !== "connected" && n !== "completed" || (this._pcReady = !0, this._maybeReady()), n === "failed" && this.__destroy($e(new Error("Ice connection failed."), "ERR_ICE_CONNECTION_FAILURE")), n === "closed" && this.__destroy($e(new Error("Ice connection closed."), "ERR_ICE_CONNECTION_CLOSED"));
  }
  getStats(n) {
    const i = (r) => (Object.prototype.toString.call(r.values) === "[object Array]" && r.values.forEach((s) => {
      Object.assign(r, s);
    }), r);
    this._pc.getStats.length === 0 || this._isReactNativeWebrtc ? this._pc.getStats().then((r) => {
      const s = [];
      r.forEach((o) => {
        s.push(i(o));
      }), n(null, s);
    }, (r) => n(r)) : this._pc.getStats.length > 0 ? this._pc.getStats((r) => {
      if (this.destroyed) return;
      const s = [];
      r.result().forEach((o) => {
        const a = {};
        o.names().forEach((u) => {
          a[u] = o.stat(u);
        }), a.id = o.id, a.type = o.type, a.timestamp = o.timestamp, s.push(i(a));
      }), n(null, s);
    }, (r) => n(r)) : n(null, []);
  }
  _maybeReady() {
    if (this._debug("maybeReady pc %s channel %s", this._pcReady, this._channelReady), this._connected || this._connecting || !this._pcReady || !this._channelReady) return;
    this._connecting = !0;
    const n = () => {
      this.destroyed || this._destroying || this.getStats((i, r) => {
        if (this.destroyed || this._destroying) return;
        i && (r = []);
        const s = {}, o = {}, a = {};
        let u = !1;
        r.forEach((l) => {
          l.type !== "remotecandidate" && l.type !== "remote-candidate" || (s[l.id] = l), l.type !== "localcandidate" && l.type !== "local-candidate" || (o[l.id] = l), l.type !== "candidatepair" && l.type !== "candidate-pair" || (a[l.id] = l);
        });
        const c = (l) => {
          u = !0;
          let h = o[l.localCandidateId];
          h && (h.ip || h.address) ? (this.localAddress = h.ip || h.address, this.localPort = Number(h.port)) : h && h.ipAddress ? (this.localAddress = h.ipAddress, this.localPort = Number(h.portNumber)) : typeof l.googLocalAddress == "string" && (h = l.googLocalAddress.split(":"), this.localAddress = h[0], this.localPort = Number(h[1])), this.localAddress && (this.localFamily = this.localAddress.includes(":") ? "IPv6" : "IPv4");
          let f = s[l.remoteCandidateId];
          f && (f.ip || f.address) ? (this.remoteAddress = f.ip || f.address, this.remotePort = Number(f.port)) : f && f.ipAddress ? (this.remoteAddress = f.ipAddress, this.remotePort = Number(f.portNumber)) : typeof l.googRemoteAddress == "string" && (f = l.googRemoteAddress.split(":"), this.remoteAddress = f[0], this.remotePort = Number(f[1])), this.remoteAddress && (this.remoteFamily = this.remoteAddress.includes(":") ? "IPv6" : "IPv4"), this._debug("connect local: %s:%s remote: %s:%s", this.localAddress, this.localPort, this.remoteAddress, this.remotePort);
        };
        if (r.forEach((l) => {
          l.type === "transport" && l.selectedCandidatePairId && c(a[l.selectedCandidatePairId]), (l.type === "googCandidatePair" && l.googActiveConnection === "true" || (l.type === "candidatepair" || l.type === "candidate-pair") && l.selected) && c(l);
        }), u || Object.keys(a).length && !Object.keys(o).length) {
          if (this._connecting = !1, this._connected = !0, this._chunk) {
            try {
              this.send(this._chunk);
            } catch (h) {
              return this.__destroy($e(h, "ERR_DATA_CHANNEL"));
            }
            this._chunk = null, this._debug('sent chunk from "write before connect"');
            const l = this._cb;
            this._cb = null, l(null);
          }
          typeof this._channel.bufferedAmountLowThreshold != "number" && (this._interval = setInterval(() => this._onInterval(), 150), this._interval.unref && this._interval.unref()), this._debug("connect"), this.emit("connect");
        } else setTimeout(n, 100);
      });
    };
    n();
  }
  _onInterval() {
    !this._cb || !this._channel || this._channel.bufferedAmount > uo || this._onChannelBufferedAmountLow();
  }
  _onSignalingStateChange() {
    this.destroyed || (this._pc.signalingState === "stable" && (this._isNegotiating = !1, this._debug("flushing sender queue", this._sendersAwaitingStable), this._sendersAwaitingStable.forEach((n) => {
      this._pc.removeTrack(n), this._queuedNegotiation = !0;
    }), this._sendersAwaitingStable = [], this._queuedNegotiation ? (this._debug("flushing negotiation queue"), this._queuedNegotiation = !1, this._needsNegotiation()) : (this._debug("negotiated"), this.emit("negotiated"))), this._debug("signalingStateChange %s", this._pc.signalingState), this.emit("signalingStateChange", this._pc.signalingState));
  }
  _onIceCandidate(n) {
    this.destroyed || (n.candidate && this.trickle ? this.emit("signal", { type: "candidate", candidate: { candidate: n.candidate.candidate, sdpMLineIndex: n.candidate.sdpMLineIndex, sdpMid: n.candidate.sdpMid } }) : n.candidate || this._iceComplete || (this._iceComplete = !0, this.emit("_iceComplete")), n.candidate && this._startIceCompleteTimeout());
  }
  _onChannelMessage(n) {
    if (this.destroyed) return;
    let i = n.data;
    i instanceof ArrayBuffer ? i = new Uint8Array(i) : this.__objectMode === !1 && (i = (0, re.L0)(i)), this.push(i);
  }
  _onChannelBufferedAmountLow() {
    if (this.destroyed || !this._cb) return;
    this._debug("ending backpressure: bufferedAmount %d", this._channel.bufferedAmount);
    const n = this._cb;
    this._cb = null, n(null);
  }
  _onChannelOpen() {
    this._connected || this.destroyed || (this._debug("on channel open"), this._channelReady = !0, this._maybeReady());
  }
  _onChannelClose() {
    this.destroyed || (this._debug("on channel close"), this.__destroy());
  }
  _debug() {
    const n = [].slice.call(arguments);
    n[0] = "[" + this._id + "] " + n[0], N_.apply(null, n);
  }
}
Xn.WEBRTC_SUPPORT = !!Vo, Xn.config = { iceServers: [{ urls: ["stun:stun.l.google.com:19302", "stun:global.stun.twilio.com:3478"] }], sdpSemantics: "unified-plan" }, Xn.channelConfig = {};
const La = Xn;
var as = ae(1035), cc = ae(7541), lc = ae(3278), Go = ae(8271), nf = ae(6686), hc = ae(7828), fc = ae(6889);
const B_ = /^\[?([^\]]+)]?:(\d+)$/;
let Ir = /* @__PURE__ */ new Map();
function Pr(t) {
  if (Ir.size === 1e5 && Ir.clear(), !Ir.has(t)) {
    const e = B_.exec(t);
    if (!e) throw new Error(`invalid addr: ${t}`);
    Ir.set(t, [e[1], Number(e[2])]);
  }
  return Ir.get(t);
}
var us = ae(3033), $_ = ae(4497);
async function* z_(t, e = {}) {
  if (t != null && t[Symbol.asyncIterator]) return void (yield* t[Symbol.asyncIterator](e.offset));
  if (!(t != null && t.get)) throw new Error("First argument must be an abstract-chunk-store compliant store");
  const n = e.chunkLength || t.chunkLength;
  if (!n) throw new Error("missing required `chunkLength` property");
  let i = e.length || t.length;
  if (!Number.isFinite(i)) throw new Error("missing required `length` property");
  const r = e.offset || 0, s = (u, c, l) => new Promise((h, f) => {
    t.get(u, { offset: l, length: c }, (d, p) => {
      d && f(d), h(p);
    });
  });
  let o = Math.floor(r / n);
  const a = r % n;
  if (r) {
    const u = Math.min(i, n - a);
    i -= u, yield s(o++, u, a);
  }
  for (let u = i; u > 0; ++o, u -= n) yield s(o, Math.min(u, n));
}
async function U_(t, e, n = {}) {
  if (!(t != null && t.put)) throw new Error("First argument must be an abstract-chunk-store compliant store");
  const i = n.chunkLength || t.chunkLength;
  if (!i) throw new Error("missing required `chunkLength` property");
  const r = n.storeMaxOutstandingPuts || 16;
  let s = 0, o = 0, a = () => {
  }, u = !1;
  for await (const c of Xh(e, i, { zeroPadding: n.zeroPadding || !1 })) await new Promise((l, h) => {
    s++ <= r && l(), t.put(o++, c, (f) => {
      if (f) return h(f);
      --s, l(), u && s === 0 && a();
    });
  });
  s !== 0 && (u = new Promise((c) => {
    a = c;
  }), await u);
}
var H_ = ae(4018), dc = ae(3970), rf = ae(3519), q_ = ae(1551);
const Ko = { DEFAULT_ANNOUNCE_PEERS: 50, MAX_ANNOUNCE_PEERS: 82, parseUrl: (t) => {
  const e = new URL(t.replace(/^udp:/, "http:"));
  return t.match(/^udp:/) && Object.defineProperties(e, { href: { value: e.href.replace(/^http/, "udp") }, protocol: { value: e.protocol.replace(/^http/, "udp") }, origin: { value: e.origin.replace(/^http/, "udp") } }), e;
}, ...ae.t(q_, 2) };
var pc = ae(826), mc = ae(61), Wr = ae(2701);
const W_ = Dt("simple-websocket"), $r = typeof Wr != "function" ? WebSocket : Wr;
class sf extends Ss.Duplex {
  constructor(e = {}) {
    if (typeof e == "string" && (e = { url: e }), super(e = Object.assign({ allowHalfOpen: !1 }, e)), this.__objectMode = !!e.objectMode, e.objectMode != null && delete e.objectMode, e.url == null && e.socket == null) throw new Error("Missing required `url` or `socket` option");
    if (e.url != null && e.socket != null) throw new Error("Must specify either `url` or `socket` option, not both");
    if (this._id = (0, re.V5)((0, re.po)(4)).slice(0, 7), this._debug("new websocket: %o", e), this.connected = !1, this._chunk = null, this._cb = null, this._interval = null, e.socket) this.url = e.socket.url, this._ws = e.socket, this.connected = e.socket.readyState === $r.OPEN;
    else {
      this.url = e.url;
      try {
        this._ws = typeof Wr == "function" ? new $r(e.url, { ...e, encoding: void 0 }) : new $r(e.url);
      } catch (n) {
        return void tt(() => this.destroy(n));
      }
    }
    this._ws.binaryType = "arraybuffer", e.socket && this.connected ? tt(() => this._handleOpen()) : this._ws.onopen = () => this._handleOpen(), this._ws.onmessage = (n) => this._handleMessage(n), this._ws.onclose = () => this._handleClose(), this._ws.onerror = (n) => this._handleError(n), this._handleFinishBound = () => this._handleFinish(), this.once("finish", this._handleFinishBound);
  }
  send(e) {
    this._ws.send(e);
  }
  _final(e) {
    this._readableState.ended || this.push(null), e(null);
  }
  _destroy(e) {
    if (!this.destroyed) {
      if (this._writableState.ended || this.end(), this.connected = !1, clearInterval(this._interval), this._interval = null, this._chunk = null, this._cb = null, this._handleFinishBound && this.removeListener("finish", this._handleFinishBound), this._handleFinishBound = null, this._ws) {
        const n = this._ws, i = () => {
          n.onclose = null;
        };
        if (n.readyState === $r.CLOSED) i();
        else try {
          n.onclose = i, n.close();
        } catch {
          i();
        }
        n.onopen = null, n.onmessage = null, n.onerror = () => {
        };
      }
      this._ws = null, e();
    }
  }
  _write(e, n) {
    if (this.destroyed) return n(new Error("cannot write after socket is destroyed"));
    if (this.connected) {
      try {
        this.send(e);
      } catch (i) {
        return this.destroy(i);
      }
      typeof Wr != "function" && this._ws.bufferedAmount > 65536 ? (this._debug("start backpressure: bufferedAmount %d", this._ws.bufferedAmount), this._cb = n) : n(null);
    } else this._debug("write before connect"), this._chunk = e, this._cb = n;
  }
  _handleOpen() {
    if (!this.connected && !this.destroyed) {
      if (this.connected = !0, this._chunk) {
        try {
          this.send(this._chunk);
        } catch (n) {
          return this.destroy(n);
        }
        this._chunk = null, this._debug('sent chunk from "write before connect"');
        const e = this._cb;
        this._cb = null, e(null);
      }
      typeof Wr != "function" && (this._interval = setInterval(() => this._onInterval(), 150), this._interval.unref && this._interval.unref()), this._debug("connect"), this.emit("connect");
    }
  }
  _handleMessage(e) {
    if (this.destroyed) return;
    let n = e.data;
    n instanceof ArrayBuffer && (n = new Uint8Array(n)), this.__objectMode === !1 && (n = (0, re.L0)(n)), this.push(n);
  }
  _handleClose() {
    this.destroyed || (this._debug("on close"), this.destroy());
  }
  _handleError(e) {
    this.destroy(new Error(`Error connecting to ${this.url}`));
  }
  _handleFinish() {
    if (this.destroyed) return;
    const e = () => {
      setTimeout(() => this.destroy(), 1e3);
    };
    this.connected ? e() : this.once("connect", e);
  }
  _onInterval() {
    if (!this._cb || !this._ws || this._ws.bufferedAmount > 65536) return;
    this._debug("ending backpressure: bufferedAmount %d", this._ws.bufferedAmount);
    const e = this._cb;
    this._cb = null, e(null);
  }
  _debug() {
    const e = [].slice.call(arguments);
    e[0] = "[" + this._id + "] " + e[0], W_.apply(null, e);
  }
}
sf.WEBSOCKET_SUPPORT = !!$r;
const V_ = class extends dn {
  constructor(t, e) {
    super(), this.client = t, this.announceUrl = e, this.interval = null, this.destroyed = !1;
  }
  setInterval(t) {
    t == null && (t = this.DEFAULT_ANNOUNCE_INTERVAL), clearInterval(this.interval), t && (this.interval = setInterval(() => {
      this.announce(this.client._defaultAnnounceOpts());
    }, t), this.interval.unref && this.interval.unref());
  }
}, xt = Dt("bittorrent-tracker:websocket-tracker"), en = {};
class Zo extends V_ {
  constructor(e, n) {
    super(e, n), xt("new websocket tracker %s", n), this.peers = {}, this.socket = null, this.reconnecting = !1, this.retries = 0, this.reconnectTimer = null, this.expectingResponse = !1, this._openSocket();
  }
  announce(e) {
    if (this.destroyed || this.reconnecting) return;
    if (!this.socket.connected) return void this.socket.once("connect", () => {
      this.announce(e);
    });
    const n = Object.assign({}, e, { action: "announce", info_hash: this.client._infoHashBinary, peer_id: this.client._peerIdBinary });
    if (this._trackerId && (n.trackerid = this._trackerId), e.event === "stopped" || e.event === "completed") this._send(n);
    else {
      const i = Math.min(e.numwant, 5);
      this._generateOffers(i, (r) => {
        n.numwant = i, n.offers = r, this._send(n);
      });
    }
  }
  scrape(e) {
    if (this.destroyed || this.reconnecting) return;
    if (!this.socket.connected) return void this.socket.once("connect", () => {
      this.scrape(e);
    });
    const n = { action: "scrape", info_hash: Array.isArray(e.infoHash) && e.infoHash.length > 0 ? e.infoHash.map((i) => (0, re.Ht)(i)) : e.infoHash && (0, re.Ht)(e.infoHash) || this.client._infoHashBinary };
    this._send(n);
  }
  destroy(e = gc) {
    if (this.destroyed) return e(null);
    this.destroyed = !0, clearInterval(this.interval), clearTimeout(this.reconnectTimer);
    for (const s in this.peers) {
      const o = this.peers[s];
      clearTimeout(o.trackerTimeout), o.destroy();
    }
    if (this.peers = null, this.socket && (this.socket.removeListener("connect", this._onSocketConnectBound), this.socket.removeListener("data", this._onSocketDataBound), this.socket.removeListener("close", this._onSocketCloseBound), this.socket.removeListener("error", this._onSocketErrorBound), this.socket = null), this._onSocketConnectBound = null, this._onSocketErrorBound = null, this._onSocketDataBound = null, this._onSocketCloseBound = null, en[this.announceUrl] && (en[this.announceUrl].consumers -= 1), en[this.announceUrl].consumers > 0) return e();
    let n, i = en[this.announceUrl];
    if (delete en[this.announceUrl], i.on("error", gc), i.once("close", e), !this.expectingResponse) return r();
    function r() {
      n && (clearTimeout(n), n = null), i.removeListener("data", r), i.destroy(), i = null;
    }
    n = setTimeout(r, Ko.DESTROY_TIMEOUT), i.once("data", r);
  }
  _openSocket() {
    if (this.destroyed = !1, this.peers || (this.peers = {}), this._onSocketConnectBound = () => {
      this._onSocketConnect();
    }, this._onSocketErrorBound = (e) => {
      this._onSocketError(e);
    }, this._onSocketDataBound = (e) => {
      this._onSocketData(e);
    }, this._onSocketCloseBound = () => {
      this._onSocketClose();
    }, this.socket = en[this.announceUrl], this.socket) en[this.announceUrl].consumers += 1, this.socket.connected && this._onSocketConnectBound();
    else {
      const e = new URL(this.announceUrl);
      let n;
      this.client._proxyOpts && (n = e.protocol === "wss:" ? this.client._proxyOpts.httpsAgent : this.client._proxyOpts.httpAgent, !n && this.client._proxyOpts.socksProxy && (n = this.client._proxyOpts.socksProxy)), this.socket = en[this.announceUrl] = new sf({ url: this.announceUrl, agent: n }), this.socket.consumers = 1, this.socket.once("connect", this._onSocketConnectBound);
    }
    this.socket.on("data", this._onSocketDataBound), this.socket.once("close", this._onSocketCloseBound), this.socket.once("error", this._onSocketErrorBound);
  }
  _onSocketConnect() {
    this.destroyed || this.reconnecting && (this.reconnecting = !1, this.retries = 0, this.announce(this.client._defaultAnnounceOpts()));
  }
  _onSocketData(e) {
    if (!this.destroyed) {
      this.expectingResponse = !1;
      try {
        e = JSON.parse((0, re.dU)(e));
      } catch {
        return void this.client.emit("warning", new Error("Invalid tracker response"));
      }
      e.action === "announce" ? this._onAnnounceResponse(e) : e.action === "scrape" ? this._onScrapeResponse(e) : this._onSocketError(new Error(`invalid action in WS response: ${e.action}`));
    }
  }
  _onAnnounceResponse(e) {
    if (e.info_hash !== this.client._infoHashBinary) return void xt("ignoring websocket data from %s for %s (looking for %s: reused socket)", this.announceUrl, (0, re.HB)(e.info_hash), this.client.infoHash);
    if (e.peer_id && e.peer_id === this.client._peerIdBinary) return;
    xt("received %s from %s for %s", JSON.stringify(e), this.announceUrl, this.client.infoHash);
    const n = e["failure reason"];
    if (n) return this.client.emit("warning", new Error(n));
    const i = e["warning message"];
    i && this.client.emit("warning", new Error(i));
    const r = e.interval || e["min interval"];
    r && this.setInterval(1e3 * r);
    const s = e["tracker id"];
    if (s && (this._trackerId = s), e.complete != null) {
      const a = Object.assign({}, e, { announce: this.announceUrl, infoHash: (0, re.HB)(e.info_hash) });
      this.client.emit("update", a);
    }
    let o;
    if (e.offer && e.peer_id && (xt("creating peer (from remote offer)"), o = this._createPeer(), o.id = (0, re.HB)(e.peer_id), o.once("signal", (a) => {
      const u = { action: "announce", info_hash: this.client._infoHashBinary, peer_id: this.client._peerIdBinary, to_peer_id: e.peer_id, answer: a, offer_id: e.offer_id };
      this._trackerId && (u.trackerid = this._trackerId), this._send(u);
    }), this.client.emit("peer", o), o.signal(e.offer)), e.answer && e.peer_id) {
      const a = (0, re.HB)(e.offer_id);
      o = this.peers[a], o ? (o.id = (0, re.HB)(e.peer_id), this.client.emit("peer", o), o.signal(e.answer), clearTimeout(o.trackerTimeout), o.trackerTimeout = null, delete this.peers[a]) : xt(`got unexpected answer: ${JSON.stringify(e.answer)}`);
    }
  }
  _onScrapeResponse(e) {
    e = e.files || {};
    const n = Object.keys(e);
    n.length !== 0 ? n.forEach((i) => {
      const r = Object.assign(e[i], { announce: this.announceUrl, infoHash: (0, re.HB)(i) });
      this.client.emit("scrape", r);
    }) : this.client.emit("warning", new Error("invalid scrape response"));
  }
  _onSocketClose() {
    this.destroyed || (this.destroy(), this._startReconnectTimer());
  }
  _onSocketError(e) {
    this.destroyed || (this.destroy(), this.client.emit("warning", e), this._startReconnectTimer());
  }
  _startReconnectTimer() {
    const e = Math.floor(3e5 * Math.random()) + Math.min(1e4 * Math.pow(2, this.retries), 36e5);
    this.reconnecting = !0, clearTimeout(this.reconnectTimer), this.reconnectTimer = setTimeout(() => {
      this.retries++, this._openSocket();
    }, e), this.reconnectTimer.unref && this.reconnectTimer.unref(), xt("reconnecting socket in %s ms", e);
  }
  _send(e) {
    if (this.destroyed) return;
    this.expectingResponse = !0;
    const n = JSON.stringify(e);
    xt("send %s", n), this.socket.send(n);
  }
  _generateOffers(e, n) {
    const i = this, r = [];
    xt("generating %s offers", e);
    for (let a = 0; a < e; ++a) s();
    function s() {
      const a = (0, re.V5)((0, re.po)(20));
      xt("creating peer (from _generateOffers)");
      const u = i.peers[a] = i._createPeer({ initiator: !0 });
      u.once("signal", (c) => {
        r.push({ offer: c, offer_id: (0, re.Ht)(a) }), o();
      }), u.trackerTimeout = setTimeout(() => {
        xt("tracker timeout: destroying peer"), u.trackerTimeout = null, delete i.peers[a], u.destroy();
      }, 5e4), u.trackerTimeout.unref && u.trackerTimeout.unref();
    }
    function o() {
      r.length === e && (xt("generated %s offers", e), n(r));
    }
    o();
  }
  _createPeer(e) {
    const n = this;
    e = Object.assign({ trickle: !1, config: n.client._rtcConfig, wrtc: n.client._wrtc }, e);
    const i = new La(e);
    return i.once("error", r), i.once("connect", function s() {
      i.removeListener("error", r), i.removeListener("connect", s);
    }), i;
    function r(s) {
      n.client.emit("warning", new Error(`Connection error: ${s.message}`)), i.destroy();
    }
  }
}
function gc() {
}
Zo.prototype.DEFAULT_ANNOUNCE_INTERVAL = 3e4, Zo._socketPool = en;
const G_ = Zo;
var K_ = ae(717);
const gn = Dt("bittorrent-tracker:client");
class Jo extends dn {
  constructor(e = {}) {
    if (super(), !e.peerId) throw new Error("Option `peerId` is required");
    if (!e.infoHash) throw new Error("Option `infoHash` is required");
    if (!e.announce) throw new Error("Option `announce` is required");
    if (!K_.browser && !e.port) throw new Error("Option `port` is required");
    this.peerId = typeof e.peerId == "string" ? e.peerId : (0, re.V5)(e.peerId), this._peerIdBuffer = (0, re.fk)(this.peerId), this._peerIdBinary = (0, re.Ht)(this.peerId), this.infoHash = typeof e.infoHash == "string" ? e.infoHash.toLowerCase() : (0, re.V5)(e.infoHash), this._infoHashBuffer = (0, re.fk)(this.infoHash), this._infoHashBinary = (0, re.Ht)(this.infoHash), gn("new client %s", this.infoHash), this.destroyed = !1, this._port = e.port, this._getAnnounceOpts = e.getAnnounceOpts, this._rtcConfig = e.rtcConfig, this._userAgent = e.userAgent, this._proxyOpts = e.proxyOpts, this._wrtc = typeof e.wrtc == "function" ? e.wrtc() : e.wrtc;
    let n = typeof e.announce == "string" ? [e.announce] : e.announce == null ? [] : e.announce;
    n = n.map((s) => (ArrayBuffer.isView(s) && (s = (0, re.dU)(s)), s[s.length - 1] === "/" && (s = s.substring(0, s.length - 1)), s)), n = Array.from(new Set(n));
    const i = this._wrtc !== !1 && (!!this._wrtc || La.WEBRTC_SUPPORT), r = (s) => {
      tt(() => {
        this.emit("warning", s);
      });
    };
    this._trackers = n.map((s) => {
      let o;
      try {
        o = Ko.parseUrl(s);
      } catch {
        return r(new Error(`Invalid tracker URL: ${s}`)), null;
      }
      const a = o.port;
      if (a < 0 || a > 65535) return r(new Error(`Invalid tracker port: ${s}`)), null;
      const u = o.protocol;
      return u !== "http:" && u !== "https:" || typeof pc != "function" ? u === "udp:" && typeof mc == "function" ? new mc(this, s) : u !== "ws:" && u !== "wss:" || !i || u === "ws:" && typeof window < "u" && window.location.protocol === "https:" ? (r(new Error(`Unsupported tracker protocol: ${s}`)), null) : new G_(this, s) : new pc(this, s);
    }).filter(Boolean);
  }
  start(e) {
    (e = this._defaultAnnounceOpts(e)).event = "started", gn("send `start` %o", e), this._announce(e), this._trackers.forEach((n) => {
      n.setInterval();
    });
  }
  stop(e) {
    (e = this._defaultAnnounceOpts(e)).event = "stopped", gn("send `stop` %o", e), this._announce(e);
  }
  complete(e) {
    e || (e = {}), (e = this._defaultAnnounceOpts(e)).event = "completed", gn("send `complete` %o", e), this._announce(e);
  }
  update(e) {
    (e = this._defaultAnnounceOpts(e)).event && delete e.event, gn("send `update` %o", e), this._announce(e);
  }
  _announce(e) {
    this._trackers.forEach((n) => {
      n.announce(e);
    });
  }
  scrape(e) {
    gn("send `scrape`"), e || (e = {}), this._trackers.forEach((n) => {
      n.scrape(e);
    });
  }
  setInterval(e) {
    gn("setInterval %d", e), this._trackers.forEach((n) => {
      n.setInterval(e);
    });
  }
  destroy(e) {
    if (this.destroyed) return;
    this.destroyed = !0, gn("destroy");
    const n = this._trackers.map((i) => (r) => {
      i.destroy(r);
    });
    On(n, e), this._trackers = [], this._getAnnounceOpts = null;
  }
  _defaultAnnounceOpts(e = {}) {
    return e.numwant == null && (e.numwant = Ko.DEFAULT_ANNOUNCE_PEERS), e.uploaded == null && (e.uploaded = 0), e.downloaded == null && (e.downloaded = 0), this._getAnnounceOpts && (e = Object.assign({}, e, this._getAnnounceOpts())), e;
  }
}
Jo.scrape = (t, e) => {
  if (e = rf(e), !t.infoHash) throw new Error("Option `infoHash` is required");
  if (!t.announce) throw new Error("Option `announce` is required");
  const n = Object.assign({}, t, { infoHash: Array.isArray(t.infoHash) ? t.infoHash[0] : t.infoHash, peerId: (0, re.L0)("01234567890123456789"), port: 6881 }), i = new Jo(n);
  i.once("error", e), i.once("warning", e);
  let r = Array.isArray(t.infoHash) ? t.infoHash.length : 1;
  const s = {};
  return i.on("scrape", (o) => {
    if (r -= 1, s[o.infoHash] = o, r === 0) {
      i.destroy();
      const a = Object.keys(s);
      a.length === 1 ? e(null, s[a[0]]) : e(null, s);
    }
  }), i.scrape({ infoHash: t.infoHash }), i;
};
const Z_ = Jo;
ae(7936);
var bc = ae(2799), J_ = ae(717);
const _c = Dt("torrent-discovery");
class Y_ extends dn.EventEmitter {
  constructor(e) {
    if (super(), !e.peerId) throw new Error("Option `peerId` is required");
    if (!e.infoHash) throw new Error("Option `infoHash` is required");
    if (!J_.browser && !e.port) throw new Error("Option `port` is required");
    this.peerId = typeof e.peerId == "string" ? e.peerId : e.peerId.toString("hex"), this.infoHash = typeof e.infoHash == "string" ? e.infoHash.toLowerCase() : e.infoHash.toString("hex"), this._port = e.port, this._userAgent = e.userAgent, this.destroyed = !1, this._announce = e.announce || [], this._intervalMs = e.intervalMs || 9e5, this._trackerOpts = null, this._dhtAnnouncing = !1, this._dhtTimeout = !1, this._internalDHT = !1, this._onWarning = (i) => {
      this.emit("warning", i);
    }, this._onError = (i) => {
      this.emit("error", i);
    }, this._onDHTPeer = (i, r) => {
      r.toString("hex") === this.infoHash && this.emit("peer", `${i.host}:${i.port}`, "dht");
    }, this._onTrackerPeer = (i) => {
      this.emit("peer", i, "tracker");
    }, this._onTrackerAnnounce = () => {
      this.emit("trackerAnnounce");
    }, this._onLSDPeer = (i, r) => {
      this.emit("peer", i, "lsd");
    };
    const n = (i, r) => {
      const s = new dc.Client(r);
      return s.on("warning", this._onWarning), s.on("error", this._onError), s.listen(i), this._internalDHT = !0, s;
    };
    e.tracker === !1 ? this.tracker = null : e.tracker && typeof e.tracker == "object" ? (this._trackerOpts = Object.assign({}, e.tracker), this.tracker = this._createTracker()) : this.tracker = this._createTracker(), e.dht === !1 || typeof dc.Client != "function" ? this.dht = null : e.dht && typeof e.dht.addNode == "function" ? this.dht = e.dht : e.dht && typeof e.dht == "object" ? this.dht = n(e.dhtPort, e.dht) : this.dht = n(e.dhtPort), this.dht && (this.dht.on("peer", this._onDHTPeer), this._dhtAnnounce()), e.lsd === !1 || typeof bc != "function" ? this.lsd = null : this.lsd = this._createLSD();
  }
  updatePort(e) {
    e !== this._port && (this._port = e, this.dht && this._dhtAnnounce(), this.tracker && (this.tracker.stop(), this.tracker.destroy(() => {
      this.tracker = this._createTracker();
    })));
  }
  complete(e) {
    this.tracker && this.tracker.complete(e);
  }
  destroy(e) {
    if (this.destroyed) return;
    this.destroyed = !0, clearTimeout(this._dhtTimeout);
    const n = [];
    this.tracker && (this.tracker.stop(), this.tracker.removeListener("warning", this._onWarning), this.tracker.removeListener("error", this._onError), this.tracker.removeListener("peer", this._onTrackerPeer), this.tracker.removeListener("update", this._onTrackerAnnounce), n.push((i) => {
      this.tracker.destroy(i);
    })), this.dht && this.dht.removeListener("peer", this._onDHTPeer), this._internalDHT && (this.dht.removeListener("warning", this._onWarning), this.dht.removeListener("error", this._onError), n.push((i) => {
      this.dht.destroy(i);
    })), this.lsd && (this.lsd.removeListener("warning", this._onWarning), this.lsd.removeListener("error", this._onError), this.lsd.removeListener("peer", this._onLSDPeer), n.push((i) => {
      this.lsd.destroy(i);
    })), On(n, e), this.dht = null, this.tracker = null, this.lsd = null, this._announce = null;
  }
  _createTracker() {
    const e = Object.assign({}, this._trackerOpts, { infoHash: this.infoHash, announce: this._announce, peerId: this.peerId, port: this._port, userAgent: this._userAgent }), n = new Z_(e);
    return n.on("warning", this._onWarning), n.on("error", this._onError), n.on("peer", this._onTrackerPeer), n.on("update", this._onTrackerAnnounce), n.setInterval(this._intervalMs), n.start(), n;
  }
  _dhtAnnounce() {
    this._dhtAnnouncing || (_c("dht announce"), this._dhtAnnouncing = !0, clearTimeout(this._dhtTimeout), this.dht.announce(this.infoHash, this._port, (e) => {
      this._dhtAnnouncing = !1, _c("dht announce complete"), e && this.emit("warning", e), this.emit("dhtAnnounce"), this.destroyed || (this._dhtTimeout = setTimeout(() => {
        this._dhtAnnounce();
      }, this._intervalMs + Math.floor(Math.random() * this._intervalMs / 5)), this._dhtTimeout.unref && this._dhtTimeout.unref());
    }));
  }
  _createLSD() {
    const e = Object.assign({}, { infoHash: this.infoHash, peerId: this.peerId, port: this._port }), n = new bc(e);
    return n.on("warning", this._onWarning), n.on("error", this._onError), n.on("peer", this._onLSDPeer), n.start(), n;
  }
}
const X_ = Y_, Q_ = ["seeking position failed.", "InvalidStateError"], ey = ["A requested file or directory could not be found at the time an operation was processed.", "NotFoundError"], co = (t) => [`Failed to execute 'write' on 'UnderlyingSinkBase': Invalid params passed. ${t}`, "SyntaxError"];
class Ci extends WritableStream {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, FileSystemWritableFileStream.prototype), this._closed = !1;
  }
  async close() {
    this._closed = !0;
    const e = this.getWriter(), n = e.close();
    return e.releaseLock(), n;
  }
  seek(e) {
    return this.write({ type: "seek", position: e });
  }
  truncate(e) {
    return this.write({ type: "truncate", size: e });
  }
  write(e) {
    if (this._closed) return Promise.reject(new TypeError("Cannot write to a CLOSED writable stream"));
    const n = this.getWriter(), i = n.write(e);
    return n.releaseLock(), i;
  }
}
if (Object.defineProperty(Ci.prototype, Symbol.toStringTag, { value: "FileSystemWritableFileStream", writable: !1, enumerable: !1, configurable: !0 }), Object.defineProperties(Ci.prototype, { close: { enumerable: !0 }, seek: { enumerable: !0 }, truncate: { enumerable: !0 }, write: { enumerable: !0 } }), !globalThis.FileSystemFileHandle || globalThis.FileSystemFileHandle.prototype.createWritable || globalThis.FileSystemWritableFileStream || (globalThis.FileSystemWritableFileStream = Ci), globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable) {
  const t = /* @__PURE__ */ new WeakMap();
  let e;
  const n = () => {
    let r, s;
    onmessage = async (o) => {
      const a = o.ports[0], u = o.data;
      switch (u.type) {
        case "open": {
          const c = u.name;
          let l = await navigator.storage.getDirectory();
          for (const h of u.path) l = await l.getDirectoryHandle(h);
          r = await l.getFileHandle(c), s = await r.createSyncAccessHandle();
          break;
        }
        case "write":
          s.write(u.data, { at: u.position }), s.flush();
          break;
        case "truncate":
          s.truncate(u.size);
          break;
        case "abort":
        case "close":
          s.close();
      }
      a.postMessage(0);
    };
  };
  globalThis.FileSystemFileHandle.prototype.createWritable = async function(r) {
    if (!e) {
      const d = `(${n.toString()})()`, p = new Blob([d], { type: "text/javascript" });
      e = URL.createObjectURL(p);
    }
    const s = new Worker(e, { type: "module" });
    let o = 0;
    const a = new TextEncoder();
    let u = await this.getFile().then((d) => d.size);
    const c = (d) => new Promise((p, m) => {
      const _ = new MessageChannel();
      _.port1.onmessage = (y) => {
        y.data instanceof Error ? m(y.data) : p(y.data), _.port1.close(), _.port2.close(), _.port1.onmessage = null;
      }, s.postMessage(d, [_.port2]);
    }), l = await navigator.storage.getDirectory(), h = await t.get(this), f = await l.resolve(h);
    if (f === null) throw new DOMException(...ey);
    return await c({ type: "open", path: f, name: this.name }), (r == null ? void 0 : r.keepExistingData) === !1 && (await c({ type: "truncate", size: 0 }), u = 0), new Ci({ async write(d) {
      if ((d = (d == null ? void 0 : d.constructor) === Object ? { ...d } : { type: "write", data: d, position: o }).type === "write") {
        if (!("data" in d)) throw await c({ type: "close" }), new DOMException(...co("write requires a data argument"));
        if (d.position ?? (d.position = o), typeof d.data == "string") d.data = a.encode(d.data);
        else if (d.data instanceof ArrayBuffer) d.data = new Uint8Array(d.data);
        else if (d.data instanceof Uint8Array || !ArrayBuffer.isView(d.data)) {
          if (!(d.data instanceof Uint8Array)) {
            const p = await new Response(d.data).arrayBuffer();
            d.data = new Uint8Array(p);
          }
        } else d.data = new Uint8Array(d.data.buffer, d.data.byteOffset, d.data.byteLength);
        Number.isInteger(d.position) && d.position >= 0 && (o = d.position), o += d.data.byteLength, u += d.data.byteLength;
      } else {
        if (d.type === "seek") {
          if (Number.isInteger(d.position) && d.position >= 0) {
            if (u < d.position) throw new DOMException(...Q_);
            return void (o = d.position);
          }
          throw await c({ type: "close" }), new DOMException(...co("seek requires a position argument"));
        }
        if (d.type === "truncate") {
          if (!(Number.isInteger(d.size) && d.size >= 0)) throw await c({ type: "close" }), new DOMException(...co("truncate requires a size argument"));
          u = d.size, o > u && (o = u);
        }
      }
      await c(d);
    }, async close() {
      await c({ type: "close" }), s.terminate();
    }, async abort(d) {
      await c({ type: "abort", reason: d }), s.terminate();
    } });
  };
  const i = FileSystemDirectoryHandle.prototype.getFileHandle;
  FileSystemDirectoryHandle.prototype.getFileHandle = async function(...r) {
    const s = await i.call(this, ...r);
    return t.set(s, this), s;
  };
}
const ty = /[<>:"/\\|?*\u0000-\u001F]/g;
var sl, ol;
(ol = (sl = globalThis.navigator) == null ? void 0 : sl.storage) != null && ol.getDirectory && navigator.storage.getDirectory().then((t) => {
  t.removeEntry("chunks", { recursive: !0 }).catch(() => {
  });
});
const Rr = (t, e) => {
};
class of {
  constructor(e, n = {}) {
    ut(this, "name", "");
    ut(this, "chunks", []);
    ut(this, "chunkMap", []);
    ut(this, "directoryMap", {});
    ut(this, "files");
    ut(this, "rootDirPromise");
    ut(this, "storageDirPromise");
    ut(this, "chunksDirPromise");
    ut(this, "closing", !1);
    ut(this, "closed", !1);
    var i, r;
    if (this.chunkLength = Number(e), !this.chunkLength) throw new Error("First argument must be a chunk length");
    if (!((r = (i = globalThis.navigator) == null ? void 0 : i.storage) != null && r.getDirectory)) throw new Error("FSA API is not supported");
    if (this.closed = !1, this.name = n.name || crypto.randomUUID(), this.rootDirPromise = n.rootDir || navigator.storage.getDirectory(), this.storageDirPromise = (async () => (await this.rootDirPromise).getDirectoryHandle(this.name, { create: !0 }))(), this.chunksDirPromise = this.storageDirPromise, n.files && n.rootDir) {
      if (this.chunksDirPromise = this._getChunksDirHandle(), this.files = n.files.map((s, o, a) => {
        if (s.path == null) throw new Error("File is missing `path` property");
        if (s.length == null) throw new Error("File is missing `length` property");
        if (s.offset == null) if (o === 0) s.offset = 0;
        else {
          const f = a[o - 1];
          s.offset = f.offset + f.length;
        }
        s.handle == null && (s.handle = this._createFileHandle({ path: s.path })), s.blob = this._createBlobReference(s.handle);
        const u = s.offset, c = s.offset + s.length, l = Math.floor(u / this.chunkLength), h = Math.floor((c - 1) / this.chunkLength);
        for (let f = l; f <= h; ++f) {
          const d = f * this.chunkLength, p = u < d ? 0 : u - d, m = c > d + this.chunkLength ? this.chunkLength : c - d, _ = u > d ? 0 : d - u;
          this.chunkMap[f] || (this.chunkMap[f] = []), this.chunkMap[f].push({ from: p, to: m, offset: _, file: s });
        }
        return s;
      }), window.addEventListener("pagehide", () => this.cleanup()), this.length = this.files.reduce((s, o) => s + o.length, 0), n.length != null && n.length !== this.length) throw new Error("total `files` length is not equal to explicit `length` option");
    } else this.length = Number(n.length) || 1 / 0;
    this.length !== 1 / 0 && (this.lastChunkLength = this.length % this.chunkLength || this.chunkLength, this.lastChunkIndex = Math.ceil(this.length / this.chunkLength) - 1);
  }
  async _getChunkHandle(e) {
    let n = this.chunks[e];
    if (!n) {
      const i = await this.chunksDirPromise;
      this.chunks[e] = n = await i.getFileHandle(e, { create: !0 });
    }
    return n;
  }
  async _createFileHandle(e) {
    const n = e.path.slice(e.path.lastIndexOf("/") + 1);
    return (await this._getDirectoryHandle(e)).getFileHandle(n.replace(ty, ""), { create: !0 });
  }
  async _createBlobReference(e) {
    return (await e).getFile();
  }
  async _getDirectoryHandle(e) {
    const n = e.path.lastIndexOf("/");
    if (n === -1 || n === 0) return this.storageDirPromise;
    const i = e.path = e.path.slice(0, n);
    return this.directoryMap[i] || (this.directoryMap[i] = (async () => (await this._getDirectoryHandle(e)).getDirectoryHandle(i.slice(i.lastIndexOf("/") + 1), { create: !0 }))()), this.directoryMap[i];
  }
  async _getChunksDirHandle() {
    return (await (await navigator.storage.getDirectory()).getDirectoryHandle("chunks", { create: !0 })).getDirectoryHandle(this.name, { create: !0 });
  }
  async put(e, n, i = Rr) {
    try {
      return await this._put(e, n), i(null), null;
    } catch (r) {
      return queueMicrotask(() => i(r)), r;
    }
  }
  async getStreamForHandle(e) {
    return (await e).createWritable({ keepExistingData: !0 });
  }
  async _put(e, n) {
    if (this.closed) throw new Error("Storage is closed");
    const i = e === this.lastChunkIndex;
    if (i && n.length !== this.lastChunkLength) throw new Error(`Last chunk length must be ${this.lastChunkLength}`);
    if (!i && n.length !== this.chunkLength) throw new Error(`Chunk length must be ${this.chunkLength}`);
    const r = (async () => {
      const a = await this._getChunkHandle(e), u = await a.createWritable({ keepExistingData: !1 });
      await u.write(n), await u.close();
    })();
    if (!this.files) return r;
    const s = this.chunkMap[e];
    if (!s) throw new Error("No files matching the request range");
    const o = s.map(async ({ file: a, offset: u, from: c, to: l }) => {
      a.stream || (a.stream = this.getStreamForHandle(a.handle)), await (await a.stream).write({ type: "write", position: u, data: n.slice(c, l) });
    });
    o.push(r), await Promise.all(o);
  }
  async get(e, n, i = Rr) {
    n == null && (n = {});
    try {
      const r = await this._get(e, n);
      return i(null, r), r;
    } catch (r) {
      return i(r), r;
    }
  }
  async _get(e, n) {
    if (typeof n == "function") return this.get(e, void 0, n);
    if (this.closed) throw new Error("Storage is closed");
    const i = e === this.lastChunkIndex ? this.lastChunkLength : this.chunkLength, r = n.offset || 0, s = n.length ? r + n.length : i, o = n.length || i - r;
    if (r < 0 || r < 0 || s > i) throw new Error("Invalid offset and/or length");
    if (r === s) return new Uint8Array(0);
    if (!this.files || this.chunks[e]) {
      let f = await (await this._getChunkHandle(e)).getFile();
      r === 0 && o === i || (f = f.slice(r, o + r));
      const d = await f.arrayBuffer();
      if (d.byteLength === 0) throw new Error(`Index ${e} does not exist`);
      return new Uint8Array(d);
    }
    let a = this.chunkMap[e];
    if (!a) throw new Error("No files matching the request range");
    if (n && (a = a.filter(({ from: h, to: f }) => f > r && h < s), a.length === 0)) throw new Error("No files matching the request range");
    const u = a.map(async ({ from: h, to: f, offset: d, file: p }) => (n && (f > s && (f = s), h < r && (d += r - h, h = r)), (await p.blob).slice(d, d + f - h))), c = await Promise.all(u), l = c.length === 1 ? await c[0].arrayBuffer() : await new Blob(c).arrayBuffer();
    if (l.byteLength === 0) throw new Error(`Index ${e} does not exist`);
    return new Uint8Array(l);
  }
  async close(e = Rr) {
    if (this.closing) return ((n = Rr, i) => queueMicrotask(() => n(new Error(i))))(e, "Storage is closed");
    this.closing = !0, this.chunkMap = void 0, this.directoryMap = void 0, this.files && await this.cleanup(), this.closed = !0, queueMicrotask(() => e(null));
  }
  async cleanup() {
    if (this.closed || !this.files) return;
    const e = [];
    for (const i of this.files) i.stream && (e.push(i.stream.then((r) => r.close())), i.stream = void 0);
    const n = (async () => {
      const i = await this.chunksDirPromise;
      this.chunks = [];
      for await (const r of i.keys()) await i.removeEntry(r, { recursive: !0 });
      this.chunksDirPromise = this._getChunksDirHandle(), await this.chunksDirPromise;
    })();
    await Promise.all(e);
    for (const i of this.files) i.blob = this._createBlobReference(i.handle);
    await n;
  }
  async destroy(e = Rr) {
    this.close(async (n) => {
      if (n) return e(n);
      try {
        await (await this.rootDirPromise).removeEntry(this.name, { recursive: !0 });
      } catch (i) {
        return e(i);
      }
      e(null);
    });
  }
}
var ny = ae(3714), ry = ae(1314);
const yc = Dt("lt_donthave"), af = () => {
  class t extends dn.EventEmitter {
    constructor(n) {
      super(), this._peerSupports = !1, this._wire = n;
    }
    onExtendedHandshake() {
      this._peerSupports = !0;
    }
    onMessage(n) {
      let i;
      try {
        i = new DataView(n.buffer).getUint32(0);
      } catch {
        return;
      }
      this._wire.peerPieces.get(i) && (yc("got donthave %d", i), this._wire.peerPieces.set(i, !1), this.emit("donthave", i), this._failRequests(i));
    }
    donthave(n) {
      if (!this._peerSupports) return;
      yc("donthave %d", n);
      const i = new Uint8Array(4);
      new DataView(i.buffer).setUint32(0, n), this._wire.extended("lt_donthave", i);
    }
    _failRequests(n) {
      const i = this._wire.requests;
      for (let r = 0; r < i.length; r++) {
        const s = i[r];
        s.piece === n && (ry(i, r), r -= 1, this._wire._callback(s, new Error("peer sent donthave"), null));
      }
    }
  }
  return t.prototype.name = "lt_donthave", t;
};
var uf = ae(4862), vc = ae(5372);
const Bt = 16384;
class rn {
  constructor(e) {
    this.length = e, this.missing = e, this.sources = null, this._chunks = Math.ceil(e / Bt), this._remainder = e % Bt || Bt, this._buffered = 0, this._buffer = null, this._cancellations = null, this._reservations = 0, this._flushed = !1;
  }
  chunkLength(e) {
    return e === this._chunks - 1 ? this._remainder : Bt;
  }
  chunkLengthRemaining(e) {
    return this.length - e * Bt;
  }
  chunkOffset(e) {
    return e * Bt;
  }
  reserve() {
    return this.init() ? this._cancellations.length ? this._cancellations.pop() : this._reservations < this._chunks ? this._reservations++ : -1 : -1;
  }
  reserveRemaining() {
    if (!this.init()) return -1;
    if (this._cancellations.length || this._reservations < this._chunks) {
      let e = this._reservations;
      for (; this._cancellations.length; ) e = Math.min(e, this._cancellations.pop());
      return this._reservations = this._chunks, e;
    }
    return -1;
  }
  cancel(e) {
    this.init() && this._cancellations.push(e);
  }
  cancelRemaining(e) {
    this.init() && (this._reservations = e);
  }
  get(e) {
    return this.init() ? this._buffer[e] : null;
  }
  set(e, n, i) {
    if (!this.init()) return !1;
    const r = n.length, s = Math.ceil(r / Bt);
    for (let o = 0; o < s; o++) if (!this._buffer[e + o]) {
      const a = o * Bt, u = n.slice(a, a + Bt);
      this._buffered++, this._buffer[e + o] = u, this.missing -= u.length, this.sources.includes(i) || this.sources.push(i);
    }
    return this._buffered === this._chunks;
  }
  flush() {
    if (!this._buffer || this._chunks !== this._buffered) return null;
    const e = (0, re.xW)(this._buffer, this.length);
    return this._buffer = null, this._cancellations = null, this.sources = null, this._flushed = !0, e;
  }
  init() {
    return !this._flushed && (this._buffer || (this._buffer = new Array(this._chunks), this._cancellations = [], this.sources = []), !0);
  }
}
rn.BLOCK_LENGTH = Bt;
var iy = ae(7373);
const sy = Dt("ut_metadata"), Lr = 16384, oy = (t) => {
  class e extends dn.EventEmitter {
    constructor(i) {
      super(), this._wire = i, this._fetching = !1, this._metadataComplete = !1, this._metadataSize = null, this._remainingRejects = null, this._bitfield = new us.A(0, { grow: 1e3 }), ArrayBuffer.isView(t) && this.setMetadata(t);
    }
    onHandshake(i, r, s) {
      this._infoHash = i;
    }
    onExtendedHandshake(i) {
      return i.m && i.m.ut_metadata ? i.metadata_size ? typeof i.metadata_size != "number" || 1e7 < i.metadata_size || i.metadata_size <= 0 ? this.emit("warning", new Error("Peer gave invalid metadata size")) : (this._metadataSize = i.metadata_size, this._numPieces = Math.ceil(this._metadataSize / Lr), this._remainingRejects = 2 * this._numPieces, void this._requestPieces()) : this.emit("warning", new Error("Peer does not have metadata")) : this.emit("warning", new Error("Peer does not support ut_metadata"));
    }
    onMessage(i) {
      let r, s;
      try {
        const o = (0, re.dU)(i), a = o.indexOf("ee") + 2;
        r = zt.A.decode(o.substring(0, a)), s = i.slice(a);
      } catch {
        return;
      }
      switch (r.msg_type) {
        case 0:
          this._onRequest(r.piece);
          break;
        case 1:
          this._onData(r.piece, s, r.total_size);
          break;
        case 2:
          this._onReject(r.piece);
      }
    }
    fetch() {
      this._metadataComplete || (this._fetching = !0, this._metadataSize && this._requestPieces());
    }
    cancel() {
      this._fetching = !1;
    }
    async setMetadata(i) {
      if (this._metadataComplete) return !0;
      sy("set metadata");
      try {
        const r = zt.A.decode(i).info;
        r && (i = zt.A.encode(r));
      } catch {
      }
      return (!this._infoHash || this._infoHash === await (0, re.tW)(i, "hex")) && (this.cancel(), this.metadata = i, this._metadataComplete = !0, this._metadataSize = this.metadata.length, this._wire.extendedHandshake.metadata_size = this._metadataSize, this.emit("metadata", zt.A.encode({ info: zt.A.decode(this.metadata) })), !0);
    }
    _send(i, r) {
      let s = zt.A.encode(i);
      ArrayBuffer.isView(r) && (s = (0, re.xW)([s, r])), this._wire.extended("ut_metadata", s);
    }
    _request(i) {
      this._send({ msg_type: 0, piece: i });
    }
    _data(i, r, s) {
      const o = { msg_type: 1, piece: i };
      typeof s == "number" && (o.total_size = s), this._send(o, r);
    }
    _reject(i) {
      this._send({ msg_type: 2, piece: i });
    }
    _onRequest(i) {
      if (!this._metadataComplete) return void this._reject(i);
      const r = i * Lr;
      let s = r + Lr;
      s > this._metadataSize && (s = this._metadataSize);
      const o = this.metadata.slice(r, s);
      this._data(i, o, this._metadataSize);
    }
    _onData(i, r, s) {
      r.length > Lr || !this._fetching || (this.metadata.set(r, i * Lr), this._bitfield.set(i), this._checkDone());
    }
    _onReject(i) {
      this._remainingRejects > 0 && this._fetching ? (this._request(i), this._remainingRejects -= 1) : this.emit("warning", new Error('Peer sent "reject" too much'));
    }
    _requestPieces() {
      if (this._fetching) {
        this.metadata = new Uint8Array(this._metadataSize);
        for (let i = 0; i < this._numPieces; i++) this._request(i);
      }
    }
    async _checkDone() {
      let i = !0;
      for (let r = 0; r < this._numPieces; r++) if (!this._bitfield.get(r)) {
        i = !1;
        break;
      }
      i && (await this.setMetadata(this.metadata) || this._failedMetadata());
    }
    _failedMetadata() {
      this._bitfield = new us.A(0, { grow: 1e3 }), this._remainingRejects -= this._numPieces, this._remainingRejects > 0 ? this._requestPieces() : this.emit("warning", new Error("Peer sent invalid metadata"));
    }
  }
  return e.prototype.name = "ut_metadata", e;
};
var lo = ae(8878), ay = ae(1133);
const uy = Dt("webtorrent:file-iterator");
class cy extends dn {
  constructor(e, { start: n, end: i }) {
    super(), this._torrent = e._torrent, this._pieceLength = e._torrent.pieceLength, this._startPiece = (n + e.offset) / this._pieceLength | 0, this._endPiece = (i + e.offset) / this._pieceLength | 0, this._piece = this._startPiece, this._offset = n + e.offset - this._startPiece * this._pieceLength, this._missing = i - n + 1, this._criticalLength = Math.min(1048576 / this._pieceLength | 0, 2), this._torrent._select(this._startPiece, this._endPiece, 1, null, !0), this.destroyed = !1;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return new Promise((e, n) => {
      if (this._missing === 0 || this.destroyed) return e({ done: !0 }), this.destroy();
      const i = (s, o) => {
        if (!this._torrent.bitfield.get(s)) {
          const a = (u) => {
            (u === s || this.destroyed) && (this._torrent.removeListener("verified", a), i(s, o));
          };
          return this._torrent.on("verified", a), this._torrent.critical(s, s + this._criticalLength);
        }
        if (this._torrent.destroyed) return n(new Error("Torrent removed"));
        this._torrent.store.get(s, o, (a, u) => this.destroyed ? e({ done: !0 }) : (uy("read %s and yielding (length %s) (err %s)", s, u == null ? void 0 : u.length, a == null ? void 0 : a.message), a ? n(a) : void e({ value: u, done: !1 })));
      }, r = Math.min(this._missing, this._pieceLength - this._offset);
      i(this._piece++, { length: r, offset: this._offset }), this._missing -= r, this._offset = 0;
    });
  }
  async return() {
    return this.destroy(), { done: !0 };
  }
  async throw(e) {
    throw e;
  }
  destroy(e = () => {
  }, n) {
    this.destroyed || (this.destroyed = !0, this._torrent.destroyed || this._torrent._deselect(this._startPiece, this._endPiece, !0), this.emit("return"), e(n));
  }
}
class wc extends dn {
  constructor(e, n) {
    super(), this._torrent = e, this._destroyed = !1, this._fileStreams = /* @__PURE__ */ new Set(), this._iterators = /* @__PURE__ */ new Set(), this.name = n.name, this.path = n.path, this.length = n.length, this.size = n.length, this.type = ay.getType(this.name) || "application/octet-stream", this.offset = n.offset, this.done = !1;
    const i = n.offset, r = i + n.length - 1;
    this._startPiece = i / this._torrent.pieceLength | 0, this._endPiece = r / this._torrent.pieceLength | 0, this.length === 0 && (this.done = !0, this.emit("done")), this._client = e.client;
  }
  get downloaded() {
    if (this._destroyed || !this._torrent.bitfield) return 0;
    const { pieces: e, bitfield: n, pieceLength: i, lastPieceLength: r } = this._torrent, { _startPiece: s, _endPiece: o } = this, a = (c) => {
      const l = c === e.length - 1 ? r : i;
      return n.get(c) ? l : l - e[c].missing;
    };
    let u = 0;
    for (let c = s; c <= o; c += 1) {
      const l = a(c);
      if (u += l, c === s) {
        const h = this.offset % i;
        u -= Math.min(h, l);
      }
      if (c === o) {
        const h = (o === e.length - 1 ? r : i) - (this.offset + this.length) % i;
        u -= Math.min(h, l);
      }
    }
    return u;
  }
  get progress() {
    return this.length ? this.downloaded / this.length : 0;
  }
  select(e) {
    this.length !== 0 && this._torrent.select(this._startPiece, this._endPiece, e);
  }
  deselect() {
    this.length !== 0 && this._torrent.deselect(this._startPiece, this._endPiece);
  }
  [Symbol.asyncIterator](e = {}) {
    if (this.length === 0) return async function* () {
    }();
    const { start: n = 0 } = e ?? {}, i = e != null && e.end && e.end < this.length ? e.end : this.length - 1;
    if (this.done) return z_(this._torrent.store, { offset: n + this.offset, length: i - n + 1 });
    const r = new cy(this, { start: n, end: i });
    return this._iterators.add(r), r.once("return", () => {
      this._iterators.delete(r);
    }), r;
  }
  createReadStream(e) {
    const n = this[Symbol.asyncIterator](e), i = Ss.Readable.from(n);
    return this._fileStreams.add(i), i.once("close", () => {
      this._fileStreams.delete(i);
    }), i;
  }
  async arrayBuffer(e = {}) {
    const { start: n = 0 } = e, i = e != null && e.end && e.end < this.length ? e.end : this.length - 1, r = new Uint8Array(i - n + 1);
    let s = 0;
    for await (const o of this[Symbol.asyncIterator]({ start: n, end: i })) r.set(o, s), s += o.length;
    return r.buffer;
  }
  async blob(e) {
    return new Blob([await this.arrayBuffer(e)], { type: this.type });
  }
  stream(e) {
    let n;
    return new ReadableStream({ start: () => {
      n = this[Symbol.asyncIterator](e);
    }, async pull(i) {
      const { value: r, done: s } = await n.next();
      s ? i.close() : i.enqueue(r);
    }, cancel() {
      n.return();
    } });
  }
  get streamURL() {
    if (!this._client._server) throw new Error("No server created");
    return `${this._client._server.pathname}/${this._torrent.infoHash}/${this.path}`;
  }
  streamTo(e) {
    return e.src = this.streamURL, e;
  }
  includes(e) {
    return this._startPiece <= e && this._endPiece >= e;
  }
  _destroy() {
    this._destroyed = !0, this._torrent = null;
    for (const e of this._fileStreams) e.destroy();
    this._fileStreams.clear();
    for (const e of this._iterators) e.destroy();
    this._iterators.clear();
  }
}
var kt = ae(5658);
class ly {
  constructor(e) {
    this._torrent = e, this._numPieces = e.pieces.length, this._pieces = new Array(this._numPieces), this._onWire = (n) => {
      this.recalculate(), this._initWire(n);
    }, this._onWireHave = (n) => {
      this._pieces[n] += 1;
    }, this._onWireBitfield = () => {
      this.recalculate();
    }, this._torrent.wires.forEach((n) => {
      this._initWire(n);
    }), this._torrent.on("wire", this._onWire), this.recalculate();
  }
  getRarestPiece(e) {
    let n = [], i = 1 / 0;
    for (let r = 0; r < this._numPieces; ++r) {
      if (e && !e(r)) continue;
      const s = this._pieces[r];
      s === i ? n.push(r) : s < i && (n = [r], i = s);
    }
    return n.length ? n[Math.random() * n.length | 0] : -1;
  }
  destroy() {
    this._torrent.removeListener("wire", this._onWire), this._torrent.wires.forEach((e) => {
      this._cleanupWireEvents(e);
    }), this._torrent = null, this._pieces = null, this._onWire = null, this._onWireHave = null, this._onWireBitfield = null;
  }
  _initWire(e) {
    e._onClose = () => {
      this._cleanupWireEvents(e);
      for (let n = 0; n < this._numPieces; ++n) this._pieces[n] -= e.peerPieces.get(n);
    }, e.on("have", this._onWireHave), e.on("bitfield", this._onWireBitfield), e.once("close", e._onClose);
  }
  recalculate() {
    this._pieces.fill(0);
    for (const e of this._torrent.wires) for (let n = 0; n < this._numPieces; ++n) this._pieces[n] += e.peerPieces.get(n);
  }
  _cleanupWireEvents(e) {
    e.removeListener("have", this._onWireHave), e.removeListener("bitfield", this._onWireBitfield), e._onClose && e.removeListener("close", e._onClose), e._onClose = null;
  }
}
var hy = ae(4343), fy = ae(6458), hi = ae(6819);
const Yt = Dt("webtorrent:webconn");
class dy extends fy.A {
  constructor(e, n) {
    super(), this.url = e, this.connId = e, this._torrent = n, this._init(e);
  }
  _init(e) {
    this.setKeepAlive(!0), this.use(af()), this.once("handshake", async (n, i) => {
      const r = await (0, re.tW)(e, "hex");
      if (this.destroyed) return;
      this.handshake(n, r);
      const s = this._torrent.pieces.length, o = new us.A(s);
      for (let a = 0; a <= s; a++) o.set(a, !0);
      this.bitfield(o);
    }), this.once("interested", () => {
      Yt("interested"), this.unchoke();
    }), this.on("uninterested", () => {
      Yt("uninterested");
    }), this.on("choke", () => {
      Yt("choke");
    }), this.on("unchoke", () => {
      Yt("unchoke");
    }), this.on("bitfield", () => {
      Yt("bitfield");
    }), this.lt_donthave.on("donthave", () => {
      Yt("donthave");
    }), this.on("request", (n, i, r, s) => {
      Yt("request pieceIndex=%d offset=%d length=%d", n, i, r), this.httpRequest(n, i, r, (o, a) => {
        if (o) {
          this.lt_donthave.donthave(n);
          const u = setTimeout(() => {
            this.destroyed || this.have(n);
          }, 1e4);
          u.unref && u.unref();
        }
        s(o, a);
      });
    });
  }
  async httpRequest(e, n, i, r) {
    r = rf(r);
    const s = e * this._torrent.pieceLength + n, o = s + i - 1, a = this._torrent.files;
    let u, c;
    if (a.length <= 1) u = [{ url: this.url, start: s, end: o }];
    else {
      const l = a.filter((h) => h.offset <= o && h.offset + h.length > s);
      if (l.length < 1) return r(new Error("Could not find file corresponding to web seed range request"));
      u = l.map((h) => {
        const f = h.offset + h.length - 1;
        return { url: this.url + (this.url[this.url.length - 1] === "/" ? "" : "/") + h.path.replace(this._torrent.path, ""), fileOffsetInRange: Math.max(h.offset - s, 0), start: Math.max(s - h.offset, 0), end: Math.min(f, o - h.offset) };
      });
    }
    try {
      c = await Promise.all(u.map(async ({ start: l, end: h, url: f }) => {
        Yt("Requesting url=%s pieceIndex=%d offset=%d length=%d start=%d end=%d", f, e, n, i, l, h);
        const d = await Ra(f, { cache: "no-store", method: "GET", headers: { "Cache-Control": "no-store", "user-agent": `WebTorrent/${hi} (https://webtorrent.io)`, range: `bytes=${l}-${h}` }, signal: AbortSignal.timeout(6e4) });
        if (!d.ok) throw new Error(`Unexpected HTTP status code ${d.status}`);
        const p = new Uint8Array(await d.arrayBuffer());
        return Yt("Got data of length %d", p.length), p;
      }));
    } catch (l) {
      return r(l);
    }
    r(null, (0, re.xW)(c));
  }
  destroy() {
    super.destroy(), this._torrent = null;
  }
}
class py {
  constructor() {
    ut(this, "_items", []);
  }
  remove(e) {
    for (let n = 0; n < this._items.length; n++) {
      const i = this._items[n];
      if (i.isStreamSelection) {
        if (!e.isStreamSelection) continue;
        if (i.from === e.from && i.to === e.to) {
          this._items.splice(n, 1);
          break;
        }
      } else if (cf(e, i)) i.to = Math.max(e.from - 1, 0);
      else if (lf(e, i)) i.from = e.to + 1;
      else if (hf(e, i)) {
        const r = [], s = { ...i, to: Math.max(e.from - 1, 0) };
        s.to - s.from >= 0 && e.from !== 0 && r.push(s);
        const o = { ...i, from: e.to + 1 };
        o.to - o.from >= 0 && r.push(o), this._items.splice(n, 1, ...r), n = n - 1 + r.length;
      } else ff(e, i) && (this._items.splice(n, 1), n--);
    }
  }
  insert(e) {
    if (e.from > e.to) throw new Error("Invalid interval");
    if (!e.isStreamSelection) {
      const { notify: n } = e, i = [];
      for (const r of this._items) r.notify && my(e, r) && i.push(r.notify);
      i.length > 0 && (e.notify = () => {
        i.forEach((r) => r()), n == null || n();
      }), this.remove(e);
    }
    this._items.push(e);
  }
  sort(e = (n, i) => n.from - i.from) {
    this._items.sort(e);
  }
  get length() {
    return this._items.length;
  }
  get(e) {
    return this._items[e];
  }
  swap(e, n) {
    const i = this._items[e];
    this._items[e] = this._items[n], this._items[n] = i;
  }
  clear() {
    this._items.length = 0;
  }
  *[Symbol.iterator]() {
    for (let e = 0; e < this._items.length; e++) {
      const n = this._items[e];
      n.remove = () => {
        this._items.splice(e, 1), e--;
      }, yield n, delete n.remove;
    }
  }
}
function cf(t, e) {
  return t.from <= e.to && t.from > e.from && t.to > e.to;
}
function lf(t, e) {
  return t.to >= e.from && t.to < e.to && t.from < e.from;
}
function hf(t, e) {
  const n = e.to - e.from, i = t.to - t.from;
  return t.from >= e.from && t.to <= e.to && i < n;
}
function ff(t, e) {
  return t.from <= e.from && t.to >= e.to;
}
const my = (t, e) => () => cf(t, e) || lf(t, e) || hf(t, e) || ff(t, e);
var df = ae(717);
const gy = Dt("webtorrent:torrent"), ho = 5e3, fo = 3 * rn.BLOCK_LENGTH, xc = df.browser ? H_().length : 2, po = [1e3, 5e3, 15e3], kc = `WebTorrent/${hi} (https://webtorrent.io)`;
var al, ul, cl, ll;
const by = ((ul = (al = globalThis.navigator) == null ? void 0 : al.storage) == null ? void 0 : ul.getDirectory) && ((ll = (cl = globalThis.FileSystemFileHandle) == null ? void 0 : cl.prototype) == null ? void 0 : ll.createWritable), _y = !df.browser || by ? of : uf;
let Yo;
try {
  Yo = ni(nf.statSync("/tmp") && "/tmp", "webtorrent");
} catch {
  Yo = ni(typeof fc.tmpdir == "function" ? fc.tmpdir() : "/", "webtorrent");
}
const Sc = typeof window < "u" && typeof window.requestIdleCallback == "function" && window.requestIdleCallback;
class Ac extends dn {
  constructor(e, n, i) {
    super(), this._debugId = "unknown infohash", this.client = n, this.announce = i.announce, this.urlList = i.urlList, this.path = i.path || Yo, this.addUID = i.addUID || !1, this.rootDir = i.rootDir || null, this.skipVerify = !!i.skipVerify, this._startupBitfield = i.bitfield, this._store = i.store || _y, this._preloadedStore = i.preloadedStore || null, this._storeCacheSlots = i.storeCacheSlots !== void 0 ? i.storeCacheSlots : 20, this._destroyStoreOnDestroy = i.destroyStoreOnDestroy || !1, this.store = null, this.storeOpts = i.storeOpts, this.alwaysChokeSeeders = i.alwaysChokeSeeders ?? !0, this._getAnnounceOpts = i.getAnnounceOpts, typeof i.private == "boolean" && (this.private = i.private), this.strategy = i.strategy || "sequential", this.maxWebConns = i.maxWebConns || 4, this._rechokeNumSlots = i.uploads === !1 || i.uploads === 0 ? 0 : +i.uploads || 10, this._rechokeOptimisticWire = null, this._rechokeOptimisticTime = 0, this._rechokeIntervalId = null, this._noPeersIntervalId = null, this._noPeersIntervalTime = i.noPeersIntervalTime ? 1e3 * i.noPeersIntervalTime : 3e4, this._startAsDeselected = i.deselect || !1, this.ready = !1, this.destroyed = !1, this.paused = i.paused || !1, this.done = !1, this.metadata = null, this.files = [], this.pieces = [], this._amInterested = !1, this._selections = new py(), this._critical = [], this.wires = [], this._queue = [], this._peers = {}, this._peersLength = 0, this.received = 0, this.uploaded = 0, this._downloadSpeed = as(), this._uploadSpeed = as(), this._servers = [], this._xsRequests = [], this._fileModtimes = i.fileModtimes, e !== null && this._onTorrentId(e), this._debug("new torrent");
  }
  get timeRemaining() {
    return this.done ? 0 : this.downloadSpeed === 0 ? 1 / 0 : (this.length - this.downloaded) / this.downloadSpeed * 1e3;
  }
  get downloaded() {
    if (!this.bitfield) return 0;
    let e = 0;
    for (let n = 0, i = this.pieces.length; n < i; ++n) if (this.bitfield.get(n)) e += n === i - 1 ? this.lastPieceLength : this.pieceLength;
    else {
      const r = this.pieces[n];
      e += r.length - r.missing;
    }
    return e;
  }
  get downloadSpeed() {
    return this._downloadSpeed();
  }
  get uploadSpeed() {
    return this._uploadSpeed();
  }
  get progress() {
    return this.length ? this.downloaded / this.length : 0;
  }
  get ratio() {
    return this.uploaded / (this.received || this.length);
  }
  get numPeers() {
    return this.wires.length;
  }
  get torrentFileBlob() {
    return this.torrentFile ? new Blob([this.torrentFile], { type: "application/x-bittorrent" }) : null;
  }
  get _numQueued() {
    return this._queue.length + (this._peersLength - this._numConns);
  }
  get _numConns() {
    let e = 0;
    for (const n in this._peers) this._peers[n].connected && (e += 1);
    return e;
  }
  async _onTorrentId(e) {
    if (this.destroyed) return;
    let n;
    try {
      n = await zi(e);
    } catch {
    }
    n ? (this.infoHash = n.infoHash, this._debugId = (0, re.V5)(n.infoHash).substring(0, 7), tt(() => {
      this.destroyed || this._onParsedTorrent(n);
    })) : tf(e, (i, r) => {
      if (!this.destroyed) return i ? this._destroy(i) : void this._onParsedTorrent(r);
    });
  }
  _onParsedTorrent(e) {
    if (!this.destroyed) {
      if (this._processParsedTorrent(e), !this.infoHash) return this._destroy(new Error("Malformed torrent data: No info hash"));
      this._rechokeIntervalId = setInterval(() => {
        this._rechoke();
      }, 1e4), this._rechokeIntervalId.unref && this._rechokeIntervalId.unref(), this.emit("_infoHash", this.infoHash), this.destroyed || (this.emit("infoHash", this.infoHash), this.destroyed || (this.client.listening ? this._onListening() : this.client.once("listening", () => {
        this._onListening();
      })));
    }
  }
  _processParsedTorrent(e) {
    this._debugId = (0, re.V5)(e.infoHash).substring(0, 7), this.private !== void 0 && (e.private = this.private), Array.isArray(this.announce) && (e.announce = e.announce.concat(this.announce)), this.client.tracker && Array.isArray(this.client.tracker.announce) && !e.private && (e.announce = e.announce.concat(this.client.tracker.announce)), this.client.tracker && globalThis.WEBTORRENT_ANNOUNCE && !e.private && (e.announce = e.announce.concat(globalThis.WEBTORRENT_ANNOUNCE)), this.urlList && (e.urlList = e.urlList.concat(this.urlList)), e.announce = Array.from(new Set(e.announce)), e.urlList = Array.from(new Set(e.urlList)), Object.assign(this, e), this.magnetURI = L_(e), this.torrentFile = function(n) {
      const i = { info: n.info };
      return i["announce-list"] = (n.announce || []).map((r) => (i.announce || (i.announce = r), [r = (0, re.L0)(r)])), i["url-list"] = n.urlList || [], n.private !== void 0 && (i.private = Number(n.private)), n.created && (i["creation date"] = n.created.getTime() / 1e3 | 0), n.createdBy && (i["created by"] = n.createdBy), n.comment && (i.comment = n.comment), zt.A.encode(i);
    }(e);
  }
  _onListening() {
    this.destroyed || (this.info ? this._onMetadata(this) : (this.xs && this._getMetadataFromServer(), this._startDiscovery()));
  }
  _startDiscovery() {
    if (this.discovery || this.destroyed) return;
    let e = this.client.tracker;
    e && (e = Object.assign({}, this.client.tracker, { getAnnounceOpts: () => {
      if (this.destroyed) return;
      const n = { uploaded: this.uploaded, downloaded: this.downloaded, left: Math.max(this.length - this.downloaded, 0) };
      return this.client.tracker.getAnnounceOpts && Object.assign(n, this.client.tracker.getAnnounceOpts()), this._getAnnounceOpts && Object.assign(n, this._getAnnounceOpts()), n;
    } })), this.peerAddresses && this.peerAddresses.forEach((n) => this.addPeer(n, kt.default.SOURCE_MANUAL)), this.discovery = new X_({ infoHash: this.infoHash, announce: this.announce, peerId: this.client.peerId, dht: !this.private && this.client.dht, tracker: e, port: this.client.torrentPort, userAgent: kc, lsd: this.client.lsd }), this.discovery.on("error", (n) => {
      this._destroy(n);
    }), this.discovery.on("peer", (n, i) => {
      this._debug("peer %s discovered via %s", n, i), this.client.seedOutgoingConnections || !this.done ? this.addPeer(n, i) : this._debug("discovery ignoring peer %s: torrent is done and seedOutgoingConnections is false", n);
    }), this.discovery.on("trackerAnnounce", () => {
      this.emit("trackerAnnounce");
    }), this.discovery.on("dhtAnnounce", () => {
      this.emit("dhtAnnounce");
    }), this.discovery.on("warning", (n) => {
      this.emit("warning", n);
    }), this._noPeersIntervalId = setInterval(() => {
      if (this.destroyed) return;
      const n = { [kt.default.SOURCE_TRACKER]: { enabled: !!this.client.tracker, numPeers: 0 }, [kt.default.SOURCE_DHT]: { enabled: !!this.client.dht, numPeers: 0 }, [kt.default.SOURCE_LSD]: { enabled: !!this.client.lsd, numPeers: 0 }, [kt.default.SOURCE_UT_PEX]: { enabled: this.client.utPex && typeof lo == "function", numPeers: 0 } };
      for (const i of Object.values(this._peers)) {
        const r = n[i.source];
        r !== void 0 && r.numPeers++;
      }
      for (const i of Object.keys(n)) {
        const r = n[i];
        r.enabled && r.numPeers === 0 && this.emit("noPeers", i);
      }
    }, this._noPeersIntervalTime), this._noPeersIntervalId.unref && this._noPeersIntervalId.unref();
  }
  _getMetadataFromServer() {
    const e = this, n = Array.isArray(this.xs) ? this.xs : [this.xs];
    e._xsRequestsController = new AbortController();
    const i = e._xsRequestsController.signal, r = n.map((s) => (o) => {
      (async function(a, u) {
        if (a.indexOf("http://") !== 0 && a.indexOf("https://") !== 0) return e.emit("warning", new Error(`skipping non-http xs param: ${a}`)), u(null);
        const c = { method: "GET", headers: { "user-agent": kc }, signal: i };
        let l, h, f;
        try {
          l = await Ra(a, c);
        } catch {
          return e.emit("warning", new Error(`http error from xs param: ${a}`)), u(null);
        }
        if (e.destroyed || e.metadata) return u(null);
        if (l.status !== 200) return e.emit("warning", new Error(`non-200 status code ${l.status} from xs param: ${a}`)), u(null);
        try {
          h = new Uint8Array(await l.arrayBuffer());
        } catch (d) {
          return e.emit("warning", d), u(null);
        }
        try {
          f = await zi(h);
        } catch {
        }
        if (!f) return e.emit("warning", new Error(`got invalid torrent file from xs param: ${a}`)), u(null);
        if (f.infoHash !== e.infoHash) return e.emit("warning", new Error(`got torrent file with incorrect info hash from xs param: ${a}`)), u(null);
        e._onMetadata(f), u(null);
      })(s, o);
    });
    On(r);
  }
  async _onMetadata(e) {
    var r;
    if (this.metadata || this.destroyed) return;
    let n;
    if (this._debug("got metadata"), (r = this._xsRequestsController) == null || r.abort(), this._xsRequestsController = null, e && e.infoHash) n = e;
    else try {
      n = await zi(e);
    } catch (s) {
      return this._destroy(s);
    }
    this._processParsedTorrent(n), this.metadata = this.torrentFile, this.client.enableWebSeeds && this.urlList.forEach((s) => {
      this.addWebSeed(s);
    }), this._rarityMap = new ly(this), this.files = this.files.map((s) => new wc(this, s));
    let i = this._preloadedStore;
    if (i || (i = new this._store(this.pieceLength, { ...this.storeOpts, torrent: this, path: this.path, files: this.files, length: this.length, name: this.name + " - " + this.infoHash.slice(0, 8), addUID: this.addUID, rootDir: this.rootDir, max: this._storeCacheSlots })), this._storeCacheSlots > 0 && !(i instanceof uf) && (i = new $_(i, { max: this._storeCacheSlots })), this.store = new ny(i), this.so && !this._startAsDeselected ? this.files.forEach((s, o) => {
      this.so.includes(o) && this.files[o].select();
    }) : this.pieces.length === 0 || this._startAsDeselected || this.select(0, this.pieces.length - 1, 0), this._hashes = this.pieces, this._hasStartupBitfield = this._startupBitfield && this._startupBitfield.length === Math.ceil(this.pieces.length / 8) && !this.skipVerify, this.bitfield = new us.A(this._hasStartupBitfield ? new Uint8Array(this._startupBitfield) : this.pieces.length), this._reservations = this._hasStartupBitfield ? this.pieces.map((s, o) => this.bitfield.get(o) ? null : []) : this.pieces.map(() => []), this.pieces = this.pieces.map((s, o) => {
      if (this._hasStartupBitfield && this.bitfield.get(o)) return null;
      const a = o === this.pieces.length - 1 ? this.lastPieceLength : this.pieceLength;
      return new rn(a);
    }), this.emit("metadata"), !this.destroyed) if (this.skipVerify) this._markAllVerified(), this._onStore();
    else {
      const s = (o) => {
        if (o) return this._destroy(o);
        this._debug("done verifying"), this._onStore();
      };
      this._debug("verifying existing torrent data"), this._fileModtimes && this._store === of ? this.getFileModtimes((o, a) => {
        if (o) return this._destroy(o);
        this.files.map((u, c) => a[c] === this._fileModtimes[c]).every((u) => u) ? (this._markAllVerified(), this._onStore()) : this._verifyPieces(s);
      }) : this._verifyPieces(s);
    }
  }
  getFileModtimes(e) {
    const n = [];
    vc(this.files.map((i, r) => (s) => {
      const o = this.addUID ? ni(this.name + " - " + this.infoHash.slice(0, 8)) : ni(this.path, i.path);
      nf.stat(o, (a, u) => {
        if (a && a.code !== "ENOENT") return s(a);
        n[r] = u && u.mtime.getTime(), s(null);
      });
    }), xc, (i) => {
      this._debug("done getting file modtimes"), e(i, n);
    });
  }
  _verifyPiece(e, n) {
    if (this.destroyed) return n(new Error("torrent is destroyed"));
    const i = {};
    e === this.pieces.length - 1 && (i.length = this.lastPieceLength), this.store.get(e, i, async (r, s) => {
      if (this.destroyed) return n(new Error("torrent is destroyed"));
      if (r) return tt(() => n(null, !1));
      const o = await (0, re.tW)(s, "hex");
      if (this.destroyed) return n(new Error("torrent is destroyed"));
      n(null, o === this._hashes[e]);
    });
  }
  _verifyPiecesUsingBitfield(e) {
    const n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
    for (const r of this.files) {
      let s = 2, o = null;
      for (let a = r._startPiece; a <= r._endPiece; ++a) this.bitfield.get(a) && (s && (o = a, s--), i.has(a) || i.set(a, []), i.get(a).push(r));
      o !== null && n.add(o);
    }
    this._verifyPiecesUsingHash([...n], (r) => {
      if (r) return e(r);
      const s = /* @__PURE__ */ new Set();
      for (const o of n) if (!this.bitfield.get(o)) {
        const a = i.get(o);
        for (const u of a) s.add(u);
      }
      if (s.size) {
        const o = [];
        for (const a of s) for (let u = a._startPiece; u <= a._endPiece; ++u) o.indexOf(u) === -1 && o.push(u);
        return this._verifyPiecesUsingHash(o, e);
      }
      e(null);
    });
  }
  _verifyPiecesUsingHash(e, n) {
    vc(e.map((i, r) => (s) => {
      const o = Number.isInteger(i) ? i : r;
      this._verifyPiece(o, (a, u) => {
        if (a) return s(a);
        u ? (this._debug("piece verified %s", o), this._markVerified(o)) : (this._markUnverified(o), this._debug("piece invalid %s", o)), s(null);
      });
    }), xc, n);
  }
  _verifyPieces(e) {
    if (this._hasStartupBitfield) return this._verifyPiecesUsingBitfield(e);
    this._verifyPiecesUsingHash(this.pieces, e);
  }
  rescanFiles(e) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    e || (e = Ec), this._verifyPiecesUsingHash(this.pieces, (n) => {
      if (n) return this._destroy(n), e(n);
      this._checkDone(), e(null);
    });
  }
  _markAllVerified() {
    for (let e = 0; e < this.pieces.length; e++) this._markVerified(e);
  }
  _markVerified(e) {
    this.pieces[e] = null, this._reservations[e] = null, this.bitfield.set(e, !0), this.emit("verified", e);
  }
  _markUnverified(e) {
    const n = e === this.pieces.length - 1 ? this.lastPieceLength : this.pieceLength;
    this.pieces[e] = new rn(n), this.bitfield.set(e, !1), this._startAsDeselected || this.select(e, e, 1);
    for (const i of this.files) i.done && i.includes(e) && (i.done = !1);
  }
  _hasAllPieces() {
    for (let e = 0; e < this.pieces.length; e++) if (!this.bitfield.get(e)) return !1;
    return !0;
  }
  _hasNoPieces() {
    return !this._hasMorePieces(0);
  }
  _hasMorePieces(e) {
    let n = 0;
    for (let i = 0; i < this.pieces.length; i++) if (this.bitfield.get(i) && (n += 1, n > e)) return !0;
    return !1;
  }
  _onStore() {
    this.destroyed || (this._debug("on store"), this._startDiscovery(), this.ready = !0, this.emit("ready"), this._checkDone(), this._updateSelections(), this.wires.forEach((e) => {
      e.ut_metadata && e.ut_metadata.setMetadata(this.metadata), this._onWireWithMetadata(e);
    }));
  }
  destroy(e, n) {
    if (typeof e == "function") return this.destroy(null, e);
    this._destroy(null, e, n);
  }
  _destroy(e, n, i) {
    var s;
    if (typeof n == "function") return this._destroy(e, null, n);
    if (this.destroyed) return;
    this.destroyed = !0, this._debug("destroy"), this.client._remove(this), this._selections.clear(), clearInterval(this._rechokeIntervalId), clearInterval(this._noPeersIntervalId), (s = this._xsRequestsController) == null || s.abort(), this._rarityMap && this._rarityMap.destroy();
    for (const o in this._peers) this.removePeer(o);
    for (const o of this.files) o instanceof wc && o._destroy();
    const r = this._servers.map((o) => (a) => {
      o.destroy(a);
    });
    if (this.discovery && r.push((o) => {
      this.discovery.destroy(o);
    }), this.store) {
      let o = this._destroyStoreOnDestroy;
      n && n.destroyStore !== void 0 && (o = n.destroyStore), r.push((a) => {
        o ? this.store.destroy(a) : this.store.close(a);
      });
    }
    On(r, i), e && (this.listenerCount("error") === 0 ? this.client.emit("error", e) : this.emit("error", e)), this.emit("close"), this.client = null, this.files = [], this.discovery = null, this.store = null, this._rarityMap = null, this._peers = null, this._servers = null, this._xsRequests = null, this._queue = null;
  }
  addPeer(e, n) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    if (!this.infoHash) throw new Error("addPeer() must not be called before the `infoHash` event");
    let i;
    if (typeof e == "string") {
      let o;
      try {
        o = Pr(e);
      } catch {
        return this._debug("ignoring peer: invalid %s", e), this.emit("invalidPeer", e), !1;
      }
      i = o[0];
    } else typeof e.remoteAddress == "string" && (i = e.remoteAddress);
    if (this.client.blocked && i && this.client.blocked.contains(i)) return this._debug("ignoring peer: blocked %s", e), typeof e != "string" && e.destroy(), this.emit("blockedPeer", e), !1;
    const r = this.client.utp && this._isIPv4(i) ? "utp" : "tcp", s = !!this._addPeer(e, r, n);
    return s ? this.emit("peer", e) : this.emit("invalidPeer", e), s;
  }
  _addPeer(e, n, i) {
    if (this.destroyed) return typeof e != "string" && e.destroy(), null;
    if (typeof e == "string" && !this._validAddr(e)) return this._debug("ignoring peer: invalid %s", e), null;
    const r = e && e.id || e;
    if (this._peers[r]) return this._debug("ignoring peer: duplicate (%s)", r), typeof e != "string" && e.destroy(), null;
    if (this.paused) return this._debug("ignoring peer: torrent is paused"), typeof e != "string" && e.destroy(), null;
    let s;
    return this._debug("add peer %s", r), s = typeof e == "string" ? n === "utp" ? kt.default.createUTPOutgoingPeer(e, this, this.client.throttleGroups, i) : kt.default.createTCPOutgoingPeer(e, this, this.client.throttleGroups, i) : kt.default.createWebRTCPeer(e, this, this.client.throttleGroups, i), this._registerPeer(s), typeof e == "string" && (this._queue.push(s), this._drain()), s;
  }
  addWebSeed(e) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    let n, i;
    if (typeof e == "string") {
      if (n = e, !/^https?:\/\/.+/.test(n)) return this.emit("warning", new Error(`ignoring invalid web seed: ${n}`)), void this.emit("invalidPeer", n);
      if (this._peers[n]) return this.emit("warning", new Error(`ignoring duplicate web seed: ${n}`)), void this.emit("invalidPeer", n);
      i = new dy(n, this);
    } else {
      if (!e || typeof e.connId != "string") return void this.emit("warning", new Error("addWebSeed must be passed a string or connection object with id property"));
      if (i = e, n = i.connId, this._peers[n]) return this.emit("warning", new Error(`ignoring duplicate web seed: ${n}`)), void this.emit("invalidPeer", n);
    }
    this._debug("add web seed %s", n);
    const r = kt.default.createWebSeedPeer(i, n, this, this.client.throttleGroups);
    this._registerPeer(r), this.emit("peer", n);
  }
  _addIncomingPeer(e) {
    return this.destroyed ? e.destroy(new Error("torrent is destroyed")) : this.paused ? e.destroy(new Error("torrent is paused")) : (this._debug("add incoming peer %s", e.id), void this._registerPeer(e));
  }
  _registerPeer(e) {
    e.on("download", (n) => {
      this.destroyed || (this.received += n, this._downloadSpeed(n), this.client._downloadSpeed(n), this.emit("download", n), this.destroyed || this.client.emit("download", n));
    }), e.on("upload", (n) => {
      this.destroyed || (this.uploaded += n, this._uploadSpeed(n), this.client._uploadSpeed(n), this.emit("upload", n), this.destroyed || this.client.emit("upload", n));
    }), this._peers[e.id] = e, this._peersLength += 1;
  }
  removePeer(e) {
    var i;
    const n = (e == null ? void 0 : e.id) || e;
    e && !e.id && (e = (i = this._peers) == null ? void 0 : i[n]), e && (e.destroy(), this.destroyed || (this._debug("removePeer %s", n), delete this._peers[n], this._peersLength -= 1, this._drain()));
  }
  _select(e = 0, n = this.pieces.length - 1, i, r, s = !1) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    if (e < 0 || n < e || this.pieces.length <= n) throw new Error(`invalid selection ${e} : ${n}`);
    i = Number(i) || 0, this._debug("select %s-%s (priority %s)", e, n, i), this._selections.insert({ from: e, to: n, offset: 0, priority: i, notify: r, isStreamSelection: s }), this._selections.sort((o, a) => a.priority - o.priority), this._updateSelections();
  }
  select(e, n, i, r) {
    this._select(e, n, i, r, !1);
  }
  _deselect(e, n, i = !1) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    this._debug("deselect %s-%s", e, n), this._selections.remove({ from: e, to: n, isStreamSelection: i }), this._updateSelections();
  }
  deselect(e, n) {
    this._deselect(e, n, !1);
  }
  critical(e, n) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    this._debug("critical %s-%s", e, n);
    for (let i = e; i <= n; ++i) this._critical[i] = !0;
    this._updateSelections();
  }
  _onWire(e, n) {
    if (this._debug("got wire %s (%s)", e._debugId, n || "Unknown"), this.wires.push(e), n) {
      const i = Pr(n);
      e.remoteAddress = i[0], e.remotePort = i[1];
    }
    this.client.dht && this.client.dht.listening && e.on("port", (i) => {
      if (!this.destroyed && !this.client.dht.destroyed) {
        if (!e.remoteAddress) return this._debug("ignoring PORT from peer with no address");
        if (i === 0 || i > 65536) return this._debug("ignoring invalid PORT from peer");
        this._debug("port: %s (from %s)", i, n), this.client.dht.addNode({ host: e.remoteAddress, port: i });
      }
    }), e.on("timeout", () => {
      this._debug("wire timeout (%s)", n), e.destroy();
    }), e.type !== "webSeed" && e.setTimeout(3e4, !0), e.setKeepAlive(!0), e.use(oy(this.metadata)), e.ut_metadata.on("warning", (i) => {
      this._debug("ut_metadata warning: %s", i.message);
    }), this.metadata || (e.ut_metadata.on("metadata", (i) => {
      this._debug("got metadata via ut_metadata"), this._onMetadata(i);
    }), e.ut_metadata.fetch()), this.client.utPex && typeof lo == "function" && !this.private && (e.use(lo()), e.ut_pex.on("peer", (i) => {
      this.client.seedOutgoingConnections || !this.done ? (this._debug("ut_pex: got peer: %s (from %s)", i, n), this.addPeer(i, kt.default.SOURCE_UT_PEX)) : this._debug("ut_pex ignoring peer %s: torrent is done and seedOutgoingConnections is false", i);
    }), e.ut_pex.on("dropped", (i) => {
      const r = this._peers[i];
      r && !r.connected && (this._debug("ut_pex: dropped peer: %s (from %s)", i, n), this.removePeer(i));
    }), e.once("close", () => {
      e.ut_pex.reset();
    })), e.use(af()), this.emit("wire", e, n), this.ready && tt(() => {
      this._onWireWithMetadata(e);
    });
  }
  _onWireWithMetadata(e) {
    let n = null;
    const i = () => {
      this.destroyed || e.destroyed || (this._numQueued > 2 * (this._numConns - this.numPeers) && e.amInterested ? e.destroy() : (n = setTimeout(i, ho), n.unref && n.unref()));
    };
    let r;
    const s = () => {
      if (e.peerPieces.buffer.length === this.bitfield.buffer.length) {
        for (r = 0; r < this.pieces.length; ++r) if (!e.peerPieces.get(r)) return;
        e.isSeeder = !0, this.alwaysChokeSeeders && e.choke();
      }
    };
    e.on("bitfield", () => {
      s(), this._update(), this._updateWireInterest(e);
    }), e.on("have", () => {
      s(), this._update(), this._updateWireInterest(e);
    }), e.lt_donthave.on("donthave", () => {
      s(), this._update(), this._updateWireInterest(e);
    }), e.on("have-all", () => {
      e.isSeeder = !0, this.alwaysChokeSeeders && e.choke(), this._update(), this._updateWireInterest(e);
    }), e.on("have-none", () => {
      e.isSeeder = !1, this._update(), this._updateWireInterest(e);
    }), e.on("allowed-fast", (o) => {
      this._update();
    }), e.once("interested", () => {
      e.unchoke();
    }), e.once("close", () => {
      clearTimeout(n);
    }), e.on("choke", () => {
      clearTimeout(n), n = setTimeout(i, ho), n.unref && n.unref();
    }), e.on("unchoke", () => {
      clearTimeout(n), this._update();
    }), e.on("request", (o, a, u, c) => {
      if (u > 131072) return e.destroy();
      this.pieces[o] || this.store.get(o, { offset: a, length: u }, c);
    }), e.hasFast && this._hasAllPieces() ? e.haveAll() : e.hasFast && this._hasNoPieces() ? e.haveNone() : e.bitfield(this.bitfield), this._updateWireInterest(e), e.peerExtensions.dht && this.client.dht && this.client.dht.listening && e.port(this.client.dht.address().port), e.type !== "webSeed" && (n = setTimeout(i, ho), n.unref && n.unref()), e.isSeeder = !1, s();
  }
  _updateSelections() {
    this.ready && !this.destroyed && (tt(() => {
      this._gcSelections();
    }), this._updateInterest(), this._update());
  }
  _gcSelections() {
    var e, n;
    for (const i of this._selections) {
      const r = i.offset;
      for (; this.bitfield.get(i.from + i.offset) && i.from + i.offset < i.to; ) i.offset += 1;
      r !== i.offset && ((e = i.notify) == null || e.call(i)), i.to === i.from + i.offset && this.bitfield.get(i.from + i.offset) && (i.remove(), (n = i.notify) == null || n.call(i), this._updateInterest());
    }
    this._selections.length || this.emit("idle");
  }
  _updateInterest() {
    const e = this._amInterested;
    this._amInterested = !!this._selections.length, this.wires.forEach((n) => this._updateWireInterest(n)), e !== this._amInterested && (this._amInterested ? this.emit("interested") : this.emit("uninterested"));
  }
  _updateWireInterest(e) {
    let n = !1;
    for (let i = 0; i < this.pieces.length; ++i) if (this.pieces[i] && e.peerPieces.get(i)) {
      n = !0;
      break;
    }
    n ? e.interested() : e.uninterested();
  }
  _update() {
    Sc ? Sc(() => this._updateWireWrapper(), { timeout: 250 }) : this._updateWireWrapper();
  }
  _updateWireWrapper() {
    if (this.destroyed) return;
    const e = iy(this.wires);
    let n;
    for (; n = e(); ) this._updateWire(n);
  }
  _updateWire(e) {
    if (e.destroyed) return !1;
    const n = this, i = mo(e, 0.5);
    if (e.requests.length >= i) return;
    const r = mo(e, 1);
    if (e.peerChoking) e.hasFast && e.peerAllowedFastSet.length > 0 && !this._hasMorePieces(e.peerAllowedFastSet.length - 1) && function() {
      if (e.requests.length >= r) return !1;
      for (const u of e.peerAllowedFastSet) {
        if (e.peerPieces.get(u) && !n.bitfield.get(u)) for (; n._request(e, u, !1) && e.requests.length < r; ) ;
        if (!(e.requests.length < r)) return !0;
      }
    }();
    else {
      if (!e.downloaded) return function() {
        if (e.requests.length) return;
        let u = n._selections.length;
        for (; u--; ) {
          const c = n._selections.get(u);
          let l;
          if (n.strategy === "rarest") {
            const h = c.from + c.offset, f = c.to, d = f - h + 1, p = {};
            let m = 0;
            const _ = s(h, f, p);
            for (; m < d && (l = n._rarityMap.getRarestPiece(_), !(l < 0)); ) {
              if (n._request(e, l, !1)) return;
              p[l] = !0, m += 1;
            }
          } else for (l = c.to; l >= c.from + c.offset; --l) if (e.peerPieces.get(l) && n._request(e, l, !1)) return;
        }
      }();
      a(!1) || a(!0);
    }
    function s(u, c, l, h) {
      return (f) => f >= u && f <= c && !(f in l) && e.peerPieces.get(f) && (!h || h(f));
    }
    function o(u) {
      let c = u;
      for (let l = u; l < n._selections.length && n._selections.get(l).priority; l++) c = l;
      n._selections.swap(u, c);
    }
    function a(u) {
      if (e.requests.length >= r) return !0;
      const c = function() {
        const l = e.downloadSpeed() || 1;
        if (l > fo) return () => !0;
        const h = Math.max(1, e.requests.length) * rn.BLOCK_LENGTH / l;
        let f = 10, d = 0;
        return (p) => {
          if (!f || n.bitfield.get(p)) return !0;
          let m = n.pieces[p].missing;
          for (; d < n.wires.length; d++) {
            const _ = n.wires[d], y = _.downloadSpeed();
            if (!(y < fo) && !(y <= l) && _.peerPieces.get(p) && !((m -= y * h) > 0)) return f--, !1;
          }
          return !0;
        };
      }();
      for (let l = 0; l < n._selections.length; l++) {
        const h = n._selections.get(l);
        let f;
        if (n.strategy === "rarest") {
          const d = h.from + h.offset, p = h.to, m = p - d + 1, _ = {};
          let y = 0;
          const b = s(d, p, _, c);
          for (; y < m && (f = n._rarityMap.getRarestPiece(b), !(f < 0)); ) {
            for (; n._request(e, f, n._critical[f] || u) && e.requests.length < r; ) ;
            if (!(e.requests.length < r)) return h.priority && o(l), !0;
            _[f] = !0, y++;
          }
        } else for (f = h.from + h.offset; f <= h.to; f++) if (e.peerPieces.get(f) && c(f)) {
          for (; n._request(e, f, n._critical[f] || u) && e.requests.length < r; ) ;
          if (!(e.requests.length < r)) return h.priority && o(l), !0;
        }
      }
      return !1;
    }
  }
  _rechoke() {
    if (!this.ready) return;
    const e = this.wires.map((r) => ({ wire: r, random: Math.random() })).sort((r, s) => {
      const o = r.wire, a = s.wire;
      return o.downloadSpeed() !== a.downloadSpeed() ? o.downloadSpeed() - a.downloadSpeed() : o.uploadSpeed() !== a.uploadSpeed() ? o.uploadSpeed() - a.uploadSpeed() : o.amChoking !== a.amChoking ? o.amChoking ? -1 : 1 : r.random - s.random;
    }).map((r) => r.wire);
    this._rechokeOptimisticTime <= 0 ? this._rechokeOptimisticWire = null : this._rechokeOptimisticTime -= 1;
    let n = 0;
    for (; e.length > 0 && n < this._rechokeNumSlots - 1; ) {
      const r = e.pop();
      r.isSeeder || r === this._rechokeOptimisticWire || (r.unchoke(), r.peerInterested && n++);
    }
    if (this._rechokeOptimisticWire === null && this._rechokeNumSlots > 0) {
      const r = e.filter((s) => s.peerInterested);
      if (r.length > 0) {
        const s = r[i = r.length, Math.random() * i | 0];
        s.unchoke(), this._rechokeOptimisticWire = s, this._rechokeOptimisticTime = 2;
      }
    }
    var i;
    e.filter((r) => r !== this._rechokeOptimisticWire).forEach((r) => r.choke());
  }
  _hotswap(e, n) {
    const i = e.downloadSpeed();
    if (i < rn.BLOCK_LENGTH || !this._reservations[n]) return !1;
    const r = this._reservations[n];
    if (!r) return !1;
    let s, o, a = 1 / 0;
    for (o = 0; o < r.length; o++) {
      const u = r[o];
      if (!u || u === e) continue;
      const c = u.downloadSpeed();
      c >= fo || 2 * c > i || c > a || (s = u, a = c);
    }
    if (!s) return !1;
    for (o = 0; o < r.length; o++) r[o] === s && (r[o] = null);
    for (o = 0; o < s.requests.length; o++) {
      const u = s.requests[o];
      u.piece === n && this.pieces[n].cancel(u.offset / rn.BLOCK_LENGTH | 0);
    }
    return this.emit("hotswap", s, e, n), !0;
  }
  _request(e, n, i) {
    const r = this, s = e.requests.length, o = e.type === "webSeed";
    if (r.bitfield.get(n)) return !1;
    const a = o ? Math.min(function(m, _, y) {
      return 1 + Math.ceil(_ * m.downloadSpeed() / y);
    }(e, 1, r.pieceLength), r.maxWebConns) : mo(e, 1);
    if (s >= a) return !1;
    const u = r.pieces[n];
    let c = o ? u.reserveRemaining() : u.reserve();
    if (c === -1 && i && r._hotswap(e, n) && (c = o ? u.reserveRemaining() : u.reserve()), c === -1) return !1;
    let l = r._reservations[n];
    l || (l = r._reservations[n] = []);
    let h = l.indexOf(null);
    h === -1 && (h = l.length), l[h] = e;
    const f = u.chunkOffset(c), d = o ? u.chunkLengthRemaining(c) : u.chunkLength(c);
    function p() {
      tt(() => {
        r._update();
      });
    }
    return e.request(n, f, d, async function m(_, y) {
      if (r.destroyed) return;
      if (!r.ready) return r.once("ready", () => {
        m(_, y);
      });
      if (l[h] === e && (l[h] = null), u !== r.pieces[n]) return p();
      if (_) return r._debug("error getting piece %s (offset: %s length: %s) from %s: %s", n, f, d, `${e.remoteAddress}:${e.remotePort}`, _.message), o ? u.cancelRemaining(c) : u.cancel(c), void p();
      if (r._debug("got piece %s (offset: %s length: %s) from %s", n, f, d, `${e.remoteAddress}:${e.remotePort}`), !u.set(c, y, e)) return p();
      const b = u.flush(), g = await (0, re.tW)(b, "hex");
      r.destroyed || (g === r._hashes[n] ? (r._debug("piece verified %s", n), r.store.put(n, b, (v) => {
        v ? r._destroy(v) : (r.pieces[n] = null, r._markVerified(n), r.wires.forEach((w) => {
          w.have(n);
        }), r._checkDone(), p());
      })) : (r.pieces[n] = new rn(u.length), r.emit("warning", new Error(`Piece ${n} failed verification`)), p()));
    }), !0;
  }
  _checkDone() {
    var n;
    if (this.destroyed) return;
    this.files.forEach((i) => {
      if (!i.done) {
        for (let r = i._startPiece; r <= i._endPiece; ++r) if (!this.bitfield.get(r)) return;
        i.done = !0, i.emit("done"), this._debug(`file done: ${i.name}`);
      }
    });
    const e = this.files.every((i) => i.done);
    return !this.done && e ? (this.done = !0, this._debug(`torrent done: ${this.infoHash}`), this.emit("done"), this.destroyed || this.discovery.complete()) : this.done && !e && (this.done = !1, (n = this.discovery.tracker) == null || n.start()), this._gcSelections(), e;
  }
  async load(e, n) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    if (!this.ready) return this.once("ready", () => {
      this.load(e, n);
    });
    Array.isArray(e) || (e = [e]), n || (n = Ec);
    try {
      await U_(this.store, Qh(e), { chunkLength: this.pieceLength }), this._markAllVerified(), this._checkDone(), n(null);
    } catch (i) {
      return n(i), i;
    }
  }
  pause() {
    this.destroyed || (this._debug("pause"), this.paused = !0);
  }
  resume() {
    this.destroyed || (this._debug("resume"), this.paused = !1, this._drain());
  }
  _debug() {
    const e = [].slice.call(arguments);
    e[0] = `[${this.client ? this.client._debugId : "No Client"}] [${this._debugId}] ${e[0]}`, gy(...e);
  }
  _drain() {
    if (this._debug("_drain numConns %s maxConns %s", this._numConns, this.client.maxConns), typeof hc.connect != "function" || this.destroyed || this.paused || this._numConns >= this.client.maxConns) return;
    this._debug("drain (%s queued, %s/%s peers)", this._numQueued, this.numPeers, this.client.maxConns);
    const e = this._queue.shift();
    if (!e) return;
    this._debug("%s connect attempt to %s", e.type, e.addr);
    const n = Pr(e.addr), i = { host: n[0], port: n[1] };
    this.client.utp && e.type === kt.default.TYPE_UTP_OUTGOING ? e.conn = hy.connect(i.port, i.host) : e.conn = hc.connect(i);
    const r = e.conn;
    r.once("connect", () => {
      this.destroyed || e.onConnect();
    }), r.once("error", (s) => {
      e.destroy(s);
    }), e.startConnectTimeout(), r.on("close", () => {
      if (this.destroyed) return;
      if (e.retries >= po.length) {
        if (this.client.utp) {
          const a = this._addPeer(e.addr, "tcp", e.source);
          a && (a.retries = 0);
        } else this._debug("conn %s closed: will not re-add (max %s attempts)", e.addr, po.length);
        return;
      }
      const s = po[e.retries];
      this._debug("conn %s closed: will re-add to queue in %sms (attempt %s)", e.addr, s, e.retries + 1);
      const o = setTimeout(() => {
        if (this.destroyed) return;
        const a = Pr(e.addr)[0], u = this.client.utp && this._isIPv4(a) ? "utp" : "tcp", c = this._addPeer(e.addr, u, e.source);
        c && (c.retries = e.retries + 1);
      }, s);
      o.unref && o.unref();
    });
  }
  _validAddr(e) {
    let n;
    try {
      n = Pr(e);
    } catch {
      return !1;
    }
    const i = n[0], r = n[1];
    return r > 0 && r < 65535 && !(i === "127.0.0.1" && r === this.client.torrentPort);
  }
  _isIPv4(e) {
    return /^((?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])[.]){3}(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])$/.test(e);
  }
}
function mo(t, e) {
  let n = 2 + Math.ceil(e * t.downloadSpeed() / rn.BLOCK_LENGTH);
  if (t.peerExtendedHandshake) {
    const i = t.peerExtendedHandshake.reqq;
    typeof i == "number" && i > 0 && (n = Math.min(n, i));
  }
  return n;
}
function Ec() {
}
var yy = ae(4043), Xt = ae(580), pf = ae(815), vy = ae(2878);
class dt {
  constructor(e, n = {}) {
    this.client = e, n.origin || (n.origin = "*"), this.opts = n, this.pendingReady = /* @__PURE__ */ new Set();
  }
  static serveIndexPage(e, n, i) {
    const r = n.map((s) => `<li>
        <a href="${Xt(i)}/${s.infoHash}">
          ${Xt(s.name)}
        </a>
        (${Xt(s.length)} bytes)
      </li>`).join("<br>");
    return e.status = 200, e.headers["Content-Type"] = "text/html", e.body = Ti("WebTorrent", `<h1>WebTorrent</h1>
       <ol>${r}</ol>`), e;
  }
  isOriginAllowed(e) {
    return this.opts.origin !== !1 && (this.opts.origin === "*" || e.headers.origin === this.opts.origin);
  }
  static serveMethodNotAllowed(e) {
    return e.status = 405, e.headers["Content-Type"] = "text/html", e.body = Ti("405 - Method Not Allowed", "<h1>405 - Method Not Allowed</h1>"), e;
  }
  static serve404Page(e) {
    return e.status = 404, e.headers["Content-Type"] = "text/html", e.body = Ti("404 - Not Found", "<h1>404 - Not Found</h1>"), e;
  }
  static serveTorrentPage(e, n, i) {
    const r = e.files.map((s) => `<li>
        <a href="${Xt(i)}/${e.infoHash}/${Xt(s.path)}">
          ${Xt(s.path)}
        </a>
        (${Xt(s.length)} bytes)
      </li>`).join("<br>");
    return n.status = 200, n.headers["Content-Type"] = "text/html", n.body = Ti(`${Xt(e.name)} - WebTorrent`, `<h1>${Xt(e.name)}</h1>
      <ol>${r}</ol>`), n;
  }
  static serveOptionsRequest(e, n) {
    return n.status = 204, n.headers["Access-Control-Max-Age"] = "600", n.headers["Access-Control-Allow-Methods"] = "GET,HEAD", e.headers["access-control-request-headers"] && (n.headers["Access-Control-Allow-Headers"] = e.headers["access-control-request-headers"]), n;
  }
  static serveFile(e, n, i) {
    i.status = 200, i.headers.Expires = "0", i.headers["Cache-Control"] = "no-cache, no-store, must-revalidate, max-age=0", i.headers["Accept-Ranges"] = "bytes", i.headers["Content-Type"] = e.type, i.headers["transferMode.dlna.org"] = "Streaming", i.headers["contentFeatures.dlna.org"] = "DLNA.ORG_OP=01;DLNA.ORG_CI=0;DLNA.ORG_FLAGS=01700000000000000000000000000000", n.destination === "document" ? (i.headers["Content-Type"] = "application/octet-stream", i.headers["Content-Disposition"] = `attachment; filename*=UTF-8''${Cc(e.name)}`, i.body = "DOWNLOAD") : i.headers["Content-Disposition"] = `inline; filename*=UTF-8''${Cc(e.name)}`;
    let r = vy(e.length, n.headers.range || "");
    if (Array.isArray(r) ? (i.status = 206, r = r[0], i.headers["Content-Range"] = `bytes ${r.start}-${r.end}/${e.length}`, i.headers["Content-Length"] = r.end - r.start + 1) : (i.statusCode = 200, r = null, i.headers["Content-Length"] = e.length), n.method === "GET") {
      const s = e[Symbol.asyncIterator](r);
      let o = null;
      e.emit("iterator", { iterator: s, req: n, file: e }, (c) => {
        o = c;
      });
      const a = Ss.Readable.from(o || s);
      let u = null;
      e.emit("stream", { stream: a, req: n, file: e }, (c) => {
        u = pf(a, c);
      }), i.body = u || a;
    } else i.body = !1;
    return i;
  }
  async onRequest(e, n) {
    let i = new URL(e.url, "http://example.com").pathname;
    i = i.slice(i.indexOf(this.pathname) + this.pathname.length + 1);
    const r = { headers: { "X-Content-Type-Options": "nosniff", "Content-Security-Policy": "base-uri 'none'; frame-ancestors 'none'; form-action 'none';" } };
    if (this.isOriginAllowed(e) && (r.headers["Access-Control-Allow-Origin"] = this.opts.origin === "*" ? "*" : e.headers.origin), i === "favicon.ico") return n(dt.serve404Page(r));
    if (e.method === "OPTIONS") return this.isOriginAllowed(e) ? n(dt.serveOptionsRequest(e, r)) : n(dt.serveMethodNotAllowed(r));
    const s = async () => {
      this.pendingReady.delete(s);
      const a = await o();
      n(a);
    }, o = async () => {
      if (i === "") return dt.serveIndexPage(r, this.client.torrents, this.pathname);
      let [a, ...u] = i.split("/");
      u = decodeURI(u.join("/"));
      const c = await this.client.get(a);
      if (!a || !c) return dt.serve404Page(r);
      if (!u) return dt.serveTorrentPage(c, r, this.pathname);
      const l = c.files.find((h) => h.path.replace(/\\/g, "/") === u);
      return l ? dt.serveFile(l, e, r) : dt.serve404Page(r);
    };
    if (e.method === "GET" || e.method === "HEAD") {
      if (this.client.ready) {
        const a = await o();
        return n(a);
      }
      return this.pendingReady.add(s), void this.client.once("ready", s);
    }
    return n(dt.serveMethodNotAllowed(r));
  }
  close(e = () => {
  }) {
    this.closed = !0, this.pendingReady.forEach((n) => {
      this.client.removeListener("ready", n);
    }), this.pendingReady.clear(), tt(e);
  }
  destroy(e = () => {
  }) {
    this.closed ? tt(e) : this.close(e), this.client = null;
  }
}
class wy extends dt {
  constructor(e, n) {
    super(e, n), this.server = yy.createServer(), this._listen = this.server.listen, this.server.listen = this.listen.bind(this), this._close = this.server.close, this.server.close = this.close.bind(this), this.sockets = /* @__PURE__ */ new Set(), this.closed = !1, this.pathname = (n == null ? void 0 : n.pathname) || "/webtorrent";
  }
  wrapRequest(e, n) {
    return this.opts.hostname && e.headers.host !== `${this.opts.hostname}:${this.server.address().port}` ? e.destroy() : new URL(e.url, "http://example.com").pathname.startsWith(this.pathname) ? void this.onRequest(e, ({ status: i, headers: r, body: s }) => {
      n.writeHead(i, r), s != null && s._readableState || s != null && s._writableState ? pf(s, n) : n.end(s);
    }) : e.destroy();
  }
  onConnection(e) {
    e.setTimeout(36e6), this.sockets.add(e), e.once("close", () => {
      this.sockets.delete(e);
    });
  }
  address() {
    return this.server.address();
  }
  listen(...e) {
    return this.closed = !1, this.server.on("connection", this.onConnection.bind(this)), this.server.on("request", this.wrapRequest.bind(this)), this._listen.apply(this.server, e);
  }
  close(e = () => {
  }) {
    this.server.removeAllListeners("connection"), this.server.removeAllListeners("request"), this.server.removeAllListeners("listening"), super.close(), this._close.call(this.server, e);
  }
  destroy(e) {
    this.sockets.forEach((n) => {
      n.destroy();
    }), super.destroy(e);
  }
}
class xy extends dt {
  constructor(e, n) {
    super(e, n), this.registration = n.controller, this.workerKeepAliveInterval = null, this.workerPortCount = 0;
    const i = new URL(n.controller.scope);
    this.pathname = i.pathname + "webtorrent", this._address = { port: i.port, family: "IPv4", address: i.hostname }, this.boundHandler = this.wrapRequest.bind(this), navigator.serviceWorker.addEventListener("message", this.boundHandler), fetch(`${this.pathname}/cancel/`).then((r) => {
      r.body.cancel();
    });
  }
  wrapRequest(e) {
    const n = e.data;
    if (!(n != null && n.type) === "webtorrent" || !n.url) return null;
    const [i] = e.ports;
    this.onRequest(n, ({ status: r, headers: s, body: o }) => {
      var c;
      const a = (c = o[Symbol.asyncIterator]) == null ? void 0 : c.call(o), u = () => {
        i.onmessage = null, o != null && o.destroy && o.destroy(), this.workerPortCount--, this.workerPortCount || (clearInterval(this.workerKeepAliveInterval), this.workerKeepAliveInterval = null);
      };
      i.onmessage = async (l) => {
        if (l.data) {
          let h;
          try {
            h = (await a.next()).value;
          } catch {
          }
          i.postMessage(h), h || u(), this.workerKeepAliveInterval || (this.workerKeepAliveInterval = setInterval(() => fetch(`${this.pathname}/keepalive/`), 2e4));
        } else u();
      }, this.workerPortCount++, i.postMessage({ status: r, headers: s, body: a ? "STREAM" : o });
    });
  }
  listen(e, n) {
    n();
  }
  address() {
    return this._address;
  }
  close(e) {
    navigator.serviceWorker.removeEventListener("message", this.boundHandler), super.close(e);
  }
  destroy(e) {
    super.destroy(e);
  }
}
function Ti(t, e) {
  return `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="utf-8">
        <title>${t}</title>
      </head>
      <body>
        ${e}
      </body>
    </html>
  `;
}
function Cc(t) {
  return encodeURIComponent(t).replace(/['()]/g, escape).replace(/\*/g, "%2A").replace(/%(?:7C|60|5E)/g, unescape);
}
const go = Dt("webtorrent"), mf = hi.replace(/\d*./g, (t) => ("0" + t % 100).slice(-2)).slice(0, 4), ky = `-WW${mf}-`;
class yr extends dn {
  constructor(e = {}) {
    super(), typeof e.peerId == "string" ? this.peerId = e.peerId : ArrayBuffer.isView(e.peerId) ? this.peerId = (0, re.V5)(e.peerId) : this.peerId = (0, re.V5)((0, re.L0)(ky + (0, re.NJ)((0, re.po)(9)))), this.peerIdBuffer = (0, re.fk)(this.peerId), typeof e.nodeId == "string" ? this.nodeId = e.nodeId : ArrayBuffer.isView(e.nodeId) ? this.nodeId = (0, re.V5)(e.nodeId) : this.nodeId = (0, re.V5)((0, re.po)(20)), this.nodeIdBuffer = (0, re.fk)(this.nodeId), this._debugId = this.peerId.substring(0, 7), this.destroyed = !1, this.listening = !1, this.torrentPort = e.torrentPort || 0, this.dhtPort = e.dhtPort || 0, this.tracker = e.tracker !== void 0 ? e.tracker : {}, this.lsd = e.lsd !== !1, this.utPex = e.utPex !== !1, this.natUpnp = e.natUpnp ?? !0, this.natPmp = e.natPmp ?? !0, this.torrents = [], this.maxConns = Number(e.maxConns) || 55, this.utp = yr.UTP_SUPPORT && e.utp !== !1, this.seedOutgoingConnections = e.seedOutgoingConnections ?? !0, this._downloadLimit = Math.max(typeof e.downloadLimit == "number" ? e.downloadLimit : -1, -1), this._uploadLimit = Math.max(typeof e.uploadLimit == "number" ? e.uploadLimit : -1, -1), (this.natUpnp || this.natPmp) && typeof lc == "function" && (this.natTraversal = new lc({ enableUPNP: this.natUpnp, enablePMP: this.natPmp, upnpPermanentFallback: e.natUpnp === "permanent" })), e.secure === !0 && Promise.resolve().then(ae.bind(ae, 5658)).then(({ enableSecure: i }) => i()), this._debug("new webtorrent (peerId %s, nodeId %s, port %s)", this.peerId, this.nodeId, this.torrentPort), this.throttleGroups = { down: new cc.ThrottleGroup({ rate: Math.max(this._downloadLimit, 0), enabled: this._downloadLimit >= 0 }), up: new cc.ThrottleGroup({ rate: Math.max(this._uploadLimit, 0), enabled: this._uploadLimit >= 0 }) }, this.tracker && (typeof this.tracker != "object" && (this.tracker = {}), globalThis.WRTC && !this.tracker.wrtc && (this.tracker.wrtc = globalThis.WRTC)), typeof Go == "function" ? this._connPool = new Go(this) : tt(() => {
      this._onListening();
    }), this._downloadSpeed = as(), this._uploadSpeed = as(), e.dht !== !1 && typeof rc.Client == "function" ? (this.dht = new rc.Client(Object.assign({}, { nodeId: this.nodeId }, e.dht)), this.dht.once("error", (i) => {
      this._destroy(i);
    }), this.dht.once("listening", () => {
      const i = this.dht.address();
      i && (this.dhtPort = i.port, this.natTraversal && this.natTraversal.map({ publicPort: this.dhtPort, privatePort: this.dhtPort, protocol: "udp", description: "WebTorrent DHT" }).catch((r) => {
        go("error mapping DHT port via UPnP/PMP: %o", r);
      }));
    }), this.dht.setMaxListeners(0), this.dht.listen(this.dhtPort)) : this.dht = !1, this.enableWebSeeds = e.webSeeds !== !1;
    const n = () => {
      this.destroyed || (this.ready = !0, this.emit("ready"));
    };
    typeof ic == "function" && e.blocklist != null ? ic(e.blocklist, { headers: { "user-agent": `WebTorrent/${hi} (https://webtorrent.io)` } }, (i, r) => {
      if (i) return console.error(`Failed to load blocklist: ${i.message}`);
      this.blocked = r, n();
    }) : tt(n);
  }
  createServer(e, n) {
    if (this.destroyed) throw new Error("torrent is destroyed");
    if (this._server) throw new Error("server already created");
    if (typeof window < "u" && n !== "node" || n === "browser") {
      if (!((e == null ? void 0 : e.controller) instanceof ServiceWorkerRegistration)) throw new Error("Invalid worker registration");
      if (e.controller.active.state !== "activated") throw new Error("Worker isn't activated");
      return this._server = new xy(this, e), this._server;
    }
    return this._server = new wy(this, e), this._server;
  }
  get downloadSpeed() {
    return this._downloadSpeed();
  }
  get uploadSpeed() {
    return this._uploadSpeed();
  }
  get progress() {
    const e = this.torrents.filter((n) => n.progress !== 1);
    return e.reduce((n, i) => n + i.downloaded, 0) / (e.reduce((n, i) => n + (i.length || 0), 0) || 1);
  }
  get ratio() {
    return this.torrents.reduce((e, n) => e + n.uploaded, 0) / (this.torrents.reduce((e, n) => e + n.received, 0) || 1);
  }
  async get(e) {
    if (e instanceof Ac) {
      if (this.torrents.includes(e)) return e;
    } else {
      const n = this.torrents;
      let i;
      try {
        i = await zi(e);
      } catch {
      }
      if (!i) return null;
      if (!i.infoHash) throw new Error("Invalid torrent identifier");
      for (const r of n) if (r.infoHash === i.infoHash) return r;
    }
    return null;
  }
  add(e, n = {}, i = () => {
  }) {
    if (this.destroyed) throw new Error("client is destroyed");
    typeof n == "function" && ([n, i] = [{}, n]);
    const r = () => {
      if (!this.destroyed) {
        for (const a of this.torrents) if (a.infoHash === o.infoHash && a !== o) return o._destroy(new Error(`Cannot add duplicate torrent ${o.infoHash}`)), void i(a);
      }
    }, s = () => {
      this.destroyed || (i(o), this.emit("torrent", o));
    };
    this._debug("add"), n = n ? Object.assign({}, n) : {};
    const o = new Ac(e, this, n);
    return this.torrents.push(o), o.once("_infoHash", r), o.once("ready", s), o.once("close", function a() {
      o.removeListener("_infoHash", r), o.removeListener("ready", s), o.removeListener("close", a);
    }), this.emit("add", o), o;
  }
  seed(e, n, i) {
    if (this.destroyed) throw new Error("client is destroyed");
    typeof n == "function" && ([n, i] = [{}, n]), this._debug("seed"), (n = n ? Object.assign({}, n) : {}).skipVerify = !0;
    const r = typeof e == "string";
    r && (n.path = function(c) {
      if (os(c), c.length === 0) return ".";
      let l = c.charCodeAt(0);
      const h = l === 47;
      let f = -1, d = !0;
      for (let p = c.length - 1; p >= 1; --p) if (l = c.charCodeAt(p), l === 47) {
        if (!d) {
          f = p;
          break;
        }
      } else d = !1;
      return f === -1 ? h ? "/" : "." : h && f === 1 ? "//" : c.slice(0, f);
    }(e)), n.createdBy || (n.createdBy = `WebTorrent/${mf}`);
    const s = (c) => {
      this._debug("on seed"), typeof i == "function" && i(c), c.emit("seed"), this.emit("seed", c);
    }, o = this.add(null, n, (c) => {
      const l = [(h) => {
        if (r || n.preloadedStore) return h();
        c.load(a, h);
      }];
      this.dht && l.push((h) => {
        c.once("dhtAnnounce", h);
      }), On(l, (h) => {
        if (!this.destroyed) return h ? c._destroy(h) : void s(c);
      });
    });
    let a;
    var u;
    return u = e, typeof FileList < "u" && u instanceof FileList ? e = Array.from(e) : Array.isArray(e) || (e = [e]), On(e.map((c) => async (l) => {
      if (!n.preloadedStore && function(h) {
        return typeof h == "object" && h != null && typeof h.pipe == "function";
      }(c)) {
        const h = [];
        try {
          for await (const d of c) h.push(d);
        } catch (d) {
          return l(d);
        }
        const f = (0, re.xW)(h);
        f.name = c.name, l(null, f);
      } else l(null, c);
    }), (c, l) => {
      if (!this.destroyed) return c ? o._destroy(c) : void function(h, f, d) {
        typeof f == "function" && ([f, d] = [d, f]), ef(h, f = f ? Object.assign({}, f) : {}, d);
      }(l, n, (h, f) => {
        if (!this.destroyed) {
          if (h) return o._destroy(h);
          a = f.map((d) => d.getStream), I_(l, n, async (d, p) => {
            if (this.destroyed) return;
            if (d) return o._destroy(d);
            const m = await this.get(p);
            m ? (console.warn("A torrent with the same id is already being seeded"), o._destroy(), typeof i == "function" && i(m)) : o._onTorrentId(p);
          });
        }
      });
    }), o;
  }
  async remove(e, n, i) {
    if (typeof n == "function") return this.remove(e, null, n);
    this._debug("remove");
    const r = await this.get(e);
    if (!r) throw new Error(`No torrent with id ${e}`);
    this._remove(r, n, i);
  }
  _remove(e, n, i) {
    if (!e) return;
    if (typeof n == "function") return this._remove(e, null, n);
    const r = this.torrents.indexOf(e);
    r !== -1 && (this.torrents.splice(r, 1), e.destroy(n, i), this.dht && this.dht._tables.remove(e.infoHash), this.emit("remove", e));
  }
  address() {
    return this.listening ? this._connPool ? this._connPool.tcpServer.address() : { address: "0.0.0.0", family: "IPv4", port: 0 } : null;
  }
  throttleDownload(e) {
    return e = Number(e), !(isNaN(e) || !isFinite(e) || e < -1) && (this._downloadLimit = e, this._downloadLimit < 0 ? this.throttleGroups.down.setEnabled(!1) : (this.throttleGroups.down.setEnabled(!0), void this.throttleGroups.down.setRate(this._downloadLimit)));
  }
  throttleUpload(e) {
    return e = Number(e), !(isNaN(e) || !isFinite(e) || e < -1) && (this._uploadLimit = e, this._uploadLimit < 0 ? this.throttleGroups.up.setEnabled(!1) : (this.throttleGroups.up.setEnabled(!0), void this.throttleGroups.up.setRate(this._uploadLimit)));
  }
  destroy(e) {
    if (this.destroyed) throw new Error("client already destroyed");
    this._destroy(null, e);
  }
  _destroy(e, n) {
    this._debug("client destroy"), this.destroyed = !0;
    const i = this.torrents.map((r) => (s) => {
      r.destroy(s);
    });
    this._connPool && i.push((r) => {
      this._connPool.destroy(r);
    }), this.dht && i.push((r) => {
      this.dht.destroy(r);
    }), this._server && i.push((r) => {
      this._server.destroy(r);
    }), this.natTraversal && i.push((r) => {
      this.natTraversal.destroy().then(() => r());
    }), On(i, n), e && this.emit("error", e), this.torrents = [], this._connPool = null, this.dht = null, this.throttleGroups.down.destroy(), this.throttleGroups.up.destroy();
  }
  _onListening() {
    if (this._debug("listening"), this.listening = !0, this._connPool) {
      const e = this._connPool.tcpServer.address();
      e && (this.torrentPort = e.port, this.natTraversal && this.natTraversal.map({ publicPort: this.torrentPort, privatePort: this.torrentPort, protocol: this.utp ? null : "tcp", description: "WebTorrent Torrent" }).catch((n) => {
        go("error mapping WebTorrent port via UPnP/PMP: %o", n);
      }));
    }
    this.emit("listening");
  }
  _debug() {
    const e = [].slice.call(arguments);
    e[0] = `[${this._debugId}] ${e[0]}`, go(...e);
  }
  async _getByHash(e) {
    for (const n of this.torrents) if (n.infoHashHash || (n.infoHashHash = await (0, re.tW)((0, re.fk)("72657132" + n.infoHash), "hex")), e === n.infoHashHash) return n;
    return null;
  }
}
yr.WEBRTC_SUPPORT = La.WEBRTC_SUPPORT, yr.UTP_SUPPORT = Go.UTP_SUPPORT, yr.VERSION = hi;
class Sy {
  constructor() {
    this.files = /* @__PURE__ */ new Map(), this.metadata = /* @__PURE__ */ new Map();
  }
  async getDirectoryHandle() {
    return this;
  }
  async getFileHandle(e, n = {}) {
    return !this.files.has(e) && n.create && this.files.set(e, null), {
      createWritable: async () => ({
        write: async (i) => {
          this.files.set(e, i);
        },
        close: async () => {
        }
      }),
      getFile: async () => {
        const i = this.files.get(e);
        return new File([i], e);
      }
    };
  }
  async removeEntry(e) {
    this.files.delete(e), this.metadata.delete(e);
  }
  entries() {
    return Array.from(this.files.keys()).map((e) => [e]);
  }
}
const Ay = [
  "udp://tracker.leechers-paradise.org:6969",
  "udp://tracker.coppersurfer.tk:6969",
  "udp://tracker.opentrackr.org:1337",
  "udp://explodie.org:6969",
  "udp://tracker.empire-js.us:1337",
  "wss://tracker.btorrent.xyz",
  "wss://tracker.openwebtorrent.com"
], Tc = Gt("trackers", Ay), Uv = ye(), Bn = ie(/* @__PURE__ */ new Map()), Di = ye(!1), Dc = ie({
  done: !1,
  progress: 0,
  downloadSpeed: 0,
  downloaded: 0
});
let bn = null, $n = null, ze = null;
function Hv() {
  async function t() {
    try {
      await navigator.storage.persist() || console.warn("Storage persistence denied");
      const v = await navigator.storage.estimate();
      return console.log(`Storage quota: ${v.quota} bytes`), console.log(`Storage usage: ${v.usage} bytes`), !0;
    } catch (g) {
      return console.error("Storage permission error:", g), !1;
    }
  }
  async function e() {
    try {
      if (!(await navigator.storage.estimate()).quota)
        throw new Error("Storage quota is 0, likely in private mode");
      if ("storage" in navigator && "getDirectory" in navigator.storage) {
        const v = await navigator.permissions.query({
          name: "persistent-storage"
        });
        if (v.state === "granted" || v.state === "prompt")
          return await t(), bn = await navigator.storage.getDirectory(), ze = await n(), !0;
      }
      throw new Error("Storage API not available or permission denied");
    } catch (g) {
      return console.warn("OPFS not available, falling back to in-memory storage:", g), bn = new Sy(), ze = bn, !0;
    }
  }
  async function n() {
    return await bn.getDirectoryHandle("files", { create: !0 });
  }
  function i(g) {
    const v = Tc.value.map((w) => `&tr=${encodeURIComponent(w)}`).join("");
    return `magnet:?xt=urn:btih:${g}${v}`;
  }
  function r(g) {
    return g.replace(/[^a-zA-Z0-9.-]/g, "_");
  }
  async function s(g) {
    try {
      const E = await (await (await ze.getFileHandle(`${g}.meta.json`)).getFile()).text();
      return JSON.parse(E);
    } catch {
      return null;
    }
  }
  async function o(g, v) {
    const E = await (await ze.getFileHandle(`${g}.meta.json`, { create: !0 })).createWritable();
    await E.write(JSON.stringify(v)), await E.close();
  }
  async function a() {
    try {
      await e(), $n = new yr(), $n.on("download", (g) => {
        const v = $n.torrents[$n.torrents.length - 1];
        v && Object.assign(Dc, {
          done: v.done,
          progress: v.progress,
          downloaded: v.downloaded,
          downloadSpeed: v.downloadSpeed
        });
      }), Di.value = !0, await c();
    } catch (g) {
      return console.error("Torrent system initialization failed:", g), !1;
    }
  }
  async function u(g, v) {
    const w = r(g.name);
    try {
      const A = await (await ze.getFileHandle(w, { create: !0 })).createWritable(), C = await g.arrayBuffer();
      return await A.write(C), await A.close(), await o(w, {
        originalName: g.name,
        type: g.type || "application/octet-stream",
        lastModified: Date.now(),
        infoHash: v
      }), w;
    } catch (E) {
      return console.error("Error caching downloaded file:", E), null;
    }
  }
  async function c() {
    if (ze)
      for await (const [g] of ze.entries()) {
        if (g.endsWith(".meta.json")) continue;
        const v = await s(g);
        if (!v) continue;
        const w = await p(g);
        if (w) {
          const E = new File([w], v.originalName, {
            type: v.type
          }), A = v.infoHash ? { infoHash: v.infoHash } : void 0;
          await l(E, g, A);
        }
      }
  }
  async function l(g, v, w = {}) {
    return new Promise((E) => {
      $n.seed([g], w, (A) => {
        Bn.set(v, {
          file: g,
          torrent: A,
          info: {
            infoHash: A.infoHash,
            magnetURI: A.magnetURI,
            name: A.name,
            length: A.length
          }
        }), E(Bn.get(v));
      });
    });
  }
  async function h(g) {
    Di.value || await a();
    const v = [];
    for (const w of g) {
      const E = await d(w);
      if (E) {
        const A = await l(w, E);
        v.push(A);
      }
    }
    return v;
  }
  async function f(g) {
    const v = Bn.get(g);
    v != null && v.torrent && v.torrent.destroy(), await (ze == null ? void 0 : ze.removeEntry(g)), await (ze == null ? void 0 : ze.removeEntry(`${g}.meta.json`).catch(() => {
    })), Bn.delete(g);
  }
  async function d(g) {
    if (!ze) return null;
    try {
      const v = r(g.name), E = await (await ze.getFileHandle(v, { create: !0 })).createWritable();
      return await E.write(g), await E.close(), await o(v, {
        originalName: g.name,
        type: g.type,
        lastModified: g.lastModified
      }), v;
    } catch (v) {
      return console.error("Error saving to OPFS:", v), null;
    }
  }
  async function p(g) {
    if (!ze) return null;
    try {
      return await (await ze.getFileHandle(g)).getFile();
    } catch (v) {
      return console.error("Error loading from OPFS:", v), null;
    }
  }
  async function m(g) {
    if (!ze) return null;
    for await (const [v] of ze.entries()) {
      if (v.endsWith(".meta.json")) continue;
      const w = await s(v);
      if ((w == null ? void 0 : w.infoHash) === g) {
        const E = await p(v);
        if (E) {
          const A = new File([E], w.originalName, {
            type: w.type
          });
          return A.path = w.originalName, A.length = E.size, A.progress = 1, A.downloaded = E.size, A.blob = async () => new Blob([await A.arrayBuffer()], { type: A.type }), A;
        }
      }
    }
    return null;
  }
  async function _(g) {
    Di.value || await a();
    const v = await m(g);
    return v ? (console.log("File found in cache, returning without download"), [v]) : new Promise(async (w) => {
      function E(C) {
        const O = C.files.map((R) => (R.blob = () => new Promise((P, k) => {
          const S = [], x = R.createReadStream();
          x.on("data", (I) => S.push(I)), x.on("end", () => {
            const I = new Blob(S, { type: R.type || "application/octet-stream" });
            P(I);
          }), x.on("error", k);
        }), R));
        C.on("done", async () => {
          for (const R of O)
            await u(R, C.infoHash);
        }), w(O);
      }
      let A = await $n.get(g);
      if (A)
        E(A);
      else {
        const C = i(g);
        $n.add(C, E);
      }
    });
  }
  async function y() {
    if (ze) {
      for (const [g, v] of Bn)
        v != null && v.torrent && v.torrent.destroy();
      Bn.clear();
      try {
        for await (const [g] of ze.entries())
          await ze.removeEntry(g);
        console.log("Files directory cleared successfully");
      } catch (g) {
        throw console.error("Error clearing files directory:", g), g;
      }
    }
  }
  async function b() {
    if (bn) {
      await y();
      try {
        for await (const [g, v] of bn.entries())
          v.kind === "file" ? await bn.removeEntry(g) : v.kind === "directory" && await bn.removeEntry(g, { recursive: !0 });
        console.log("OPFS cleared successfully");
      } catch (g) {
        throw console.error("Error clearing OPFS:", g), g;
      }
    }
  }
  return {
    files: Bn,
    initialized: Di,
    downloadStatus: Dc,
    init: a,
    upload: h,
    download: _,
    deleteFile: f,
    trackers: Tc,
    clearFiles: y,
    clearOPFS: b
  };
}
function qv() {
  const t = ue(), e = ie({});
  return t.user(ne.pub).get(Ye).map().once((n, i) => {
    t.get("#" + Ye).get(i.slice(0, -88)).once((r, s) => {
      try {
        const o = JSON.parse(r);
        e[s] = o;
      } catch {
      }
    });
  }), { gifts: e };
}
function Wv() {
  const { user: t } = Re(), e = ue(), n = ie({}), i = ie({}), r = ie({});
  e.user().get(Ye).map().on((o, a) => {
    e.get("#" + Ye).get(a).once((u) => {
      try {
        u = JSON.parse(u), n[a] = u, u.from == t.pub && (i[a] = u), u.to == t.pub && (r[a] = u);
      } catch (c) {
        console.log(c);
      }
    });
  });
  const s = ie({});
  return e.user(ne.pub).get(Ye).map().once(async (o, a) => {
    let u = a.slice(0, -88);
    e.get("#" + Ye).get(u).once(async (c) => {
      try {
        c = JSON.parse(c), c.to == t.pub && (await e.user().get(Ye).get(u).then() || (s[u] = c));
      } catch (l) {
        console.log(l);
      }
    });
  }), { gifts: n, from: i, to: r, newGifts: s };
}
function Vv(t) {
  const e = t.slice(-87), n = ue(), i = ie({});
  n.user(e).get(Ye).map().once((s, o) => {
    n.get("#" + Ye).get(o).once((a) => {
      try {
        a = JSON.parse(a), a.project == t && (i[o] = { ...a, state: {} }, n.user(a.from).get(Ye).get(o).on((u) => {
          i[o].state.from = u;
        }), n.user(a.to).get(Ye).get(o).on((u) => {
          i[o].state.to = u;
        }));
      } catch (u) {
        console.log(u);
      }
    });
  });
  const r = te(() => {
    let s = {};
    for (let o in i) {
      let a = i[o];
      s[a.ql] = s[a.ql] || {
        list: {},
        sum: 0,
        from: {}
      }, s[a.ql].list[o] = a;
    }
    for (let o in s) {
      s[o].sum = 0, s[o].from = {};
      for (let a in s[o].list) {
        let u = s[o].list[a];
        u.state.from && u.state.to && (s[o].sum += Number(u.qn), s[o].from[u.from] = s[o].from[u.from] || 0, s[o].from[u.from] += Number(u.qn));
      }
    }
    return s;
  });
  return { gifts: i, collections: r };
}
const Ey = Xl("deep"), Gv = ie({
  pub: ""
}), xe = ie({
  initiated: !1,
  auth: !1,
  is: null,
  name: "",
  pub: te(() => {
    var t;
    return (t = xe == null ? void 0 : xe.is) == null ? void 0 : t.pub;
  }),
  color: te(() => xe.pub ? Ey.hex(xe.pub) : "gray"),
  pulse: 0,
  pulser: null,
  blink: !1,
  safe: {
    saved: !1,
    password: "",
    enc: "",
    pass: ""
  },
  rooms: {},
  db: void 0,
  pair() {
    return console.warn("User pair read externally"), zr();
  },
  async encrypt(t) {
    return await Ve.encrypt(t, zr());
  },
  async decrypt(t) {
    return await Ve.decrypt(t, zr());
  },
  async secret(t) {
    return await Ve.secret(t, zr());
  }
});
let Cy = 0;
function zr() {
  var e, n;
  return console.log("User pair read", ++Cy), (n = (e = ue().user()) == null ? void 0 : e._) == null ? void 0 : n.sea;
}
function Re() {
  if (!xe.initiated) {
    const t = ue();
    xe.db = t.user(), t.user().recall({ sessionStorage: !0 }, () => {
      console.log("user was recalled");
    }), t.on("auth", () => {
      const e = ue();
      xe.is = e.user().is, xe.pulser && clearInterval(xe.pulser), xe.pulser = setInterval(() => {
        e.user().get("pulse").put(Date.now());
      }, 1e3), e.user().get("epub").put(xe.is.epub), e.user().get("pulse").on((n) => {
        xe.blink = !xe.blink, xe.pulse = n;
      }), e.user().get("safe").map().on((n, i) => {
        xe.safe[i] = n;
      }), e.user().get("profile").get("name").on((n) => xe.name = n), e.user().get("my_rooms").map().on(async (n, i) => {
        let r = await Ve.decrypt(i, xe.pair());
        xe.rooms[r] = n;
      });
    }), xe.initiated = !0;
  }
  return { user: xe, auth: As, leave: Ty };
}
async function As(t, e = (n) => {
}) {
  const n = ue();
  if (!gf(t)) {
    console.log("incorrect pair", t);
    return;
  }
  n.user().auth(t, async () => {
    e(t), console.log("user is authenticated");
  });
}
function Ty() {
  var n;
  const t = ue();
  let e = !!((n = xe.is) != null && n.pub);
  xe.initiated = !1, clearInterval(xe.pulser), t.user().leave(), setTimeout(() => {
    e && !zr() && (xe.is = null, console.info("User logged out"));
  }, 500);
}
function Kv(t) {
  if (t)
    return t.slice(1, 88) == xe.pub;
}
function Zv(t) {
  ue().user().get("profile").get(t).put("");
}
function Jv(t, e) {
  t && e !== void 0 && ue().user().get("profile").get(t).put(e);
}
function gf(t) {
  return !!(t && typeof t == "object" && t.pub && t.epub && t.priv && t.epriv);
}
function Yv(t, e = 42) {
  const n = Co(t), i = Co(e), r = ye(), s = ye(), o = ue();
  return Ge(
    n,
    (a) => {
      r.value = oh({ pub: a, size: i.value * 4 });
    },
    { immediate: !0 }
  ), o.user(n.value).get("avatar").on((a) => {
    a && o.get("#avatars").get(a).once((u) => {
      r.value = u;
    });
  }), o.user(n.value).get("pulse").on(() => {
    s.value = !s.value;
  }), {
    avatar: r,
    blink: s
  };
}
function Xv() {
  const { user: t } = Re(), e = ue(), n = ye(null);
  t.db.get("avatar").once((s) => {
    s ? e.get("#avatars").get(s).once((o) => {
      n.value = o;
    }) : n.value = null;
  });
  async function i(s) {
    if (s) {
      const o = await hn(s);
      e.get("#avatars").get(o).put(s), t.db.get("avatar").put(o);
    } else
      r();
  }
  function r() {
    t.db.get("avatar").put(null);
  }
  return {
    remove: r,
    upload: i,
    avatar: n
  };
}
function Qv(t) {
  const e = ue(), n = ie({}), i = ie({
    from: !1,
    to: !1,
    complete: te(() => i.from && i.to),
    status: te(
      () => i.from ? i.to ? "complete" : "proposed" : "canceled"
    )
  });
  return e.get("#" + Ye).get(t).once((r, s) => {
    try {
      Object.assign(n, JSON.parse(r)), e.user(n.from).get(Ye).get(s).on((o) => {
        i.from = o;
      }), e.user(n.to).get(Ye).get(s).on((o) => {
        i.to = o;
      });
    } catch {
    }
  }), { gift: n, state: i };
}
async function ew(t, e = !0) {
  const { user: n } = Re();
  n.db.get(Ye).get(t).put(e);
}
function tw(t) {
  const { user: e } = Re(), { now: n, pause: i } = X0({ interval: 1e3, controls: !0 }), r = ie({
    from: te(() => e == null ? void 0 : e.pub),
    to: "",
    qn: null,
    ql: null,
    wish: "",
    project: "",
    date: te(() => n.value.getTime()),
    room: te(() => ne.pub)
  }), s = te(() => {
    let f = Ma(r);
    return f.qn = Number(f.qn), f;
  }), o = ["from", "to", "qn", "ql"], a = te(() => o.reduce((d, p) => d && r[p], !0));
  Ge(r, (f) => {
    f.project && (r.to = f.project.slice(-87));
  });
  const u = Zl(async () => {
    const { hash: f } = await es(s.value);
    return f;
  }), c = ye(!1);
  Object.assign(r, t);
  const l = ue();
  async function h() {
    var p;
    const { hash: f, hashed: d } = await es(s.value);
    console.log(f, d), l.get("#" + Ye).get(f).put(d), l.user().get(Ye).get(f).put("proposed", () => {
      i(), c.value = !0;
    }), (p = ne.features) != null && p.gifts && l.user(ne.pub).get(Ye).get(`${f}@${e.pub}`).put(
      !0,
      () => {
        console.log(`gift ${f} published`);
      },
      {
        opt: { cert: ne.features.gifts }
      }
    );
  }
  return { gift: r, cleanGift: s, valid: a, propose: h, proposed: c, hash: u };
}
function Ma(t) {
  return Object.entries(t).filter(([e, n]) => !!n).reduce(
    (e, [n, i]) => ({
      ...e,
      [n]: i === Object(i) ? Ma(i) : i
    }),
    {}
  );
}
const Ye = "gifts";
function nw(t) {
  const e = ue(), { user: n } = Re(), i = ye(""), r = ye({}), s = Zl(
    async () => Object.entries(r.value || {}).sort(([, u], [, c]) => ((u == null ? void 0 : u.timestamp) || 0) - ((c == null ? void 0 : c.timestamp) || 0)).map(([, u]) => u),
    [],
    // default value while computing
    { debounce: 200 }
  );
  e.user(t).get("epub").once((u) => i.value = u), e.user(t).get("messages").get(n.pub).map().once(function(u, c) {
    this.map().on(async (l, h) => r.value[h] = await o(l, c, t));
  }), e.user().get("messages").get(t).map().once(function(u, c) {
    this.map().on(async (l, h) => r.value[h] = await o(l, c, n.pub));
  });
  async function o(u, c, l) {
    if (typeof u != "number" && u && u.startsWith("SEA")) {
      const h = await Ve.decrypt(
        u,
        await Ve.work(
          await n.secret(i.value),
          void 0,
          void 0,
          { salt: c }
        )
      );
      return !h || typeof h != "object" ? void 0 : {
        timestamp: h.timestamp,
        author: l,
        text: h.text
      };
    }
  }
  return ie({
    epub: i,
    messages: r,
    sorted: s,
    send: Dy
  });
}
function rw(t) {
  const e = ue(), { user: n } = Re(), i = ie({}), r = ye(!1);
  return e.user(t).get("epub").on((o) => r.value = o), e.user(t).get("messages").get(n.pub).map().map().on((o, a) => {
    o && !o.startsWith("SEA") || (i[a] = o);
  }), e.user().get("messages").get(t).map().map().on((o, a) => {
    o && !o.startsWith("SEA") || (i[a] = o);
  }), { count: te(() => Object.keys(i).length), available: r };
}
async function Dy(t, e) {
  if (!t || typeof e != "string" || e.trim() === "") return;
  const n = ue(), { user: i } = Re(), r = /* @__PURE__ */ new Date(), s = await n.user(t).get("epub").then(), o = r.toLocaleDateString("en-CA"), a = await Ve.encrypt(
    {
      timestamp: r.getTime(),
      text: e
    },
    await Ve.work(
      await i.secret(s),
      void 0,
      void 0,
      { salt: o }
    )
  );
  n.user().get("messages").get(t).get(o).set(a);
}
function iw() {
  const t = ue(), { user: e } = Re(), n = ie({});
  return e.is && (t.user().get("messages").map().on((i, r) => {
    n[r] = i;
  }), t.user().get("mates").map().on(async (i, r) => {
    await t.user(r).get("epub").then() && (n[r] = i);
  })), n;
}
function sw(t) {
  const { user: e } = Re(), n = ie({
    id: dh(6),
    title: t,
    type: "project",
    status: "new",
    public: !0,
    funding: !1,
    room: te(() => ne.pub),
    author: te(() => e.pub)
  });
  async function i(r) {
    const s = ue(), o = s.user().get("projects").get(n.id).put(n, () => {
      var a;
      n.public && (s.user(ne.pub).get("projects").get(n.id + "@" + e.pub).put(
        o,
        () => {
          console.log("added project"), r && r();
        },
        {
          opt: { cert: (a = ne.features) == null ? void 0 : a.projects }
        }
      ), n.title = "", n.id = "");
    });
  }
  return { newProject: n, addProject: i };
}
function bf(t, e, n) {
  const r = ue().user().get("projects").get(t);
  r.get(e).put(n, () => {
    r.get("updated").put(Date.now());
  });
}
function ow(t) {
  const e = ue(), n = ie({
    id: "0",
    type: "event"
  });
  e.user(ne.pub).get("projects").get(t).map().on(async (s, o) => {
    o == "cover" && ka(s) ? n[o] = await e.get("#cover").get(s).then() : n[o] = s;
  });
  function i(s, o) {
    bf(t.slice(0, -88), s, o);
  }
  async function r(s) {
    const o = await hn(s);
    o && (e.get("#cover").get(o).put(s), i("cover", o));
  }
  return { project: n, updateField: i, updateCover: r };
}
function aw(t = ye()) {
  const e = ue(), n = te(() => {
    const s = ie({
      id: ""
    });
    return e.user(ne.pub).get("projects").get(t.value).map().on(async (o, a) => {
      a == "cover" && ka(o) ? s[a] = await e.get("#cover").get(o).then() : s[a] = o;
    }), s;
  });
  function i(s, o) {
    bf(t.value.slice(0, -88), s, o);
  }
  async function r(s) {
    const o = await hn(s);
    o && (e.get("#cover").get(o).put(s), i("cover", o));
  }
  return { project: n, updateField: i, updateCover: r };
}
async function uw(t) {
  var r;
  const e = ue(), n = hm(), { user: i } = Re();
  if (t.includes(i.pub))
    e.user(ne.pub).get("projects").get(t).put(null, void 0, {
      opt: { cert: (r = ne.features) == null ? void 0 : r.projects }
    });
  else if (ne.hosts[i.pub]) {
    const s = await i.decrypt(ne.hosts[i.pub].enc);
    n.user().auth(s, () => {
      n.user().get("projects").get(t).put(null);
    });
  }
  console.error("Can't delete the project");
}
function cw(t = ne.pub) {
  const e = ye(""), n = ie({}), i = te(() => {
    const o = Object.entries(n).map((a) => ({
      ...a[1],
      path: a[0]
    }));
    return new fn(o, {
      includeScore: !0,
      ignoreLocation: !0,
      keys: ["title"]
    });
  }), r = te(() => e.value ? i.value.search(e.value) : Object.entries(n).map((o) => ({
    item: { ...o[1], path: o[0] }
  }))), s = ue();
  return s.user(t).get("projects").map().on((o, a) => {
    if (o == null) {
      delete n[a];
      return;
    }
    const u = { ...o, path: a };
    delete u._, n[a] = u, ka(u == null ? void 0 : u.cover) && s.get("#cover").get(u.cover).on((c) => n[a].cover = c);
  }), { projects: n, search: e, candidates: r };
}
function lw(t = ne.pub) {
  const e = ie({});
  return ue().user(t).get("projects").map().on((i, r) => {
    if (i == null) {
      delete e[r];
      return;
    }
    e[r] = !0;
  }), te(() => Object.keys(e).length);
}
function Xo() {
  return Xo = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Xo.apply(this, arguments);
}
function Fy(t, e) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function Fc(t, e) {
  return {
    x: t.x - e,
    y: t.y - e,
    w: t.w + 2 * e,
    h: t.h + 2 * e
  };
}
function Oc(t, e) {
  return t.x > e.x && t.x < e.x + e.w && t.y > e.y && t.y < e.y + e.h;
}
function Ic(t, e, n, i) {
  switch (i === void 0 && (i = 50), n) {
    case "top":
      return {
        x: t.x,
        y: Math.min((t.y + e.y) / 2, t.y - i)
      };
    case "bottom":
      return {
        x: t.x,
        y: Math.max((t.y + e.y) / 2, t.y + i)
      };
    case "left":
      return {
        x: Math.min((t.x + e.x) / 2, t.x - i),
        y: t.y
      };
    case "right":
      return {
        x: Math.max((t.x + e.x) / 2, t.x + i),
        y: t.y
      };
  }
}
function Pc(t) {
  switch (t) {
    case "left":
      return 0;
    case "top":
      return 90;
    case "right":
      return 180;
    case "bottom":
      return 270;
  }
}
function Oy(t, e, n, i, r, s, o, a, u) {
  for (var c = Xo({
    padStart: 0,
    padEnd: 0,
    controlPointStretch: 50,
    allowedStartSides: ["top", "right", "bottom", "left"],
    allowedEndSides: ["top", "right", "bottom", "left"]
  }, u), l = {
    x: t,
    y: e,
    w: n,
    h: i
  }, h = {
    x: t + n / 2,
    y: e - 2 * c.padStart
  }, f = {
    x: t + n / 2,
    y: e + i + 2 * c.padStart
  }, d = {
    x: t - 2 * c.padStart,
    y: e + i / 2
  }, p = {
    x: t + n + 2 * c.padStart,
    y: e + i / 2
  }, m = {
    x: r,
    y: s,
    w: o,
    h: a
  }, _ = {
    x: r + o / 2,
    y: s - 2 * c.padEnd
  }, y = {
    x: r + o / 2,
    y: s + a + 2 * c.padEnd
  }, b = {
    x: r - 2 * c.padEnd,
    y: s + a / 2
  }, g = {
    x: r + o + 2 * c.padEnd,
    y: s + a / 2
  }, v = ["top", "right", "bottom", "left"], w = c.allowedStartSides.length > 0 ? c.allowedStartSides : v, E = c.allowedEndSides.length > 0 ? c.allowedEndSides : v, A = {
    top: h,
    right: p,
    bottom: f,
    left: d
  }, C = {
    top: _,
    right: g,
    bottom: y,
    left: b
  }, O = 1 / 0, R = h, P = _, k = "top", S = "top", x = 15, I = 0; I < w.length; I++) {
    var F = w[I], T = A[F];
    if (!Oc(T, Fc(m, x)))
      for (var L = 0; L < E.length; L++) {
        var M = E[L], U = C[M];
        if (!Oc(U, Fc(l, x))) {
          var $ = Fy(T, U);
          $ < O && (O = $, R = T, P = U, k = F, S = M);
        }
      }
  }
  var z = Ic(R, P, k, c.controlPointStretch), X = Ic(P, R, S, c.controlPointStretch);
  return [R.x, R.y, z.x, z.y, X.x, X.y, P.x, P.y, Pc(S), Pc(k)];
}
function Iy(t, e, n, i, r) {
  return Oy(t, e, 0, 0, n, i, 0, 0, r);
}
function Py(t, e, n) {
  if (Vt(t))
    return te(() => Ms(De(t), De(e), De(n)));
  const i = ye(t);
  return te({
    get() {
      return i.value = Ms(i.value, De(e), De(n));
    },
    set(r) {
      i.value = Ms(r, De(e), De(n));
    }
  });
}
function hw({ TIMEOUT: t = 1e4, randomness: e = 0.1 } = {}) {
  const n = ye(), { area: i, mouse: r } = tp(n), { width: s, height: o } = W0(n), a = ie([0, 0]), u = Py(1, 0.5, 2), c = ue(), { user: l } = Re(), h = ie({
    title: "space",
    joined: !1,
    db: te(() => c.user(ne.pub).get("space")),
    cert: te(() => {
      var A;
      return (A = ne.features) == null ? void 0 : A.space;
    }),
    my: {
      mouse: te(() => ({ x: r.x, y: r.y })),
      pos: null
    }
  });
  async function f() {
    h.joined = !0;
  }
  function d({ x: A = r.x, y: C = r.y } = {}) {
    var O;
    l.pub && (h.joined || f(), a[0] = A, a[1] = C, h.db.get(l.pub).get("pos").put(JSON.stringify({ x: A, y: C }), null, {
      opt: { cert: (O = ne.features) == null ? void 0 : O.space }
    }));
  }
  const p = G0("Shift"), m = te(() => p.value ? 100 : 10);
  gi("ArrowUp", () => {
    d({ x: a[0], y: a[1] - m.value });
  }), gi("ArrowDown", () => {
    d({ x: a[0], y: a[1] + m.value });
  }), gi("ArrowLeft", () => {
    d({ x: a[0] - m.value, y: a[1] });
  }), gi("ArrowRight", () => {
    d({ x: a[0] + m.value, y: a[1] });
  });
  function _(A = "") {
    var C;
    l.pub && (h.joined || f(), h.db.get(l.pub).get("status").put(A, null, {
      opt: { cert: (C = ne.features) == null ? void 0 : C.space }
    }));
  }
  const y = ie({}), b = ie({}), g = ie({}), v = te(() => {
    var C;
    const A = {};
    for (let O in y)
      Date.now() - ((C = y[O]) == null ? void 0 : C.pulse) < t && (A[O] = y[O]);
    return A;
  }), w = te(() => Object.keys(v.value).length);
  h.db.map().once(async (A, C) => {
    C == l.pub && (h.joined = !0);
    const O = {
      pub: C,
      draw: "",
      status: "",
      blink: !1,
      pulse: 0,
      hasPos: !1,
      pos: {
        x: 0,
        y: 0
      }
    };
    y[C] = O, h.db.get(C).get("pos").on((R) => {
      y[C].hasPos = !0, y[C].pos = typeof R == "string" ? JSON.parse(R) : R;
    }), h.db.get(C).get("draw").on((R) => {
      y[C].draw = R;
    }), h.db.get(C).get("status").on((R) => {
      y[C].status = R;
    }), c.user(C).get("pulse").on((R) => {
      y[C].pulse = Number(R), y[C].blink = !y[C].blink;
    }).back().get("mates").map().on((R, P) => {
      b[C] = b[C] || {}, b[C][P] = R;
    });
  });
  const E = {};
  return nr(() => {
    for (let A in b) {
      E[A] = E[A] || {};
      for (let C in b[A]) {
        let O = E[A][C] = E[A][C] || Math.random() * e;
        if (b[A][C]) {
          const R = b[A][C];
          let P = y[A], k = y[C], S = Date.now() * 2 - (P == null ? void 0 : P.pulse) - (k == null ? void 0 : k.pulse);
          P && k && (P != null && P.hasPos) && (k != null && k.hasPos) && S < t && (g[A + C] = {
            user: A,
            mate: C,
            emoji: kr(R),
            from: P.pos,
            to: k.pos,
            arrow: Ry(P.pos, k.pos, O)
          });
        } else
          delete g[A + C];
      }
    }
  }), {
    space: h,
    allGuests: y,
    guests: v,
    guestCount: w,
    links: g,
    plane: n,
    width: s,
    height: o,
    pos: a,
    zoom: u,
    area: i,
    join: f,
    place: d,
    setStatus: _
  };
}
function Ry(t, e, n = 0) {
  let i = Iy(t.x, t.y, e.x, e.y, {
    padEnd: 20,
    padStart: 10
  });
  const [r, s, o, a, u, c, l, h, f, d] = i;
  return {
    sx: r,
    sy: s,
    c1x: o * (1 - n + 2 * n),
    c1y: a * (1 - n + 2 * n),
    c2x: u * (1 - n + 2 * n),
    c2y: c * (1 - n + 2 * n),
    ex: l,
    ey: h,
    ae: f,
    as: d
  };
}
var Ly = Object.defineProperty, Rc = Object.getOwnPropertySymbols, My = Object.prototype.hasOwnProperty, jy = Object.prototype.propertyIsEnumerable, Lc = (t, e, n) => e in t ? Ly(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Qo = (t, e) => {
  for (var n in e || (e = {}))
    My.call(e, n) && Lc(t, n, e[n]);
  if (Rc)
    for (var n of Rc(e))
      jy.call(e, n) && Lc(t, n, e[n]);
  return t;
}, Ny = () => ({
  emit(t, ...e) {
    for (let n = this.events[t] || [], i = 0, r = n.length; i < r; i++)
      n[i](...e);
  },
  events: {},
  on(t, e) {
    var n;
    return ((n = this.events)[t] || (n[t] = [])).push(e), () => {
      var i;
      this.events[t] = (i = this.events[t]) == null ? void 0 : i.filter((r) => e !== r);
    };
  }
});
function cs(t, e) {
  return t - e;
}
function By(t) {
  return t < 0 ? -1 : 1;
}
function ls(t) {
  return [Math.abs(t), By(t)];
}
function _f() {
  const t = () => ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  return `${t() + t()}-${t()}-${t()}-${t()}-${t()}${t()}${t()}`;
}
var $y = 2, tn = $y;
function yf(t, e) {
  const n = document.createElementNS("http://www.w3.org/2000/svg", "defs"), i = document.createElementNS("http://www.w3.org/2000/svg", "marker"), r = document.createElementNS("http://www.w3.org/2000/svg", "path");
  return r.setAttribute("fill", e), i.setAttribute("id", t), i.setAttribute("viewBox", "0 -5 10 10"), i.setAttribute("refX", "5"), i.setAttribute("refY", "0"), i.setAttribute("markerWidth", "4"), i.setAttribute("markerHeight", "4"), i.setAttribute("orient", "auto"), r.setAttribute("d", "M0,-5L10,0L0,5"), i.appendChild(r), n.appendChild(i), n;
}
function zy(t, e) {
  const n = t.x - e.x, i = t.y - e.y;
  return n * n + i * i;
}
function Uy(t, e, n) {
  let i = e.x, r = e.y, s = n.x - i, o = n.y - r;
  if (s !== 0 || o !== 0) {
    const a = ((t.x - i) * s + (t.y - r) * o) / (s * s + o * o);
    a > 1 ? (i = n.x, r = n.y) : a > 0 && (i += s * a, r += o * a);
  }
  return s = t.x - i, o = t.y - r, s * s + o * o;
}
function Hy(t, e) {
  let n = t[0];
  const i = [n];
  let r;
  for (let s = 1, o = t.length; s < o; s++)
    r = t[s], zy(r, n) > e && (i.push(r), n = r);
  return n !== r && r && i.push(r), i;
}
function ea(t, e, n, i, r) {
  let s = i, o = 0;
  for (let a = e + 1; a < n; a++) {
    const u = Uy(t[a], t[e], t[n]);
    u > s && (o = a, s = u);
  }
  s > i && (o - e > 1 && ea(t, e, o, i, r), r.push(t[o]), n - o > 1 && ea(t, o, n, i, r));
}
function qy(t, e) {
  const n = t.length - 1, i = [t[0]];
  return ea(t, 0, n, e, i), i.push(t[n]), i;
}
function Mc(t, e, n = !1) {
  if (t.length <= 2)
    return t;
  const i = e * e;
  return t = n ? t : Hy(t, i), t = qy(t, i), t;
}
var Cr = class {
  constructor(t) {
    this.drauu = t, this.event = void 0, this.point = void 0, this.start = void 0, this.el = null;
  }
  onSelected(t) {
  }
  onUnselected() {
  }
  onStart(t) {
  }
  onMove(t) {
    return !1;
  }
  onEnd(t) {
  }
  get brush() {
    return this.drauu.brush;
  }
  get shiftPressed() {
    return this.drauu.shiftPressed;
  }
  get altPressed() {
    return this.drauu.altPressed;
  }
  get svgElement() {
    return this.drauu.el;
  }
  getMousePosition(t) {
    var e, n, i, r;
    const s = this.drauu.el, o = (e = this.drauu.options.cssZoom) != null ? e : 1, a = (n = this.drauu.options.coordinateScale) != null ? n : 1, u = (i = this.drauu.options.offset) != null ? i : { x: 0, y: 0 };
    if (this.drauu.options.coordinateTransform === !1) {
      const c = this.drauu.el.getBoundingClientRect();
      return {
        x: (t.pageX / o - c.left + u.x) * a,
        y: (t.pageY / o - c.top + u.y) * a,
        pressure: t.pressure
      };
    } else {
      const c = this.drauu.svgPoint;
      c.x = t.clientX / o + u.x, c.y = t.clientY / o + u.y;
      const l = c.matrixTransform((r = s.getScreenCTM()) == null ? void 0 : r.inverse());
      return {
        x: l.x * a,
        y: l.y * a,
        pressure: t.pressure
      };
    }
  }
  createElement(t, e) {
    var n;
    const i = document.createElementNS("http://www.w3.org/2000/svg", t), r = e ? Qo(Qo({}, this.brush), e) : this.brush;
    return i.setAttribute("fill", (n = r.fill) != null ? n : "transparent"), i.setAttribute("stroke", r.color), i.setAttribute("stroke-width", r.size.toString()), i.setAttribute("stroke-linecap", "round"), r.dasharray && i.setAttribute("stroke-dasharray", r.dasharray), i;
  }
  attr(t, e) {
    this.el.setAttribute(t, typeof e == "string" ? e : e.toFixed(tn));
  }
  _setEvent(t) {
    this.event = t, this.point = this.getMousePosition(t);
  }
  /**
   * @internal
   */
  _eventDown(t) {
    return this._setEvent(t), this.start = this.point, this.onStart(this.point);
  }
  /**
   * @internal
   */
  _eventMove(t) {
    return this._setEvent(t), this.onMove(this.point);
  }
  /**
   * @internal
   */
  _eventUp(t) {
    return this._setEvent(t), this.onEnd(this.point);
  }
}, Wy = class qn extends Cr {
  constructor() {
    super(...arguments), this.points = [], this.count = 0;
  }
  onStart(e) {
    if (this.el = this.createElement("path", { fill: "transparent" }), this.points = [e], this.brush.arrowEnd) {
      this.arrowId = _f();
      const n = yf(this.arrowId, this.brush.color);
      this.el.appendChild(n);
    }
    return this.el;
  }
  onMove(e) {
    return this.el || this.onStart(e), this.points[this.points.length - 1] !== e && (this.points.push(e), this.count += 1), this.count > 5 && (this.points = Mc(this.points, 1, !0), this.count = 0), this.attr("d", qn.toSvgData(this.points)), !0;
  }
  onEnd() {
    const e = this.el;
    if (this.el = null, !e)
      return !1;
    if (e.setAttribute("d", qn.toSvgData(Mc(this.points, 1, !0))), !e.getTotalLength()) {
      const { x: n, y: i } = this.points[0], r = this.brush.size / 2;
      e.setAttribute("d", `M ${n - r} ${i} a ${r},${r} 0 1,0 ${r * 2},0 a ${r},${r} 0 1,0 ${-r * 2},0`), e.setAttribute("fill", this.brush.color), e.setAttribute("stroke-width", "0");
    }
    return !0;
  }
  // https://francoisromain.medium.com/smooth-a-svg-path-with-cubic-bezier-curves-e37b49d46c74
  static line(e, n) {
    const i = n.x - e.x, r = n.y - e.y;
    return {
      length: Math.sqrt(i ** 2 + r ** 2),
      angle: Math.atan2(r, i)
    };
  }
  static controlPoint(e, n, i, r) {
    const s = n || e, o = i || e, a = 0.2, u = qn.line(s, o), c = u.angle + (r ? Math.PI : 0), l = u.length * a, h = e.x + Math.cos(c) * l, f = e.y + Math.sin(c) * l;
    return { x: h, y: f };
  }
  static bezierCommand(e, n, i) {
    const r = qn.controlPoint(i[n - 1], i[n - 2], e), s = qn.controlPoint(e, i[n - 1], i[n + 1], !0);
    return `C ${r.x.toFixed(tn)},${r.y.toFixed(tn)} ${s.x.toFixed(tn)},${s.y.toFixed(tn)} ${e.x.toFixed(tn)},${e.y.toFixed(tn)}`;
  }
  static toSvgData(e) {
    return e.reduce(
      (n, i, r, s) => r === 0 ? `M ${i.x.toFixed(tn)},${i.y.toFixed(tn)}` : `${n} ${qn.bezierCommand(i, r, s)}`,
      ""
    );
  }
}, Vy = class extends Cr {
  onStart(t) {
    return this.el = this.createElement("ellipse"), this.attr("cx", t.x), this.attr("cy", t.y), this.el;
  }
  onMove(t) {
    if (!this.el || !this.start)
      return !1;
    let [e, n] = ls(t.x - this.start.x), [i, r] = ls(t.y - this.start.y);
    if (this.shiftPressed) {
      const s = Math.min(e, i);
      e = s, i = s;
    }
    if (this.altPressed)
      this.attr("cx", this.start.x), this.attr("cy", this.start.y), this.attr("rx", e), this.attr("ry", i);
    else {
      const [s, o] = [this.start.x, this.start.x + e * n].sort(cs), [a, u] = [this.start.y, this.start.y + i * r].sort(cs);
      this.attr("cx", (s + o) / 2), this.attr("cy", (a + u) / 2), this.attr("rx", (o - s) / 2), this.attr("ry", (u - a) / 2);
    }
    return !0;
  }
  onEnd() {
    const t = this.el;
    if (this.el = null, !t)
      return !1;
    try {
      if (!t.getTotalLength())
        return !1;
    } catch {
      return !1;
    }
    return !0;
  }
}, Gy = class extends Cr {
  constructor() {
    super(...arguments), this.pathSubFactor = 20, this.pathFragments = [], this._erased = [];
  }
  onSelected(t) {
    const e = (n, i) => {
      if (n && n.length)
        for (let r = 0; r < n.length; r++) {
          const s = n[r];
          if (s.getTotalLength) {
            const o = s.getTotalLength();
            for (let a = 0; a < this.pathSubFactor; a++) {
              const u = s.getPointAtLength(o * a / this.pathSubFactor), c = s.getPointAtLength(o * (a + 1) / this.pathSubFactor);
              this.pathFragments.push({
                x1: u.x,
                x2: c.x,
                y1: u.y,
                y2: c.y,
                segment: a,
                element: i || s
              });
            }
          } else
            s.children && e(s.children, s);
        }
    };
    t && e(t.children);
  }
  onUnselected() {
    this.pathFragments = [];
  }
  onStart(t) {
    this.svgPointPrevious = this.svgElement.createSVGPoint(), this.svgPointPrevious.x = t.x, this.svgPointPrevious.y = t.y;
  }
  onMove(t) {
    this.svgPointCurrent = this.svgElement.createSVGPoint(), this.svgPointCurrent.x = t.x, this.svgPointCurrent.y = t.y;
    const e = this.checkAndEraseElement();
    return this.svgPointPrevious = this.svgPointCurrent, e;
  }
  onEnd() {
    this.svgPointPrevious = void 0, this.svgPointCurrent = void 0;
    const t = this._erased;
    return this._erased = [], {
      undo: () => t.forEach((e) => this.drauu._restoreNode(e)),
      redo: () => t.forEach((e) => this.drauu._removeNode(e))
    };
  }
  checkAndEraseElement() {
    if (this.pathFragments.length)
      for (let t = 0; t < this.pathFragments.length; t++) {
        const e = this.pathFragments[t];
        if (this.svgPointPrevious && this.svgPointCurrent) {
          const n = {
            x1: this.svgPointPrevious.x,
            x2: this.svgPointCurrent.x,
            y1: this.svgPointPrevious.y,
            y2: this.svgPointCurrent.y
          };
          this.lineLineIntersect(e, n) && (this.drauu._removeNode(e.element), this._erased.push(e.element));
        }
      }
    return this._erased.length && (this.pathFragments = this.pathFragments.filter((t) => !this._erased.includes(t.element))), this._erased.length > 0;
  }
  lineLineIntersect(t, e) {
    const n = t.x1, i = t.x2, r = e.x1, s = e.x2, o = t.y1, a = t.y2, u = e.y1, c = e.y2, l = (n - i) * (u - c) - (o - a) * (r - s), h = (n * a - o * i) * (r - s) - (n - i) * (r * c - u * s), f = (n * a - o * i) * (u - c) - (o - a) * (r * c - u * s), d = (p, m, _) => p >= m && p <= _ ? !0 : p >= _ && p <= m;
    if (l === 0)
      return !1;
    {
      const p = {
        x: h / l,
        y: f / l
      };
      return d(p.x, n, i) && d(p.y, o, a) && d(p.x, r, s) && d(p.y, u, c);
    }
  }
}, Ky = class extends Cr {
  onStart(t) {
    if (this.el = this.createElement("line", { fill: "transparent" }), this.attr("x1", t.x), this.attr("y1", t.y), this.attr("x2", t.x), this.attr("y2", t.y), this.brush.arrowEnd) {
      const e = _f(), n = document.createElementNS("http://www.w3.org/2000/svg", "g");
      return n.append(yf(e, this.brush.color)), n.append(this.el), this.attr("marker-end", `url(#${e})`), n;
    }
    return this.el;
  }
  onMove(t) {
    if (!this.el)
      return !1;
    let { x: e, y: n } = t;
    if (this.shiftPressed) {
      const i = t.x - this.start.x, r = t.y - this.start.y;
      if (r !== 0) {
        let s = i / r;
        s = Math.round(s), Math.abs(s) <= 1 ? (e = this.start.x + r * s, n = this.start.y + r) : (e = this.start.x + i, n = this.start.y);
      }
    }
    return this.altPressed ? (this.attr("x1", this.start.x * 2 - e), this.attr("y1", this.start.y * 2 - n), this.attr("x2", e), this.attr("y2", n)) : (this.attr("x1", this.start.x), this.attr("y1", this.start.y), this.attr("x2", e), this.attr("y2", n)), !0;
  }
  onEnd() {
    const t = this.el;
    if (this.el = null, !t)
      return !1;
    try {
      if (t.getTotalLength() < 5)
        return !1;
    } catch {
      return !1;
    }
    return !0;
  }
}, Zy = class extends Cr {
  onStart(t) {
    return this.el = this.createElement("rect"), this.brush.cornerRadius && (this.attr("rx", this.brush.cornerRadius), this.attr("ry", this.brush.cornerRadius)), this.attr("x", t.x), this.attr("y", t.y), this.el;
  }
  onMove(t) {
    if (!this.el || !this.start)
      return !1;
    let [e, n] = ls(t.x - this.start.x), [i, r] = ls(t.y - this.start.y);
    if (this.shiftPressed) {
      const s = Math.min(e, i);
      e = s, i = s;
    }
    if (this.altPressed)
      this.attr("x", this.start.x - e), this.attr("y", this.start.y - i), this.attr("width", e * 2), this.attr("height", i * 2);
    else {
      const [s, o] = [this.start.x, this.start.x + e * n].sort(cs), [a, u] = [this.start.y, this.start.y + i * r].sort(cs);
      this.attr("x", s), this.attr("y", a), this.attr("width", o - s), this.attr("height", u - a);
    }
    return !0;
  }
  onEnd() {
    const t = this.el;
    if (this.el = null, !t)
      return !1;
    try {
      if (!t.getTotalLength())
        return !1;
    } catch {
      return !1;
    }
    return !0;
  }
};
function jc(t, e, n, i = (r) => r) {
  return t * i(0.5 - e * (0.5 - n));
}
function Jy(t) {
  return [-t[0], -t[1]];
}
function Et(t, e) {
  return [t[0] + e[0], t[1] + e[1]];
}
function pt(t, e) {
  return [t[0] - e[0], t[1] - e[1]];
}
function At(t, e) {
  return [t[0] * e, t[1] * e];
}
function Yy(t, e) {
  return [t[0] / e, t[1] / e];
}
function Mr(t) {
  return [t[1], -t[0]];
}
function Nc(t, e) {
  return t[0] * e[0] + t[1] * e[1];
}
function Xy(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}
function Qy(t) {
  return Math.hypot(t[0], t[1]);
}
function e2(t) {
  return t[0] * t[0] + t[1] * t[1];
}
function Bc(t, e) {
  return e2(pt(t, e));
}
function vf(t) {
  return Yy(t, Qy(t));
}
function t2(t, e) {
  return Math.hypot(t[1] - e[1], t[0] - e[0]);
}
function jr(t, e, n) {
  let i = Math.sin(n), r = Math.cos(n), s = t[0] - e[0], o = t[1] - e[1], a = s * r - o * i, u = s * i + o * r;
  return [a + e[0], u + e[1]];
}
function ta(t, e, n) {
  return Et(t, At(pt(e, t), n));
}
function $c(t, e, n) {
  return Et(t, At(e, n));
}
var { min: cr, PI: n2 } = Math, zc = 0.275, Nr = n2 + 1e-4;
function r2(t, e = {}) {
  let { size: n = 16, smoothing: i = 0.5, thinning: r = 0.5, simulatePressure: s = !0, easing: o = (T) => T, start: a = {}, end: u = {}, last: c = !1 } = e, { cap: l = !0, easing: h = (T) => T * (2 - T) } = a, { cap: f = !0, easing: d = (T) => --T * T * T + 1 } = u;
  if (t.length === 0 || n <= 0) return [];
  let p = t[t.length - 1].runningLength, m = a.taper === !1 ? 0 : a.taper === !0 ? Math.max(n, p) : a.taper, _ = u.taper === !1 ? 0 : u.taper === !0 ? Math.max(n, p) : u.taper, y = Math.pow(n * i, 2), b = [], g = [], v = t.slice(0, 10).reduce((T, L) => {
    let M = L.pressure;
    if (s) {
      let U = cr(1, L.distance / n), $ = cr(1, 1 - U);
      M = cr(1, T + ($ - T) * (U * zc));
    }
    return (T + M) / 2;
  }, t[0].pressure), w = jc(n, r, t[t.length - 1].pressure, o), E, A = t[0].vector, C = t[0].point, O = C, R = C, P = O, k = !1;
  for (let T = 0; T < t.length; T++) {
    let { pressure: L } = t[T], { point: M, vector: U, distance: $, runningLength: z } = t[T];
    if (T < t.length - 1 && p - z < 3) continue;
    if (r) {
      if (s) {
        let Ae = cr(1, $ / n), ke = cr(1, 1 - Ae);
        L = cr(1, v + (ke - v) * (Ae * zc));
      }
      w = jc(n, r, L, o);
    } else w = n / 2;
    E === void 0 && (E = w);
    let X = z < m ? h(z / m) : 1, J = p - z < _ ? d((p - z) / _) : 1;
    w = Math.max(0.01, w * Math.min(X, J));
    let K = (T < t.length - 1 ? t[T + 1] : t[T]).vector, be = T < t.length - 1 ? Nc(U, K) : 1, Fe = Nc(U, A) < 0 && !k, de = be !== null && be < 0;
    if (Fe || de) {
      let Ae = At(Mr(A), w);
      for (let ke = 1 / 13, Le = 0; Le <= 1; Le += ke) R = jr(pt(M, Ae), M, Nr * Le), b.push(R), P = jr(Et(M, Ae), M, Nr * -Le), g.push(P);
      C = R, O = P, de && (k = !0);
      continue;
    }
    if (k = !1, T === t.length - 1) {
      let Ae = At(Mr(U), w);
      b.push(pt(M, Ae)), g.push(Et(M, Ae));
      continue;
    }
    let ge = At(Mr(ta(K, U, be)), w);
    R = pt(M, ge), (T <= 1 || Bc(C, R) > y) && (b.push(R), C = R), P = Et(M, ge), (T <= 1 || Bc(O, P) > y) && (g.push(P), O = P), v = L, A = U;
  }
  let S = t[0].point.slice(0, 2), x = t.length > 1 ? t[t.length - 1].point.slice(0, 2) : Et(t[0].point, [1, 1]), I = [], F = [];
  if (t.length === 1) {
    if (!(m || _) || c) {
      let T = $c(S, vf(Mr(pt(S, x))), -(E || w)), L = [];
      for (let M = 1 / 13, U = M; U <= 1; U += M) L.push(jr(T, S, Nr * 2 * U));
      return L;
    }
  } else {
    if (!(m || _ && t.length === 1)) if (l) for (let L = 1 / 13, M = L; M <= 1; M += L) {
      let U = jr(g[0], S, Nr * M);
      I.push(U);
    }
    else {
      let L = pt(b[0], g[0]), M = At(L, 0.5), U = At(L, 0.51);
      I.push(pt(S, M), pt(S, U), Et(S, U), Et(S, M));
    }
    let T = Mr(Jy(t[t.length - 1].vector));
    if (_ || m && t.length === 1) F.push(x);
    else if (f) {
      let L = $c(x, T, w);
      for (let M = 1 / 29, U = M; U < 1; U += M) F.push(jr(L, x, Nr * 3 * U));
    } else F.push(Et(x, At(T, w)), Et(x, At(T, w * 0.99)), pt(x, At(T, w * 0.99)), pt(x, At(T, w)));
  }
  return b.concat(F, g.reverse(), I);
}
function i2(t, e = {}) {
  var n;
  let { streamline: i = 0.5, size: r = 16, last: s = !1 } = e;
  if (t.length === 0) return [];
  let o = 0.15 + (1 - i) * 0.85, a = Array.isArray(t[0]) ? t : t.map(({ x: d, y: p, pressure: m = 0.5 }) => [d, p, m]);
  if (a.length === 2) {
    let d = a[1];
    a = a.slice(0, -1);
    for (let p = 1; p < 5; p++) a.push(ta(a[0], d, p / 4));
  }
  a.length === 1 && (a = [...a, [...Et(a[0], [1, 1]), ...a[0].slice(2)]]);
  let u = [{ point: [a[0][0], a[0][1]], pressure: a[0][2] >= 0 ? a[0][2] : 0.25, vector: [1, 1], distance: 0, runningLength: 0 }], c = !1, l = 0, h = u[0], f = a.length - 1;
  for (let d = 1; d < a.length; d++) {
    let p = s && d === f ? a[d].slice(0, 2) : ta(h.point, a[d], o);
    if (Xy(h.point, p)) continue;
    let m = t2(p, h.point);
    if (l += m, d < f && !c) {
      if (l < r) continue;
      c = !0;
    }
    h = { point: p, pressure: a[d][2] >= 0 ? a[d][2] : 0.5, vector: vf(pt(h.point, p)), distance: m, runningLength: l }, u.push(h);
  }
  return u[0].vector = ((n = u[1]) == null ? void 0 : n.vector) || [0, 0], u;
}
function s2(t, e = {}) {
  return r2(i2(t, e), e);
}
var o2 = class wf extends Cr {
  constructor() {
    super(...arguments), this.points = [];
  }
  onStart(e) {
    return this.el = document.createElementNS("http://www.w3.org/2000/svg", "path"), this.points = [e], this.attr("fill", this.brush.color), this.attr("d", this.getSvgData(this.points)), this.el;
  }
  onMove(e) {
    return this.el || this.onStart(e), this.points[this.points.length - 1] !== e && this.points.push(e), this.attr("d", this.getSvgData(this.points)), !0;
  }
  onEnd() {
    const e = this.el;
    return this.el = null, !!e;
  }
  getSvgData(e) {
    return wf.getSvgData(e, this.brush);
  }
  static getSvgData(e, n) {
    const i = s2(e, Qo({
      size: n.size,
      thinning: 0.9,
      simulatePressure: !1,
      start: {
        taper: 5
      },
      end: {
        taper: 5
      }
    }, n.stylusOptions));
    if (!i.length)
      return "";
    const r = i.reduce(
      (s, [o, a], u, c) => {
        const [l, h] = c[(u + 1) % c.length];
        return s.push(o, a, (o + l) / 2, (a + h) / 2), s;
      },
      ["M", ...i[0], "Q"]
    );
    return r.push("Z"), r.map((s) => typeof s == "number" ? s.toFixed(2) : s).join(" ");
  }
};
function a2(t) {
  return {
    draw: new Wy(t),
    stylus: new o2(t),
    line: new Ky(t),
    rectangle: new Zy(t),
    ellipse: new Vy(t),
    eraseLine: new Gy(t)
  };
}
var u2 = class {
  constructor(t = {}) {
    this.options = t, this.el = null, this.svgPoint = null, this.eventEl = null, this.shiftPressed = !1, this.altPressed = !1, this.drawing = !1, this._emitter = Ny(), this._originalPointerId = null, this._models = a2(this), this._opStack = [], this._opIndex = 0, this._disposables = [], this._elements = [], this.options.brush || (this.options.brush = { color: "black", size: 3, mode: "stylus" }), t.el && this.mount(t.el, t.eventTarget, t.window);
  }
  get model() {
    return this._models[this.mode];
  }
  get mounted() {
    return !!this.el;
  }
  get mode() {
    return this.options.brush.mode || "stylus";
  }
  set mode(t) {
    this._models[this.mode].onUnselected(), this.options.brush.mode = t, this.model.onSelected(this.el);
  }
  get brush() {
    return this.options.brush;
  }
  set brush(t) {
    this.options.brush = t;
  }
  resolveSelector(t) {
    return typeof t == "string" ? document.querySelector(t) : t || null;
  }
  mount(t, e, n = window) {
    if (this.el)
      throw new Error("[drauu] already mounted, unmount previous target first");
    if (this.el = this.resolveSelector(t), !this.el)
      throw new Error("[drauu] target element not found");
    if (this.el.tagName.toLocaleLowerCase() !== "svg")
      throw new Error("[drauu] can only mount to a SVG element");
    if (!this.el.createSVGPoint)
      throw new Error("[drauu] SVG element must be create by document.createElementNS('http://www.w3.org/2000/svg', 'svg')");
    this.svgPoint = this.el.createSVGPoint();
    const i = this.resolveSelector(e) || this.el, r = this.eventStart.bind(this), s = this.eventMove.bind(this), o = this.eventEnd.bind(this), a = this.eventKeyboard.bind(this);
    i.addEventListener("pointerdown", r, { passive: !1 }), n.addEventListener("pointermove", s, { passive: !1 }), n.addEventListener("pointerup", o, { passive: !1 }), n.addEventListener("pointercancel", o, { passive: !1 }), n.addEventListener("keydown", a, !1), n.addEventListener("keyup", a, !1), this._disposables.push(() => {
      i.removeEventListener("pointerdown", r), n.removeEventListener("pointermove", s), n.removeEventListener("pointerup", o), n.removeEventListener("pointercancel", o), n.removeEventListener("keydown", a, !1), n.removeEventListener("keyup", a, !1);
    }), this._emitter.emit("mounted");
  }
  unmount() {
    this._disposables.forEach((t) => t()), this._disposables.length = 0, this._elements.length = 0, this.el = null, this._emitter.emit("unmounted");
  }
  on(t, e) {
    return this._emitter.on(t, e);
  }
  undo() {
    return !this.canUndo() || this.drawing ? !1 : (this._opStack[--this._opIndex].undo(), this._emitter.emit("changed"), !0);
  }
  redo() {
    return !this.canRedo() || this.drawing ? !1 : (this._opStack[this._opIndex++].redo(), this._emitter.emit("changed"), !0);
  }
  canRedo() {
    return this._opIndex < this._opStack.length;
  }
  canUndo() {
    return this._opIndex > 0;
  }
  eventMove(t) {
    !this.acceptsInput(t) || !this.drawing || this.model._eventMove(t) && (t.stopPropagation(), t.preventDefault(), this._emitter.emit("changed"));
  }
  eventStart(t) {
    this.acceptsInput(t) && (t.stopPropagation(), t.preventDefault(), this._currentNode && this.cancel(), this.drawing = !0, this._originalPointerId = t.pointerId, this._emitter.emit("start"), this._currentNode = this.model._eventDown(t), this._currentNode && this.mode !== "eraseLine" && this.el.appendChild(this._currentNode), this._emitter.emit("changed"));
  }
  eventEnd(t) {
    if (!this.acceptsInput(t) || !this.drawing)
      return;
    const e = this.model._eventUp(t);
    if (!e)
      this.cancel();
    else if (e === !0) {
      const n = this._currentNode;
      n && (this._appendNode(n), this.commit({
        undo: () => this._removeNode(n),
        redo: () => this._restoreNode(n)
      }));
    } else
      this.commit(e);
    this.drawing = !1, this._emitter.emit("end"), this._emitter.emit("changed"), this._originalPointerId = null;
  }
  acceptsInput(t) {
    return (!this.options.acceptsInputTypes || this.options.acceptsInputTypes.includes(t.pointerType)) && !(this._originalPointerId && this._originalPointerId !== t.pointerId);
  }
  eventKeyboard(t) {
    this.shiftPressed === t.shiftKey && this.altPressed === t.altKey || (this.shiftPressed = t.shiftKey, this.altPressed = t.altKey, this.model.point && this.model.onMove(this.model.point) && this._emitter.emit("changed"));
  }
  commit(t) {
    this._opStack.length = this._opIndex, this._opStack.push(t), this._opIndex++;
    const e = this._currentNode;
    this._currentNode = void 0, this._emitter.emit("committed", e);
  }
  clear() {
    this._opStack.length = 0, this._opIndex = 0, this._elements = [], this.cancel(), this.el.innerHTML = "", this._emitter.emit("changed");
  }
  cancel() {
    this._currentNode && (this.el.removeChild(this._currentNode), this._currentNode = void 0, this._emitter.emit("canceled"));
  }
  dump() {
    return this.el.innerHTML;
  }
  load(t) {
    this.clear(), this.el.innerHTML = t;
  }
  /**
   * @internal
   */
  _appendNode(t) {
    const e = this._elements.at(-1);
    e ? e.after(t) : this.el.append(t);
    const n = this._elements.push(t) - 1;
    t.dataset.drauu_index = n.toString();
  }
  /**
   * @internal
   */
  _removeNode(t) {
    t.remove(), this._elements[+t.dataset.drauu_index] = null;
  }
  /**
   * @internal
   */
  _restoreNode(t) {
    const e = +t.dataset.drauu_index;
    this._elements[e] = t;
    for (let n = e - 1; n >= 0; n--) {
      const i = this._elements[n];
      if (i) {
        i.after(t);
        return;
      }
    }
    this.el.prepend(t);
  }
};
function c2(t) {
  return new u2(t);
}
const He = ie({
  colors: [
    "#000000",
    ...new Array(12).fill(!0).map((t, e) => `hsl(${e * 30}, 100%,50%)`),
    "#ffffff"
  ],
  sizes: z0([4, 8, 16, 24]),
  modes: ["line", "arrow", "stylus", "rectangle", "ellipse"],
  mode: te({
    get() {
      return Uc.value;
    },
    set(t) {
      Uc.value = t, t === "arrow" ? (Kn.mode = "line", Kn.arrowEnd = !0) : (Kn.mode = t, Kn.arrowEnd = !1);
    }
  }),
  enabled: !1,
  pinned: Gt("drawing-pinned", !1),
  canUndo: !1,
  canRedo: !1,
  canClear: !1,
  ing: !1,
  initiated: !1,
  content: "",
  clear: () => {
  }
}), Kn = d0(
  Gt("drawing-brush", {
    color: He.colors[0],
    size: 10,
    mode: "stylus",
    arrowEnd: !1
  })
), Uc = ye("stylus");
let na = !1;
const l2 = ie({
  brush: Kn,
  acceptsInputTypes: te(() => He.enabled ? void 0 : ["pen"])
}), qe = hd(c2(l2));
function Fi() {
  na = !0, He.content != null ? qe.load(He.content) : qe == null || qe.clear(), na = !1;
}
function h2() {
  var t;
  He.canRedo = qe.canRedo(), He.canUndo = qe.canUndo(), He.canClear = !!((t = qe.el) != null && t.children.length);
}
function fw() {
  if (!He.initiated) {
    const t = ue(), { user: e } = Re(), n = t.user(ne.pub).get("space").get(e.pub).get("draw");
    n.on((s) => {
      He.ing || (He.content = s, Fi());
    });
    const i = Gl(() => {
      var s;
      if (h2(), !na) {
        let o = qe.dump();
        He.content = o, n.put(o, void 0, {
          opt: { cert: (s = ne.features) == null ? void 0 : s.space }
        });
      }
    }, 200);
    qe.on("changed", i), Md(() => {
      _s(() => {
        Fi();
      });
    }), Ge(
      () => ne.pub,
      (s) => {
        qe == null || qe.clear(), He.content = "", Fi();
      }
    ), qe.on("start", () => He.ing = !0), qe.on("end", () => He.ing = !1), He.clear = () => {
      var s;
      qe == null || qe.clear(), He.content = "", n.put("", void 0, {
        opt: { cert: (s = ne.features) == null ? void 0 : s.space }
      });
    };
    const r = [];
    window.addEventListener(
      "keydown",
      (s) => {
        if (!He.enabled) return;
        const o = !s.ctrlKey && !s.altKey && !s.shiftKey && !s.metaKey;
        let a = !0;
        s.code === "KeyZ" && (s.ctrlKey || s.metaKey) ? s.shiftKey ? qe.redo() : qe.undo() : s.code === "Escape" ? He.enabled = !1 : s.code === "KeyC" && (s.ctrlKey || s.metaKey) ? He.clear() : s.code.startsWith("Digit") && o && +s.code[5] <= r.length ? Kn.color = r[+s.code[5] - 1] : a = !1, a && (s.preventDefault(), s.stopPropagation());
      },
      !1
    );
  }
  return He.initiated = !0, {
    brush: Kn,
    draw: He,
    drauu: qe,
    loadCanvas: Fi
  };
}
const xf = { trie: "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", classes: { Other: 0, Prepend: 1, CR: 2, LF: 3, Control: 4, Extend: 5, Regional_Indicator: 6, SpacingMark: 7, L: 8, V: 9, T: 10, LV: 11, LVT: 12, ZWJ: 13, ExtPict: 14 } };
var ja = 0, kf = -3;
function ri() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function f2(t, e) {
  this.source = t, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = e, this.destLen = 0, this.ltree = new ri(), this.dtree = new ri();
}
var Sf = new ri(), Af = new ri(), Na = new Uint8Array(30), Ba = new Uint16Array(30), Ef = new Uint8Array(30), Cf = new Uint16Array(30), d2 = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), Hc = new ri(), Ft = new Uint8Array(320);
function Tf(t, e, n, i) {
  var r, s;
  for (r = 0; r < n; ++r) t[r] = 0;
  for (r = 0; r < 30 - n; ++r) t[r + n] = r / n | 0;
  for (s = i, r = 0; r < 30; ++r)
    e[r] = s, s += 1 << t[r];
}
function p2(t, e) {
  var n;
  for (n = 0; n < 7; ++n) t.table[n] = 0;
  for (t.table[7] = 24, t.table[8] = 152, t.table[9] = 112, n = 0; n < 24; ++n) t.trans[n] = 256 + n;
  for (n = 0; n < 144; ++n) t.trans[24 + n] = n;
  for (n = 0; n < 8; ++n) t.trans[168 + n] = 280 + n;
  for (n = 0; n < 112; ++n) t.trans[176 + n] = 144 + n;
  for (n = 0; n < 5; ++n) e.table[n] = 0;
  for (e.table[5] = 32, n = 0; n < 32; ++n) e.trans[n] = n;
}
var qc = new Uint16Array(16);
function bo(t, e, n, i) {
  var r, s;
  for (r = 0; r < 16; ++r) t.table[r] = 0;
  for (r = 0; r < i; ++r) t.table[e[n + r]]++;
  for (t.table[0] = 0, s = 0, r = 0; r < 16; ++r)
    qc[r] = s, s += t.table[r];
  for (r = 0; r < i; ++r)
    e[n + r] && (t.trans[qc[e[n + r]]++] = r);
}
function m2(t) {
  t.bitcount-- || (t.tag = t.source[t.sourceIndex++], t.bitcount = 7);
  var e = t.tag & 1;
  return t.tag >>>= 1, e;
}
function $t(t, e, n) {
  if (!e)
    return n;
  for (; t.bitcount < 24; )
    t.tag |= t.source[t.sourceIndex++] << t.bitcount, t.bitcount += 8;
  var i = t.tag & 65535 >>> 16 - e;
  return t.tag >>>= e, t.bitcount -= e, i + n;
}
function ra(t, e) {
  for (; t.bitcount < 24; )
    t.tag |= t.source[t.sourceIndex++] << t.bitcount, t.bitcount += 8;
  var n = 0, i = 0, r = 0, s = t.tag;
  do
    i = 2 * i + (s & 1), s >>>= 1, ++r, n += e.table[r], i -= e.table[r];
  while (i >= 0);
  return t.tag = s, t.bitcount -= r, e.trans[n + i];
}
function g2(t, e, n) {
  var i, r, s, o, a, u;
  for (i = $t(t, 5, 257), r = $t(t, 5, 1), s = $t(t, 4, 4), o = 0; o < 19; ++o) Ft[o] = 0;
  for (o = 0; o < s; ++o) {
    var c = $t(t, 3, 0);
    Ft[d2[o]] = c;
  }
  for (bo(Hc, Ft, 0, 19), a = 0; a < i + r; ) {
    var l = ra(t, Hc);
    switch (l) {
      case 16:
        var h = Ft[a - 1];
        for (u = $t(t, 2, 3); u; --u)
          Ft[a++] = h;
        break;
      case 17:
        for (u = $t(t, 3, 3); u; --u)
          Ft[a++] = 0;
        break;
      case 18:
        for (u = $t(t, 7, 11); u; --u)
          Ft[a++] = 0;
        break;
      default:
        Ft[a++] = l;
        break;
    }
  }
  bo(e, Ft, 0, i), bo(n, Ft, i, r);
}
function Wc(t, e, n) {
  for (; ; ) {
    var i = ra(t, e);
    if (i === 256)
      return ja;
    if (i < 256)
      t.dest[t.destLen++] = i;
    else {
      var r, s, o, a;
      for (i -= 257, r = $t(t, Na[i], Ba[i]), s = ra(t, n), o = t.destLen - $t(t, Ef[s], Cf[s]), a = o; a < o + r; ++a)
        t.dest[t.destLen++] = t.dest[a];
    }
  }
}
function b2(t) {
  for (var e, n, i; t.bitcount > 8; )
    t.sourceIndex--, t.bitcount -= 8;
  if (e = t.source[t.sourceIndex + 1], e = 256 * e + t.source[t.sourceIndex], n = t.source[t.sourceIndex + 3], n = 256 * n + t.source[t.sourceIndex + 2], e !== (~n & 65535))
    return kf;
  for (t.sourceIndex += 4, i = e; i; --i)
    t.dest[t.destLen++] = t.source[t.sourceIndex++];
  return t.bitcount = 0, ja;
}
function Vc(t, e) {
  var n = new f2(t, e), i, r, s;
  do {
    switch (i = m2(n), r = $t(n, 2, 0), r) {
      case 0:
        s = b2(n);
        break;
      case 1:
        s = Wc(n, Sf, Af);
        break;
      case 2:
        g2(n, n.ltree, n.dtree), s = Wc(n, n.ltree, n.dtree);
        break;
      default:
        s = kf;
    }
    if (s !== ja)
      throw new Error("Data error");
  } while (!i);
  return n.destLen < n.dest.length ? typeof n.dest.slice == "function" ? n.dest.slice(0, n.destLen) : n.dest.subarray(0, n.destLen) : n.dest;
}
p2(Sf, Af);
Tf(Na, Ba, 4, 3);
Tf(Ef, Cf, 2, 1);
Na[28] = 0;
Ba[28] = 258;
const _2 = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, Gc = (t, e, n) => {
  let i = t[e];
  t[e] = t[n], t[n] = i;
}, y2 = (t) => {
  const e = t.length;
  for (let n = 0; n < e; n += 4)
    Gc(t, n, n + 3), Gc(t, n + 1, n + 2);
}, v2 = (t) => {
  _2 && y2(t);
}, w2 = {
  swap32LE: v2
}, x2 = w2.swap32LE, $a = 11, Qn = 5, k2 = $a - Qn, S2 = 65536 >> $a, A2 = 1 << k2, E2 = A2 - 1, Ui = 2, C2 = 1 << Qn, _o = C2 - 1, Df = 65536 >> Qn, T2 = 1024 >> Qn, D2 = Df + T2, F2 = D2, O2 = 32, I2 = F2 + O2, P2 = 1 << Ui;
class R2 {
  constructor(e) {
    const n = typeof e.readUInt32BE == "function" && typeof e.slice == "function";
    if (n || e instanceof Uint8Array) {
      let i;
      if (n)
        this.highStart = e.readUInt32LE(0), this.errorValue = e.readUInt32LE(4), i = e.readUInt32LE(8), e = e.slice(12);
      else {
        const r = new DataView(e.buffer);
        this.highStart = r.getUint32(0, !0), this.errorValue = r.getUint32(4, !0), i = r.getUint32(8, !0), e = e.subarray(12);
      }
      e = Vc(e, new Uint8Array(i)), e = Vc(e, new Uint8Array(i)), x2(e), this.data = new Uint32Array(e.buffer);
    } else
      ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = e);
  }
  get(e) {
    let n;
    return e < 0 || e > 1114111 ? this.errorValue : e < 55296 || e > 56319 && e <= 65535 ? (n = (this.data[e >> Qn] << Ui) + (e & _o), this.data[n]) : e <= 65535 ? (n = (this.data[Df + (e - 55296 >> Qn)] << Ui) + (e & _o), this.data[n]) : e < this.highStart ? (n = this.data[I2 - S2 + (e >> $a)], n = this.data[n + (e >> Qn & E2)], n = (n << Ui) + (e & _o), this.data[n]) : this.data[this.data.length - P2];
  }
}
const Kc = xf.trie, { Other: Zc, Prepend: Jc, CR: yo, LF: vo, Control: Yc, Extend: Oi, Regional_Indicator: nn, SpacingMark: L2, L: Xc, V: wo, T: xo, LV: Qc, LVT: el, ZWJ: lr, ExtPict: Ii } = xf.classes;
let Hi = null;
if (globalThis.window) {
  const t = window.atob(Kc);
  Hi = new Uint8Array(t.length);
  for (let e = 0; e < t.length; e++)
    Hi[e] = t.charCodeAt(e);
} else
  Hi = Buffer.from(Kc, "base64");
const hs = new R2(Hi), tl = function(t, e) {
  const n = t.charCodeAt(e);
  if (55296 <= n && n <= 56319) {
    const i = n, r = t.charCodeAt(e + 1);
    return 56320 <= r && r <= 57343 ? (i - 55296) * 1024 + (r - 56320) + 65536 : i;
  }
  if (56320 <= n && n <= 57343) {
    const i = t.charCodeAt(e - 1), r = n;
    return 55296 <= i && i <= 56319 ? (i - 55296) * 1024 + (r - 56320) + 65536 : r;
  }
  return n;
}, za = function(t, e) {
  let n, i;
  return 55296 <= (n = t.charCodeAt(e)) && n <= 56319 && 56320 <= (i = t.charCodeAt(e + 1)) && i <= 57343;
}, Pe = {
  NotBreak: 0,
  BreakStart: 1,
  Break: 2,
  BreakLastRegional: 3,
  BreakPenultimateRegional: 4
}, Ff = function(t, e, n, i) {
  const r = [e].concat(n).concat([i]), s = t ? e : r[r.length - 2], o = t ? r[1] : i;
  let a = r.lastIndexOf(nn);
  if (a > 0 && r.slice(1, a).every((u) => u === nn) && s !== Jc && s !== nn)
    return r.filter((u) => u === nn).length % 2 === 1 ? Pe.BreakLastRegional : Pe.BreakPenultimateRegional;
  if (s === yo && o === vo)
    return Pe.NotBreak;
  if (s === Yc || s === yo || s === vo)
    return o !== Oi && n.every((u) => u === Oi) ? Pe.Break : Pe.BreakStart;
  if (o === Yc || o === yo || o === vo)
    return Pe.BreakStart;
  if (s === Xc && (o === Xc || o === wo || o === Qc || o === el) || (s === Qc || s === wo) && (o === wo || o === xo) || (s === el || s === xo) && o === xo)
    return Pe.NotBreak;
  if (t) {
    if (o === Oi)
      return Pe.NotBreak;
    if (o === lr)
      return s == Zc && n.length > 0 && n[0] == lr ? i != Ii ? Pe.BreakStart : Pe.Break : Pe.NotBreak;
  } else if (o === Oi || o === lr)
    return Pe.NotBreak;
  if (o === L2 || s === Jc)
    return Pe.NotBreak;
  if (t) {
    if (s == lr && o == Ii && (e == lr || e == Zc))
      return Pe.NotBreak;
  } else if (e == Ii && s == lr && o == Ii)
    return Pe.NotBreak;
  return !t && n.indexOf(nn) >= 0 ? Pe.Break : s === nn && o === nn ? Pe.NotBreak : Pe.BreakStart;
}, nl = function(t, e, n) {
  for (; n--; )
    e += za(t, e) ? 2 : 1;
  return e;
}, tr = {};
tr.nextBreak = function(t, e = 0) {
  if (e < 0)
    return 0;
  if (e >= t.length - 1)
    return t.length;
  const n = hs.get(t.codePointAt(e)), i = [];
  let r, s, o;
  for (r = s = e + 1, o = t.length; s < o; r = s += 1) {
    if (za(t, r - 1))
      continue;
    const a = hs.get(t.codePointAt(r));
    if (Ff(!1, n, i, a))
      return r;
    i.push(a);
  }
  return t.length;
};
tr.previousBreak = function(t, e = t.length) {
  if (e > t.length)
    return t.length;
  if (e <= 1)
    return 0;
  e--;
  let n = [], i = hs.get(tl(t, e)), r, s;
  for (r = s = e - 1; s >= -1; r = s += -1) {
    if (za(t, r))
      continue;
    let o = hs.get(tl(t, r));
    switch (Ff(!0, o, n, i)) {
      case Pe.Break:
        return r + n.length + 1;
      case Pe.BreakStart:
        return r + 1;
      case Pe.BreakLastRegional:
        return nl(t, r, n.concat(i).lastIndexOf(nn) + 1);
      case Pe.BreakPenultimateRegional:
        return nl(t, r, n.concat(i).lastIndexOf(nn));
    }
    n.unshift(o);
  }
};
tr.break = function(t) {
  const e = [];
  let n = 0, i;
  for (; (i = tr.nextBreak(t, n)) < t.length; )
    e.push(t.slice(n, i)), n = i;
  return n < t.length && e.push(t.slice(n)), e;
};
tr.countBreaks = function(t) {
  let e = 0, n = 0, i;
  for (; (i = tr.nextBreak(t, n)) < t.length; )
    n = i, e++;
  return n < t.length && e++, e;
};
function dw(t) {
  t || (t = xe.pub);
  const e = ie({}), n = ue();
  return n.user(t).get("mates").map().once((i, r) => {
    if (i) {
      const s = {
        emoji: kr(i),
        text: i
      };
      e[r] = s, n.user(r).get("mates").get(t).on((o) => {
        o ? e[r].back = kr(o) : delete e[r].back;
      });
    } else
      delete e[r];
  }), e;
}
function kr(t, e = "👋") {
  if (!t || typeof t != "string") return "";
  let n = tr.break(t)[0];
  return M2(n) ? n : e;
}
function M2(t) {
  return new RegExp("\\p{Extended_Pictographic}", "u").test(t);
}
function pw(t) {
  var s;
  const e = ye("👋"), n = ye(!1), i = (s = xe == null ? void 0 : xe.db) == null ? void 0 : s.get("mates").get(t);
  i == null || i.on((o) => {
    n.value = kr(o);
  });
  function r() {
    i == null || i.put(n.value ? !1 : kr(e.value));
  }
  return { emoji: e, isMate: n, toggleMate: r };
}
function j2() {
  return {
    processFile: N2
  };
}
async function N2(t) {
  const e = await B2(t), n = (await import("./jsQR-CzXCMISK.js").then((r) => r.jsQR)).default, i = n(e.data, e.width, e.height);
  return i == null ? void 0 : i.data;
}
async function B2(t) {
  var e;
  if (/image.*/.test(t.type)) {
    const n = new FileReader();
    n.readAsDataURL(t);
    const i = await Of(n, "load");
    return $2((e = i == null ? void 0 : i.target) == null ? void 0 : e.result);
  } else
    console.log("File is not an image");
}
async function $2(t) {
  if (!t) return;
  const e = document.createElement("img");
  return e.src = t, await Of(e, "load"), z2(e);
}
function z2(t) {
  const e = t.naturalWidth, n = t.naturalHeight;
  return U2(t, e, n);
}
function U2(t, e, n) {
  const i = document.createElement("canvas"), r = i.getContext("2d");
  i.width = 1920, i.height = 1080;
  const s = Math.min(
    1,
    i.width / e,
    i.height / n
  ), o = s * e, a = s * n;
  return r.drawImage(t, 0, 0, o, a), r.getImageData(0, 0, o, a);
}
function Of(t, e, n) {
  let i, r;
  const s = new Promise((o, a) => {
    i = o, r = a;
  });
  return t.addEventListener(e, i), t.addEventListener(n, r), s.finally(() => {
    t.removeEventListener(e, i), t.removeEventListener(n, r);
  }), s;
}
const mw = Gn.room;
export {
  oh as N,
  Ve as SEA,
  Uv as activeFile,
  d_ as addPost,
  Zv as addProfileField,
  As as auth,
  fg as base64Extension,
  hg as base64FileType,
  kv as base64MimeType,
  Kn as brush,
  ru as cameras,
  nv as cast,
  sn as commonjsGlobal,
  Gn as config,
  lw as countProjects,
  $v as countRating,
  l_ as createMd,
  Y2 as createPassKey,
  Jh as createRoom,
  An as currentCamera,
  wi as currentChat,
  br as currentMic,
  ne as currentRoom,
  uv as decFrom,
  Ay as defaultTrackers,
  Ou as detectMimeType,
  tv as devices,
  No as dictLang,
  Cn as dictRecord,
  ou as download,
  m_ as downloadFeed,
  Bo as downloadFile,
  p_ as downloadPost,
  qe as drauu,
  l2 as drauuOptions,
  He as draw,
  av as encFor,
  su as ensureDevicesListPermissions,
  __ as enterRoom,
  Pv as favRoom,
  ev as fileNames,
  dh as genUUID,
  Su as generateCerts,
  Pn as getDefaultExportFromCjs,
  Xi as getFilename,
  kr as getFirstEmoji,
  X2 as getPassKey,
  cv as getShortHash,
  Q2 as getSupportedMimeTypes,
  Ye as giftPath,
  ew as giftState,
  Z2 as handleAuthFiles,
  G2 as hasPass,
  es as hashObj,
  hn as hashText,
  M2 as isEmoji,
  ka as isHash,
  Kv as isMine,
  gf as isPair,
  wm as issueCert,
  Iv as joinRoom,
  fv as langParts,
  dv as languages,
  Ty as leave,
  y_ as leaveRoom,
  kh as letterFilter,
  jv as listPersonalTag,
  Fi as loadCanvas,
  Qu as loadFromHash,
  bm as loadRelays,
  iu as microphones,
  lh as mimeExtMap,
  nu as mimeType,
  lg as niceBytes,
  Aa as parseHashLink,
  W2 as parseLink,
  h_ as parseMd,
  Av as parsePost,
  Ue as pass,
  w_ as reactToPost,
  tu as recordCamera,
  Vp as recordingName,
  Fv as recreateRoom,
  je as relay,
  Ma as removeEmptyKeys,
  uw as removeProject,
  wv as renderStress,
  um as resetPeer,
  mw as rootRoom,
  _m as safeHash,
  hv as safeJSONParse,
  Tv as selectedRoom,
  Gv as selectedUser,
  Dy as sendMessage,
  am as setPeer,
  mp as setPetname,
  Qi as slugify,
  sv as soul,
  b_ as submitRoom,
  cp as theme,
  Tc as trackers,
  lv as unsafeHash,
  Jv as updateProfile,
  bf as updateProjectField,
  qo as updateRoomProfile,
  h2 as updateState,
  g_ as uploadFeed,
  ug as uploadText,
  pp as useAccount,
  V2 as useAuth,
  K2 as useAuthLink,
  Yv as useAvatar,
  q2 as useBackground,
  rv as useChat,
  Xl as useColor,
  aw as useComputedProject,
  J2 as useCredentials,
  gv as useDefs,
  yv as useDictAuthors,
  vv as useDictLangs,
  _v as useDictRecordsBy,
  bv as useDictRecordsFor,
  fw as useDraw,
  Qv as useGift,
  qv as useGifts,
  Rv as useGuests,
  ue as useGun,
  hm as useGunSecondary,
  pw as useMate,
  dw as useMates,
  Sv as useMd,
  nw as useMessages,
  rw as useMessagesCount,
  iw as useMessagesList,
  Wv as useMyGifts,
  tw as useNewGift,
  sw as useNewProject,
  xv as usePictureUpload,
  f_ as usePost,
  Ev as usePostTimestamp,
  Cv as usePosts,
  ow as useProject,
  Vv as useProjectGifts,
  cw as useProjects,
  j2 as useQR,
  Nv as useReaction,
  Bv as useReactions,
  Gp as useRecording,
  iv as useRelay,
  ov as useRelays,
  Dv as useRoom,
  Lv as useRoomLogo,
  Ov as useRooms,
  hw as useSpace,
  tp as useSvgMouse,
  Mv as useTagList,
  Hv as useTorrent,
  Re as useUser,
  Xv as useUserAvatar,
  zv as useUserPosts,
  mv as useWord,
  pv as useWords,
  Yh as useZip,
  xe as user,
  uu as voteTopic
};
//# sourceMappingURL=composables-BbJ4etOy.js.map
